import { jsx as w, Fragment as bt, jsxs as Pe } from "react/jsx-runtime";
import * as p from "react";
import Ze, { forwardRef as xr, useState as nr, createContext as Sn, useContext as Pn, useEffect as ir, useLayoutEffect as fl, useRef as Wr, createElement as Ec, useCallback as ro, Fragment as Im } from "react";
import * as Si from "react-dom";
import Lf from "react-dom";
const vA = ({
  width: e,
  height: t,
  targetWidth: r,
  background: n,
  shimmer: o = !1
}) => {
  const i = {
    width: e ? `${e}px` : "100%",
    height: t ? `${t}px` : "4px"
  };
  return /* @__PURE__ */ w(
    "div",
    {
      className: "rounded-default bg-gray-backdrop-300",
      style: i,
      children: /* @__PURE__ */ w(
        "div",
        {
          className: "relative overflow-hidden rounded-default",
          style: {
            width: r,
            height: "100%",
            backgroundColor: n || "#000"
            // 기본 배경색을 검정으로 설정
          },
          children: o && /* @__PURE__ */ w(
            "div",
            {
              className: "animate-progress-fill-shimmer pointer-events-none absolute inset-0",
              "aria-hidden": "true"
            }
          )
        }
      )
    }
  );
}, Bm = ({
  title: e,
  titleId: t,
  ...r
}, n) => /* @__PURE__ */ p.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: n, "aria-labelledby": t, ...r }, e ? /* @__PURE__ */ p.createElement("title", { id: t }, e) : null, /* @__PURE__ */ p.createElement("g", { clipPath: "url(#clip0_11640_150871)" }, /* @__PURE__ */ p.createElement("path", { d: "M14.25 4.8075L13.1925 3.75L9 7.9425L4.8075 3.75L3.75 4.8075L7.9425 9L3.75 13.1925L4.8075 14.25L9 10.0575L13.1925 14.25L14.25 13.1925L10.0575 9L14.25 4.8075Z", fill: "currentColor" })), /* @__PURE__ */ p.createElement("defs", null, /* @__PURE__ */ p.createElement("clipPath", { id: "clip0_11640_150871" }, /* @__PURE__ */ p.createElement("rect", { width: 18, height: 18, fill: "white" })))), hl = xr(Bm);
function Wf(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (r = Wf(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function Lm() {
  for (var e, t, r = 0, n = "", o = arguments.length; r < o; r++) (e = arguments[r]) && (t = Wf(e)) && (n && (n += " "), n += t);
  return n;
}
const vl = "-", Wm = (e) => {
  const t = jm(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  return {
    getClassGroupId: (a) => {
      const s = a.split(vl);
      return s[0] === "" && s.length !== 1 && s.shift(), zf(s, t) || zm(a);
    },
    getConflictingClassGroupIds: (a, s) => {
      const c = r[a] || [];
      return s && n[a] ? [...c, ...n[a]] : c;
    }
  };
}, zf = (e, t) => {
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], n = t.nextPart.get(r), o = n ? zf(e.slice(1), n) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const i = e.join(vl);
  return t.validators.find(({
    validator: a
  }) => a(i))?.classGroupId;
}, Hu = /^\[(.+)\]$/, zm = (e) => {
  if (Hu.test(e)) {
    const t = Hu.exec(e)[1], r = t?.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}, jm = (e) => {
  const {
    theme: t,
    prefix: r
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return Vm(Object.entries(e.classGroups), r).forEach(([i, a]) => {
    kc(a, n, i, t);
  }), n;
}, kc = (e, t, r, n) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const i = o === "" ? t : qu(t, o);
      i.classGroupId = r;
      return;
    }
    if (typeof o == "function") {
      if (Um(o)) {
        kc(o(n), t, r, n);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: r
      });
      return;
    }
    Object.entries(o).forEach(([i, a]) => {
      kc(a, qu(t, i), r, n);
    });
  });
}, qu = (e, t) => {
  let r = e;
  return t.split(vl).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}, Um = (e) => e.isThemeGetter, Vm = (e, t) => t ? e.map(([r, n]) => {
  const o = n.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([a, s]) => [t + a, s])) : i);
  return [r, o];
}) : e, Hm = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  const o = (i, a) => {
    r.set(i, a), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
  };
  return {
    get(i) {
      let a = r.get(i);
      if (a !== void 0)
        return a;
      if ((a = n.get(i)) !== void 0)
        return o(i, a), a;
    },
    set(i, a) {
      r.has(i) ? r.set(i, a) : o(i, a);
    }
  };
}, jf = "!", qm = (e) => {
  const {
    separator: t,
    experimentalParseClassName: r
  } = e, n = t.length === 1, o = t[0], i = t.length, a = (s) => {
    const c = [];
    let l = 0, u = 0, d;
    for (let y = 0; y < s.length; y++) {
      let b = s[y];
      if (l === 0) {
        if (b === o && (n || s.slice(y, y + i) === t)) {
          c.push(s.slice(u, y)), u = y + i;
          continue;
        }
        if (b === "/") {
          d = y;
          continue;
        }
      }
      b === "[" ? l++ : b === "]" && l--;
    }
    const f = c.length === 0 ? s : s.substring(u), h = f.startsWith(jf), g = h ? f.substring(1) : f, v = d && d > u ? d - u : void 0;
    return {
      modifiers: c,
      hasImportantModifier: h,
      baseClassName: g,
      maybePostfixModifierPosition: v
    };
  };
  return r ? (s) => r({
    className: s,
    parseClassName: a
  }) : a;
}, Gm = (e) => {
  if (e.length <= 1)
    return e;
  const t = [];
  let r = [];
  return e.forEach((n) => {
    n[0] === "[" ? (t.push(...r.sort(), n), r = []) : r.push(n);
  }), t.push(...r.sort()), t;
}, Km = (e) => ({
  cache: Hm(e.cacheSize),
  parseClassName: qm(e),
  ...Wm(e)
}), Xm = /\s+/, Ym = (e, t) => {
  const {
    parseClassName: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: o
  } = t, i = [], a = e.trim().split(Xm);
  let s = "";
  for (let c = a.length - 1; c >= 0; c -= 1) {
    const l = a[c], {
      modifiers: u,
      hasImportantModifier: d,
      baseClassName: f,
      maybePostfixModifierPosition: h
    } = r(l);
    let g = !!h, v = n(g ? f.substring(0, h) : f);
    if (!v) {
      if (!g) {
        s = l + (s.length > 0 ? " " + s : s);
        continue;
      }
      if (v = n(f), !v) {
        s = l + (s.length > 0 ? " " + s : s);
        continue;
      }
      g = !1;
    }
    const y = Gm(u).join(":"), b = d ? y + jf : y, x = b + v;
    if (i.includes(x))
      continue;
    i.push(x);
    const C = o(v, g);
    for (let E = 0; E < C.length; ++E) {
      const D = C[E];
      i.push(b + D);
    }
    s = l + (s.length > 0 ? " " + s : s);
  }
  return s;
};
function Zm() {
  let e = 0, t, r, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = Uf(t)) && (n && (n += " "), n += r);
  return n;
}
const Uf = (e) => {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = Uf(e[n])) && (r && (r += " "), r += t);
  return r;
};
function _m(e, ...t) {
  let r, n, o, i = a;
  function a(c) {
    const l = t.reduce((u, d) => d(u), e());
    return r = Km(l), n = r.cache.get, o = r.cache.set, i = s, s(c);
  }
  function s(c) {
    const l = n(c);
    if (l)
      return l;
    const u = Ym(c, r);
    return o(c, u), u;
  }
  return function() {
    return i(Zm.apply(null, arguments));
  };
}
const st = (e) => {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}, Vf = /^\[(?:([a-z-]+):)?(.+)\]$/i, Jm = /^\d+\/\d+$/, Qm = /* @__PURE__ */ new Set(["px", "full", "screen"]), $m = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, ey = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, ty = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, ry = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, ny = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, Mr = (e) => yo(e) || Qm.has(e) || Jm.test(e), $r = (e) => Ro(e, "length", dy), yo = (e) => !!e && !Number.isNaN(Number(e)), Us = (e) => Ro(e, "number", yo), jo = (e) => !!e && Number.isInteger(Number(e)), oy = (e) => e.endsWith("%") && yo(e.slice(0, -1)), Oe = (e) => Vf.test(e), en = (e) => $m.test(e), iy = /* @__PURE__ */ new Set(["length", "size", "percentage"]), ay = (e) => Ro(e, iy, Hf), sy = (e) => Ro(e, "position", Hf), cy = /* @__PURE__ */ new Set(["image", "url"]), ly = (e) => Ro(e, cy, hy), uy = (e) => Ro(e, "", fy), Uo = () => !0, Ro = (e, t, r) => {
  const n = Vf.exec(e);
  return n ? n[1] ? typeof t == "string" ? n[1] === t : t.has(n[1]) : r(n[2]) : !1;
}, dy = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  ey.test(e) && !ty.test(e)
), Hf = () => !1, fy = (e) => ry.test(e), hy = (e) => ny.test(e), vy = () => {
  const e = st("colors"), t = st("spacing"), r = st("blur"), n = st("brightness"), o = st("borderColor"), i = st("borderRadius"), a = st("borderSpacing"), s = st("borderWidth"), c = st("contrast"), l = st("grayscale"), u = st("hueRotate"), d = st("invert"), f = st("gap"), h = st("gradientColorStops"), g = st("gradientColorStopPositions"), v = st("inset"), y = st("margin"), b = st("opacity"), x = st("padding"), C = st("saturate"), E = st("scale"), D = st("sepia"), A = st("skew"), R = st("space"), O = st("translate"), W = () => ["auto", "contain", "none"], z = () => ["auto", "hidden", "clip", "visible", "scroll"], q = () => ["auto", Oe, t], V = () => [Oe, t], I = () => ["", Mr, $r], Z = () => ["auto", yo, Oe], Q = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], K = () => ["solid", "dashed", "dotted", "double", "none"], L = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], U = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], Y = () => ["", "0", Oe], he = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], ce = () => [yo, Oe];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Uo],
      spacing: [Mr, $r],
      blur: ["none", "", en, Oe],
      brightness: ce(),
      borderColor: [e],
      borderRadius: ["none", "", "full", en, Oe],
      borderSpacing: V(),
      borderWidth: I(),
      contrast: ce(),
      grayscale: Y(),
      hueRotate: ce(),
      invert: Y(),
      gap: V(),
      gradientColorStops: [e],
      gradientColorStopPositions: [oy, $r],
      inset: q(),
      margin: q(),
      opacity: ce(),
      padding: V(),
      saturate: ce(),
      scale: ce(),
      sepia: Y(),
      skew: ce(),
      space: V(),
      translate: V()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Oe]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [en]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": he()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": he()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...Q(), Oe]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: z()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": z()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": z()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: W()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": W()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": W()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [v]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [v]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [v]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [v]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [v]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [v]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [v]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [v]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [v]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", jo, Oe]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: q()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Oe]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: Y()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: Y()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", jo, Oe]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Uo]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", jo, Oe]
        }, Oe]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": Z()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": Z()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Uo]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [jo, Oe]
        }, Oe]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": Z()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": Z()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Oe]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Oe]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [f]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [f]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [f]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...U()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...U(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...U(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [x]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [x]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [x]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [x]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [x]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [x]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [x]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [x]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [x]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [y]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [y]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [y]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [y]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [y]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [y]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [y]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [y]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [y]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [R]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [R]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", Oe, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [Oe, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [Oe, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [en]
        }, en]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Oe, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [Oe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Oe, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [Oe, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", en, $r]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Us]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Uo]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Oe]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", yo, Us]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Mr, Oe]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Oe]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Oe]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...K(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Mr, $r]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Mr, Oe]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: V()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Oe]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Oe]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...Q(), sy]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", ay]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, ly]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [g]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [h]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...K(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: K()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": [o]
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...K()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Mr, Oe]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Mr, $r]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: I()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Mr, $r]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", en, uy]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Uo]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...L(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": L()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [c]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", en, Oe]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [l]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [C]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [D]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [c]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [l]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [C]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [D]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Oe]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: ce()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Oe]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: ce()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Oe]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [E]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [E]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [E]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [jo, Oe]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [O]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [O]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [A]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [A]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Oe]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Oe]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": V()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": V()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": V()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": V()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": V()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": V()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": V()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": V()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": V()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": V()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": V()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": V()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": V()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": V()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": V()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": V()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": V()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": V()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Oe]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Mr, $r, Us]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}, py = /* @__PURE__ */ _m(vy);
function le(...e) {
  return py(Lm(e));
}
function Ue(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(o) {
    if (e?.(o), r === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function gy(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function qf(...e) {
  return (t) => e.forEach((r) => gy(r, t));
}
function ct(...e) {
  return p.useCallback(qf(...e), e);
}
function my(e, t) {
  const r = p.createContext(t), n = (i) => {
    const { children: a, ...s } = i, c = p.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ w(r.Provider, { value: c, children: a });
  };
  n.displayName = e + "Provider";
  function o(i) {
    const a = p.useContext(r);
    if (a) return a;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [n, o];
}
function En(e, t = []) {
  let r = [];
  function n(i, a) {
    const s = p.createContext(a), c = r.length;
    r = [...r, a];
    const l = (d) => {
      const { scope: f, children: h, ...g } = d, v = f?.[e]?.[c] || s, y = p.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ w(v.Provider, { value: y, children: h });
    };
    l.displayName = i + "Provider";
    function u(d, f) {
      const h = f?.[e]?.[c] || s, g = p.useContext(h);
      if (g) return g;
      if (a !== void 0) return a;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return [l, u];
  }
  const o = () => {
    const i = r.map((a) => p.createContext(a));
    return function(s) {
      const c = s?.[e] || i;
      return p.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return o.scopeName = e, [n, yy(o, ...t)];
}
function yy(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const a = n.reduce((s, { useScope: c, scopeName: l }) => {
        const d = c(i)[`__scope${l}`];
        return { ...s, ...d };
      }, {});
      return p.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
var wt = globalThis?.document ? p.useLayoutEffect : () => {
}, by = p.useId || (() => {
}), wy = 0;
function kr(e) {
  const [t, r] = p.useState(by());
  return wt(() => {
    r((n) => n ?? String(wy++));
  }, [e]), t ? `radix-${t}` : "";
}
function Vr(e) {
  const t = p.useRef(e);
  return p.useEffect(() => {
    t.current = e;
  }), p.useMemo(() => (...r) => t.current?.(...r), []);
}
function Hr({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  }
}) {
  const [n, o] = xy({ defaultProp: t, onChange: r }), i = e !== void 0, a = i ? e : n, s = Vr(r), c = p.useCallback(
    (l) => {
      if (i) {
        const d = typeof l == "function" ? l(e) : l;
        d !== e && s(d);
      } else
        o(l);
    },
    [i, e, o, s]
  );
  return [a, c];
}
function xy({
  defaultProp: e,
  onChange: t
}) {
  const r = p.useState(e), [n] = r, o = p.useRef(n), i = Vr(t);
  return p.useEffect(() => {
    o.current !== n && (i(n), o.current = n);
  }, [n, o, i]), r;
}
var fn = p.forwardRef((e, t) => {
  const { children: r, ...n } = e, o = p.Children.toArray(r), i = o.find(Cy);
  if (i) {
    const a = i.props.children, s = o.map((c) => c === i ? p.Children.count(a) > 1 ? p.Children.only(null) : p.isValidElement(a) ? a.props.children : null : c);
    return /* @__PURE__ */ w(Fc, { ...n, ref: t, children: p.isValidElement(a) ? p.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ w(Fc, { ...n, ref: t, children: r });
});
fn.displayName = "Slot";
var Fc = p.forwardRef((e, t) => {
  const { children: r, ...n } = e;
  if (p.isValidElement(r)) {
    const o = Py(r);
    return p.cloneElement(r, {
      ...Sy(n, r.props),
      // @ts-ignore
      ref: t ? qf(t, o) : o
    });
  }
  return p.Children.count(r) > 1 ? p.Children.only(null) : null;
});
Fc.displayName = "SlotClone";
var Gf = ({ children: e }) => /* @__PURE__ */ w(bt, { children: e });
function Cy(e) {
  return p.isValidElement(e) && e.type === Gf;
}
function Sy(e, t) {
  const r = { ...t };
  for (const n in t) {
    const o = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? o && i ? r[n] = (...s) => {
      i(...s), o(...s);
    } : o && (r[n] = o) : n === "style" ? r[n] = { ...o, ...i } : n === "className" && (r[n] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Py(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var Ey = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], nt = Ey.reduce((e, t) => {
  const r = p.forwardRef((n, o) => {
    const { asChild: i, ...a } = n, s = i ? fn : t;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ w(s, { ...a, ref: o });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function ky(e, t) {
  e && Si.flushSync(() => e.dispatchEvent(t));
}
function Fy(e, t = globalThis?.document) {
  const r = Vr(e);
  p.useEffect(() => {
    const n = (o) => {
      o.key === "Escape" && r(o);
    };
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [r, t]);
}
var Dy = "DismissableLayer", Dc = "dismissableLayer.update", Ry = "dismissableLayer.pointerDownOutside", Ty = "dismissableLayer.focusOutside", Gu, Kf = p.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Pi = p.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: a,
      onDismiss: s,
      ...c
    } = e, l = p.useContext(Kf), [u, d] = p.useState(null), f = u?.ownerDocument ?? globalThis?.document, [, h] = p.useState({}), g = ct(t, (R) => d(R)), v = Array.from(l.layers), [y] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), b = v.indexOf(y), x = u ? v.indexOf(u) : -1, C = l.layersWithOutsidePointerEventsDisabled.size > 0, E = x >= b, D = Oy((R) => {
      const O = R.target, W = [...l.branches].some((z) => z.contains(O));
      !E || W || (o?.(R), a?.(R), R.defaultPrevented || s?.());
    }, f), A = My((R) => {
      const O = R.target;
      [...l.branches].some((z) => z.contains(O)) || (i?.(R), a?.(R), R.defaultPrevented || s?.());
    }, f);
    return Fy((R) => {
      x === l.layers.size - 1 && (n?.(R), !R.defaultPrevented && s && (R.preventDefault(), s()));
    }, f), p.useEffect(() => {
      if (u)
        return r && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Gu = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(u)), l.layers.add(u), Ku(), () => {
          r && l.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = Gu);
        };
    }, [u, f, r, l]), p.useEffect(() => () => {
      u && (l.layers.delete(u), l.layersWithOutsidePointerEventsDisabled.delete(u), Ku());
    }, [u, l]), p.useEffect(() => {
      const R = () => h({});
      return document.addEventListener(Dc, R), () => document.removeEventListener(Dc, R);
    }, []), /* @__PURE__ */ w(
      nt.div,
      {
        ...c,
        ref: g,
        style: {
          pointerEvents: C ? E ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Ue(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: Ue(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: Ue(
          e.onPointerDownCapture,
          D.onPointerDownCapture
        )
      }
    );
  }
);
Pi.displayName = Dy;
var Ay = "DismissableLayerBranch", Ny = p.forwardRef((e, t) => {
  const r = p.useContext(Kf), n = p.useRef(null), o = ct(t, n);
  return p.useEffect(() => {
    const i = n.current;
    if (i)
      return r.branches.add(i), () => {
        r.branches.delete(i);
      };
  }, [r.branches]), /* @__PURE__ */ w(nt.div, { ...e, ref: o });
});
Ny.displayName = Ay;
function Oy(e, t = globalThis?.document) {
  const r = Vr(e), n = p.useRef(!1), o = p.useRef(() => {
  });
  return p.useEffect(() => {
    const i = (s) => {
      if (s.target && !n.current) {
        let c = function() {
          Xf(
            Ry,
            r,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = c, t.addEventListener("click", o.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", o.current);
      n.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function My(e, t = globalThis?.document) {
  const r = Vr(e), n = p.useRef(!1);
  return p.useEffect(() => {
    const o = (i) => {
      i.target && !n.current && Xf(Ty, r, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function Ku() {
  const e = new CustomEvent(Dc);
  document.dispatchEvent(e);
}
function Xf(e, t, r, { discrete: n }) {
  const o = r.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && o.addEventListener(e, t, { once: !0 }), n ? ky(o, i) : o.dispatchEvent(i);
}
var Vs = "focusScope.autoFocusOnMount", Hs = "focusScope.autoFocusOnUnmount", Xu = { bubbles: !1, cancelable: !0 }, Iy = "FocusScope", Ja = p.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...a
  } = e, [s, c] = p.useState(null), l = Vr(o), u = Vr(i), d = p.useRef(null), f = ct(t, (v) => c(v)), h = p.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  p.useEffect(() => {
    if (n) {
      let v = function(C) {
        if (h.paused || !s) return;
        const E = C.target;
        s.contains(E) ? d.current = E : nn(d.current, { select: !0 });
      }, y = function(C) {
        if (h.paused || !s) return;
        const E = C.relatedTarget;
        E !== null && (s.contains(E) || nn(d.current, { select: !0 }));
      }, b = function(C) {
        if (document.activeElement === document.body)
          for (const D of C)
            D.removedNodes.length > 0 && nn(s);
      };
      document.addEventListener("focusin", v), document.addEventListener("focusout", y);
      const x = new MutationObserver(b);
      return s && x.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", v), document.removeEventListener("focusout", y), x.disconnect();
      };
    }
  }, [n, s, h.paused]), p.useEffect(() => {
    if (s) {
      Zu.add(h);
      const v = document.activeElement;
      if (!s.contains(v)) {
        const b = new CustomEvent(Vs, Xu);
        s.addEventListener(Vs, l), s.dispatchEvent(b), b.defaultPrevented || (By(Uy(Yf(s)), { select: !0 }), document.activeElement === v && nn(s));
      }
      return () => {
        s.removeEventListener(Vs, l), setTimeout(() => {
          const b = new CustomEvent(Hs, Xu);
          s.addEventListener(Hs, u), s.dispatchEvent(b), b.defaultPrevented || nn(v ?? document.body, { select: !0 }), s.removeEventListener(Hs, u), Zu.remove(h);
        }, 0);
      };
    }
  }, [s, l, u, h]);
  const g = p.useCallback(
    (v) => {
      if (!r && !n || h.paused) return;
      const y = v.key === "Tab" && !v.altKey && !v.ctrlKey && !v.metaKey, b = document.activeElement;
      if (y && b) {
        const x = v.currentTarget, [C, E] = Ly(x);
        C && E ? !v.shiftKey && b === E ? (v.preventDefault(), r && nn(C, { select: !0 })) : v.shiftKey && b === C && (v.preventDefault(), r && nn(E, { select: !0 })) : b === x && v.preventDefault();
      }
    },
    [r, n, h.paused]
  );
  return /* @__PURE__ */ w(nt.div, { tabIndex: -1, ...a, ref: f, onKeyDown: g });
});
Ja.displayName = Iy;
function By(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (nn(n, { select: t }), document.activeElement !== r) return;
}
function Ly(e) {
  const t = Yf(e), r = Yu(t, e), n = Yu(t.reverse(), e);
  return [r, n];
}
function Yf(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const o = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || o ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Yu(e, t) {
  for (const r of e)
    if (!Wy(r, { upTo: t })) return r;
}
function Wy(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function zy(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function nn(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && zy(e) && t && e.select();
  }
}
var Zu = jy();
function jy() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && r?.pause(), e = _u(e, t), e.unshift(t);
    },
    remove(t) {
      e = _u(e, t), e[0]?.resume();
    }
  };
}
function _u(e, t) {
  const r = [...e], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function Uy(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Vy = "Portal", Ei = p.forwardRef((e, t) => {
  const { container: r, ...n } = e, [o, i] = p.useState(!1);
  wt(() => i(!0), []);
  const a = r || o && globalThis?.document?.body;
  return a ? Lf.createPortal(/* @__PURE__ */ w(nt.div, { ...n, ref: t }), a) : null;
});
Ei.displayName = Vy;
function Hy(e, t) {
  return p.useReducer((r, n) => t[r][n] ?? r, e);
}
var kn = (e) => {
  const { present: t, children: r } = e, n = qy(t), o = typeof r == "function" ? r({ present: n.isPresent }) : p.Children.only(r), i = ct(n.ref, Gy(o));
  return typeof r == "function" || n.isPresent ? p.cloneElement(o, { ref: i }) : null;
};
kn.displayName = "Presence";
function qy(e) {
  const [t, r] = p.useState(), n = p.useRef({}), o = p.useRef(e), i = p.useRef("none"), a = e ? "mounted" : "unmounted", [s, c] = Hy(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return p.useEffect(() => {
    const l = Yi(n.current);
    i.current = s === "mounted" ? l : "none";
  }, [s]), wt(() => {
    const l = n.current, u = o.current;
    if (u !== e) {
      const f = i.current, h = Yi(l);
      e ? c("MOUNT") : h === "none" || l?.display === "none" ? c("UNMOUNT") : c(u && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, c]), wt(() => {
    if (t) {
      let l;
      const u = t.ownerDocument.defaultView ?? window, d = (h) => {
        const v = Yi(n.current).includes(h.animationName);
        if (h.target === t && v && (c("ANIMATION_END"), !o.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, f = (h) => {
        h.target === t && (i.current = Yi(n.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(l), t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: p.useCallback((l) => {
      l && (n.current = getComputedStyle(l)), r(l);
    }, [])
  };
}
function Yi(e) {
  return e?.animationName || "none";
}
function Gy(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var qs = 0;
function pl() {
  p.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Ju()), document.body.insertAdjacentElement("beforeend", e[1] ?? Ju()), qs++, () => {
      qs === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), qs--;
    };
  }, []);
}
function Ju() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Rt = function() {
  return Rt = Object.assign || function(t) {
    for (var r, n = 1, o = arguments.length; n < o; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, Rt.apply(this, arguments);
};
function gl(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
}
function Zf(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, o = t.length, i; n < o; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var ii = "right-scroll-bar-position", ai = "width-before-scroll-bar", Ky = "with-scroll-bars-hidden", Xy = "--removed-body-scroll-bar-size";
function Gs(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Yy(e, t) {
  var r = nr(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var o = r.value;
          o !== n && (r.value = n, r.callback(n, o));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var Zy = typeof window < "u" ? p.useLayoutEffect : p.useEffect, Qu = /* @__PURE__ */ new WeakMap();
function _f(e, t) {
  var r = Yy(null, function(n) {
    return e.forEach(function(o) {
      return Gs(o, n);
    });
  });
  return Zy(function() {
    var n = Qu.get(r);
    if (n) {
      var o = new Set(n), i = new Set(e), a = r.current;
      o.forEach(function(s) {
        i.has(s) || Gs(s, null);
      }), i.forEach(function(s) {
        o.has(s) || Gs(s, a);
      });
    }
    Qu.set(r, e);
  }, [e]), r;
}
function _y(e) {
  return e;
}
function Jy(e, t) {
  t === void 0 && (t = _y);
  var r = [], n = !1, o = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(i) {
      var a = t(i, n);
      return r.push(a), function() {
        r = r.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (n = !0; r.length; ) {
        var a = r;
        r = [], a.forEach(i);
      }
      r = {
        push: function(s) {
          return i(s);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(i) {
      n = !0;
      var a = [];
      if (r.length) {
        var s = r;
        r = [], s.forEach(i), a = r;
      }
      var c = function() {
        var u = a;
        a = [], u.forEach(i);
      }, l = function() {
        return Promise.resolve().then(c);
      };
      l(), r = {
        push: function(u) {
          a.push(u), l();
        },
        filter: function(u) {
          return a = a.filter(u), r;
        }
      };
    }
  };
  return o;
}
function Jf(e) {
  e === void 0 && (e = {});
  var t = Jy(null);
  return t.options = Rt({ async: !0, ssr: !1 }, e), t;
}
var Qf = function(e) {
  var t = e.sideCar, r = gl(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return p.createElement(n, Rt({}, r));
};
Qf.isSideCarExport = !0;
function $f(e, t) {
  return e.useMedium(t), Qf;
}
var eh = Jf(), Ks = function() {
}, Qa = p.forwardRef(function(e, t) {
  var r = p.useRef(null), n = p.useState({
    onScrollCapture: Ks,
    onWheelCapture: Ks,
    onTouchMoveCapture: Ks
  }), o = n[0], i = n[1], a = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, h = e.noIsolation, g = e.inert, v = e.allowPinchZoom, y = e.as, b = y === void 0 ? "div" : y, x = e.gapMode, C = gl(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), E = f, D = _f([r, t]), A = Rt(Rt({}, C), o);
  return p.createElement(
    p.Fragment,
    null,
    u && p.createElement(E, { sideCar: eh, removeScrollBar: l, shards: d, noIsolation: h, inert: g, setCallbacks: i, allowPinchZoom: !!v, lockRef: r, gapMode: x }),
    a ? p.cloneElement(p.Children.only(s), Rt(Rt({}, A), { ref: D })) : p.createElement(b, Rt({}, A, { className: c, ref: D }), s)
  );
});
Qa.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Qa.classNames = {
  fullWidth: ai,
  zeroRight: ii
};
var Qy = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function $y() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Qy();
  return t && e.setAttribute("nonce", t), e;
}
function eb(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function tb(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var rb = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = $y()) && (eb(t, r), tb(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, nb = function() {
  var e = rb();
  return function(t, r) {
    p.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, ml = function() {
  var e = nb(), t = function(r) {
    var n = r.styles, o = r.dynamic;
    return e(n, o), null;
  };
  return t;
}, ob = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Xs = function(e) {
  return parseInt(e || "", 10) || 0;
}, ib = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Xs(r), Xs(n), Xs(o)];
}, ab = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return ob;
  var t = ib(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, sb = ml(), bo = "data-scroll-locked", cb = function(e, t, r, n) {
  var o = e.left, i = e.top, a = e.right, s = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(Ky, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(s, "px ").concat(n, `;
  }
  body[`).concat(bo, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(n, ";"),
    r === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(n, `;
    `),
    r === "padding" && "padding-right: ".concat(s, "px ").concat(n, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ii, ` {
    right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(ai, ` {
    margin-right: `).concat(s, "px ").concat(n, `;
  }
  
  .`).concat(ii, " .").concat(ii, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(ai, " .").concat(ai, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(bo, `] {
    `).concat(Xy, ": ").concat(s, `px;
  }
`);
}, $u = function() {
  var e = parseInt(document.body.getAttribute(bo) || "0", 10);
  return isFinite(e) ? e : 0;
}, lb = function() {
  p.useEffect(function() {
    return document.body.setAttribute(bo, ($u() + 1).toString()), function() {
      var e = $u() - 1;
      e <= 0 ? document.body.removeAttribute(bo) : document.body.setAttribute(bo, e.toString());
    };
  }, []);
}, th = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, o = n === void 0 ? "margin" : n;
  lb();
  var i = p.useMemo(function() {
    return ab(o);
  }, [o]);
  return p.createElement(sb, { styles: cb(i, !t, o, r ? "" : "!important") });
}, Rc = !1;
if (typeof window < "u")
  try {
    var Zi = Object.defineProperty({}, "passive", {
      get: function() {
        return Rc = !0, !0;
      }
    });
    window.addEventListener("test", Zi, Zi), window.removeEventListener("test", Zi, Zi);
  } catch {
    Rc = !1;
  }
var no = Rc ? { passive: !1 } : !1, ub = function(e) {
  return e.tagName === "TEXTAREA";
}, rh = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !ub(e) && r[t] === "visible")
  );
}, db = function(e) {
  return rh(e, "overflowY");
}, fb = function(e) {
  return rh(e, "overflowX");
}, ed = function(e, t) {
  var r = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var o = nh(e, n);
    if (o) {
      var i = oh(e, n), a = i[1], s = i[2];
      if (a > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, hb = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, vb = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, nh = function(e, t) {
  return e === "v" ? db(t) : fb(t);
}, oh = function(e, t) {
  return e === "v" ? hb(t) : vb(t);
}, pb = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, gb = function(e, t, r, n, o) {
  var i = pb(e, window.getComputedStyle(t).direction), a = i * n, s = r.target, c = t.contains(s), l = !1, u = a > 0, d = 0, f = 0;
  do {
    var h = oh(e, s), g = h[0], v = h[1], y = h[2], b = v - y - i * g;
    (g || b) && nh(e, s) && (d += b, f += g), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(f) < 1) && (l = !0), l;
}, _i = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, td = function(e) {
  return [e.deltaX, e.deltaY];
}, rd = function(e) {
  return e && "current" in e ? e.current : e;
}, mb = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, yb = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, bb = 0, oo = [];
function wb(e) {
  var t = p.useRef([]), r = p.useRef([0, 0]), n = p.useRef(), o = p.useState(bb++)[0], i = p.useState(ml)[0], a = p.useRef(e);
  p.useEffect(function() {
    a.current = e;
  }, [e]), p.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var v = Zf([e.lockRef.current], (e.shards || []).map(rd), !0).filter(Boolean);
      return v.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), v.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = p.useCallback(function(v, y) {
    if ("touches" in v && v.touches.length === 2 || v.type === "wheel" && v.ctrlKey)
      return !a.current.allowPinchZoom;
    var b = _i(v), x = r.current, C = "deltaX" in v ? v.deltaX : x[0] - b[0], E = "deltaY" in v ? v.deltaY : x[1] - b[1], D, A = v.target, R = Math.abs(C) > Math.abs(E) ? "h" : "v";
    if ("touches" in v && R === "h" && A.type === "range")
      return !1;
    var O = ed(R, A);
    if (!O)
      return !0;
    if (O ? D = R : (D = R === "v" ? "h" : "v", O = ed(R, A)), !O)
      return !1;
    if (!n.current && "changedTouches" in v && (C || E) && (n.current = D), !D)
      return !0;
    var W = n.current || D;
    return gb(W, y, v, W === "h" ? C : E);
  }, []), c = p.useCallback(function(v) {
    var y = v;
    if (!(!oo.length || oo[oo.length - 1] !== i)) {
      var b = "deltaY" in y ? td(y) : _i(y), x = t.current.filter(function(D) {
        return D.name === y.type && (D.target === y.target || y.target === D.shadowParent) && mb(D.delta, b);
      })[0];
      if (x && x.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!x) {
        var C = (a.current.shards || []).map(rd).filter(Boolean).filter(function(D) {
          return D.contains(y.target);
        }), E = C.length > 0 ? s(y, C[0]) : !a.current.noIsolation;
        E && y.cancelable && y.preventDefault();
      }
    }
  }, []), l = p.useCallback(function(v, y, b, x) {
    var C = { name: v, delta: y, target: b, should: x, shadowParent: xb(b) };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(E) {
        return E !== C;
      });
    }, 1);
  }, []), u = p.useCallback(function(v) {
    r.current = _i(v), n.current = void 0;
  }, []), d = p.useCallback(function(v) {
    l(v.type, td(v), v.target, s(v, e.lockRef.current));
  }, []), f = p.useCallback(function(v) {
    l(v.type, _i(v), v.target, s(v, e.lockRef.current));
  }, []);
  p.useEffect(function() {
    return oo.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", c, no), document.addEventListener("touchmove", c, no), document.addEventListener("touchstart", u, no), function() {
      oo = oo.filter(function(v) {
        return v !== i;
      }), document.removeEventListener("wheel", c, no), document.removeEventListener("touchmove", c, no), document.removeEventListener("touchstart", u, no);
    };
  }, []);
  var h = e.removeScrollBar, g = e.inert;
  return p.createElement(
    p.Fragment,
    null,
    g ? p.createElement(i, { styles: yb(o) }) : null,
    h ? p.createElement(th, { gapMode: e.gapMode }) : null
  );
}
function xb(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Cb = $f(eh, wb);
var $a = p.forwardRef(function(e, t) {
  return p.createElement(Qa, Rt({}, e, { ref: t, sideCar: Cb }));
});
$a.classNames = Qa.classNames;
var Sb = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, io = /* @__PURE__ */ new WeakMap(), Ji = /* @__PURE__ */ new WeakMap(), Qi = {}, Ys = 0, ih = function(e) {
  return e && (e.host || ih(e.parentNode));
}, Pb = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var n = ih(r);
    return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, Eb = function(e, t, r, n) {
  var o = Pb(t, Array.isArray(e) ? e : [e]);
  Qi[r] || (Qi[r] = /* @__PURE__ */ new WeakMap());
  var i = Qi[r], a = [], s = /* @__PURE__ */ new Set(), c = new Set(o), l = function(d) {
    !d || s.has(d) || (s.add(d), l(d.parentNode));
  };
  o.forEach(l);
  var u = function(d) {
    !d || c.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (s.has(f))
        u(f);
      else
        try {
          var h = f.getAttribute(n), g = h !== null && h !== "false", v = (io.get(f) || 0) + 1, y = (i.get(f) || 0) + 1;
          io.set(f, v), i.set(f, y), a.push(f), v === 1 && g && Ji.set(f, !0), y === 1 && f.setAttribute(r, "true"), g || f.setAttribute(n, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", f, b);
        }
    });
  };
  return u(t), s.clear(), Ys++, function() {
    a.forEach(function(d) {
      var f = io.get(d) - 1, h = i.get(d) - 1;
      io.set(d, f), i.set(d, h), f || (Ji.has(d) || d.removeAttribute(n), Ji.delete(d)), h || d.removeAttribute(r);
    }), Ys--, Ys || (io = /* @__PURE__ */ new WeakMap(), io = /* @__PURE__ */ new WeakMap(), Ji = /* @__PURE__ */ new WeakMap(), Qi = {});
  };
}, es = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), o = Sb(e);
  return o ? (n.push.apply(n, Array.from(o.querySelectorAll("[aria-live]"))), Eb(n, o, r, "aria-hidden")) : function() {
    return null;
  };
}, yl = "Dialog", [ah] = En(yl), [kb, Cr] = ah(yl), sh = (e) => {
  const {
    __scopeDialog: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: i,
    modal: a = !0
  } = e, s = p.useRef(null), c = p.useRef(null), [l = !1, u] = Hr({
    prop: n,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ w(
    kb,
    {
      scope: t,
      triggerRef: s,
      contentRef: c,
      contentId: kr(),
      titleId: kr(),
      descriptionId: kr(),
      open: l,
      onOpenChange: u,
      onOpenToggle: p.useCallback(() => u((d) => !d), [u]),
      modal: a,
      children: r
    }
  );
};
sh.displayName = yl;
var ch = "DialogTrigger", lh = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = Cr(ch, r), i = ct(t, o.triggerRef);
    return /* @__PURE__ */ w(
      nt.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": xl(o.open),
        ...n,
        ref: i,
        onClick: Ue(e.onClick, o.onOpenToggle)
      }
    );
  }
);
lh.displayName = ch;
var bl = "DialogPortal", [Fb, uh] = ah(bl, {
  forceMount: void 0
}), dh = (e) => {
  const { __scopeDialog: t, forceMount: r, children: n, container: o } = e, i = Cr(bl, t);
  return /* @__PURE__ */ w(Fb, { scope: t, forceMount: r, children: p.Children.map(n, (a) => /* @__PURE__ */ w(kn, { present: r || i.open, children: /* @__PURE__ */ w(Ei, { asChild: !0, container: o, children: a }) })) });
};
dh.displayName = bl;
var Pa = "DialogOverlay", fh = p.forwardRef(
  (e, t) => {
    const r = uh(Pa, e.__scopeDialog), { forceMount: n = r.forceMount, ...o } = e, i = Cr(Pa, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ w(kn, { present: n || i.open, children: /* @__PURE__ */ w(Db, { ...o, ref: t }) }) : null;
  }
);
fh.displayName = Pa;
var Db = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = Cr(Pa, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ w($a, { as: fn, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ w(
        nt.div,
        {
          "data-state": xl(o.open),
          ...n,
          ref: t,
          style: { pointerEvents: "auto", ...n.style }
        }
      ) })
    );
  }
), jn = "DialogContent", hh = p.forwardRef(
  (e, t) => {
    const r = uh(jn, e.__scopeDialog), { forceMount: n = r.forceMount, ...o } = e, i = Cr(jn, e.__scopeDialog);
    return /* @__PURE__ */ w(kn, { present: n || i.open, children: i.modal ? /* @__PURE__ */ w(Rb, { ...o, ref: t }) : /* @__PURE__ */ w(Tb, { ...o, ref: t }) });
  }
);
hh.displayName = jn;
var Rb = p.forwardRef(
  (e, t) => {
    const r = Cr(jn, e.__scopeDialog), n = p.useRef(null), o = ct(t, r.contentRef, n);
    return p.useEffect(() => {
      const i = n.current;
      if (i) return es(i);
    }, []), /* @__PURE__ */ w(
      vh,
      {
        ...e,
        ref: o,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Ue(e.onCloseAutoFocus, (i) => {
          i.preventDefault(), r.triggerRef.current?.focus();
        }),
        onPointerDownOutside: Ue(e.onPointerDownOutside, (i) => {
          const a = i.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
          (a.button === 2 || s) && i.preventDefault();
        }),
        onFocusOutside: Ue(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), Tb = p.forwardRef(
  (e, t) => {
    const r = Cr(jn, e.__scopeDialog), n = p.useRef(!1), o = p.useRef(!1);
    return /* @__PURE__ */ w(
      vh,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          e.onCloseAutoFocus?.(i), i.defaultPrevented || (n.current || r.triggerRef.current?.focus(), i.preventDefault()), n.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          e.onInteractOutside?.(i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const a = i.target;
          r.triggerRef.current?.contains(a) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), vh = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, trapFocus: n, onOpenAutoFocus: o, onCloseAutoFocus: i, ...a } = e, s = Cr(jn, r), c = p.useRef(null), l = ct(t, c);
    return pl(), /* @__PURE__ */ Pe(bt, { children: [
      /* @__PURE__ */ w(
        Ja,
        {
          asChild: !0,
          loop: !0,
          trapped: n,
          onMountAutoFocus: o,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ w(
            Pi,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": xl(s.open),
              ...a,
              ref: l,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ Pe(bt, { children: [
        /* @__PURE__ */ w(Ab, { titleId: s.titleId }),
        /* @__PURE__ */ w(Ob, { contentRef: c, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), wl = "DialogTitle", ph = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = Cr(wl, r);
    return /* @__PURE__ */ w(nt.h2, { id: o.titleId, ...n, ref: t });
  }
);
ph.displayName = wl;
var gh = "DialogDescription", mh = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = Cr(gh, r);
    return /* @__PURE__ */ w(nt.p, { id: o.descriptionId, ...n, ref: t });
  }
);
mh.displayName = gh;
var yh = "DialogClose", bh = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...n } = e, o = Cr(yh, r);
    return /* @__PURE__ */ w(
      nt.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: Ue(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
bh.displayName = yh;
function xl(e) {
  return e ? "open" : "closed";
}
var wh = "DialogTitleWarning", [pA, xh] = my(wh, {
  contentName: jn,
  titleName: wl,
  docsSlug: "dialog"
}), Ab = ({ titleId: e }) => {
  const t = xh(wh), r = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return p.useEffect(() => {
    e && (document.getElementById(e) || console.error(r));
  }, [r, e]), null;
}, Nb = "DialogDescriptionWarning", Ob = ({ contentRef: e, descriptionId: t }) => {
  const n = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${xh(Nb).contentName}}.`;
  return p.useEffect(() => {
    const o = e.current?.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(n));
  }, [n, e, t]), null;
}, Ch = sh, Sh = lh, Ph = dh, Eh = fh, kh = hh, Fh = ph, Dh = mh, ts = bh;
function gA({ ...e }) {
  return /* @__PURE__ */ w(Ch, { "data-slot": "sheet", ...e });
}
function mA({
  ...e
}) {
  return /* @__PURE__ */ w(Sh, { "data-slot": "sheet-trigger", ...e });
}
function yA({
  ...e
}) {
  return /* @__PURE__ */ w(ts, { "data-slot": "sheet-close", ...e });
}
function Mb({
  ...e
}) {
  return /* @__PURE__ */ w(Ph, { "data-slot": "sheet-portal", ...e });
}
function Ib({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w(
    Eh,
    {
      "data-slot": "sheet-overlay",
      className: le(
        "fixed inset-0 z-50 bg-black/50 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
        e
      ),
      ...t
    }
  );
}
function bA({
  hideClose: e,
  hasBackground: t = !0,
  className: r,
  children: n,
  side: o = "right",
  ...i
}) {
  return /* @__PURE__ */ Pe(Mb, { children: [
    /* @__PURE__ */ w(Ib, {}),
    /* @__PURE__ */ Pe(
      kh,
      {
        "data-slot": "sheet-content",
        className: le(
          "fixed z-50 flex flex-col gap-4 bg-background shadow-lg transition ease-in-out data-[state=closed]:duration-300 data-[state=open]:duration-500 data-[state=open]:animate-in data-[state=closed]:animate-out",
          o === "right" && "inset-y-0 right-0 h-full w-3/4 border-l data-[state=closed]:slide-out-to-right data-[state=open]:slide-in-from-right sm:max-w-sm",
          o === "left" && "inset-y-0 left-0 h-full w-3/4 border-r data-[state=closed]:slide-out-to-left data-[state=open]:slide-in-from-left sm:max-w-sm",
          o === "top" && "inset-x-0 top-0 h-auto border-b data-[state=closed]:slide-out-to-top data-[state=open]:slide-in-from-top",
          o === "bottom" && "inset-x-0 bottom-0 h-auto border-t data-[state=closed]:slide-out-to-bottom data-[state=open]:slide-in-from-bottom",
          r
        ),
        ...i,
        children: [
          n,
          !e && /* @__PURE__ */ Pe(ts, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-slate-950 focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-slate-100 dark:ring-offset-slate-950 dark:focus:ring-slate-300 dark:data-[state=open]:bg-slate-800", children: [
            /* @__PURE__ */ w(hl, { className: "h-4 w-4" }),
            /* @__PURE__ */ w("span", { className: "sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] });
}
function wA({ className: e, ...t }) {
  return /* @__PURE__ */ w(
    "div",
    {
      "data-slot": "sheet-header",
      className: le("flex flex-col gap-1.5 p-4", e),
      ...t
    }
  );
}
function xA({ className: e, ...t }) {
  return /* @__PURE__ */ w(
    "div",
    {
      "data-slot": "sheet-footer",
      className: le("mt-auto flex flex-col gap-2 p-4", e),
      ...t
    }
  );
}
function CA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w(
    Fh,
    {
      "data-slot": "sheet-title",
      className: le("font-semibold text-foreground", e),
      ...t
    }
  );
}
function SA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w(
    Dh,
    {
      "data-slot": "sheet-description",
      className: le("text-sm text-muted-foreground", e),
      ...t
    }
  );
}
function Cl(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(o) {
    if (e?.(o), r === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function nd(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Rh(...e) {
  return (t) => {
    let r = !1;
    const n = e.map((o) => {
      const i = nd(o, t);
      return !r && typeof i == "function" && (r = !0), i;
    });
    if (r)
      return () => {
        for (let o = 0; o < n.length; o++) {
          const i = n[o];
          typeof i == "function" ? i() : nd(e[o], null);
        }
      };
  };
}
function Co(...e) {
  return p.useCallback(Rh(...e), e);
}
function Th(e) {
  const t = p.useRef({ value: e, previous: e });
  return p.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function Ah(e) {
  const [t, r] = p.useState(void 0);
  return wt(() => {
    if (e) {
      r({ width: e.offsetWidth, height: e.offsetHeight });
      const n = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let a, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          a = l.inlineSize, s = l.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        r({ width: a, height: s });
      });
      return n.observe(e, { box: "border-box" }), () => n.unobserve(e);
    } else
      r(void 0);
  }, [e]), t;
}
var Ea = p.forwardRef((e, t) => {
  const { children: r, ...n } = e, o = p.Children.toArray(r), i = o.find(Lb);
  if (i) {
    const a = i.props.children, s = o.map((c) => c === i ? p.Children.count(a) > 1 ? p.Children.only(null) : p.isValidElement(a) ? a.props.children : null : c);
    return /* @__PURE__ */ w(Tc, { ...n, ref: t, children: p.isValidElement(a) ? p.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ w(Tc, { ...n, ref: t, children: r });
});
Ea.displayName = "Slot";
var Tc = p.forwardRef((e, t) => {
  const { children: r, ...n } = e;
  if (p.isValidElement(r)) {
    const o = zb(r), i = Wb(n, r.props);
    return r.type !== p.Fragment && (i.ref = t ? Rh(t, o) : o), p.cloneElement(r, i);
  }
  return p.Children.count(r) > 1 ? p.Children.only(null) : null;
});
Tc.displayName = "SlotClone";
var Bb = ({ children: e }) => /* @__PURE__ */ w(bt, { children: e });
function Lb(e) {
  return p.isValidElement(e) && e.type === Bb;
}
function Wb(e, t) {
  const r = { ...t };
  for (const n in t) {
    const o = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? o && i ? r[n] = (...s) => {
      i(...s), o(...s);
    } : o && (r[n] = o) : n === "style" ? r[n] = { ...o, ...i } : n === "className" && (r[n] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function zb(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var jb = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Gn = jb.reduce((e, t) => {
  const r = p.forwardRef((n, o) => {
    const { asChild: i, ...a } = n, s = i ? Ea : t;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ w(s, { ...a, ref: o });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {}), Sl = "Switch", [Ub] = En(Sl), [Vb, Hb] = Ub(Sl), Nh = p.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: r,
      name: n,
      checked: o,
      defaultChecked: i,
      required: a,
      disabled: s,
      value: c = "on",
      onCheckedChange: l,
      form: u,
      ...d
    } = e, [f, h] = p.useState(null), g = Co(t, (C) => h(C)), v = p.useRef(!1), y = f ? u || !!f.closest("form") : !0, [b = !1, x] = Hr({
      prop: o,
      defaultProp: i,
      onChange: l
    });
    return /* @__PURE__ */ Pe(Vb, { scope: r, checked: b, disabled: s, children: [
      /* @__PURE__ */ w(
        Gn.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": b,
          "aria-required": a,
          "data-state": Ih(b),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: c,
          ...d,
          ref: g,
          onClick: Cl(e.onClick, (C) => {
            x((E) => !E), y && (v.current = C.isPropagationStopped(), v.current || C.stopPropagation());
          })
        }
      ),
      y && /* @__PURE__ */ w(
        qb,
        {
          control: f,
          bubbles: !v.current,
          name: n,
          value: c,
          checked: b,
          required: a,
          disabled: s,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Nh.displayName = Sl;
var Oh = "SwitchThumb", Mh = p.forwardRef(
  (e, t) => {
    const { __scopeSwitch: r, ...n } = e, o = Hb(Oh, r);
    return /* @__PURE__ */ w(
      Gn.span,
      {
        "data-state": Ih(o.checked),
        "data-disabled": o.disabled ? "" : void 0,
        ...n,
        ref: t
      }
    );
  }
);
Mh.displayName = Oh;
var qb = (e) => {
  const { control: t, checked: r, bubbles: n = !0, ...o } = e, i = p.useRef(null), a = Th(r), s = Ah(t);
  return p.useEffect(() => {
    const c = i.current, l = window.HTMLInputElement.prototype, d = Object.getOwnPropertyDescriptor(l, "checked").set;
    if (a !== r && d) {
      const f = new Event("click", { bubbles: n });
      d.call(c, r), c.dispatchEvent(f);
    }
  }, [a, r, n]), /* @__PURE__ */ w(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: r,
      ...o,
      tabIndex: -1,
      ref: i,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Ih(e) {
  return e ? "checked" : "unchecked";
}
var Gb = Nh, Kb = Mh;
function PA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w(
    Gb,
    {
      "data-slot": "switch",
      className: le(
        // 다크에서 primary는 거의 흰색, input은 배경과 1.3:1이라 켜짐이 눈부시고
        // 꺼짐은 보이지 않는다. 다크에서만 켜짐을 브랜드 보라로, 꺼짐을 식별 가능한
        // 중간 회색으로 바꾼다. 라이트 렌더링은 그대로다.
        "peer inline-flex h-4 w-7 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input dark:data-[state=checked]:bg-key-color dark:data-[state=unchecked]:bg-gray-backdrop-500",
        e
      ),
      ...t,
      children: /* @__PURE__ */ w(
        Kb,
        {
          "data-slot": "switch-thumb",
          className: le(
            // 다크에서 배경색 손잡이는 검은 트랙 위에서 사라지므로 밝은 전경색을 쓴다.
            "pointer-events-none block h-3 w-3 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-3 data-[state=unchecked]:translate-x-0 dark:bg-foreground"
          )
        }
      )
    }
  );
}
const Xb = ({
  className: e
}) => /* @__PURE__ */ Pe(
  "svg",
  {
    "aria-hidden": "true",
    className: le(e, "h-5 w-5 animate-spin"),
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ w(
        "path",
        {
          d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
          fill: "currentColor",
          className: "opacity-25"
        }
      ),
      /* @__PURE__ */ w(
        "path",
        {
          d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
function Bh(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (r = Bh(e[t])) && (n && (n += " "), n += r);
  else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function Yb() {
  for (var e, t, r = 0, n = ""; r < arguments.length; ) (e = arguments[r++]) && (t = Bh(e)) && (n && (n += " "), n += t);
  return n;
}
const od = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, id = Yb, Pl = (e, t) => (r) => {
  var n;
  if (t?.variants == null) return id(e, r?.class, r?.className);
  const { variants: o, defaultVariants: i } = t, a = Object.keys(o).map((l) => {
    const u = r?.[l], d = i?.[l];
    if (u === null) return null;
    const f = od(u) || od(d);
    return o[l][f];
  }), s = r && Object.entries(r).reduce((l, u) => {
    let [d, f] = u;
    return f === void 0 || (l[d] = f), l;
  }, {}), c = t == null || (n = t.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((l, u) => {
    let { class: d, className: f, ...h } = u;
    return Object.entries(h).every((g) => {
      let [v, y] = g;
      return Array.isArray(y) ? y.includes({
        ...i,
        ...s
      }[v]) : {
        ...i,
        ...s
      }[v] === y;
    }) ? [
      ...l,
      d,
      f
    ] : l;
  }, []);
  return id(e, a, c, r?.class, r?.className);
}, ka = Pl(
  "inline-flex items-center justify-center whitespace-nowrap rounded-default text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-key-color focus-visible:ring-offset-2 focus-visible:ring-offset-background",
  {
    variants: {
      variant: {
        key: "bg-key-color text-white hover:bg-key-color/90 dark:text-primary-foreground",
        secondary: "bg-secondary text-white hover:bg-secondary/90",
        gray: "bg-gray-backdrop-300 text-default hover:bg-gray-button-hovered",
        black: "bg-default text-background hover:bg-button-hover",
        outline: "border border-border-color bg-background hover:bg-outline-button-hovered hover:text-accent-foreground",
        ghost: "hover:bg-gray-backdrop-300 hover:bg-outline-button-hovered dark:hover:bg-slate-800 dark:hover:text-slate-50",
        plain: "flex justify-between",
        link: "text-primary underline-offset-4 underline"
      },
      size: {
        sm: "h-7 px-[14px]",
        md: "h-[30px] px-[14px]",
        lg: "h-8 px-[14px]",
        full: "w-full h-10 text-base px-[14px]",
        login: "w-full h-12 text-base",
        iconXs: "p-[3px]",
        iconSm: "p-[5px]",
        iconMd: "p-[6px]",
        iconLg: "p-[7px]",
        withIconSm: "pl-3 pr-[14px] h-7",
        withIconMd: "pl-3 pr-[14px] h-[30px]",
        withIconLg: "pl-3 pr-[14px] h-8",
        catButton: "px-2 h-[22px]",
        plain: "p-0"
      },
      state: {
        default: "",
        disabled: "pointer-events-none opacity-38"
      }
    },
    defaultVariants: {
      variant: "key",
      size: "lg",
      state: "default"
    }
  }
);
function hn({
  className: e,
  variant: t,
  size: r,
  asChild: n = !1,
  loading: o = !1,
  children: i,
  ...a
}) {
  if (n) {
    const { disabled: s, onClick: c, tabIndex: l, ...u } = a, d = o || s;
    return /* @__PURE__ */ w(
      fn,
      {
        className: le(
          ka({
            variant: t,
            size: r,
            state: d ? "disabled" : "default",
            className: e
          })
        ),
        "aria-disabled": d || void 0,
        tabIndex: d ? -1 : l,
        onClick: d ? (f) => f.preventDefault() : c,
        ...u,
        children: i
      }
    );
  }
  return /* @__PURE__ */ w(
    "button",
    {
      className: le(
        ka({
          variant: t,
          size: r,
          state: o || a.disabled ? "disabled" : "default",
          className: e
        }),
        o ? "relative" : null
      ),
      disabled: o || a.disabled,
      ...a,
      children: /* @__PURE__ */ Pe(bt, { children: [
        /* @__PURE__ */ w("div", { className: o ? "invisible" : "", children: i }),
        o ? /* @__PURE__ */ Pe("span", { className: "absolute inset-0 flex items-center justify-center", children: [
          /* @__PURE__ */ w(Xb, {}),
          /* @__PURE__ */ w("span", { className: "sr-only", children: "Loading..." })
        ] }) : null
      ] })
    }
  );
}
const Zb = ({
  title: e,
  titleId: t,
  ...r
}, n) => /* @__PURE__ */ p.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: n, "aria-labelledby": t, ...r }, e ? /* @__PURE__ */ p.createElement("title", { id: t }, e) : null, /* @__PURE__ */ p.createElement("g", { clipPath: "url(#clip0_11640_150865)" }, /* @__PURE__ */ p.createElement("path", { d: "M11.9425 6.5L8.5 9.935L5.0575 6.5L4 7.5575L8.5 12.0575L13 7.5575L11.9425 6.5Z" })), /* @__PURE__ */ p.createElement("defs", null, /* @__PURE__ */ p.createElement("clipPath", { id: "clip0_11640_150865" }, /* @__PURE__ */ p.createElement("rect", { width: 18, height: 18, fill: "white" })))), Un = xr(Zb);
function Le(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Kt(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Mt(e, t) {
  const r = Le(e);
  return isNaN(t) ? Kt(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function mr(e, t) {
  const r = Le(e);
  if (isNaN(t)) return Kt(e, NaN);
  if (!t)
    return r;
  const n = r.getDate(), o = Kt(e, r.getTime());
  o.setMonth(r.getMonth() + t + 1, 0);
  const i = o.getDate();
  return n >= i ? o : (r.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    n
  ), r);
}
const El = 6048e5, _b = 864e5, Jb = 6e4, Qb = 36e5;
let $b = {};
function ki() {
  return $b;
}
function Fr(e, t) {
  const r = ki(), n = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, o = Le(e), i = o.getDay(), a = (i < n ? 7 : 0) + i - n;
  return o.setDate(o.getDate() - a), o.setHours(0, 0, 0, 0), o;
}
function Vn(e) {
  return Fr(e, { weekStartsOn: 1 });
}
function Lh(e) {
  const t = Le(e), r = t.getFullYear(), n = Kt(e, 0);
  n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const o = Vn(n), i = Kt(e, 0);
  i.setFullYear(r, 0, 4), i.setHours(0, 0, 0, 0);
  const a = Vn(i);
  return t.getTime() >= o.getTime() ? r + 1 : t.getTime() >= a.getTime() ? r : r - 1;
}
function So(e) {
  const t = Le(e);
  return t.setHours(0, 0, 0, 0), t;
}
function Fa(e) {
  const t = Le(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
function pr(e, t) {
  const r = So(e), n = So(t), o = +r - Fa(r), i = +n - Fa(n);
  return Math.round((o - i) / _b);
}
function e1(e) {
  const t = Lh(e), r = Kt(e, 0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), Vn(r);
}
function Ac(e, t) {
  const r = t * 7;
  return Mt(e, r);
}
function t1(e, t) {
  return mr(e, t * 12);
}
function r1(e) {
  let t;
  return e.forEach(function(r) {
    const n = Le(r);
    (t === void 0 || t < n || isNaN(Number(n))) && (t = n);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function n1(e) {
  let t;
  return e.forEach((r) => {
    const n = Le(r);
    (!t || t > n || isNaN(+n)) && (t = n);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function zt(e, t) {
  const r = So(e), n = So(t);
  return +r == +n;
}
function kl(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function o1(e) {
  if (!kl(e) && typeof e != "number")
    return !1;
  const t = Le(e);
  return !isNaN(Number(t));
}
function fi(e, t) {
  const r = Le(e), n = Le(t), o = r.getFullYear() - n.getFullYear(), i = r.getMonth() - n.getMonth();
  return o * 12 + i;
}
function i1(e, t, r) {
  const n = Fr(e, r), o = Fr(t, r), i = +n - Fa(n), a = +o - Fa(o);
  return Math.round((i - a) / El);
}
function a1(e, t) {
  const r = Le(e), n = Le(t), o = ad(r, n), i = Math.abs(pr(r, n));
  r.setDate(r.getDate() - o * i);
  const a = +(ad(r, n) === -o), s = o * (i - a);
  return s === 0 ? 0 : s;
}
function ad(e, t) {
  const r = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function Wh(e) {
  return (t) => {
    const n = (e ? Math[e] : Math.trunc)(t);
    return n === 0 ? 0 : n;
  };
}
function zh(e, t) {
  return +Le(e) - +Le(t);
}
function sd(e, t, r) {
  const n = zh(e, t) / Qb;
  return Wh(r?.roundingMethod)(n);
}
function cd(e, t, r) {
  const n = zh(e, t) / Jb;
  return Wh(r?.roundingMethod)(n);
}
function Fl(e) {
  const t = Le(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function jt(e) {
  const t = Le(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function jh(e) {
  const t = Le(e), r = Kt(e, 0);
  return r.setFullYear(t.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function Dl(e, t) {
  const r = ki(), n = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, o = Le(e), i = o.getDay(), a = (i < n ? -7 : 0) + 6 - (i - n);
  return o.setDate(o.getDate() + a), o.setHours(23, 59, 59, 999), o;
}
function Uh(e) {
  return Dl(e, { weekStartsOn: 1 });
}
const s1 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, c1 = (e, t, r) => {
  let n;
  const o = s1[e];
  return typeof o == "string" ? n = o : t === 1 ? n = o.one : n = o.other.replace("{{count}}", t.toString()), r?.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
function Zs(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
const l1 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, u1 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, d1 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, f1 = {
  date: Zs({
    formats: l1,
    defaultWidth: "full"
  }),
  time: Zs({
    formats: u1,
    defaultWidth: "full"
  }),
  dateTime: Zs({
    formats: d1,
    defaultWidth: "full"
  })
}, h1 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, v1 = (e, t, r, n) => h1[e];
function Vo(e) {
  return (t, r) => {
    const n = r?.context ? String(r.context) : "standalone";
    let o;
    if (n === "formatting" && e.formattingValues) {
      const a = e.defaultFormattingWidth || e.defaultWidth, s = r?.width ? String(r.width) : a;
      o = e.formattingValues[s] || e.formattingValues[a];
    } else {
      const a = e.defaultWidth, s = r?.width ? String(r.width) : e.defaultWidth;
      o = e.values[s] || e.values[a];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[i];
  };
}
const p1 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, g1 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, m1 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, y1 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, b1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, w1 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, x1 = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, C1 = {
  ordinalNumber: x1,
  era: Vo({
    values: p1,
    defaultWidth: "wide"
  }),
  quarter: Vo({
    values: g1,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Vo({
    values: m1,
    defaultWidth: "wide"
  }),
  day: Vo({
    values: y1,
    defaultWidth: "wide"
  }),
  dayPeriod: Vo({
    values: b1,
    defaultWidth: "wide",
    formattingValues: w1,
    defaultFormattingWidth: "wide"
  })
};
function Ho(e) {
  return (t, r = {}) => {
    const n = r.width, o = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], i = t.match(o);
    if (!i)
      return null;
    const a = i[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], c = Array.isArray(s) ? P1(s, (d) => d.test(a)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      S1(s, (d) => d.test(a))
    );
    let l;
    l = e.valueCallback ? e.valueCallback(c) : c, l = r.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      r.valueCallback(l)
    ) : l;
    const u = t.slice(a.length);
    return { value: l, rest: u };
  };
}
function S1(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function P1(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function E1(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n) return null;
    const o = n[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let a = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    a = r.valueCallback ? r.valueCallback(a) : a;
    const s = t.slice(o.length);
    return { value: a, rest: s };
  };
}
const k1 = /^(\d+)(th|st|nd|rd)?/i, F1 = /\d+/i, D1 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, R1 = {
  any: [/^b/i, /^(a|c)/i]
}, T1 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, A1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, N1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, O1 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, M1 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, I1 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, B1 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, L1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, W1 = {
  ordinalNumber: E1({
    matchPattern: k1,
    parsePattern: F1,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ho({
    matchPatterns: D1,
    defaultMatchWidth: "wide",
    parsePatterns: R1,
    defaultParseWidth: "any"
  }),
  quarter: Ho({
    matchPatterns: T1,
    defaultMatchWidth: "wide",
    parsePatterns: A1,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ho({
    matchPatterns: N1,
    defaultMatchWidth: "wide",
    parsePatterns: O1,
    defaultParseWidth: "any"
  }),
  day: Ho({
    matchPatterns: M1,
    defaultMatchWidth: "wide",
    parsePatterns: I1,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ho({
    matchPatterns: B1,
    defaultMatchWidth: "any",
    parsePatterns: L1,
    defaultParseWidth: "any"
  })
}, Rl = {
  code: "en-US",
  formatDistance: c1,
  formatLong: f1,
  formatRelative: v1,
  localize: C1,
  match: W1,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function z1(e) {
  const t = Le(e);
  return pr(t, jh(t)) + 1;
}
function Vh(e) {
  const t = Le(e), r = +Vn(t) - +e1(t);
  return Math.round(r / El) + 1;
}
function Hh(e, t) {
  const r = Le(e), n = r.getFullYear(), o = ki(), i = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, a = Kt(e, 0);
  a.setFullYear(n + 1, 0, i), a.setHours(0, 0, 0, 0);
  const s = Fr(a, t), c = Kt(e, 0);
  c.setFullYear(n, 0, i), c.setHours(0, 0, 0, 0);
  const l = Fr(c, t);
  return r.getTime() >= s.getTime() ? n + 1 : r.getTime() >= l.getTime() ? n : n - 1;
}
function j1(e, t) {
  const r = ki(), n = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, o = Hh(e, t), i = Kt(e, 0);
  return i.setFullYear(o, 0, n), i.setHours(0, 0, 0, 0), Fr(i, t);
}
function qh(e, t) {
  const r = Le(e), n = +Fr(r, t) - +j1(r, t);
  return Math.round(n / El) + 1;
}
function rt(e, t) {
  const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return r + n;
}
const tn = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
    return rt(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : rt(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return rt(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return rt(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return rt(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return rt(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return rt(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, n = e.getMilliseconds(), o = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return rt(o, t.length);
  }
}, ao = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, ld = {
  // Era
  G: function(e, t, r) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const n = e.getFullYear(), o = n > 0 ? n : 1 - n;
      return r.ordinalNumber(o, { unit: "year" });
    }
    return tn.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    const o = Hh(e, n), i = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const a = i % 100;
      return rt(a, 2);
    }
    return t === "Yo" ? r.ordinalNumber(i, { unit: "year" }) : rt(i, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = Lh(e);
    return rt(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return rt(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(n);
      // 01, 02, 03, 04
      case "QQ":
        return rt(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(n);
      // 01, 02, 03, 04
      case "qq":
        return rt(n, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return tn.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(n + 1);
      // 01, 02, ..., 12
      case "LL":
        return rt(n + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    const o = qh(e, n);
    return t === "wo" ? r.ordinalNumber(o, { unit: "week" }) : rt(o, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const n = Vh(e);
    return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : rt(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : tn.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const n = z1(e);
    return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : rt(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const n = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    const o = e.getDay(), i = (o - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return rt(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return r.ordinalNumber(i, { unit: "day" });
      case "eee":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    const o = e.getDay(), i = (o - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return rt(i, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return r.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return r.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return r.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return r.day(o, {
          width: "short",
          context: "standalone"
        });
      default:
        return r.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const n = e.getDay(), o = n === 0 ? 7 : n;
    switch (t) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return rt(o, t.length);
      // 2nd
      case "io":
        return r.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const n = e.getHours();
    let o;
    switch (n === 12 ? o = ao.noon : n === 0 ? o = ao.midnight : o = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const n = e.getHours();
    let o;
    switch (n >= 17 ? o = ao.evening : n >= 12 ? o = ao.afternoon : n >= 4 ? o = ao.morning : o = ao.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return tn.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : tn.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const n = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : rt(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : rt(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : tn.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : tn.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return tn.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return dd(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Wn(n);
      // Hours and minutes with `:` delimiter
      default:
        return Wn(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return dd(n);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Wn(n);
      // Hours and minutes with `:` delimiter
      default:
        return Wn(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + ud(n, ":");
      default:
        return "GMT" + Wn(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + ud(n, ":");
      default:
        return "GMT" + Wn(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const n = Math.trunc(e.getTime() / 1e3);
    return rt(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    const n = e.getTime();
    return rt(n, t.length);
  }
};
function ud(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), o = Math.trunc(n / 60), i = n % 60;
  return i === 0 ? r + String(o) : r + String(o) + t + rt(i, 2);
}
function dd(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + rt(Math.abs(e) / 60, 2) : Wn(e, t);
}
function Wn(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), o = rt(Math.trunc(n / 60), 2), i = rt(n % 60, 2);
  return r + o + t + i;
}
const fd = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    default:
      return t.date({ width: "full" });
  }
}, Gh = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    default:
      return t.time({ width: "full" });
  }
}, U1 = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], n = r[1], o = r[2];
  if (!o)
    return fd(e, t);
  let i;
  switch (n) {
    case "P":
      i = t.dateTime({ width: "short" });
      break;
    case "PP":
      i = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = t.dateTime({ width: "long" });
      break;
    default:
      i = t.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", fd(n, t)).replace("{{time}}", Gh(o, t));
}, V1 = {
  p: Gh,
  P: U1
}, H1 = /^D+$/, q1 = /^Y+$/, G1 = ["D", "DD", "YY", "YYYY"];
function K1(e) {
  return H1.test(e);
}
function X1(e) {
  return q1.test(e);
}
function Y1(e, t, r) {
  const n = Z1(e, t, r);
  if (console.warn(n), G1.includes(e)) throw new RangeError(n);
}
function Z1(e, t, r) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const _1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, J1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Q1 = /^'([^]*?)'?$/, $1 = /''/g, ew = /[a-zA-Z]/;
function Kn(e, t, r) {
  const n = ki(), o = r?.locale ?? n.locale ?? Rl, i = r?.firstWeekContainsDate ?? r?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, a = r?.weekStartsOn ?? r?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, s = Le(e);
  if (!o1(s))
    throw new RangeError("Invalid time value");
  let c = t.match(J1).map((u) => {
    const d = u[0];
    if (d === "p" || d === "P") {
      const f = V1[d];
      return f(u, o.formatLong);
    }
    return u;
  }).join("").match(_1).map((u) => {
    if (u === "''")
      return { isToken: !1, value: "'" };
    const d = u[0];
    if (d === "'")
      return { isToken: !1, value: tw(u) };
    if (ld[d])
      return { isToken: !0, value: u };
    if (d.match(ew))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + d + "`"
      );
    return { isToken: !1, value: u };
  });
  o.localize.preprocessor && (c = o.localize.preprocessor(s, c));
  const l = {
    firstWeekContainsDate: i,
    weekStartsOn: a,
    locale: o
  };
  return c.map((u) => {
    if (!u.isToken) return u.value;
    const d = u.value;
    (!r?.useAdditionalWeekYearTokens && X1(d) || !r?.useAdditionalDayOfYearTokens && K1(d)) && Y1(d, t, String(e));
    const f = ld[d[0]];
    return f(s, d, o.localize, l);
  }).join("");
}
function tw(e) {
  const t = e.match(Q1);
  return t ? t[1].replace($1, "'") : e;
}
function rw(e) {
  const t = Le(e), r = t.getFullYear(), n = t.getMonth(), o = Kt(e, 0);
  return o.setFullYear(r, n + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function nw(e) {
  return Math.trunc(+Le(e) / 1e3);
}
function ow(e) {
  const t = Le(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function iw(e, t) {
  return i1(
    ow(e),
    jt(e),
    t
  ) + 1;
}
function Nc(e, t) {
  const r = Le(e), n = Le(t);
  return r.getTime() > n.getTime();
}
function Kh(e, t) {
  const r = Le(e), n = Le(t);
  return +r < +n;
}
function Tl(e, t) {
  const r = Le(e), n = Le(t);
  return r.getFullYear() === n.getFullYear() && r.getMonth() === n.getMonth();
}
function aw(e, t) {
  const r = Le(e), n = Le(t);
  return r.getFullYear() === n.getFullYear();
}
function _s(e, t) {
  return Mt(e, -t);
}
function Js(e, t) {
  const r = Le(e), n = r.getFullYear(), o = r.getDate(), i = Kt(e, 0);
  i.setFullYear(n, t, 15), i.setHours(0, 0, 0, 0);
  const a = rw(i);
  return r.setMonth(t, Math.min(o, a)), r;
}
function hd(e, t) {
  const r = Le(e);
  return isNaN(+r) ? Kt(e, NaN) : (r.setFullYear(t), r);
}
var be = function() {
  return be = Object.assign || function(t) {
    for (var r, n = 1, o = arguments.length; n < o; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, be.apply(this, arguments);
};
function sw(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
}
function Xh(e, t, r) {
  for (var n = 0, o = t.length, i; n < o; n++)
    (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function Fi(e) {
  return e.mode === "multiple";
}
function Di(e) {
  return e.mode === "range";
}
function rs(e) {
  return e.mode === "single";
}
var cw = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function lw(e, t) {
  return Kn(e, "LLLL y", t);
}
function uw(e, t) {
  return Kn(e, "d", t);
}
function dw(e, t) {
  return Kn(e, "LLLL", t);
}
function fw(e) {
  return "".concat(e);
}
function hw(e, t) {
  return Kn(e, "cccccc", t);
}
function vw(e, t) {
  return Kn(e, "yyyy", t);
}
var pw = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: lw,
  formatDay: uw,
  formatMonthCaption: dw,
  formatWeekNumber: fw,
  formatWeekdayName: hw,
  formatYearCaption: vw
}), gw = function(e, t, r) {
  return Kn(e, "do MMMM (EEEE)", r);
}, mw = function() {
  return "Month: ";
}, yw = function() {
  return "Go to next month";
}, bw = function() {
  return "Go to previous month";
}, ww = function(e, t) {
  return Kn(e, "cccc", t);
}, xw = function(e) {
  return "Week n. ".concat(e);
}, Cw = function() {
  return "Year: ";
}, Sw = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: gw,
  labelMonthDropdown: mw,
  labelNext: yw,
  labelPrevious: bw,
  labelWeekNumber: xw,
  labelWeekday: ww,
  labelYearDropdown: Cw
});
function Pw() {
  var e = "buttons", t = cw, r = Rl, n = {}, o = {}, i = 1, a = {}, s = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: t,
    formatters: pw,
    labels: Sw,
    locale: r,
    modifiersClassNames: n,
    modifiers: o,
    numberOfMonths: i,
    styles: a,
    today: s,
    mode: "default"
  };
}
function Ew(e) {
  var t = e.fromYear, r = e.toYear, n = e.fromMonth, o = e.toMonth, i = e.fromDate, a = e.toDate;
  return n ? i = jt(n) : t && (i = new Date(t, 0, 1)), o ? a = Fl(o) : r && (a = new Date(r, 11, 31)), {
    fromDate: i ? So(i) : void 0,
    toDate: a ? So(a) : void 0
  };
}
var Yh = Sn(void 0);
function kw(e) {
  var t, r = e.initialProps, n = Pw(), o = Ew(r), i = o.fromDate, a = o.toDate, s = (t = r.captionLayout) !== null && t !== void 0 ? t : n.captionLayout;
  s !== "buttons" && (!i || !a) && (s = "buttons");
  var c;
  (rs(r) || Fi(r) || Di(r)) && (c = r.onSelect);
  var l = be(be(be({}, n), r), { captionLayout: s, classNames: be(be({}, n.classNames), r.classNames), components: be({}, r.components), formatters: be(be({}, n.formatters), r.formatters), fromDate: i, labels: be(be({}, n.labels), r.labels), mode: r.mode || n.mode, modifiers: be(be({}, n.modifiers), r.modifiers), modifiersClassNames: be(be({}, n.modifiersClassNames), r.modifiersClassNames), onSelect: c, styles: be(be({}, n.styles), r.styles), toDate: a });
  return w(Yh.Provider, { value: l, children: e.children });
}
function at() {
  var e = Pn(Yh);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function Zh(e) {
  var t = at(), r = t.locale, n = t.classNames, o = t.styles, i = t.formatters.formatCaption;
  return w("div", { className: n.caption_label, style: o.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: i(e.displayMonth, { locale: r }) });
}
function Fw(e) {
  return w("svg", be({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: w("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function _h(e) {
  var t, r, n = e.onChange, o = e.value, i = e.children, a = e.caption, s = e.className, c = e.style, l = at(), u = (r = (t = l.components) === null || t === void 0 ? void 0 : t.IconDropdown) !== null && r !== void 0 ? r : Fw;
  return Pe("div", { className: s, style: c, children: [w("span", { className: l.classNames.vhidden, children: e["aria-label"] }), w("select", { name: e.name, "aria-label": e["aria-label"], className: l.classNames.dropdown, style: l.styles.dropdown, value: o, onChange: n, children: i }), Pe("div", { className: l.classNames.caption_label, style: l.styles.caption_label, "aria-hidden": "true", children: [a, w(u, { className: l.classNames.dropdown_icon, style: l.styles.dropdown_icon })] })] });
}
function Dw(e) {
  var t, r = at(), n = r.fromDate, o = r.toDate, i = r.styles, a = r.locale, s = r.formatters.formatMonthCaption, c = r.classNames, l = r.components, u = r.labels.labelMonthDropdown;
  if (!n)
    return w(bt, {});
  if (!o)
    return w(bt, {});
  var d = [];
  if (aw(n, o))
    for (var f = jt(n), h = n.getMonth(); h <= o.getMonth(); h++)
      d.push(Js(f, h));
  else
    for (var f = jt(/* @__PURE__ */ new Date()), h = 0; h <= 11; h++)
      d.push(Js(f, h));
  var g = function(y) {
    var b = Number(y.target.value), x = Js(jt(e.displayMonth), b);
    e.onChange(x);
  }, v = (t = l?.Dropdown) !== null && t !== void 0 ? t : _h;
  return w(v, { name: "months", "aria-label": u(), className: c.dropdown_month, style: i.dropdown_month, onChange: g, value: e.displayMonth.getMonth(), caption: s(e.displayMonth, { locale: a }), children: d.map(function(y) {
    return w("option", { value: y.getMonth(), children: s(y, { locale: a }) }, y.getMonth());
  }) });
}
function Rw(e) {
  var t, r = e.displayMonth, n = at(), o = n.fromDate, i = n.toDate, a = n.locale, s = n.styles, c = n.classNames, l = n.components, u = n.formatters.formatYearCaption, d = n.labels.labelYearDropdown, f = [];
  if (!o)
    return w(bt, {});
  if (!i)
    return w(bt, {});
  for (var h = o.getFullYear(), g = i.getFullYear(), v = h; v <= g; v++)
    f.push(hd(jh(/* @__PURE__ */ new Date()), v));
  var y = function(x) {
    var C = hd(jt(r), Number(x.target.value));
    e.onChange(C);
  }, b = (t = l?.Dropdown) !== null && t !== void 0 ? t : _h;
  return w(b, { name: "years", "aria-label": d(), className: c.dropdown_year, style: s.dropdown_year, onChange: y, value: r.getFullYear(), caption: u(r, { locale: a }), children: f.map(function(x) {
    return w("option", { value: x.getFullYear(), children: u(x, { locale: a }) }, x.getFullYear());
  }) });
}
function Tw(e, t) {
  var r = nr(e), n = r[0], o = r[1], i = t === void 0 ? n : t;
  return [i, o];
}
function Aw(e) {
  var t = e.month, r = e.defaultMonth, n = e.today, o = t || r || n || /* @__PURE__ */ new Date(), i = e.toDate, a = e.fromDate, s = e.numberOfMonths, c = s === void 0 ? 1 : s;
  if (i && fi(i, o) < 0) {
    var l = -1 * (c - 1);
    o = mr(i, l);
  }
  return a && fi(o, a) < 0 && (o = a), jt(o);
}
function Nw() {
  var e = at(), t = Aw(e), r = Tw(t, e.month), n = r[0], o = r[1], i = function(a) {
    var s;
    if (!e.disableNavigation) {
      var c = jt(a);
      o(c), (s = e.onMonthChange) === null || s === void 0 || s.call(e, c);
    }
  };
  return [n, i];
}
function Ow(e, t) {
  for (var r = t.reverseMonths, n = t.numberOfMonths, o = jt(e), i = jt(mr(o, n)), a = fi(i, o), s = [], c = 0; c < a; c++) {
    var l = mr(o, c);
    s.push(l);
  }
  return r && (s = s.reverse()), s;
}
function Mw(e, t) {
  if (!t.disableNavigation) {
    var r = t.toDate, n = t.pagedNavigation, o = t.numberOfMonths, i = o === void 0 ? 1 : o, a = n ? i : 1, s = jt(e);
    if (!r)
      return mr(s, a);
    var c = fi(r, e);
    if (!(c < i))
      return mr(s, a);
  }
}
function Iw(e, t) {
  if (!t.disableNavigation) {
    var r = t.fromDate, n = t.pagedNavigation, o = t.numberOfMonths, i = o === void 0 ? 1 : o, a = n ? i : 1, s = jt(e);
    if (!r)
      return mr(s, -a);
    var c = fi(s, r);
    if (!(c <= 0))
      return mr(s, -a);
  }
}
var Jh = Sn(void 0);
function Bw(e) {
  var t = at(), r = Nw(), n = r[0], o = r[1], i = Ow(n, t), a = Mw(n, t), s = Iw(n, t), c = function(d) {
    return i.some(function(f) {
      return Tl(d, f);
    });
  }, l = function(d, f) {
    c(d) || (f && Kh(d, f) ? o(mr(d, 1 + t.numberOfMonths * -1)) : o(d));
  }, u = {
    currentMonth: n,
    displayMonths: i,
    goToMonth: o,
    goToDate: l,
    previousMonth: s,
    nextMonth: a,
    isDateDisplayed: c
  };
  return w(Jh.Provider, { value: u, children: e.children });
}
function Ri() {
  var e = Pn(Jh);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function vd(e) {
  var t, r = at(), n = r.classNames, o = r.styles, i = r.components, a = Ri().goToMonth, s = function(u) {
    a(mr(u, e.displayIndex ? -e.displayIndex : 0));
  }, c = (t = i?.CaptionLabel) !== null && t !== void 0 ? t : Zh, l = w(c, { id: e.id, displayMonth: e.displayMonth });
  return Pe("div", { className: n.caption_dropdowns, style: o.caption_dropdowns, children: [w("div", { className: n.vhidden, children: l }), w(Dw, { onChange: s, displayMonth: e.displayMonth }), w(Rw, { onChange: s, displayMonth: e.displayMonth })] });
}
function Lw(e) {
  return w("svg", be({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: w("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function Ww(e) {
  return w("svg", be({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: w("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var Da = xr(function(e, t) {
  var r = at(), n = r.classNames, o = r.styles, i = [n.button_reset, n.button];
  e.className && i.push(e.className);
  var a = i.join(" "), s = be(be({}, o.button_reset), o.button);
  return e.style && Object.assign(s, e.style), w("button", be({}, e, { ref: t, type: "button", className: a, style: s }));
});
function zw(e) {
  var t, r, n = at(), o = n.dir, i = n.locale, a = n.classNames, s = n.styles, c = n.labels, l = c.labelPrevious, u = c.labelNext, d = n.components;
  if (!e.nextMonth && !e.previousMonth)
    return w(bt, {});
  var f = l(e.previousMonth, { locale: i }), h = [
    a.nav_button,
    a.nav_button_previous
  ].join(" "), g = u(e.nextMonth, { locale: i }), v = [
    a.nav_button,
    a.nav_button_next
  ].join(" "), y = (t = d?.IconRight) !== null && t !== void 0 ? t : Ww, b = (r = d?.IconLeft) !== null && r !== void 0 ? r : Lw;
  return Pe("div", { className: a.nav, style: s.nav, children: [!e.hidePrevious && w(Da, { name: "previous-month", "aria-label": f, className: h, style: s.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: o === "rtl" ? w(y, { className: a.nav_icon, style: s.nav_icon }) : w(b, { className: a.nav_icon, style: s.nav_icon }) }), !e.hideNext && w(Da, { name: "next-month", "aria-label": g, className: v, style: s.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: o === "rtl" ? w(b, { className: a.nav_icon, style: s.nav_icon }) : w(y, { className: a.nav_icon, style: s.nav_icon }) })] });
}
function pd(e) {
  var t = at().numberOfMonths, r = Ri(), n = r.previousMonth, o = r.nextMonth, i = r.goToMonth, a = r.displayMonths, s = a.findIndex(function(g) {
    return Tl(e.displayMonth, g);
  }), c = s === 0, l = s === a.length - 1, u = t > 1 && (c || !l), d = t > 1 && (l || !c), f = function() {
    n && i(n);
  }, h = function() {
    o && i(o);
  };
  return w(zw, { displayMonth: e.displayMonth, hideNext: u, hidePrevious: d, nextMonth: o, previousMonth: n, onPreviousClick: f, onNextClick: h });
}
function jw(e) {
  var t, r = at(), n = r.classNames, o = r.disableNavigation, i = r.styles, a = r.captionLayout, s = r.components, c = (t = s?.CaptionLabel) !== null && t !== void 0 ? t : Zh, l;
  return o ? l = w(c, { id: e.id, displayMonth: e.displayMonth }) : a === "dropdown" ? l = w(vd, { displayMonth: e.displayMonth, id: e.id }) : a === "dropdown-buttons" ? l = Pe(bt, { children: [w(vd, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), w(pd, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : l = Pe(bt, { children: [w(c, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), w(pd, { displayMonth: e.displayMonth, id: e.id })] }), w("div", { className: n.caption, style: i.caption, children: l });
}
function Uw(e) {
  var t = at(), r = t.footer, n = t.styles, o = t.classNames.tfoot;
  return r ? w("tfoot", { className: o, style: n.tfoot, children: w("tr", { children: w("td", { colSpan: 8, children: r }) }) }) : w(bt, {});
}
function Vw(e, t, r) {
  for (var n = r ? Vn(/* @__PURE__ */ new Date()) : Fr(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: t }), o = [], i = 0; i < 7; i++) {
    var a = Mt(n, i);
    o.push(a);
  }
  return o;
}
function Hw() {
  var e = at(), t = e.classNames, r = e.styles, n = e.showWeekNumber, o = e.locale, i = e.weekStartsOn, a = e.ISOWeek, s = e.formatters.formatWeekdayName, c = e.labels.labelWeekday, l = Vw(o, i, a);
  return Pe("tr", { style: r.head_row, className: t.head_row, children: [n && w("td", { style: r.head_cell, className: t.head_cell }), l.map(function(u, d) {
    return w("th", { scope: "col", className: t.head_cell, style: r.head_cell, "aria-label": c(u, { locale: o }), children: s(u, { locale: o }) }, d);
  })] });
}
function qw() {
  var e, t = at(), r = t.classNames, n = t.styles, o = t.components, i = (e = o?.HeadRow) !== null && e !== void 0 ? e : Hw;
  return w("thead", { style: n.head, className: r.head, children: w(i, {}) });
}
function Gw(e) {
  var t = at(), r = t.locale, n = t.formatters.formatDay;
  return w(bt, { children: n(e.date, { locale: r }) });
}
var Al = Sn(void 0);
function Kw(e) {
  if (!Fi(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return w(Al.Provider, { value: t, children: e.children });
  }
  return w(Xw, { initialProps: e.initialProps, children: e.children });
}
function Xw(e) {
  var t = e.initialProps, r = e.children, n = t.selected, o = t.min, i = t.max, a = function(l, u, d) {
    var f, h;
    (f = t.onDayClick) === null || f === void 0 || f.call(t, l, u, d);
    var g = !!(u.selected && o && n?.length === o);
    if (!g) {
      var v = !!(!u.selected && i && n?.length === i);
      if (!v) {
        var y = n ? Xh([], n) : [];
        if (u.selected) {
          var b = y.findIndex(function(x) {
            return zt(l, x);
          });
          y.splice(b, 1);
        } else
          y.push(l);
        (h = t.onSelect) === null || h === void 0 || h.call(t, y, l, u, d);
      }
    }
  }, s = {
    disabled: []
  };
  n && s.disabled.push(function(l) {
    var u = i && n.length > i - 1, d = n.some(function(f) {
      return zt(f, l);
    });
    return !!(u && !d);
  });
  var c = {
    selected: n,
    onDayClick: a,
    modifiers: s
  };
  return w(Al.Provider, { value: c, children: r });
}
function Nl() {
  var e = Pn(Al);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function Yw(e, t) {
  var r = t || {}, n = r.from, o = r.to;
  return n && o ? zt(o, e) && zt(n, e) ? void 0 : zt(o, e) ? { from: o, to: void 0 } : zt(n, e) ? void 0 : Nc(n, e) ? { from: e, to: o } : { from: n, to: e } : o ? Nc(e, o) ? { from: o, to: e } : { from: e, to: o } : n ? Kh(e, n) ? { from: e, to: n } : { from: n, to: e } : { from: e, to: void 0 };
}
var Ol = Sn(void 0);
function Zw(e) {
  if (!Di(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return w(Ol.Provider, { value: t, children: e.children });
  }
  return w(_w, { initialProps: e.initialProps, children: e.children });
}
function _w(e) {
  var t = e.initialProps, r = e.children, n = t.selected, o = n || {}, i = o.from, a = o.to, s = t.min, c = t.max, l = function(h, g, v) {
    var y, b;
    (y = t.onDayClick) === null || y === void 0 || y.call(t, h, g, v);
    var x = Yw(h, n);
    (b = t.onSelect) === null || b === void 0 || b.call(t, x, h, g, v);
  }, u = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (i ? (u.range_start = [i], a ? (u.range_end = [a], zt(i, a) || (u.range_middle = [
    {
      after: i,
      before: a
    }
  ])) : u.range_end = [i]) : a && (u.range_start = [a], u.range_end = [a]), s && (i && !a && u.disabled.push({
    after: _s(i, s - 1),
    before: Mt(i, s - 1)
  }), i && a && u.disabled.push({
    after: i,
    before: Mt(i, s - 1)
  }), !i && a && u.disabled.push({
    after: _s(a, s - 1),
    before: Mt(a, s - 1)
  })), c) {
    if (i && !a && (u.disabled.push({
      before: Mt(i, -c + 1)
    }), u.disabled.push({
      after: Mt(i, c - 1)
    })), i && a) {
      var d = pr(a, i) + 1, f = c - d;
      u.disabled.push({
        before: _s(i, f)
      }), u.disabled.push({
        after: Mt(a, f)
      });
    }
    !i && a && (u.disabled.push({
      before: Mt(a, -c + 1)
    }), u.disabled.push({
      after: Mt(a, c - 1)
    }));
  }
  return w(Ol.Provider, { value: { selected: n, onDayClick: l, modifiers: u }, children: r });
}
function Ml() {
  var e = Pn(Ol);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function pa(e) {
  return Array.isArray(e) ? Xh([], e) : e !== void 0 ? [e] : [];
}
function Jw(e) {
  var t = {};
  return Object.entries(e).forEach(function(r) {
    var n = r[0], o = r[1];
    t[n] = pa(o);
  }), t;
}
var yr;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(yr || (yr = {}));
var Qw = yr.Selected, Ir = yr.Disabled, $w = yr.Hidden, ex = yr.Today, Qs = yr.RangeEnd, $s = yr.RangeMiddle, ec = yr.RangeStart, tx = yr.Outside;
function rx(e, t, r) {
  var n, o = (n = {}, n[Qw] = pa(e.selected), n[Ir] = pa(e.disabled), n[$w] = pa(e.hidden), n[ex] = [e.today], n[Qs] = [], n[$s] = [], n[ec] = [], n[tx] = [], n);
  return e.fromDate && o[Ir].push({ before: e.fromDate }), e.toDate && o[Ir].push({ after: e.toDate }), Fi(e) ? o[Ir] = o[Ir].concat(t.modifiers[Ir]) : Di(e) && (o[Ir] = o[Ir].concat(r.modifiers[Ir]), o[ec] = r.modifiers[ec], o[$s] = r.modifiers[$s], o[Qs] = r.modifiers[Qs]), o;
}
var Qh = Sn(void 0);
function nx(e) {
  var t = at(), r = Nl(), n = Ml(), o = rx(t, r, n), i = Jw(t.modifiers), a = be(be({}, o), i);
  return w(Qh.Provider, { value: a, children: e.children });
}
function $h() {
  var e = Pn(Qh);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function ox(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function ix(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function ax(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function sx(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function cx(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function lx(e, t) {
  var r, n = t.from, o = t.to;
  if (n && o) {
    var i = pr(o, n) < 0;
    i && (r = [o, n], n = r[0], o = r[1]);
    var a = pr(e, n) >= 0 && pr(o, e) >= 0;
    return a;
  }
  return o ? zt(o, e) : n ? zt(n, e) : !1;
}
function ux(e) {
  return kl(e);
}
function dx(e) {
  return Array.isArray(e) && e.every(kl);
}
function fx(e, t) {
  return t.some(function(r) {
    if (typeof r == "boolean")
      return r;
    if (ux(r))
      return zt(e, r);
    if (dx(r))
      return r.includes(e);
    if (ix(r))
      return lx(e, r);
    if (cx(r))
      return r.dayOfWeek.includes(e.getDay());
    if (ox(r)) {
      var n = pr(r.before, e), o = pr(r.after, e), i = n > 0, a = o < 0, s = Nc(r.before, r.after);
      return s ? a && i : i || a;
    }
    return ax(r) ? pr(e, r.after) > 0 : sx(r) ? pr(r.before, e) > 0 : typeof r == "function" ? r(e) : !1;
  });
}
function Il(e, t, r) {
  var n = Object.keys(t).reduce(function(i, a) {
    var s = t[a];
    return fx(e, s) && i.push(a), i;
  }, []), o = {};
  return n.forEach(function(i) {
    return o[i] = !0;
  }), r && !Tl(e, r) && (o.outside = !0), o;
}
function hx(e, t) {
  for (var r = jt(e[0]), n = Fl(e[e.length - 1]), o, i, a = r; a <= n; ) {
    var s = Il(a, t), c = !s.disabled && !s.hidden;
    if (!c) {
      a = Mt(a, 1);
      continue;
    }
    if (s.selected)
      return a;
    s.today && !i && (i = a), o || (o = a), a = Mt(a, 1);
  }
  return i || o;
}
var vx = 365;
function ev(e, t) {
  var r = t.moveBy, n = t.direction, o = t.context, i = t.modifiers, a = t.retry, s = a === void 0 ? { count: 0, lastFocused: e } : a, c = o.weekStartsOn, l = o.fromDate, u = o.toDate, d = o.locale, f = {
    day: Mt,
    week: Ac,
    month: mr,
    year: t1,
    startOfWeek: function(y) {
      return o.ISOWeek ? Vn(y) : Fr(y, { locale: d, weekStartsOn: c });
    },
    endOfWeek: function(y) {
      return o.ISOWeek ? Uh(y) : Dl(y, { locale: d, weekStartsOn: c });
    }
  }, h = f[r](e, n === "after" ? 1 : -1);
  n === "before" && l ? h = r1([l, h]) : n === "after" && u && (h = n1([u, h]));
  var g = !0;
  if (i) {
    var v = Il(h, i);
    g = !v.disabled && !v.hidden;
  }
  return g ? h : s.count > vx ? s.lastFocused : ev(h, {
    moveBy: r,
    direction: n,
    context: o,
    modifiers: i,
    retry: be(be({}, s), { count: s.count + 1 })
  });
}
var tv = Sn(void 0);
function px(e) {
  var t = Ri(), r = $h(), n = nr(), o = n[0], i = n[1], a = nr(), s = a[0], c = a[1], l = hx(t.displayMonths, r), u = o ?? (s && t.isDateDisplayed(s)) ? s : l, d = function() {
    c(o), i(void 0);
  }, f = function(y) {
    i(y);
  }, h = at(), g = function(y, b) {
    if (o) {
      var x = ev(o, {
        moveBy: y,
        direction: b,
        context: h,
        modifiers: r
      });
      zt(o, x) || (t.goToDate(x, o), f(x));
    }
  }, v = {
    focusedDay: o,
    focusTarget: u,
    blur: d,
    focus: f,
    focusDayAfter: function() {
      return g("day", "after");
    },
    focusDayBefore: function() {
      return g("day", "before");
    },
    focusWeekAfter: function() {
      return g("week", "after");
    },
    focusWeekBefore: function() {
      return g("week", "before");
    },
    focusMonthBefore: function() {
      return g("month", "before");
    },
    focusMonthAfter: function() {
      return g("month", "after");
    },
    focusYearBefore: function() {
      return g("year", "before");
    },
    focusYearAfter: function() {
      return g("year", "after");
    },
    focusStartOfWeek: function() {
      return g("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return g("endOfWeek", "after");
    }
  };
  return w(tv.Provider, { value: v, children: e.children });
}
function Bl() {
  var e = Pn(tv);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function gx(e, t) {
  var r = $h(), n = Il(e, r, t);
  return n;
}
var Ll = Sn(void 0);
function mx(e) {
  if (!rs(e.initialProps)) {
    var t = {
      selected: void 0
    };
    return w(Ll.Provider, { value: t, children: e.children });
  }
  return w(yx, { initialProps: e.initialProps, children: e.children });
}
function yx(e) {
  var t = e.initialProps, r = e.children, n = function(i, a, s) {
    var c, l, u;
    if ((c = t.onDayClick) === null || c === void 0 || c.call(t, i, a, s), a.selected && !t.required) {
      (l = t.onSelect) === null || l === void 0 || l.call(t, void 0, i, a, s);
      return;
    }
    (u = t.onSelect) === null || u === void 0 || u.call(t, i, i, a, s);
  }, o = {
    selected: t.selected,
    onDayClick: n
  };
  return w(Ll.Provider, { value: o, children: r });
}
function rv() {
  var e = Pn(Ll);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function bx(e, t) {
  var r = at(), n = rv(), o = Nl(), i = Ml(), a = Bl(), s = a.focusDayAfter, c = a.focusDayBefore, l = a.focusWeekAfter, u = a.focusWeekBefore, d = a.blur, f = a.focus, h = a.focusMonthBefore, g = a.focusMonthAfter, v = a.focusYearBefore, y = a.focusYearAfter, b = a.focusStartOfWeek, x = a.focusEndOfWeek, C = function(L) {
    var U, Y, he, ce;
    rs(r) ? (U = n.onDayClick) === null || U === void 0 || U.call(n, e, t, L) : Fi(r) ? (Y = o.onDayClick) === null || Y === void 0 || Y.call(o, e, t, L) : Di(r) ? (he = i.onDayClick) === null || he === void 0 || he.call(i, e, t, L) : (ce = r.onDayClick) === null || ce === void 0 || ce.call(r, e, t, L);
  }, E = function(L) {
    var U;
    f(e), (U = r.onDayFocus) === null || U === void 0 || U.call(r, e, t, L);
  }, D = function(L) {
    var U;
    d(), (U = r.onDayBlur) === null || U === void 0 || U.call(r, e, t, L);
  }, A = function(L) {
    var U;
    (U = r.onDayMouseEnter) === null || U === void 0 || U.call(r, e, t, L);
  }, R = function(L) {
    var U;
    (U = r.onDayMouseLeave) === null || U === void 0 || U.call(r, e, t, L);
  }, O = function(L) {
    var U;
    (U = r.onDayPointerEnter) === null || U === void 0 || U.call(r, e, t, L);
  }, W = function(L) {
    var U;
    (U = r.onDayPointerLeave) === null || U === void 0 || U.call(r, e, t, L);
  }, z = function(L) {
    var U;
    (U = r.onDayTouchCancel) === null || U === void 0 || U.call(r, e, t, L);
  }, q = function(L) {
    var U;
    (U = r.onDayTouchEnd) === null || U === void 0 || U.call(r, e, t, L);
  }, V = function(L) {
    var U;
    (U = r.onDayTouchMove) === null || U === void 0 || U.call(r, e, t, L);
  }, I = function(L) {
    var U;
    (U = r.onDayTouchStart) === null || U === void 0 || U.call(r, e, t, L);
  }, Z = function(L) {
    var U;
    (U = r.onDayKeyUp) === null || U === void 0 || U.call(r, e, t, L);
  }, Q = function(L) {
    var U;
    switch (L.key) {
      case "ArrowLeft":
        L.preventDefault(), L.stopPropagation(), r.dir === "rtl" ? s() : c();
        break;
      case "ArrowRight":
        L.preventDefault(), L.stopPropagation(), r.dir === "rtl" ? c() : s();
        break;
      case "ArrowDown":
        L.preventDefault(), L.stopPropagation(), l();
        break;
      case "ArrowUp":
        L.preventDefault(), L.stopPropagation(), u();
        break;
      case "PageUp":
        L.preventDefault(), L.stopPropagation(), L.shiftKey ? v() : h();
        break;
      case "PageDown":
        L.preventDefault(), L.stopPropagation(), L.shiftKey ? y() : g();
        break;
      case "Home":
        L.preventDefault(), L.stopPropagation(), b();
        break;
      case "End":
        L.preventDefault(), L.stopPropagation(), x();
        break;
    }
    (U = r.onDayKeyDown) === null || U === void 0 || U.call(r, e, t, L);
  }, K = {
    onClick: C,
    onFocus: E,
    onBlur: D,
    onKeyDown: Q,
    onKeyUp: Z,
    onMouseEnter: A,
    onMouseLeave: R,
    onPointerEnter: O,
    onPointerLeave: W,
    onTouchCancel: z,
    onTouchEnd: q,
    onTouchMove: V,
    onTouchStart: I
  };
  return K;
}
function wx() {
  var e = at(), t = rv(), r = Nl(), n = Ml(), o = rs(e) ? t.selected : Fi(e) ? r.selected : Di(e) ? n.selected : void 0;
  return o;
}
function xx(e) {
  return Object.values(yr).includes(e);
}
function Cx(e, t) {
  var r = [e.classNames.day];
  return Object.keys(t).forEach(function(n) {
    var o = e.modifiersClassNames[n];
    if (o)
      r.push(o);
    else if (xx(n)) {
      var i = e.classNames["day_".concat(n)];
      i && r.push(i);
    }
  }), r;
}
function Sx(e, t) {
  var r = be({}, e.styles.day);
  return Object.keys(t).forEach(function(n) {
    var o;
    r = be(be({}, r), (o = e.modifiersStyles) === null || o === void 0 ? void 0 : o[n]);
  }), r;
}
function Px(e, t, r) {
  var n, o, i, a = at(), s = Bl(), c = gx(e, t), l = bx(e, c), u = wx(), d = !!(a.onDayClick || a.mode !== "default");
  ir(function() {
    var A;
    c.outside || s.focusedDay && d && zt(s.focusedDay, e) && ((A = r.current) === null || A === void 0 || A.focus());
  }, [
    s.focusedDay,
    e,
    r,
    d,
    c.outside
  ]);
  var f = Cx(a, c).join(" "), h = Sx(a, c), g = !!(c.outside && !a.showOutsideDays || c.hidden), v = (i = (o = a.components) === null || o === void 0 ? void 0 : o.DayContent) !== null && i !== void 0 ? i : Gw, y = w(v, { date: e, displayMonth: t, activeModifiers: c }), b = {
    style: h,
    className: f,
    children: y,
    role: "gridcell"
  }, x = s.focusTarget && zt(s.focusTarget, e) && !c.outside, C = s.focusedDay && zt(s.focusedDay, e), E = be(be(be({}, b), (n = { disabled: c.disabled, role: "gridcell" }, n["aria-selected"] = c.selected, n.tabIndex = C || x ? 0 : -1, n)), l), D = {
    isButton: d,
    isHidden: g,
    activeModifiers: c,
    selectedDays: u,
    buttonProps: E,
    divProps: b
  };
  return D;
}
function Ex(e) {
  var t = Wr(null), r = Px(e.date, e.displayMonth, t);
  return r.isHidden ? w("div", { role: "gridcell" }) : r.isButton ? w(Da, be({ name: "day", ref: t }, r.buttonProps)) : w("div", be({}, r.divProps));
}
function kx(e) {
  var t = e.number, r = e.dates, n = at(), o = n.onWeekNumberClick, i = n.styles, a = n.classNames, s = n.locale, c = n.labels.labelWeekNumber, l = n.formatters.formatWeekNumber, u = l(Number(t), { locale: s });
  if (!o)
    return w("span", { className: a.weeknumber, style: i.weeknumber, children: u });
  var d = c(Number(t), { locale: s }), f = function(h) {
    o(t, r, h);
  };
  return w(Da, { name: "week-number", "aria-label": d, className: a.weeknumber, style: i.weeknumber, onClick: f, children: u });
}
function Fx(e) {
  var t, r, n = at(), o = n.styles, i = n.classNames, a = n.showWeekNumber, s = n.components, c = (t = s?.Day) !== null && t !== void 0 ? t : Ex, l = (r = s?.WeekNumber) !== null && r !== void 0 ? r : kx, u;
  return a && (u = w("td", { className: i.cell, style: o.cell, children: w(l, { number: e.weekNumber, dates: e.dates }) })), Pe("tr", { className: i.row, style: o.row, children: [u, e.dates.map(function(d) {
    return w("td", { className: i.cell, style: o.cell, role: "presentation", children: w(c, { displayMonth: e.displayMonth, date: d }) }, nw(d));
  })] });
}
function gd(e, t, r) {
  for (var n = r?.ISOWeek ? Uh(t) : Dl(t, r), o = r?.ISOWeek ? Vn(e) : Fr(e, r), i = pr(n, o), a = [], s = 0; s <= i; s++)
    a.push(Mt(o, s));
  var c = a.reduce(function(l, u) {
    var d = r?.ISOWeek ? Vh(u) : qh(u, r), f = l.find(function(h) {
      return h.weekNumber === d;
    });
    return f ? (f.dates.push(u), l) : (l.push({
      weekNumber: d,
      dates: [u]
    }), l);
  }, []);
  return c;
}
function Dx(e, t) {
  var r = gd(jt(e), Fl(e), t);
  if (t?.useFixedWeeks) {
    var n = iw(e, t);
    if (n < 6) {
      var o = r[r.length - 1], i = o.dates[o.dates.length - 1], a = Ac(i, 6 - n), s = gd(Ac(i, 1), a, t);
      r.push.apply(r, s);
    }
  }
  return r;
}
function Rx(e) {
  var t, r, n, o = at(), i = o.locale, a = o.classNames, s = o.styles, c = o.hideHead, l = o.fixedWeeks, u = o.components, d = o.weekStartsOn, f = o.firstWeekContainsDate, h = o.ISOWeek, g = Dx(e.displayMonth, {
    useFixedWeeks: !!l,
    ISOWeek: h,
    locale: i,
    weekStartsOn: d,
    firstWeekContainsDate: f
  }), v = (t = u?.Head) !== null && t !== void 0 ? t : qw, y = (r = u?.Row) !== null && r !== void 0 ? r : Fx, b = (n = u?.Footer) !== null && n !== void 0 ? n : Uw;
  return Pe("table", { id: e.id, className: a.table, style: s.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!c && w(v, {}), w("tbody", { className: a.tbody, style: s.tbody, children: g.map(function(x) {
    return w(y, { displayMonth: e.displayMonth, dates: x.dates, weekNumber: x.weekNumber }, x.weekNumber);
  }) }), w(b, { displayMonth: e.displayMonth })] });
}
function Tx() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var Ax = Tx() ? fl : ir, tc = !1, Nx = 0;
function md() {
  return "react-day-picker-".concat(++Nx);
}
function Ox(e) {
  var t, r = e ?? (tc ? md() : null), n = nr(r), o = n[0], i = n[1];
  return Ax(function() {
    o === null && i(md());
  }, []), ir(function() {
    tc === !1 && (tc = !0);
  }, []), (t = e ?? o) !== null && t !== void 0 ? t : void 0;
}
function Mx(e) {
  var t, r, n = at(), o = n.dir, i = n.classNames, a = n.styles, s = n.components, c = Ri().displayMonths, l = Ox(n.id ? "".concat(n.id, "-").concat(e.displayIndex) : void 0), u = n.id ? "".concat(n.id, "-grid-").concat(e.displayIndex) : void 0, d = [i.month], f = a.month, h = e.displayIndex === 0, g = e.displayIndex === c.length - 1, v = !h && !g;
  o === "rtl" && (t = [h, g], g = t[0], h = t[1]), h && (d.push(i.caption_start), f = be(be({}, f), a.caption_start)), g && (d.push(i.caption_end), f = be(be({}, f), a.caption_end)), v && (d.push(i.caption_between), f = be(be({}, f), a.caption_between));
  var y = (r = s?.Caption) !== null && r !== void 0 ? r : jw;
  return Pe("div", { className: d.join(" "), style: f, children: [w(y, { id: l, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), w(Rx, { id: u, "aria-labelledby": l, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function Ix(e) {
  var t = at(), r = t.classNames, n = t.styles;
  return w("div", { className: r.months, style: n.months, children: e.children });
}
function Bx(e) {
  var t, r, n = e.initialProps, o = at(), i = Bl(), a = Ri(), s = nr(!1), c = s[0], l = s[1];
  ir(function() {
    o.initialFocus && i.focusTarget && (c || (i.focus(i.focusTarget), l(!0)));
  }, [
    o.initialFocus,
    c,
    i.focus,
    i.focusTarget,
    i
  ]);
  var u = [o.classNames.root, o.className];
  o.numberOfMonths > 1 && u.push(o.classNames.multiple_months), o.showWeekNumber && u.push(o.classNames.with_weeknumber);
  var d = be(be({}, o.styles.root), o.style), f = Object.keys(n).filter(function(g) {
    return g.startsWith("data-");
  }).reduce(function(g, v) {
    var y;
    return be(be({}, g), (y = {}, y[v] = n[v], y));
  }, {}), h = (r = (t = n.components) === null || t === void 0 ? void 0 : t.Months) !== null && r !== void 0 ? r : Ix;
  return w("div", be({ className: u.join(" "), style: d, dir: o.dir, id: o.id, nonce: n.nonce, title: n.title, lang: n.lang }, f, { children: w(h, { children: a.displayMonths.map(function(g, v) {
    return w(Mx, { displayIndex: v, displayMonth: g }, v);
  }) }) }));
}
function Lx(e) {
  var t = e.children, r = sw(e, ["children"]);
  return w(kw, { initialProps: r, children: w(Bw, { children: w(mx, { initialProps: r, children: w(Kw, { initialProps: r, children: w(Zw, { initialProps: r, children: w(nx, { children: w(px, { children: t }) }) }) }) }) }) });
}
function Wx(e) {
  return w(Lx, be({}, e, { children: w(Bx, { initialProps: e }) }));
}
const zx = ({
  className: e,
  classNames: t,
  showOutsideDays: r = !0,
  ...n
}) => /* @__PURE__ */ w(
  Wx,
  {
    locale: Rl,
    showOutsideDays: r,
    className: le("p-3", e),
    classNames: {
      months: "flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0",
      month: "space-y-4",
      caption: "flex justify-center pt-1 relative items-center",
      caption_label: "text-sm font-medium",
      nav: "space-x-1 flex items-center",
      nav_button: le(
        ka({ variant: "outline" }),
        "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100"
      ),
      nav_button_previous: "absolute left-1",
      nav_button_next: "absolute right-1",
      table: "w-full border-collapse space-y-1",
      head_row: "flex",
      head_cell: "text-slate-500 rounded-md w-9 font-normal text-[0.8rem] dark:text-slate-400",
      row: "flex w-full mt-2",
      cell: "h-9 w-9 text-center text-sm p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-slate-100/50 [&:has([aria-selected])]:bg-slate-100 first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20 dark:[&:has([aria-selected].day-outside)]:bg-slate-800/50 dark:[&:has([aria-selected])]:bg-slate-800",
      day: le(
        ka({ variant: "ghost" }),
        "h-9 w-9 p-0 font-normal aria-selected:opacity-100"
      ),
      day_range_end: "day-range-end",
      day_selected: "text-white bg-slate-900 text-slate-50 hover:bg-slate-900 hover:text-slate-50 focus:bg-slate-900 focus:text-slate-50 dark:bg-slate-50 dark:text-slate-900 dark:hover:bg-slate-50 dark:hover:text-slate-900 dark:focus:bg-slate-50 dark:focus:text-slate-900",
      day_today: "bg-slate-100 text-slate-900 dark:bg-slate-800 dark:text-slate-50",
      day_outside: "day-outside text-slate-500 opacity-50 aria-selected:bg-slate-100/50 aria-selected:text-slate-500 aria-selected:opacity-30 dark:text-slate-400 dark:aria-selected:bg-slate-800/50 dark:aria-selected:text-slate-400",
      day_disabled: "text-slate-500 opacity-50 dark:text-slate-400",
      day_range_middle: "aria-selected:bg-slate-100 aria-selected:text-slate-900 dark:aria-selected:bg-slate-800 dark:aria-selected:text-slate-50",
      day_hidden: "invisible",
      ...t
    },
    components: {
      IconLeft: () => /* @__PURE__ */ w(Un, { className: "h-4 w-4 rotate-90 text-default", fill: "currentColor" }),
      IconRight: () => /* @__PURE__ */ w(Un, { className: "h-4 w-4 -rotate-90 text-default", fill: "currentColor" })
    },
    ...n
  }
);
zx.displayName = "Calendar";
function jx(e) {
  const t = e + "CollectionProvider", [r, n] = En(t), [o, i] = r(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (h) => {
    const { scope: g, children: v } = h, y = Ze.useRef(null), b = Ze.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ w(o, { scope: g, itemMap: b, collectionRef: y, children: v });
  };
  a.displayName = t;
  const s = e + "CollectionSlot", c = Ze.forwardRef(
    (h, g) => {
      const { scope: v, children: y } = h, b = i(s, v), x = Co(g, b.collectionRef);
      return /* @__PURE__ */ w(Ea, { ref: x, children: y });
    }
  );
  c.displayName = s;
  const l = e + "CollectionItemSlot", u = "data-radix-collection-item", d = Ze.forwardRef(
    (h, g) => {
      const { scope: v, children: y, ...b } = h, x = Ze.useRef(null), C = Co(g, x), E = i(l, v);
      return Ze.useEffect(() => (E.itemMap.set(x, { ref: x, ...b }), () => {
        E.itemMap.delete(x);
      })), /* @__PURE__ */ w(Ea, { [u]: "", ref: C, children: y });
    }
  );
  d.displayName = l;
  function f(h) {
    const g = i(e + "CollectionConsumer", h);
    return Ze.useCallback(() => {
      const y = g.collectionRef.current;
      if (!y) return [];
      const b = Array.from(y.querySelectorAll(`[${u}]`));
      return Array.from(g.itemMap.values()).sort(
        (E, D) => b.indexOf(E.ref.current) - b.indexOf(D.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: a, Slot: c, ItemSlot: d },
    f,
    n
  ];
}
function Ux(e, t) {
  return p.useReducer((r, n) => t[r][n] ?? r, e);
}
var nv = (e) => {
  const { present: t, children: r } = e, n = Vx(t), o = typeof r == "function" ? r({ present: n.isPresent }) : p.Children.only(r), i = Co(n.ref, Hx(o));
  return typeof r == "function" || n.isPresent ? p.cloneElement(o, { ref: i }) : null;
};
nv.displayName = "Presence";
function Vx(e) {
  const [t, r] = p.useState(), n = p.useRef({}), o = p.useRef(e), i = p.useRef("none"), a = e ? "mounted" : "unmounted", [s, c] = Ux(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return p.useEffect(() => {
    const l = $i(n.current);
    i.current = s === "mounted" ? l : "none";
  }, [s]), wt(() => {
    const l = n.current, u = o.current;
    if (u !== e) {
      const f = i.current, h = $i(l);
      e ? c("MOUNT") : h === "none" || l?.display === "none" ? c("UNMOUNT") : c(u && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, c]), wt(() => {
    if (t) {
      let l;
      const u = t.ownerDocument.defaultView ?? window, d = (h) => {
        const v = $i(n.current).includes(h.animationName);
        if (h.target === t && v && (c("ANIMATION_END"), !o.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, f = (h) => {
        h.target === t && (i.current = $i(n.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(l), t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: p.useCallback((l) => {
      l && (n.current = getComputedStyle(l)), r(l);
    }, [])
  };
}
function $i(e) {
  return e?.animationName || "none";
}
function Hx(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var Wl = "Collapsible", [qx, ov] = En(Wl), [Gx, zl] = qx(Wl), iv = p.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: r,
      open: n,
      defaultOpen: o,
      disabled: i,
      onOpenChange: a,
      ...s
    } = e, [c = !1, l] = Hr({
      prop: n,
      defaultProp: o,
      onChange: a
    });
    return /* @__PURE__ */ w(
      Gx,
      {
        scope: r,
        disabled: i,
        contentId: kr(),
        open: c,
        onOpenToggle: p.useCallback(() => l((u) => !u), [l]),
        children: /* @__PURE__ */ w(
          Gn.div,
          {
            "data-state": Ul(c),
            "data-disabled": i ? "" : void 0,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
iv.displayName = Wl;
var av = "CollapsibleTrigger", sv = p.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: r, ...n } = e, o = zl(av, r);
    return /* @__PURE__ */ w(
      Gn.button,
      {
        type: "button",
        "aria-controls": o.contentId,
        "aria-expanded": o.open || !1,
        "data-state": Ul(o.open),
        "data-disabled": o.disabled ? "" : void 0,
        disabled: o.disabled,
        ...n,
        ref: t,
        onClick: Cl(e.onClick, o.onOpenToggle)
      }
    );
  }
);
sv.displayName = av;
var jl = "CollapsibleContent", cv = p.forwardRef(
  (e, t) => {
    const { forceMount: r, ...n } = e, o = zl(jl, e.__scopeCollapsible);
    return /* @__PURE__ */ w(nv, { present: r || o.open, children: ({ present: i }) => /* @__PURE__ */ w(Kx, { ...n, ref: t, present: i }) });
  }
);
cv.displayName = jl;
var Kx = p.forwardRef((e, t) => {
  const { __scopeCollapsible: r, present: n, children: o, ...i } = e, a = zl(jl, r), [s, c] = p.useState(n), l = p.useRef(null), u = Co(t, l), d = p.useRef(0), f = d.current, h = p.useRef(0), g = h.current, v = a.open || s, y = p.useRef(v), b = p.useRef(void 0);
  return p.useEffect(() => {
    const x = requestAnimationFrame(() => y.current = !1);
    return () => cancelAnimationFrame(x);
  }, []), wt(() => {
    const x = l.current;
    if (x) {
      b.current = b.current || {
        transitionDuration: x.style.transitionDuration,
        animationName: x.style.animationName
      }, x.style.transitionDuration = "0s", x.style.animationName = "none";
      const C = x.getBoundingClientRect();
      d.current = C.height, h.current = C.width, y.current || (x.style.transitionDuration = b.current.transitionDuration, x.style.animationName = b.current.animationName), c(n);
    }
  }, [a.open, n]), /* @__PURE__ */ w(
    Gn.div,
    {
      "data-state": Ul(a.open),
      "data-disabled": a.disabled ? "" : void 0,
      id: a.contentId,
      hidden: !v,
      ...i,
      ref: u,
      style: {
        "--radix-collapsible-content-height": f ? `${f}px` : void 0,
        "--radix-collapsible-content-width": g ? `${g}px` : void 0,
        ...e.style
      },
      children: v && o
    }
  );
});
function Ul(e) {
  return e ? "open" : "closed";
}
var Xx = iv, Yx = sv, Zx = cv, _x = p.createContext(void 0);
function lv(e) {
  const t = p.useContext(_x);
  return e || t || "ltr";
}
var Xr = "Accordion", Jx = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Vl, Qx, $x] = jx(Xr), [ns] = En(Xr, [
  $x,
  ov
]), Hl = ov(), uv = Ze.forwardRef(
  (e, t) => {
    const { type: r, ...n } = e, o = n, i = n;
    return /* @__PURE__ */ w(Vl.Provider, { scope: e.__scopeAccordion, children: r === "multiple" ? /* @__PURE__ */ w(nC, { ...i, ref: t }) : /* @__PURE__ */ w(rC, { ...o, ref: t }) });
  }
);
uv.displayName = Xr;
var [dv, eC] = ns(Xr), [fv, tC] = ns(
  Xr,
  { collapsible: !1 }
), rC = Ze.forwardRef(
  (e, t) => {
    const {
      value: r,
      defaultValue: n,
      onValueChange: o = () => {
      },
      collapsible: i = !1,
      ...a
    } = e, [s, c] = Hr({
      prop: r,
      defaultProp: n,
      onChange: o
    });
    return /* @__PURE__ */ w(
      dv,
      {
        scope: e.__scopeAccordion,
        value: s ? [s] : [],
        onItemOpen: c,
        onItemClose: Ze.useCallback(() => i && c(""), [i, c]),
        children: /* @__PURE__ */ w(fv, { scope: e.__scopeAccordion, collapsible: i, children: /* @__PURE__ */ w(hv, { ...a, ref: t }) })
      }
    );
  }
), nC = Ze.forwardRef((e, t) => {
  const {
    value: r,
    defaultValue: n,
    onValueChange: o = () => {
    },
    ...i
  } = e, [a = [], s] = Hr({
    prop: r,
    defaultProp: n,
    onChange: o
  }), c = Ze.useCallback(
    (u) => s((d = []) => [...d, u]),
    [s]
  ), l = Ze.useCallback(
    (u) => s((d = []) => d.filter((f) => f !== u)),
    [s]
  );
  return /* @__PURE__ */ w(
    dv,
    {
      scope: e.__scopeAccordion,
      value: a,
      onItemOpen: c,
      onItemClose: l,
      children: /* @__PURE__ */ w(fv, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ w(hv, { ...i, ref: t }) })
    }
  );
}), [oC, os] = ns(Xr), hv = Ze.forwardRef(
  (e, t) => {
    const { __scopeAccordion: r, disabled: n, dir: o, orientation: i = "vertical", ...a } = e, s = Ze.useRef(null), c = Co(s, t), l = Qx(r), d = lv(o) === "ltr", f = Cl(e.onKeyDown, (h) => {
      if (!Jx.includes(h.key)) return;
      const g = h.target, v = l().filter((O) => !O.ref.current?.disabled), y = v.findIndex((O) => O.ref.current === g), b = v.length;
      if (y === -1) return;
      h.preventDefault();
      let x = y;
      const C = 0, E = b - 1, D = () => {
        x = y + 1, x > E && (x = C);
      }, A = () => {
        x = y - 1, x < C && (x = E);
      };
      switch (h.key) {
        case "Home":
          x = C;
          break;
        case "End":
          x = E;
          break;
        case "ArrowRight":
          i === "horizontal" && (d ? D() : A());
          break;
        case "ArrowDown":
          i === "vertical" && D();
          break;
        case "ArrowLeft":
          i === "horizontal" && (d ? A() : D());
          break;
        case "ArrowUp":
          i === "vertical" && A();
          break;
      }
      const R = x % b;
      v[R].ref.current?.focus();
    });
    return /* @__PURE__ */ w(
      oC,
      {
        scope: r,
        disabled: n,
        direction: o,
        orientation: i,
        children: /* @__PURE__ */ w(Vl.Slot, { scope: r, children: /* @__PURE__ */ w(
          Gn.div,
          {
            ...a,
            "data-orientation": i,
            ref: c,
            onKeyDown: n ? void 0 : f
          }
        ) })
      }
    );
  }
), Ra = "AccordionItem", [iC, ql] = ns(Ra), vv = Ze.forwardRef(
  (e, t) => {
    const { __scopeAccordion: r, value: n, ...o } = e, i = os(Ra, r), a = eC(Ra, r), s = Hl(r), c = kr(), l = n && a.value.includes(n) || !1, u = i.disabled || e.disabled;
    return /* @__PURE__ */ w(
      iC,
      {
        scope: r,
        open: l,
        disabled: u,
        triggerId: c,
        children: /* @__PURE__ */ w(
          Xx,
          {
            "data-orientation": i.orientation,
            "data-state": wv(l),
            ...s,
            ...o,
            ref: t,
            disabled: u,
            open: l,
            onOpenChange: (d) => {
              d ? a.onItemOpen(n) : a.onItemClose(n);
            }
          }
        )
      }
    );
  }
);
vv.displayName = Ra;
var pv = "AccordionHeader", gv = Ze.forwardRef(
  (e, t) => {
    const { __scopeAccordion: r, ...n } = e, o = os(Xr, r), i = ql(pv, r);
    return /* @__PURE__ */ w(
      Gn.h3,
      {
        "data-orientation": o.orientation,
        "data-state": wv(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        ...n,
        ref: t
      }
    );
  }
);
gv.displayName = pv;
var Oc = "AccordionTrigger", mv = Ze.forwardRef(
  (e, t) => {
    const { __scopeAccordion: r, ...n } = e, o = os(Xr, r), i = ql(Oc, r), a = tC(Oc, r), s = Hl(r);
    return /* @__PURE__ */ w(Vl.ItemSlot, { scope: r, children: /* @__PURE__ */ w(
      Yx,
      {
        "aria-disabled": i.open && !a.collapsible || void 0,
        "data-orientation": o.orientation,
        id: i.triggerId,
        ...s,
        ...n,
        ref: t
      }
    ) });
  }
);
mv.displayName = Oc;
var yv = "AccordionContent", bv = Ze.forwardRef(
  (e, t) => {
    const { __scopeAccordion: r, ...n } = e, o = os(Xr, r), i = ql(yv, r), a = Hl(r);
    return /* @__PURE__ */ w(
      Zx,
      {
        role: "region",
        "aria-labelledby": i.triggerId,
        "data-orientation": o.orientation,
        ...a,
        ...n,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
bv.displayName = yv;
function wv(e) {
  return e ? "open" : "closed";
}
var aC = uv, sC = vv, cC = gv, lC = mv, uC = bv;
const dC = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), xv = (...e) => e.filter((t, r, n) => !!t && t.trim() !== "" && n.indexOf(t) === r).join(" ").trim();
var fC = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const hC = xr(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: n,
    className: o = "",
    children: i,
    iconNode: a,
    ...s
  }, c) => Ec(
    "svg",
    {
      ref: c,
      ...fC,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: n ? Number(r) * 24 / Number(t) : r,
      className: xv("lucide", o),
      ...s
    },
    [
      ...a.map(([l, u]) => Ec(l, u)),
      ...Array.isArray(i) ? i : [i]
    ]
  )
);
const is = (e, t) => {
  const r = xr(
    ({ className: n, ...o }, i) => Ec(hC, {
      ref: i,
      iconNode: t,
      className: xv(`lucide-${dC(e)}`, n),
      ...o
    })
  );
  return r.displayName = `${e}`, r;
};
const vC = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Cv = is("Check", vC);
const pC = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], gC = is("ChevronDown", pC);
const mC = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], yC = is("ChevronRight", mC);
const bC = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], wC = is("Circle", bC), EA = aC;
function kA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w(
    sC,
    {
      "data-slot": "accordion-item",
      className: le("border-b", e),
      ...t
    }
  );
}
function FA({
  className: e,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ w(cC, { className: "flex", children: /* @__PURE__ */ Pe(
    lC,
    {
      "data-slot": "accordion-trigger",
      className: le(
        "flex flex-1 items-center justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180",
        e
      ),
      ...r,
      children: [
        t,
        /* @__PURE__ */ w(gC, { className: "h-4 w-4 shrink-0 transition-transform duration-200" })
      ]
    }
  ) });
}
function DA({
  className: e,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ w(
    uC,
    {
      "data-slot": "accordion-content",
      className: "overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
      ...r,
      children: /* @__PURE__ */ w("div", { className: le("pb-4 pt-0", e), children: t })
    }
  );
}
function yd(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function as(...e) {
  return (t) => {
    let r = !1;
    const n = e.map((o) => {
      const i = yd(o, t);
      return !r && typeof i == "function" && (r = !0), i;
    });
    if (r)
      return () => {
        for (let o = 0; o < n.length; o++) {
          const i = n[o];
          typeof i == "function" ? i() : yd(e[o], null);
        }
      };
  };
}
function Tt(...e) {
  return p.useCallback(as(...e), e);
}
function To(e, t = []) {
  let r = [];
  function n(i, a) {
    const s = p.createContext(a), c = r.length;
    r = [...r, a];
    const l = (d) => {
      const { scope: f, children: h, ...g } = d, v = f?.[e]?.[c] || s, y = p.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ w(v.Provider, { value: y, children: h });
    };
    l.displayName = i + "Provider";
    function u(d, f) {
      const h = f?.[e]?.[c] || s, g = p.useContext(h);
      if (g) return g;
      if (a !== void 0) return a;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return [l, u];
  }
  const o = () => {
    const i = r.map((a) => p.createContext(a));
    return function(s) {
      const c = s?.[e] || i;
      return p.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return o.scopeName = e, [n, xC(o, ...t)];
}
function xC(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const a = n.reduce((s, { useScope: c, scopeName: l }) => {
        const d = c(i)[`__scope${l}`];
        return { ...s, ...d };
      }, {});
      return p.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
function Ve(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(o) {
    if (e?.(o), r === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var vn = globalThis?.document ? p.useLayoutEffect : () => {
}, CC = p[" useInsertionEffect ".trim().toString()] || vn;
function ss({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  },
  caller: n
}) {
  const [o, i, a] = SC({
    defaultProp: t,
    onChange: r
  }), s = e !== void 0, c = s ? e : o;
  {
    const u = p.useRef(e !== void 0);
    p.useEffect(() => {
      const d = u.current;
      d !== s && console.warn(
        `${n} is changing from ${d ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = s;
    }, [s, n]);
  }
  const l = p.useCallback(
    (u) => {
      if (s) {
        const d = PC(u) ? u(e) : u;
        d !== e && a.current?.(d);
      } else
        i(u);
    },
    [s, e, i, a]
  );
  return [c, l];
}
function SC({
  defaultProp: e,
  onChange: t
}) {
  const [r, n] = p.useState(e), o = p.useRef(r), i = p.useRef(t);
  return CC(() => {
    i.current = t;
  }, [t]), p.useEffect(() => {
    o.current !== r && (i.current?.(r), o.current = r);
  }, [r, o]), [r, n, i];
}
function PC(e) {
  return typeof e == "function";
}
function EC(e) {
  const t = p.useRef({ value: e, previous: e });
  return p.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function Sv(e) {
  const [t, r] = p.useState(void 0);
  return vn(() => {
    if (e) {
      r({ width: e.offsetWidth, height: e.offsetHeight });
      const n = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const i = o[0];
        let a, s;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, l = Array.isArray(c) ? c[0] : c;
          a = l.inlineSize, s = l.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        r({ width: a, height: s });
      });
      return n.observe(e, { box: "border-box" }), () => n.unobserve(e);
    } else
      r(void 0);
  }, [e]), t;
}
function kC(e, t) {
  return p.useReducer((r, n) => t[r][n] ?? r, e);
}
var Ao = (e) => {
  const { present: t, children: r } = e, n = FC(t), o = typeof r == "function" ? r({ present: n.isPresent }) : p.Children.only(r), i = Tt(n.ref, DC(o));
  return typeof r == "function" || n.isPresent ? p.cloneElement(o, { ref: i }) : null;
};
Ao.displayName = "Presence";
function FC(e) {
  const [t, r] = p.useState(), n = p.useRef(null), o = p.useRef(e), i = p.useRef("none"), a = e ? "mounted" : "unmounted", [s, c] = kC(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return p.useEffect(() => {
    const l = ea(n.current);
    i.current = s === "mounted" ? l : "none";
  }, [s]), vn(() => {
    const l = n.current, u = o.current;
    if (u !== e) {
      const f = i.current, h = ea(l);
      e ? c("MOUNT") : h === "none" || l?.display === "none" ? c("UNMOUNT") : c(u && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, c]), vn(() => {
    if (t) {
      let l;
      const u = t.ownerDocument.defaultView ?? window, d = (h) => {
        const v = ea(n.current).includes(CSS.escape(h.animationName));
        if (h.target === t && v && (c("ANIMATION_END"), !o.current)) {
          const y = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = y);
          });
        }
      }, f = (h) => {
        h.target === t && (i.current = ea(n.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(l), t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: p.useCallback((l) => {
      n.current = l ? getComputedStyle(l) : null, r(l);
    }, [])
  };
}
function ea(e) {
  return e?.animationName || "none";
}
function DC(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
// @__NO_SIDE_EFFECTS__
function Ta(e) {
  const t = /* @__PURE__ */ RC(e), r = p.forwardRef((n, o) => {
    const { children: i, ...a } = n, s = p.Children.toArray(i), c = s.find(AC);
    if (c) {
      const l = c.props.children, u = s.map((d) => d === c ? p.Children.count(l) > 1 ? p.Children.only(null) : p.isValidElement(l) ? l.props.children : null : d);
      return /* @__PURE__ */ w(t, { ...a, ref: o, children: p.isValidElement(l) ? p.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ w(t, { ...a, ref: o, children: i });
  });
  return r.displayName = `${e}.Slot`, r;
}
// @__NO_SIDE_EFFECTS__
function RC(e) {
  const t = p.forwardRef((r, n) => {
    const { children: o, ...i } = r;
    if (p.isValidElement(o)) {
      const a = OC(o), s = NC(i, o.props);
      return o.type !== p.Fragment && (s.ref = n ? as(n, a) : a), p.cloneElement(o, s);
    }
    return p.Children.count(o) > 1 ? p.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var TC = /* @__PURE__ */ Symbol("radix.slottable");
function AC(e) {
  return p.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === TC;
}
function NC(e, t) {
  const r = { ...t };
  for (const n in t) {
    const o = e[n], i = t[n];
    /^on[A-Z]/.test(n) ? o && i ? r[n] = (...s) => {
      const c = i(...s);
      return o(...s), c;
    } : o && (r[n] = o) : n === "style" ? r[n] = { ...o, ...i } : n === "className" && (r[n] = [o, i].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function OC(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var MC = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], xt = MC.reduce((e, t) => {
  const r = /* @__PURE__ */ Ta(`Primitive.${t}`), n = p.forwardRef((o, i) => {
    const { asChild: a, ...s } = o, c = a ? r : t;
    return typeof window < "u" && (window[/* @__PURE__ */ Symbol.for("radix-ui")] = !0), /* @__PURE__ */ w(c, { ...s, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function Pv(e, t) {
  e && Si.flushSync(() => e.dispatchEvent(t));
}
var cs = "Checkbox", [IC] = To(cs), [BC, Gl] = IC(cs);
function LC(e) {
  const {
    __scopeCheckbox: t,
    checked: r,
    children: n,
    defaultChecked: o,
    disabled: i,
    form: a,
    name: s,
    onCheckedChange: c,
    required: l,
    value: u = "on",
    // @ts-expect-error
    internal_do_not_use_render: d
  } = e, [f, h] = ss({
    prop: r,
    defaultProp: o ?? !1,
    onChange: c,
    caller: cs
  }), [g, v] = p.useState(null), [y, b] = p.useState(null), x = p.useRef(!1), C = g ? !!a || !!g.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), E = {
    checked: f,
    disabled: i,
    setChecked: h,
    control: g,
    setControl: v,
    name: s,
    form: a,
    value: u,
    hasConsumerStoppedPropagationRef: x,
    required: l,
    defaultChecked: ln(o) ? !1 : o,
    isFormControl: C,
    bubbleInput: y,
    setBubbleInput: b
  };
  return /* @__PURE__ */ w(
    BC,
    {
      scope: t,
      ...E,
      children: WC(d) ? d(E) : n
    }
  );
}
var Ev = "CheckboxTrigger", kv = p.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: r, ...n }, o) => {
    const {
      control: i,
      value: a,
      disabled: s,
      checked: c,
      required: l,
      setControl: u,
      setChecked: d,
      hasConsumerStoppedPropagationRef: f,
      isFormControl: h,
      bubbleInput: g
    } = Gl(Ev, e), v = Tt(o, u), y = p.useRef(c);
    return p.useEffect(() => {
      const b = i?.form;
      if (b) {
        const x = () => d(y.current);
        return b.addEventListener("reset", x), () => b.removeEventListener("reset", x);
      }
    }, [i, d]), /* @__PURE__ */ w(
      xt.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": ln(c) ? "mixed" : c,
        "aria-required": l,
        "data-state": Nv(c),
        "data-disabled": s ? "" : void 0,
        disabled: s,
        value: a,
        ...n,
        ref: v,
        onKeyDown: Ve(t, (b) => {
          b.key === "Enter" && b.preventDefault();
        }),
        onClick: Ve(r, (b) => {
          d((x) => ln(x) ? !0 : !x), g && h && (f.current = b.isPropagationStopped(), f.current || b.stopPropagation());
        })
      }
    );
  }
);
kv.displayName = Ev;
var Fv = p.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: r,
      name: n,
      checked: o,
      defaultChecked: i,
      required: a,
      disabled: s,
      value: c,
      onCheckedChange: l,
      form: u,
      ...d
    } = e;
    return /* @__PURE__ */ w(
      LC,
      {
        __scopeCheckbox: r,
        checked: o,
        defaultChecked: i,
        disabled: s,
        required: a,
        onCheckedChange: l,
        name: n,
        form: u,
        value: c,
        internal_do_not_use_render: ({ isFormControl: f }) => /* @__PURE__ */ Pe(bt, { children: [
          /* @__PURE__ */ w(
            kv,
            {
              ...d,
              ref: t,
              __scopeCheckbox: r
            }
          ),
          f && /* @__PURE__ */ w(
            Av,
            {
              __scopeCheckbox: r
            }
          )
        ] })
      }
    );
  }
);
Fv.displayName = cs;
var Dv = "CheckboxIndicator", Rv = p.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: r, forceMount: n, ...o } = e, i = Gl(Dv, r);
    return /* @__PURE__ */ w(
      Ao,
      {
        present: n || ln(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ w(
          xt.span,
          {
            "data-state": Nv(i.checked),
            "data-disabled": i.disabled ? "" : void 0,
            ...o,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
Rv.displayName = Dv;
var Tv = "CheckboxBubbleInput", Av = p.forwardRef(
  ({ __scopeCheckbox: e, ...t }, r) => {
    const {
      control: n,
      hasConsumerStoppedPropagationRef: o,
      checked: i,
      defaultChecked: a,
      required: s,
      disabled: c,
      name: l,
      value: u,
      form: d,
      bubbleInput: f,
      setBubbleInput: h
    } = Gl(Tv, e), g = Tt(r, h), v = EC(i), y = Sv(n);
    p.useEffect(() => {
      const x = f;
      if (!x) return;
      const C = window.HTMLInputElement.prototype, D = Object.getOwnPropertyDescriptor(
        C,
        "checked"
      ).set, A = !o.current;
      if (v !== i && D) {
        const R = new Event("click", { bubbles: A });
        x.indeterminate = ln(i), D.call(x, ln(i) ? !1 : i), x.dispatchEvent(R);
      }
    }, [f, v, i, o]);
    const b = p.useRef(ln(i) ? !1 : i);
    return /* @__PURE__ */ w(
      xt.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: a ?? b.current,
        required: s,
        disabled: c,
        name: l,
        value: u,
        form: d,
        ...t,
        tabIndex: -1,
        ref: g,
        style: {
          ...t.style,
          ...y,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
Av.displayName = Tv;
function WC(e) {
  return typeof e == "function";
}
function ln(e) {
  return e === "indeterminate";
}
function Nv(e) {
  return ln(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function RA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w(
    Fv,
    {
      "data-slot": "checkbox",
      className: le(
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive shadow-xs peer size-4 shrink-0 rounded-[4px] border border-input outline-none transition-shadow focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:border-primary data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground dark:bg-input/30 dark:data-[state=checked]:bg-primary",
        e
      ),
      ...t,
      children: /* @__PURE__ */ w(
        Rv,
        {
          "data-slot": "checkbox-indicator",
          className: "grid place-content-center text-current transition-none",
          children: /* @__PURE__ */ w(Cv, { className: "size-3.5" })
        }
      )
    }
  );
}
var zC = "Label", Ov = p.forwardRef((e, t) => /* @__PURE__ */ w(
  nt.label,
  {
    ...e,
    ref: t,
    onMouseDown: (r) => {
      r.target.closest("button, input, select, textarea") || (e.onMouseDown?.(r), !r.defaultPrevented && r.detail > 1 && r.preventDefault());
    }
  }
));
Ov.displayName = zC;
var jC = Ov;
function UC({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w(
    jC,
    {
      "data-slot": "label",
      className: le(
        "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
        e
      ),
      ...t
    }
  );
}
function TA({
  onChange: e,
  allowMultipleFiles: t = !0,
  accept: r,
  icon: n,
  title: o,
  description: i,
  className: a,
  disabled: s = !1,
  hasBorder: c = !0
}) {
  const [l, u] = nr(!1), d = Wr(null), f = Wr(0), h = ro(
    (C) => {
      C.preventDefault(), C.stopPropagation(), !s && (f.current += 1, u(!0));
    },
    [s]
  ), g = ro((C) => {
    C.preventDefault(), C.stopPropagation(), f.current = Math.max(0, f.current - 1), f.current === 0 && u(!1);
  }, []), v = ro(
    (C) => {
      C.preventDefault(), C.stopPropagation(), s && C.dataTransfer && (C.dataTransfer.dropEffect = "none");
    },
    [s]
  ), y = ro(
    (C) => {
      if (C.preventDefault(), C.stopPropagation(), f.current = 0, !s && C.dataTransfer?.files) {
        const E = C.dataTransfer.files;
        e({
          target: {
            files: E
          }
        });
      }
      u(!1);
    },
    [s, e]
  ), b = ro(() => {
    d.current !== null && (d.current.addEventListener("dragenter", h), d.current.addEventListener("dragleave", g), d.current.addEventListener("dragover", v), d.current.addEventListener("drop", y));
  }, [h, g, v, y]), x = ro(() => {
    d.current !== null && (d.current.removeEventListener("dragenter", h), d.current.removeEventListener("dragleave", g), d.current.removeEventListener("dragover", v), d.current.removeEventListener("drop", y));
  }, [h, g, v, y]);
  return ir(() => (b(), () => x()), [b, x]), /* @__PURE__ */ Pe(
    UC,
    {
      ref: d,
      htmlFor: "dropzone-file",
      className: le(
        "flex h-56 w-full cursor-pointer flex-col items-center justify-center rounded-default text-gray-backdrop-900",
        c && "border border-dashed border-border-color",
        "bg-file-upload-area transition-colors hover:bg-file-upload-area-hover",
        // 다크에서 gray-100과 file-upload-area는 명도가 1.1배밖에 차이나지 않아
        // 파일을 끌고 와도 변화가 보이지 않았다. 브랜드 색으로 확실히 알린다.
        l && "border-key-color bg-selected-plan",
        s && "cursor-not-allowed opacity-50",
        a
      ),
      children: [
        n && /* @__PURE__ */ w("div", { className: "mb-2", children: n }),
        o && /* @__PURE__ */ w("div", { className: "mb-3 mt-1 text-sm", children: o }),
        i && /* @__PURE__ */ w("div", { className: "flex flex-col items-center", children: i }),
        /* @__PURE__ */ w(
          "input",
          {
            id: "dropzone-file",
            type: "file",
            className: "hidden",
            multiple: t,
            onChange: e,
            accept: r,
            disabled: s
          }
        )
      ]
    }
  );
}
function Mv(e) {
  const t = e + "CollectionProvider", [r, n] = To(t), [o, i] = r(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (v) => {
    const { scope: y, children: b } = v, x = Ze.useRef(null), C = Ze.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ w(o, { scope: y, itemMap: C, collectionRef: x, children: b });
  };
  a.displayName = t;
  const s = e + "CollectionSlot", c = /* @__PURE__ */ Ta(s), l = Ze.forwardRef(
    (v, y) => {
      const { scope: b, children: x } = v, C = i(s, b), E = Tt(y, C.collectionRef);
      return /* @__PURE__ */ w(c, { ref: E, children: x });
    }
  );
  l.displayName = s;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", f = /* @__PURE__ */ Ta(u), h = Ze.forwardRef(
    (v, y) => {
      const { scope: b, children: x, ...C } = v, E = Ze.useRef(null), D = Tt(y, E), A = i(u, b);
      return Ze.useEffect(() => (A.itemMap.set(E, { ref: E, ...C }), () => {
        A.itemMap.delete(E);
      })), /* @__PURE__ */ w(f, { [d]: "", ref: D, children: x });
    }
  );
  h.displayName = u;
  function g(v) {
    const y = i(e + "CollectionConsumer", v);
    return Ze.useCallback(() => {
      const x = y.collectionRef.current;
      if (!x) return [];
      const C = Array.from(x.querySelectorAll(`[${d}]`));
      return Array.from(y.itemMap.values()).sort(
        (A, R) => C.indexOf(A.ref.current) - C.indexOf(R.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: a, Slot: l, ItemSlot: h },
    g,
    n
  ];
}
var VC = p.createContext(void 0);
function Iv(e) {
  const t = p.useContext(VC);
  return e || t || "ltr";
}
function Dr(e) {
  const t = p.useRef(e);
  return p.useEffect(() => {
    t.current = e;
  }), p.useMemo(() => (...r) => t.current?.(...r), []);
}
function HC(e, t = globalThis?.document) {
  const r = Dr(e);
  p.useEffect(() => {
    const n = (o) => {
      o.key === "Escape" && r(o);
    };
    return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
  }, [r, t]);
}
var qC = "DismissableLayer", Mc = "dismissableLayer.update", GC = "dismissableLayer.pointerDownOutside", KC = "dismissableLayer.focusOutside", bd, Bv = p.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Lv = p.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: n,
      onPointerDownOutside: o,
      onFocusOutside: i,
      onInteractOutside: a,
      onDismiss: s,
      ...c
    } = e, l = p.useContext(Bv), [u, d] = p.useState(null), f = u?.ownerDocument ?? globalThis?.document, [, h] = p.useState({}), g = Tt(t, (R) => d(R)), v = Array.from(l.layers), [y] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), b = v.indexOf(y), x = u ? v.indexOf(u) : -1, C = l.layersWithOutsidePointerEventsDisabled.size > 0, E = x >= b, D = ZC((R) => {
      const O = R.target, W = [...l.branches].some((z) => z.contains(O));
      !E || W || (o?.(R), a?.(R), R.defaultPrevented || s?.());
    }, f), A = _C((R) => {
      const O = R.target;
      [...l.branches].some((z) => z.contains(O)) || (i?.(R), a?.(R), R.defaultPrevented || s?.());
    }, f);
    return HC((R) => {
      x === l.layers.size - 1 && (n?.(R), !R.defaultPrevented && s && (R.preventDefault(), s()));
    }, f), p.useEffect(() => {
      if (u)
        return r && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (bd = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(u)), l.layers.add(u), wd(), () => {
          r && l.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = bd);
        };
    }, [u, f, r, l]), p.useEffect(() => () => {
      u && (l.layers.delete(u), l.layersWithOutsidePointerEventsDisabled.delete(u), wd());
    }, [u, l]), p.useEffect(() => {
      const R = () => h({});
      return document.addEventListener(Mc, R), () => document.removeEventListener(Mc, R);
    }, []), /* @__PURE__ */ w(
      xt.div,
      {
        ...c,
        ref: g,
        style: {
          pointerEvents: C ? E ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Ve(e.onFocusCapture, A.onFocusCapture),
        onBlurCapture: Ve(e.onBlurCapture, A.onBlurCapture),
        onPointerDownCapture: Ve(
          e.onPointerDownCapture,
          D.onPointerDownCapture
        )
      }
    );
  }
);
Lv.displayName = qC;
var XC = "DismissableLayerBranch", YC = p.forwardRef((e, t) => {
  const r = p.useContext(Bv), n = p.useRef(null), o = Tt(t, n);
  return p.useEffect(() => {
    const i = n.current;
    if (i)
      return r.branches.add(i), () => {
        r.branches.delete(i);
      };
  }, [r.branches]), /* @__PURE__ */ w(xt.div, { ...e, ref: o });
});
YC.displayName = XC;
function ZC(e, t = globalThis?.document) {
  const r = Dr(e), n = p.useRef(!1), o = p.useRef(() => {
  });
  return p.useEffect(() => {
    const i = (s) => {
      if (s.target && !n.current) {
        let c = function() {
          Wv(
            GC,
            r,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = c, t.addEventListener("click", o.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", o.current);
      n.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", i), t.removeEventListener("click", o.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => n.current = !0
  };
}
function _C(e, t = globalThis?.document) {
  const r = Dr(e), n = p.useRef(!1);
  return p.useEffect(() => {
    const o = (i) => {
      i.target && !n.current && Wv(KC, r, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, r]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function wd() {
  const e = new CustomEvent(Mc);
  document.dispatchEvent(e);
}
function Wv(e, t, r, { discrete: n }) {
  const o = r.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && o.addEventListener(e, t, { once: !0 }), n ? Pv(o, i) : o.dispatchEvent(i);
}
var rc = 0;
function JC() {
  p.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? xd()), document.body.insertAdjacentElement("beforeend", e[1] ?? xd()), rc++, () => {
      rc === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), rc--;
    };
  }, []);
}
function xd() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var nc = "focusScope.autoFocusOnMount", oc = "focusScope.autoFocusOnUnmount", Cd = { bubbles: !1, cancelable: !0 }, QC = "FocusScope", zv = p.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: n = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: i,
    ...a
  } = e, [s, c] = p.useState(null), l = Dr(o), u = Dr(i), d = p.useRef(null), f = Tt(t, (v) => c(v)), h = p.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  p.useEffect(() => {
    if (n) {
      let v = function(C) {
        if (h.paused || !s) return;
        const E = C.target;
        s.contains(E) ? d.current = E : on(d.current, { select: !0 });
      }, y = function(C) {
        if (h.paused || !s) return;
        const E = C.relatedTarget;
        E !== null && (s.contains(E) || on(d.current, { select: !0 }));
      }, b = function(C) {
        if (document.activeElement === document.body)
          for (const D of C)
            D.removedNodes.length > 0 && on(s);
      };
      document.addEventListener("focusin", v), document.addEventListener("focusout", y);
      const x = new MutationObserver(b);
      return s && x.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", v), document.removeEventListener("focusout", y), x.disconnect();
      };
    }
  }, [n, s, h.paused]), p.useEffect(() => {
    if (s) {
      Pd.add(h);
      const v = document.activeElement;
      if (!s.contains(v)) {
        const b = new CustomEvent(nc, Cd);
        s.addEventListener(nc, l), s.dispatchEvent(b), b.defaultPrevented || ($C(oS(jv(s)), { select: !0 }), document.activeElement === v && on(s));
      }
      return () => {
        s.removeEventListener(nc, l), setTimeout(() => {
          const b = new CustomEvent(oc, Cd);
          s.addEventListener(oc, u), s.dispatchEvent(b), b.defaultPrevented || on(v ?? document.body, { select: !0 }), s.removeEventListener(oc, u), Pd.remove(h);
        }, 0);
      };
    }
  }, [s, l, u, h]);
  const g = p.useCallback(
    (v) => {
      if (!r && !n || h.paused) return;
      const y = v.key === "Tab" && !v.altKey && !v.ctrlKey && !v.metaKey, b = document.activeElement;
      if (y && b) {
        const x = v.currentTarget, [C, E] = eS(x);
        C && E ? !v.shiftKey && b === E ? (v.preventDefault(), r && on(C, { select: !0 })) : v.shiftKey && b === C && (v.preventDefault(), r && on(E, { select: !0 })) : b === x && v.preventDefault();
      }
    },
    [r, n, h.paused]
  );
  return /* @__PURE__ */ w(xt.div, { tabIndex: -1, ...a, ref: f, onKeyDown: g });
});
zv.displayName = QC;
function $C(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (on(n, { select: t }), document.activeElement !== r) return;
}
function eS(e) {
  const t = jv(e), r = Sd(t, e), n = Sd(t.reverse(), e);
  return [r, n];
}
function jv(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const o = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || o ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function Sd(e, t) {
  for (const r of e)
    if (!tS(r, { upTo: t })) return r;
}
function tS(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function rS(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function on(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && rS(e) && t && e.select();
  }
}
var Pd = nS();
function nS() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && r?.pause(), e = Ed(e, t), e.unshift(t);
    },
    remove(t) {
      e = Ed(e, t), e[0]?.resume();
    }
  };
}
function Ed(e, t) {
  const r = [...e], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function oS(e) {
  return e.filter((t) => t.tagName !== "A");
}
var iS = p[" useId ".trim().toString()] || (() => {
}), aS = 0;
function hi(e) {
  const [t, r] = p.useState(iS());
  return vn(() => {
    r((n) => n ?? String(aS++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
const sS = ["top", "right", "bottom", "left"], pn = Math.min, Ut = Math.max, Aa = Math.round, ta = Math.floor, gn = (e) => ({
  x: e,
  y: e
}), cS = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, lS = {
  start: "end",
  end: "start"
};
function Ic(e, t, r) {
  return Ut(e, pn(t, r));
}
function qr(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Gr(e) {
  return e.split("-")[0];
}
function No(e) {
  return e.split("-")[1];
}
function Kl(e) {
  return e === "x" ? "y" : "x";
}
function Xl(e) {
  return e === "y" ? "height" : "width";
}
function mn(e) {
  return ["top", "bottom"].includes(Gr(e)) ? "y" : "x";
}
function Yl(e) {
  return Kl(mn(e));
}
function uS(e, t, r) {
  r === void 0 && (r = !1);
  const n = No(e), o = Yl(e), i = Xl(o);
  let a = o === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (a = Na(a)), [a, Na(a)];
}
function dS(e) {
  const t = Na(e);
  return [Bc(e), t, Bc(t)];
}
function Bc(e) {
  return e.replace(/start|end/g, (t) => lS[t]);
}
function fS(e, t, r) {
  const n = ["left", "right"], o = ["right", "left"], i = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? o : n : t ? n : o;
    case "left":
    case "right":
      return t ? i : a;
    default:
      return [];
  }
}
function hS(e, t, r, n) {
  const o = No(e);
  let i = fS(Gr(e), r === "start", n);
  return o && (i = i.map((a) => a + "-" + o), t && (i = i.concat(i.map(Bc)))), i;
}
function Na(e) {
  return e.replace(/left|right|bottom|top/g, (t) => cS[t]);
}
function vS(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Uv(e) {
  return typeof e != "number" ? vS(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Oa(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: o
  } = e;
  return {
    width: n,
    height: o,
    top: r,
    left: t,
    right: t + n,
    bottom: r + o,
    x: t,
    y: r
  };
}
function kd(e, t, r) {
  let {
    reference: n,
    floating: o
  } = e;
  const i = mn(t), a = Yl(t), s = Xl(a), c = Gr(t), l = i === "y", u = n.x + n.width / 2 - o.width / 2, d = n.y + n.height / 2 - o.height / 2, f = n[s] / 2 - o[s] / 2;
  let h;
  switch (c) {
    case "top":
      h = {
        x: u,
        y: n.y - o.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: n.y + n.height
      };
      break;
    case "right":
      h = {
        x: n.x + n.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: n.x - o.width,
        y: d
      };
      break;
    default:
      h = {
        x: n.x,
        y: n.y
      };
  }
  switch (No(t)) {
    case "start":
      h[a] -= f * (r && l ? -1 : 1);
      break;
    case "end":
      h[a] += f * (r && l ? -1 : 1);
      break;
  }
  return h;
}
const pS = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: i = [],
    platform: a
  } = r, s = i.filter(Boolean), c = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let l = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: d
  } = kd(l, n, c), f = n, h = {}, g = 0;
  for (let v = 0; v < s.length; v++) {
    const {
      name: y,
      fn: b
    } = s[v], {
      x,
      y: C,
      data: E,
      reset: D
    } = await b({
      x: u,
      y: d,
      initialPlacement: n,
      placement: f,
      strategy: o,
      middlewareData: h,
      rects: l,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = x ?? u, d = C ?? d, h = {
      ...h,
      [y]: {
        ...h[y],
        ...E
      }
    }, D && g <= 50 && (g++, typeof D == "object" && (D.placement && (f = D.placement), D.rects && (l = D.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : D.rects), {
      x: u,
      y: d
    } = kd(l, f, c)), v = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: h
  };
};
async function vi(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: o,
    platform: i,
    rects: a,
    elements: s,
    strategy: c
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = qr(t, e), g = Uv(h), y = s[f ? d === "floating" ? "reference" : "floating" : d], b = Oa(await i.getClippingRect({
    element: (r = await (i.isElement == null ? void 0 : i.isElement(y))) == null || r ? y : y.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(s.floating)),
    boundary: l,
    rootBoundary: u,
    strategy: c
  })), x = d === "floating" ? {
    x: n,
    y: o,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, C = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(s.floating)), E = await (i.isElement == null ? void 0 : i.isElement(C)) ? await (i.getScale == null ? void 0 : i.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, D = Oa(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: x,
    offsetParent: C,
    strategy: c
  }) : x);
  return {
    top: (b.top - D.top + g.top) / E.y,
    bottom: (D.bottom - b.bottom + g.bottom) / E.y,
    left: (b.left - D.left + g.left) / E.x,
    right: (D.right - b.right + g.right) / E.x
  };
}
const gS = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: n,
      placement: o,
      rects: i,
      platform: a,
      elements: s,
      middlewareData: c
    } = t, {
      element: l,
      padding: u = 0
    } = qr(e, t) || {};
    if (l == null)
      return {};
    const d = Uv(u), f = {
      x: r,
      y: n
    }, h = Yl(o), g = Xl(h), v = await a.getDimensions(l), y = h === "y", b = y ? "top" : "left", x = y ? "bottom" : "right", C = y ? "clientHeight" : "clientWidth", E = i.reference[g] + i.reference[h] - f[h] - i.floating[g], D = f[h] - i.reference[h], A = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(l));
    let R = A ? A[C] : 0;
    (!R || !await (a.isElement == null ? void 0 : a.isElement(A))) && (R = s.floating[C] || i.floating[g]);
    const O = E / 2 - D / 2, W = R / 2 - v[g] / 2 - 1, z = pn(d[b], W), q = pn(d[x], W), V = z, I = R - v[g] - q, Z = R / 2 - v[g] / 2 + O, Q = Ic(V, Z, I), K = !c.arrow && No(o) != null && Z !== Q && i.reference[g] / 2 - (Z < V ? z : q) - v[g] / 2 < 0, L = K ? Z < V ? Z - V : Z - I : 0;
    return {
      [h]: f[h] + L,
      data: {
        [h]: Q,
        centerOffset: Z - Q - L,
        ...K && {
          alignmentOffset: L
        }
      },
      reset: K
    };
  }
}), mS = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        middlewareData: i,
        rects: a,
        initialPlacement: s,
        platform: c,
        elements: l
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: v = !0,
        ...y
      } = qr(e, t);
      if ((r = i.arrow) != null && r.alignmentOffset)
        return {};
      const b = Gr(o), x = mn(s), C = Gr(s) === s, E = await (c.isRTL == null ? void 0 : c.isRTL(l.floating)), D = f || (C || !v ? [Na(s)] : dS(s)), A = g !== "none";
      !f && A && D.push(...hS(s, v, g, E));
      const R = [s, ...D], O = await vi(t, y), W = [];
      let z = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (u && W.push(O[b]), d) {
        const Z = uS(o, a, E);
        W.push(O[Z[0]], O[Z[1]]);
      }
      if (z = [...z, {
        placement: o,
        overflows: W
      }], !W.every((Z) => Z <= 0)) {
        var q, V;
        const Z = (((q = i.flip) == null ? void 0 : q.index) || 0) + 1, Q = R[Z];
        if (Q)
          return {
            data: {
              index: Z,
              overflows: z
            },
            reset: {
              placement: Q
            }
          };
        let K = (V = z.filter((L) => L.overflows[0] <= 0).sort((L, U) => L.overflows[1] - U.overflows[1])[0]) == null ? void 0 : V.placement;
        if (!K)
          switch (h) {
            case "bestFit": {
              var I;
              const L = (I = z.filter((U) => {
                if (A) {
                  const Y = mn(U.placement);
                  return Y === x || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Y === "y";
                }
                return !0;
              }).map((U) => [U.placement, U.overflows.filter((Y) => Y > 0).reduce((Y, he) => Y + he, 0)]).sort((U, Y) => U[1] - Y[1])[0]) == null ? void 0 : I[0];
              L && (K = L);
              break;
            }
            case "initialPlacement":
              K = s;
              break;
          }
        if (o !== K)
          return {
            reset: {
              placement: K
            }
          };
      }
      return {};
    }
  };
};
function Fd(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Dd(e) {
  return sS.some((t) => e[t] >= 0);
}
const yS = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r
      } = t, {
        strategy: n = "referenceHidden",
        ...o
      } = qr(e, t);
      switch (n) {
        case "referenceHidden": {
          const i = await vi(t, {
            ...o,
            elementContext: "reference"
          }), a = Fd(i, r.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: Dd(a)
            }
          };
        }
        case "escaped": {
          const i = await vi(t, {
            ...o,
            altBoundary: !0
          }), a = Fd(i, r.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: Dd(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function bS(e, t) {
  const {
    placement: r,
    platform: n,
    elements: o
  } = e, i = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), a = Gr(r), s = No(r), c = mn(r) === "y", l = ["left", "top"].includes(a) ? -1 : 1, u = i && c ? -1 : 1, d = qr(t, e);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: g
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof g == "number" && (h = s === "end" ? g * -1 : g), c ? {
    x: h * u,
    y: f * l
  } : {
    x: f * l,
    y: h * u
  };
}
const wS = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: o,
        y: i,
        placement: a,
        middlewareData: s
      } = t, c = await bS(t, e);
      return a === ((r = s.offset) == null ? void 0 : r.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: o + c.x,
        y: i + c.y,
        data: {
          ...c,
          placement: a
        }
      };
    }
  };
}, xS = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: o
      } = t, {
        mainAxis: i = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (y) => {
            let {
              x: b,
              y: x
            } = y;
            return {
              x: b,
              y: x
            };
          }
        },
        ...c
      } = qr(e, t), l = {
        x: r,
        y: n
      }, u = await vi(t, c), d = mn(Gr(o)), f = Kl(d);
      let h = l[f], g = l[d];
      if (i) {
        const y = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", x = h + u[y], C = h - u[b];
        h = Ic(x, h, C);
      }
      if (a) {
        const y = d === "y" ? "top" : "left", b = d === "y" ? "bottom" : "right", x = g + u[y], C = g - u[b];
        g = Ic(x, g, C);
      }
      const v = s.fn({
        ...t,
        [f]: h,
        [d]: g
      });
      return {
        ...v,
        data: {
          x: v.x - r,
          y: v.y - n,
          enabled: {
            [f]: i,
            [d]: a
          }
        }
      };
    }
  };
}, CS = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: n,
        placement: o,
        rects: i,
        middlewareData: a
      } = t, {
        offset: s = 0,
        mainAxis: c = !0,
        crossAxis: l = !0
      } = qr(e, t), u = {
        x: r,
        y: n
      }, d = mn(o), f = Kl(d);
      let h = u[f], g = u[d];
      const v = qr(s, t), y = typeof v == "number" ? {
        mainAxis: v,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...v
      };
      if (c) {
        const C = f === "y" ? "height" : "width", E = i.reference[f] - i.floating[C] + y.mainAxis, D = i.reference[f] + i.reference[C] - y.mainAxis;
        h < E ? h = E : h > D && (h = D);
      }
      if (l) {
        var b, x;
        const C = f === "y" ? "width" : "height", E = ["top", "left"].includes(Gr(o)), D = i.reference[d] - i.floating[C] + (E && ((b = a.offset) == null ? void 0 : b[d]) || 0) + (E ? 0 : y.crossAxis), A = i.reference[d] + i.reference[C] + (E ? 0 : ((x = a.offset) == null ? void 0 : x[d]) || 0) - (E ? y.crossAxis : 0);
        g < D ? g = D : g > A && (g = A);
      }
      return {
        [f]: h,
        [d]: g
      };
    }
  };
}, SS = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        rects: i,
        platform: a,
        elements: s
      } = t, {
        apply: c = () => {
        },
        ...l
      } = qr(e, t), u = await vi(t, l), d = Gr(o), f = No(o), h = mn(o) === "y", {
        width: g,
        height: v
      } = i.floating;
      let y, b;
      d === "top" || d === "bottom" ? (y = d, b = f === (await (a.isRTL == null ? void 0 : a.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (b = d, y = f === "end" ? "top" : "bottom");
      const x = v - u.top - u.bottom, C = g - u.left - u.right, E = pn(v - u[y], x), D = pn(g - u[b], C), A = !t.middlewareData.shift;
      let R = E, O = D;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (O = C), (n = t.middlewareData.shift) != null && n.enabled.y && (R = x), A && !f) {
        const z = Ut(u.left, 0), q = Ut(u.right, 0), V = Ut(u.top, 0), I = Ut(u.bottom, 0);
        h ? O = g - 2 * (z !== 0 || q !== 0 ? z + q : Ut(u.left, u.right)) : R = v - 2 * (V !== 0 || I !== 0 ? V + I : Ut(u.top, u.bottom));
      }
      await c({
        ...t,
        availableWidth: O,
        availableHeight: R
      });
      const W = await a.getDimensions(s.floating);
      return g !== W.width || v !== W.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function ls() {
  return typeof window < "u";
}
function Oo(e) {
  return Vv(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function qt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ar(e) {
  var t;
  return (t = (Vv(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Vv(e) {
  return ls() ? e instanceof Node || e instanceof qt(e).Node : !1;
}
function br(e) {
  return ls() ? e instanceof Element || e instanceof qt(e).Element : !1;
}
function Rr(e) {
  return ls() ? e instanceof HTMLElement || e instanceof qt(e).HTMLElement : !1;
}
function Rd(e) {
  return !ls() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof qt(e).ShadowRoot;
}
function Ti(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: o
  } = wr(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(o);
}
function PS(e) {
  return ["table", "td", "th"].includes(Oo(e));
}
function us(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Zl(e) {
  const t = _l(), r = br(e) ? wr(e) : e;
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function ES(e) {
  let t = yn(e);
  for (; Rr(t) && !Po(t); ) {
    if (Zl(t))
      return t;
    if (us(t))
      return null;
    t = yn(t);
  }
  return null;
}
function _l() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Po(e) {
  return ["html", "body", "#document"].includes(Oo(e));
}
function wr(e) {
  return qt(e).getComputedStyle(e);
}
function ds(e) {
  return br(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function yn(e) {
  if (Oo(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Rd(e) && e.host || // Fallback.
    Ar(e)
  );
  return Rd(t) ? t.host : t;
}
function Hv(e) {
  const t = yn(e);
  return Po(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Rr(t) && Ti(t) ? t : Hv(t);
}
function pi(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const o = Hv(e), i = o === ((n = e.ownerDocument) == null ? void 0 : n.body), a = qt(o);
  if (i) {
    const s = Lc(a);
    return t.concat(a, a.visualViewport || [], Ti(o) ? o : [], s && r ? pi(s) : []);
  }
  return t.concat(o, pi(o, [], r));
}
function Lc(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function qv(e) {
  const t = wr(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const o = Rr(e), i = o ? e.offsetWidth : r, a = o ? e.offsetHeight : n, s = Aa(r) !== i || Aa(n) !== a;
  return s && (r = i, n = a), {
    width: r,
    height: n,
    $: s
  };
}
function Jl(e) {
  return br(e) ? e : e.contextElement;
}
function wo(e) {
  const t = Jl(e);
  if (!Rr(t))
    return gn(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: o,
    $: i
  } = qv(t);
  let a = (i ? Aa(r.width) : r.width) / n, s = (i ? Aa(r.height) : r.height) / o;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const kS = /* @__PURE__ */ gn(0);
function Gv(e) {
  const t = qt(e);
  return !_l() || !t.visualViewport ? kS : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function FS(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== qt(e) ? !1 : t;
}
function Hn(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const o = e.getBoundingClientRect(), i = Jl(e);
  let a = gn(1);
  t && (n ? br(n) && (a = wo(n)) : a = wo(e));
  const s = FS(i, r, n) ? Gv(i) : gn(0);
  let c = (o.left + s.x) / a.x, l = (o.top + s.y) / a.y, u = o.width / a.x, d = o.height / a.y;
  if (i) {
    const f = qt(i), h = n && br(n) ? qt(n) : n;
    let g = f, v = Lc(g);
    for (; v && n && h !== g; ) {
      const y = wo(v), b = v.getBoundingClientRect(), x = wr(v), C = b.left + (v.clientLeft + parseFloat(x.paddingLeft)) * y.x, E = b.top + (v.clientTop + parseFloat(x.paddingTop)) * y.y;
      c *= y.x, l *= y.y, u *= y.x, d *= y.y, c += C, l += E, g = qt(v), v = Lc(g);
    }
  }
  return Oa({
    width: u,
    height: d,
    x: c,
    y: l
  });
}
function DS(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: o
  } = e;
  const i = o === "fixed", a = Ar(n), s = t ? us(t.floating) : !1;
  if (n === a || s && i)
    return r;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = gn(1);
  const u = gn(0), d = Rr(n);
  if ((d || !d && !i) && ((Oo(n) !== "body" || Ti(a)) && (c = ds(n)), Rr(n))) {
    const f = Hn(n);
    l = wo(n), u.x = f.x + n.clientLeft, u.y = f.y + n.clientTop;
  }
  return {
    width: r.width * l.x,
    height: r.height * l.y,
    x: r.x * l.x - c.scrollLeft * l.x + u.x,
    y: r.y * l.y - c.scrollTop * l.y + u.y
  };
}
function RS(e) {
  return Array.from(e.getClientRects());
}
function Wc(e, t) {
  const r = ds(e).scrollLeft;
  return t ? t.left + r : Hn(Ar(e)).left + r;
}
function TS(e) {
  const t = Ar(e), r = ds(e), n = e.ownerDocument.body, o = Ut(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), i = Ut(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let a = -r.scrollLeft + Wc(e);
  const s = -r.scrollTop;
  return wr(n).direction === "rtl" && (a += Ut(t.clientWidth, n.clientWidth) - o), {
    width: o,
    height: i,
    x: a,
    y: s
  };
}
function AS(e, t) {
  const r = qt(e), n = Ar(e), o = r.visualViewport;
  let i = n.clientWidth, a = n.clientHeight, s = 0, c = 0;
  if (o) {
    i = o.width, a = o.height;
    const l = _l();
    (!l || l && t === "fixed") && (s = o.offsetLeft, c = o.offsetTop);
  }
  return {
    width: i,
    height: a,
    x: s,
    y: c
  };
}
function NS(e, t) {
  const r = Hn(e, !0, t === "fixed"), n = r.top + e.clientTop, o = r.left + e.clientLeft, i = Rr(e) ? wo(e) : gn(1), a = e.clientWidth * i.x, s = e.clientHeight * i.y, c = o * i.x, l = n * i.y;
  return {
    width: a,
    height: s,
    x: c,
    y: l
  };
}
function Td(e, t, r) {
  let n;
  if (t === "viewport")
    n = AS(e, r);
  else if (t === "document")
    n = TS(Ar(e));
  else if (br(t))
    n = NS(t, r);
  else {
    const o = Gv(e);
    n = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return Oa(n);
}
function Kv(e, t) {
  const r = yn(e);
  return r === t || !br(r) || Po(r) ? !1 : wr(r).position === "fixed" || Kv(r, t);
}
function OS(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = pi(e, [], !1).filter((s) => br(s) && Oo(s) !== "body"), o = null;
  const i = wr(e).position === "fixed";
  let a = i ? yn(e) : e;
  for (; br(a) && !Po(a); ) {
    const s = wr(a), c = Zl(a);
    !c && s.position === "fixed" && (o = null), (i ? !c && !o : !c && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Ti(a) && !c && Kv(e, a)) ? n = n.filter((u) => u !== a) : o = s, a = yn(a);
  }
  return t.set(e, n), n;
}
function MS(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: o
  } = e;
  const a = [...r === "clippingAncestors" ? us(t) ? [] : OS(t, this._c) : [].concat(r), n], s = a[0], c = a.reduce((l, u) => {
    const d = Td(t, u, o);
    return l.top = Ut(d.top, l.top), l.right = pn(d.right, l.right), l.bottom = pn(d.bottom, l.bottom), l.left = Ut(d.left, l.left), l;
  }, Td(t, s, o));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function IS(e) {
  const {
    width: t,
    height: r
  } = qv(e);
  return {
    width: t,
    height: r
  };
}
function BS(e, t, r) {
  const n = Rr(t), o = Ar(t), i = r === "fixed", a = Hn(e, !0, i, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = gn(0);
  if (n || !n && !i)
    if ((Oo(t) !== "body" || Ti(o)) && (s = ds(t)), n) {
      const h = Hn(t, !0, i, t);
      c.x = h.x + t.clientLeft, c.y = h.y + t.clientTop;
    } else o && (c.x = Wc(o));
  let l = 0, u = 0;
  if (o && !n && !i) {
    const h = o.getBoundingClientRect();
    u = h.top + s.scrollTop, l = h.left + s.scrollLeft - // RTL <body> scrollbar.
    Wc(o, h);
  }
  const d = a.left + s.scrollLeft - c.x - l, f = a.top + s.scrollTop - c.y - u;
  return {
    x: d,
    y: f,
    width: a.width,
    height: a.height
  };
}
function ic(e) {
  return wr(e).position === "static";
}
function Ad(e, t) {
  if (!Rr(e) || wr(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return Ar(e) === r && (r = r.ownerDocument.body), r;
}
function Xv(e, t) {
  const r = qt(e);
  if (us(e))
    return r;
  if (!Rr(e)) {
    let o = yn(e);
    for (; o && !Po(o); ) {
      if (br(o) && !ic(o))
        return o;
      o = yn(o);
    }
    return r;
  }
  let n = Ad(e, t);
  for (; n && PS(n) && ic(n); )
    n = Ad(n, t);
  return n && Po(n) && ic(n) && !Zl(n) ? r : n || ES(e) || r;
}
const LS = async function(e) {
  const t = this.getOffsetParent || Xv, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: BS(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function WS(e) {
  return wr(e).direction === "rtl";
}
const zS = {
  convertOffsetParentRelativeRectToViewportRelativeRect: DS,
  getDocumentElement: Ar,
  getClippingRect: MS,
  getOffsetParent: Xv,
  getElementRects: LS,
  getClientRects: RS,
  getDimensions: IS,
  getScale: wo,
  isElement: br,
  isRTL: WS
};
function jS(e, t) {
  let r = null, n;
  const o = Ar(e);
  function i() {
    var s;
    clearTimeout(n), (s = r) == null || s.disconnect(), r = null;
  }
  function a(s, c) {
    s === void 0 && (s = !1), c === void 0 && (c = 1), i();
    const {
      left: l,
      top: u,
      width: d,
      height: f
    } = e.getBoundingClientRect();
    if (s || t(), !d || !f)
      return;
    const h = ta(u), g = ta(o.clientWidth - (l + d)), v = ta(o.clientHeight - (u + f)), y = ta(l), x = {
      rootMargin: -h + "px " + -g + "px " + -v + "px " + -y + "px",
      threshold: Ut(0, pn(1, c)) || 1
    };
    let C = !0;
    function E(D) {
      const A = D[0].intersectionRatio;
      if (A !== c) {
        if (!C)
          return a();
        A ? a(!1, A) : n = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      C = !1;
    }
    try {
      r = new IntersectionObserver(E, {
        ...x,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(E, x);
    }
    r.observe(e);
  }
  return a(!0), i;
}
function Yv(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: i = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = n, l = Jl(e), u = o || i ? [...l ? pi(l) : [], ...pi(t)] : [];
  u.forEach((b) => {
    o && b.addEventListener("scroll", r, {
      passive: !0
    }), i && b.addEventListener("resize", r);
  });
  const d = l && s ? jS(l, r) : null;
  let f = -1, h = null;
  a && (h = new ResizeObserver((b) => {
    let [x] = b;
    x && x.target === l && h && (h.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var C;
      (C = h) == null || C.observe(t);
    })), r();
  }), l && !c && h.observe(l), h.observe(t));
  let g, v = c ? Hn(e) : null;
  c && y();
  function y() {
    const b = Hn(e);
    v && (b.x !== v.x || b.y !== v.y || b.width !== v.width || b.height !== v.height) && r(), v = b, g = requestAnimationFrame(y);
  }
  return r(), () => {
    var b;
    u.forEach((x) => {
      o && x.removeEventListener("scroll", r), i && x.removeEventListener("resize", r);
    }), d?.(), (b = h) == null || b.disconnect(), h = null, c && cancelAnimationFrame(g);
  };
}
const US = wS, VS = xS, HS = mS, qS = SS, GS = yS, Nd = gS, KS = CS, XS = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: zS,
    ...r
  }, i = {
    ...o.platform,
    _c: n
  };
  return pS(e, t, {
    ...o,
    platform: i
  });
};
var ga = typeof document < "u" ? fl : ir;
function Ma(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!Ma(e[n], t[n]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), r = o.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const i = o[n];
      if (!(i === "_owner" && e.$$typeof) && !Ma(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Zv(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Od(e, t) {
  const r = Zv(e);
  return Math.round(t * r) / r;
}
function ac(e) {
  const t = p.useRef(e);
  return ga(() => {
    t.current = e;
  }), t;
}
function _v(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: o,
    elements: {
      reference: i,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: c,
    open: l
  } = e, [u, d] = p.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = p.useState(n);
  Ma(f, n) || h(n);
  const [g, v] = p.useState(null), [y, b] = p.useState(null), x = p.useCallback((U) => {
    U !== A.current && (A.current = U, v(U));
  }, []), C = p.useCallback((U) => {
    U !== R.current && (R.current = U, b(U));
  }, []), E = i || g, D = a || y, A = p.useRef(null), R = p.useRef(null), O = p.useRef(u), W = c != null, z = ac(c), q = ac(o), V = ac(l), I = p.useCallback(() => {
    if (!A.current || !R.current)
      return;
    const U = {
      placement: t,
      strategy: r,
      middleware: f
    };
    q.current && (U.platform = q.current), XS(A.current, R.current, U).then((Y) => {
      const he = {
        ...Y,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: V.current !== !1
      };
      Z.current && !Ma(O.current, he) && (O.current = he, Si.flushSync(() => {
        d(he);
      }));
    });
  }, [f, t, r, q, V]);
  ga(() => {
    l === !1 && O.current.isPositioned && (O.current.isPositioned = !1, d((U) => ({
      ...U,
      isPositioned: !1
    })));
  }, [l]);
  const Z = p.useRef(!1);
  ga(() => (Z.current = !0, () => {
    Z.current = !1;
  }), []), ga(() => {
    if (E && (A.current = E), D && (R.current = D), E && D) {
      if (z.current)
        return z.current(E, D, I);
      I();
    }
  }, [E, D, I, z, W]);
  const Q = p.useMemo(() => ({
    reference: A,
    floating: R,
    setReference: x,
    setFloating: C
  }), [x, C]), K = p.useMemo(() => ({
    reference: E,
    floating: D
  }), [E, D]), L = p.useMemo(() => {
    const U = {
      position: r,
      left: 0,
      top: 0
    };
    if (!K.floating)
      return U;
    const Y = Od(K.floating, u.x), he = Od(K.floating, u.y);
    return s ? {
      ...U,
      transform: "translate(" + Y + "px, " + he + "px)",
      ...Zv(K.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: Y,
      top: he
    };
  }, [r, s, K.floating, u.x, u.y]);
  return p.useMemo(() => ({
    ...u,
    update: I,
    refs: Q,
    elements: K,
    floatingStyles: L
  }), [u, I, Q, K, L]);
}
const YS = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: n,
        padding: o
      } = typeof e == "function" ? e(r) : e;
      return n && t(n) ? n.current != null ? Nd({
        element: n.current,
        padding: o
      }).fn(r) : {} : n ? Nd({
        element: n,
        padding: o
      }).fn(r) : {};
    }
  };
}, Jv = (e, t) => ({
  ...US(e),
  options: [e, t]
}), Qv = (e, t) => ({
  ...VS(e),
  options: [e, t]
}), $v = (e, t) => ({
  ...KS(e),
  options: [e, t]
}), ep = (e, t) => ({
  ...HS(e),
  options: [e, t]
}), tp = (e, t) => ({
  ...qS(e),
  options: [e, t]
}), rp = (e, t) => ({
  ...GS(e),
  options: [e, t]
}), np = (e, t) => ({
  ...YS(e),
  options: [e, t]
});
var ZS = "Arrow", op = p.forwardRef((e, t) => {
  const { children: r, width: n = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ w(
    xt.svg,
    {
      ...i,
      ref: t,
      width: n,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? r : /* @__PURE__ */ w("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
op.displayName = ZS;
var _S = op, Ql = "Popper", [ip, ap] = To(Ql), [JS, sp] = ip(Ql), cp = (e) => {
  const { __scopePopper: t, children: r } = e, [n, o] = p.useState(null);
  return /* @__PURE__ */ w(JS, { scope: t, anchor: n, onAnchorChange: o, children: r });
};
cp.displayName = Ql;
var lp = "PopperAnchor", up = p.forwardRef(
  (e, t) => {
    const { __scopePopper: r, virtualRef: n, ...o } = e, i = sp(lp, r), a = p.useRef(null), s = Tt(t, a), c = p.useRef(null);
    return p.useEffect(() => {
      const l = c.current;
      c.current = n?.current || a.current, l !== c.current && i.onAnchorChange(c.current);
    }), n ? null : /* @__PURE__ */ w(xt.div, { ...o, ref: s });
  }
);
up.displayName = lp;
var $l = "PopperContent", [QS, $S] = ip($l), dp = p.forwardRef(
  (e, t) => {
    const {
      __scopePopper: r,
      side: n = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: a = 0,
      arrowPadding: s = 0,
      avoidCollisions: c = !0,
      collisionBoundary: l = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: f = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: g,
      ...v
    } = e, y = sp($l, r), [b, x] = p.useState(null), C = Tt(t, (ee) => x(ee)), [E, D] = p.useState(null), A = Sv(E), R = A?.width ?? 0, O = A?.height ?? 0, W = n + (i !== "center" ? "-" + i : ""), z = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, q = Array.isArray(l) ? l : [l], V = q.length > 0, I = {
      padding: z,
      boundary: q.filter(t2),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: V
    }, { refs: Z, floatingStyles: Q, placement: K, isPositioned: L, middlewareData: U } = _v({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: W,
      whileElementsMounted: (...ee) => Yv(...ee, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: y.anchor
      },
      middleware: [
        Jv({ mainAxis: o + O, alignmentAxis: a }),
        c && Qv({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? $v() : void 0,
          ...I
        }),
        c && ep({ ...I }),
        tp({
          ...I,
          apply: ({ elements: ee, rects: oe, availableWidth: We, availableHeight: Fe }) => {
            const { width: Me, height: ve } = oe.reference, Je = ee.floating.style;
            Je.setProperty("--radix-popper-available-width", `${We}px`), Je.setProperty("--radix-popper-available-height", `${Fe}px`), Je.setProperty("--radix-popper-anchor-width", `${Me}px`), Je.setProperty("--radix-popper-anchor-height", `${ve}px`);
          }
        }),
        E && np({ element: E, padding: s }),
        r2({ arrowWidth: R, arrowHeight: O }),
        f && rp({ strategy: "referenceHidden", ...I })
      ]
    }), [Y, he] = vp(K), ce = Dr(g);
    vn(() => {
      L && ce?.();
    }, [L, ce]);
    const ke = U.arrow?.x, Ie = U.arrow?.y, Ne = U.arrow?.centerOffset !== 0, [qe, ge] = p.useState();
    return vn(() => {
      b && ge(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ w(
      "div",
      {
        ref: Z.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...Q,
          transform: L ? Q.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: qe,
          "--radix-popper-transform-origin": [
            U.transformOrigin?.x,
            U.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...U.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ w(
          QS,
          {
            scope: r,
            placedSide: Y,
            onArrowChange: D,
            arrowX: ke,
            arrowY: Ie,
            shouldHideArrow: Ne,
            children: /* @__PURE__ */ w(
              xt.div,
              {
                "data-side": Y,
                "data-align": he,
                ...v,
                ref: C,
                style: {
                  ...v.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: L ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
dp.displayName = $l;
var fp = "PopperArrow", e2 = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, hp = p.forwardRef(function(t, r) {
  const { __scopePopper: n, ...o } = t, i = $S(fp, n), a = e2[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ w(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ w(
          _S,
          {
            ...o,
            ref: r,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
hp.displayName = fp;
function t2(e) {
  return e !== null;
}
var r2 = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: r, rects: n, middlewareData: o } = t, a = o.arrow?.centerOffset !== 0, s = a ? 0 : e.arrowWidth, c = a ? 0 : e.arrowHeight, [l, u] = vp(r), d = { start: "0%", center: "50%", end: "100%" }[u], f = (o.arrow?.x ?? 0) + s / 2, h = (o.arrow?.y ?? 0) + c / 2;
    let g = "", v = "";
    return l === "bottom" ? (g = a ? d : `${f}px`, v = `${-c}px`) : l === "top" ? (g = a ? d : `${f}px`, v = `${n.floating.height + c}px`) : l === "right" ? (g = `${-c}px`, v = a ? d : `${h}px`) : l === "left" && (g = `${n.floating.width + c}px`, v = a ? d : `${h}px`), { data: { x: g, y: v } };
  }
});
function vp(e) {
  const [t, r = "center"] = e.split("-");
  return [t, r];
}
var pp = cp, n2 = up, o2 = dp, i2 = hp, a2 = "Portal", gp = p.forwardRef((e, t) => {
  const { container: r, ...n } = e, [o, i] = p.useState(!1);
  vn(() => i(!0), []);
  const a = r || o && globalThis?.document?.body;
  return a ? Lf.createPortal(/* @__PURE__ */ w(xt.div, { ...n, ref: t }), a) : null;
});
gp.displayName = a2;
var sc = "rovingFocusGroup.onEntryFocus", s2 = { bubbles: !1, cancelable: !0 }, Ai = "RovingFocusGroup", [zc, mp, c2] = Mv(Ai), [l2, yp] = To(
  Ai,
  [c2]
), [u2, d2] = l2(Ai), bp = p.forwardRef(
  (e, t) => /* @__PURE__ */ w(zc.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ w(zc.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ w(f2, { ...e, ref: t }) }) })
);
bp.displayName = Ai;
var f2 = p.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: r,
    orientation: n,
    loop: o = !1,
    dir: i,
    currentTabStopId: a,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: c,
    onEntryFocus: l,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, f = p.useRef(null), h = Tt(t, f), g = Iv(i), [v, y] = ss({
    prop: a,
    defaultProp: s ?? null,
    onChange: c,
    caller: Ai
  }), [b, x] = p.useState(!1), C = Dr(l), E = mp(r), D = p.useRef(!1), [A, R] = p.useState(0);
  return p.useEffect(() => {
    const O = f.current;
    if (O)
      return O.addEventListener(sc, C), () => O.removeEventListener(sc, C);
  }, [C]), /* @__PURE__ */ w(
    u2,
    {
      scope: r,
      orientation: n,
      dir: g,
      loop: o,
      currentTabStopId: v,
      onItemFocus: p.useCallback(
        (O) => y(O),
        [y]
      ),
      onItemShiftTab: p.useCallback(() => x(!0), []),
      onFocusableItemAdd: p.useCallback(
        () => R((O) => O + 1),
        []
      ),
      onFocusableItemRemove: p.useCallback(
        () => R((O) => O - 1),
        []
      ),
      children: /* @__PURE__ */ w(
        xt.div,
        {
          tabIndex: b || A === 0 ? -1 : 0,
          "data-orientation": n,
          ...d,
          ref: h,
          style: { outline: "none", ...e.style },
          onMouseDown: Ve(e.onMouseDown, () => {
            D.current = !0;
          }),
          onFocus: Ve(e.onFocus, (O) => {
            const W = !D.current;
            if (O.target === O.currentTarget && W && !b) {
              const z = new CustomEvent(sc, s2);
              if (O.currentTarget.dispatchEvent(z), !z.defaultPrevented) {
                const q = E().filter((K) => K.focusable), V = q.find((K) => K.active), I = q.find((K) => K.id === v), Q = [V, I, ...q].filter(
                  Boolean
                ).map((K) => K.ref.current);
                Cp(Q, u);
              }
            }
            D.current = !1;
          }),
          onBlur: Ve(e.onBlur, () => x(!1))
        }
      )
    }
  );
}), wp = "RovingFocusGroupItem", xp = p.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: r,
      focusable: n = !0,
      active: o = !1,
      tabStopId: i,
      children: a,
      ...s
    } = e, c = hi(), l = i || c, u = d2(wp, r), d = u.currentTabStopId === l, f = mp(r), { onFocusableItemAdd: h, onFocusableItemRemove: g, currentTabStopId: v } = u;
    return p.useEffect(() => {
      if (n)
        return h(), () => g();
    }, [n, h, g]), /* @__PURE__ */ w(
      zc.ItemSlot,
      {
        scope: r,
        id: l,
        focusable: n,
        active: o,
        children: /* @__PURE__ */ w(
          xt.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": u.orientation,
            ...s,
            ref: t,
            onMouseDown: Ve(e.onMouseDown, (y) => {
              n ? u.onItemFocus(l) : y.preventDefault();
            }),
            onFocus: Ve(e.onFocus, () => u.onItemFocus(l)),
            onKeyDown: Ve(e.onKeyDown, (y) => {
              if (y.key === "Tab" && y.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (y.target !== y.currentTarget) return;
              const b = p2(y, u.orientation, u.dir);
              if (b !== void 0) {
                if (y.metaKey || y.ctrlKey || y.altKey || y.shiftKey) return;
                y.preventDefault();
                let C = f().filter((E) => E.focusable).map((E) => E.ref.current);
                if (b === "last") C.reverse();
                else if (b === "prev" || b === "next") {
                  b === "prev" && C.reverse();
                  const E = C.indexOf(y.currentTarget);
                  C = u.loop ? g2(C, E + 1) : C.slice(E + 1);
                }
                setTimeout(() => Cp(C));
              }
            }),
            children: typeof a == "function" ? a({ isCurrentTabStop: d, hasTabStop: v != null }) : a
          }
        )
      }
    );
  }
);
xp.displayName = wp;
var h2 = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function v2(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function p2(e, t, r) {
  const n = v2(e.key, r);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(n)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(n)))
    return h2[n];
}
function Cp(e, t = !1) {
  const r = document.activeElement;
  for (const n of e)
    if (n === r || (n.focus({ preventScroll: t }), document.activeElement !== r)) return;
}
function g2(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
var m2 = bp, y2 = xp, Sp = Jf(), cc = function() {
}, fs = p.forwardRef(function(e, t) {
  var r = p.useRef(null), n = p.useState({
    onScrollCapture: cc,
    onWheelCapture: cc,
    onTouchMoveCapture: cc
  }), o = n[0], i = n[1], a = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, h = e.noRelative, g = e.noIsolation, v = e.inert, y = e.allowPinchZoom, b = e.as, x = b === void 0 ? "div" : b, C = e.gapMode, E = gl(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), D = f, A = _f([r, t]), R = Rt(Rt({}, E), o);
  return p.createElement(
    p.Fragment,
    null,
    u && p.createElement(D, { sideCar: Sp, removeScrollBar: l, shards: d, noRelative: h, noIsolation: g, inert: v, setCallbacks: i, allowPinchZoom: !!y, lockRef: r, gapMode: C }),
    a ? p.cloneElement(p.Children.only(s), Rt(Rt({}, R), { ref: A })) : p.createElement(x, Rt({}, R, { className: c, ref: A }), s)
  );
});
fs.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
fs.classNames = {
  fullWidth: ai,
  zeroRight: ii
};
var jc = !1;
if (typeof window < "u")
  try {
    var ra = Object.defineProperty({}, "passive", {
      get: function() {
        return jc = !0, !0;
      }
    });
    window.addEventListener("test", ra, ra), window.removeEventListener("test", ra, ra);
  } catch {
    jc = !1;
  }
var so = jc ? { passive: !1 } : !1, b2 = function(e) {
  return e.tagName === "TEXTAREA";
}, Pp = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !b2(e) && r[t] === "visible")
  );
}, w2 = function(e) {
  return Pp(e, "overflowY");
}, x2 = function(e) {
  return Pp(e, "overflowX");
}, Md = function(e, t) {
  var r = t.ownerDocument, n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var o = Ep(e, n);
    if (o) {
      var i = kp(e, n), a = i[1], s = i[2];
      if (a > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== r.body);
  return !1;
}, C2 = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, S2 = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, Ep = function(e, t) {
  return e === "v" ? w2(t) : x2(t);
}, kp = function(e, t) {
  return e === "v" ? C2(t) : S2(t);
}, P2 = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, E2 = function(e, t, r, n, o) {
  var i = P2(e, window.getComputedStyle(t).direction), a = i * n, s = r.target, c = t.contains(s), l = !1, u = a > 0, d = 0, f = 0;
  do {
    if (!s)
      break;
    var h = kp(e, s), g = h[0], v = h[1], y = h[2], b = v - y - i * g;
    (g || b) && Ep(e, s) && (d += b, f += g);
    var x = s.parentNode;
    s = x && x.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? x.host : x;
  } while (
    // portaled content
    !c && s !== document.body || // self content
    c && (t.contains(s) || t === s)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(f) < 1) && (l = !0), l;
}, na = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Id = function(e) {
  return [e.deltaX, e.deltaY];
}, Bd = function(e) {
  return e && "current" in e ? e.current : e;
}, k2 = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, F2 = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, D2 = 0, co = [];
function R2(e) {
  var t = p.useRef([]), r = p.useRef([0, 0]), n = p.useRef(), o = p.useState(D2++)[0], i = p.useState(ml)[0], a = p.useRef(e);
  p.useEffect(function() {
    a.current = e;
  }, [e]), p.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var v = Zf([e.lockRef.current], (e.shards || []).map(Bd), !0).filter(Boolean);
      return v.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), v.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = p.useCallback(function(v, y) {
    if ("touches" in v && v.touches.length === 2 || v.type === "wheel" && v.ctrlKey)
      return !a.current.allowPinchZoom;
    var b = na(v), x = r.current, C = "deltaX" in v ? v.deltaX : x[0] - b[0], E = "deltaY" in v ? v.deltaY : x[1] - b[1], D, A = v.target, R = Math.abs(C) > Math.abs(E) ? "h" : "v";
    if ("touches" in v && R === "h" && A.type === "range")
      return !1;
    var O = Md(R, A);
    if (!O)
      return !0;
    if (O ? D = R : (D = R === "v" ? "h" : "v", O = Md(R, A)), !O)
      return !1;
    if (!n.current && "changedTouches" in v && (C || E) && (n.current = D), !D)
      return !0;
    var W = n.current || D;
    return E2(W, y, v, W === "h" ? C : E);
  }, []), c = p.useCallback(function(v) {
    var y = v;
    if (!(!co.length || co[co.length - 1] !== i)) {
      var b = "deltaY" in y ? Id(y) : na(y), x = t.current.filter(function(D) {
        return D.name === y.type && (D.target === y.target || y.target === D.shadowParent) && k2(D.delta, b);
      })[0];
      if (x && x.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!x) {
        var C = (a.current.shards || []).map(Bd).filter(Boolean).filter(function(D) {
          return D.contains(y.target);
        }), E = C.length > 0 ? s(y, C[0]) : !a.current.noIsolation;
        E && y.cancelable && y.preventDefault();
      }
    }
  }, []), l = p.useCallback(function(v, y, b, x) {
    var C = { name: v, delta: y, target: b, should: x, shadowParent: T2(b) };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(E) {
        return E !== C;
      });
    }, 1);
  }, []), u = p.useCallback(function(v) {
    r.current = na(v), n.current = void 0;
  }, []), d = p.useCallback(function(v) {
    l(v.type, Id(v), v.target, s(v, e.lockRef.current));
  }, []), f = p.useCallback(function(v) {
    l(v.type, na(v), v.target, s(v, e.lockRef.current));
  }, []);
  p.useEffect(function() {
    return co.push(i), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", c, so), document.addEventListener("touchmove", c, so), document.addEventListener("touchstart", u, so), function() {
      co = co.filter(function(v) {
        return v !== i;
      }), document.removeEventListener("wheel", c, so), document.removeEventListener("touchmove", c, so), document.removeEventListener("touchstart", u, so);
    };
  }, []);
  var h = e.removeScrollBar, g = e.inert;
  return p.createElement(
    p.Fragment,
    null,
    g ? p.createElement(i, { styles: F2(o) }) : null,
    h ? p.createElement(th, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function T2(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const A2 = $f(Sp, R2);
var Fp = p.forwardRef(function(e, t) {
  return p.createElement(fs, Rt({}, e, { ref: t, sideCar: A2 }));
});
Fp.classNames = fs.classNames;
var Uc = ["Enter", " "], N2 = ["ArrowDown", "PageUp", "Home"], Dp = ["ArrowUp", "PageDown", "End"], O2 = [...N2, ...Dp], M2 = {
  ltr: [...Uc, "ArrowRight"],
  rtl: [...Uc, "ArrowLeft"]
}, I2 = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Ni = "Menu", [gi, B2, L2] = Mv(Ni), [Xn, Rp] = To(Ni, [
  L2,
  ap,
  yp
]), Oi = ap(), Tp = yp(), [Ap, Fn] = Xn(Ni), [W2, Mi] = Xn(Ni), Np = (e) => {
  const { __scopeMenu: t, open: r = !1, children: n, dir: o, onOpenChange: i, modal: a = !0 } = e, s = Oi(t), [c, l] = p.useState(null), u = p.useRef(!1), d = Dr(i), f = Iv(o);
  return p.useEffect(() => {
    const h = () => {
      u.current = !0, document.addEventListener("pointerdown", g, { capture: !0, once: !0 }), document.addEventListener("pointermove", g, { capture: !0, once: !0 });
    }, g = () => u.current = !1;
    return document.addEventListener("keydown", h, { capture: !0 }), () => {
      document.removeEventListener("keydown", h, { capture: !0 }), document.removeEventListener("pointerdown", g, { capture: !0 }), document.removeEventListener("pointermove", g, { capture: !0 });
    };
  }, []), /* @__PURE__ */ w(pp, { ...s, children: /* @__PURE__ */ w(
    Ap,
    {
      scope: t,
      open: r,
      onOpenChange: d,
      content: c,
      onContentChange: l,
      children: /* @__PURE__ */ w(
        W2,
        {
          scope: t,
          onClose: p.useCallback(() => d(!1), [d]),
          isUsingKeyboardRef: u,
          dir: f,
          modal: a,
          children: n
        }
      )
    }
  ) });
};
Np.displayName = Ni;
var z2 = "MenuAnchor", eu = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e, o = Oi(r);
    return /* @__PURE__ */ w(n2, { ...o, ...n, ref: t });
  }
);
eu.displayName = z2;
var tu = "MenuPortal", [j2, Op] = Xn(tu, {
  forceMount: void 0
}), Mp = (e) => {
  const { __scopeMenu: t, forceMount: r, children: n, container: o } = e, i = Fn(tu, t);
  return /* @__PURE__ */ w(j2, { scope: t, forceMount: r, children: /* @__PURE__ */ w(Ao, { present: r || i.open, children: /* @__PURE__ */ w(gp, { asChild: !0, container: o, children: n }) }) });
};
Mp.displayName = tu;
var or = "MenuContent", [U2, ru] = Xn(or), Ip = p.forwardRef(
  (e, t) => {
    const r = Op(or, e.__scopeMenu), { forceMount: n = r.forceMount, ...o } = e, i = Fn(or, e.__scopeMenu), a = Mi(or, e.__scopeMenu);
    return /* @__PURE__ */ w(gi.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ w(Ao, { present: n || i.open, children: /* @__PURE__ */ w(gi.Slot, { scope: e.__scopeMenu, children: a.modal ? /* @__PURE__ */ w(V2, { ...o, ref: t }) : /* @__PURE__ */ w(H2, { ...o, ref: t }) }) }) });
  }
), V2 = p.forwardRef(
  (e, t) => {
    const r = Fn(or, e.__scopeMenu), n = p.useRef(null), o = Tt(t, n);
    return p.useEffect(() => {
      const i = n.current;
      if (i) return es(i);
    }, []), /* @__PURE__ */ w(
      nu,
      {
        ...e,
        ref: o,
        trapFocus: r.open,
        disableOutsidePointerEvents: r.open,
        disableOutsideScroll: !0,
        onFocusOutside: Ve(
          e.onFocusOutside,
          (i) => i.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => r.onOpenChange(!1)
      }
    );
  }
), H2 = p.forwardRef((e, t) => {
  const r = Fn(or, e.__scopeMenu);
  return /* @__PURE__ */ w(
    nu,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => r.onOpenChange(!1)
    }
  );
}), q2 = /* @__PURE__ */ Ta("MenuContent.ScrollLock"), nu = p.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: r,
      loop: n = !1,
      trapFocus: o,
      onOpenAutoFocus: i,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: s,
      onEntryFocus: c,
      onEscapeKeyDown: l,
      onPointerDownOutside: u,
      onFocusOutside: d,
      onInteractOutside: f,
      onDismiss: h,
      disableOutsideScroll: g,
      ...v
    } = e, y = Fn(or, r), b = Mi(or, r), x = Oi(r), C = Tp(r), E = B2(r), [D, A] = p.useState(null), R = p.useRef(null), O = Tt(t, R, y.onContentChange), W = p.useRef(0), z = p.useRef(""), q = p.useRef(0), V = p.useRef(null), I = p.useRef("right"), Z = p.useRef(0), Q = g ? Fp : p.Fragment, K = g ? { as: q2, allowPinchZoom: !0 } : void 0, L = (Y) => {
      const he = z.current + Y, ce = E().filter((ee) => !ee.disabled), ke = document.activeElement, Ie = ce.find((ee) => ee.ref.current === ke)?.textValue, Ne = ce.map((ee) => ee.textValue), qe = rP(Ne, he, Ie), ge = ce.find((ee) => ee.textValue === qe)?.ref.current;
      (function ee(oe) {
        z.current = oe, window.clearTimeout(W.current), oe !== "" && (W.current = window.setTimeout(() => ee(""), 1e3));
      })(he), ge && setTimeout(() => ge.focus());
    };
    p.useEffect(() => () => window.clearTimeout(W.current), []), JC();
    const U = p.useCallback((Y) => I.current === V.current?.side && oP(Y, V.current?.area), []);
    return /* @__PURE__ */ w(
      U2,
      {
        scope: r,
        searchRef: z,
        onItemEnter: p.useCallback(
          (Y) => {
            U(Y) && Y.preventDefault();
          },
          [U]
        ),
        onItemLeave: p.useCallback(
          (Y) => {
            U(Y) || (R.current?.focus(), A(null));
          },
          [U]
        ),
        onTriggerLeave: p.useCallback(
          (Y) => {
            U(Y) && Y.preventDefault();
          },
          [U]
        ),
        pointerGraceTimerRef: q,
        onPointerGraceIntentChange: p.useCallback((Y) => {
          V.current = Y;
        }, []),
        children: /* @__PURE__ */ w(Q, { ...K, children: /* @__PURE__ */ w(
          zv,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: Ve(i, (Y) => {
              Y.preventDefault(), R.current?.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: a,
            children: /* @__PURE__ */ w(
              Lv,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: l,
                onPointerDownOutside: u,
                onFocusOutside: d,
                onInteractOutside: f,
                onDismiss: h,
                children: /* @__PURE__ */ w(
                  m2,
                  {
                    asChild: !0,
                    ...C,
                    dir: b.dir,
                    orientation: "vertical",
                    loop: n,
                    currentTabStopId: D,
                    onCurrentTabStopIdChange: A,
                    onEntryFocus: Ve(c, (Y) => {
                      b.isUsingKeyboardRef.current || Y.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ w(
                      o2,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": Qp(y.open),
                        "data-radix-menu-content": "",
                        dir: b.dir,
                        ...x,
                        ...v,
                        ref: O,
                        style: { outline: "none", ...v.style },
                        onKeyDown: Ve(v.onKeyDown, (Y) => {
                          const ce = Y.target.closest("[data-radix-menu-content]") === Y.currentTarget, ke = Y.ctrlKey || Y.altKey || Y.metaKey, Ie = Y.key.length === 1;
                          ce && (Y.key === "Tab" && Y.preventDefault(), !ke && Ie && L(Y.key));
                          const Ne = R.current;
                          if (Y.target !== Ne || !O2.includes(Y.key)) return;
                          Y.preventDefault();
                          const ge = E().filter((ee) => !ee.disabled).map((ee) => ee.ref.current);
                          Dp.includes(Y.key) && ge.reverse(), eP(ge);
                        }),
                        onBlur: Ve(e.onBlur, (Y) => {
                          Y.currentTarget.contains(Y.target) || (window.clearTimeout(W.current), z.current = "");
                        }),
                        onPointerMove: Ve(
                          e.onPointerMove,
                          mi((Y) => {
                            const he = Y.target, ce = Z.current !== Y.clientX;
                            if (Y.currentTarget.contains(he) && ce) {
                              const ke = Y.clientX > Z.current ? "right" : "left";
                              I.current = ke, Z.current = Y.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Ip.displayName = or;
var G2 = "MenuGroup", ou = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e;
    return /* @__PURE__ */ w(xt.div, { role: "group", ...n, ref: t });
  }
);
ou.displayName = G2;
var K2 = "MenuLabel", Bp = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e;
    return /* @__PURE__ */ w(xt.div, { ...n, ref: t });
  }
);
Bp.displayName = K2;
var Ia = "MenuItem", Ld = "menu.itemSelect", hs = p.forwardRef(
  (e, t) => {
    const { disabled: r = !1, onSelect: n, ...o } = e, i = p.useRef(null), a = Mi(Ia, e.__scopeMenu), s = ru(Ia, e.__scopeMenu), c = Tt(t, i), l = p.useRef(!1), u = () => {
      const d = i.current;
      if (!r && d) {
        const f = new CustomEvent(Ld, { bubbles: !0, cancelable: !0 });
        d.addEventListener(Ld, (h) => n?.(h), { once: !0 }), Pv(d, f), f.defaultPrevented ? l.current = !1 : a.onClose();
      }
    };
    return /* @__PURE__ */ w(
      Lp,
      {
        ...o,
        ref: c,
        disabled: r,
        onClick: Ve(e.onClick, u),
        onPointerDown: (d) => {
          e.onPointerDown?.(d), l.current = !0;
        },
        onPointerUp: Ve(e.onPointerUp, (d) => {
          l.current || d.currentTarget?.click();
        }),
        onKeyDown: Ve(e.onKeyDown, (d) => {
          const f = s.searchRef.current !== "";
          r || f && d.key === " " || Uc.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
        })
      }
    );
  }
);
hs.displayName = Ia;
var Lp = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, disabled: n = !1, textValue: o, ...i } = e, a = ru(Ia, r), s = Tp(r), c = p.useRef(null), l = Tt(t, c), [u, d] = p.useState(!1), [f, h] = p.useState("");
    return p.useEffect(() => {
      const g = c.current;
      g && h((g.textContent ?? "").trim());
    }, [i.children]), /* @__PURE__ */ w(
      gi.ItemSlot,
      {
        scope: r,
        disabled: n,
        textValue: o ?? f,
        children: /* @__PURE__ */ w(y2, { asChild: !0, ...s, focusable: !n, children: /* @__PURE__ */ w(
          xt.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": n || void 0,
            "data-disabled": n ? "" : void 0,
            ...i,
            ref: l,
            onPointerMove: Ve(
              e.onPointerMove,
              mi((g) => {
                n ? a.onItemLeave(g) : (a.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: Ve(
              e.onPointerLeave,
              mi((g) => a.onItemLeave(g))
            ),
            onFocus: Ve(e.onFocus, () => d(!0)),
            onBlur: Ve(e.onBlur, () => d(!1))
          }
        ) })
      }
    );
  }
), X2 = "MenuCheckboxItem", Wp = p.forwardRef(
  (e, t) => {
    const { checked: r = !1, onCheckedChange: n, ...o } = e;
    return /* @__PURE__ */ w(Hp, { scope: e.__scopeMenu, checked: r, children: /* @__PURE__ */ w(
      hs,
      {
        role: "menuitemcheckbox",
        "aria-checked": Ba(r) ? "mixed" : r,
        ...o,
        ref: t,
        "data-state": su(r),
        onSelect: Ve(
          o.onSelect,
          () => n?.(Ba(r) ? !0 : !r),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Wp.displayName = X2;
var zp = "MenuRadioGroup", [Y2, Z2] = Xn(
  zp,
  { value: void 0, onValueChange: () => {
  } }
), jp = p.forwardRef(
  (e, t) => {
    const { value: r, onValueChange: n, ...o } = e, i = Dr(n);
    return /* @__PURE__ */ w(Y2, { scope: e.__scopeMenu, value: r, onValueChange: i, children: /* @__PURE__ */ w(ou, { ...o, ref: t }) });
  }
);
jp.displayName = zp;
var Up = "MenuRadioItem", Vp = p.forwardRef(
  (e, t) => {
    const { value: r, ...n } = e, o = Z2(Up, e.__scopeMenu), i = r === o.value;
    return /* @__PURE__ */ w(Hp, { scope: e.__scopeMenu, checked: i, children: /* @__PURE__ */ w(
      hs,
      {
        role: "menuitemradio",
        "aria-checked": i,
        ...n,
        ref: t,
        "data-state": su(i),
        onSelect: Ve(
          n.onSelect,
          () => o.onValueChange?.(r),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Vp.displayName = Up;
var iu = "MenuItemIndicator", [Hp, _2] = Xn(
  iu,
  { checked: !1 }
), qp = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, forceMount: n, ...o } = e, i = _2(iu, r);
    return /* @__PURE__ */ w(
      Ao,
      {
        present: n || Ba(i.checked) || i.checked === !0,
        children: /* @__PURE__ */ w(
          xt.span,
          {
            ...o,
            ref: t,
            "data-state": su(i.checked)
          }
        )
      }
    );
  }
);
qp.displayName = iu;
var J2 = "MenuSeparator", Gp = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e;
    return /* @__PURE__ */ w(
      xt.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...n,
        ref: t
      }
    );
  }
);
Gp.displayName = J2;
var Q2 = "MenuArrow", Kp = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: r, ...n } = e, o = Oi(r);
    return /* @__PURE__ */ w(i2, { ...o, ...n, ref: t });
  }
);
Kp.displayName = Q2;
var au = "MenuSub", [$2, Xp] = Xn(au), Yp = (e) => {
  const { __scopeMenu: t, children: r, open: n = !1, onOpenChange: o } = e, i = Fn(au, t), a = Oi(t), [s, c] = p.useState(null), [l, u] = p.useState(null), d = Dr(o);
  return p.useEffect(() => (i.open === !1 && d(!1), () => d(!1)), [i.open, d]), /* @__PURE__ */ w(pp, { ...a, children: /* @__PURE__ */ w(
    Ap,
    {
      scope: t,
      open: n,
      onOpenChange: d,
      content: l,
      onContentChange: u,
      children: /* @__PURE__ */ w(
        $2,
        {
          scope: t,
          contentId: hi(),
          triggerId: hi(),
          trigger: s,
          onTriggerChange: c,
          children: r
        }
      )
    }
  ) });
};
Yp.displayName = au;
var Jo = "MenuSubTrigger", Zp = p.forwardRef(
  (e, t) => {
    const r = Fn(Jo, e.__scopeMenu), n = Mi(Jo, e.__scopeMenu), o = Xp(Jo, e.__scopeMenu), i = ru(Jo, e.__scopeMenu), a = p.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: c } = i, l = { __scopeMenu: e.__scopeMenu }, u = p.useCallback(() => {
      a.current && window.clearTimeout(a.current), a.current = null;
    }, []);
    return p.useEffect(() => u, [u]), p.useEffect(() => {
      const d = s.current;
      return () => {
        window.clearTimeout(d), c(null);
      };
    }, [s, c]), /* @__PURE__ */ w(eu, { asChild: !0, ...l, children: /* @__PURE__ */ w(
      Lp,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": r.open,
        "aria-controls": o.contentId,
        "data-state": Qp(r.open),
        ...e,
        ref: as(t, o.onTriggerChange),
        onClick: (d) => {
          e.onClick?.(d), !(e.disabled || d.defaultPrevented) && (d.currentTarget.focus(), r.open || r.onOpenChange(!0));
        },
        onPointerMove: Ve(
          e.onPointerMove,
          mi((d) => {
            i.onItemEnter(d), !d.defaultPrevented && !e.disabled && !r.open && !a.current && (i.onPointerGraceIntentChange(null), a.current = window.setTimeout(() => {
              r.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: Ve(
          e.onPointerLeave,
          mi((d) => {
            u();
            const f = r.content?.getBoundingClientRect();
            if (f) {
              const h = r.content?.dataset.side, g = h === "right", v = g ? -5 : 5, y = f[g ? "left" : "right"], b = f[g ? "right" : "left"];
              i.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: d.clientX + v, y: d.clientY },
                  { x: y, y: f.top },
                  { x: b, y: f.top },
                  { x: b, y: f.bottom },
                  { x: y, y: f.bottom }
                ],
                side: h
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => i.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (i.onTriggerLeave(d), d.defaultPrevented) return;
              i.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: Ve(e.onKeyDown, (d) => {
          const f = i.searchRef.current !== "";
          e.disabled || f && d.key === " " || M2[n.dir].includes(d.key) && (r.onOpenChange(!0), r.content?.focus(), d.preventDefault());
        })
      }
    ) });
  }
);
Zp.displayName = Jo;
var _p = "MenuSubContent", Jp = p.forwardRef(
  (e, t) => {
    const r = Op(or, e.__scopeMenu), { forceMount: n = r.forceMount, ...o } = e, i = Fn(or, e.__scopeMenu), a = Mi(or, e.__scopeMenu), s = Xp(_p, e.__scopeMenu), c = p.useRef(null), l = Tt(t, c);
    return /* @__PURE__ */ w(gi.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ w(Ao, { present: n || i.open, children: /* @__PURE__ */ w(gi.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ w(
      nu,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...o,
        ref: l,
        align: "start",
        side: a.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          a.isUsingKeyboardRef.current && c.current?.focus(), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: Ve(e.onFocusOutside, (u) => {
          u.target !== s.trigger && i.onOpenChange(!1);
        }),
        onEscapeKeyDown: Ve(e.onEscapeKeyDown, (u) => {
          a.onClose(), u.preventDefault();
        }),
        onKeyDown: Ve(e.onKeyDown, (u) => {
          const d = u.currentTarget.contains(u.target), f = I2[a.dir].includes(u.key);
          d && f && (i.onOpenChange(!1), s.trigger?.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
Jp.displayName = _p;
function Qp(e) {
  return e ? "open" : "closed";
}
function Ba(e) {
  return e === "indeterminate";
}
function su(e) {
  return Ba(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function eP(e) {
  const t = document.activeElement;
  for (const r of e)
    if (r === t || (r.focus(), document.activeElement !== t)) return;
}
function tP(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
function rP(e, t, r) {
  const o = t.length > 1 && Array.from(t).every((l) => l === t[0]) ? t[0] : t, i = r ? e.indexOf(r) : -1;
  let a = tP(e, Math.max(i, 0));
  o.length === 1 && (a = a.filter((l) => l !== r));
  const c = a.find(
    (l) => l.toLowerCase().startsWith(o.toLowerCase())
  );
  return c !== r ? c : void 0;
}
function nP(e, t) {
  const { x: r, y: n } = e;
  let o = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const s = t[i], c = t[a], l = s.x, u = s.y, d = c.x, f = c.y;
    u > n != f > n && r < (d - l) * (n - u) / (f - u) + l && (o = !o);
  }
  return o;
}
function oP(e, t) {
  if (!t) return !1;
  const r = { x: e.clientX, y: e.clientY };
  return nP(r, t);
}
function mi(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var iP = Np, aP = eu, sP = Mp, cP = Ip, lP = ou, uP = Bp, dP = hs, fP = Wp, hP = jp, vP = Vp, pP = qp, gP = Gp, mP = Kp, yP = Yp, bP = Zp, wP = Jp, vs = "DropdownMenu", [xP] = To(
  vs,
  [Rp]
), Nt = Rp(), [CP, $p] = xP(vs), e0 = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: r,
    dir: n,
    open: o,
    defaultOpen: i,
    onOpenChange: a,
    modal: s = !0
  } = e, c = Nt(t), l = p.useRef(null), [u, d] = ss({
    prop: o,
    defaultProp: i ?? !1,
    onChange: a,
    caller: vs
  });
  return /* @__PURE__ */ w(
    CP,
    {
      scope: t,
      triggerId: hi(),
      triggerRef: l,
      contentId: hi(),
      open: u,
      onOpenChange: d,
      onOpenToggle: p.useCallback(() => d((f) => !f), [d]),
      modal: s,
      children: /* @__PURE__ */ w(iP, { ...c, open: u, onOpenChange: d, dir: n, modal: s, children: r })
    }
  );
};
e0.displayName = vs;
var t0 = "DropdownMenuTrigger", r0 = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, disabled: n = !1, ...o } = e, i = $p(t0, r), a = Nt(r);
    return /* @__PURE__ */ w(aP, { asChild: !0, ...a, children: /* @__PURE__ */ w(
      xt.button,
      {
        type: "button",
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": i.open,
        "aria-controls": i.open ? i.contentId : void 0,
        "data-state": i.open ? "open" : "closed",
        "data-disabled": n ? "" : void 0,
        disabled: n,
        ...o,
        ref: as(t, i.triggerRef),
        onPointerDown: Ve(e.onPointerDown, (s) => {
          !n && s.button === 0 && s.ctrlKey === !1 && (i.onOpenToggle(), i.open || s.preventDefault());
        }),
        onKeyDown: Ve(e.onKeyDown, (s) => {
          n || (["Enter", " "].includes(s.key) && i.onOpenToggle(), s.key === "ArrowDown" && i.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
r0.displayName = t0;
var SP = "DropdownMenuPortal", n0 = (e) => {
  const { __scopeDropdownMenu: t, ...r } = e, n = Nt(t);
  return /* @__PURE__ */ w(sP, { ...n, ...r });
};
n0.displayName = SP;
var o0 = "DropdownMenuContent", i0 = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = $p(o0, r), i = Nt(r), a = p.useRef(!1);
    return /* @__PURE__ */ w(
      cP,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...i,
        ...n,
        ref: t,
        onCloseAutoFocus: Ve(e.onCloseAutoFocus, (s) => {
          a.current || o.triggerRef.current?.focus(), a.current = !1, s.preventDefault();
        }),
        onInteractOutside: Ve(e.onInteractOutside, (s) => {
          const c = s.detail.originalEvent, l = c.button === 0 && c.ctrlKey === !0, u = c.button === 2 || l;
          (!o.modal || u) && (a.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
i0.displayName = o0;
var PP = "DropdownMenuGroup", a0 = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = Nt(r);
    return /* @__PURE__ */ w(lP, { ...o, ...n, ref: t });
  }
);
a0.displayName = PP;
var EP = "DropdownMenuLabel", s0 = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = Nt(r);
    return /* @__PURE__ */ w(uP, { ...o, ...n, ref: t });
  }
);
s0.displayName = EP;
var kP = "DropdownMenuItem", c0 = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = Nt(r);
    return /* @__PURE__ */ w(dP, { ...o, ...n, ref: t });
  }
);
c0.displayName = kP;
var FP = "DropdownMenuCheckboxItem", l0 = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = Nt(r);
  return /* @__PURE__ */ w(fP, { ...o, ...n, ref: t });
});
l0.displayName = FP;
var DP = "DropdownMenuRadioGroup", u0 = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = Nt(r);
  return /* @__PURE__ */ w(hP, { ...o, ...n, ref: t });
});
u0.displayName = DP;
var RP = "DropdownMenuRadioItem", d0 = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = Nt(r);
  return /* @__PURE__ */ w(vP, { ...o, ...n, ref: t });
});
d0.displayName = RP;
var TP = "DropdownMenuItemIndicator", f0 = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = Nt(r);
  return /* @__PURE__ */ w(pP, { ...o, ...n, ref: t });
});
f0.displayName = TP;
var AP = "DropdownMenuSeparator", h0 = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = Nt(r);
  return /* @__PURE__ */ w(gP, { ...o, ...n, ref: t });
});
h0.displayName = AP;
var NP = "DropdownMenuArrow", OP = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, o = Nt(r);
    return /* @__PURE__ */ w(mP, { ...o, ...n, ref: t });
  }
);
OP.displayName = NP;
var MP = (e) => {
  const { __scopeDropdownMenu: t, children: r, open: n, onOpenChange: o, defaultOpen: i } = e, a = Nt(t), [s, c] = ss({
    prop: n,
    defaultProp: i ?? !1,
    onChange: o,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ w(yP, { ...a, open: s, onOpenChange: c, children: r });
}, IP = "DropdownMenuSubTrigger", v0 = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = Nt(r);
  return /* @__PURE__ */ w(bP, { ...o, ...n, ref: t });
});
v0.displayName = IP;
var BP = "DropdownMenuSubContent", p0 = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: r, ...n } = e, o = Nt(r);
  return /* @__PURE__ */ w(
    wP,
    {
      ...o,
      ...n,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
p0.displayName = BP;
var LP = e0, WP = r0, g0 = n0, zP = i0, jP = a0, UP = s0, VP = c0, HP = l0, qP = u0, GP = d0, m0 = f0, KP = h0, XP = MP, YP = v0, ZP = p0;
const AA = LP, NA = WP, OA = jP, MA = g0, IA = XP, BA = qP;
function LA({
  className: e,
  inset: t,
  children: r,
  ...n
}) {
  return /* @__PURE__ */ Pe(
    YP,
    {
      "data-slot": "dropdown-menu-sub-trigger",
      className: le(
        "flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
        t && "pl-8",
        e
      ),
      ...n,
      children: [
        r,
        /* @__PURE__ */ w(yC, { className: "ml-auto" })
      ]
    }
  );
}
function WA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w(
    ZP,
    {
      "data-slot": "dropdown-menu-sub-content",
      className: le(
        "z-50 min-w-[8rem] origin-[--radix-dropdown-menu-content-transform-origin] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        e
      ),
      ...t
    }
  );
}
function zA({
  className: e,
  sideOffset: t = 4,
  ...r
}) {
  return /* @__PURE__ */ w(g0, { children: /* @__PURE__ */ w(
    zP,
    {
      "data-slot": "dropdown-menu-content",
      sideOffset: t,
      className: le(
        "z-50 max-h-[var(--radix-dropdown-menu-content-available-height)] min-w-[8rem] origin-[--radix-dropdown-menu-content-transform-origin] overflow-y-auto overflow-x-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        e
      ),
      ...r
    }
  ) });
}
function jA({
  className: e,
  inset: t,
  ...r
}) {
  return /* @__PURE__ */ w(
    VP,
    {
      "data-slot": "dropdown-menu-item",
      className: le(
        "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
        t && "pl-8",
        e
      ),
      ...r
    }
  );
}
function UA({
  className: e,
  children: t,
  checked: r,
  ...n
}) {
  return /* @__PURE__ */ Pe(
    HP,
    {
      "data-slot": "dropdown-menu-checkbox-item",
      className: le(
        "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        e
      ),
      checked: r,
      ...n,
      children: [
        /* @__PURE__ */ w("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ w(m0, { children: /* @__PURE__ */ w(Cv, { className: "h-4 w-4" }) }) }),
        t
      ]
    }
  );
}
function VA({
  className: e,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ Pe(
    GP,
    {
      "data-slot": "dropdown-menu-radio-item",
      className: le(
        "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
        e
      ),
      ...r,
      children: [
        /* @__PURE__ */ w("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ w(m0, { children: /* @__PURE__ */ w(wC, { className: "h-2 w-2 fill-current" }) }) }),
        t
      ]
    }
  );
}
function HA({
  className: e,
  inset: t,
  ...r
}) {
  return /* @__PURE__ */ w(
    UP,
    {
      "data-slot": "dropdown-menu-label",
      className: le(
        "px-2 py-1.5 text-sm font-semibold",
        t && "pl-8",
        e
      ),
      ...r
    }
  );
}
function qA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w(
    KP,
    {
      "data-slot": "dropdown-menu-separator",
      className: le("-mx-1 my-1 h-px bg-muted", e),
      ...t
    }
  );
}
function GA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w(
    "span",
    {
      className: le("ml-auto text-xs tracking-widest opacity-60", e),
      ...t
    }
  );
}
function KA({
  ...e
}) {
  return /* @__PURE__ */ w(Ch, { "data-slot": "dialog", ...e });
}
function XA({
  ...e
}) {
  return /* @__PURE__ */ w(Sh, { "data-slot": "dialog-trigger", ...e });
}
function _P({
  ...e
}) {
  return /* @__PURE__ */ w(Ph, { "data-slot": "dialog-portal", ...e });
}
function YA({
  ...e
}) {
  return /* @__PURE__ */ w(ts, { "data-slot": "dialog-close", ...e });
}
function JP({
  className: e,
  hasBackground: t,
  ...r
}) {
  return /* @__PURE__ */ w(
    Eh,
    {
      "data-slot": "dialog-overlay",
      className: le(
        `fixed inset-0 z-50 ${t ? "bg-black/80" : ""} data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0`,
        e
      ),
      ...r
    }
  );
}
function ZA({
  className: e,
  children: t,
  hideClose: r = !1,
  hasBackground: n = !0,
  ...o
}) {
  return /* @__PURE__ */ Pe(_P, { "data-slot": "dialog-portal", children: [
    /* @__PURE__ */ w(JP, { hasBackground: n }),
    /* @__PURE__ */ Pe(
      kh,
      {
        "data-slot": "dialog-content",
        className: le(
          "fixed left-[50%] top-[50%] z-50 grid w-full max-w-[calc(100vw-2rem)] translate-x-[-50%] translate-y-[-50%] border border-slate-200 bg-card shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] dark:border-slate-800 sm:rounded-default",
          e
        ),
        ...o,
        children: [
          t,
          !r && /* @__PURE__ */ w(
            ts,
            {
              "data-slot": "dialog-close",
              asChild: !0,
              className: "absolute right-4 top-4 rounded-default opacity-70 ring-offset-white transition-opacity hover:opacity-100 focus:outline-none disabled:pointer-events-none data-[state=open]:bg-slate-100 data-[state=open]:text-slate-500 dark:ring-offset-slate-950 dark:focus:ring-slate-300 dark:data-[state=open]:bg-slate-800 dark:data-[state=open]:text-slate-400",
              children: /* @__PURE__ */ Pe(hn, { variant: "ghost", size: "iconSm", children: [
                /* @__PURE__ */ w(hl, {}),
                /* @__PURE__ */ w("span", { className: "sr-only", children: "Close" })
              ] })
            }
          )
        ]
      }
    )
  ] });
}
function _A({ className: e, ...t }) {
  return /* @__PURE__ */ w(
    "div",
    {
      "data-slot": "dialog-header",
      className: le(
        "flex flex-col space-y-1.5 text-center sm:text-left",
        e
      ),
      ...t
    }
  );
}
function JA({ className: e, ...t }) {
  return /* @__PURE__ */ w(
    "div",
    {
      "data-slot": "dialog-footer",
      className: le(
        "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
        e
      ),
      ...t
    }
  );
}
function QA({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w(
    Fh,
    {
      "data-slot": "dialog-title",
      className: le(
        "text-lg font-semibold leading-none tracking-tight",
        e
      ),
      ...t
    }
  );
}
function $A({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w(
    Dh,
    {
      "data-slot": "dialog-description",
      className: le("text-sm text-slate-500 dark:text-slate-400", e),
      ...t
    }
  );
}
const eN = ({
  children: e,
  onClose: t,
  className: r,
  zIndex: n = 50
}) => (ir(() => {
  const o = (i) => {
    i.key === "Escape" && t();
  };
  return document.addEventListener("keydown", o), () => {
    document.removeEventListener("keydown", o);
  };
}, [t]), /* @__PURE__ */ Pe(
  "div",
  {
    className: le(
      r,
      "fixed inset-0 left-0 top-0 h-[100vh] w-[100vw] overflow-y-auto bg-card"
    ),
    style: { zIndex: n },
    children: [
      /* @__PURE__ */ w(
        hn,
        {
          className: "fixed right-[30px] top-[30px] print:hidden",
          onClick: t,
          variant: "ghost",
          size: "iconSm",
          children: /* @__PURE__ */ w(hl, {})
        }
      ),
      e
    ]
  }
));
function QP({
  className: e,
  type: t,
  variant: r = "default",
  startIcon: n,
  endIcon: o,
  wrapperClassName: i,
  ref: a,
  ...s
}) {
  const c = Pl(
    "flex w-full rounded-default border-border-color bg-card text-sm file:border-0 file:bg-transparent file:text-sm file:font-medium focus:outline-none focus:border-default",
    {
      variants: {
        variant: {
          default: "border border-border-color hover:border-default/16 px-3 py-2",
          underline: "border-b rounded-none py-[7px]",
          plain: "border-none py-0 pointer-events-none"
        }
      },
      defaultVariants: {
        variant: "default"
      }
    }
  );
  return /* @__PURE__ */ Pe("div", { className: le("relative flex w-full items-center", i), children: [
    n ? /* @__PURE__ */ w("div", { className: "absolute left-[11px]", children: n }) : null,
    /* @__PURE__ */ w(
      "input",
      {
        ref: a,
        type: t,
        className: le(
          "w-full",
          n ? "!pl-[35px]" : "",
          o ? "!pr-[35px]" : "",
          c({ variant: r, className: e })
        ),
        ...s
      }
    ),
    o ? /* @__PURE__ */ w("div", { className: "absolute right-[11px]", children: o }) : null
  ] });
}
var $P = "Arrow", y0 = p.forwardRef((e, t) => {
  const { children: r, width: n = 10, height: o = 5, ...i } = e;
  return /* @__PURE__ */ w(
    nt.svg,
    {
      ...i,
      ref: t,
      width: n,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? r : /* @__PURE__ */ w("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
y0.displayName = $P;
var eE = y0;
function b0(e, t = []) {
  let r = [];
  function n(i, a) {
    const s = p.createContext(a), c = r.length;
    r = [...r, a];
    function l(d) {
      const { scope: f, children: h, ...g } = d, v = f?.[e][c] || s, y = p.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ w(v.Provider, { value: y, children: h });
    }
    function u(d, f) {
      const h = f?.[e][c] || s, g = p.useContext(h);
      if (g) return g;
      if (a !== void 0) return a;
      throw new Error(`\`${d}\` must be used within \`${i}\``);
    }
    return l.displayName = i + "Provider", [l, u];
  }
  const o = () => {
    const i = r.map((a) => p.createContext(a));
    return function(s) {
      const c = s?.[e] || i;
      return p.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: c } }),
        [s, c]
      );
    };
  };
  return o.scopeName = e, [n, tE(o, ...t)];
}
function tE(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const n = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(i) {
      const a = n.reduce((s, { useScope: c, scopeName: l }) => {
        const d = c(i)[`__scope${l}`];
        return { ...s, ...d };
      }, {});
      return p.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
var cu = "Popper", [w0, Mo] = b0(cu), [rE, x0] = w0(cu), C0 = (e) => {
  const { __scopePopper: t, children: r } = e, [n, o] = p.useState(null);
  return /* @__PURE__ */ w(rE, { scope: t, anchor: n, onAnchorChange: o, children: r });
};
C0.displayName = cu;
var S0 = "PopperAnchor", P0 = p.forwardRef(
  (e, t) => {
    const { __scopePopper: r, virtualRef: n, ...o } = e, i = x0(S0, r), a = p.useRef(null), s = ct(t, a);
    return p.useEffect(() => {
      i.onAnchorChange(n?.current || a.current);
    }), n ? null : /* @__PURE__ */ w(nt.div, { ...o, ref: s });
  }
);
P0.displayName = S0;
var lu = "PopperContent", [nE, oE] = w0(lu), E0 = p.forwardRef(
  (e, t) => {
    const {
      __scopePopper: r,
      side: n = "bottom",
      sideOffset: o = 0,
      align: i = "center",
      alignOffset: a = 0,
      arrowPadding: s = 0,
      avoidCollisions: c = !0,
      collisionBoundary: l = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: f = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: g,
      ...v
    } = e, y = x0(lu, r), [b, x] = p.useState(null), C = ct(t, (ee) => x(ee)), [E, D] = p.useState(null), A = Ah(E), R = A?.width ?? 0, O = A?.height ?? 0, W = n + (i !== "center" ? "-" + i : ""), z = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, q = Array.isArray(l) ? l : [l], V = q.length > 0, I = {
      padding: z,
      boundary: q.filter(aE),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: V
    }, { refs: Z, floatingStyles: Q, placement: K, isPositioned: L, middlewareData: U } = _v({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: W,
      whileElementsMounted: (...ee) => Yv(...ee, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: y.anchor
      },
      middleware: [
        Jv({ mainAxis: o + O, alignmentAxis: a }),
        c && Qv({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? $v() : void 0,
          ...I
        }),
        c && ep({ ...I }),
        tp({
          ...I,
          apply: ({ elements: ee, rects: oe, availableWidth: We, availableHeight: Fe }) => {
            const { width: Me, height: ve } = oe.reference, Je = ee.floating.style;
            Je.setProperty("--radix-popper-available-width", `${We}px`), Je.setProperty("--radix-popper-available-height", `${Fe}px`), Je.setProperty("--radix-popper-anchor-width", `${Me}px`), Je.setProperty("--radix-popper-anchor-height", `${ve}px`);
          }
        }),
        E && np({ element: E, padding: s }),
        sE({ arrowWidth: R, arrowHeight: O }),
        f && rp({ strategy: "referenceHidden", ...I })
      ]
    }), [Y, he] = D0(K), ce = Vr(g);
    wt(() => {
      L && ce?.();
    }, [L, ce]);
    const ke = U.arrow?.x, Ie = U.arrow?.y, Ne = U.arrow?.centerOffset !== 0, [qe, ge] = p.useState();
    return wt(() => {
      b && ge(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ w(
      "div",
      {
        ref: Z.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...Q,
          transform: L ? Q.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: qe,
          "--radix-popper-transform-origin": [
            U.transformOrigin?.x,
            U.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...U.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ w(
          nE,
          {
            scope: r,
            placedSide: Y,
            onArrowChange: D,
            arrowX: ke,
            arrowY: Ie,
            shouldHideArrow: Ne,
            children: /* @__PURE__ */ w(
              nt.div,
              {
                "data-side": Y,
                "data-align": he,
                ...v,
                ref: C,
                style: {
                  ...v.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: L ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
E0.displayName = lu;
var k0 = "PopperArrow", iE = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, F0 = p.forwardRef(function(t, r) {
  const { __scopePopper: n, ...o } = t, i = oE(k0, n), a = iE[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ w(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ w(
          eE,
          {
            ...o,
            ref: r,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
F0.displayName = k0;
function aE(e) {
  return e !== null;
}
var sE = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: r, rects: n, middlewareData: o } = t, a = o.arrow?.centerOffset !== 0, s = a ? 0 : e.arrowWidth, c = a ? 0 : e.arrowHeight, [l, u] = D0(r), d = { start: "0%", center: "50%", end: "100%" }[u], f = (o.arrow?.x ?? 0) + s / 2, h = (o.arrow?.y ?? 0) + c / 2;
    let g = "", v = "";
    return l === "bottom" ? (g = a ? d : `${f}px`, v = `${-c}px`) : l === "top" ? (g = a ? d : `${f}px`, v = `${n.floating.height + c}px`) : l === "right" ? (g = `${-c}px`, v = a ? d : `${h}px`) : l === "left" && (g = `${n.floating.width + c}px`, v = a ? d : `${h}px`), { data: { x: g, y: v } };
  }
});
function D0(e) {
  const [t, r = "center"] = e.split("-");
  return [t, r];
}
var uu = C0, ps = P0, du = E0, fu = F0, hu = "Popover", [R0] = En(hu, [
  Mo
]), Ii = Mo(), [cE, Dn] = R0(hu), T0 = (e) => {
  const {
    __scopePopover: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: i,
    modal: a = !1
  } = e, s = Ii(t), c = p.useRef(null), [l, u] = p.useState(!1), [d = !1, f] = Hr({
    prop: n,
    defaultProp: o,
    onChange: i
  });
  return /* @__PURE__ */ w(uu, { ...s, children: /* @__PURE__ */ w(
    cE,
    {
      scope: t,
      contentId: kr(),
      triggerRef: c,
      open: d,
      onOpenChange: f,
      onOpenToggle: p.useCallback(() => f((h) => !h), [f]),
      hasCustomAnchor: l,
      onCustomAnchorAdd: p.useCallback(() => u(!0), []),
      onCustomAnchorRemove: p.useCallback(() => u(!1), []),
      modal: a,
      children: r
    }
  ) });
};
T0.displayName = hu;
var A0 = "PopoverAnchor", N0 = p.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Dn(A0, r), i = Ii(r), { onCustomAnchorAdd: a, onCustomAnchorRemove: s } = o;
    return p.useEffect(() => (a(), () => s()), [a, s]), /* @__PURE__ */ w(ps, { ...i, ...n, ref: t });
  }
);
N0.displayName = A0;
var O0 = "PopoverTrigger", M0 = p.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Dn(O0, r), i = Ii(r), a = ct(t, o.triggerRef), s = /* @__PURE__ */ w(
      nt.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": z0(o.open),
        ...n,
        ref: a,
        onClick: Ue(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? s : /* @__PURE__ */ w(ps, { asChild: !0, ...i, children: s });
  }
);
M0.displayName = O0;
var vu = "PopoverPortal", [lE, uE] = R0(vu, {
  forceMount: void 0
}), I0 = (e) => {
  const { __scopePopover: t, forceMount: r, children: n, container: o } = e, i = Dn(vu, t);
  return /* @__PURE__ */ w(lE, { scope: t, forceMount: r, children: /* @__PURE__ */ w(kn, { present: r || i.open, children: /* @__PURE__ */ w(Ei, { asChild: !0, container: o, children: n }) }) });
};
I0.displayName = vu;
var Eo = "PopoverContent", B0 = p.forwardRef(
  (e, t) => {
    const r = uE(Eo, e.__scopePopover), { forceMount: n = r.forceMount, ...o } = e, i = Dn(Eo, e.__scopePopover);
    return /* @__PURE__ */ w(kn, { present: n || i.open, children: i.modal ? /* @__PURE__ */ w(dE, { ...o, ref: t }) : /* @__PURE__ */ w(fE, { ...o, ref: t }) });
  }
);
B0.displayName = Eo;
var dE = p.forwardRef(
  (e, t) => {
    const r = Dn(Eo, e.__scopePopover), n = p.useRef(null), o = ct(t, n), i = p.useRef(!1);
    return p.useEffect(() => {
      const a = n.current;
      if (a) return es(a);
    }, []), /* @__PURE__ */ w($a, { as: fn, allowPinchZoom: !0, children: /* @__PURE__ */ w(
      L0,
      {
        ...e,
        ref: o,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Ue(e.onCloseAutoFocus, (a) => {
          a.preventDefault(), i.current || r.triggerRef.current?.focus();
        }),
        onPointerDownOutside: Ue(
          e.onPointerDownOutside,
          (a) => {
            const s = a.detail.originalEvent, c = s.button === 0 && s.ctrlKey === !0, l = s.button === 2 || c;
            i.current = l;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: Ue(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), fE = p.forwardRef(
  (e, t) => {
    const r = Dn(Eo, e.__scopePopover), n = p.useRef(!1), o = p.useRef(!1);
    return /* @__PURE__ */ w(
      L0,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          e.onCloseAutoFocus?.(i), i.defaultPrevented || (n.current || r.triggerRef.current?.focus(), i.preventDefault()), n.current = !1, o.current = !1;
        },
        onInteractOutside: (i) => {
          e.onInteractOutside?.(i), i.defaultPrevented || (n.current = !0, i.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const a = i.target;
          r.triggerRef.current?.contains(a) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && o.current && i.preventDefault();
        }
      }
    );
  }
), L0 = p.forwardRef(
  (e, t) => {
    const {
      __scopePopover: r,
      trapFocus: n,
      onOpenAutoFocus: o,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: a,
      onEscapeKeyDown: s,
      onPointerDownOutside: c,
      onFocusOutside: l,
      onInteractOutside: u,
      ...d
    } = e, f = Dn(Eo, r), h = Ii(r);
    return pl(), /* @__PURE__ */ w(
      Ja,
      {
        asChild: !0,
        loop: !0,
        trapped: n,
        onMountAutoFocus: o,
        onUnmountAutoFocus: i,
        children: /* @__PURE__ */ w(
          Pi,
          {
            asChild: !0,
            disableOutsidePointerEvents: a,
            onInteractOutside: u,
            onEscapeKeyDown: s,
            onPointerDownOutside: c,
            onFocusOutside: l,
            onDismiss: () => f.onOpenChange(!1),
            children: /* @__PURE__ */ w(
              du,
              {
                "data-state": z0(f.open),
                role: "dialog",
                id: f.contentId,
                ...h,
                ...d,
                ref: t,
                style: {
                  ...d.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), W0 = "PopoverClose", hE = p.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Dn(W0, r);
    return /* @__PURE__ */ w(
      nt.button,
      {
        type: "button",
        ...n,
        ref: t,
        onClick: Ue(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
hE.displayName = W0;
var vE = "PopoverArrow", pE = p.forwardRef(
  (e, t) => {
    const { __scopePopover: r, ...n } = e, o = Ii(r);
    return /* @__PURE__ */ w(fu, { ...o, ...n, ref: t });
  }
);
pE.displayName = vE;
function z0(e) {
  return e ? "open" : "closed";
}
var gE = T0, mE = N0, yE = M0, bE = I0, wE = B0;
function tN({
  ...e
}) {
  return /* @__PURE__ */ w(gE, { "data-slot": "popover", ...e });
}
function rN({
  ...e
}) {
  return /* @__PURE__ */ w(yE, { "data-slot": "popover-trigger", ...e });
}
function nN({
  className: e,
  align: t = "center",
  sideOffset: r = 4,
  ...n
}) {
  return /* @__PURE__ */ w(bE, { children: /* @__PURE__ */ w(
    wE,
    {
      "data-slot": "popover-content",
      align: t,
      sideOffset: r,
      className: le(
        "z-50 w-72 rounded-md border border-border-color bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        e
      ),
      ...n
    }
  ) });
}
function oN({
  ...e
}) {
  return /* @__PURE__ */ w(mE, { "data-slot": "popover-anchor", ...e });
}
const xE = ({
  title: e,
  titleId: t,
  ...r
}, n) => /* @__PURE__ */ p.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: n, "aria-labelledby": t, ...r }, e ? /* @__PURE__ */ p.createElement("title", { id: t }, e) : null, /* @__PURE__ */ p.createElement("g", { clipPath: "url(#clip0_10896_56706)" }, /* @__PURE__ */ p.createElement("path", { d: "M6.7498 12.1502L3.5998 9.0002L2.5498 10.0502L6.7498 14.2502L15.7498 5.2502L14.6998 4.2002L6.7498 12.1502Z" })), /* @__PURE__ */ p.createElement("defs", null, /* @__PURE__ */ p.createElement("clipPath", { id: "clip0_10896_56706" }, /* @__PURE__ */ p.createElement("rect", { width: 18, height: 18, fill: "white" })))), CE = xr(xE);
function Wd(e, [t, r]) {
  return Math.min(r, Math.max(t, e));
}
function SE(e) {
  const t = e + "CollectionProvider", [r, n] = b0(t), [o, i] = r(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (h) => {
    const { scope: g, children: v } = h, y = Ze.useRef(null), b = Ze.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ w(o, { scope: g, itemMap: b, collectionRef: y, children: v });
  };
  a.displayName = t;
  const s = e + "CollectionSlot", c = Ze.forwardRef(
    (h, g) => {
      const { scope: v, children: y } = h, b = i(s, v), x = ct(g, b.collectionRef);
      return /* @__PURE__ */ w(fn, { ref: x, children: y });
    }
  );
  c.displayName = s;
  const l = e + "CollectionItemSlot", u = "data-radix-collection-item", d = Ze.forwardRef(
    (h, g) => {
      const { scope: v, children: y, ...b } = h, x = Ze.useRef(null), C = ct(g, x), E = i(l, v);
      return Ze.useEffect(() => (E.itemMap.set(x, { ref: x, ...b }), () => {
        E.itemMap.delete(x);
      })), /* @__PURE__ */ w(fn, { [u]: "", ref: C, children: y });
    }
  );
  d.displayName = l;
  function f(h) {
    const g = i(e + "CollectionConsumer", h);
    return Ze.useCallback(() => {
      const y = g.collectionRef.current;
      if (!y) return [];
      const b = Array.from(y.querySelectorAll(`[${u}]`));
      return Array.from(g.itemMap.values()).sort(
        (E, D) => b.indexOf(E.ref.current) - b.indexOf(D.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: a, Slot: c, ItemSlot: d },
    f,
    n
  ];
}
var PE = "VisuallyHidden", pu = p.forwardRef(
  (e, t) => /* @__PURE__ */ w(
    nt.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
pu.displayName = PE;
var EE = pu, kE = [" ", "Enter", "ArrowUp", "ArrowDown"], FE = [" ", "Enter"], Bi = "Select", [gs, ms, DE] = SE(Bi), [Io] = En(Bi, [
  DE,
  Mo
]), ys = Mo(), [RE, Rn] = Io(Bi), [TE, AE] = Io(Bi), j0 = (e) => {
  const {
    __scopeSelect: t,
    children: r,
    open: n,
    defaultOpen: o,
    onOpenChange: i,
    value: a,
    defaultValue: s,
    onValueChange: c,
    dir: l,
    name: u,
    autoComplete: d,
    disabled: f,
    required: h,
    form: g
  } = e, v = ys(t), [y, b] = p.useState(null), [x, C] = p.useState(null), [E, D] = p.useState(!1), A = lv(l), [R = !1, O] = Hr({
    prop: n,
    defaultProp: o,
    onChange: i
  }), [W, z] = Hr({
    prop: a,
    defaultProp: s,
    onChange: c
  }), q = p.useRef(null), V = y ? g || !!y.closest("form") : !0, [I, Z] = p.useState(/* @__PURE__ */ new Set()), Q = Array.from(I).map((K) => K.props.value).join(";");
  return /* @__PURE__ */ w(uu, { ...v, children: /* @__PURE__ */ Pe(
    RE,
    {
      required: h,
      scope: t,
      trigger: y,
      onTriggerChange: b,
      valueNode: x,
      onValueNodeChange: C,
      valueNodeHasChildren: E,
      onValueNodeHasChildrenChange: D,
      contentId: kr(),
      value: W,
      onValueChange: z,
      open: R,
      onOpenChange: O,
      dir: A,
      triggerPointerDownPosRef: q,
      disabled: f,
      children: [
        /* @__PURE__ */ w(gs.Provider, { scope: t, children: /* @__PURE__ */ w(
          TE,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: p.useCallback((K) => {
              Z((L) => new Set(L).add(K));
            }, []),
            onNativeOptionRemove: p.useCallback((K) => {
              Z((L) => {
                const U = new Set(L);
                return U.delete(K), U;
              });
            }, []),
            children: r
          }
        ) }),
        V ? /* @__PURE__ */ Pe(
          fg,
          {
            "aria-hidden": !0,
            required: h,
            tabIndex: -1,
            name: u,
            autoComplete: d,
            value: W,
            onChange: (K) => z(K.target.value),
            disabled: f,
            form: g,
            children: [
              W === void 0 ? /* @__PURE__ */ w("option", { value: "" }) : null,
              Array.from(I)
            ]
          },
          Q
        ) : null
      ]
    }
  ) });
};
j0.displayName = Bi;
var U0 = "SelectTrigger", V0 = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, disabled: n = !1, ...o } = e, i = ys(r), a = Rn(U0, r), s = a.disabled || n, c = ct(t, a.onTriggerChange), l = ms(r), u = p.useRef("touch"), [d, f, h] = hg((v) => {
      const y = l().filter((C) => !C.disabled), b = y.find((C) => C.value === a.value), x = vg(y, v, b);
      x !== void 0 && a.onValueChange(x.value);
    }), g = (v) => {
      s || (a.onOpenChange(!0), h()), v && (a.triggerPointerDownPosRef.current = {
        x: Math.round(v.pageX),
        y: Math.round(v.pageY)
      });
    };
    return /* @__PURE__ */ w(ps, { asChild: !0, ...i, children: /* @__PURE__ */ w(
      nt.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": dg(a.value) ? "" : void 0,
        ...o,
        ref: c,
        onClick: Ue(o.onClick, (v) => {
          v.currentTarget.focus(), u.current !== "mouse" && g(v);
        }),
        onPointerDown: Ue(o.onPointerDown, (v) => {
          u.current = v.pointerType;
          const y = v.target;
          y.hasPointerCapture(v.pointerId) && y.releasePointerCapture(v.pointerId), v.button === 0 && v.ctrlKey === !1 && v.pointerType === "mouse" && (g(v), v.preventDefault());
        }),
        onKeyDown: Ue(o.onKeyDown, (v) => {
          const y = d.current !== "";
          !(v.ctrlKey || v.altKey || v.metaKey) && v.key.length === 1 && f(v.key), !(y && v.key === " ") && kE.includes(v.key) && (g(), v.preventDefault());
        })
      }
    ) });
  }
);
V0.displayName = U0;
var H0 = "SelectValue", q0 = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, className: n, style: o, children: i, placeholder: a = "", ...s } = e, c = Rn(H0, r), { onValueNodeHasChildrenChange: l } = c, u = i !== void 0, d = ct(t, c.onValueNodeChange);
    return wt(() => {
      l(u);
    }, [l, u]), /* @__PURE__ */ w(
      nt.span,
      {
        ...s,
        ref: d,
        style: { pointerEvents: "none" },
        children: dg(c.value) ? /* @__PURE__ */ w(bt, { children: a }) : i
      }
    );
  }
);
q0.displayName = H0;
var NE = "SelectIcon", G0 = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, children: n, ...o } = e;
    return /* @__PURE__ */ w(nt.span, { "aria-hidden": !0, ...o, ref: t, children: n || "▼" });
  }
);
G0.displayName = NE;
var OE = "SelectPortal", K0 = (e) => /* @__PURE__ */ w(Ei, { asChild: !0, ...e });
K0.displayName = OE;
var qn = "SelectContent", X0 = p.forwardRef(
  (e, t) => {
    const r = Rn(qn, e.__scopeSelect), [n, o] = p.useState();
    if (wt(() => {
      o(new DocumentFragment());
    }, []), !r.open) {
      const i = n;
      return i ? Si.createPortal(
        /* @__PURE__ */ w(Y0, { scope: e.__scopeSelect, children: /* @__PURE__ */ w(gs.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ w("div", { children: e.children }) }) }),
        i
      ) : null;
    }
    return /* @__PURE__ */ w(Z0, { ...e, ref: t });
  }
);
X0.displayName = qn;
var fr = 10, [Y0, Tn] = Io(qn), ME = "SelectContentImpl", Z0 = p.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: r,
      position: n = "item-aligned",
      onCloseAutoFocus: o,
      onEscapeKeyDown: i,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: s,
      sideOffset: c,
      align: l,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: f,
      collisionPadding: h,
      sticky: g,
      hideWhenDetached: v,
      avoidCollisions: y,
      //
      ...b
    } = e, x = Rn(qn, r), [C, E] = p.useState(null), [D, A] = p.useState(null), R = ct(t, (ee) => E(ee)), [O, W] = p.useState(null), [z, q] = p.useState(
      null
    ), V = ms(r), [I, Z] = p.useState(!1), Q = p.useRef(!1);
    p.useEffect(() => {
      if (C) return es(C);
    }, [C]), pl();
    const K = p.useCallback(
      (ee) => {
        const [oe, ...We] = V().map((ve) => ve.ref.current), [Fe] = We.slice(-1), Me = document.activeElement;
        for (const ve of ee)
          if (ve === Me || (ve?.scrollIntoView({ block: "nearest" }), ve === oe && D && (D.scrollTop = 0), ve === Fe && D && (D.scrollTop = D.scrollHeight), ve?.focus(), document.activeElement !== Me)) return;
      },
      [V, D]
    ), L = p.useCallback(
      () => K([O, C]),
      [K, O, C]
    );
    p.useEffect(() => {
      I && L();
    }, [I, L]);
    const { onOpenChange: U, triggerPointerDownPosRef: Y } = x;
    p.useEffect(() => {
      if (C) {
        let ee = { x: 0, y: 0 };
        const oe = (Fe) => {
          ee = {
            x: Math.abs(Math.round(Fe.pageX) - (Y.current?.x ?? 0)),
            y: Math.abs(Math.round(Fe.pageY) - (Y.current?.y ?? 0))
          };
        }, We = (Fe) => {
          ee.x <= 10 && ee.y <= 10 ? Fe.preventDefault() : C.contains(Fe.target) || U(!1), document.removeEventListener("pointermove", oe), Y.current = null;
        };
        return Y.current !== null && (document.addEventListener("pointermove", oe), document.addEventListener("pointerup", We, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", oe), document.removeEventListener("pointerup", We, { capture: !0 });
        };
      }
    }, [C, U, Y]), p.useEffect(() => {
      const ee = () => U(!1);
      return window.addEventListener("blur", ee), window.addEventListener("resize", ee), () => {
        window.removeEventListener("blur", ee), window.removeEventListener("resize", ee);
      };
    }, [U]);
    const [he, ce] = hg((ee) => {
      const oe = V().filter((Me) => !Me.disabled), We = oe.find((Me) => Me.ref.current === document.activeElement), Fe = vg(oe, ee, We);
      Fe && setTimeout(() => Fe.ref.current.focus());
    }), ke = p.useCallback(
      (ee, oe, We) => {
        const Fe = !Q.current && !We;
        (x.value !== void 0 && x.value === oe || Fe) && (W(ee), Fe && (Q.current = !0));
      },
      [x.value]
    ), Ie = p.useCallback(() => C?.focus(), [C]), Ne = p.useCallback(
      (ee, oe, We) => {
        const Fe = !Q.current && !We;
        (x.value !== void 0 && x.value === oe || Fe) && q(ee);
      },
      [x.value]
    ), qe = n === "popper" ? Vc : _0, ge = qe === Vc ? {
      side: s,
      sideOffset: c,
      align: l,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: f,
      collisionPadding: h,
      sticky: g,
      hideWhenDetached: v,
      avoidCollisions: y
    } : {};
    return /* @__PURE__ */ w(
      Y0,
      {
        scope: r,
        content: C,
        viewport: D,
        onViewportChange: A,
        itemRefCallback: ke,
        selectedItem: O,
        onItemLeave: Ie,
        itemTextRefCallback: Ne,
        focusSelectedItem: L,
        selectedItemText: z,
        position: n,
        isPositioned: I,
        searchRef: he,
        children: /* @__PURE__ */ w($a, { as: fn, allowPinchZoom: !0, children: /* @__PURE__ */ w(
          Ja,
          {
            asChild: !0,
            trapped: x.open,
            onMountAutoFocus: (ee) => {
              ee.preventDefault();
            },
            onUnmountAutoFocus: Ue(o, (ee) => {
              x.trigger?.focus({ preventScroll: !0 }), ee.preventDefault();
            }),
            children: /* @__PURE__ */ w(
              Pi,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: i,
                onPointerDownOutside: a,
                onFocusOutside: (ee) => ee.preventDefault(),
                onDismiss: () => x.onOpenChange(!1),
                children: /* @__PURE__ */ w(
                  qe,
                  {
                    role: "listbox",
                    id: x.contentId,
                    "data-state": x.open ? "open" : "closed",
                    dir: x.dir,
                    onContextMenu: (ee) => ee.preventDefault(),
                    ...b,
                    ...ge,
                    onPlaced: () => Z(!0),
                    ref: R,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...b.style
                    },
                    onKeyDown: Ue(b.onKeyDown, (ee) => {
                      const oe = ee.ctrlKey || ee.altKey || ee.metaKey;
                      if (ee.key === "Tab" && ee.preventDefault(), !oe && ee.key.length === 1 && ce(ee.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(ee.key)) {
                        let Fe = V().filter((Me) => !Me.disabled).map((Me) => Me.ref.current);
                        if (["ArrowUp", "End"].includes(ee.key) && (Fe = Fe.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(ee.key)) {
                          const Me = ee.target, ve = Fe.indexOf(Me);
                          Fe = Fe.slice(ve + 1);
                        }
                        setTimeout(() => K(Fe)), ee.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Z0.displayName = ME;
var IE = "SelectItemAlignedPosition", _0 = p.forwardRef((e, t) => {
  const { __scopeSelect: r, onPlaced: n, ...o } = e, i = Rn(qn, r), a = Tn(qn, r), [s, c] = p.useState(null), [l, u] = p.useState(null), d = ct(t, (R) => u(R)), f = ms(r), h = p.useRef(!1), g = p.useRef(!0), { viewport: v, selectedItem: y, selectedItemText: b, focusSelectedItem: x } = a, C = p.useCallback(() => {
    if (i.trigger && i.valueNode && s && l && v && y && b) {
      const R = i.trigger.getBoundingClientRect(), O = l.getBoundingClientRect(), W = i.valueNode.getBoundingClientRect(), z = b.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const Me = z.left - O.left, ve = W.left - Me, Je = R.left - ve, Ot = R.width + Je, kt = Math.max(Ot, O.width), Ct = window.innerWidth - fr, it = Wd(ve, [
          fr,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(fr, Ct - kt)
        ]);
        s.style.minWidth = Ot + "px", s.style.left = it + "px";
      } else {
        const Me = O.right - z.right, ve = window.innerWidth - W.right - Me, Je = window.innerWidth - R.right - ve, Ot = R.width + Je, kt = Math.max(Ot, O.width), Ct = window.innerWidth - fr, it = Wd(ve, [
          fr,
          Math.max(fr, Ct - kt)
        ]);
        s.style.minWidth = Ot + "px", s.style.right = it + "px";
      }
      const q = f(), V = window.innerHeight - fr * 2, I = v.scrollHeight, Z = window.getComputedStyle(l), Q = parseInt(Z.borderTopWidth, 10), K = parseInt(Z.paddingTop, 10), L = parseInt(Z.borderBottomWidth, 10), U = parseInt(Z.paddingBottom, 10), Y = Q + K + I + U + L, he = Math.min(y.offsetHeight * 5, Y), ce = window.getComputedStyle(v), ke = parseInt(ce.paddingTop, 10), Ie = parseInt(ce.paddingBottom, 10), Ne = R.top + R.height / 2 - fr, qe = V - Ne, ge = y.offsetHeight / 2, ee = y.offsetTop + ge, oe = Q + K + ee, We = Y - oe;
      if (oe <= Ne) {
        const Me = q.length > 0 && y === q[q.length - 1].ref.current;
        s.style.bottom = "0px";
        const ve = l.clientHeight - v.offsetTop - v.offsetHeight, Je = Math.max(
          qe,
          ge + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (Me ? Ie : 0) + ve + L
        ), Ot = oe + Je;
        s.style.height = Ot + "px";
      } else {
        const Me = q.length > 0 && y === q[0].ref.current;
        s.style.top = "0px";
        const Je = Math.max(
          Ne,
          Q + v.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (Me ? ke : 0) + ge
        ) + We;
        s.style.height = Je + "px", v.scrollTop = oe - Ne + v.offsetTop;
      }
      s.style.margin = `${fr}px 0`, s.style.minHeight = he + "px", s.style.maxHeight = V + "px", n?.(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    f,
    i.trigger,
    i.valueNode,
    s,
    l,
    v,
    y,
    b,
    i.dir,
    n
  ]);
  wt(() => C(), [C]);
  const [E, D] = p.useState();
  wt(() => {
    l && D(window.getComputedStyle(l).zIndex);
  }, [l]);
  const A = p.useCallback(
    (R) => {
      R && g.current === !0 && (C(), x?.(), g.current = !1);
    },
    [C, x]
  );
  return /* @__PURE__ */ w(
    LE,
    {
      scope: r,
      contentWrapper: s,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: A,
      children: /* @__PURE__ */ w(
        "div",
        {
          ref: c,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: E
          },
          children: /* @__PURE__ */ w(
            nt.div,
            {
              ...o,
              ref: d,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...o.style
              }
            }
          )
        }
      )
    }
  );
});
_0.displayName = IE;
var BE = "SelectPopperPosition", Vc = p.forwardRef((e, t) => {
  const {
    __scopeSelect: r,
    align: n = "start",
    collisionPadding: o = fr,
    ...i
  } = e, a = ys(r);
  return /* @__PURE__ */ w(
    du,
    {
      ...a,
      ...i,
      ref: t,
      align: n,
      collisionPadding: o,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...i.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Vc.displayName = BE;
var [LE, gu] = Io(qn, {}), Hc = "SelectViewport", J0 = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, nonce: n, ...o } = e, i = Tn(Hc, r), a = gu(Hc, r), s = ct(t, i.onViewportChange), c = p.useRef(0);
    return /* @__PURE__ */ Pe(bt, { children: [
      /* @__PURE__ */ w(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ w(gs.Slot, { scope: r, children: /* @__PURE__ */ w(
        nt.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...o,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...o.style
          },
          onScroll: Ue(o.onScroll, (l) => {
            const u = l.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: f } = a;
            if (f?.current && d) {
              const h = Math.abs(c.current - u.scrollTop);
              if (h > 0) {
                const g = window.innerHeight - fr * 2, v = parseFloat(d.style.minHeight), y = parseFloat(d.style.height), b = Math.max(v, y);
                if (b < g) {
                  const x = b + h, C = Math.min(g, x), E = x - C;
                  d.style.height = C + "px", d.style.bottom === "0px" && (u.scrollTop = E > 0 ? E : 0, d.style.justifyContent = "flex-end");
                }
              }
            }
            c.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
J0.displayName = Hc;
var Q0 = "SelectGroup", [WE, zE] = Io(Q0), $0 = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, o = kr();
    return /* @__PURE__ */ w(WE, { scope: r, id: o, children: /* @__PURE__ */ w(nt.div, { role: "group", "aria-labelledby": o, ...n, ref: t }) });
  }
);
$0.displayName = Q0;
var eg = "SelectLabel", tg = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, o = zE(eg, r);
    return /* @__PURE__ */ w(nt.div, { id: o.id, ...n, ref: t });
  }
);
tg.displayName = eg;
var La = "SelectItem", [jE, rg] = Io(La), ng = p.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: r,
      value: n,
      disabled: o = !1,
      textValue: i,
      ...a
    } = e, s = Rn(La, r), c = Tn(La, r), l = s.value === n, [u, d] = p.useState(i ?? ""), [f, h] = p.useState(!1), g = ct(
      t,
      (x) => c.itemRefCallback?.(x, n, o)
    ), v = kr(), y = p.useRef("touch"), b = () => {
      o || (s.onValueChange(n), s.onOpenChange(!1));
    };
    if (n === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ w(
      jE,
      {
        scope: r,
        value: n,
        disabled: o,
        textId: v,
        isSelected: l,
        onItemTextChange: p.useCallback((x) => {
          d((C) => C || (x?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ w(
          gs.ItemSlot,
          {
            scope: r,
            value: n,
            disabled: o,
            textValue: u,
            children: /* @__PURE__ */ w(
              nt.div,
              {
                role: "option",
                "aria-labelledby": v,
                "data-highlighted": f ? "" : void 0,
                "aria-selected": l && f,
                "data-state": l ? "checked" : "unchecked",
                "aria-disabled": o || void 0,
                "data-disabled": o ? "" : void 0,
                tabIndex: o ? void 0 : -1,
                ...a,
                ref: g,
                onFocus: Ue(a.onFocus, () => h(!0)),
                onBlur: Ue(a.onBlur, () => h(!1)),
                onClick: Ue(a.onClick, () => {
                  y.current !== "mouse" && b();
                }),
                onPointerUp: Ue(a.onPointerUp, () => {
                  y.current === "mouse" && b();
                }),
                onPointerDown: Ue(a.onPointerDown, (x) => {
                  y.current = x.pointerType;
                }),
                onPointerMove: Ue(a.onPointerMove, (x) => {
                  y.current = x.pointerType, o ? c.onItemLeave?.() : y.current === "mouse" && x.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: Ue(a.onPointerLeave, (x) => {
                  x.currentTarget === document.activeElement && c.onItemLeave?.();
                }),
                onKeyDown: Ue(a.onKeyDown, (x) => {
                  c.searchRef?.current !== "" && x.key === " " || (FE.includes(x.key) && b(), x.key === " " && x.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
ng.displayName = La;
var Qo = "SelectItemText", og = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, className: n, style: o, ...i } = e, a = Rn(Qo, r), s = Tn(Qo, r), c = rg(Qo, r), l = AE(Qo, r), [u, d] = p.useState(null), f = ct(
      t,
      (b) => d(b),
      c.onItemTextChange,
      (b) => s.itemTextRefCallback?.(b, c.value, c.disabled)
    ), h = u?.textContent, g = p.useMemo(
      () => /* @__PURE__ */ w("option", { value: c.value, disabled: c.disabled, children: h }, c.value),
      [c.disabled, c.value, h]
    ), { onNativeOptionAdd: v, onNativeOptionRemove: y } = l;
    return wt(() => (v(g), () => y(g)), [v, y, g]), /* @__PURE__ */ Pe(bt, { children: [
      /* @__PURE__ */ w(nt.span, { id: c.textId, ...i, ref: f }),
      c.isSelected && a.valueNode && !a.valueNodeHasChildren ? Si.createPortal(i.children, a.valueNode) : null
    ] });
  }
);
og.displayName = Qo;
var ig = "SelectItemIndicator", ag = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e;
    return rg(ig, r).isSelected ? /* @__PURE__ */ w(nt.span, { "aria-hidden": !0, ...n, ref: t }) : null;
  }
);
ag.displayName = ig;
var qc = "SelectScrollUpButton", sg = p.forwardRef((e, t) => {
  const r = Tn(qc, e.__scopeSelect), n = gu(qc, e.__scopeSelect), [o, i] = p.useState(!1), a = ct(t, n.onScrollButtonChange);
  return wt(() => {
    if (r.viewport && r.isPositioned) {
      let s = function() {
        const l = c.scrollTop > 0;
        i(l);
      };
      const c = r.viewport;
      return s(), c.addEventListener("scroll", s), () => c.removeEventListener("scroll", s);
    }
  }, [r.viewport, r.isPositioned]), o ? /* @__PURE__ */ w(
    lg,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: c } = r;
        s && c && (s.scrollTop = s.scrollTop - c.offsetHeight);
      }
    }
  ) : null;
});
sg.displayName = qc;
var Gc = "SelectScrollDownButton", cg = p.forwardRef((e, t) => {
  const r = Tn(Gc, e.__scopeSelect), n = gu(Gc, e.__scopeSelect), [o, i] = p.useState(!1), a = ct(t, n.onScrollButtonChange);
  return wt(() => {
    if (r.viewport && r.isPositioned) {
      let s = function() {
        const l = c.scrollHeight - c.clientHeight, u = Math.ceil(c.scrollTop) < l;
        i(u);
      };
      const c = r.viewport;
      return s(), c.addEventListener("scroll", s), () => c.removeEventListener("scroll", s);
    }
  }, [r.viewport, r.isPositioned]), o ? /* @__PURE__ */ w(
    lg,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: c } = r;
        s && c && (s.scrollTop = s.scrollTop + c.offsetHeight);
      }
    }
  ) : null;
});
cg.displayName = Gc;
var lg = p.forwardRef((e, t) => {
  const { __scopeSelect: r, onAutoScroll: n, ...o } = e, i = Tn("SelectScrollButton", r), a = p.useRef(null), s = ms(r), c = p.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return p.useEffect(() => () => c(), [c]), wt(() => {
    s().find((u) => u.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ w(
    nt.div,
    {
      "aria-hidden": !0,
      ...o,
      ref: t,
      style: { flexShrink: 0, ...o.style },
      onPointerDown: Ue(o.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(n, 50));
      }),
      onPointerMove: Ue(o.onPointerMove, () => {
        i.onItemLeave?.(), a.current === null && (a.current = window.setInterval(n, 50));
      }),
      onPointerLeave: Ue(o.onPointerLeave, () => {
        c();
      })
    }
  );
}), UE = "SelectSeparator", ug = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e;
    return /* @__PURE__ */ w(nt.div, { "aria-hidden": !0, ...n, ref: t });
  }
);
ug.displayName = UE;
var Kc = "SelectArrow", VE = p.forwardRef(
  (e, t) => {
    const { __scopeSelect: r, ...n } = e, o = ys(r), i = Rn(Kc, r), a = Tn(Kc, r);
    return i.open && a.position === "popper" ? /* @__PURE__ */ w(fu, { ...o, ...n, ref: t }) : null;
  }
);
VE.displayName = Kc;
function dg(e) {
  return e === "" || e === void 0;
}
var fg = p.forwardRef(
  (e, t) => {
    const { value: r, ...n } = e, o = p.useRef(null), i = ct(t, o), a = Th(r);
    return p.useEffect(() => {
      const s = o.current, c = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        c,
        "value"
      ).set;
      if (a !== r && u) {
        const d = new Event("change", { bubbles: !0 });
        u.call(s, r), s.dispatchEvent(d);
      }
    }, [a, r]), /* @__PURE__ */ w(pu, { asChild: !0, children: /* @__PURE__ */ w("select", { ...n, ref: i, defaultValue: r }) });
  }
);
fg.displayName = "BubbleSelect";
function hg(e) {
  const t = Vr(e), r = p.useRef(""), n = p.useRef(0), o = p.useCallback(
    (a) => {
      const s = r.current + a;
      t(s), (function c(l) {
        r.current = l, window.clearTimeout(n.current), l !== "" && (n.current = window.setTimeout(() => c(""), 1e3));
      })(s);
    },
    [t]
  ), i = p.useCallback(() => {
    r.current = "", window.clearTimeout(n.current);
  }, []);
  return p.useEffect(() => () => window.clearTimeout(n.current), []), [r, o, i];
}
function vg(e, t, r) {
  const o = t.length > 1 && Array.from(t).every((l) => l === t[0]) ? t[0] : t, i = r ? e.indexOf(r) : -1;
  let a = HE(e, Math.max(i, 0));
  o.length === 1 && (a = a.filter((l) => l !== r));
  const c = a.find(
    (l) => l.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return c !== r ? c : void 0;
}
function HE(e, t) {
  return e.map((r, n) => e[(t + n) % e.length]);
}
var qE = j0, GE = V0, KE = q0, XE = G0, YE = K0, ZE = X0, _E = J0, JE = $0, QE = tg, $E = ng, ek = og, tk = ag, rk = sg, nk = cg, ok = ug;
const ik = Pl(
  "flex h-10 gap-x-0.5 items-center rounded-default bg-card px-3 py-2 text-left placeholder:text-slate-500 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 [&>span]:flex-1 [&>span]:min-w-0 [&>span]:truncate dark:placeholder:text-slate-400",
  {
    variants: {
      variant: {
        // Same focus treatment as Input: the border darkens.
        default: "text-sm border border-border-color focus-visible:border-default",
        borderless: "h-8 border-none hover:bg-gray-backdrop-300 focus-visible:bg-gray-backdrop-300 data-[state=open]:bg-gray-backdrop-300"
      }
    },
    defaultVariants: { variant: "default" }
  }
);
function ak({
  ...e
}) {
  return /* @__PURE__ */ w(qE, { "data-slot": "select", ...e });
}
function iN({
  ...e
}) {
  return /* @__PURE__ */ w(JE, { "data-slot": "select-group", ...e });
}
function sk({
  ...e
}) {
  return /* @__PURE__ */ w(KE, { "data-slot": "select-value", ...e });
}
function ck({
  className: e,
  size: t = "default",
  children: r,
  iconClassName: n,
  variant: o,
  ...i
}) {
  return /* @__PURE__ */ Pe(
    GE,
    {
      "data-slot": "select-trigger",
      "data-size": t,
      className: le(ik({ variant: o }), e),
      ...i,
      children: [
        r,
        /* @__PURE__ */ w(XE, { asChild: !0, children: /* @__PURE__ */ w(
          Un,
          {
            className: le("h-4 w-4 shrink-0 text-default", n),
            fill: "currentColor"
          }
        ) })
      ]
    }
  );
}
function lk({
  className: e,
  children: t,
  position: r = "popper",
  align: n = "center",
  ...o
}) {
  return /* @__PURE__ */ w(YE, { children: /* @__PURE__ */ Pe(
    ZE,
    {
      "data-slot": "select-content",
      className: le(
        "relative z-50 mt-1 max-h-96 min-w-[8rem] overflow-hidden rounded-default border border-slate-200 bg-popover text-slate-950 shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 dark:border-slate-800 dark:text-slate-50",
        r === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
        e
      ),
      position: r,
      align: n,
      ...o,
      children: [
        /* @__PURE__ */ w(dk, {}),
        /* @__PURE__ */ w(
          _E,
          {
            className: le(
              "p-1",
              r === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)] scroll-my-1"
            ),
            children: t
          }
        ),
        /* @__PURE__ */ w(fk, {})
      ]
    }
  ) });
}
function aN({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w(
    QE,
    {
      "data-slot": "select-label",
      className: le("py-1.5 pl-8 pr-2 text-sm font-semibold", e),
      ...t
    }
  );
}
function uk({
  className: e,
  children: t,
  ...r
}) {
  return /* @__PURE__ */ Pe(
    $E,
    {
      "data-slot": "select-item",
      className: le(
        "relative flex w-full cursor-default select-none items-center rounded-default py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-slate-100 focus:text-slate-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 dark:focus:bg-slate-800 dark:focus:text-slate-50",
        e
      ),
      ...r,
      children: [
        /* @__PURE__ */ w("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ w(tk, { children: /* @__PURE__ */ w(CE, { className: "h-4 w-4 text-default", fill: "currentColor" }) }) }),
        /* @__PURE__ */ w(ek, { children: t })
      ]
    }
  );
}
function sN({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w(
    ok,
    {
      "data-slot": "select-separator",
      className: le(
        "pointer-events-none -mx-1 my-1 h-px bg-slate-100 dark:bg-slate-800",
        e
      ),
      ...t
    }
  );
}
function dk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w(
    rk,
    {
      "data-slot": "select-scroll-up-button",
      className: le(
        "flex cursor-default items-center justify-center py-1",
        e
      ),
      ...t,
      children: /* @__PURE__ */ w(Un, { className: "h-4 w-4 rotate-180 text-default", fill: "currentColor" })
    }
  );
}
function fk({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w(
    nk,
    {
      "data-slot": "select-scroll-down-button",
      className: le(
        "flex cursor-default items-center justify-center py-1",
        e
      ),
      ...t,
      children: /* @__PURE__ */ w(Un, { className: "h-4 w-4 text-default", fill: "currentColor" })
    }
  );
}
function cN({ className: e, ...t }) {
  return /* @__PURE__ */ w(
    "textarea",
    {
      "data-slot": "textarea",
      className: le(
        "flex w-full rounded-md bg-card px-3 py-2 placeholder:text-gray-400 focus-visible:outline-none focus:border-default disabled:cursor-not-allowed disabled:opacity-50 disabled:placeholder:text-gray-400",
        e
      ),
      ...t
    }
  );
}
var [bs] = En("Tooltip", [
  Mo
]), ws = Mo(), pg = "TooltipProvider", hk = 700, Xc = "tooltip.open", [vk, mu] = bs(pg), gg = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: r = hk,
    skipDelayDuration: n = 300,
    disableHoverableContent: o = !1,
    children: i
  } = e, [a, s] = p.useState(!0), c = p.useRef(!1), l = p.useRef(0);
  return p.useEffect(() => {
    const u = l.current;
    return () => window.clearTimeout(u);
  }, []), /* @__PURE__ */ w(
    vk,
    {
      scope: t,
      isOpenDelayed: a,
      delayDuration: r,
      onOpen: p.useCallback(() => {
        window.clearTimeout(l.current), s(!1);
      }, []),
      onClose: p.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => s(!0),
          n
        );
      }, [n]),
      isPointerInTransitRef: c,
      onPointerInTransitChange: p.useCallback((u) => {
        c.current = u;
      }, []),
      disableHoverableContent: o,
      children: i
    }
  );
};
gg.displayName = pg;
var xs = "Tooltip", [pk, Li] = bs(xs), mg = (e) => {
  const {
    __scopeTooltip: t,
    children: r,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: i,
    disableHoverableContent: a,
    delayDuration: s
  } = e, c = mu(xs, e.__scopeTooltip), l = ws(t), [u, d] = p.useState(null), f = kr(), h = p.useRef(0), g = a ?? c.disableHoverableContent, v = s ?? c.delayDuration, y = p.useRef(!1), [b = !1, x] = Hr({
    prop: n,
    defaultProp: o,
    onChange: (R) => {
      R ? (c.onOpen(), document.dispatchEvent(new CustomEvent(Xc))) : c.onClose(), i?.(R);
    }
  }), C = p.useMemo(() => b ? y.current ? "delayed-open" : "instant-open" : "closed", [b]), E = p.useCallback(() => {
    window.clearTimeout(h.current), y.current = !1, x(!0);
  }, [x]), D = p.useCallback(() => {
    window.clearTimeout(h.current), x(!1);
  }, [x]), A = p.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      y.current = !0, x(!0);
    }, v);
  }, [v, x]);
  return p.useEffect(() => () => window.clearTimeout(h.current), []), /* @__PURE__ */ w(uu, { ...l, children: /* @__PURE__ */ w(
    pk,
    {
      scope: t,
      contentId: f,
      open: b,
      stateAttribute: C,
      trigger: u,
      onTriggerChange: d,
      onTriggerEnter: p.useCallback(() => {
        c.isOpenDelayed ? A() : E();
      }, [c.isOpenDelayed, A, E]),
      onTriggerLeave: p.useCallback(() => {
        g ? D() : window.clearTimeout(h.current);
      }, [D, g]),
      onOpen: E,
      onClose: D,
      disableHoverableContent: g,
      children: r
    }
  ) });
};
mg.displayName = xs;
var Yc = "TooltipTrigger", yg = p.forwardRef(
  (e, t) => {
    const { __scopeTooltip: r, ...n } = e, o = Li(Yc, r), i = mu(Yc, r), a = ws(r), s = p.useRef(null), c = ct(t, s, o.onTriggerChange), l = p.useRef(!1), u = p.useRef(!1), d = p.useCallback(() => l.current = !1, []);
    return p.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ w(ps, { asChild: !0, ...a, children: /* @__PURE__ */ w(
      nt.button,
      {
        "aria-describedby": o.open ? o.contentId : void 0,
        "data-state": o.stateAttribute,
        ...n,
        ref: c,
        onPointerMove: Ue(e.onPointerMove, (f) => {
          f.pointerType !== "touch" && !u.current && !i.isPointerInTransitRef.current && (o.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: Ue(e.onPointerLeave, () => {
          o.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: Ue(e.onPointerDown, () => {
          l.current = !0, document.addEventListener("pointerup", d, { once: !0 });
        }),
        onFocus: Ue(e.onFocus, () => {
          l.current || o.onOpen();
        }),
        onBlur: Ue(e.onBlur, o.onClose),
        onClick: Ue(e.onClick, o.onClose)
      }
    ) });
  }
);
yg.displayName = Yc;
var yu = "TooltipPortal", [gk, mk] = bs(yu, {
  forceMount: void 0
}), bg = (e) => {
  const { __scopeTooltip: t, forceMount: r, children: n, container: o } = e, i = Li(yu, t);
  return /* @__PURE__ */ w(gk, { scope: t, forceMount: r, children: /* @__PURE__ */ w(kn, { present: r || i.open, children: /* @__PURE__ */ w(Ei, { asChild: !0, container: o, children: n }) }) });
};
bg.displayName = yu;
var ko = "TooltipContent", wg = p.forwardRef(
  (e, t) => {
    const r = mk(ko, e.__scopeTooltip), { forceMount: n = r.forceMount, side: o = "top", ...i } = e, a = Li(ko, e.__scopeTooltip);
    return /* @__PURE__ */ w(kn, { present: n || a.open, children: a.disableHoverableContent ? /* @__PURE__ */ w(xg, { side: o, ...i, ref: t }) : /* @__PURE__ */ w(yk, { side: o, ...i, ref: t }) });
  }
), yk = p.forwardRef((e, t) => {
  const r = Li(ko, e.__scopeTooltip), n = mu(ko, e.__scopeTooltip), o = p.useRef(null), i = ct(t, o), [a, s] = p.useState(null), { trigger: c, onClose: l } = r, u = o.current, { onPointerInTransitChange: d } = n, f = p.useCallback(() => {
    s(null), d(!1);
  }, [d]), h = p.useCallback(
    (g, v) => {
      const y = g.currentTarget, b = { x: g.clientX, y: g.clientY }, x = xk(b, y.getBoundingClientRect()), C = Ck(b, x), E = Sk(v.getBoundingClientRect()), D = Ek([...C, ...E]);
      s(D), d(!0);
    },
    [d]
  );
  return p.useEffect(() => () => f(), [f]), p.useEffect(() => {
    if (c && u) {
      const g = (y) => h(y, u), v = (y) => h(y, c);
      return c.addEventListener("pointerleave", g), u.addEventListener("pointerleave", v), () => {
        c.removeEventListener("pointerleave", g), u.removeEventListener("pointerleave", v);
      };
    }
  }, [c, u, h, f]), p.useEffect(() => {
    if (a) {
      const g = (v) => {
        const y = v.target, b = { x: v.clientX, y: v.clientY }, x = c?.contains(y) || u?.contains(y), C = !Pk(b, a);
        x ? f() : C && (f(), l());
      };
      return document.addEventListener("pointermove", g), () => document.removeEventListener("pointermove", g);
    }
  }, [c, u, a, l, f]), /* @__PURE__ */ w(xg, { ...e, ref: i });
}), [bk, wk] = bs(xs, { isInside: !1 }), xg = p.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: r,
      children: n,
      "aria-label": o,
      onEscapeKeyDown: i,
      onPointerDownOutside: a,
      ...s
    } = e, c = Li(ko, r), l = ws(r), { onClose: u } = c;
    return p.useEffect(() => (document.addEventListener(Xc, u), () => document.removeEventListener(Xc, u)), [u]), p.useEffect(() => {
      if (c.trigger) {
        const d = (f) => {
          f.target?.contains(c.trigger) && u();
        };
        return window.addEventListener("scroll", d, { capture: !0 }), () => window.removeEventListener("scroll", d, { capture: !0 });
      }
    }, [c.trigger, u]), /* @__PURE__ */ w(
      Pi,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: a,
        onFocusOutside: (d) => d.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ Pe(
          du,
          {
            "data-state": c.stateAttribute,
            ...l,
            ...s,
            ref: t,
            style: {
              ...s.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ w(Gf, { children: n }),
              /* @__PURE__ */ w(bk, { scope: r, isInside: !0, children: /* @__PURE__ */ w(EE, { id: c.contentId, role: "tooltip", children: o || n }) })
            ]
          }
        )
      }
    );
  }
);
wg.displayName = ko;
var Cg = "TooltipArrow", Sg = p.forwardRef(
  (e, t) => {
    const { __scopeTooltip: r, ...n } = e, o = ws(r);
    return wk(
      Cg,
      r
    ).isInside ? null : /* @__PURE__ */ w(fu, { ...o, ...n, ref: t });
  }
);
Sg.displayName = Cg;
function xk(e, t) {
  const r = Math.abs(t.top - e.y), n = Math.abs(t.bottom - e.y), o = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(r, n, o, i)) {
    case i:
      return "left";
    case o:
      return "right";
    case r:
      return "top";
    case n:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Ck(e, t, r = 5) {
  const n = [];
  switch (t) {
    case "top":
      n.push(
        { x: e.x - r, y: e.y + r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "bottom":
      n.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x + r, y: e.y - r }
      );
      break;
    case "left":
      n.push(
        { x: e.x + r, y: e.y - r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "right":
      n.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x - r, y: e.y + r }
      );
      break;
  }
  return n;
}
function Sk(e) {
  const { top: t, right: r, bottom: n, left: o } = e;
  return [
    { x: o, y: t },
    { x: r, y: t },
    { x: r, y: n },
    { x: o, y: n }
  ];
}
function Pk(e, t) {
  const { x: r, y: n } = e;
  let o = !1;
  for (let i = 0, a = t.length - 1; i < t.length; a = i++) {
    const s = t[i].x, c = t[i].y, l = t[a].x, u = t[a].y;
    c > n != u > n && r < (l - s) * (n - c) / (u - c) + s && (o = !o);
  }
  return o;
}
function Ek(e) {
  const t = e.slice();
  return t.sort((r, n) => r.x < n.x ? -1 : r.x > n.x ? 1 : r.y < n.y ? -1 : r.y > n.y ? 1 : 0), kk(t);
}
function kk(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], a = t[t.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x)) t.pop();
      else break;
    }
    t.push(o);
  }
  t.pop();
  const r = [];
  for (let n = e.length - 1; n >= 0; n--) {
    const o = e[n];
    for (; r.length >= 2; ) {
      const i = r[r.length - 1], a = r[r.length - 2];
      if ((i.x - a.x) * (o.y - a.y) >= (i.y - a.y) * (o.x - a.x)) r.pop();
      else break;
    }
    r.push(o);
  }
  return r.pop(), t.length === 1 && r.length === 1 && t[0].x === r[0].x && t[0].y === r[0].y ? t : t.concat(r);
}
var Fk = gg, Dk = mg, Rk = yg, Tk = bg, Ak = wg, Nk = Sg;
function Ok({
  delayDuration: e = 0,
  ...t
}) {
  return /* @__PURE__ */ w(
    Fk,
    {
      "data-slot": "tooltip-provider",
      delayDuration: e,
      ...t
    }
  );
}
function lN({
  ...e
}) {
  return /* @__PURE__ */ w(Ok, { children: /* @__PURE__ */ w(Dk, { "data-slot": "tooltip", ...e }) });
}
function uN({
  ...e
}) {
  return /* @__PURE__ */ w(Rk, { "data-slot": "tooltip-trigger", ...e });
}
function dN({
  className: e,
  arrowClassName: t,
  sideOffset: r = 0,
  children: n,
  ...o
}) {
  return /* @__PURE__ */ w(Tk, { children: /* @__PURE__ */ Pe(
    Ak,
    {
      "data-slot": "tooltip-content",
      sideOffset: r,
      className: le(
        "z-50 overflow-hidden rounded-default bg-tooltip-surface px-3 py-1.5 text-sm text-white shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
        e
      ),
      ...o,
      children: [
        n,
        /* @__PURE__ */ w(
          Nk,
          {
            className: le(
              "z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-[2px] bg-tooltip-surface fill-tooltip-surface",
              t
            )
          }
        )
      ]
    }
  ) });
}
const fN = ({ className: e }) => /* @__PURE__ */ Pe("div", { role: "status", className: "flex justify-center", children: [
  /* @__PURE__ */ Pe(
    "svg",
    {
      "aria-hidden": "true",
      className: le(
        "h-8 w-8 animate-spin fill-key-color text-gray-200 dark:text-gray-600",
        e
      ),
      viewBox: "0 0 100 101",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ w(
          "path",
          {
            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ w(
          "path",
          {
            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
            fill: "currentFill"
          }
        )
      ]
    }
  ),
  /* @__PURE__ */ w("span", { className: "sr-only", children: "Loading..." })
] }), hN = ({
  className: e,
  ...t
}) => /* @__PURE__ */ w(
  "div",
  {
    className: le("animate-pulse rounded-md bg-muted", e),
    ...t
  }
);
let Mk = { data: "" }, Ik = (e) => typeof window == "object" ? ((e ? e.querySelector("#_goober") : window._goober) || Object.assign((e || document.head).appendChild(document.createElement("style")), { innerHTML: " ", id: "_goober" })).firstChild : e || Mk, Bk = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, Lk = /\/\*[^]*?\*\/|  +/g, zd = /\n+/g, sn = (e, t) => {
  let r = "", n = "", o = "";
  for (let i in e) {
    let a = e[i];
    i[0] == "@" ? i[1] == "i" ? r = i + " " + a + ";" : n += i[1] == "f" ? sn(a, i) : i + "{" + sn(a, i[1] == "k" ? "" : t) + "}" : typeof a == "object" ? n += sn(a, t ? t.replace(/([^,])+/g, (s) => i.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (c) => /&/.test(c) ? c.replace(/&/g, s) : s ? s + " " + c : c)) : i) : a != null && (i = /^--/.test(i) ? i : i.replace(/[A-Z]/g, "-$&").toLowerCase(), o += sn.p ? sn.p(i, a) : i + ":" + a + ";");
  }
  return r + (t && o ? t + "{" + o + "}" : o) + n;
}, Br = {}, Pg = (e) => {
  if (typeof e == "object") {
    let t = "";
    for (let r in e) t += r + Pg(e[r]);
    return t;
  }
  return e;
}, Wk = (e, t, r, n, o) => {
  let i = Pg(e), a = Br[i] || (Br[i] = ((c) => {
    let l = 0, u = 11;
    for (; l < c.length; ) u = 101 * u + c.charCodeAt(l++) >>> 0;
    return "go" + u;
  })(i));
  if (!Br[a]) {
    let c = i !== e ? e : ((l) => {
      let u, d, f = [{}];
      for (; u = Bk.exec(l.replace(Lk, "")); ) u[4] ? f.shift() : u[3] ? (d = u[3].replace(zd, " ").trim(), f.unshift(f[0][d] = f[0][d] || {})) : f[0][u[1]] = u[2].replace(zd, " ").trim();
      return f[0];
    })(e);
    Br[a] = sn(o ? { ["@keyframes " + a]: c } : c, r ? "" : "." + a);
  }
  let s = r && Br.g ? Br.g : null;
  return r && (Br.g = Br[a]), ((c, l, u, d) => {
    d ? l.data = l.data.replace(d, c) : l.data.indexOf(c) === -1 && (l.data = u ? c + l.data : l.data + c);
  })(Br[a], t, n, s), a;
}, zk = (e, t, r) => e.reduce((n, o, i) => {
  let a = t[i];
  if (a && a.call) {
    let s = a(r), c = s && s.props && s.props.className || /^go/.test(s) && s;
    a = c ? "." + c : s && typeof s == "object" ? s.props ? "" : sn(s, "") : s === !1 ? "" : s;
  }
  return n + o + (a ?? "");
}, "");
function Cs(e) {
  let t = this || {}, r = e.call ? e(t.p) : e;
  return Wk(r.unshift ? r.raw ? zk(r, [].slice.call(arguments, 1), t.p) : r.reduce((n, o) => Object.assign(n, o && o.call ? o(t.p) : o), {}) : r, Ik(t.target), t.g, t.o, t.k);
}
let Eg, Zc, _c;
Cs.bind({ g: 1 });
let Kr = Cs.bind({ k: 1 });
function jk(e, t, r, n) {
  sn.p = t, Eg = e, Zc = r, _c = n;
}
function An(e, t) {
  let r = this || {};
  return function() {
    let n = arguments;
    function o(i, a) {
      let s = Object.assign({}, i), c = s.className || o.className;
      r.p = Object.assign({ theme: Zc && Zc() }, s), r.o = / *go\d+/.test(c), s.className = Cs.apply(r, n) + (c ? " " + c : "");
      let l = e;
      return e[0] && (l = s.as || e, delete s.as), _c && l[0] && _c(s), Eg(l, s);
    }
    return o;
  };
}
var Uk = (e) => typeof e == "function", Jc = (e, t) => Uk(e) ? e(t) : e, Vk = /* @__PURE__ */ (() => {
  let e = 0;
  return () => (++e).toString();
})(), Hk = /* @__PURE__ */ (() => {
  let e;
  return () => {
    if (e === void 0 && typeof window < "u") {
      let t = matchMedia("(prefers-reduced-motion: reduce)");
      e = !t || t.matches;
    }
    return e;
  };
})(), qk = 20, ma = /* @__PURE__ */ new Map(), Gk = 1e3, jd = (e) => {
  if (ma.has(e)) return;
  let t = setTimeout(() => {
    ma.delete(e), Ss({ type: 4, toastId: e });
  }, Gk);
  ma.set(e, t);
}, Kk = (e) => {
  let t = ma.get(e);
  t && clearTimeout(t);
}, Qc = (e, t) => {
  switch (t.type) {
    case 0:
      return { ...e, toasts: [t.toast, ...e.toasts].slice(0, qk) };
    case 1:
      return t.toast.id && Kk(t.toast.id), { ...e, toasts: e.toasts.map((i) => i.id === t.toast.id ? { ...i, ...t.toast } : i) };
    case 2:
      let { toast: r } = t;
      return e.toasts.find((i) => i.id === r.id) ? Qc(e, { type: 1, toast: r }) : Qc(e, { type: 0, toast: r });
    case 3:
      let { toastId: n } = t;
      return n ? jd(n) : e.toasts.forEach((i) => {
        jd(i.id);
      }), { ...e, toasts: e.toasts.map((i) => i.id === n || n === void 0 ? { ...i, visible: !1 } : i) };
    case 4:
      return t.toastId === void 0 ? { ...e, toasts: [] } : { ...e, toasts: e.toasts.filter((i) => i.id !== t.toastId) };
    case 5:
      return { ...e, pausedAt: t.time };
    case 6:
      let o = t.time - (e.pausedAt || 0);
      return { ...e, pausedAt: void 0, toasts: e.toasts.map((i) => ({ ...i, pauseDuration: i.pauseDuration + o })) };
  }
}, Xk = [], lc = { toasts: [], pausedAt: void 0 }, Ss = (e) => {
  lc = Qc(lc, e), Xk.forEach((t) => {
    t(lc);
  });
}, Yk = (e, t = "blank", r) => ({ createdAt: Date.now(), visible: !0, type: t, ariaProps: { role: "status", "aria-live": "polite" }, message: e, pauseDuration: 0, ...r, id: r?.id || Vk() }), Wi = (e) => (t, r) => {
  let n = Yk(t, e, r);
  return Ss({ type: 2, toast: n }), n.id;
}, gr = (e, t) => Wi("blank")(e, t);
gr.error = Wi("error");
gr.success = Wi("success");
gr.loading = Wi("loading");
gr.custom = Wi("custom");
gr.dismiss = (e) => {
  Ss({ type: 3, toastId: e });
};
gr.remove = (e) => Ss({ type: 4, toastId: e });
gr.promise = (e, t, r) => {
  let n = gr.loading(t.loading, { ...r, ...r?.loading });
  return e.then((o) => (gr.success(Jc(t.success, o), { id: n, ...r, ...r?.success }), o)).catch((o) => {
    gr.error(Jc(t.error, o), { id: n, ...r, ...r?.error });
  }), e;
};
var Zk = Kr`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, _k = Kr`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, Jk = Kr`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, Qk = An("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${Zk} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${_k} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e) => e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${Jk} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`, $k = Kr`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, eF = An("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e) => e.secondary || "#e0e0e0"};
  border-right-color: ${(e) => e.primary || "#616161"};
  animation: ${$k} 1s linear infinite;
`, tF = Kr`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, rF = Kr`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, nF = An("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e) => e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${tF} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${rF} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e) => e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`, oF = An("div")`
  position: absolute;
`, iF = An("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, aF = Kr`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, sF = An("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${aF} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, cF = ({ toast: e }) => {
  let { icon: t, type: r, iconTheme: n } = e;
  return t !== void 0 ? typeof t == "string" ? p.createElement(sF, null, t) : t : r === "blank" ? null : p.createElement(iF, null, p.createElement(eF, { ...n }), r !== "loading" && p.createElement(oF, null, r === "error" ? p.createElement(Qk, { ...n }) : p.createElement(nF, { ...n })));
}, lF = (e) => `
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, uF = (e) => `
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, dF = "0%{opacity:0;} 100%{opacity:1;}", fF = "0%{opacity:1;} 100%{opacity:0;}", hF = An("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, vF = An("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, pF = (e, t) => {
  let r = e.includes("top") ? 1 : -1, [n, o] = Hk() ? [dF, fF] : [lF(r), uF(r)];
  return { animation: t ? `${Kr(n)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${Kr(o)} 0.4s forwards cubic-bezier(.06,.71,.55,1)` };
};
p.memo(({ toast: e, position: t, style: r, children: n }) => {
  let o = e.height ? pF(e.position || t || "top-center", e.visible) : { opacity: 0 }, i = p.createElement(cF, { toast: e }), a = p.createElement(vF, { ...e.ariaProps }, Jc(e.message, e));
  return p.createElement(hF, { className: e.className, style: { ...o, ...r, ...e.style } }, typeof n == "function" ? n({ icon: i, message: a }) : p.createElement(p.Fragment, null, i, a));
});
jk(p.createElement);
Cs`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`;
var kg = gr;
function gF(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function mF() {
  if (console && console.warn) {
    for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
      t[r] = arguments[r];
    typeof t[0] == "string" && (t[0] = `react-i18next:: ${t[0]}`), console.warn(...t);
  }
}
const Ud = {};
function $c() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  typeof t[0] == "string" && Ud[t[0]] || (typeof t[0] == "string" && (Ud[t[0]] = /* @__PURE__ */ new Date()), mF(...t));
}
const Fg = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const r = () => {
      setTimeout(() => {
        e.off("initialized", r);
      }, 0), t();
    };
    e.on("initialized", r);
  }
};
function Vd(e, t, r) {
  e.loadNamespaces(t, Fg(e, r));
}
function Hd(e, t, r, n) {
  typeof r == "string" && (r = [r]), r.forEach((o) => {
    e.options.ns.indexOf(o) < 0 && e.options.ns.push(o);
  }), e.loadLanguages(t, Fg(e, n));
}
function yF(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  const n = t.languages[0], o = t.options ? t.options.fallbackLng : !1, i = t.languages[t.languages.length - 1];
  if (n.toLowerCase() === "cimode") return !0;
  const a = (s, c) => {
    const l = t.services.backendConnector.state[`${s}|${c}`];
    return l === -1 || l === 2;
  };
  return r.bindI18n && r.bindI18n.indexOf("languageChanging") > -1 && t.services.backendConnector.backend && t.isLanguageChangingTo && !a(t.isLanguageChangingTo, e) ? !1 : !!(t.hasResourceBundle(n, e) || !t.services.backendConnector.backend || t.options.resources && !t.options.partialBundledLanguages || a(n, e) && (!o || a(i, e)));
}
function bF(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return !t.languages || !t.languages.length ? ($c("i18n.languages were undefined or empty", t.languages), !0) : t.options.ignoreJSONStructure !== void 0 ? t.hasLoadedNamespace(e, {
    lng: r.lng,
    precheck: (o, i) => {
      if (r.bindI18n && r.bindI18n.indexOf("languageChanging") > -1 && o.services.backendConnector.backend && o.isLanguageChangingTo && !i(o.isLanguageChangingTo, e)) return !1;
    }
  }) : yF(e, t, r);
}
const wF = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, xF = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, CF = (e) => xF[e], SF = (e) => e.replace(wF, CF);
let PF = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: SF
};
function EF() {
  return PF;
}
let kF;
function FF() {
  return kF;
}
const DF = Sn();
class RF {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((r) => {
      this.usedNamespaces[r] || (this.usedNamespaces[r] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const TF = (e, t) => {
  const r = Wr();
  return ir(() => {
    r.current = e;
  }, [e, t]), r.current;
};
function AF(e) {
  let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  const {
    i18n: r
  } = t, {
    i18n: n,
    defaultNS: o
  } = Pn(DF) || {}, i = r || n || FF();
  if (i && !i.reportNamespaces && (i.reportNamespaces = new RF()), !i) {
    $c("You will need to pass in an i18next instance by using initReactI18next");
    const C = (D, A) => typeof A == "string" ? A : A && typeof A == "object" && typeof A.defaultValue == "string" ? A.defaultValue : Array.isArray(D) ? D[D.length - 1] : D, E = [C, {}, !1];
    return E.t = C, E.i18n = {}, E.ready = !1, E;
  }
  i.options.react && i.options.react.wait !== void 0 && $c("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const a = {
    ...EF(),
    ...i.options.react,
    ...t
  }, {
    useSuspense: s,
    keyPrefix: c
  } = a;
  let l = o || i.options && i.options.defaultNS;
  l = typeof l == "string" ? [l] : l || ["translation"], i.reportNamespaces.addUsedNamespaces && i.reportNamespaces.addUsedNamespaces(l);
  const u = (i.isInitialized || i.initializedStoreOnce) && l.every((C) => bF(C, i, a));
  function d() {
    return i.getFixedT(t.lng || null, a.nsMode === "fallback" ? l : l[0], c);
  }
  const [f, h] = nr(d);
  let g = l.join();
  t.lng && (g = `${t.lng}${g}`);
  const v = TF(g), y = Wr(!0);
  ir(() => {
    const {
      bindI18n: C,
      bindI18nStore: E
    } = a;
    y.current = !0, !u && !s && (t.lng ? Hd(i, t.lng, l, () => {
      y.current && h(d);
    }) : Vd(i, l, () => {
      y.current && h(d);
    })), u && v && v !== g && y.current && h(d);
    function D() {
      y.current && h(d);
    }
    return C && i && i.on(C, D), E && i && i.store.on(E, D), () => {
      y.current = !1, C && i && C.split(" ").forEach((A) => i.off(A, D)), E && i && E.split(" ").forEach((A) => i.store.off(A, D));
    };
  }, [i, g]);
  const b = Wr(!0);
  ir(() => {
    y.current && !b.current && h(d), b.current = !1;
  }, [i, c]);
  const x = [f, i, u];
  if (x.t = f, x.i18n = i, x.ready = u, u || !u && !s) return x;
  throw new Promise((C) => {
    t.lng ? Hd(i, t.lng, l, () => C()) : Vd(i, l, () => C());
  });
}
const vN = (e, t) => {
  let r;
  return (...n) => {
    r && clearTimeout(r), r = setTimeout(() => {
      r = null, e(...n);
    }, t ?? 100);
  };
}, pN = () => {
  const { t: e } = AF();
  return { copyText: (r) => {
    navigator.clipboard.writeText(r), kg.success(e("common.copied"));
  } };
}, gN = ({
  func: e,
  variables: t,
  success: r,
  loading: n,
  errorHandler: o
}) => () => {
  kg.promise(
    new Promise((i, a) => {
      e(t, {
        onSuccess: i,
        onError: a
      });
    }),
    {
      success: r,
      loading: n,
      error: (i) => typeof o == "function" ? o(i) : o
    }
  );
}, mN = () => {
  const [e, t] = nr(!1), [r, n] = nr(!1), [o, i] = nr(!1);
  return ir(() => {
    const a = () => {
      const s = window.matchMedia("(min-width: 1024px)"), c = window.matchMedia(
        "(min-width: 768px) and (max-width: 1023px)"
      ), l = window.matchMedia("(max-width: 767px)");
      t(s.matches), n(c.matches), i(l.matches);
    };
    return a(), window.addEventListener("resize", a), () => window.removeEventListener("resize", a);
  }, []), { isDesktop: e, isTablet: r, isMobile: o };
}, yN = (e, t) => {
  const r = Object.keys(e), n = Object.keys(t);
  if (r.length !== n.length)
    return !1;
  for (const o of r)
    if (e[o] !== t[o])
      return !1;
  return !0;
}, bN = (e, t, r) => {
  const n = new Date(e), o = {
    year: "numeric",
    month: "long",
    day: "numeric"
  };
  if (!t)
    return r && (o.hour = "numeric", o.minute = "numeric", o.second = "numeric"), new Intl.DateTimeFormat("en-US", o).format(n);
  const i = n.getFullYear(), a = n.getMonth() + 1, s = n.getDate(), c = `${i}년 ${a}월 ${s}일`;
  return r ? `${c} ${new Intl.DateTimeFormat("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23"
  }).format(n)}` : c;
}, wN = ({
  date: e,
  isKoreanLanguage: t
}) => {
  const r = new Date(e), n = /* @__PURE__ */ new Date(), o = (i) => {
    let a;
    switch (i) {
      case "minutes":
        a = cd(n, r);
        break;
      case "hours":
        a = sd(n, r);
        break;
      case "days":
        a = a1(n, r);
        break;
    }
    let s = "";
    if (i === "minutes" ? s = "분" : i === "hours" ? s = "시간" : s = "일", i === "minutes" && a <= 1)
      return t ? "방금 전" : "Just Now";
    const c = a === 1 ? i.slice(0, -1) : i;
    return `${a}${t ? s + " 전" : " " + c + " ago"}`;
  };
  return cd(n, r) < 60 ? o("minutes") : sd(n, r) < 24 ? o("hours") : o("days");
}, xN = (e) => {
  const t = new Date(e), r = t.getFullYear(), n = String(t.getMonth() + 1).padStart(2, "0"), o = String(t.getDate()).padStart(2, "0");
  return `${r}.${n}.${o}.`;
}, CN = (e) => new Date(e).toLocaleTimeString(), SN = (e, t) => {
  const r = parseInt(e.substring(0, 4), 10), n = parseInt(e.substring(4, 6), 10), o = parseInt(e.substring(6, 8), 10), i = new Date(Date.UTC(r, n - 1, o));
  return t && i.setUTCHours(23, 59, 59), i;
}, NF = () => {
  const e = /* @__PURE__ */ new Date(), t = e.getMonth();
  return new Date(e.getFullYear(), t + 1, 1);
}, PN = () => new Date((/* @__PURE__ */ new Date()).getFullYear(), (/* @__PURE__ */ new Date()).getMonth(), 1), EN = () => new Date(NF().getTime() - 1), kN = (e) => {
  if (!/^(19|20)\d\d(0[1-9]|1[012])(0[1-9]|[12]\d|3[01])$/.test(e))
    return !1;
  const r = parseInt(e.substring(0, 4), 10), n = parseInt(e.substring(4, 6), 10) - 1, o = parseInt(e.substring(6, 8), 10), i = new Date(r, n, o);
  return i.getFullYear() === r && i.getMonth() === n && i.getDate() === o;
}, FN = (e) => {
  e.target.value = e.target.value.replace(/[^0-9]/g, ""), e.target.value.length > e.target.maxLength && (e.target.value = e.target.value.slice(0, e.target.maxLength));
}, DN = (e) => {
  !/^[0-9]$/.test(e.key) && e.key !== "Backspace" && e.key !== "Tab" && e.preventDefault();
}, RN = (e, t) => {
  e.key === "Enter" && (e.preventDefault(), t());
}, OF = ({
  title: e,
  titleId: t,
  ...r
}, n) => /* @__PURE__ */ p.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: n, "aria-labelledby": t, ...r }, e ? /* @__PURE__ */ p.createElement("title", { id: t }, e) : null, /* @__PURE__ */ p.createElement("path", { d: "M12.7508 13.5L13.8008 12.45L10.3508 9L13.8008 5.55L12.7508 4.5L8.25078 9L12.7508 13.5ZM6.00078 13.5V4.5H4.50078V13.5H6.00078Z" })), Dg = xr(OF), MF = ({ className: e, ...t }) => /* @__PURE__ */ w(
  "nav",
  {
    role: "navigation",
    "aria-label": "pagination",
    className: le("mx-auto flex w-full justify-center", e),
    ...t
  }
);
MF.displayName = "Pagination";
function TN({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ w(
    "ul",
    {
      "data-slot": "pagination-content",
      className: le("flex flex-row items-center gap-1", e),
      ...t
    }
  );
}
function AN({ ...e }) {
  return /* @__PURE__ */ w("li", { "data-slot": "pagination-item", ...e });
}
const IF = ({
  disabled: e,
  ...t
}) => /* @__PURE__ */ w(
  hn,
  {
    variant: "ghost",
    size: "iconLg",
    "aria-label": "Go to first page",
    disabled: e,
    ...t,
    children: /* @__PURE__ */ w(Dg, { fill: e ? "#a3a3a3" : "#222222" })
  }
);
IF.displayName = "PaginationFirst";
const BF = ({
  disabled: e,
  ...t
}) => /* @__PURE__ */ w(
  hn,
  {
    variant: "ghost",
    size: "iconLg",
    "aria-label": "Go to previous page",
    disabled: e,
    ...t,
    children: /* @__PURE__ */ w(
      Un,
      {
        className: "rotate-90",
        fill: e ? "#a3a3a3" : "#222222"
      }
    )
  }
);
BF.displayName = "PaginationPrevious";
const LF = ({
  disabled: e,
  ...t
}) => /* @__PURE__ */ w(
  hn,
  {
    variant: "ghost",
    size: "iconLg",
    "aria-label": "Go to next page",
    disabled: e,
    ...t,
    children: /* @__PURE__ */ w(
      Un,
      {
        className: "-rotate-90",
        fill: e ? "#a3a3a3" : "#222222"
      }
    )
  }
);
LF.displayName = "PaginationNext";
const WF = ({
  disabled: e,
  ...t
}) => /* @__PURE__ */ w(
  hn,
  {
    variant: "ghost",
    size: "iconLg",
    "aria-label": "Go to last page",
    disabled: e,
    ...t,
    children: /* @__PURE__ */ w(
      Dg,
      {
        className: "rotate-180",
        fill: e ? "#a3a3a3" : "#222222"
      }
    )
  }
);
WF.displayName = "PaginationLast";
const zF = ({
  title: e,
  titleId: t,
  ...r
}, n) => /* @__PURE__ */ p.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: n, "aria-labelledby": t, ...r }, e ? /* @__PURE__ */ p.createElement("title", { id: t }, e) : null, /* @__PURE__ */ p.createElement("path", { d: "M14.343 15.2992L9.86172 10.818C9.48672 11.093 9.07552 11.3086 8.62812 11.4648C8.18072 11.6211 7.70464 11.6992 7.19988 11.6992C5.94944 11.6992 4.88672 11.2617 4.01172 10.3867C3.13672 9.51172 2.69922 8.44922 2.69922 7.19922C2.69922 5.94922 3.13672 4.88672 4.01172 4.01172C4.88672 3.13672 5.94922 2.69922 7.19922 2.69922C8.44922 2.69922 9.51172 3.13672 10.3867 4.01172C11.2617 4.88672 11.6992 5.94944 11.6992 7.19987C11.6992 7.70464 11.6211 8.18072 11.4648 8.62812C11.3086 9.07552 11.093 9.48672 10.818 9.86172L15.2992 14.343L14.343 15.2992ZM7.19922 10.3492C8.07422 10.3492 8.81797 10.043 9.43047 9.43047C10.043 8.81797 10.3492 8.07422 10.3492 7.19922C10.3492 6.32422 10.043 5.58047 9.43047 4.96797C8.81797 4.35547 8.07422 4.04922 7.19922 4.04922C6.32422 4.04922 5.58047 4.35547 4.96797 4.96797C4.35547 5.58047 4.04922 6.32422 4.04922 7.19922C4.04922 8.07422 4.35547 8.81797 4.96797 9.43047C5.58047 10.043 6.32422 10.3492 7.19922 10.3492Z", fill: "#B1B1B1" })), jF = xr(zF), UF = ({
  title: e,
  titleId: t,
  ...r
}, n) => /* @__PURE__ */ p.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: n, "aria-labelledby": t, ...r }, e ? /* @__PURE__ */ p.createElement("title", { id: t }, e) : null, /* @__PURE__ */ p.createElement("path", { d: "M7.19922 13.0492V11.6992H10.7992V13.0492H7.19922ZM4.49922 9.67422V8.32422H13.4992V9.67422H4.49922ZM2.69922 6.29922V4.94922H15.2992V6.29922H2.69922Z", fill: "#222222" })), VF = xr(UF), HF = 100, NN = ({
  list: e,
  defaultValue: t,
  onSelect: r,
  onChangeInputValue: n,
  onSearch: o,
  isSelectDisabled: i = !1,
  disabled: a = !1,
  placeholder: s = "검색어를 입력하세요.",
  responsive: c = !1
}) => {
  const [l, u] = nr(!1), d = Wr(null), f = Wr(null), h = Wr(n);
  fl(() => {
    h.current = n;
  }), ir(
    () => () => {
      f.current && clearTimeout(f.current);
    },
    []
  );
  const g = (b) => {
    f.current && clearTimeout(f.current), f.current = setTimeout(() => {
      f.current = null, h.current?.(b);
    }, HF);
  }, v = () => {
    const b = d.current?.value ?? "";
    f.current && (clearTimeout(f.current), f.current = null, n?.(b)), o(b);
  }, y = (b) => {
    b.key === "Enter" && !b.nativeEvent.isComposing && !b.repeat && v();
  };
  return /* @__PURE__ */ Pe(
    "div",
    {
      className: le(
        "my-[7.5px] flex items-center gap-2",
        c && "min-w-0 flex-wrap"
      ),
      children: [
        /* @__PURE__ */ Pe(
          "div",
          {
            className: le(
              "flex items-center",
              c && "min-w-0 flex-1 basis-full sm:basis-auto"
            ),
            children: [
              /* @__PURE__ */ w(
                QP,
                {
                  ref: d,
                  startIcon: /* @__PURE__ */ w(jF, {}),
                  className: le(
                    "w-[593px] flex-1 rounded-r-none py-[7px] text-xs",
                    c && "w-0 min-w-0 sm:w-[593px]"
                  ),
                  placeholder: s,
                  onChange: (b) => g(b.target.value),
                  onKeyDown: y,
                  disabled: a
                }
              ),
              /* @__PURE__ */ Pe(
                ak,
                {
                  defaultValue: t,
                  onValueChange: (b) => r(b),
                  disabled: i || a,
                  children: [
                    /* @__PURE__ */ w(ck, { className: "h-8 w-[100px] rounded-l-none border-l-0", children: /* @__PURE__ */ w(sk, {}) }),
                    /* @__PURE__ */ w(lk, { children: e.map((b) => /* @__PURE__ */ w(uk, { value: b.value, children: b.label }, b.value)) })
                  ]
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ w(
          hn,
          {
            disabled: !0,
            size: "iconLg",
            variant: "plain",
            onClick: () => u(!l),
            className: l ? "bg-gray-backdrop-300" : "hover:bg-outline-button-hovered",
            children: /* @__PURE__ */ w(VF, {})
          }
        ),
        /* @__PURE__ */ w(
          hn,
          {
            onClick: v,
            disabled: a,
            className: c ? "flex-1 sm:flex-none" : void 0,
            children: "검색"
          }
        )
      ]
    }
  );
};
var el = function(e, t) {
  return el = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var o in n) n.hasOwnProperty(o) && (r[o] = n[o]);
  }, el(e, t);
};
function ne(e, t) {
  el(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var Se = function() {
  return Se = Object.assign || function(t) {
    for (var r, n = 1, o = arguments.length; n < o; n++) {
      r = arguments[n];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, Se.apply(this, arguments);
};
function qF(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
}
function Re(e, t, r, n) {
  function o(i) {
    return i instanceof r ? i : new r(function(a) {
      a(i);
    });
  }
  return new (r || (r = Promise))(function(i, a) {
    function s(u) {
      try {
        l(n.next(u));
      } catch (d) {
        a(d);
      }
    }
    function c(u) {
      try {
        l(n.throw(u));
      } catch (d) {
        a(d);
      }
    }
    function l(u) {
      u.done ? i(u.value) : o(u.value).then(s, c);
    }
    l((n = n.apply(e, [])).next());
  });
}
function Te(e, t) {
  var r = { label: 0, sent: function() {
    if (i[0] & 1) throw i[1];
    return i[1];
  }, trys: [], ops: [] }, n, o, i, a;
  return a = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (a[Symbol.iterator] = function() {
    return this;
  }), a;
  function s(l) {
    return function(u) {
      return c([l, u]);
    };
  }
  function c(l) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; r; ) try {
      if (n = 1, o && (i = l[0] & 2 ? o.return : l[0] ? o.throw || ((i = o.return) && i.call(o), 0) : o.next) && !(i = i.call(o, l[1])).done) return i;
      switch (o = 0, i && (l = [l[0] & 2, i.value]), l[0]) {
        case 0:
        case 1:
          i = l;
          break;
        case 4:
          return r.label++, { value: l[1], done: !1 };
        case 5:
          r.label++, o = l[1], l = [0];
          continue;
        case 7:
          l = r.ops.pop(), r.trys.pop();
          continue;
        default:
          if (i = r.trys, !(i = i.length > 0 && i[i.length - 1]) && (l[0] === 6 || l[0] === 2)) {
            r = 0;
            continue;
          }
          if (l[0] === 3 && (!i || l[1] > i[0] && l[1] < i[3])) {
            r.label = l[1];
            break;
          }
          if (l[0] === 6 && r.label < i[1]) {
            r.label = i[1], i = l;
            break;
          }
          if (i && r.label < i[2]) {
            r.label = i[2], r.ops.push(l);
            break;
          }
          i[2] && r.ops.pop(), r.trys.pop();
          continue;
      }
      l = t.call(e, r);
    } catch (u) {
      l = [6, u], o = 0;
    } finally {
      n = i = 0;
    }
    if (l[0] & 5) throw l[1];
    return { value: l[0] ? l[1] : void 0, done: !0 };
  }
}
function Ge() {
  for (var e = 0, t = 0, r = arguments.length; t < r; t++) e += arguments[t].length;
  for (var n = Array(e), o = 0, t = 0; t < r; t++)
    for (var i = arguments[t], a = 0, s = i.length; a < s; a++, o++)
      n[o] = i[a];
  return n;
}
var go = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", $o = new Uint8Array(256);
for (var oa = 0; oa < go.length; oa++)
  $o[go.charCodeAt(oa)] = oa;
var GF = function(e) {
  for (var t = "", r = e.length, n = 0; n < r; n += 3)
    t += go[e[n] >> 2], t += go[(e[n] & 3) << 4 | e[n + 1] >> 4], t += go[(e[n + 1] & 15) << 2 | e[n + 2] >> 6], t += go[e[n + 2] & 63];
  return r % 3 === 2 ? t = t.substring(0, t.length - 1) + "=" : r % 3 === 1 && (t = t.substring(0, t.length - 2) + "=="), t;
}, qd = function(e) {
  var t = e.length * 0.75, r = e.length, n, o = 0, i, a, s, c;
  e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
  var l = new Uint8Array(t);
  for (n = 0; n < r; n += 4)
    i = $o[e.charCodeAt(n)], a = $o[e.charCodeAt(n + 1)], s = $o[e.charCodeAt(n + 2)], c = $o[e.charCodeAt(n + 3)], l[o++] = i << 2 | a >> 4, l[o++] = (a & 15) << 4 | s >> 2, l[o++] = (s & 3) << 6 | c & 63;
  return l;
}, KF = /^(data)?:?([\w\/\+]+)?;?(charset=[\w-]+|base64)?.*,/i, XF = function(e) {
  var t = e.trim(), r = t.substring(0, 100), n = r.match(KF);
  if (!n)
    return qd(t);
  var o = n[0], i = t.substring(o.length);
  return qd(i);
}, Ce = function(e) {
  return e.charCodeAt(0);
}, YF = function(e) {
  return e.codePointAt(0);
}, zi = function(e, t) {
  return vr(e.toString(16), t, "0").toUpperCase();
}, Ps = function(e) {
  return zi(e, 2);
}, zr = function(e) {
  return String.fromCharCode(e);
}, ZF = function(e) {
  return zr(parseInt(e, 16));
}, vr = function(e, t, r) {
  for (var n = "", o = 0, i = t - e.length; o < i; o++)
    n += r;
  return n + e;
}, Pt = function(e, t, r) {
  for (var n = e.length, o = 0; o < n; o++)
    t[r++] = e.charCodeAt(o);
  return n;
}, _F = function(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}, ji = function(e) {
  return e.replace(/\t|\u0085|\u2028|\u2029/g, "    ").replace(/[\b\v]/g, "");
}, JF = ["\\n", "\\f", "\\r", "\\u000B"], Rg = function(e) {
  return /^[\n\f\r\u000B]$/.test(e);
}, Tg = function(e) {
  return e.split(/[\n\f\r\u000B]/);
}, Ag = function(e) {
  return e.replace(/[\n\f\r\u000B]/g, " ");
}, Ng = function(e, t) {
  var r = e.charCodeAt(t), n, o = t + 1, i = 1;
  return (
    // Check if it's the start of a surrogate pair.
    r >= 55296 && r <= 56319 && // high surrogate
    e.length > o && (n = e.charCodeAt(o), n >= 56320 && n <= 57343 && (i = 2)), [e.slice(t, t + i), i]
  );
}, QF = function(e) {
  for (var t = [], r = 0, n = e.length; r < n; ) {
    var o = Ng(e, r), i = o[0], a = o[1];
    t.push(i), r += a;
  }
  return t;
}, $F = function(e) {
  for (var t = JF.join("|"), r = ["$"], n = 0, o = e.length; n < o; n++) {
    var i = e[n];
    if (Rg(i))
      throw new TypeError("`wordBreak` must not include " + t);
    r.push(i === "" ? "." : _F(i));
  }
  var a = r.join("|");
  return new RegExp("(" + t + ")|((.*?)(" + a + "))", "gm");
}, eD = function(e, t, r, n) {
  for (var o = $F(t), i = ji(e).match(o), a = "", s = 0, c = [], l = function() {
    a !== "" && c.push(a), a = "", s = 0;
  }, u = 0, d = i.length; u < d; u++) {
    var f = i[u];
    if (Rg(f))
      l();
    else {
      var h = n(f);
      s + h > r && l(), a += f, s += h;
    }
  }
  return l(), c;
}, tD = /^D:(\d\d\d\d)(\d\d)?(\d\d)?(\d\d)?(\d\d)?(\d\d)?([+\-Z])?(\d\d)?'?(\d\d)?'?$/, Og = function(e) {
  var t = e.match(tD);
  if (t) {
    var r = t[1], n = t[2], o = n === void 0 ? "01" : n, i = t[3], a = i === void 0 ? "01" : i, s = t[4], c = s === void 0 ? "00" : s, l = t[5], u = l === void 0 ? "00" : l, d = t[6], f = d === void 0 ? "00" : d, h = t[7], g = h === void 0 ? "Z" : h, v = t[8], y = v === void 0 ? "00" : v, b = t[9], x = b === void 0 ? "00" : b, C = g === "Z" ? "Z" : "" + g + y + ":" + x, E = /* @__PURE__ */ new Date(r + "-" + o + "-" + a + "T" + c + ":" + u + ":" + f + C);
    return E;
  }
}, bu = function(e, t) {
  for (var r, n = 0, o; n < e.length; ) {
    var i = e.substring(n).match(t);
    if (!i)
      return { match: o, pos: n };
    o = i, n += ((r = i.index) !== null && r !== void 0 ? r : 0) + i[0].length;
  }
  return { match: o, pos: n };
}, Wa = function(e) {
  return e[e.length - 1];
}, tl = function(e) {
  if (e instanceof Uint8Array)
    return e;
  for (var t = e.length, r = new Uint8Array(t), n = 0; n < t; n++)
    r[n] = e.charCodeAt(n);
  return r;
}, rD = function() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e.length, n = [], o = 0; o < r; o++) {
    var i = e[o];
    n[o] = i instanceof Uint8Array ? i : tl(i);
  }
  for (var a = 0, o = 0; o < r; o++)
    a += e[o].length;
  for (var s = new Uint8Array(a), c = 0, l = 0; l < r; l++)
    for (var u = n[l], d = 0, f = u.length; d < f; d++)
      s[c++] = u[d];
  return s;
}, nD = function(e) {
  for (var t = 0, r = 0, n = e.length; r < n; r++)
    t += e[r].length;
  for (var o = new Uint8Array(t), i = 0, r = 0, n = e.length; r < n; r++) {
    var a = e[r];
    o.set(a, i), i += a.length;
  }
  return o;
}, Mg = function(e) {
  for (var t = "", r = 0, n = e.length; r < n; r++)
    t += zr(e[r]);
  return t;
}, oD = function(e, t) {
  return e.id - t.id;
}, iD = function(e, t) {
  for (var r = [], n = 0, o = e.length; n < o; n++) {
    var i = e[n], a = e[n - 1];
    (n === 0 || t(i) !== t(a)) && r.push(i);
  }
  return r;
}, lo = function(e) {
  for (var t = e.length, r = 0, n = Math.floor(t / 2); r < n; r++) {
    var o = r, i = t - r - 1, a = e[r];
    e[o] = e[i], e[i] = a;
  }
  return e;
}, aD = function(e) {
  for (var t = 0, r = 0, n = e.length; r < n; r++)
    t += e[r];
  return t;
}, sD = function(e, t) {
  for (var r = new Array(t - e), n = 0, o = r.length; n < o; n++)
    r[n] = e + n;
  return r;
}, cD = function(e, t) {
  for (var r = new Array(t.length), n = 0, o = t.length; n < o; n++)
    r[n] = e[t[n]];
  return r;
}, lD = function(e) {
  return e instanceof Uint8Array || e instanceof ArrayBuffer || typeof e == "string";
}, qo = function(e) {
  if (typeof e == "string")
    return XF(e);
  if (e instanceof ArrayBuffer)
    return new Uint8Array(e);
  if (e instanceof Uint8Array)
    return e;
  throw new TypeError("`input` must be one of `string | ArrayBuffer | Uint8Array`");
}, Fo = function() {
  return new Promise(function(e) {
    setTimeout(function() {
      return e();
    }, 0);
  });
}, uD = function(e, t) {
  t === void 0 && (t = !0);
  var r = [];
  t && r.push(65279);
  for (var n = 0, o = e.length; n < o; ) {
    var i = e.codePointAt(n);
    if (i < 65536)
      r.push(i), n += 1;
    else if (i < 1114112)
      r.push(Ig(i), Bg(i)), n += 2;
    else
      throw new Error("Invalid code point: 0x" + Ps(i));
  }
  return new Uint16Array(r);
}, dD = function(e) {
  return e >= 0 && e <= 65535;
}, fD = function(e) {
  return e >= 65536 && e <= 1114111;
}, Ig = function(e) {
  return Math.floor((e - 65536) / 1024) + 55296;
}, Bg = function(e) {
  return (e - 65536) % 1024 + 56320;
}, un;
(function(e) {
  e.BigEndian = "BigEndian", e.LittleEndian = "LittleEndian";
})(un || (un = {}));
var Go = "�".codePointAt(0), Lg = function(e, t) {
  if (t === void 0 && (t = !0), e.length <= 1)
    return String.fromCodePoint(Go);
  for (var r = t ? vD(e) : un.BigEndian, n = t ? 2 : 0, o = []; e.length - n >= 2; ) {
    var i = Kd(e[n++], e[n++], r);
    if (hD(i))
      if (e.length - n < 2)
        o.push(Go);
      else {
        var a = Kd(e[n++], e[n++], r);
        Gd(a) ? o.push(i, a) : o.push(Go);
      }
    else Gd(i) ? (n += 2, o.push(Go)) : o.push(i);
  }
  return n < e.length && o.push(Go), String.fromCodePoint.apply(String, o);
}, hD = function(e) {
  return e >= 55296 && e <= 56319;
}, Gd = function(e) {
  return e >= 56320 && e <= 57343;
}, Kd = function(e, t, r) {
  if (r === un.LittleEndian)
    return t << 8 | e;
  if (r === un.BigEndian)
    return e << 8 | t;
  throw new Error("Invalid byteOrder: " + r);
}, vD = function(e) {
  return Wg(e) ? un.BigEndian : zg(e) ? un.LittleEndian : un.BigEndian;
}, Wg = function(e) {
  return e[0] === 254 && e[1] === 255;
}, zg = function(e) {
  return e[0] === 255 && e[1] === 254;
}, jg = function(e) {
  return Wg(e) || zg(e);
}, pD = function(e) {
  var t = String(e);
  if (Math.abs(e) < 1) {
    var r = parseInt(e.toString().split("e-")[1]);
    if (r) {
      var n = e < 0;
      n && (e *= -1), e *= Math.pow(10, r - 1), t = "0." + new Array(r).join("0") + e.toString().substring(2), n && (t = "-" + t);
    }
  } else {
    var r = parseInt(e.toString().split("+")[1]);
    r > 20 && (r -= 20, e /= Math.pow(10, r), t = e.toString() + new Array(r + 1).join("0"));
  }
  return t;
}, ya = function(e) {
  return Math.ceil(e.toString(2).length / 8);
}, uo = function(e) {
  for (var t = new Uint8Array(ya(e)), r = 1; r <= t.length; r++)
    t[r - 1] = e >> (t.length - r) * 8;
  return t;
}, Ui = function(e) {
  throw new Error(e);
}, uc = {}, Xd;
function Nn() {
  return Xd || (Xd = 1, (function(e) {
    var t = typeof Uint8Array < "u" && typeof Uint16Array < "u" && typeof Int32Array < "u";
    function r(i, a) {
      return Object.prototype.hasOwnProperty.call(i, a);
    }
    e.assign = function(i) {
      for (var a = Array.prototype.slice.call(arguments, 1); a.length; ) {
        var s = a.shift();
        if (s) {
          if (typeof s != "object")
            throw new TypeError(s + "must be non-object");
          for (var c in s)
            r(s, c) && (i[c] = s[c]);
        }
      }
      return i;
    }, e.shrinkBuf = function(i, a) {
      return i.length === a ? i : i.subarray ? i.subarray(0, a) : (i.length = a, i);
    };
    var n = {
      arraySet: function(i, a, s, c, l) {
        if (a.subarray && i.subarray) {
          i.set(a.subarray(s, s + c), l);
          return;
        }
        for (var u = 0; u < c; u++)
          i[l + u] = a[s + u];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        var a, s, c, l, u, d;
        for (c = 0, a = 0, s = i.length; a < s; a++)
          c += i[a].length;
        for (d = new Uint8Array(c), l = 0, a = 0, s = i.length; a < s; a++)
          u = i[a], d.set(u, l), l += u.length;
        return d;
      }
    }, o = {
      arraySet: function(i, a, s, c, l) {
        for (var u = 0; u < c; u++)
          i[l + u] = a[s + u];
      },
      // Join array of chunks to single array.
      flattenChunks: function(i) {
        return [].concat.apply([], i);
      }
    };
    e.setTyped = function(i) {
      i ? (e.Buf8 = Uint8Array, e.Buf16 = Uint16Array, e.Buf32 = Int32Array, e.assign(e, n)) : (e.Buf8 = Array, e.Buf16 = Array, e.Buf32 = Array, e.assign(e, o));
    }, e.setTyped(t);
  })(uc)), uc;
}
var fo = {}, ur = {}, In = {}, Yd;
function gD() {
  if (Yd) return In;
  Yd = 1;
  var e = Nn(), t = 4, r = 0, n = 1, o = 2;
  function i(k) {
    for (var J = k.length; --J >= 0; )
      k[J] = 0;
  }
  var a = 0, s = 1, c = 2, l = 3, u = 258, d = 29, f = 256, h = f + 1 + d, g = 30, v = 19, y = 2 * h + 1, b = 15, x = 16, C = 7, E = 256, D = 16, A = 17, R = 18, O = (
    /* extra bits for each length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0]
  ), W = (
    /* extra bits for each distance code */
    [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13]
  ), z = (
    /* extra bits for each bit length code */
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7]
  ), q = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], V = 512, I = new Array((h + 2) * 2);
  i(I);
  var Z = new Array(g * 2);
  i(Z);
  var Q = new Array(V);
  i(Q);
  var K = new Array(u - l + 1);
  i(K);
  var L = new Array(d);
  i(L);
  var U = new Array(g);
  i(U);
  function Y(k, J, re, se, M) {
    this.static_tree = k, this.extra_bits = J, this.extra_base = re, this.elems = se, this.max_length = M, this.has_stree = k && k.length;
  }
  var he, ce, ke;
  function Ie(k, J) {
    this.dyn_tree = k, this.max_code = 0, this.stat_desc = J;
  }
  function Ne(k) {
    return k < 256 ? Q[k] : Q[256 + (k >>> 7)];
  }
  function qe(k, J) {
    k.pending_buf[k.pending++] = J & 255, k.pending_buf[k.pending++] = J >>> 8 & 255;
  }
  function ge(k, J, re) {
    k.bi_valid > x - re ? (k.bi_buf |= J << k.bi_valid & 65535, qe(k, k.bi_buf), k.bi_buf = J >> x - k.bi_valid, k.bi_valid += re - x) : (k.bi_buf |= J << k.bi_valid & 65535, k.bi_valid += re);
  }
  function ee(k, J, re) {
    ge(
      k,
      re[J * 2],
      re[J * 2 + 1]
      /*.Len*/
    );
  }
  function oe(k, J) {
    var re = 0;
    do
      re |= k & 1, k >>>= 1, re <<= 1;
    while (--J > 0);
    return re >>> 1;
  }
  function We(k) {
    k.bi_valid === 16 ? (qe(k, k.bi_buf), k.bi_buf = 0, k.bi_valid = 0) : k.bi_valid >= 8 && (k.pending_buf[k.pending++] = k.bi_buf & 255, k.bi_buf >>= 8, k.bi_valid -= 8);
  }
  function Fe(k, J) {
    var re = J.dyn_tree, se = J.max_code, M = J.stat_desc.static_tree, X = J.stat_desc.has_stree, S = J.stat_desc.extra_bits, $ = J.stat_desc.extra_base, me = J.stat_desc.max_length, m, H, G, P, N, j, ue = 0;
    for (P = 0; P <= b; P++)
      k.bl_count[P] = 0;
    for (re[k.heap[k.heap_max] * 2 + 1] = 0, m = k.heap_max + 1; m < y; m++)
      H = k.heap[m], P = re[re[H * 2 + 1] * 2 + 1] + 1, P > me && (P = me, ue++), re[H * 2 + 1] = P, !(H > se) && (k.bl_count[P]++, N = 0, H >= $ && (N = S[H - $]), j = re[H * 2], k.opt_len += j * (P + N), X && (k.static_len += j * (M[H * 2 + 1] + N)));
    if (ue !== 0) {
      do {
        for (P = me - 1; k.bl_count[P] === 0; )
          P--;
        k.bl_count[P]--, k.bl_count[P + 1] += 2, k.bl_count[me]--, ue -= 2;
      } while (ue > 0);
      for (P = me; P !== 0; P--)
        for (H = k.bl_count[P]; H !== 0; )
          G = k.heap[--m], !(G > se) && (re[G * 2 + 1] !== P && (k.opt_len += (P - re[G * 2 + 1]) * re[G * 2], re[G * 2 + 1] = P), H--);
    }
  }
  function Me(k, J, re) {
    var se = new Array(b + 1), M = 0, X, S;
    for (X = 1; X <= b; X++)
      se[X] = M = M + re[X - 1] << 1;
    for (S = 0; S <= J; S++) {
      var $ = k[S * 2 + 1];
      $ !== 0 && (k[S * 2] = oe(se[$]++, $));
    }
  }
  function ve() {
    var k, J, re, se, M, X = new Array(b + 1);
    for (re = 0, se = 0; se < d - 1; se++)
      for (L[se] = re, k = 0; k < 1 << O[se]; k++)
        K[re++] = se;
    for (K[re - 1] = se, M = 0, se = 0; se < 16; se++)
      for (U[se] = M, k = 0; k < 1 << W[se]; k++)
        Q[M++] = se;
    for (M >>= 7; se < g; se++)
      for (U[se] = M << 7, k = 0; k < 1 << W[se] - 7; k++)
        Q[256 + M++] = se;
    for (J = 0; J <= b; J++)
      X[J] = 0;
    for (k = 0; k <= 143; )
      I[k * 2 + 1] = 8, k++, X[8]++;
    for (; k <= 255; )
      I[k * 2 + 1] = 9, k++, X[9]++;
    for (; k <= 279; )
      I[k * 2 + 1] = 7, k++, X[7]++;
    for (; k <= 287; )
      I[k * 2 + 1] = 8, k++, X[8]++;
    for (Me(I, h + 1, X), k = 0; k < g; k++)
      Z[k * 2 + 1] = 5, Z[k * 2] = oe(k, 5);
    he = new Y(I, O, f + 1, h, b), ce = new Y(Z, W, 0, g, b), ke = new Y(new Array(0), z, 0, v, C);
  }
  function Je(k) {
    var J;
    for (J = 0; J < h; J++)
      k.dyn_ltree[J * 2] = 0;
    for (J = 0; J < g; J++)
      k.dyn_dtree[J * 2] = 0;
    for (J = 0; J < v; J++)
      k.bl_tree[J * 2] = 0;
    k.dyn_ltree[E * 2] = 1, k.opt_len = k.static_len = 0, k.last_lit = k.matches = 0;
  }
  function Ot(k) {
    k.bi_valid > 8 ? qe(k, k.bi_buf) : k.bi_valid > 0 && (k.pending_buf[k.pending++] = k.bi_buf), k.bi_buf = 0, k.bi_valid = 0;
  }
  function kt(k, J, re, se) {
    Ot(k), qe(k, re), qe(k, ~re), e.arraySet(k.pending_buf, k.window, J, re, k.pending), k.pending += re;
  }
  function Ct(k, J, re, se) {
    var M = J * 2, X = re * 2;
    return k[M] < k[X] || k[M] === k[X] && se[J] <= se[re];
  }
  function it(k, J, re) {
    for (var se = k.heap[re], M = re << 1; M <= k.heap_len && (M < k.heap_len && Ct(J, k.heap[M + 1], k.heap[M], k.depth) && M++, !Ct(J, se, k.heap[M], k.depth)); )
      k.heap[re] = k.heap[M], re = M, M <<= 1;
    k.heap[re] = se;
  }
  function Be(k, J, re) {
    var se, M, X = 0, S, $;
    if (k.last_lit !== 0)
      do
        se = k.pending_buf[k.d_buf + X * 2] << 8 | k.pending_buf[k.d_buf + X * 2 + 1], M = k.pending_buf[k.l_buf + X], X++, se === 0 ? ee(k, M, J) : (S = K[M], ee(k, S + f + 1, J), $ = O[S], $ !== 0 && (M -= L[S], ge(k, M, $)), se--, S = Ne(se), ee(k, S, re), $ = W[S], $ !== 0 && (se -= U[S], ge(k, se, $)));
      while (X < k.last_lit);
    ee(k, E, J);
  }
  function Yt(k, J) {
    var re = J.dyn_tree, se = J.stat_desc.static_tree, M = J.stat_desc.has_stree, X = J.stat_desc.elems, S, $, me = -1, m;
    for (k.heap_len = 0, k.heap_max = y, S = 0; S < X; S++)
      re[S * 2] !== 0 ? (k.heap[++k.heap_len] = me = S, k.depth[S] = 0) : re[S * 2 + 1] = 0;
    for (; k.heap_len < 2; )
      m = k.heap[++k.heap_len] = me < 2 ? ++me : 0, re[m * 2] = 1, k.depth[m] = 0, k.opt_len--, M && (k.static_len -= se[m * 2 + 1]);
    for (J.max_code = me, S = k.heap_len >> 1; S >= 1; S--)
      it(k, re, S);
    m = X;
    do
      S = k.heap[
        1
        /*SMALLEST*/
      ], k.heap[
        1
        /*SMALLEST*/
      ] = k.heap[k.heap_len--], it(
        k,
        re,
        1
        /*SMALLEST*/
      ), $ = k.heap[
        1
        /*SMALLEST*/
      ], k.heap[--k.heap_max] = S, k.heap[--k.heap_max] = $, re[m * 2] = re[S * 2] + re[$ * 2], k.depth[m] = (k.depth[S] >= k.depth[$] ? k.depth[S] : k.depth[$]) + 1, re[S * 2 + 1] = re[$ * 2 + 1] = m, k.heap[
        1
        /*SMALLEST*/
      ] = m++, it(
        k,
        re,
        1
        /*SMALLEST*/
      );
    while (k.heap_len >= 2);
    k.heap[--k.heap_max] = k.heap[
      1
      /*SMALLEST*/
    ], Fe(k, J), Me(re, me, k.bl_count);
  }
  function Qn(k, J, re) {
    var se, M = -1, X, S = J[1], $ = 0, me = 7, m = 4;
    for (S === 0 && (me = 138, m = 3), J[(re + 1) * 2 + 1] = 65535, se = 0; se <= re; se++)
      X = S, S = J[(se + 1) * 2 + 1], !(++$ < me && X === S) && ($ < m ? k.bl_tree[X * 2] += $ : X !== 0 ? (X !== M && k.bl_tree[X * 2]++, k.bl_tree[D * 2]++) : $ <= 10 ? k.bl_tree[A * 2]++ : k.bl_tree[R * 2]++, $ = 0, M = X, S === 0 ? (me = 138, m = 3) : X === S ? (me = 6, m = 3) : (me = 7, m = 4));
  }
  function _r(k, J, re) {
    var se, M = -1, X, S = J[1], $ = 0, me = 7, m = 4;
    for (S === 0 && (me = 138, m = 3), se = 0; se <= re; se++)
      if (X = S, S = J[(se + 1) * 2 + 1], !(++$ < me && X === S)) {
        if ($ < m)
          do
            ee(k, X, k.bl_tree);
          while (--$ !== 0);
        else X !== 0 ? (X !== M && (ee(k, X, k.bl_tree), $--), ee(k, D, k.bl_tree), ge(k, $ - 3, 2)) : $ <= 10 ? (ee(k, A, k.bl_tree), ge(k, $ - 3, 3)) : (ee(k, R, k.bl_tree), ge(k, $ - 11, 7));
        $ = 0, M = X, S === 0 ? (me = 138, m = 3) : X === S ? (me = 6, m = 3) : (me = 7, m = 4);
      }
  }
  function Zt(k) {
    var J;
    for (Qn(k, k.dyn_ltree, k.l_desc.max_code), Qn(k, k.dyn_dtree, k.d_desc.max_code), Yt(k, k.bl_desc), J = v - 1; J >= 3 && k.bl_tree[q[J] * 2 + 1] === 0; J--)
      ;
    return k.opt_len += 3 * (J + 1) + 5 + 5 + 4, J;
  }
  function $n(k, J, re, se) {
    var M;
    for (ge(k, J - 257, 5), ge(k, re - 1, 5), ge(k, se - 4, 4), M = 0; M < se; M++)
      ge(k, k.bl_tree[q[M] * 2 + 1], 3);
    _r(k, k.dyn_ltree, J - 1), _r(k, k.dyn_dtree, re - 1);
  }
  function Jr(k) {
    var J = 4093624447, re;
    for (re = 0; re <= 31; re++, J >>>= 1)
      if (J & 1 && k.dyn_ltree[re * 2] !== 0)
        return r;
    if (k.dyn_ltree[18] !== 0 || k.dyn_ltree[20] !== 0 || k.dyn_ltree[26] !== 0)
      return n;
    for (re = 32; re < f; re++)
      if (k.dyn_ltree[re * 2] !== 0)
        return n;
    return r;
  }
  var lr = !1;
  function eo(k) {
    lr || (ve(), lr = !0), k.l_desc = new Ie(k.dyn_ltree, he), k.d_desc = new Ie(k.dyn_dtree, ce), k.bl_desc = new Ie(k.bl_tree, ke), k.bi_buf = 0, k.bi_valid = 0, Je(k);
  }
  function Qr(k, J, re, se) {
    ge(k, (a << 1) + (se ? 1 : 0), 3), kt(k, J, re);
  }
  function Ft(k) {
    ge(k, s << 1, 3), ee(k, E, I), We(k);
  }
  function Sr(k, J, re, se) {
    var M, X, S = 0;
    k.level > 0 ? (k.strm.data_type === o && (k.strm.data_type = Jr(k)), Yt(k, k.l_desc), Yt(k, k.d_desc), S = Zt(k), M = k.opt_len + 3 + 7 >>> 3, X = k.static_len + 3 + 7 >>> 3, X <= M && (M = X)) : M = X = re + 5, re + 4 <= M && J !== -1 ? Qr(k, J, re, se) : k.strategy === t || X === M ? (ge(k, (s << 1) + (se ? 1 : 0), 3), Be(k, I, Z)) : (ge(k, (c << 1) + (se ? 1 : 0), 3), $n(k, k.l_desc.max_code + 1, k.d_desc.max_code + 1, S + 1), Be(k, k.dyn_ltree, k.dyn_dtree)), Je(k), se && Ot(k);
  }
  function to(k, J, re) {
    return k.pending_buf[k.d_buf + k.last_lit * 2] = J >>> 8 & 255, k.pending_buf[k.d_buf + k.last_lit * 2 + 1] = J & 255, k.pending_buf[k.l_buf + k.last_lit] = re & 255, k.last_lit++, J === 0 ? k.dyn_ltree[re * 2]++ : (k.matches++, J--, k.dyn_ltree[(K[re] + f + 1) * 2]++, k.dyn_dtree[Ne(J) * 2]++), k.last_lit === k.lit_bufsize - 1;
  }
  return In._tr_init = eo, In._tr_stored_block = Qr, In._tr_flush_block = Sr, In._tr_tally = to, In._tr_align = Ft, In;
}
var dc, Zd;
function Ug() {
  if (Zd) return dc;
  Zd = 1;
  function e(t, r, n, o) {
    for (var i = t & 65535 | 0, a = t >>> 16 & 65535 | 0, s = 0; n !== 0; ) {
      s = n > 2e3 ? 2e3 : n, n -= s;
      do
        i = i + r[o++] | 0, a = a + i | 0;
      while (--s);
      i %= 65521, a %= 65521;
    }
    return i | a << 16 | 0;
  }
  return dc = e, dc;
}
var fc, _d;
function Vg() {
  if (_d) return fc;
  _d = 1;
  function e() {
    for (var n, o = [], i = 0; i < 256; i++) {
      n = i;
      for (var a = 0; a < 8; a++)
        n = n & 1 ? 3988292384 ^ n >>> 1 : n >>> 1;
      o[i] = n;
    }
    return o;
  }
  var t = e();
  function r(n, o, i, a) {
    var s = t, c = a + i;
    n ^= -1;
    for (var l = a; l < c; l++)
      n = n >>> 8 ^ s[(n ^ o[l]) & 255];
    return n ^ -1;
  }
  return fc = r, fc;
}
var hc, Jd;
function wu() {
  return Jd || (Jd = 1, hc = {
    2: "need dictionary",
    /* Z_NEED_DICT       2  */
    1: "stream end",
    /* Z_STREAM_END      1  */
    0: "",
    /* Z_OK              0  */
    "-1": "file error",
    /* Z_ERRNO         (-1) */
    "-2": "stream error",
    /* Z_STREAM_ERROR  (-2) */
    "-3": "data error",
    /* Z_DATA_ERROR    (-3) */
    "-4": "insufficient memory",
    /* Z_MEM_ERROR     (-4) */
    "-5": "buffer error",
    /* Z_BUF_ERROR     (-5) */
    "-6": "incompatible version"
    /* Z_VERSION_ERROR (-6) */
  }), hc;
}
var Qd;
function mD() {
  if (Qd) return ur;
  Qd = 1;
  var e = Nn(), t = gD(), r = Ug(), n = Vg(), o = wu(), i = 0, a = 1, s = 3, c = 4, l = 5, u = 0, d = 1, f = -2, h = -3, g = -5, v = -1, y = 1, b = 2, x = 3, C = 4, E = 0, D = 2, A = 8, R = 9, O = 15, W = 8, z = 29, q = 256, V = q + 1 + z, I = 30, Z = 19, Q = 2 * V + 1, K = 15, L = 3, U = 258, Y = U + L + 1, he = 32, ce = 42, ke = 69, Ie = 73, Ne = 91, qe = 103, ge = 113, ee = 666, oe = 1, We = 2, Fe = 3, Me = 4, ve = 3;
  function Je(m, H) {
    return m.msg = o[H], H;
  }
  function Ot(m) {
    return (m << 1) - (m > 4 ? 9 : 0);
  }
  function kt(m) {
    for (var H = m.length; --H >= 0; )
      m[H] = 0;
  }
  function Ct(m) {
    var H = m.state, G = H.pending;
    G > m.avail_out && (G = m.avail_out), G !== 0 && (e.arraySet(m.output, H.pending_buf, H.pending_out, G, m.next_out), m.next_out += G, H.pending_out += G, m.total_out += G, m.avail_out -= G, H.pending -= G, H.pending === 0 && (H.pending_out = 0));
  }
  function it(m, H) {
    t._tr_flush_block(m, m.block_start >= 0 ? m.block_start : -1, m.strstart - m.block_start, H), m.block_start = m.strstart, Ct(m.strm);
  }
  function Be(m, H) {
    m.pending_buf[m.pending++] = H;
  }
  function Yt(m, H) {
    m.pending_buf[m.pending++] = H >>> 8 & 255, m.pending_buf[m.pending++] = H & 255;
  }
  function Qn(m, H, G, P) {
    var N = m.avail_in;
    return N > P && (N = P), N === 0 ? 0 : (m.avail_in -= N, e.arraySet(H, m.input, m.next_in, N, G), m.state.wrap === 1 ? m.adler = r(m.adler, H, N, G) : m.state.wrap === 2 && (m.adler = n(m.adler, H, N, G)), m.next_in += N, m.total_in += N, N);
  }
  function _r(m, H) {
    var G = m.max_chain_length, P = m.strstart, N, j, ue = m.prev_length, ie = m.nice_match, ae = m.strstart > m.w_size - Y ? m.strstart - (m.w_size - Y) : 0, Xe = m.window, Nr = m.w_mask, ut = m.prev, Ye = m.strstart + U, ht = Xe[P + ue - 1], Dt = Xe[P + ue];
    m.prev_length >= m.good_match && (G >>= 2), ie > m.lookahead && (ie = m.lookahead);
    do
      if (N = H, !(Xe[N + ue] !== Dt || Xe[N + ue - 1] !== ht || Xe[N] !== Xe[P] || Xe[++N] !== Xe[P + 1])) {
        P += 2, N++;
        do
          ;
        while (Xe[++P] === Xe[++N] && Xe[++P] === Xe[++N] && Xe[++P] === Xe[++N] && Xe[++P] === Xe[++N] && Xe[++P] === Xe[++N] && Xe[++P] === Xe[++N] && Xe[++P] === Xe[++N] && Xe[++P] === Xe[++N] && P < Ye);
        if (j = U - (Ye - P), P = Ye - U, j > ue) {
          if (m.match_start = H, ue = j, j >= ie)
            break;
          ht = Xe[P + ue - 1], Dt = Xe[P + ue];
        }
      }
    while ((H = ut[H & Nr]) > ae && --G !== 0);
    return ue <= m.lookahead ? ue : m.lookahead;
  }
  function Zt(m) {
    var H = m.w_size, G, P, N, j, ue;
    do {
      if (j = m.window_size - m.lookahead - m.strstart, m.strstart >= H + (H - Y)) {
        e.arraySet(m.window, m.window, H, H, 0), m.match_start -= H, m.strstart -= H, m.block_start -= H, P = m.hash_size, G = P;
        do
          N = m.head[--G], m.head[G] = N >= H ? N - H : 0;
        while (--P);
        P = H, G = P;
        do
          N = m.prev[--G], m.prev[G] = N >= H ? N - H : 0;
        while (--P);
        j += H;
      }
      if (m.strm.avail_in === 0)
        break;
      if (P = Qn(m.strm, m.window, m.strstart + m.lookahead, j), m.lookahead += P, m.lookahead + m.insert >= L)
        for (ue = m.strstart - m.insert, m.ins_h = m.window[ue], m.ins_h = (m.ins_h << m.hash_shift ^ m.window[ue + 1]) & m.hash_mask; m.insert && (m.ins_h = (m.ins_h << m.hash_shift ^ m.window[ue + L - 1]) & m.hash_mask, m.prev[ue & m.w_mask] = m.head[m.ins_h], m.head[m.ins_h] = ue, ue++, m.insert--, !(m.lookahead + m.insert < L)); )
          ;
    } while (m.lookahead < Y && m.strm.avail_in !== 0);
  }
  function $n(m, H) {
    var G = 65535;
    for (G > m.pending_buf_size - 5 && (G = m.pending_buf_size - 5); ; ) {
      if (m.lookahead <= 1) {
        if (Zt(m), m.lookahead === 0 && H === i)
          return oe;
        if (m.lookahead === 0)
          break;
      }
      m.strstart += m.lookahead, m.lookahead = 0;
      var P = m.block_start + G;
      if ((m.strstart === 0 || m.strstart >= P) && (m.lookahead = m.strstart - P, m.strstart = P, it(m, !1), m.strm.avail_out === 0) || m.strstart - m.block_start >= m.w_size - Y && (it(m, !1), m.strm.avail_out === 0))
        return oe;
    }
    return m.insert = 0, H === c ? (it(m, !0), m.strm.avail_out === 0 ? Fe : Me) : (m.strstart > m.block_start && (it(m, !1), m.strm.avail_out === 0), oe);
  }
  function Jr(m, H) {
    for (var G, P; ; ) {
      if (m.lookahead < Y) {
        if (Zt(m), m.lookahead < Y && H === i)
          return oe;
        if (m.lookahead === 0)
          break;
      }
      if (G = 0, m.lookahead >= L && (m.ins_h = (m.ins_h << m.hash_shift ^ m.window[m.strstart + L - 1]) & m.hash_mask, G = m.prev[m.strstart & m.w_mask] = m.head[m.ins_h], m.head[m.ins_h] = m.strstart), G !== 0 && m.strstart - G <= m.w_size - Y && (m.match_length = _r(m, G)), m.match_length >= L)
        if (P = t._tr_tally(m, m.strstart - m.match_start, m.match_length - L), m.lookahead -= m.match_length, m.match_length <= m.max_lazy_match && m.lookahead >= L) {
          m.match_length--;
          do
            m.strstart++, m.ins_h = (m.ins_h << m.hash_shift ^ m.window[m.strstart + L - 1]) & m.hash_mask, G = m.prev[m.strstart & m.w_mask] = m.head[m.ins_h], m.head[m.ins_h] = m.strstart;
          while (--m.match_length !== 0);
          m.strstart++;
        } else
          m.strstart += m.match_length, m.match_length = 0, m.ins_h = m.window[m.strstart], m.ins_h = (m.ins_h << m.hash_shift ^ m.window[m.strstart + 1]) & m.hash_mask;
      else
        P = t._tr_tally(m, 0, m.window[m.strstart]), m.lookahead--, m.strstart++;
      if (P && (it(m, !1), m.strm.avail_out === 0))
        return oe;
    }
    return m.insert = m.strstart < L - 1 ? m.strstart : L - 1, H === c ? (it(m, !0), m.strm.avail_out === 0 ? Fe : Me) : m.last_lit && (it(m, !1), m.strm.avail_out === 0) ? oe : We;
  }
  function lr(m, H) {
    for (var G, P, N; ; ) {
      if (m.lookahead < Y) {
        if (Zt(m), m.lookahead < Y && H === i)
          return oe;
        if (m.lookahead === 0)
          break;
      }
      if (G = 0, m.lookahead >= L && (m.ins_h = (m.ins_h << m.hash_shift ^ m.window[m.strstart + L - 1]) & m.hash_mask, G = m.prev[m.strstart & m.w_mask] = m.head[m.ins_h], m.head[m.ins_h] = m.strstart), m.prev_length = m.match_length, m.prev_match = m.match_start, m.match_length = L - 1, G !== 0 && m.prev_length < m.max_lazy_match && m.strstart - G <= m.w_size - Y && (m.match_length = _r(m, G), m.match_length <= 5 && (m.strategy === y || m.match_length === L && m.strstart - m.match_start > 4096) && (m.match_length = L - 1)), m.prev_length >= L && m.match_length <= m.prev_length) {
        N = m.strstart + m.lookahead - L, P = t._tr_tally(m, m.strstart - 1 - m.prev_match, m.prev_length - L), m.lookahead -= m.prev_length - 1, m.prev_length -= 2;
        do
          ++m.strstart <= N && (m.ins_h = (m.ins_h << m.hash_shift ^ m.window[m.strstart + L - 1]) & m.hash_mask, G = m.prev[m.strstart & m.w_mask] = m.head[m.ins_h], m.head[m.ins_h] = m.strstart);
        while (--m.prev_length !== 0);
        if (m.match_available = 0, m.match_length = L - 1, m.strstart++, P && (it(m, !1), m.strm.avail_out === 0))
          return oe;
      } else if (m.match_available) {
        if (P = t._tr_tally(m, 0, m.window[m.strstart - 1]), P && it(m, !1), m.strstart++, m.lookahead--, m.strm.avail_out === 0)
          return oe;
      } else
        m.match_available = 1, m.strstart++, m.lookahead--;
    }
    return m.match_available && (P = t._tr_tally(m, 0, m.window[m.strstart - 1]), m.match_available = 0), m.insert = m.strstart < L - 1 ? m.strstart : L - 1, H === c ? (it(m, !0), m.strm.avail_out === 0 ? Fe : Me) : m.last_lit && (it(m, !1), m.strm.avail_out === 0) ? oe : We;
  }
  function eo(m, H) {
    for (var G, P, N, j, ue = m.window; ; ) {
      if (m.lookahead <= U) {
        if (Zt(m), m.lookahead <= U && H === i)
          return oe;
        if (m.lookahead === 0)
          break;
      }
      if (m.match_length = 0, m.lookahead >= L && m.strstart > 0 && (N = m.strstart - 1, P = ue[N], P === ue[++N] && P === ue[++N] && P === ue[++N])) {
        j = m.strstart + U;
        do
          ;
        while (P === ue[++N] && P === ue[++N] && P === ue[++N] && P === ue[++N] && P === ue[++N] && P === ue[++N] && P === ue[++N] && P === ue[++N] && N < j);
        m.match_length = U - (j - N), m.match_length > m.lookahead && (m.match_length = m.lookahead);
      }
      if (m.match_length >= L ? (G = t._tr_tally(m, 1, m.match_length - L), m.lookahead -= m.match_length, m.strstart += m.match_length, m.match_length = 0) : (G = t._tr_tally(m, 0, m.window[m.strstart]), m.lookahead--, m.strstart++), G && (it(m, !1), m.strm.avail_out === 0))
        return oe;
    }
    return m.insert = 0, H === c ? (it(m, !0), m.strm.avail_out === 0 ? Fe : Me) : m.last_lit && (it(m, !1), m.strm.avail_out === 0) ? oe : We;
  }
  function Qr(m, H) {
    for (var G; ; ) {
      if (m.lookahead === 0 && (Zt(m), m.lookahead === 0)) {
        if (H === i)
          return oe;
        break;
      }
      if (m.match_length = 0, G = t._tr_tally(m, 0, m.window[m.strstart]), m.lookahead--, m.strstart++, G && (it(m, !1), m.strm.avail_out === 0))
        return oe;
    }
    return m.insert = 0, H === c ? (it(m, !0), m.strm.avail_out === 0 ? Fe : Me) : m.last_lit && (it(m, !1), m.strm.avail_out === 0) ? oe : We;
  }
  function Ft(m, H, G, P, N) {
    this.good_length = m, this.max_lazy = H, this.nice_length = G, this.max_chain = P, this.func = N;
  }
  var Sr;
  Sr = [
    /*      good lazy nice chain */
    new Ft(0, 0, 0, 0, $n),
    /* 0 store only */
    new Ft(4, 4, 8, 4, Jr),
    /* 1 max speed, no lazy matches */
    new Ft(4, 5, 16, 8, Jr),
    /* 2 */
    new Ft(4, 6, 32, 32, Jr),
    /* 3 */
    new Ft(4, 4, 16, 16, lr),
    /* 4 lazy matches */
    new Ft(8, 16, 32, 32, lr),
    /* 5 */
    new Ft(8, 16, 128, 128, lr),
    /* 6 */
    new Ft(8, 32, 128, 256, lr),
    /* 7 */
    new Ft(32, 128, 258, 1024, lr),
    /* 8 */
    new Ft(32, 258, 258, 4096, lr)
    /* 9 max compression */
  ];
  function to(m) {
    m.window_size = 2 * m.w_size, kt(m.head), m.max_lazy_match = Sr[m.level].max_lazy, m.good_match = Sr[m.level].good_length, m.nice_match = Sr[m.level].nice_length, m.max_chain_length = Sr[m.level].max_chain, m.strstart = 0, m.block_start = 0, m.lookahead = 0, m.insert = 0, m.match_length = m.prev_length = L - 1, m.match_available = 0, m.ins_h = 0;
  }
  function k() {
    this.strm = null, this.status = 0, this.pending_buf = null, this.pending_buf_size = 0, this.pending_out = 0, this.pending = 0, this.wrap = 0, this.gzhead = null, this.gzindex = 0, this.method = A, this.last_flush = -1, this.w_size = 0, this.w_bits = 0, this.w_mask = 0, this.window = null, this.window_size = 0, this.prev = null, this.head = null, this.ins_h = 0, this.hash_size = 0, this.hash_bits = 0, this.hash_mask = 0, this.hash_shift = 0, this.block_start = 0, this.match_length = 0, this.prev_match = 0, this.match_available = 0, this.strstart = 0, this.match_start = 0, this.lookahead = 0, this.prev_length = 0, this.max_chain_length = 0, this.max_lazy_match = 0, this.level = 0, this.strategy = 0, this.good_match = 0, this.nice_match = 0, this.dyn_ltree = new e.Buf16(Q * 2), this.dyn_dtree = new e.Buf16((2 * I + 1) * 2), this.bl_tree = new e.Buf16((2 * Z + 1) * 2), kt(this.dyn_ltree), kt(this.dyn_dtree), kt(this.bl_tree), this.l_desc = null, this.d_desc = null, this.bl_desc = null, this.bl_count = new e.Buf16(K + 1), this.heap = new e.Buf16(2 * V + 1), kt(this.heap), this.heap_len = 0, this.heap_max = 0, this.depth = new e.Buf16(2 * V + 1), kt(this.depth), this.l_buf = 0, this.lit_bufsize = 0, this.last_lit = 0, this.d_buf = 0, this.opt_len = 0, this.static_len = 0, this.matches = 0, this.insert = 0, this.bi_buf = 0, this.bi_valid = 0;
  }
  function J(m) {
    var H;
    return !m || !m.state ? Je(m, f) : (m.total_in = m.total_out = 0, m.data_type = D, H = m.state, H.pending = 0, H.pending_out = 0, H.wrap < 0 && (H.wrap = -H.wrap), H.status = H.wrap ? ce : ge, m.adler = H.wrap === 2 ? 0 : 1, H.last_flush = i, t._tr_init(H), u);
  }
  function re(m) {
    var H = J(m);
    return H === u && to(m.state), H;
  }
  function se(m, H) {
    return !m || !m.state || m.state.wrap !== 2 ? f : (m.state.gzhead = H, u);
  }
  function M(m, H, G, P, N, j) {
    if (!m)
      return f;
    var ue = 1;
    if (H === v && (H = 6), P < 0 ? (ue = 0, P = -P) : P > 15 && (ue = 2, P -= 16), N < 1 || N > R || G !== A || P < 8 || P > 15 || H < 0 || H > 9 || j < 0 || j > C)
      return Je(m, f);
    P === 8 && (P = 9);
    var ie = new k();
    return m.state = ie, ie.strm = m, ie.wrap = ue, ie.gzhead = null, ie.w_bits = P, ie.w_size = 1 << ie.w_bits, ie.w_mask = ie.w_size - 1, ie.hash_bits = N + 7, ie.hash_size = 1 << ie.hash_bits, ie.hash_mask = ie.hash_size - 1, ie.hash_shift = ~~((ie.hash_bits + L - 1) / L), ie.window = new e.Buf8(ie.w_size * 2), ie.head = new e.Buf16(ie.hash_size), ie.prev = new e.Buf16(ie.w_size), ie.lit_bufsize = 1 << N + 6, ie.pending_buf_size = ie.lit_bufsize * 4, ie.pending_buf = new e.Buf8(ie.pending_buf_size), ie.d_buf = 1 * ie.lit_bufsize, ie.l_buf = 3 * ie.lit_bufsize, ie.level = H, ie.strategy = j, ie.method = G, re(m);
  }
  function X(m, H) {
    return M(m, H, A, O, W, E);
  }
  function S(m, H) {
    var G, P, N, j;
    if (!m || !m.state || H > l || H < 0)
      return m ? Je(m, f) : f;
    if (P = m.state, !m.output || !m.input && m.avail_in !== 0 || P.status === ee && H !== c)
      return Je(m, m.avail_out === 0 ? g : f);
    if (P.strm = m, G = P.last_flush, P.last_flush = H, P.status === ce)
      if (P.wrap === 2)
        m.adler = 0, Be(P, 31), Be(P, 139), Be(P, 8), P.gzhead ? (Be(
          P,
          (P.gzhead.text ? 1 : 0) + (P.gzhead.hcrc ? 2 : 0) + (P.gzhead.extra ? 4 : 0) + (P.gzhead.name ? 8 : 0) + (P.gzhead.comment ? 16 : 0)
        ), Be(P, P.gzhead.time & 255), Be(P, P.gzhead.time >> 8 & 255), Be(P, P.gzhead.time >> 16 & 255), Be(P, P.gzhead.time >> 24 & 255), Be(P, P.level === 9 ? 2 : P.strategy >= b || P.level < 2 ? 4 : 0), Be(P, P.gzhead.os & 255), P.gzhead.extra && P.gzhead.extra.length && (Be(P, P.gzhead.extra.length & 255), Be(P, P.gzhead.extra.length >> 8 & 255)), P.gzhead.hcrc && (m.adler = n(m.adler, P.pending_buf, P.pending, 0)), P.gzindex = 0, P.status = ke) : (Be(P, 0), Be(P, 0), Be(P, 0), Be(P, 0), Be(P, 0), Be(P, P.level === 9 ? 2 : P.strategy >= b || P.level < 2 ? 4 : 0), Be(P, ve), P.status = ge);
      else {
        var ue = A + (P.w_bits - 8 << 4) << 8, ie = -1;
        P.strategy >= b || P.level < 2 ? ie = 0 : P.level < 6 ? ie = 1 : P.level === 6 ? ie = 2 : ie = 3, ue |= ie << 6, P.strstart !== 0 && (ue |= he), ue += 31 - ue % 31, P.status = ge, Yt(P, ue), P.strstart !== 0 && (Yt(P, m.adler >>> 16), Yt(P, m.adler & 65535)), m.adler = 1;
      }
    if (P.status === ke)
      if (P.gzhead.extra) {
        for (N = P.pending; P.gzindex < (P.gzhead.extra.length & 65535) && !(P.pending === P.pending_buf_size && (P.gzhead.hcrc && P.pending > N && (m.adler = n(m.adler, P.pending_buf, P.pending - N, N)), Ct(m), N = P.pending, P.pending === P.pending_buf_size)); )
          Be(P, P.gzhead.extra[P.gzindex] & 255), P.gzindex++;
        P.gzhead.hcrc && P.pending > N && (m.adler = n(m.adler, P.pending_buf, P.pending - N, N)), P.gzindex === P.gzhead.extra.length && (P.gzindex = 0, P.status = Ie);
      } else
        P.status = Ie;
    if (P.status === Ie)
      if (P.gzhead.name) {
        N = P.pending;
        do {
          if (P.pending === P.pending_buf_size && (P.gzhead.hcrc && P.pending > N && (m.adler = n(m.adler, P.pending_buf, P.pending - N, N)), Ct(m), N = P.pending, P.pending === P.pending_buf_size)) {
            j = 1;
            break;
          }
          P.gzindex < P.gzhead.name.length ? j = P.gzhead.name.charCodeAt(P.gzindex++) & 255 : j = 0, Be(P, j);
        } while (j !== 0);
        P.gzhead.hcrc && P.pending > N && (m.adler = n(m.adler, P.pending_buf, P.pending - N, N)), j === 0 && (P.gzindex = 0, P.status = Ne);
      } else
        P.status = Ne;
    if (P.status === Ne)
      if (P.gzhead.comment) {
        N = P.pending;
        do {
          if (P.pending === P.pending_buf_size && (P.gzhead.hcrc && P.pending > N && (m.adler = n(m.adler, P.pending_buf, P.pending - N, N)), Ct(m), N = P.pending, P.pending === P.pending_buf_size)) {
            j = 1;
            break;
          }
          P.gzindex < P.gzhead.comment.length ? j = P.gzhead.comment.charCodeAt(P.gzindex++) & 255 : j = 0, Be(P, j);
        } while (j !== 0);
        P.gzhead.hcrc && P.pending > N && (m.adler = n(m.adler, P.pending_buf, P.pending - N, N)), j === 0 && (P.status = qe);
      } else
        P.status = qe;
    if (P.status === qe && (P.gzhead.hcrc ? (P.pending + 2 > P.pending_buf_size && Ct(m), P.pending + 2 <= P.pending_buf_size && (Be(P, m.adler & 255), Be(P, m.adler >> 8 & 255), m.adler = 0, P.status = ge)) : P.status = ge), P.pending !== 0) {
      if (Ct(m), m.avail_out === 0)
        return P.last_flush = -1, u;
    } else if (m.avail_in === 0 && Ot(H) <= Ot(G) && H !== c)
      return Je(m, g);
    if (P.status === ee && m.avail_in !== 0)
      return Je(m, g);
    if (m.avail_in !== 0 || P.lookahead !== 0 || H !== i && P.status !== ee) {
      var ae = P.strategy === b ? Qr(P, H) : P.strategy === x ? eo(P, H) : Sr[P.level].func(P, H);
      if ((ae === Fe || ae === Me) && (P.status = ee), ae === oe || ae === Fe)
        return m.avail_out === 0 && (P.last_flush = -1), u;
      if (ae === We && (H === a ? t._tr_align(P) : H !== l && (t._tr_stored_block(P, 0, 0, !1), H === s && (kt(P.head), P.lookahead === 0 && (P.strstart = 0, P.block_start = 0, P.insert = 0))), Ct(m), m.avail_out === 0))
        return P.last_flush = -1, u;
    }
    return H !== c ? u : P.wrap <= 0 ? d : (P.wrap === 2 ? (Be(P, m.adler & 255), Be(P, m.adler >> 8 & 255), Be(P, m.adler >> 16 & 255), Be(P, m.adler >> 24 & 255), Be(P, m.total_in & 255), Be(P, m.total_in >> 8 & 255), Be(P, m.total_in >> 16 & 255), Be(P, m.total_in >> 24 & 255)) : (Yt(P, m.adler >>> 16), Yt(P, m.adler & 65535)), Ct(m), P.wrap > 0 && (P.wrap = -P.wrap), P.pending !== 0 ? u : d);
  }
  function $(m) {
    var H;
    return !m || !m.state ? f : (H = m.state.status, H !== ce && H !== ke && H !== Ie && H !== Ne && H !== qe && H !== ge && H !== ee ? Je(m, f) : (m.state = null, H === ge ? Je(m, h) : u));
  }
  function me(m, H) {
    var G = H.length, P, N, j, ue, ie, ae, Xe, Nr;
    if (!m || !m.state || (P = m.state, ue = P.wrap, ue === 2 || ue === 1 && P.status !== ce || P.lookahead))
      return f;
    for (ue === 1 && (m.adler = r(m.adler, H, G, 0)), P.wrap = 0, G >= P.w_size && (ue === 0 && (kt(P.head), P.strstart = 0, P.block_start = 0, P.insert = 0), Nr = new e.Buf8(P.w_size), e.arraySet(Nr, H, G - P.w_size, P.w_size, 0), H = Nr, G = P.w_size), ie = m.avail_in, ae = m.next_in, Xe = m.input, m.avail_in = G, m.next_in = 0, m.input = H, Zt(P); P.lookahead >= L; ) {
      N = P.strstart, j = P.lookahead - (L - 1);
      do
        P.ins_h = (P.ins_h << P.hash_shift ^ P.window[N + L - 1]) & P.hash_mask, P.prev[N & P.w_mask] = P.head[P.ins_h], P.head[P.ins_h] = N, N++;
      while (--j);
      P.strstart = N, P.lookahead = L - 1, Zt(P);
    }
    return P.strstart += P.lookahead, P.block_start = P.strstart, P.insert = P.lookahead, P.lookahead = 0, P.match_length = P.prev_length = L - 1, P.match_available = 0, m.next_in = ae, m.input = Xe, m.avail_in = ie, P.wrap = ue, u;
  }
  return ur.deflateInit = X, ur.deflateInit2 = M, ur.deflateReset = re, ur.deflateResetKeep = J, ur.deflateSetHeader = se, ur.deflate = S, ur.deflateEnd = $, ur.deflateSetDictionary = me, ur.deflateInfo = "pako deflate (from Nodeca project)", ur;
}
var Bn = {}, $d;
function Hg() {
  if ($d) return Bn;
  $d = 1;
  var e = Nn(), t = !0, r = !0;
  try {
    String.fromCharCode.apply(null, [0]);
  } catch {
    t = !1;
  }
  try {
    String.fromCharCode.apply(null, new Uint8Array(1));
  } catch {
    r = !1;
  }
  for (var n = new e.Buf8(256), o = 0; o < 256; o++)
    n[o] = o >= 252 ? 6 : o >= 248 ? 5 : o >= 240 ? 4 : o >= 224 ? 3 : o >= 192 ? 2 : 1;
  n[254] = n[254] = 1, Bn.string2buf = function(a) {
    var s, c, l, u, d, f = a.length, h = 0;
    for (u = 0; u < f; u++)
      c = a.charCodeAt(u), (c & 64512) === 55296 && u + 1 < f && (l = a.charCodeAt(u + 1), (l & 64512) === 56320 && (c = 65536 + (c - 55296 << 10) + (l - 56320), u++)), h += c < 128 ? 1 : c < 2048 ? 2 : c < 65536 ? 3 : 4;
    for (s = new e.Buf8(h), d = 0, u = 0; d < h; u++)
      c = a.charCodeAt(u), (c & 64512) === 55296 && u + 1 < f && (l = a.charCodeAt(u + 1), (l & 64512) === 56320 && (c = 65536 + (c - 55296 << 10) + (l - 56320), u++)), c < 128 ? s[d++] = c : c < 2048 ? (s[d++] = 192 | c >>> 6, s[d++] = 128 | c & 63) : c < 65536 ? (s[d++] = 224 | c >>> 12, s[d++] = 128 | c >>> 6 & 63, s[d++] = 128 | c & 63) : (s[d++] = 240 | c >>> 18, s[d++] = 128 | c >>> 12 & 63, s[d++] = 128 | c >>> 6 & 63, s[d++] = 128 | c & 63);
    return s;
  };
  function i(a, s) {
    if (s < 65534 && (a.subarray && r || !a.subarray && t))
      return String.fromCharCode.apply(null, e.shrinkBuf(a, s));
    for (var c = "", l = 0; l < s; l++)
      c += String.fromCharCode(a[l]);
    return c;
  }
  return Bn.buf2binstring = function(a) {
    return i(a, a.length);
  }, Bn.binstring2buf = function(a) {
    for (var s = new e.Buf8(a.length), c = 0, l = s.length; c < l; c++)
      s[c] = a.charCodeAt(c);
    return s;
  }, Bn.buf2string = function(a, s) {
    var c, l, u, d, f = s || a.length, h = new Array(f * 2);
    for (l = 0, c = 0; c < f; ) {
      if (u = a[c++], u < 128) {
        h[l++] = u;
        continue;
      }
      if (d = n[u], d > 4) {
        h[l++] = 65533, c += d - 1;
        continue;
      }
      for (u &= d === 2 ? 31 : d === 3 ? 15 : 7; d > 1 && c < f; )
        u = u << 6 | a[c++] & 63, d--;
      if (d > 1) {
        h[l++] = 65533;
        continue;
      }
      u < 65536 ? h[l++] = u : (u -= 65536, h[l++] = 55296 | u >> 10 & 1023, h[l++] = 56320 | u & 1023);
    }
    return i(h, l);
  }, Bn.utf8border = function(a, s) {
    var c;
    for (s = s || a.length, s > a.length && (s = a.length), c = s - 1; c >= 0 && (a[c] & 192) === 128; )
      c--;
    return c < 0 || c === 0 ? s : c + n[a[c]] > s ? c : s;
  }, Bn;
}
var vc, ef;
function qg() {
  if (ef) return vc;
  ef = 1;
  function e() {
    this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
  }
  return vc = e, vc;
}
var tf;
function yD() {
  if (tf) return fo;
  tf = 1;
  var e = mD(), t = Nn(), r = Hg(), n = wu(), o = qg(), i = Object.prototype.toString, a = 0, s = 4, c = 0, l = 1, u = 2, d = -1, f = 0, h = 8;
  function g(x) {
    if (!(this instanceof g)) return new g(x);
    this.options = t.assign({
      level: d,
      method: h,
      chunkSize: 16384,
      windowBits: 15,
      memLevel: 8,
      strategy: f,
      to: ""
    }, x || {});
    var C = this.options;
    C.raw && C.windowBits > 0 ? C.windowBits = -C.windowBits : C.gzip && C.windowBits > 0 && C.windowBits < 16 && (C.windowBits += 16), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new o(), this.strm.avail_out = 0;
    var E = e.deflateInit2(
      this.strm,
      C.level,
      C.method,
      C.windowBits,
      C.memLevel,
      C.strategy
    );
    if (E !== c)
      throw new Error(n[E]);
    if (C.header && e.deflateSetHeader(this.strm, C.header), C.dictionary) {
      var D;
      if (typeof C.dictionary == "string" ? D = r.string2buf(C.dictionary) : i.call(C.dictionary) === "[object ArrayBuffer]" ? D = new Uint8Array(C.dictionary) : D = C.dictionary, E = e.deflateSetDictionary(this.strm, D), E !== c)
        throw new Error(n[E]);
      this._dict_set = !0;
    }
  }
  g.prototype.push = function(x, C) {
    var E = this.strm, D = this.options.chunkSize, A, R;
    if (this.ended)
      return !1;
    R = C === ~~C ? C : C === !0 ? s : a, typeof x == "string" ? E.input = r.string2buf(x) : i.call(x) === "[object ArrayBuffer]" ? E.input = new Uint8Array(x) : E.input = x, E.next_in = 0, E.avail_in = E.input.length;
    do {
      if (E.avail_out === 0 && (E.output = new t.Buf8(D), E.next_out = 0, E.avail_out = D), A = e.deflate(E, R), A !== l && A !== c)
        return this.onEnd(A), this.ended = !0, !1;
      (E.avail_out === 0 || E.avail_in === 0 && (R === s || R === u)) && (this.options.to === "string" ? this.onData(r.buf2binstring(t.shrinkBuf(E.output, E.next_out))) : this.onData(t.shrinkBuf(E.output, E.next_out)));
    } while ((E.avail_in > 0 || E.avail_out === 0) && A !== l);
    return R === s ? (A = e.deflateEnd(this.strm), this.onEnd(A), this.ended = !0, A === c) : (R === u && (this.onEnd(c), E.avail_out = 0), !0);
  }, g.prototype.onData = function(x) {
    this.chunks.push(x);
  }, g.prototype.onEnd = function(x) {
    x === c && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = x, this.msg = this.strm.msg;
  };
  function v(x, C) {
    var E = new g(C);
    if (E.push(x, !0), E.err)
      throw E.msg || n[E.err];
    return E.result;
  }
  function y(x, C) {
    return C = C || {}, C.raw = !0, v(x, C);
  }
  function b(x, C) {
    return C = C || {}, C.gzip = !0, v(x, C);
  }
  return fo.Deflate = g, fo.deflate = v, fo.deflateRaw = y, fo.gzip = b, fo;
}
var ho = {}, Jt = {}, pc, rf;
function bD() {
  if (rf) return pc;
  rf = 1;
  var e = 30, t = 12;
  return pc = function(n, o) {
    var i, a, s, c, l, u, d, f, h, g, v, y, b, x, C, E, D, A, R, O, W, z, q, V, I;
    i = n.state, a = n.next_in, V = n.input, s = a + (n.avail_in - 5), c = n.next_out, I = n.output, l = c - (o - n.avail_out), u = c + (n.avail_out - 257), d = i.dmax, f = i.wsize, h = i.whave, g = i.wnext, v = i.window, y = i.hold, b = i.bits, x = i.lencode, C = i.distcode, E = (1 << i.lenbits) - 1, D = (1 << i.distbits) - 1;
    e:
      do {
        b < 15 && (y += V[a++] << b, b += 8, y += V[a++] << b, b += 8), A = x[y & E];
        t:
          for (; ; ) {
            if (R = A >>> 24, y >>>= R, b -= R, R = A >>> 16 & 255, R === 0)
              I[c++] = A & 65535;
            else if (R & 16) {
              O = A & 65535, R &= 15, R && (b < R && (y += V[a++] << b, b += 8), O += y & (1 << R) - 1, y >>>= R, b -= R), b < 15 && (y += V[a++] << b, b += 8, y += V[a++] << b, b += 8), A = C[y & D];
              r:
                for (; ; ) {
                  if (R = A >>> 24, y >>>= R, b -= R, R = A >>> 16 & 255, R & 16) {
                    if (W = A & 65535, R &= 15, b < R && (y += V[a++] << b, b += 8, b < R && (y += V[a++] << b, b += 8)), W += y & (1 << R) - 1, W > d) {
                      n.msg = "invalid distance too far back", i.mode = e;
                      break e;
                    }
                    if (y >>>= R, b -= R, R = c - l, W > R) {
                      if (R = W - R, R > h && i.sane) {
                        n.msg = "invalid distance too far back", i.mode = e;
                        break e;
                      }
                      if (z = 0, q = v, g === 0) {
                        if (z += f - R, R < O) {
                          O -= R;
                          do
                            I[c++] = v[z++];
                          while (--R);
                          z = c - W, q = I;
                        }
                      } else if (g < R) {
                        if (z += f + g - R, R -= g, R < O) {
                          O -= R;
                          do
                            I[c++] = v[z++];
                          while (--R);
                          if (z = 0, g < O) {
                            R = g, O -= R;
                            do
                              I[c++] = v[z++];
                            while (--R);
                            z = c - W, q = I;
                          }
                        }
                      } else if (z += g - R, R < O) {
                        O -= R;
                        do
                          I[c++] = v[z++];
                        while (--R);
                        z = c - W, q = I;
                      }
                      for (; O > 2; )
                        I[c++] = q[z++], I[c++] = q[z++], I[c++] = q[z++], O -= 3;
                      O && (I[c++] = q[z++], O > 1 && (I[c++] = q[z++]));
                    } else {
                      z = c - W;
                      do
                        I[c++] = I[z++], I[c++] = I[z++], I[c++] = I[z++], O -= 3;
                      while (O > 2);
                      O && (I[c++] = I[z++], O > 1 && (I[c++] = I[z++]));
                    }
                  } else if ((R & 64) === 0) {
                    A = C[(A & 65535) + (y & (1 << R) - 1)];
                    continue r;
                  } else {
                    n.msg = "invalid distance code", i.mode = e;
                    break e;
                  }
                  break;
                }
            } else if ((R & 64) === 0) {
              A = x[(A & 65535) + (y & (1 << R) - 1)];
              continue t;
            } else if (R & 32) {
              i.mode = t;
              break e;
            } else {
              n.msg = "invalid literal/length code", i.mode = e;
              break e;
            }
            break;
          }
      } while (a < s && c < u);
    O = b >> 3, a -= O, b -= O << 3, y &= (1 << b) - 1, n.next_in = a, n.next_out = c, n.avail_in = a < s ? 5 + (s - a) : 5 - (a - s), n.avail_out = c < u ? 257 + (u - c) : 257 - (c - u), i.hold = y, i.bits = b;
  }, pc;
}
var gc, nf;
function wD() {
  if (nf) return gc;
  nf = 1;
  var e = Nn(), t = 15, r = 852, n = 592, o = 0, i = 1, a = 2, s = [
    /* Length codes 257..285 base */
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
  ], c = [
    /* Length codes 257..285 extra */
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
  ], l = [
    /* Distance codes 0..29 base */
    1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
  ], u = [
    /* Distance codes 0..29 extra */
    16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
  ];
  return gc = function(f, h, g, v, y, b, x, C) {
    var E = C.bits, D = 0, A = 0, R = 0, O = 0, W = 0, z = 0, q = 0, V = 0, I = 0, Z = 0, Q, K, L, U, Y, he = null, ce = 0, ke, Ie = new e.Buf16(t + 1), Ne = new e.Buf16(t + 1), qe = null, ge = 0, ee, oe, We;
    for (D = 0; D <= t; D++)
      Ie[D] = 0;
    for (A = 0; A < v; A++)
      Ie[h[g + A]]++;
    for (W = E, O = t; O >= 1 && Ie[O] === 0; O--)
      ;
    if (W > O && (W = O), O === 0)
      return y[b++] = 1 << 24 | 64 << 16 | 0, y[b++] = 1 << 24 | 64 << 16 | 0, C.bits = 1, 0;
    for (R = 1; R < O && Ie[R] === 0; R++)
      ;
    for (W < R && (W = R), V = 1, D = 1; D <= t; D++)
      if (V <<= 1, V -= Ie[D], V < 0)
        return -1;
    if (V > 0 && (f === o || O !== 1))
      return -1;
    for (Ne[1] = 0, D = 1; D < t; D++)
      Ne[D + 1] = Ne[D] + Ie[D];
    for (A = 0; A < v; A++)
      h[g + A] !== 0 && (x[Ne[h[g + A]]++] = A);
    if (f === o ? (he = qe = x, ke = 19) : f === i ? (he = s, ce -= 257, qe = c, ge -= 257, ke = 256) : (he = l, qe = u, ke = -1), Z = 0, A = 0, D = R, Y = b, z = W, q = 0, L = -1, I = 1 << W, U = I - 1, f === i && I > r || f === a && I > n)
      return 1;
    for (; ; ) {
      ee = D - q, x[A] < ke ? (oe = 0, We = x[A]) : x[A] > ke ? (oe = qe[ge + x[A]], We = he[ce + x[A]]) : (oe = 96, We = 0), Q = 1 << D - q, K = 1 << z, R = K;
      do
        K -= Q, y[Y + (Z >> q) + K] = ee << 24 | oe << 16 | We | 0;
      while (K !== 0);
      for (Q = 1 << D - 1; Z & Q; )
        Q >>= 1;
      if (Q !== 0 ? (Z &= Q - 1, Z += Q) : Z = 0, A++, --Ie[D] === 0) {
        if (D === O)
          break;
        D = h[g + x[A]];
      }
      if (D > W && (Z & U) !== L) {
        for (q === 0 && (q = W), Y += R, z = D - q, V = 1 << z; z + q < O && (V -= Ie[z + q], !(V <= 0)); )
          z++, V <<= 1;
        if (I += 1 << z, f === i && I > r || f === a && I > n)
          return 1;
        L = Z & U, y[L] = W << 24 | z << 16 | Y - b | 0;
      }
    }
    return Z !== 0 && (y[Y + Z] = D - q << 24 | 64 << 16 | 0), C.bits = W, 0;
  }, gc;
}
var of;
function xD() {
  if (of) return Jt;
  of = 1;
  var e = Nn(), t = Ug(), r = Vg(), n = bD(), o = wD(), i = 0, a = 1, s = 2, c = 4, l = 5, u = 6, d = 0, f = 1, h = 2, g = -2, v = -3, y = -4, b = -5, x = 8, C = 1, E = 2, D = 3, A = 4, R = 5, O = 6, W = 7, z = 8, q = 9, V = 10, I = 11, Z = 12, Q = 13, K = 14, L = 15, U = 16, Y = 17, he = 18, ce = 19, ke = 20, Ie = 21, Ne = 22, qe = 23, ge = 24, ee = 25, oe = 26, We = 27, Fe = 28, Me = 29, ve = 30, Je = 31, Ot = 32, kt = 852, Ct = 592, it = 15, Be = it;
  function Yt(M) {
    return (M >>> 24 & 255) + (M >>> 8 & 65280) + ((M & 65280) << 8) + ((M & 255) << 24);
  }
  function Qn() {
    this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new e.Buf16(320), this.work = new e.Buf16(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
  }
  function _r(M) {
    var X;
    return !M || !M.state ? g : (X = M.state, M.total_in = M.total_out = X.total = 0, M.msg = "", X.wrap && (M.adler = X.wrap & 1), X.mode = C, X.last = 0, X.havedict = 0, X.dmax = 32768, X.head = null, X.hold = 0, X.bits = 0, X.lencode = X.lendyn = new e.Buf32(kt), X.distcode = X.distdyn = new e.Buf32(Ct), X.sane = 1, X.back = -1, d);
  }
  function Zt(M) {
    var X;
    return !M || !M.state ? g : (X = M.state, X.wsize = 0, X.whave = 0, X.wnext = 0, _r(M));
  }
  function $n(M, X) {
    var S, $;
    return !M || !M.state || ($ = M.state, X < 0 ? (S = 0, X = -X) : (S = (X >> 4) + 1, X < 48 && (X &= 15)), X && (X < 8 || X > 15)) ? g : ($.window !== null && $.wbits !== X && ($.window = null), $.wrap = S, $.wbits = X, Zt(M));
  }
  function Jr(M, X) {
    var S, $;
    return M ? ($ = new Qn(), M.state = $, $.window = null, S = $n(M, X), S !== d && (M.state = null), S) : g;
  }
  function lr(M) {
    return Jr(M, Be);
  }
  var eo = !0, Qr, Ft;
  function Sr(M) {
    if (eo) {
      var X;
      for (Qr = new e.Buf32(512), Ft = new e.Buf32(32), X = 0; X < 144; )
        M.lens[X++] = 8;
      for (; X < 256; )
        M.lens[X++] = 9;
      for (; X < 280; )
        M.lens[X++] = 7;
      for (; X < 288; )
        M.lens[X++] = 8;
      for (o(a, M.lens, 0, 288, Qr, 0, M.work, { bits: 9 }), X = 0; X < 32; )
        M.lens[X++] = 5;
      o(s, M.lens, 0, 32, Ft, 0, M.work, { bits: 5 }), eo = !1;
    }
    M.lencode = Qr, M.lenbits = 9, M.distcode = Ft, M.distbits = 5;
  }
  function to(M, X, S, $) {
    var me, m = M.state;
    return m.window === null && (m.wsize = 1 << m.wbits, m.wnext = 0, m.whave = 0, m.window = new e.Buf8(m.wsize)), $ >= m.wsize ? (e.arraySet(m.window, X, S - m.wsize, m.wsize, 0), m.wnext = 0, m.whave = m.wsize) : (me = m.wsize - m.wnext, me > $ && (me = $), e.arraySet(m.window, X, S - $, me, m.wnext), $ -= me, $ ? (e.arraySet(m.window, X, S - $, $, 0), m.wnext = $, m.whave = m.wsize) : (m.wnext += me, m.wnext === m.wsize && (m.wnext = 0), m.whave < m.wsize && (m.whave += me))), 0;
  }
  function k(M, X) {
    var S, $, me, m, H, G, P, N, j, ue, ie, ae, Xe, Nr, ut = 0, Ye, ht, Dt, Lt, Ki, Xi, dt, _t, St = new e.Buf8(4), Or, Pr, Vu = (
      /* permutation of code lengths */
      [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]
    );
    if (!M || !M.state || !M.output || !M.input && M.avail_in !== 0)
      return g;
    S = M.state, S.mode === Z && (S.mode = Q), H = M.next_out, me = M.output, P = M.avail_out, m = M.next_in, $ = M.input, G = M.avail_in, N = S.hold, j = S.bits, ue = G, ie = P, _t = d;
    e:
      for (; ; )
        switch (S.mode) {
          case C:
            if (S.wrap === 0) {
              S.mode = Q;
              break;
            }
            for (; j < 16; ) {
              if (G === 0)
                break e;
              G--, N += $[m++] << j, j += 8;
            }
            if (S.wrap & 2 && N === 35615) {
              S.check = 0, St[0] = N & 255, St[1] = N >>> 8 & 255, S.check = r(S.check, St, 2, 0), N = 0, j = 0, S.mode = E;
              break;
            }
            if (S.flags = 0, S.head && (S.head.done = !1), !(S.wrap & 1) || /* check if zlib header allowed */
            (((N & 255) << 8) + (N >> 8)) % 31) {
              M.msg = "incorrect header check", S.mode = ve;
              break;
            }
            if ((N & 15) !== x) {
              M.msg = "unknown compression method", S.mode = ve;
              break;
            }
            if (N >>>= 4, j -= 4, dt = (N & 15) + 8, S.wbits === 0)
              S.wbits = dt;
            else if (dt > S.wbits) {
              M.msg = "invalid window size", S.mode = ve;
              break;
            }
            S.dmax = 1 << dt, M.adler = S.check = 1, S.mode = N & 512 ? V : Z, N = 0, j = 0;
            break;
          case E:
            for (; j < 16; ) {
              if (G === 0)
                break e;
              G--, N += $[m++] << j, j += 8;
            }
            if (S.flags = N, (S.flags & 255) !== x) {
              M.msg = "unknown compression method", S.mode = ve;
              break;
            }
            if (S.flags & 57344) {
              M.msg = "unknown header flags set", S.mode = ve;
              break;
            }
            S.head && (S.head.text = N >> 8 & 1), S.flags & 512 && (St[0] = N & 255, St[1] = N >>> 8 & 255, S.check = r(S.check, St, 2, 0)), N = 0, j = 0, S.mode = D;
          /* falls through */
          case D:
            for (; j < 32; ) {
              if (G === 0)
                break e;
              G--, N += $[m++] << j, j += 8;
            }
            S.head && (S.head.time = N), S.flags & 512 && (St[0] = N & 255, St[1] = N >>> 8 & 255, St[2] = N >>> 16 & 255, St[3] = N >>> 24 & 255, S.check = r(S.check, St, 4, 0)), N = 0, j = 0, S.mode = A;
          /* falls through */
          case A:
            for (; j < 16; ) {
              if (G === 0)
                break e;
              G--, N += $[m++] << j, j += 8;
            }
            S.head && (S.head.xflags = N & 255, S.head.os = N >> 8), S.flags & 512 && (St[0] = N & 255, St[1] = N >>> 8 & 255, S.check = r(S.check, St, 2, 0)), N = 0, j = 0, S.mode = R;
          /* falls through */
          case R:
            if (S.flags & 1024) {
              for (; j < 16; ) {
                if (G === 0)
                  break e;
                G--, N += $[m++] << j, j += 8;
              }
              S.length = N, S.head && (S.head.extra_len = N), S.flags & 512 && (St[0] = N & 255, St[1] = N >>> 8 & 255, S.check = r(S.check, St, 2, 0)), N = 0, j = 0;
            } else S.head && (S.head.extra = null);
            S.mode = O;
          /* falls through */
          case O:
            if (S.flags & 1024 && (ae = S.length, ae > G && (ae = G), ae && (S.head && (dt = S.head.extra_len - S.length, S.head.extra || (S.head.extra = new Array(S.head.extra_len)), e.arraySet(
              S.head.extra,
              $,
              m,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              ae,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              dt
            )), S.flags & 512 && (S.check = r(S.check, $, ae, m)), G -= ae, m += ae, S.length -= ae), S.length))
              break e;
            S.length = 0, S.mode = W;
          /* falls through */
          case W:
            if (S.flags & 2048) {
              if (G === 0)
                break e;
              ae = 0;
              do
                dt = $[m + ae++], S.head && dt && S.length < 65536 && (S.head.name += String.fromCharCode(dt));
              while (dt && ae < G);
              if (S.flags & 512 && (S.check = r(S.check, $, ae, m)), G -= ae, m += ae, dt)
                break e;
            } else S.head && (S.head.name = null);
            S.length = 0, S.mode = z;
          /* falls through */
          case z:
            if (S.flags & 4096) {
              if (G === 0)
                break e;
              ae = 0;
              do
                dt = $[m + ae++], S.head && dt && S.length < 65536 && (S.head.comment += String.fromCharCode(dt));
              while (dt && ae < G);
              if (S.flags & 512 && (S.check = r(S.check, $, ae, m)), G -= ae, m += ae, dt)
                break e;
            } else S.head && (S.head.comment = null);
            S.mode = q;
          /* falls through */
          case q:
            if (S.flags & 512) {
              for (; j < 16; ) {
                if (G === 0)
                  break e;
                G--, N += $[m++] << j, j += 8;
              }
              if (N !== (S.check & 65535)) {
                M.msg = "header crc mismatch", S.mode = ve;
                break;
              }
              N = 0, j = 0;
            }
            S.head && (S.head.hcrc = S.flags >> 9 & 1, S.head.done = !0), M.adler = S.check = 0, S.mode = Z;
            break;
          case V:
            for (; j < 32; ) {
              if (G === 0)
                break e;
              G--, N += $[m++] << j, j += 8;
            }
            M.adler = S.check = Yt(N), N = 0, j = 0, S.mode = I;
          /* falls through */
          case I:
            if (S.havedict === 0)
              return M.next_out = H, M.avail_out = P, M.next_in = m, M.avail_in = G, S.hold = N, S.bits = j, h;
            M.adler = S.check = 1, S.mode = Z;
          /* falls through */
          case Z:
            if (X === l || X === u)
              break e;
          /* falls through */
          case Q:
            if (S.last) {
              N >>>= j & 7, j -= j & 7, S.mode = We;
              break;
            }
            for (; j < 3; ) {
              if (G === 0)
                break e;
              G--, N += $[m++] << j, j += 8;
            }
            switch (S.last = N & 1, N >>>= 1, j -= 1, N & 3) {
              case 0:
                S.mode = K;
                break;
              case 1:
                if (Sr(S), S.mode = ke, X === u) {
                  N >>>= 2, j -= 2;
                  break e;
                }
                break;
              case 2:
                S.mode = Y;
                break;
              case 3:
                M.msg = "invalid block type", S.mode = ve;
            }
            N >>>= 2, j -= 2;
            break;
          case K:
            for (N >>>= j & 7, j -= j & 7; j < 32; ) {
              if (G === 0)
                break e;
              G--, N += $[m++] << j, j += 8;
            }
            if ((N & 65535) !== (N >>> 16 ^ 65535)) {
              M.msg = "invalid stored block lengths", S.mode = ve;
              break;
            }
            if (S.length = N & 65535, N = 0, j = 0, S.mode = L, X === u)
              break e;
          /* falls through */
          case L:
            S.mode = U;
          /* falls through */
          case U:
            if (ae = S.length, ae) {
              if (ae > G && (ae = G), ae > P && (ae = P), ae === 0)
                break e;
              e.arraySet(me, $, m, ae, H), G -= ae, m += ae, P -= ae, H += ae, S.length -= ae;
              break;
            }
            S.mode = Z;
            break;
          case Y:
            for (; j < 14; ) {
              if (G === 0)
                break e;
              G--, N += $[m++] << j, j += 8;
            }
            if (S.nlen = (N & 31) + 257, N >>>= 5, j -= 5, S.ndist = (N & 31) + 1, N >>>= 5, j -= 5, S.ncode = (N & 15) + 4, N >>>= 4, j -= 4, S.nlen > 286 || S.ndist > 30) {
              M.msg = "too many length or distance symbols", S.mode = ve;
              break;
            }
            S.have = 0, S.mode = he;
          /* falls through */
          case he:
            for (; S.have < S.ncode; ) {
              for (; j < 3; ) {
                if (G === 0)
                  break e;
                G--, N += $[m++] << j, j += 8;
              }
              S.lens[Vu[S.have++]] = N & 7, N >>>= 3, j -= 3;
            }
            for (; S.have < 19; )
              S.lens[Vu[S.have++]] = 0;
            if (S.lencode = S.lendyn, S.lenbits = 7, Or = { bits: S.lenbits }, _t = o(i, S.lens, 0, 19, S.lencode, 0, S.work, Or), S.lenbits = Or.bits, _t) {
              M.msg = "invalid code lengths set", S.mode = ve;
              break;
            }
            S.have = 0, S.mode = ce;
          /* falls through */
          case ce:
            for (; S.have < S.nlen + S.ndist; ) {
              for (; ut = S.lencode[N & (1 << S.lenbits) - 1], Ye = ut >>> 24, ht = ut >>> 16 & 255, Dt = ut & 65535, !(Ye <= j); ) {
                if (G === 0)
                  break e;
                G--, N += $[m++] << j, j += 8;
              }
              if (Dt < 16)
                N >>>= Ye, j -= Ye, S.lens[S.have++] = Dt;
              else {
                if (Dt === 16) {
                  for (Pr = Ye + 2; j < Pr; ) {
                    if (G === 0)
                      break e;
                    G--, N += $[m++] << j, j += 8;
                  }
                  if (N >>>= Ye, j -= Ye, S.have === 0) {
                    M.msg = "invalid bit length repeat", S.mode = ve;
                    break;
                  }
                  dt = S.lens[S.have - 1], ae = 3 + (N & 3), N >>>= 2, j -= 2;
                } else if (Dt === 17) {
                  for (Pr = Ye + 3; j < Pr; ) {
                    if (G === 0)
                      break e;
                    G--, N += $[m++] << j, j += 8;
                  }
                  N >>>= Ye, j -= Ye, dt = 0, ae = 3 + (N & 7), N >>>= 3, j -= 3;
                } else {
                  for (Pr = Ye + 7; j < Pr; ) {
                    if (G === 0)
                      break e;
                    G--, N += $[m++] << j, j += 8;
                  }
                  N >>>= Ye, j -= Ye, dt = 0, ae = 11 + (N & 127), N >>>= 7, j -= 7;
                }
                if (S.have + ae > S.nlen + S.ndist) {
                  M.msg = "invalid bit length repeat", S.mode = ve;
                  break;
                }
                for (; ae--; )
                  S.lens[S.have++] = dt;
              }
            }
            if (S.mode === ve)
              break;
            if (S.lens[256] === 0) {
              M.msg = "invalid code -- missing end-of-block", S.mode = ve;
              break;
            }
            if (S.lenbits = 9, Or = { bits: S.lenbits }, _t = o(a, S.lens, 0, S.nlen, S.lencode, 0, S.work, Or), S.lenbits = Or.bits, _t) {
              M.msg = "invalid literal/lengths set", S.mode = ve;
              break;
            }
            if (S.distbits = 6, S.distcode = S.distdyn, Or = { bits: S.distbits }, _t = o(s, S.lens, S.nlen, S.ndist, S.distcode, 0, S.work, Or), S.distbits = Or.bits, _t) {
              M.msg = "invalid distances set", S.mode = ve;
              break;
            }
            if (S.mode = ke, X === u)
              break e;
          /* falls through */
          case ke:
            S.mode = Ie;
          /* falls through */
          case Ie:
            if (G >= 6 && P >= 258) {
              M.next_out = H, M.avail_out = P, M.next_in = m, M.avail_in = G, S.hold = N, S.bits = j, n(M, ie), H = M.next_out, me = M.output, P = M.avail_out, m = M.next_in, $ = M.input, G = M.avail_in, N = S.hold, j = S.bits, S.mode === Z && (S.back = -1);
              break;
            }
            for (S.back = 0; ut = S.lencode[N & (1 << S.lenbits) - 1], Ye = ut >>> 24, ht = ut >>> 16 & 255, Dt = ut & 65535, !(Ye <= j); ) {
              if (G === 0)
                break e;
              G--, N += $[m++] << j, j += 8;
            }
            if (ht && (ht & 240) === 0) {
              for (Lt = Ye, Ki = ht, Xi = Dt; ut = S.lencode[Xi + ((N & (1 << Lt + Ki) - 1) >> Lt)], Ye = ut >>> 24, ht = ut >>> 16 & 255, Dt = ut & 65535, !(Lt + Ye <= j); ) {
                if (G === 0)
                  break e;
                G--, N += $[m++] << j, j += 8;
              }
              N >>>= Lt, j -= Lt, S.back += Lt;
            }
            if (N >>>= Ye, j -= Ye, S.back += Ye, S.length = Dt, ht === 0) {
              S.mode = oe;
              break;
            }
            if (ht & 32) {
              S.back = -1, S.mode = Z;
              break;
            }
            if (ht & 64) {
              M.msg = "invalid literal/length code", S.mode = ve;
              break;
            }
            S.extra = ht & 15, S.mode = Ne;
          /* falls through */
          case Ne:
            if (S.extra) {
              for (Pr = S.extra; j < Pr; ) {
                if (G === 0)
                  break e;
                G--, N += $[m++] << j, j += 8;
              }
              S.length += N & (1 << S.extra) - 1, N >>>= S.extra, j -= S.extra, S.back += S.extra;
            }
            S.was = S.length, S.mode = qe;
          /* falls through */
          case qe:
            for (; ut = S.distcode[N & (1 << S.distbits) - 1], Ye = ut >>> 24, ht = ut >>> 16 & 255, Dt = ut & 65535, !(Ye <= j); ) {
              if (G === 0)
                break e;
              G--, N += $[m++] << j, j += 8;
            }
            if ((ht & 240) === 0) {
              for (Lt = Ye, Ki = ht, Xi = Dt; ut = S.distcode[Xi + ((N & (1 << Lt + Ki) - 1) >> Lt)], Ye = ut >>> 24, ht = ut >>> 16 & 255, Dt = ut & 65535, !(Lt + Ye <= j); ) {
                if (G === 0)
                  break e;
                G--, N += $[m++] << j, j += 8;
              }
              N >>>= Lt, j -= Lt, S.back += Lt;
            }
            if (N >>>= Ye, j -= Ye, S.back += Ye, ht & 64) {
              M.msg = "invalid distance code", S.mode = ve;
              break;
            }
            S.offset = Dt, S.extra = ht & 15, S.mode = ge;
          /* falls through */
          case ge:
            if (S.extra) {
              for (Pr = S.extra; j < Pr; ) {
                if (G === 0)
                  break e;
                G--, N += $[m++] << j, j += 8;
              }
              S.offset += N & (1 << S.extra) - 1, N >>>= S.extra, j -= S.extra, S.back += S.extra;
            }
            if (S.offset > S.dmax) {
              M.msg = "invalid distance too far back", S.mode = ve;
              break;
            }
            S.mode = ee;
          /* falls through */
          case ee:
            if (P === 0)
              break e;
            if (ae = ie - P, S.offset > ae) {
              if (ae = S.offset - ae, ae > S.whave && S.sane) {
                M.msg = "invalid distance too far back", S.mode = ve;
                break;
              }
              ae > S.wnext ? (ae -= S.wnext, Xe = S.wsize - ae) : Xe = S.wnext - ae, ae > S.length && (ae = S.length), Nr = S.window;
            } else
              Nr = me, Xe = H - S.offset, ae = S.length;
            ae > P && (ae = P), P -= ae, S.length -= ae;
            do
              me[H++] = Nr[Xe++];
            while (--ae);
            S.length === 0 && (S.mode = Ie);
            break;
          case oe:
            if (P === 0)
              break e;
            me[H++] = S.length, P--, S.mode = Ie;
            break;
          case We:
            if (S.wrap) {
              for (; j < 32; ) {
                if (G === 0)
                  break e;
                G--, N |= $[m++] << j, j += 8;
              }
              if (ie -= P, M.total_out += ie, S.total += ie, ie && (M.adler = S.check = /*UPDATE(state.check, put - _out, _out);*/
              S.flags ? r(S.check, me, ie, H - ie) : t(S.check, me, ie, H - ie)), ie = P, (S.flags ? N : Yt(N)) !== S.check) {
                M.msg = "incorrect data check", S.mode = ve;
                break;
              }
              N = 0, j = 0;
            }
            S.mode = Fe;
          /* falls through */
          case Fe:
            if (S.wrap && S.flags) {
              for (; j < 32; ) {
                if (G === 0)
                  break e;
                G--, N += $[m++] << j, j += 8;
              }
              if (N !== (S.total & 4294967295)) {
                M.msg = "incorrect length check", S.mode = ve;
                break;
              }
              N = 0, j = 0;
            }
            S.mode = Me;
          /* falls through */
          case Me:
            _t = f;
            break e;
          case ve:
            _t = v;
            break e;
          case Je:
            return y;
          case Ot:
          /* falls through */
          default:
            return g;
        }
    return M.next_out = H, M.avail_out = P, M.next_in = m, M.avail_in = G, S.hold = N, S.bits = j, (S.wsize || ie !== M.avail_out && S.mode < ve && (S.mode < We || X !== c)) && to(M, M.output, M.next_out, ie - M.avail_out), ue -= M.avail_in, ie -= M.avail_out, M.total_in += ue, M.total_out += ie, S.total += ie, S.wrap && ie && (M.adler = S.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
    S.flags ? r(S.check, me, ie, M.next_out - ie) : t(S.check, me, ie, M.next_out - ie)), M.data_type = S.bits + (S.last ? 64 : 0) + (S.mode === Z ? 128 : 0) + (S.mode === ke || S.mode === L ? 256 : 0), (ue === 0 && ie === 0 || X === c) && _t === d && (_t = b), _t;
  }
  function J(M) {
    if (!M || !M.state)
      return g;
    var X = M.state;
    return X.window && (X.window = null), M.state = null, d;
  }
  function re(M, X) {
    var S;
    return !M || !M.state || (S = M.state, (S.wrap & 2) === 0) ? g : (S.head = X, X.done = !1, d);
  }
  function se(M, X) {
    var S = X.length, $, me, m;
    return !M || !M.state || ($ = M.state, $.wrap !== 0 && $.mode !== I) ? g : $.mode === I && (me = 1, me = t(me, X, S, 0), me !== $.check) ? v : (m = to(M, X, S, S), m ? ($.mode = Je, y) : ($.havedict = 1, d));
  }
  return Jt.inflateReset = Zt, Jt.inflateReset2 = $n, Jt.inflateResetKeep = _r, Jt.inflateInit = lr, Jt.inflateInit2 = Jr, Jt.inflate = k, Jt.inflateEnd = J, Jt.inflateGetHeader = re, Jt.inflateSetDictionary = se, Jt.inflateInfo = "pako inflate (from Nodeca project)", Jt;
}
var mc, af;
function Gg() {
  return af || (af = 1, mc = {
    /* Allowed flush values; see deflate() and inflate() below for details */
    Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
    * are errors, positive values are used for special but normal events.
    */
    Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */
    Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */
    Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */
    Z_DEFLATED: 8
    //Z_NULL:                 null // Use -1 or null inline, depending on var type
  }), mc;
}
var yc, sf;
function CD() {
  if (sf) return yc;
  sf = 1;
  function e() {
    this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
  }
  return yc = e, yc;
}
var cf;
function SD() {
  if (cf) return ho;
  cf = 1;
  var e = xD(), t = Nn(), r = Hg(), n = Gg(), o = wu(), i = qg(), a = CD(), s = Object.prototype.toString;
  function c(d) {
    if (!(this instanceof c)) return new c(d);
    this.options = t.assign({
      chunkSize: 16384,
      windowBits: 0,
      to: ""
    }, d || {});
    var f = this.options;
    f.raw && f.windowBits >= 0 && f.windowBits < 16 && (f.windowBits = -f.windowBits, f.windowBits === 0 && (f.windowBits = -15)), f.windowBits >= 0 && f.windowBits < 16 && !(d && d.windowBits) && (f.windowBits += 32), f.windowBits > 15 && f.windowBits < 48 && (f.windowBits & 15) === 0 && (f.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new i(), this.strm.avail_out = 0;
    var h = e.inflateInit2(
      this.strm,
      f.windowBits
    );
    if (h !== n.Z_OK)
      throw new Error(o[h]);
    if (this.header = new a(), e.inflateGetHeader(this.strm, this.header), f.dictionary && (typeof f.dictionary == "string" ? f.dictionary = r.string2buf(f.dictionary) : s.call(f.dictionary) === "[object ArrayBuffer]" && (f.dictionary = new Uint8Array(f.dictionary)), f.raw && (h = e.inflateSetDictionary(this.strm, f.dictionary), h !== n.Z_OK)))
      throw new Error(o[h]);
  }
  c.prototype.push = function(d, f) {
    var h = this.strm, g = this.options.chunkSize, v = this.options.dictionary, y, b, x, C, E, D = !1;
    if (this.ended)
      return !1;
    b = f === ~~f ? f : f === !0 ? n.Z_FINISH : n.Z_NO_FLUSH, typeof d == "string" ? h.input = r.binstring2buf(d) : s.call(d) === "[object ArrayBuffer]" ? h.input = new Uint8Array(d) : h.input = d, h.next_in = 0, h.avail_in = h.input.length;
    do {
      if (h.avail_out === 0 && (h.output = new t.Buf8(g), h.next_out = 0, h.avail_out = g), y = e.inflate(h, n.Z_NO_FLUSH), y === n.Z_NEED_DICT && v && (y = e.inflateSetDictionary(this.strm, v)), y === n.Z_BUF_ERROR && D === !0 && (y = n.Z_OK, D = !1), y !== n.Z_STREAM_END && y !== n.Z_OK)
        return this.onEnd(y), this.ended = !0, !1;
      h.next_out && (h.avail_out === 0 || y === n.Z_STREAM_END || h.avail_in === 0 && (b === n.Z_FINISH || b === n.Z_SYNC_FLUSH)) && (this.options.to === "string" ? (x = r.utf8border(h.output, h.next_out), C = h.next_out - x, E = r.buf2string(h.output, x), h.next_out = C, h.avail_out = g - C, C && t.arraySet(h.output, h.output, x, C, 0), this.onData(E)) : this.onData(t.shrinkBuf(h.output, h.next_out))), h.avail_in === 0 && h.avail_out === 0 && (D = !0);
    } while ((h.avail_in > 0 || h.avail_out === 0) && y !== n.Z_STREAM_END);
    return y === n.Z_STREAM_END && (b = n.Z_FINISH), b === n.Z_FINISH ? (y = e.inflateEnd(this.strm), this.onEnd(y), this.ended = !0, y === n.Z_OK) : (b === n.Z_SYNC_FLUSH && (this.onEnd(n.Z_OK), h.avail_out = 0), !0);
  }, c.prototype.onData = function(d) {
    this.chunks.push(d);
  }, c.prototype.onEnd = function(d) {
    d === n.Z_OK && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = t.flattenChunks(this.chunks)), this.chunks = [], this.err = d, this.msg = this.strm.msg;
  };
  function l(d, f) {
    var h = new c(f);
    if (h.push(d, !0), h.err)
      throw h.msg || o[h.err];
    return h.result;
  }
  function u(d, f) {
    return f = f || {}, f.raw = !0, l(d, f);
  }
  return ho.Inflate = c, ho.inflate = l, ho.inflateRaw = u, ho.ungzip = l, ho;
}
var bc, lf;
function PD() {
  if (lf) return bc;
  lf = 1;
  var e = Nn().assign, t = yD(), r = SD(), n = Gg(), o = {};
  return e(o, t, r, n), bc = o, bc;
}
var ED = PD();
const Es = /* @__PURE__ */ gF(ED);
var uf = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", ei = new Uint8Array(256);
for (var ia = 0; ia < uf.length; ia++)
  ei[uf.charCodeAt(ia)] = ia;
var kD = function(e) {
  var t = e.length * 0.75, r = e.length, n, o = 0, i, a, s, c;
  e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
  var l = new Uint8Array(t);
  for (n = 0; n < r; n += 4)
    i = ei[e.charCodeAt(n)], a = ei[e.charCodeAt(n + 1)], s = ei[e.charCodeAt(n + 2)], c = ei[e.charCodeAt(n + 3)], l[o++] = i << 2 | a >> 4, l[o++] = (a & 15) << 4 | s >> 2, l[o++] = (s & 3) << 6 | c & 63;
  return l;
}, FD = function(e) {
  for (var t = "", r = 0; r < e.length; r++)
    t += String.fromCharCode(e[r]);
  return t;
}, Kg = function(e) {
  return FD(Es.inflate(kD(e)));
}, DD = function(e, t, r) {
  for (var n = "", o = 0, i = t - e.length; o < i; o++)
    n += r;
  return n + e;
};
const RD = "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", TD = "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", AD = "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", ND = "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", OD = /* @__PURE__ */ JSON.parse('"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"'), MD = /* @__PURE__ */ JSON.parse('"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"'), ID = /* @__PURE__ */ JSON.parse('"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"'), BD = /* @__PURE__ */ JSON.parse('"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"'), LD = /* @__PURE__ */ JSON.parse('"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"'), WD = /* @__PURE__ */ JSON.parse('"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"'), zD = /* @__PURE__ */ JSON.parse('"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"'), jD = /* @__PURE__ */ JSON.parse('"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"'), UD = "eJx9WFlv2zgQ/iuGnnYBt5DkS85bmk13g27SoEkPbNEHWqIlIhSpklSuov99R7JIkSLtFyGZjxzN8c0h/4oueF1jpqKz6Mt1K1GJZ4s4S+PZYrvdbqJ59J4zdYNqDAfuXuodp52spdSToZrQl6n0KyZl1Sm/xgVpa5BcKURJfs5KCgdj+F++J8+4uCUqr6IzJVo8jy4qJFCusLjD3d27BucE0cGYd+/4c3T2/U2SxfM36XYxT+JtDI8k/jGPPrMCC0oYvuWSKMJZdPYmiWMLuK9I/sCwlNHZCuRfsJD9sSiOk7dxnMFbbrgieefGBW9eROfA7I/8z1myzVbz7rnpn9vuCW/unpvZecF3eHb3IhWu5eyK5Vw0XCCFi7ezc0pnvRo5E1hi8QhCeM0lHCoIK+/yCvdR67zrfd2THPA7VfzzNTrbpv2fX+BPeH8fm2usBMnBg++/oq/forO08+QGNMgGgeG/5wfxYrE4iPFzTlFt5JtkkLeMPIL/EFoNreJBE2vrXReako3YcqvVEXCTKWJdzPS7Gizyjk/mZZvsAKC66d7FCgMtF4NC2eaVqpDyLW+QwIzi/TGoD6tvPQL7BJEPNVKVb39DW2mkJnY5FALyD9eEhU6DL4SPrqTaS0mRrHyDXrHgvpQz7AvVU+CkqgQOnN3zVgSkkFVfKslzQIgfMfPFOBxWRiyDjcs5p5wFIoFr4kImprQrP59WP1ubiVpcCgxlNLq5XC4PwM8Wy77EvSs5ZyU0EpuFaXqAzmlTjVlerzcH8TuskH/4oiLj0WQQ/oWpdXadJAfxZSOJ7exmPfD01lYSD8K/kU0288JLS7Mh+hW337dINCPA5MRX8QE1jXU8Wx/E/6J6V4zyLBtCdd36Km4Cso+QTOG4N6T5dvRusxxsu6/scK5Wgw2fKovZ20HxHSnrQDjv0WjEejvw7/MkxmMD6ZQkvnEfa1xayperg/ibZfN2kN1K4lvxHw4lZAfD6QErpy1lOt2QF4H3XATa8HDP7VnrVWY6SoNZQfKWokBRt90Ak7mt2GACwTVE8bNPE+Tw3VTIzkmQqRuLqsvtUGaFw3cTcjzJxSod3tjYSnQgS4fvpgyc8KaDZuLwXR8FtYlv8YPD9rHBuGxfbQYG1q1vL2v9+3zC9nF0EF+BqoLBFBbbjRfSYbsJprLYboxtpx1Fj23esXoMhqlx7rB9uR2OPxP/aCMDmX61/Vhm8cha7HA91bzbWUR1z0/m8tLUKSyJ1qWNHqeXrTUf16lb76Or6XIzTmWFA4mHyeLOkUS3+H23UpJQPAnbE0bUS2CSUi6IdWM13Mhpu/OlBUE1t/YbA1QYCeWLYVsrRh+SeDm0RCQEf9pxa3Xpds4RcpJhqNVDbXPkzqTpOJcK/mT1VO17gUtn57C3J3cpMlUucW77Px3hRwZ83VJFGvriJ6YRHJboLmnWPUNXWAC7FbQg+/0IrjUL4RMFBxhYkEdSBLxiXB0xD8TkEZorywPXoP0I/jxhXGzWKEoJUFgeiTvs3srq2eO9Hq2Aeq92S9eDIgeYwIeawKoVY+KyVOumuBmpY0r+CgrgQVn7ohl9n6aIoc4TJjB0lEDWvmaGa05ETrGfPRd3lm1jI64b9SKtBJlbhAFTgEhuqWoUvlhCFdwRBW613cNWqnGYyDAdj+OQfdnugpBWHUa14jAKbbN2tlDrfR6mXUT9p7F3peyGvHNBb0UCl933GHgmyN6Hc/0R6+KZxiG7Ba6ReJjg6RiAos0DpTRsHWNz1s284Mr58DI+UF52N8B7vyIGzP4+nGJcWLXiNMtiR0/0S0BPtExAj3ZNwE42zh11e6duTZS/YlZaK6DebfrkOsb4aURMnsqiA+viHpPowDrwsoX1y6moRTZ20cMXtmpOgFYf8sGd8kFrRw4ptuCQagu2lJvwmpXEUu2DNSlOoEf12vY4aXOZkG6WY8OC4hzrwHRcjVhWepjd4KdYKK7jrx5H89WjRxPWoycydlS3jZ/I2VS/G9yp9gB6PG1T1aY4YAp3LfPHPPqABbtFRHS/jf34/T82FAfb", VD = "eJxtmNtu20YQhl+F4FULyMGeD7pz3AY1ChtG7NpFA18w1NomIlECSRcxgrx7SVk7+wOdG8H5OJydf2Z2d5gf9cV+t0v9VK/r+6vXsXlOlbHe28paq229qj/t++m62aXZ4J/m8PRb1z9/baZxefK63Z6eXN5dVMvTCh83u277xr/6kLrnl2XNq7TpXnczuZyabdee98/b2VzM/x4/dd/T5qab2pd6PQ2vaVVfvDRD005puE3Lu7eH1HbN9hTjx4/77/X6y5lcnUmjVzHIVVDicVX/1W/SsO36dLMfu6nb9/X6TAoBD+5euvZbn8axXtuZ36dhPJrVQqgPQoh5hev91LWLkIv94W1Ygq9+aX+tZAx2tfz64284/sblN/rqfLP/mqrbt3FKu7G67Nv9cNgPzZQ2H6rz7bb6vLgZq89pTMO/M/xfEqturJpqSM/d7GJIm2oamk3aNcO3av80O5xh3yyKmm1193ZIT02bqovTKjP+MAf++7zsZvZ3276kYyWWXB0z99S18/PbafPHQ71W4fjn/fxnFO+ZvkrT0LVzTr78qB/+nk38bHM9exgP8zr1z9U7jt6840YW5uSJKcZOCaBBnKgm5mU8MVNYyMwWFvO7Ukagkmgg6sDWQ5yFFqjzUrLEaQ3BEmiwNsMSaZS0vgWfOkPHWQowNeTUc0kumnxZvsgPxlGai6VTGUqAVCTQ6QkWnc77DKEiLktSUBJKqHIQZ86d8gCpHYoiEzMsb1ubYy8vW50DChB5ZhGqrijD0EqUIeiaEHIfCg5Kpuu0ApiToaGPSY0uaQsyr65L2oKi1yFt1PLaQ3lzfXTgXodGoJYzglndSLDMPg1sTPJpQJHJigw0QrGERqD9YhyTOgONQDUyuF1zaxuokc/BW2ztXCMrGZ9WMW1oQZHIXWNBkSCfRZEL5BMUiZw6CzVSFCfUSGZFNjIldoKDkonTKQiJIGzWmFd3BizJJ9SINoLDriOfUCOZS+zg+KGD1qGiLNMLxtJD1/ns00ON6EzyUCM6vbxhoBKaqbG3DFQCNiL1iHccBPV0DHhQH/JW8EW90dkyFKGywCJU0WkVSvSGeiSUODWFFD0HYdPQVoiRgfPMA+/nnRgiAyNYSjpWNQcNSMrtFCUH4ZIRpSCWocFCSuhCEY6hoUClc0WC52BJlCYYLQdhN+hygRRRlo5BKRRLS6oihSqh+ZzzRGG1Mo4Iz1LoP0qsxDGFzk0JE42ji0jCPejomJKCuwil4m5CiRMEUMVSzVLDUstSx1Juc0oVWMpqY295qVltmtWmWW2a1aZZbZrVplltmtWmWW2G1WZYbYbVZlhthtVmWG2G1WZYbYbVZlhtltVmWW2W1WZZbZbVZlltltVmWW2W1QYjQCh7E2aAQHeGhCFgPoNoy8KNb2wxBhmGKBxoUZXlLGsLI6AsftEDHV0wIURVbANLcTKlGGBIKPOAxCmhePCKUwFzAmpDFRQvjA9R06Hq8TONvshgKDCuRAZTXigUxjxNFfKRo3CLhnIJBMFRvMZpqpNBMlQJzGT5WFQMVQI/AikPMIhEU1aDjqJvQwmjSHB05cC9jbYwc5UtAHNLhDw41ha+lEqF4JaH3gmB61SYcqInxTDmQK8v08vjqv4zDf1N0w3Lf4A8/vwPpfK11w==";
var HD = {
  Courier: ND,
  "Courier-Bold": RD,
  "Courier-Oblique": AD,
  "Courier-BoldOblique": TD,
  Helvetica: BD,
  "Helvetica-Bold": OD,
  "Helvetica-Oblique": ID,
  "Helvetica-BoldOblique": MD,
  "Times-Roman": jD,
  "Times-Bold": LD,
  "Times-Italic": zD,
  "Times-BoldItalic": WD,
  Symbol: UD,
  ZapfDingbats: VD
}, yi;
(function(e) {
  e.Courier = "Courier", e.CourierBold = "Courier-Bold", e.CourierOblique = "Courier-Oblique", e.CourierBoldOblique = "Courier-BoldOblique", e.Helvetica = "Helvetica", e.HelveticaBold = "Helvetica-Bold", e.HelveticaOblique = "Helvetica-Oblique", e.HelveticaBoldOblique = "Helvetica-BoldOblique", e.TimesRoman = "Times-Roman", e.TimesRomanBold = "Times-Bold", e.TimesRomanItalic = "Times-Italic", e.TimesRomanBoldItalic = "Times-BoldItalic", e.Symbol = "Symbol", e.ZapfDingbats = "ZapfDingbats";
})(yi || (yi = {}));
var df = {}, qD = (
  /** @class */
  (function() {
    function e() {
      var t = this;
      this.getWidthOfGlyph = function(r) {
        return t.CharWidths[r];
      }, this.getXAxisKerningForPair = function(r, n) {
        return (t.KernPairXAmounts[r] || {})[n];
      };
    }
    return e.load = function(t) {
      var r = df[t];
      if (r)
        return r;
      var n = Kg(HD[t]), o = Object.assign(new e(), JSON.parse(n));
      return o.CharWidths = o.CharMetrics.reduce(function(i, a) {
        return i[a.N] = a.WX, i;
      }, {}), o.KernPairXAmounts = o.KernPairs.reduce(function(i, a) {
        var s = a[0], c = a[1], l = a[2];
        return i[s] || (i[s] = {}), i[s][c] = l, i;
      }, {}), df[t] = o, o;
    }, e;
  })()
);
const GD = "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";
var KD = Kg(GD), wc = JSON.parse(KD), xc = (
  /** @class */
  /* @__PURE__ */ (function() {
    function e(t, r) {
      var n = this;
      this.canEncodeUnicodeCodePoint = function(o) {
        return o in n.unicodeMappings;
      }, this.encodeUnicodeCodePoint = function(o) {
        var i = n.unicodeMappings[o];
        if (!i) {
          var a = String.fromCharCode(o), s = "0x" + DD(o.toString(16), 4, "0"), c = n.name + ' cannot encode "' + a + '" (' + s + ")";
          throw new Error(c);
        }
        return { code: i[0], name: i[1] };
      }, this.name = t, this.supportedCodePoints = Object.keys(r).map(Number).sort(function(o, i) {
        return o - i;
      }), this.unicodeMappings = r;
    }
    return e;
  })()
), aa = {
  Symbol: new xc("Symbol", wc.symbol),
  ZapfDingbats: new xc("ZapfDingbats", wc.zapfdingbats),
  WinAnsi: new xc("WinAnsi", wc.win1252)
}, ks = function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, XD = ks(yi), ff = function(e) {
  return XD.includes(e);
}, sa = function(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}, vt = function(e) {
  return "`" + e + "`";
}, YD = function(e) {
  return "'" + e + "'";
}, hf = function(e) {
  var t = typeof e;
  return t === "string" ? YD(e) : t === "undefined" ? vt(e) : e;
}, ZD = function(e, t, r) {
  for (var n = new Array(r.length), o = 0, i = r.length; o < i; o++) {
    var a = r[o];
    n[o] = hf(a);
  }
  var s = n.join(" or ");
  return vt(t) + " must be one of " + s + ", but was actually " + hf(e);
}, cn = function(e, t, r) {
  Array.isArray(r) || (r = ks(r));
  for (var n = 0, o = r.length; n < o; n++)
    if (e === r[n])
      return;
  throw new TypeError(ZD(e, t, r));
}, Qt = function(e, t, r) {
  Array.isArray(r) || (r = ks(r)), cn(e, t, r.concat(void 0));
}, _D = function(e, t, r) {
  Array.isArray(r) || (r = ks(r));
  for (var n = 0, o = e.length; n < o; n++)
    cn(e[n], t, r);
}, JD = function(e) {
  return e === null ? "null" : e === void 0 ? "undefined" : typeof e == "string" ? "string" : isNaN(e) ? "NaN" : typeof e == "number" ? "number" : typeof e == "boolean" ? "boolean" : typeof e == "symbol" ? "symbol" : typeof e == "bigint" ? "bigint" : e.constructor && e.constructor.name ? e.constructor.name : e.name ? e.name : e.constructor ? String(e.constructor) : String(e);
}, QD = function(e, t) {
  return t === "null" ? e === null : t === "undefined" ? e === void 0 : t === "string" ? typeof e == "string" : t === "number" ? typeof e == "number" && !isNaN(e) : t === "boolean" ? typeof e == "boolean" : t === "symbol" ? typeof e == "symbol" : t === "bigint" ? typeof e == "bigint" : t === Date ? e instanceof Date : t === Array ? e instanceof Array : t === Uint8Array ? e instanceof Uint8Array : t === ArrayBuffer ? e instanceof ArrayBuffer : t === Function ? e instanceof Function : e instanceof t[0];
}, $D = function(e, t, r) {
  for (var n = new Array(r.length), o = 0, i = r.length; o < i; o++) {
    var a = r[o];
    a === "null" && (n[o] = vt("null")), a === "undefined" && (n[o] = vt("undefined")), a === "string" ? n[o] = vt("string") : a === "number" ? n[o] = vt("number") : a === "boolean" ? n[o] = vt("boolean") : a === "symbol" ? n[o] = vt("symbol") : a === "bigint" ? n[o] = vt("bigint") : a === Array ? n[o] = vt("Array") : a === Uint8Array ? n[o] = vt("Uint8Array") : a === ArrayBuffer ? n[o] = vt("ArrayBuffer") : n[o] = vt(a[1]);
  }
  var s = n.join(" or ");
  return vt(t) + " must be of type " + s + ", but was actually of type " + vt(JD(e));
}, B = function(e, t, r) {
  for (var n = 0, o = r.length; n < o; n++)
    if (QD(e, r[n]))
      return;
  throw new TypeError($D(e, t, r));
}, te = function(e, t, r) {
  B(e, t, r.concat("undefined"));
}, Xg = function(e, t, r) {
  for (var n = 0, o = e.length; n < o; n++)
    B(e[n], t, r);
}, Vt = function(e, t, r, n) {
  if (B(e, t, ["number"]), B(r, "min", ["number"]), B(n, "max", ["number"]), n = Math.max(r, n), e < r || e > n)
    throw new Error(vt(t) + " must be at least " + r + " and at most " + n + ", but was actually " + e);
}, dr = function(e, t, r, n) {
  B(e, t, ["number", "undefined"]), typeof e == "number" && Vt(e, t, r, n);
}, Yg = function(e, t, r) {
  if (B(e, t, ["number"]), e % r !== 0)
    throw new Error(vt(t) + " must be a multiple of " + r + ", but was actually " + e);
}, eR = function(e, t) {
  if (!Number.isInteger(e))
    throw new Error(vt(t) + " must be an integer, but was actually " + e);
}, Fs = function(e, t) {
  if (![1, 0].includes(Math.sign(e)))
    throw new Error(vt(t) + " must be a positive number or 0, but was actually " + e);
}, Ee = new Uint16Array(256);
for (var ca = 0; ca < 256; ca++)
  Ee[ca] = ca;
Ee[22] = Ce("");
Ee[24] = Ce("˘");
Ee[25] = Ce("ˇ");
Ee[26] = Ce("ˆ");
Ee[27] = Ce("˙");
Ee[28] = Ce("˝");
Ee[29] = Ce("˛");
Ee[30] = Ce("˚");
Ee[31] = Ce("˜");
Ee[127] = Ce("�");
Ee[128] = Ce("•");
Ee[129] = Ce("†");
Ee[130] = Ce("‡");
Ee[131] = Ce("…");
Ee[132] = Ce("—");
Ee[133] = Ce("–");
Ee[134] = Ce("ƒ");
Ee[135] = Ce("⁄");
Ee[136] = Ce("‹");
Ee[137] = Ce("›");
Ee[138] = Ce("−");
Ee[139] = Ce("‰");
Ee[140] = Ce("„");
Ee[141] = Ce("“");
Ee[142] = Ce("”");
Ee[143] = Ce("‘");
Ee[144] = Ce("’");
Ee[145] = Ce("‚");
Ee[146] = Ce("™");
Ee[147] = Ce("ﬁ");
Ee[148] = Ce("ﬂ");
Ee[149] = Ce("Ł");
Ee[150] = Ce("Œ");
Ee[151] = Ce("Š");
Ee[152] = Ce("Ÿ");
Ee[153] = Ce("Ž");
Ee[154] = Ce("ı");
Ee[155] = Ce("ł");
Ee[156] = Ce("œ");
Ee[157] = Ce("š");
Ee[158] = Ce("ž");
Ee[159] = Ce("�");
Ee[160] = Ce("€");
Ee[173] = Ce("�");
var Zg = function(e) {
  for (var t = new Array(e.length), r = 0, n = e.length; r < n; r++)
    t[r] = Ee[e[r]];
  return String.fromCodePoint.apply(String, t);
}, jr = (
  /** @class */
  (function() {
    function e(t) {
      this.populate = t, this.value = void 0;
    }
    return e.prototype.getValue = function() {
      return this.value;
    }, e.prototype.access = function() {
      return this.value || (this.value = this.populate()), this.value;
    }, e.prototype.invalidate = function() {
      this.value = void 0;
    }, e.populatedBy = function(t) {
      return new e(t);
    }, e;
  })()
), tr = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = this, i = "Method " + r + "." + n + "() not implemented";
      return o = e.call(this, i) || this, o;
    }
    return t;
  })(Error)
), xu = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = this, o = "Cannot construct " + r + " - it has a private constructor";
      return n = e.call(this, o) || this, n;
    }
    return t;
  })(Error)
), za = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = this, i = function(c) {
        var l, u;
        return (l = c?.name) !== null && l !== void 0 ? l : (u = c?.constructor) === null || u === void 0 ? void 0 : u.name;
      }, a = Array.isArray(r) ? r.map(i) : [i(r)], s = "Expected instance of " + a.join(" or ") + ", " + ("but got instance of " + (n && i(n)));
      return o = e.call(this, s) || this, o;
    }
    return t;
  })(Error)
), tR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = this, o = r + " stream encoding not supported";
      return n = e.call(this, o) || this, n;
    }
    return t;
  })(Error)
), Cu = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = this, i = "Cannot call " + r + "." + n + "() more than once";
      return o = e.call(this, i) || this, o;
    }
    return t;
  })(Error)
);
(function(e) {
  ne(t, e);
  function t(r) {
    var n = this, o = "Missing catalog (ref=" + r + ")";
    return n = e.call(this, o) || this, n;
  }
  return t;
})(Error);
var rR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      var r = this, n = "Can't embed page with missing Contents";
      return r = e.call(this, n) || this, r;
    }
    return t;
  })(Error)
), nR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n, o, i, a = this, s = (i = (o = (n = r?.contructor) === null || n === void 0 ? void 0 : n.name) !== null && o !== void 0 ? o : r?.name) !== null && i !== void 0 ? i : r, c = "Unrecognized stream type: " + s;
      return a = e.call(this, c) || this, a;
    }
    return t;
  })(Error)
), oR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      var r = this, n = "Found mismatched contexts while embedding pages. All pages in the array passed to `PDFDocument.embedPages()` must be from the same document.";
      return r = e.call(this, n) || this, r;
    }
    return t;
  })(Error)
), iR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = this, o = "Attempted to convert PDFArray with " + r + " elements to rectangle, but must have exactly 4 elements.";
      return n = e.call(this, o) || this, n;
    }
    return t;
  })(Error)
), _g = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = this, o = 'Attempted to convert "' + r + '" to a date, but it does not match the PDF date string format.';
      return n = e.call(this, o) || this, n;
    }
    return t;
  })(Error)
), vf = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = this, i = "Invalid targetIndex specified: targetIndex=" + r + " must be less than Count=" + n;
      return o = e.call(this, i) || this, o;
    }
    return t;
  })(Error)
), pf = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = this, i = "Failed to " + n + " at targetIndex=" + r + " due to corrupt page tree: It is likely that one or more 'Count' entries are invalid";
      return o = e.call(this, i) || this, o;
    }
    return t;
  })(Error)
), ja = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      var i = this, a = "index should be at least " + n + " and at most " + o + ", but was actually " + r;
      return i = e.call(this, a) || this, i;
    }
    return t;
  })(Error)
), Su = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      var r = this, n = "Attempted to set invalid field value";
      return r = e.call(this, n) || this, r;
    }
    return t;
  })(Error)
), aR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      var r = this, n = "Attempted to select multiple values for single-select field";
      return r = e.call(this, n) || this, r;
    }
    return t;
  })(Error)
), sR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = this, o = "No /DA (default appearance) entry found for field: " + r;
      return n = e.call(this, o) || this, n;
    }
    return t;
  })(Error)
), cR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = this, o = "No Tf operator found for DA of field: " + r;
      return n = e.call(this, o) || this, n;
    }
    return t;
  })(Error)
), gf = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = this, i = "Failed to parse number " + ("(line:" + r.line + " col:" + r.column + " offset=" + r.offset + '): "' + n + '"');
      return o = e.call(this, i) || this, o;
    }
    return t;
  })(Error)
), On = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = this, i = "Failed to parse PDF document " + ("(line:" + r.line + " col:" + r.column + " offset=" + r.offset + "): " + n);
      return o = e.call(this, i) || this, o;
    }
    return t;
  })(Error)
), lR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      var i = this, a = "Expected next byte to be " + n + " but it was actually " + o;
      return i = e.call(this, r, a) || this, i;
    }
    return t;
  })(On)
), uR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = this, i = "Failed to parse PDF object starting with the following byte: " + n;
      return o = e.call(this, r, i) || this, o;
    }
    return t;
  })(On)
), dR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = this, o = "Failed to parse invalid PDF object";
      return n = e.call(this, r, o) || this, n;
    }
    return t;
  })(On)
), fR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = this, o = "Failed to parse PDF stream";
      return n = e.call(this, r, o) || this, n;
    }
    return t;
  })(On)
), hR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = this, o = "Failed to parse PDF literal string due to unbalanced parenthesis";
      return n = e.call(this, r, o) || this, n;
    }
    return t;
  })(On)
), vR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = this, o = "Parser stalled";
      return n = e.call(this, r, o) || this, n;
    }
    return t;
  })(On)
), pR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = this, o = "No PDF header found";
      return n = e.call(this, r, o) || this, n;
    }
    return t;
  })(On)
), gR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = this, i = "Did not find expected keyword '" + Mg(n) + "'";
      return o = e.call(this, r, i) || this, o;
    }
    return t;
  })(On)
), rl;
(function(e) {
  e[e.Null = 0] = "Null", e[e.Backspace = 8] = "Backspace", e[e.Tab = 9] = "Tab", e[e.Newline = 10] = "Newline", e[e.FormFeed = 12] = "FormFeed", e[e.CarriageReturn = 13] = "CarriageReturn", e[e.Space = 32] = "Space", e[e.ExclamationPoint = 33] = "ExclamationPoint", e[e.Hash = 35] = "Hash", e[e.Percent = 37] = "Percent", e[e.LeftParen = 40] = "LeftParen", e[e.RightParen = 41] = "RightParen", e[e.Plus = 43] = "Plus", e[e.Minus = 45] = "Minus", e[e.Dash = 45] = "Dash", e[e.Period = 46] = "Period", e[e.ForwardSlash = 47] = "ForwardSlash", e[e.Zero = 48] = "Zero", e[e.One = 49] = "One", e[e.Two = 50] = "Two", e[e.Three = 51] = "Three", e[e.Four = 52] = "Four", e[e.Five = 53] = "Five", e[e.Six = 54] = "Six", e[e.Seven = 55] = "Seven", e[e.Eight = 56] = "Eight", e[e.Nine = 57] = "Nine", e[e.LessThan = 60] = "LessThan", e[e.GreaterThan = 62] = "GreaterThan", e[e.A = 65] = "A", e[e.D = 68] = "D", e[e.E = 69] = "E", e[e.F = 70] = "F", e[e.O = 79] = "O", e[e.P = 80] = "P", e[e.R = 82] = "R", e[e.LeftSquareBracket = 91] = "LeftSquareBracket", e[e.BackSlash = 92] = "BackSlash", e[e.RightSquareBracket = 93] = "RightSquareBracket", e[e.a = 97] = "a", e[e.b = 98] = "b", e[e.d = 100] = "d", e[e.e = 101] = "e", e[e.f = 102] = "f", e[e.i = 105] = "i", e[e.j = 106] = "j", e[e.l = 108] = "l", e[e.m = 109] = "m", e[e.n = 110] = "n", e[e.o = 111] = "o", e[e.r = 114] = "r", e[e.s = 115] = "s", e[e.t = 116] = "t", e[e.u = 117] = "u", e[e.x = 120] = "x", e[e.LeftCurly = 123] = "LeftCurly", e[e.RightCurly = 125] = "RightCurly", e[e.Tilde = 126] = "Tilde";
})(rl || (rl = {}));
const T = rl;
var Ds = (
  /** @class */
  (function() {
    function e(t, r) {
      this.major = String(t), this.minor = String(r);
    }
    return e.prototype.toString = function() {
      var t = zr(129);
      return "%PDF-" + this.major + "." + this.minor + `
%` + t + t + t + t;
    }, e.prototype.sizeInBytes = function() {
      return 12 + this.major.length + this.minor.length;
    }, e.prototype.copyBytesInto = function(t, r) {
      var n = r;
      return t[r++] = T.Percent, t[r++] = T.P, t[r++] = T.D, t[r++] = T.F, t[r++] = T.Dash, r += Pt(this.major, t, r), t[r++] = T.Period, r += Pt(this.minor, t, r), t[r++] = T.Newline, t[r++] = T.Percent, t[r++] = 129, t[r++] = 129, t[r++] = 129, t[r++] = 129, r - n;
    }, e.forVersion = function(t, r) {
      return new e(t, r);
    }, e;
  })()
), It = (
  /** @class */
  (function() {
    function e() {
    }
    return e.prototype.clone = function(t) {
      throw new tr(this.constructor.name, "clone");
    }, e.prototype.toString = function() {
      throw new tr(this.constructor.name, "toString");
    }, e.prototype.sizeInBytes = function() {
      throw new tr(this.constructor.name, "sizeInBytes");
    }, e.prototype.copyBytesInto = function(t, r) {
      throw new tr(this.constructor.name, "copyBytesInto");
    }, e;
  })()
), we = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = e.call(this) || this;
      return n.numberValue = r, n.stringValue = pD(r), n;
    }
    return t.prototype.asNumber = function() {
      return this.numberValue;
    }, t.prototype.value = function() {
      return this.numberValue;
    }, t.prototype.clone = function() {
      return t.of(this.numberValue);
    }, t.prototype.toString = function() {
      return this.stringValue;
    }, t.prototype.sizeInBytes = function() {
      return this.stringValue.length;
    }, t.prototype.copyBytesInto = function(r, n) {
      return n += Pt(this.stringValue, r, n), this.stringValue.length;
    }, t.of = function(r) {
      return new t(r);
    }, t;
  })(It)
), _e = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = e.call(this) || this;
      return n.array = [], n.context = r, n;
    }
    return t.prototype.size = function() {
      return this.array.length;
    }, t.prototype.push = function(r) {
      this.array.push(r);
    }, t.prototype.insert = function(r, n) {
      this.array.splice(r, 0, n);
    }, t.prototype.indexOf = function(r) {
      var n = this.array.indexOf(r);
      return n === -1 ? void 0 : n;
    }, t.prototype.remove = function(r) {
      this.array.splice(r, 1);
    }, t.prototype.set = function(r, n) {
      this.array[r] = n;
    }, t.prototype.get = function(r) {
      return this.array[r];
    }, t.prototype.lookupMaybe = function(r) {
      for (var n, o = [], i = 1; i < arguments.length; i++)
        o[i - 1] = arguments[i];
      return (n = this.context).lookupMaybe.apply(n, Ge([this.get(r)], o));
    }, t.prototype.lookup = function(r) {
      for (var n, o = [], i = 1; i < arguments.length; i++)
        o[i - 1] = arguments[i];
      return (n = this.context).lookup.apply(n, Ge([this.get(r)], o));
    }, t.prototype.asRectangle = function() {
      if (this.size() !== 4)
        throw new iR(this.size());
      var r = this.lookup(0, we).asNumber(), n = this.lookup(1, we).asNumber(), o = this.lookup(2, we).asNumber(), i = this.lookup(3, we).asNumber(), a = r, s = n, c = o - r, l = i - n;
      return { x: a, y: s, width: c, height: l };
    }, t.prototype.asArray = function() {
      return this.array.slice();
    }, t.prototype.clone = function(r) {
      for (var n = t.withContext(r || this.context), o = 0, i = this.size(); o < i; o++)
        n.push(this.array[o]);
      return n;
    }, t.prototype.toString = function() {
      for (var r = "[ ", n = 0, o = this.size(); n < o; n++)
        r += this.get(n).toString(), r += " ";
      return r += "]", r;
    }, t.prototype.sizeInBytes = function() {
      for (var r = 3, n = 0, o = this.size(); n < o; n++)
        r += this.get(n).sizeInBytes() + 1;
      return r;
    }, t.prototype.copyBytesInto = function(r, n) {
      var o = n;
      r[n++] = T.LeftSquareBracket, r[n++] = T.Space;
      for (var i = 0, a = this.size(); i < a; i++)
        n += this.get(i).copyBytesInto(r, n), r[n++] = T.Space;
      return r[n++] = T.RightSquareBracket, n - o;
    }, t.prototype.scalePDFNumbers = function(r, n) {
      for (var o = 0, i = this.size(); o < i; o++) {
        var a = this.lookup(o);
        if (a instanceof we) {
          var s = o % 2 === 0 ? r : n;
          this.set(o, we.of(a.asNumber() * s));
        }
      }
    }, t.withContext = function(r) {
      return new t(r);
    }, t;
  })(It)
), Cc = {}, bi = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = this;
      if (r !== Cc)
        throw new xu("PDFBool");
      return o = e.call(this) || this, o.value = n, o;
    }
    return t.prototype.asBoolean = function() {
      return this.value;
    }, t.prototype.clone = function() {
      return this;
    }, t.prototype.toString = function() {
      return String(this.value);
    }, t.prototype.sizeInBytes = function() {
      return this.value ? 4 : 5;
    }, t.prototype.copyBytesInto = function(r, n) {
      return this.value ? (r[n++] = T.t, r[n++] = T.r, r[n++] = T.u, r[n++] = T.e, 4) : (r[n++] = T.f, r[n++] = T.a, r[n++] = T.l, r[n++] = T.s, r[n++] = T.e, 5);
    }, t.True = new t(Cc, !0), t.False = new t(Cc, !1), t;
  })(It)
), cr = new Uint8Array(256);
cr[T.LeftParen] = 1;
cr[T.RightParen] = 1;
cr[T.LessThan] = 1;
cr[T.GreaterThan] = 1;
cr[T.LeftSquareBracket] = 1;
cr[T.RightSquareBracket] = 1;
cr[T.LeftCurly] = 1;
cr[T.RightCurly] = 1;
cr[T.ForwardSlash] = 1;
cr[T.Percent] = 1;
var Yr = new Uint8Array(256);
Yr[T.Null] = 1;
Yr[T.Tab] = 1;
Yr[T.Newline] = 1;
Yr[T.FormFeed] = 1;
Yr[T.CarriageReturn] = 1;
Yr[T.Space] = 1;
var Pu = new Uint8Array(256);
for (var Ko = 0, mR = 256; Ko < mR; Ko++)
  Pu[Ko] = Yr[Ko] || cr[Ko] ? 1 : 0;
Pu[T.Hash] = 1;
var yR = function(e) {
  return e.replace(/#([\dABCDEF]{2})/g, function(t, r) {
    return ZF(r);
  });
}, bR = function(e) {
  return e >= T.ExclamationPoint && e <= T.Tilde && !Pu[e];
}, mf = {}, yf = /* @__PURE__ */ new Map(), F = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = this;
      if (r !== mf)
        throw new xu("PDFName");
      o = e.call(this) || this;
      for (var i = "/", a = 0, s = n.length; a < s; a++) {
        var c = n[a], l = Ce(c);
        i += bR(l) ? c : "#" + Ps(l);
      }
      return o.encodedName = i, o;
    }
    return t.prototype.asBytes = function() {
      for (var r = [], n = "", o = !1, i = function(d) {
        d !== void 0 && r.push(d), o = !1;
      }, a = 1, s = this.encodedName.length; a < s; a++) {
        var c = this.encodedName[a], l = Ce(c), u = this.encodedName[a + 1];
        o ? l >= T.Zero && l <= T.Nine || l >= T.a && l <= T.f || l >= T.A && l <= T.F ? (n += c, (n.length === 2 || !(u >= "0" && u <= "9" || u >= "a" && u <= "f" || u >= "A" && u <= "F")) && (i(parseInt(n, 16)), n = "")) : i(l) : l === T.Hash ? o = !0 : i(l);
      }
      return new Uint8Array(r);
    }, t.prototype.decodeText = function() {
      var r = this.asBytes();
      return String.fromCharCode.apply(String, Array.from(r));
    }, t.prototype.asString = function() {
      return this.encodedName;
    }, t.prototype.value = function() {
      return this.encodedName;
    }, t.prototype.clone = function() {
      return this;
    }, t.prototype.toString = function() {
      return this.encodedName;
    }, t.prototype.sizeInBytes = function() {
      return this.encodedName.length;
    }, t.prototype.copyBytesInto = function(r, n) {
      return n += Pt(this.encodedName, r, n), this.encodedName.length;
    }, t.of = function(r) {
      var n = yR(r), o = yf.get(n);
      return o || (o = new t(mf, n), yf.set(n, o)), o;
    }, t.Length = t.of("Length"), t.FlateDecode = t.of("FlateDecode"), t.Resources = t.of("Resources"), t.Font = t.of("Font"), t.XObject = t.of("XObject"), t.ExtGState = t.of("ExtGState"), t.Contents = t.of("Contents"), t.Type = t.of("Type"), t.Parent = t.of("Parent"), t.MediaBox = t.of("MediaBox"), t.Page = t.of("Page"), t.Annots = t.of("Annots"), t.TrimBox = t.of("TrimBox"), t.ArtBox = t.of("ArtBox"), t.BleedBox = t.of("BleedBox"), t.CropBox = t.of("CropBox"), t.Rotate = t.of("Rotate"), t.Title = t.of("Title"), t.Author = t.of("Author"), t.Subject = t.of("Subject"), t.Creator = t.of("Creator"), t.Keywords = t.of("Keywords"), t.Producer = t.of("Producer"), t.CreationDate = t.of("CreationDate"), t.ModDate = t.of("ModDate"), t;
  })(It)
), wR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.asNull = function() {
      return null;
    }, t.prototype.clone = function() {
      return this;
    }, t.prototype.toString = function() {
      return "null";
    }, t.prototype.sizeInBytes = function() {
      return 4;
    }, t.prototype.copyBytesInto = function(r, n) {
      return r[n++] = T.n, r[n++] = T.u, r[n++] = T.l, r[n++] = T.l, 4;
    }, t;
  })(It)
);
const Wt = new wR();
var De = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = e.call(this) || this;
      return o.dict = r, o.context = n, o;
    }
    return t.prototype.keys = function() {
      return Array.from(this.dict.keys());
    }, t.prototype.values = function() {
      return Array.from(this.dict.values());
    }, t.prototype.entries = function() {
      return Array.from(this.dict.entries());
    }, t.prototype.set = function(r, n) {
      this.dict.set(r, n);
    }, t.prototype.get = function(r, n) {
      n === void 0 && (n = !1);
      var o = this.dict.get(r);
      if (!(o === Wt && !n))
        return o;
    }, t.prototype.has = function(r) {
      var n = this.dict.get(r);
      return n !== void 0 && n !== Wt;
    }, t.prototype.lookupMaybe = function(r) {
      for (var n, o = [], i = 1; i < arguments.length; i++)
        o[i - 1] = arguments[i];
      var a = o.includes(Wt), s = (n = this.context).lookupMaybe.apply(n, Ge([this.get(r, a)], o));
      if (!(s === Wt && !a))
        return s;
    }, t.prototype.lookup = function(r) {
      for (var n, o = [], i = 1; i < arguments.length; i++)
        o[i - 1] = arguments[i];
      var a = o.includes(Wt), s = (n = this.context).lookup.apply(n, Ge([this.get(r, a)], o));
      if (!(s === Wt && !a))
        return s;
    }, t.prototype.delete = function(r) {
      return this.dict.delete(r);
    }, t.prototype.asMap = function() {
      return new Map(this.dict);
    }, t.prototype.uniqueKey = function(r) {
      r === void 0 && (r = "");
      for (var n = this.keys(), o = F.of(this.context.addRandomSuffix(r, 10)); n.includes(o); )
        o = F.of(this.context.addRandomSuffix(r, 10));
      return o;
    }, t.prototype.clone = function(r) {
      for (var n = t.withContext(r || this.context), o = this.entries(), i = 0, a = o.length; i < a; i++) {
        var s = o[i], c = s[0], l = s[1];
        n.set(c, l);
      }
      return n;
    }, t.prototype.toString = function() {
      for (var r = `<<
`, n = this.entries(), o = 0, i = n.length; o < i; o++) {
        var a = n[o], s = a[0], c = a[1];
        r += s.toString() + " " + c.toString() + `
`;
      }
      return r += ">>", r;
    }, t.prototype.sizeInBytes = function() {
      for (var r = 5, n = this.entries(), o = 0, i = n.length; o < i; o++) {
        var a = n[o], s = a[0], c = a[1];
        r += s.sizeInBytes() + c.sizeInBytes() + 2;
      }
      return r;
    }, t.prototype.copyBytesInto = function(r, n) {
      var o = n;
      r[n++] = T.LessThan, r[n++] = T.LessThan, r[n++] = T.Newline;
      for (var i = this.entries(), a = 0, s = i.length; a < s; a++) {
        var c = i[a], l = c[0], u = c[1];
        n += l.copyBytesInto(r, n), r[n++] = T.Space, n += u.copyBytesInto(r, n), r[n++] = T.Newline;
      }
      return r[n++] = T.GreaterThan, r[n++] = T.GreaterThan, n - o;
    }, t.withContext = function(r) {
      return new t(/* @__PURE__ */ new Map(), r);
    }, t.fromMapWithContext = function(r, n) {
      return new t(r, n);
    }, t;
  })(It)
), Gt = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = e.call(this) || this;
      return n.dict = r, n;
    }
    return t.prototype.clone = function(r) {
      throw new tr(this.constructor.name, "clone");
    }, t.prototype.getContentsString = function() {
      throw new tr(this.constructor.name, "getContentsString");
    }, t.prototype.getContents = function() {
      throw new tr(this.constructor.name, "getContents");
    }, t.prototype.getContentsSize = function() {
      throw new tr(this.constructor.name, "getContentsSize");
    }, t.prototype.updateDict = function() {
      var r = this.getContentsSize();
      this.dict.set(F.Length, we.of(r));
    }, t.prototype.sizeInBytes = function() {
      return this.updateDict(), this.dict.sizeInBytes() + this.getContentsSize() + 18;
    }, t.prototype.toString = function() {
      this.updateDict();
      var r = this.dict.toString();
      return r += `
stream
`, r += this.getContentsString(), r += `
endstream`, r;
    }, t.prototype.copyBytesInto = function(r, n) {
      this.updateDict();
      var o = n;
      n += this.dict.copyBytesInto(r, n), r[n++] = T.Newline, r[n++] = T.s, r[n++] = T.t, r[n++] = T.r, r[n++] = T.e, r[n++] = T.a, r[n++] = T.m, r[n++] = T.Newline;
      for (var i = this.getContents(), a = 0, s = i.length; a < s; a++)
        r[n++] = i[a];
      return r[n++] = T.Newline, r[n++] = T.e, r[n++] = T.n, r[n++] = T.d, r[n++] = T.s, r[n++] = T.t, r[n++] = T.r, r[n++] = T.e, r[n++] = T.a, r[n++] = T.m, n - o;
    }, t;
  })(It)
), wi = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = e.call(this, r) || this;
      return o.contents = n, o;
    }
    return t.prototype.asUint8Array = function() {
      return this.contents.slice();
    }, t.prototype.clone = function(r) {
      return t.of(this.dict.clone(r), this.contents.slice());
    }, t.prototype.getContentsString = function() {
      return Mg(this.contents);
    }, t.prototype.getContents = function() {
      return this.contents;
    }, t.prototype.getContentsSize = function() {
      return this.contents.length;
    }, t.of = function(r, n) {
      return new t(r, n);
    }, t;
  })(Gt)
), bf = {}, wf = /* @__PURE__ */ new Map(), et = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      var i = this;
      if (r !== bf)
        throw new xu("PDFRef");
      return i = e.call(this) || this, i.objectNumber = n, i.generationNumber = o, i.tag = n + " " + o + " R", i;
    }
    return t.prototype.clone = function() {
      return this;
    }, t.prototype.toString = function() {
      return this.tag;
    }, t.prototype.sizeInBytes = function() {
      return this.tag.length;
    }, t.prototype.copyBytesInto = function(r, n) {
      return n += Pt(this.tag, r, n), this.tag.length;
    }, t.of = function(r, n) {
      n === void 0 && (n = 0);
      var o = r + " " + n + " R", i = wf.get(o);
      return i || (i = new t(bf, r, n), wf.set(o, i)), i;
    }, t;
  })(It)
), He = (
  /** @class */
  (function() {
    function e(t, r) {
      this.name = t, this.args = r || [];
    }
    return e.prototype.clone = function(t) {
      for (var r = new Array(this.args.length), n = 0, o = r.length; n < o; n++) {
        var i = this.args[n];
        r[n] = i instanceof It ? i.clone(t) : i;
      }
      return e.of(this.name, r);
    }, e.prototype.toString = function() {
      for (var t = "", r = 0, n = this.args.length; r < n; r++)
        t += String(this.args[r]) + " ";
      return t += this.name, t;
    }, e.prototype.sizeInBytes = function() {
      for (var t = 0, r = 0, n = this.args.length; r < n; r++) {
        var o = this.args[r];
        t += (o instanceof It ? o.sizeInBytes() : o.length) + 1;
      }
      return t += this.name.length, t;
    }, e.prototype.copyBytesInto = function(t, r) {
      for (var n = r, o = 0, i = this.args.length; o < i; o++) {
        var a = this.args[o];
        a instanceof It ? r += a.copyBytesInto(t, r) : r += Pt(a, t, r), t[r++] = T.Space;
      }
      return r += Pt(this.name, t, r), r - n;
    }, e.of = function(t, r) {
      return new e(t, r);
    }, e;
  })()
), nl;
(function(e) {
  e.NonStrokingColor = "sc", e.NonStrokingColorN = "scn", e.NonStrokingColorRgb = "rg", e.NonStrokingColorGray = "g", e.NonStrokingColorCmyk = "k", e.NonStrokingColorspace = "cs", e.StrokingColor = "SC", e.StrokingColorN = "SCN", e.StrokingColorRgb = "RG", e.StrokingColorGray = "G", e.StrokingColorCmyk = "K", e.StrokingColorspace = "CS", e.BeginMarkedContentSequence = "BDC", e.BeginMarkedContent = "BMC", e.EndMarkedContent = "EMC", e.MarkedContentPointWithProps = "DP", e.MarkedContentPoint = "MP", e.DrawObject = "Do", e.ConcatTransformationMatrix = "cm", e.PopGraphicsState = "Q", e.PushGraphicsState = "q", e.SetFlatness = "i", e.SetGraphicsStateParams = "gs", e.SetLineCapStyle = "J", e.SetLineDashPattern = "d", e.SetLineJoinStyle = "j", e.SetLineMiterLimit = "M", e.SetLineWidth = "w", e.SetTextMatrix = "Tm", e.SetRenderingIntent = "ri", e.AppendRectangle = "re", e.BeginInlineImage = "BI", e.BeginInlineImageData = "ID", e.EndInlineImage = "EI", e.ClipEvenOdd = "W*", e.ClipNonZero = "W", e.CloseAndStroke = "s", e.CloseFillEvenOddAndStroke = "b*", e.CloseFillNonZeroAndStroke = "b", e.ClosePath = "h", e.AppendBezierCurve = "c", e.CurveToReplicateFinalPoint = "y", e.CurveToReplicateInitialPoint = "v", e.EndPath = "n", e.FillEvenOddAndStroke = "B*", e.FillEvenOdd = "f*", e.FillNonZeroAndStroke = "B", e.FillNonZero = "f", e.LegacyFillNonZero = "F", e.LineTo = "l", e.MoveTo = "m", e.ShadingFill = "sh", e.StrokePath = "S", e.BeginText = "BT", e.EndText = "ET", e.MoveText = "Td", e.MoveTextSetLeading = "TD", e.NextLine = "T*", e.SetCharacterSpacing = "Tc", e.SetFontAndSize = "Tf", e.SetTextHorizontalScaling = "Tz", e.SetTextLineHeight = "TL", e.SetTextRenderingMode = "Tr", e.SetTextRise = "Ts", e.SetWordSpacing = "Tw", e.ShowText = "Tj", e.ShowTextAdjusted = "TJ", e.ShowTextLine = "'", e.ShowTextLineAndSpace = '"', e.Type3D0 = "d0", e.Type3D1 = "d1", e.BeginCompatibilitySection = "BX", e.EndCompatibilitySection = "EX";
})(nl || (nl = {}));
const Ke = nl;
var Eu = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = e.call(this, r) || this;
      return o.computeContents = function() {
        var i = o.getUnencodedContents();
        return o.encode ? Es.deflate(i) : i;
      }, o.encode = n, n && r.set(F.of("Filter"), F.of("FlateDecode")), o.contentsCache = jr.populatedBy(o.computeContents), o;
    }
    return t.prototype.getContents = function() {
      return this.contentsCache.access();
    }, t.prototype.getContentsSize = function() {
      return this.contentsCache.access().length;
    }, t.prototype.getUnencodedContents = function() {
      throw new tr(this.constructor.name, "getUnencodedContents");
    }, t;
  })(Gt)
), si = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      o === void 0 && (o = !0);
      var i = e.call(this, r, o) || this;
      return i.operators = n, i;
    }
    return t.prototype.push = function() {
      for (var r, n = [], o = 0; o < arguments.length; o++)
        n[o] = arguments[o];
      (r = this.operators).push.apply(r, n);
    }, t.prototype.clone = function(r) {
      for (var n = new Array(this.operators.length), o = 0, i = this.operators.length; o < i; o++)
        n[o] = this.operators[o].clone(r);
      var a = this, s = a.dict, c = a.encode;
      return t.of(s.clone(r), n, c);
    }, t.prototype.getContentsString = function() {
      for (var r = "", n = 0, o = this.operators.length; n < o; n++)
        r += this.operators[n] + `
`;
      return r;
    }, t.prototype.getUnencodedContents = function() {
      for (var r = new Uint8Array(this.getUnencodedContentsSize()), n = 0, o = 0, i = this.operators.length; o < i; o++)
        n += this.operators[o].copyBytesInto(r, n), r[n++] = T.Newline;
      return r;
    }, t.prototype.getUnencodedContentsSize = function() {
      for (var r = 0, n = 0, o = this.operators.length; n < o; n++)
        r += this.operators[n].sizeInBytes() + 1;
      return r;
    }, t.of = function(r, n, o) {
      return o === void 0 && (o = !0), new t(r, n, o);
    }, t;
  })(Eu)
), xR = (
  /** @class */
  (function() {
    function e(t) {
      this.seed = t;
    }
    return e.prototype.nextInt = function() {
      var t = Math.sin(this.seed++) * 1e4;
      return t - Math.floor(t);
    }, e.withSeed = function(t) {
      return new e(t);
    }, e;
  })()
), CR = function(e, t) {
  var r = e[0], n = t[0];
  return r.objectNumber - n.objectNumber;
}, ol = (
  /** @class */
  (function() {
    function e() {
      this.largestObjectNumber = 0, this.header = Ds.forVersion(1, 7), this.trailerInfo = {}, this.indirectObjects = /* @__PURE__ */ new Map(), this.rng = xR.withSeed(1);
    }
    return e.prototype.assign = function(t, r) {
      this.indirectObjects.set(t, r), t.objectNumber > this.largestObjectNumber && (this.largestObjectNumber = t.objectNumber);
    }, e.prototype.nextRef = function() {
      return this.largestObjectNumber += 1, et.of(this.largestObjectNumber);
    }, e.prototype.register = function(t) {
      var r = this.nextRef();
      return this.assign(r, t), r;
    }, e.prototype.delete = function(t) {
      return this.indirectObjects.delete(t);
    }, e.prototype.lookupMaybe = function(t) {
      for (var r = [], n = 1; n < arguments.length; n++)
        r[n - 1] = arguments[n];
      var o = r.includes(Wt), i = t instanceof et ? this.indirectObjects.get(t) : t;
      if (!(!i || i === Wt && !o)) {
        for (var a = 0, s = r.length; a < s; a++) {
          var c = r[a];
          if (c === Wt) {
            if (i === Wt)
              return i;
          } else if (i instanceof c)
            return i;
        }
        throw new za(r, i);
      }
    }, e.prototype.lookup = function(t) {
      for (var r = [], n = 1; n < arguments.length; n++)
        r[n - 1] = arguments[n];
      var o = t instanceof et ? this.indirectObjects.get(t) : t;
      if (r.length === 0)
        return o;
      for (var i = 0, a = r.length; i < a; i++) {
        var s = r[i];
        if (s === Wt) {
          if (o === Wt)
            return o;
        } else if (o instanceof s)
          return o;
      }
      throw new za(r, o);
    }, e.prototype.getObjectRef = function(t) {
      for (var r = Array.from(this.indirectObjects.entries()), n = 0, o = r.length; n < o; n++) {
        var i = r[n], a = i[0], s = i[1];
        if (s === t)
          return a;
      }
    }, e.prototype.enumerateIndirectObjects = function() {
      return Array.from(this.indirectObjects.entries()).sort(CR);
    }, e.prototype.obj = function(t) {
      if (t instanceof It)
        return t;
      if (t == null)
        return Wt;
      if (typeof t == "string")
        return F.of(t);
      if (typeof t == "number")
        return we.of(t);
      if (typeof t == "boolean")
        return t ? bi.True : bi.False;
      if (Array.isArray(t)) {
        for (var r = _e.withContext(this), n = 0, o = t.length; n < o; n++)
          r.push(this.obj(t[n]));
        return r;
      } else {
        for (var i = De.withContext(this), a = Object.keys(t), n = 0, o = a.length; n < o; n++) {
          var s = a[n], c = t[s];
          c !== void 0 && i.set(F.of(s), this.obj(c));
        }
        return i;
      }
    }, e.prototype.stream = function(t, r) {
      return r === void 0 && (r = {}), wi.of(this.obj(r), tl(t));
    }, e.prototype.flateStream = function(t, r) {
      return r === void 0 && (r = {}), this.stream(Es.deflate(tl(t)), Se(Se({}, r), { Filter: "FlateDecode" }));
    }, e.prototype.contentStream = function(t, r) {
      return r === void 0 && (r = {}), si.of(this.obj(r), t);
    }, e.prototype.formXObject = function(t, r) {
      return r === void 0 && (r = {}), this.contentStream(t, Se(Se({ BBox: this.obj([0, 0, 0, 0]), Matrix: this.obj([1, 0, 0, 1, 0, 0]) }, r), { Type: "XObject", Subtype: "Form" }));
    }, e.prototype.getPushGraphicsStateContentStream = function() {
      if (this.pushGraphicsStateContentStreamRef)
        return this.pushGraphicsStateContentStreamRef;
      var t = this.obj({}), r = He.of(Ke.PushGraphicsState), n = si.of(t, [r]);
      return this.pushGraphicsStateContentStreamRef = this.register(n), this.pushGraphicsStateContentStreamRef;
    }, e.prototype.getPopGraphicsStateContentStream = function() {
      if (this.popGraphicsStateContentStreamRef)
        return this.popGraphicsStateContentStreamRef;
      var t = this.obj({}), r = He.of(Ke.PopGraphicsState), n = si.of(t, [r]);
      return this.popGraphicsStateContentStreamRef = this.register(n), this.popGraphicsStateContentStreamRef;
    }, e.prototype.addRandomSuffix = function(t, r) {
      return r === void 0 && (r = 4), t + "-" + Math.floor(this.rng.nextInt() * Math.pow(10, r));
    }, e.create = function() {
      return new e();
    }, e;
  })()
), Ur = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      o === void 0 && (o = !0);
      var i = e.call(this, r, n) || this;
      return i.normalized = !1, i.autoNormalizeCTM = o, i;
    }
    return t.prototype.clone = function(r) {
      for (var n = t.fromMapWithContext(/* @__PURE__ */ new Map(), r || this.context, this.autoNormalizeCTM), o = this.entries(), i = 0, a = o.length; i < a; i++) {
        var s = o[i], c = s[0], l = s[1];
        n.set(c, l);
      }
      return n;
    }, t.prototype.Parent = function() {
      return this.lookupMaybe(F.Parent, De);
    }, t.prototype.Contents = function() {
      return this.lookup(F.of("Contents"));
    }, t.prototype.Annots = function() {
      return this.lookupMaybe(F.Annots, _e);
    }, t.prototype.BleedBox = function() {
      return this.lookupMaybe(F.BleedBox, _e);
    }, t.prototype.TrimBox = function() {
      return this.lookupMaybe(F.TrimBox, _e);
    }, t.prototype.ArtBox = function() {
      return this.lookupMaybe(F.ArtBox, _e);
    }, t.prototype.Resources = function() {
      var r = this.getInheritableAttribute(F.Resources);
      return this.context.lookupMaybe(r, De);
    }, t.prototype.MediaBox = function() {
      var r = this.getInheritableAttribute(F.MediaBox);
      return this.context.lookup(r, _e);
    }, t.prototype.CropBox = function() {
      var r = this.getInheritableAttribute(F.CropBox);
      return this.context.lookupMaybe(r, _e);
    }, t.prototype.Rotate = function() {
      var r = this.getInheritableAttribute(F.Rotate);
      return this.context.lookupMaybe(r, we);
    }, t.prototype.getInheritableAttribute = function(r) {
      var n;
      return this.ascend(function(o) {
        n || (n = o.get(r));
      }), n;
    }, t.prototype.setParent = function(r) {
      this.set(F.Parent, r);
    }, t.prototype.addContentStream = function(r) {
      var n = this.normalizedEntries().Contents || this.context.obj([]);
      this.set(F.Contents, n), n.push(r);
    }, t.prototype.wrapContentStreams = function(r, n) {
      var o = this.Contents();
      return o instanceof _e ? (o.insert(0, r), o.push(n), !0) : !1;
    }, t.prototype.addAnnot = function(r) {
      var n = this.normalizedEntries().Annots;
      n.push(r);
    }, t.prototype.removeAnnot = function(r) {
      var n = this.normalizedEntries().Annots, o = n.indexOf(r);
      o !== void 0 && n.remove(o);
    }, t.prototype.setFontDictionary = function(r, n) {
      var o = this.normalizedEntries().Font;
      o.set(r, n);
    }, t.prototype.newFontDictionaryKey = function(r) {
      var n = this.normalizedEntries().Font;
      return n.uniqueKey(r);
    }, t.prototype.newFontDictionary = function(r, n) {
      var o = this.newFontDictionaryKey(r);
      return this.setFontDictionary(o, n), o;
    }, t.prototype.setXObject = function(r, n) {
      var o = this.normalizedEntries().XObject;
      o.set(r, n);
    }, t.prototype.newXObjectKey = function(r) {
      var n = this.normalizedEntries().XObject;
      return n.uniqueKey(r);
    }, t.prototype.newXObject = function(r, n) {
      var o = this.newXObjectKey(r);
      return this.setXObject(o, n), o;
    }, t.prototype.setExtGState = function(r, n) {
      var o = this.normalizedEntries().ExtGState;
      o.set(r, n);
    }, t.prototype.newExtGStateKey = function(r) {
      var n = this.normalizedEntries().ExtGState;
      return n.uniqueKey(r);
    }, t.prototype.newExtGState = function(r, n) {
      var o = this.newExtGStateKey(r);
      return this.setExtGState(o, n), o;
    }, t.prototype.ascend = function(r) {
      r(this);
      var n = this.Parent();
      n && n.ascend(r);
    }, t.prototype.normalize = function() {
      if (!this.normalized) {
        var r = this.context, n = this.get(F.Contents), o = this.context.lookup(n);
        o instanceof Gt && this.set(F.Contents, r.obj([n])), this.autoNormalizeCTM && this.wrapContentStreams(this.context.getPushGraphicsStateContentStream(), this.context.getPopGraphicsStateContentStream());
        var i = this.getInheritableAttribute(F.Resources), a = r.lookupMaybe(i, De) || r.obj({});
        this.set(F.Resources, a);
        var s = a.lookupMaybe(F.Font, De) || r.obj({});
        a.set(F.Font, s);
        var c = a.lookupMaybe(F.XObject, De) || r.obj({});
        a.set(F.XObject, c);
        var l = a.lookupMaybe(F.ExtGState, De) || r.obj({});
        a.set(F.ExtGState, l);
        var u = this.Annots() || r.obj([]);
        this.set(F.Annots, u), this.normalized = !0;
      }
    }, t.prototype.normalizedEntries = function() {
      this.normalize();
      var r = this.Annots(), n = this.Resources(), o = this.Contents();
      return {
        Annots: r,
        Resources: n,
        Contents: o,
        Font: n.lookup(F.Font, De),
        XObject: n.lookup(F.XObject, De),
        ExtGState: n.lookup(F.ExtGState, De)
      };
    }, t.InheritableEntries = [
      "Resources",
      "MediaBox",
      "CropBox",
      "Rotate"
    ], t.withContextAndParent = function(r, n) {
      var o = /* @__PURE__ */ new Map();
      return o.set(F.Type, F.Page), o.set(F.Parent, n), o.set(F.Resources, r.obj({})), o.set(F.MediaBox, r.obj([0, 0, 612, 792])), new t(o, r, !1);
    }, t.fromMapWithContext = function(r, n, o) {
      return o === void 0 && (o = !0), new t(r, n, o);
    }, t;
  })(De)
), xf = (
  /** @class */
  (function() {
    function e(t, r) {
      var n = this;
      this.traversedObjects = /* @__PURE__ */ new Map(), this.copy = function(o) {
        return o instanceof Ur ? n.copyPDFPage(o) : o instanceof De ? n.copyPDFDict(o) : o instanceof _e ? n.copyPDFArray(o) : o instanceof Gt ? n.copyPDFStream(o) : o instanceof et ? n.copyPDFIndirectObject(o) : o.clone();
      }, this.copyPDFPage = function(o) {
        for (var i = o.clone(), a = Ur.InheritableEntries, s = 0, c = a.length; s < c; s++) {
          var l = F.of(a[s]), u = i.getInheritableAttribute(l);
          !i.get(l) && u && i.set(l, u);
        }
        return i.delete(F.of("Parent")), n.copyPDFDict(i);
      }, this.copyPDFDict = function(o) {
        if (n.traversedObjects.has(o))
          return n.traversedObjects.get(o);
        var i = o.clone(n.dest);
        n.traversedObjects.set(o, i);
        for (var a = o.entries(), s = 0, c = a.length; s < c; s++) {
          var l = a[s], u = l[0], d = l[1];
          i.set(u, n.copy(d));
        }
        return i;
      }, this.copyPDFArray = function(o) {
        if (n.traversedObjects.has(o))
          return n.traversedObjects.get(o);
        var i = o.clone(n.dest);
        n.traversedObjects.set(o, i);
        for (var a = 0, s = o.size(); a < s; a++) {
          var c = o.get(a);
          i.set(a, n.copy(c));
        }
        return i;
      }, this.copyPDFStream = function(o) {
        if (n.traversedObjects.has(o))
          return n.traversedObjects.get(o);
        var i = o.clone(n.dest);
        n.traversedObjects.set(o, i);
        for (var a = o.dict.entries(), s = 0, c = a.length; s < c; s++) {
          var l = a[s], u = l[0], d = l[1];
          i.dict.set(u, n.copy(d));
        }
        return i;
      }, this.copyPDFIndirectObject = function(o) {
        var i = n.traversedObjects.has(o);
        if (!i) {
          var a = n.dest.nextRef();
          n.traversedObjects.set(o, a);
          var s = n.src.lookup(o);
          if (s) {
            var c = n.copy(s);
            n.dest.assign(a, c);
          }
        }
        return n.traversedObjects.get(o);
      }, this.src = t, this.dest = r;
    }
    return e.for = function(t, r) {
      return new e(t, r);
    }, e;
  })()
), Jg = (
  /** @class */
  (function() {
    function e(t) {
      this.subsections = t ? [[t]] : [], this.chunkIdx = 0, this.chunkLength = t ? 1 : 0;
    }
    return e.prototype.addEntry = function(t, r) {
      this.append({ ref: t, offset: r, deleted: !1 });
    }, e.prototype.addDeletedEntry = function(t, r) {
      this.append({ ref: t, offset: r, deleted: !0 });
    }, e.prototype.toString = function() {
      for (var t = `xref
`, r = 0, n = this.subsections.length; r < n; r++) {
        var o = this.subsections[r];
        t += o[0].ref.objectNumber + " " + o.length + `
`;
        for (var i = 0, a = o.length; i < a; i++) {
          var s = o[i];
          t += vr(String(s.offset), 10, "0"), t += " ", t += vr(String(s.ref.generationNumber), 5, "0"), t += " ", t += s.deleted ? "f" : "n", t += ` 
`;
        }
      }
      return t;
    }, e.prototype.sizeInBytes = function() {
      for (var t = 5, r = 0, n = this.subsections.length; r < n; r++) {
        var o = this.subsections[r], i = o.length, a = o[0];
        t += 2, t += String(a.ref.objectNumber).length, t += String(i).length, t += 20 * i;
      }
      return t;
    }, e.prototype.copyBytesInto = function(t, r) {
      var n = r;
      return t[r++] = T.x, t[r++] = T.r, t[r++] = T.e, t[r++] = T.f, t[r++] = T.Newline, r += this.copySubsectionsIntoBuffer(this.subsections, t, r), r - n;
    }, e.prototype.copySubsectionsIntoBuffer = function(t, r, n) {
      for (var o = n, i = t.length, a = 0; a < i; a++) {
        var s = this.subsections[a], c = String(s[0].ref.objectNumber);
        n += Pt(c, r, n), r[n++] = T.Space;
        var l = String(s.length);
        n += Pt(l, r, n), r[n++] = T.Newline, n += this.copyEntriesIntoBuffer(s, r, n);
      }
      return n - o;
    }, e.prototype.copyEntriesIntoBuffer = function(t, r, n) {
      for (var o = t.length, i = 0; i < o; i++) {
        var a = t[i], s = vr(String(a.offset), 10, "0");
        n += Pt(s, r, n), r[n++] = T.Space;
        var c = vr(String(a.ref.generationNumber), 5, "0");
        n += Pt(c, r, n), r[n++] = T.Space, r[n++] = a.deleted ? T.f : T.n, r[n++] = T.Space, r[n++] = T.Newline;
      }
      return 20 * o;
    }, e.prototype.append = function(t) {
      if (this.chunkLength === 0) {
        this.subsections.push([t]), this.chunkIdx = 0, this.chunkLength = 1;
        return;
      }
      var r = this.subsections[this.chunkIdx], n = r[this.chunkLength - 1];
      t.ref.objectNumber - n.ref.objectNumber > 1 ? (this.subsections.push([t]), this.chunkIdx += 1, this.chunkLength = 1) : (r.push(t), this.chunkLength += 1);
    }, e.create = function() {
      return new e({
        ref: et.of(0, 65535),
        offset: 0,
        deleted: !0
      });
    }, e.createEmpty = function() {
      return new e();
    }, e;
  })()
), ku = (
  /** @class */
  (function() {
    function e(t) {
      this.lastXRefOffset = String(t);
    }
    return e.prototype.toString = function() {
      return `startxref
` + this.lastXRefOffset + `
%%EOF`;
    }, e.prototype.sizeInBytes = function() {
      return 16 + this.lastXRefOffset.length;
    }, e.prototype.copyBytesInto = function(t, r) {
      var n = r;
      return t[r++] = T.s, t[r++] = T.t, t[r++] = T.a, t[r++] = T.r, t[r++] = T.t, t[r++] = T.x, t[r++] = T.r, t[r++] = T.e, t[r++] = T.f, t[r++] = T.Newline, r += Pt(this.lastXRefOffset, t, r), t[r++] = T.Newline, t[r++] = T.Percent, t[r++] = T.Percent, t[r++] = T.E, t[r++] = T.O, t[r++] = T.F, r - n;
    }, e.forLastCrossRefSectionOffset = function(t) {
      return new e(t);
    }, e;
  })()
), SR = (
  /** @class */
  (function() {
    function e(t) {
      this.dict = t;
    }
    return e.prototype.toString = function() {
      return `trailer
` + this.dict.toString();
    }, e.prototype.sizeInBytes = function() {
      return 8 + this.dict.sizeInBytes();
    }, e.prototype.copyBytesInto = function(t, r) {
      var n = r;
      return t[r++] = T.t, t[r++] = T.r, t[r++] = T.a, t[r++] = T.i, t[r++] = T.l, t[r++] = T.e, t[r++] = T.r, t[r++] = T.Newline, r += this.dict.copyBytesInto(t, r), r - n;
    }, e.of = function(t) {
      return new e(t);
    }, e;
  })()
), Qg = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      o === void 0 && (o = !0);
      var i = e.call(this, r.obj({}), o) || this;
      return i.objects = n, i.offsets = i.computeObjectOffsets(), i.offsetsString = i.computeOffsetsString(), i.dict.set(F.of("Type"), F.of("ObjStm")), i.dict.set(F.of("N"), we.of(i.objects.length)), i.dict.set(F.of("First"), we.of(i.offsetsString.length)), i;
    }
    return t.prototype.getObjectsCount = function() {
      return this.objects.length;
    }, t.prototype.clone = function(r) {
      return t.withContextAndObjects(r || this.dict.context, this.objects.slice(), this.encode);
    }, t.prototype.getContentsString = function() {
      for (var r = this.offsetsString, n = 0, o = this.objects.length; n < o; n++) {
        var i = this.objects[n], a = i[1];
        r += a + `
`;
      }
      return r;
    }, t.prototype.getUnencodedContents = function() {
      for (var r = new Uint8Array(this.getUnencodedContentsSize()), n = Pt(this.offsetsString, r, 0), o = 0, i = this.objects.length; o < i; o++) {
        var a = this.objects[o], s = a[1];
        n += s.copyBytesInto(r, n), r[n++] = T.Newline;
      }
      return r;
    }, t.prototype.getUnencodedContentsSize = function() {
      return this.offsetsString.length + Wa(this.offsets)[1] + Wa(this.objects)[1].sizeInBytes() + 1;
    }, t.prototype.computeOffsetsString = function() {
      for (var r = "", n = 0, o = this.offsets.length; n < o; n++) {
        var i = this.offsets[n], a = i[0], s = i[1];
        r += a + " " + s + " ";
      }
      return r;
    }, t.prototype.computeObjectOffsets = function() {
      for (var r = 0, n = new Array(this.objects.length), o = 0, i = this.objects.length; o < i; o++) {
        var a = this.objects[o], s = a[0], c = a[1];
        n[o] = [s.objectNumber, r], r += c.sizeInBytes() + 1;
      }
      return n;
    }, t.withContextAndObjects = function(r, n, o) {
      return o === void 0 && (o = !0), new t(r, n, o);
    }, t;
  })(Eu)
), $g = (
  /** @class */
  (function() {
    function e(t, r) {
      var n = this;
      this.parsedObjects = 0, this.shouldWaitForTick = function(o) {
        return n.parsedObjects += o, n.parsedObjects % n.objectsPerTick === 0;
      }, this.context = t, this.objectsPerTick = r;
    }
    return e.prototype.serializeToBuffer = function() {
      return Re(this, void 0, void 0, function() {
        var t, r, n, o, i, a, s, c, l, u, d, f, h, g, v, y, b;
        return Te(this, function(x) {
          switch (x.label) {
            case 0:
              return [4, this.computeBufferSize()];
            case 1:
              t = x.sent(), r = t.size, n = t.header, o = t.indirectObjects, i = t.xref, a = t.trailerDict, s = t.trailer, c = 0, l = new Uint8Array(r), c += n.copyBytesInto(l, c), l[c++] = T.Newline, l[c++] = T.Newline, u = 0, d = o.length, x.label = 2;
            case 2:
              return u < d ? (f = o[u], h = f[0], g = f[1], v = String(h.objectNumber), c += Pt(v, l, c), l[c++] = T.Space, y = String(h.generationNumber), c += Pt(y, l, c), l[c++] = T.Space, l[c++] = T.o, l[c++] = T.b, l[c++] = T.j, l[c++] = T.Newline, c += g.copyBytesInto(l, c), l[c++] = T.Newline, l[c++] = T.e, l[c++] = T.n, l[c++] = T.d, l[c++] = T.o, l[c++] = T.b, l[c++] = T.j, l[c++] = T.Newline, l[c++] = T.Newline, b = g instanceof Qg ? g.getObjectsCount() : 1, this.shouldWaitForTick(b) ? [4, Fo()] : [3, 4]) : [3, 5];
            case 3:
              x.sent(), x.label = 4;
            case 4:
              return u++, [3, 2];
            case 5:
              return i && (c += i.copyBytesInto(l, c), l[c++] = T.Newline), a && (c += a.copyBytesInto(l, c), l[c++] = T.Newline, l[c++] = T.Newline), c += s.copyBytesInto(l, c), [2, l];
          }
        });
      });
    }, e.prototype.computeIndirectObjectSize = function(t) {
      var r = t[0], n = t[1], o = r.sizeInBytes() + 3, i = n.sizeInBytes() + 9;
      return o + i;
    }, e.prototype.createTrailerDict = function() {
      return this.context.obj({
        Size: this.context.largestObjectNumber + 1,
        Root: this.context.trailerInfo.Root,
        Encrypt: this.context.trailerInfo.Encrypt,
        Info: this.context.trailerInfo.Info,
        ID: this.context.trailerInfo.ID
      });
    }, e.prototype.computeBufferSize = function() {
      return Re(this, void 0, void 0, function() {
        var t, r, n, o, i, a, s, c, l, u, d;
        return Te(this, function(f) {
          switch (f.label) {
            case 0:
              t = Ds.forVersion(1, 7), r = t.sizeInBytes() + 2, n = Jg.create(), o = this.context.enumerateIndirectObjects(), i = 0, a = o.length, f.label = 1;
            case 1:
              return i < a ? (s = o[i], c = s[0], n.addEntry(c, r), r += this.computeIndirectObjectSize(s), this.shouldWaitForTick(1) ? [4, Fo()] : [3, 3]) : [3, 4];
            case 2:
              f.sent(), f.label = 3;
            case 3:
              return i++, [3, 1];
            case 4:
              return l = r, r += n.sizeInBytes() + 1, u = SR.of(this.createTrailerDict()), r += u.sizeInBytes() + 2, d = ku.forLastCrossRefSectionOffset(l), r += d.sizeInBytes(), [2, { size: r, header: t, indirectObjects: o, xref: n, trailerDict: u, trailer: d }];
          }
        });
      });
    }, e.forContext = function(t, r) {
      return new e(t, r);
    }, e;
  })()
), em = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = e.call(this) || this;
      return n.data = r, n;
    }
    return t.prototype.clone = function() {
      return t.of(this.data.slice());
    }, t.prototype.toString = function() {
      return "PDFInvalidObject(" + this.data.length + " bytes)";
    }, t.prototype.sizeInBytes = function() {
      return this.data.length;
    }, t.prototype.copyBytesInto = function(r, n) {
      for (var o = this.data.length, i = 0; i < o; i++)
        r[n++] = this.data[i];
      return o;
    }, t.of = function(r) {
      return new t(r);
    }, t;
  })(It)
), an;
(function(e) {
  e[e.Deleted = 0] = "Deleted", e[e.Uncompressed = 1] = "Uncompressed", e[e.Compressed = 2] = "Compressed";
})(an || (an = {}));
var PR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      o === void 0 && (o = !0);
      var i = e.call(this, r, o) || this;
      return i.computeIndex = function() {
        for (var a = [], s = 0, c = 0, l = i.entries.length; c < l; c++) {
          var u = i.entries[c], d = i.entries[c - 1];
          c === 0 ? a.push(u.ref.objectNumber) : u.ref.objectNumber - d.ref.objectNumber > 1 && (a.push(s), a.push(u.ref.objectNumber), s = 0), s += 1;
        }
        return a.push(s), a;
      }, i.computeEntryTuples = function() {
        for (var a = new Array(i.entries.length), s = 0, c = i.entries.length; s < c; s++) {
          var l = i.entries[s];
          if (l.type === an.Deleted) {
            var u = l.type, d = l.nextFreeObjectNumber, f = l.ref;
            a[s] = [u, d, f.generationNumber];
          }
          if (l.type === an.Uncompressed) {
            var u = l.type, h = l.offset, f = l.ref;
            a[s] = [u, h, f.generationNumber];
          }
          if (l.type === an.Compressed) {
            var u = l.type, g = l.objectStreamRef, v = l.index;
            a[s] = [u, g.objectNumber, v];
          }
        }
        return a;
      }, i.computeMaxEntryByteWidths = function() {
        for (var a = i.entryTuplesCache.access(), s = [0, 0, 0], c = 0, l = a.length; c < l; c++) {
          var u = a[c], d = u[0], f = u[1], h = u[2], g = ya(d), v = ya(f), y = ya(h);
          g > s[0] && (s[0] = g), v > s[1] && (s[1] = v), y > s[2] && (s[2] = y);
        }
        return s;
      }, i.entries = n || [], i.entryTuplesCache = jr.populatedBy(i.computeEntryTuples), i.maxByteWidthsCache = jr.populatedBy(i.computeMaxEntryByteWidths), i.indexCache = jr.populatedBy(i.computeIndex), r.set(F.of("Type"), F.of("XRef")), i;
    }
    return t.prototype.addDeletedEntry = function(r, n) {
      var o = an.Deleted;
      this.entries.push({ type: o, ref: r, nextFreeObjectNumber: n }), this.entryTuplesCache.invalidate(), this.maxByteWidthsCache.invalidate(), this.indexCache.invalidate(), this.contentsCache.invalidate();
    }, t.prototype.addUncompressedEntry = function(r, n) {
      var o = an.Uncompressed;
      this.entries.push({ type: o, ref: r, offset: n }), this.entryTuplesCache.invalidate(), this.maxByteWidthsCache.invalidate(), this.indexCache.invalidate(), this.contentsCache.invalidate();
    }, t.prototype.addCompressedEntry = function(r, n, o) {
      var i = an.Compressed;
      this.entries.push({ type: i, ref: r, objectStreamRef: n, index: o }), this.entryTuplesCache.invalidate(), this.maxByteWidthsCache.invalidate(), this.indexCache.invalidate(), this.contentsCache.invalidate();
    }, t.prototype.clone = function(r) {
      var n = this, o = n.dict, i = n.entries, a = n.encode;
      return t.of(o.clone(r), i.slice(), a);
    }, t.prototype.getContentsString = function() {
      for (var r = this.entryTuplesCache.access(), n = this.maxByteWidthsCache.access(), o = "", i = 0, a = r.length; i < a; i++) {
        for (var s = r[i], c = s[0], l = s[1], u = s[2], d = lo(uo(c)), f = lo(uo(l)), h = lo(uo(u)), g = n[0] - 1; g >= 0; g--)
          o += (d[g] || 0).toString(2);
        for (var g = n[1] - 1; g >= 0; g--)
          o += (f[g] || 0).toString(2);
        for (var g = n[2] - 1; g >= 0; g--)
          o += (h[g] || 0).toString(2);
      }
      return o;
    }, t.prototype.getUnencodedContents = function() {
      for (var r = this.entryTuplesCache.access(), n = this.maxByteWidthsCache.access(), o = new Uint8Array(this.getUnencodedContentsSize()), i = 0, a = 0, s = r.length; a < s; a++) {
        for (var c = r[a], l = c[0], u = c[1], d = c[2], f = lo(uo(l)), h = lo(uo(u)), g = lo(uo(d)), v = n[0] - 1; v >= 0; v--)
          o[i++] = f[v] || 0;
        for (var v = n[1] - 1; v >= 0; v--)
          o[i++] = h[v] || 0;
        for (var v = n[2] - 1; v >= 0; v--)
          o[i++] = g[v] || 0;
      }
      return o;
    }, t.prototype.getUnencodedContentsSize = function() {
      var r = this.maxByteWidthsCache.access(), n = aD(r);
      return n * this.entries.length;
    }, t.prototype.updateDict = function() {
      e.prototype.updateDict.call(this);
      var r = this.maxByteWidthsCache.access(), n = this.indexCache.access(), o = this.dict.context;
      this.dict.set(F.of("W"), o.obj(r)), this.dict.set(F.of("Index"), o.obj(n));
    }, t.create = function(r, n) {
      n === void 0 && (n = !0);
      var o = new t(r, [], n);
      return o.addDeletedEntry(et.of(0, 65535), 0), o;
    }, t.of = function(r, n, o) {
      return o === void 0 && (o = !0), new t(r, n, o);
    }, t;
  })(Eu)
), ER = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o, i) {
      var a = e.call(this, r, n) || this;
      return a.encodeStreams = o, a.objectsPerStream = i, a;
    }
    return t.prototype.computeBufferSize = function() {
      return Re(this, void 0, void 0, function() {
        var r, n, o, i, a, s, c, l, g, v, u, b, d, f, y, h, g, v, y, b, x, C, E, D;
        return Te(this, function(A) {
          switch (A.label) {
            case 0:
              r = this.context.largestObjectNumber + 1, n = Ds.forVersion(1, 7), o = n.sizeInBytes() + 2, i = PR.create(this.createTrailerDict(), this.encodeStreams), a = [], s = [], c = [], l = this.context.enumerateIndirectObjects(), g = 0, v = l.length, A.label = 1;
            case 1:
              return g < v ? (u = l[g], b = u[0], d = u[1], f = b === this.context.trailerInfo.Encrypt || d instanceof Gt || d instanceof em || b.generationNumber !== 0, f ? (a.push(u), i.addUncompressedEntry(b, o), o += this.computeIndirectObjectSize(u), this.shouldWaitForTick(1) ? [4, Fo()] : [3, 3]) : [3, 4]) : [3, 6];
            case 2:
              A.sent(), A.label = 3;
            case 3:
              return [3, 5];
            case 4:
              y = Wa(s), h = Wa(c), (!y || y.length % this.objectsPerStream === 0) && (y = [], s.push(y), h = et.of(r++), c.push(h)), i.addCompressedEntry(b, h, y.length), y.push(u), A.label = 5;
            case 5:
              return g++, [3, 1];
            case 6:
              g = 0, v = s.length, A.label = 7;
            case 7:
              return g < v ? (y = s[g], b = c[g], x = Qg.withContextAndObjects(this.context, y, this.encodeStreams), i.addUncompressedEntry(b, o), o += this.computeIndirectObjectSize([b, x]), a.push([b, x]), this.shouldWaitForTick(y.length) ? [4, Fo()] : [3, 9]) : [3, 10];
            case 8:
              A.sent(), A.label = 9;
            case 9:
              return g++, [3, 7];
            case 10:
              return C = et.of(r++), i.dict.set(F.of("Size"), we.of(r)), i.addUncompressedEntry(C, o), E = o, o += this.computeIndirectObjectSize([C, i]), a.push([C, i]), D = ku.forLastCrossRefSectionOffset(E), o += D.sizeInBytes(), [2, { size: o, header: n, indirectObjects: a, trailer: D }];
          }
        });
      });
    }, t.forContext = function(r, n, o, i) {
      return o === void 0 && (o = !0), i === void 0 && (i = 50), new t(r, n, o, i);
    }, t;
  })($g)
), pe = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = e.call(this) || this;
      return n.value = r, n;
    }
    return t.prototype.asBytes = function() {
      for (var r = this.value + (this.value.length % 2 === 1 ? "0" : ""), n = r.length, o = new Uint8Array(r.length / 2), i = 0, a = 0; i < n; ) {
        var s = parseInt(r.substring(i, i + 2), 16);
        o[a] = s, i += 2, a += 1;
      }
      return o;
    }, t.prototype.decodeText = function() {
      var r = this.asBytes();
      return jg(r) ? Lg(r) : Zg(r);
    }, t.prototype.decodeDate = function() {
      var r = this.decodeText(), n = Og(r);
      if (!n)
        throw new _g(r);
      return n;
    }, t.prototype.asString = function() {
      return this.value;
    }, t.prototype.clone = function() {
      return t.of(this.value);
    }, t.prototype.toString = function() {
      return "<" + this.value + ">";
    }, t.prototype.sizeInBytes = function() {
      return this.value.length + 2;
    }, t.prototype.copyBytesInto = function(r, n) {
      return r[n++] = T.LessThan, n += Pt(this.value, r, n), r[n++] = T.GreaterThan, this.value.length + 2;
    }, t.of = function(r) {
      return new t(r);
    }, t.fromText = function(r) {
      for (var n = uD(r), o = "", i = 0, a = n.length; i < a; i++)
        o += zi(n[i], 4);
      return new t(o);
    }, t;
  })(It)
), Ua = (
  /** @class */
  (function() {
    function e(t, r) {
      this.encoding = t === yi.ZapfDingbats ? aa.ZapfDingbats : t === yi.Symbol ? aa.Symbol : aa.WinAnsi, this.font = qD.load(t), this.fontName = this.font.FontName, this.customName = r;
    }
    return e.prototype.encodeText = function(t) {
      for (var r = this.encodeTextAsGlyphs(t), n = new Array(r.length), o = 0, i = r.length; o < i; o++)
        n[o] = Ps(r[o].code);
      return pe.of(n.join(""));
    }, e.prototype.widthOfTextAtSize = function(t, r) {
      for (var n = this.encodeTextAsGlyphs(t), o = 0, i = 0, a = n.length; i < a; i++) {
        var s = n[i].name, c = (n[i + 1] || {}).name, l = this.font.getXAxisKerningForPair(s, c) || 0;
        o += this.widthOfGlyph(s) + l;
      }
      var u = r / 1e3;
      return o * u;
    }, e.prototype.heightOfFontAtSize = function(t, r) {
      r === void 0 && (r = {});
      var n = r.descender, o = n === void 0 ? !0 : n, i = this.font, a = i.Ascender, s = i.Descender, c = i.FontBBox, l = a || c[3], u = s || c[1], d = l - u;
      return o || (d += s || 0), d / 1e3 * t;
    }, e.prototype.sizeOfFontAtHeight = function(t) {
      var r = this.font, n = r.Ascender, o = r.Descender, i = r.FontBBox, a = n || i[3], s = o || i[1];
      return 1e3 * t / (a - s);
    }, e.prototype.embedIntoContext = function(t, r) {
      var n = t.obj({
        Type: "Font",
        Subtype: "Type1",
        BaseFont: this.customName || this.fontName,
        Encoding: this.encoding === aa.WinAnsi ? "WinAnsiEncoding" : void 0
      });
      return r ? (t.assign(r, n), r) : t.register(n);
    }, e.prototype.widthOfGlyph = function(t) {
      return this.font.getWidthOfGlyph(t) || 250;
    }, e.prototype.encodeTextAsGlyphs = function(t) {
      for (var r = Array.from(t), n = new Array(r.length), o = 0, i = r.length; o < i; o++) {
        var a = YF(r[o]);
        n[o] = this.encoding.encodeUnicodeCodePoint(a);
      }
      return n;
    }, e.for = function(t, r) {
      return new e(t, r);
    }, e;
  })()
), kR = function(e, t) {
  for (var r = new Array(e.length), n = 0, o = e.length; n < o; n++) {
    var i = e[n], a = Cf(ba(t(i))), s = Cf.apply(void 0, i.codePoints.map(DR));
    r[n] = [a, s];
  }
  return FR(r);
}, FR = function(e) {
  return `/CIDInit /ProcSet findresource begin
12 dict begin
begincmap
/CIDSystemInfo <<
  /Registry (Adobe)
  /Ordering (UCS)
  /Supplement 0
>> def
/CMapName /Adobe-Identity-UCS def
/CMapType 2 def
1 begincodespacerange
<0000><ffff>
endcodespacerange
` + e.length + ` beginbfchar
` + e.map(function(t) {
    var r = t[0], n = t[1];
    return r + " " + n;
  }).join(`
`) + `
endbfchar
endcmap
CMapName currentdict /CMap defineresource pop
end
end`;
}, Cf = function() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return "<" + e.join("") + ">";
}, ba = function(e) {
  return zi(e, 4);
}, DR = function(e) {
  if (dD(e))
    return ba(e);
  if (fD(e)) {
    var t = Ig(e), r = Bg(e);
    return "" + ba(t) + ba(r);
  }
  var n = Ps(e), o = "0x" + n + " is not a valid UTF-8 or UTF-16 codepoint.";
  throw new Error(o);
}, RR = function(e) {
  var t = 0, r = function(n) {
    t |= 1 << n - 1;
  };
  return e.fixedPitch && r(1), e.serif && r(2), r(3), e.script && r(4), e.nonsymbolic && r(6), e.italic && r(7), e.allCap && r(17), e.smallCap && r(18), e.forceBold && r(19), t;
}, TR = function(e) {
  var t = e["OS/2"] ? e["OS/2"].sFamilyClass : 0, r = RR({
    fixedPitch: e.post.isFixedPitch,
    serif: 1 <= t && t <= 7,
    script: t === 10,
    italic: e.head.macStyle.italic
  });
  return r;
}, $e = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = e.call(this) || this;
      return n.value = r, n;
    }
    return t.prototype.asBytes = function() {
      for (var r = [], n = "", o = !1, i = function(d) {
        d !== void 0 && r.push(d), o = !1;
      }, a = 0, s = this.value.length; a < s; a++) {
        var c = this.value[a], l = Ce(c), u = this.value[a + 1];
        o ? l === T.Newline || l === T.CarriageReturn ? i() : l === T.n ? i(T.Newline) : l === T.r ? i(T.CarriageReturn) : l === T.t ? i(T.Tab) : l === T.b ? i(T.Backspace) : l === T.f ? i(T.FormFeed) : l === T.LeftParen ? i(T.LeftParen) : l === T.RightParen ? i(T.RightParen) : l === T.Backspace ? i(T.BackSlash) : l >= T.Zero && l <= T.Seven ? (n += c, (n.length === 3 || !(u >= "0" && u <= "7")) && (i(parseInt(n, 8)), n = "")) : i(l) : l === T.BackSlash ? o = !0 : i(l);
      }
      return new Uint8Array(r);
    }, t.prototype.decodeText = function() {
      var r = this.asBytes();
      return jg(r) ? Lg(r) : Zg(r);
    }, t.prototype.decodeDate = function() {
      var r = this.decodeText(), n = Og(r);
      if (!n)
        throw new _g(r);
      return n;
    }, t.prototype.asString = function() {
      return this.value;
    }, t.prototype.clone = function() {
      return t.of(this.value);
    }, t.prototype.toString = function() {
      return "(" + this.value + ")";
    }, t.prototype.sizeInBytes = function() {
      return this.value.length + 2;
    }, t.prototype.copyBytesInto = function(r, n) {
      return r[n++] = T.LeftParen, n += Pt(this.value, r, n), r[n++] = T.RightParen, this.value.length + 2;
    }, t.of = function(r) {
      return new t(r);
    }, t.fromDate = function(r) {
      var n = vr(String(r.getUTCFullYear()), 4, "0"), o = vr(String(r.getUTCMonth() + 1), 2, "0"), i = vr(String(r.getUTCDate()), 2, "0"), a = vr(String(r.getUTCHours()), 2, "0"), s = vr(String(r.getUTCMinutes()), 2, "0"), c = vr(String(r.getUTCSeconds()), 2, "0");
      return new t("D:" + n + o + i + a + s + c + "Z");
    }, t;
  })(It)
), Fu = (
  /** @class */
  (function() {
    function e(t, r, n, o) {
      var i = this;
      this.allGlyphsInFontSortedById = function() {
        for (var a = new Array(i.font.characterSet.length), s = 0, c = a.length; s < c; s++) {
          var l = i.font.characterSet[s];
          a[s] = i.font.glyphForCodePoint(l);
        }
        return iD(a.sort(oD), function(u) {
          return u.id;
        });
      }, this.font = t, this.scale = 1e3 / this.font.unitsPerEm, this.fontData = r, this.fontName = this.font.postscriptName || "Font", this.customName = n, this.fontFeatures = o, this.baseFontName = "", this.glyphCache = jr.populatedBy(this.allGlyphsInFontSortedById);
    }
    return e.for = function(t, r, n, o) {
      return Re(this, void 0, void 0, function() {
        var i;
        return Te(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, t.create(r)];
            case 1:
              return i = a.sent(), [2, new e(i, r, n, o)];
          }
        });
      });
    }, e.prototype.encodeText = function(t) {
      for (var r = this.font.layout(t, this.fontFeatures).glyphs, n = new Array(r.length), o = 0, i = r.length; o < i; o++)
        n[o] = zi(r[o].id, 4);
      return pe.of(n.join(""));
    }, e.prototype.widthOfTextAtSize = function(t, r) {
      for (var n = this.font.layout(t, this.fontFeatures).glyphs, o = 0, i = 0, a = n.length; i < a; i++)
        o += n[i].advanceWidth * this.scale;
      var s = r / 1e3;
      return o * s;
    }, e.prototype.heightOfFontAtSize = function(t, r) {
      r === void 0 && (r = {});
      var n = r.descender, o = n === void 0 ? !0 : n, i = this.font, a = i.ascent, s = i.descent, c = i.bbox, l = (a || c.maxY) * this.scale, u = (s || c.minY) * this.scale, d = l - u;
      return o || (d -= Math.abs(s) || 0), d / 1e3 * t;
    }, e.prototype.sizeOfFontAtHeight = function(t) {
      var r = this.font, n = r.ascent, o = r.descent, i = r.bbox, a = (n || i.maxY) * this.scale, s = (o || i.minY) * this.scale;
      return 1e3 * t / (a - s);
    }, e.prototype.embedIntoContext = function(t, r) {
      return this.baseFontName = this.customName || t.addRandomSuffix(this.fontName), this.embedFontDict(t, r);
    }, e.prototype.embedFontDict = function(t, r) {
      return Re(this, void 0, void 0, function() {
        var n, o, i;
        return Te(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.embedCIDFontDict(t)];
            case 1:
              return n = a.sent(), o = this.embedUnicodeCmap(t), i = t.obj({
                Type: "Font",
                Subtype: "Type0",
                BaseFont: this.baseFontName,
                Encoding: "Identity-H",
                DescendantFonts: [n],
                ToUnicode: o
              }), r ? (t.assign(r, i), [2, r]) : [2, t.register(i)];
          }
        });
      });
    }, e.prototype.isCFF = function() {
      return this.font.cff;
    }, e.prototype.embedCIDFontDict = function(t) {
      return Re(this, void 0, void 0, function() {
        var r, n;
        return Te(this, function(o) {
          switch (o.label) {
            case 0:
              return [4, this.embedFontDescriptor(t)];
            case 1:
              return r = o.sent(), n = t.obj({
                Type: "Font",
                Subtype: this.isCFF() ? "CIDFontType0" : "CIDFontType2",
                CIDToGIDMap: "Identity",
                BaseFont: this.baseFontName,
                CIDSystemInfo: {
                  Registry: $e.of("Adobe"),
                  Ordering: $e.of("Identity"),
                  Supplement: 0
                },
                FontDescriptor: r,
                W: this.computeWidths()
              }), [2, t.register(n)];
          }
        });
      });
    }, e.prototype.embedFontDescriptor = function(t) {
      return Re(this, void 0, void 0, function() {
        var r, n, o, i, a, s, c, l, u, d, f, h, g, v, y;
        return Te(this, function(b) {
          switch (b.label) {
            case 0:
              return [4, this.embedFontStream(t)];
            case 1:
              return r = b.sent(), n = this.scale, o = this.font, i = o.italicAngle, a = o.ascent, s = o.descent, c = o.capHeight, l = o.xHeight, u = this.font.bbox, d = u.minX, f = u.minY, h = u.maxX, g = u.maxY, v = t.obj((y = {
                Type: "FontDescriptor",
                FontName: this.baseFontName,
                Flags: TR(this.font),
                FontBBox: [d * n, f * n, h * n, g * n],
                ItalicAngle: i,
                Ascent: a * n,
                Descent: s * n,
                CapHeight: (c || a) * n,
                XHeight: (l || 0) * n,
                // Not sure how to compute/find this, nor is anybody else really:
                // https://stackoverflow.com/questions/35485179/stemv-value-of-the-truetype-font
                StemV: 0
              }, y[this.isCFF() ? "FontFile3" : "FontFile2"] = r, y)), [2, t.register(v)];
          }
        });
      });
    }, e.prototype.serializeFont = function() {
      return Re(this, void 0, void 0, function() {
        return Te(this, function(t) {
          return [2, this.fontData];
        });
      });
    }, e.prototype.embedFontStream = function(t) {
      return Re(this, void 0, void 0, function() {
        var r, n, o;
        return Te(this, function(i) {
          switch (i.label) {
            case 0:
              return o = (n = t).flateStream, [4, this.serializeFont()];
            case 1:
              return r = o.apply(n, [i.sent(), {
                Subtype: this.isCFF() ? "CIDFontType0C" : void 0
              }]), [2, t.register(r)];
          }
        });
      });
    }, e.prototype.embedUnicodeCmap = function(t) {
      var r = kR(this.glyphCache.access(), this.glyphId.bind(this)), n = t.flateStream(r);
      return t.register(n);
    }, e.prototype.glyphId = function(t) {
      return t ? t.id : -1;
    }, e.prototype.computeWidths = function() {
      for (var t = this.glyphCache.access(), r = [], n = [], o = 0, i = t.length; o < i; o++) {
        var a = t[o], s = t[o - 1], c = this.glyphId(a), l = this.glyphId(s);
        o === 0 ? r.push(c) : c - l !== 1 && (r.push(n), r.push(c), n = []), n.push(a.advanceWidth * this.scale);
      }
      return r.push(n), r;
    }, e;
  })()
), AR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o, i) {
      var a = e.call(this, r, n, o, i) || this;
      return a.subset = a.font.createSubset(), a.glyphs = [], a.glyphCache = jr.populatedBy(function() {
        return a.glyphs;
      }), a.glyphIdMap = /* @__PURE__ */ new Map(), a;
    }
    return t.for = function(r, n, o, i) {
      return Re(this, void 0, void 0, function() {
        var a;
        return Te(this, function(s) {
          switch (s.label) {
            case 0:
              return [4, r.create(n)];
            case 1:
              return a = s.sent(), [2, new t(a, n, o, i)];
          }
        });
      });
    }, t.prototype.encodeText = function(r) {
      for (var n = this.font.layout(r, this.fontFeatures).glyphs, o = new Array(n.length), i = 0, a = n.length; i < a; i++) {
        var s = n[i], c = this.subset.includeGlyph(s);
        this.glyphs[c - 1] = s, this.glyphIdMap.set(s.id, c), o[i] = zi(c, 4);
      }
      return this.glyphCache.invalidate(), pe.of(o.join(""));
    }, t.prototype.isCFF = function() {
      return this.subset.cff;
    }, t.prototype.glyphId = function(r) {
      return r ? this.glyphIdMap.get(r.id) : -1;
    }, t.prototype.serializeFont = function() {
      var r = this;
      return new Promise(function(n, o) {
        var i = [];
        r.subset.encodeStream().on("data", function(a) {
          return i.push(a);
        }).on("end", function() {
          return n(nD(i));
        }).on("error", function(a) {
          return o(a);
        });
      });
    }, t;
  })(Fu)
), il;
(function(e) {
  e.Source = "Source", e.Data = "Data", e.Alternative = "Alternative", e.Supplement = "Supplement", e.EncryptedPayload = "EncryptedPayload", e.FormData = "EncryptedPayload", e.Schema = "Schema", e.Unspecified = "Unspecified";
})(il || (il = {}));
var NR = (
  /** @class */
  (function() {
    function e(t, r, n) {
      n === void 0 && (n = {}), this.fileData = t, this.fileName = r, this.options = n;
    }
    return e.for = function(t, r, n) {
      return n === void 0 && (n = {}), new e(t, r, n);
    }, e.prototype.embedIntoContext = function(t, r) {
      return Re(this, void 0, void 0, function() {
        var n, o, i, a, s, c, l, u, d;
        return Te(this, function(f) {
          return n = this.options, o = n.mimeType, i = n.description, a = n.creationDate, s = n.modificationDate, c = n.afRelationship, l = t.flateStream(this.fileData, {
            Type: "EmbeddedFile",
            Subtype: o ?? void 0,
            Params: {
              Size: this.fileData.length,
              CreationDate: a ? $e.fromDate(a) : void 0,
              ModDate: s ? $e.fromDate(s) : void 0
            }
          }), u = t.register(l), d = t.obj({
            Type: "Filespec",
            F: $e.of(this.fileName),
            UF: pe.fromText(this.fileName),
            EF: { F: u },
            Desc: i ? pe.fromText(i) : void 0,
            AFRelationship: c ?? void 0
          }), r ? (t.assign(r, d), [2, r]) : [2, t.register(d)];
        });
      });
    }, e;
  })()
), Sf = [
  65472,
  65473,
  65474,
  65475,
  65477,
  65478,
  65479,
  65480,
  65481,
  65482,
  65483,
  65484,
  65485,
  65486,
  65487
], xo;
(function(e) {
  e.DeviceGray = "DeviceGray", e.DeviceRGB = "DeviceRGB", e.DeviceCMYK = "DeviceCMYK";
})(xo || (xo = {}));
var OR = {
  1: xo.DeviceGray,
  3: xo.DeviceRGB,
  4: xo.DeviceCMYK
}, tm = (
  /** @class */
  (function() {
    function e(t, r, n, o, i) {
      this.imageData = t, this.bitsPerComponent = r, this.width = n, this.height = o, this.colorSpace = i;
    }
    return e.for = function(t) {
      return Re(this, void 0, void 0, function() {
        var r, n, o, i, a, s, c, l, u, d;
        return Te(this, function(f) {
          if (r = new DataView(t.buffer), n = r.getUint16(0), n !== 65496)
            throw new Error("SOI not found in JPEG");
          for (o = 2; o < r.byteLength && (i = r.getUint16(o), o += 2, !Sf.includes(i)); )
            o += r.getUint16(o);
          if (!Sf.includes(i))
            throw new Error("Invalid JPEG");
          if (o += 2, a = r.getUint8(o++), s = r.getUint16(o), o += 2, c = r.getUint16(o), o += 2, l = r.getUint8(o++), u = OR[l], !u)
            throw new Error("Unknown JPEG channel.");
          return d = u, [2, new e(t, a, c, s, d)];
        });
      });
    }, e.prototype.embedIntoContext = function(t, r) {
      return Re(this, void 0, void 0, function() {
        var n;
        return Te(this, function(o) {
          return n = t.stream(this.imageData, {
            Type: "XObject",
            Subtype: "Image",
            BitsPerComponent: this.bitsPerComponent,
            Width: this.width,
            Height: this.height,
            ColorSpace: this.colorSpace,
            Filter: "DCTDecode",
            // CMYK JPEG streams in PDF are typically stored complemented,
            // with 1 as 'off' and 0 as 'on' (PDF 32000-1:2008, 8.6.4.4).
            //
            // Standalone CMYK JPEG (usually exported by Photoshop) are
            // stored inverse, with 0 as 'off' and 1 as 'on', like RGB.
            //
            // Applying a swap here as a hedge that most bytes passing
            // through this method will benefit from it.
            Decode: this.colorSpace === xo.DeviceCMYK ? [1, 0, 1, 0, 1, 0, 1, 0] : void 0
          }), r ? (t.assign(r, n), [2, r]) : [2, t.register(n)];
        });
      });
    }, e;
  })()
), _ = {};
_.toRGBA8 = function(e) {
  var t = e.width, r = e.height;
  if (e.tabs.acTL == null) return [_.toRGBA8.decodeImage(e.data, t, r, e).buffer];
  var n = [];
  e.frames[0].data == null && (e.frames[0].data = e.data);
  for (var o = t * r * 4, i = new Uint8Array(o), a = new Uint8Array(o), s = new Uint8Array(o), c = 0; c < e.frames.length; c++) {
    var l = e.frames[c], u = l.rect.x, d = l.rect.y, f = l.rect.width, h = l.rect.height, g = _.toRGBA8.decodeImage(l.data, f, h, e);
    if (c != 0) for (var v = 0; v < o; v++) s[v] = i[v];
    if (l.blend == 0 ? _._copyTile(g, f, h, i, t, r, u, d, 0) : l.blend == 1 && _._copyTile(g, f, h, i, t, r, u, d, 1), n.push(i.buffer.slice(0)), l.dispose != 0) {
      if (l.dispose == 1) _._copyTile(a, f, h, i, t, r, u, d, 0);
      else if (l.dispose == 2) for (var v = 0; v < o; v++) i[v] = s[v];
    }
  }
  return n;
};
_.toRGBA8.decodeImage = function(e, t, r, n) {
  var o = t * r, i = _.decode._getBPP(n), a = Math.ceil(t * i / 8), s = new Uint8Array(o * 4), c = new Uint32Array(s.buffer), l = n.ctype, u = n.depth, d = _._bin.readUshort;
  if (l == 6) {
    var f = o << 2;
    if (u == 8) for (var h = 0; h < f; h += 4)
      s[h] = e[h], s[h + 1] = e[h + 1], s[h + 2] = e[h + 2], s[h + 3] = e[h + 3];
    if (u == 16) for (var h = 0; h < f; h++)
      s[h] = e[h << 1];
  } else if (l == 2) {
    var g = n.tabs.tRNS;
    if (g == null) {
      if (u == 8) for (var h = 0; h < o; h++) {
        var v = h * 3;
        c[h] = 255 << 24 | e[v + 2] << 16 | e[v + 1] << 8 | e[v];
      }
      if (u == 16) for (var h = 0; h < o; h++) {
        var v = h * 6;
        c[h] = 255 << 24 | e[v + 4] << 16 | e[v + 2] << 8 | e[v];
      }
    } else {
      var y = g[0], b = g[1], x = g[2];
      if (u == 8) for (var h = 0; h < o; h++) {
        var C = h << 2, v = h * 3;
        c[h] = 255 << 24 | e[v + 2] << 16 | e[v + 1] << 8 | e[v], e[v] == y && e[v + 1] == b && e[v + 2] == x && (s[C + 3] = 0);
      }
      if (u == 16) for (var h = 0; h < o; h++) {
        var C = h << 2, v = h * 6;
        c[h] = 255 << 24 | e[v + 4] << 16 | e[v + 2] << 8 | e[v], d(e, v) == y && d(e, v + 2) == b && d(e, v + 4) == x && (s[C + 3] = 0);
      }
    }
  } else if (l == 3) {
    var E = n.tabs.PLTE, D = n.tabs.tRNS, A = D ? D.length : 0;
    if (u == 1) for (var R = 0; R < r; R++)
      for (var O = R * a, W = R * t, h = 0; h < t; h++) {
        var C = W + h << 2, z = e[O + (h >> 3)] >> 7 - ((h & 7) << 0) & 1, q = 3 * z;
        s[C] = E[q], s[C + 1] = E[q + 1], s[C + 2] = E[q + 2], s[C + 3] = z < A ? D[z] : 255;
      }
    if (u == 2) for (var R = 0; R < r; R++)
      for (var O = R * a, W = R * t, h = 0; h < t; h++) {
        var C = W + h << 2, z = e[O + (h >> 2)] >> 6 - ((h & 3) << 1) & 3, q = 3 * z;
        s[C] = E[q], s[C + 1] = E[q + 1], s[C + 2] = E[q + 2], s[C + 3] = z < A ? D[z] : 255;
      }
    if (u == 4) for (var R = 0; R < r; R++)
      for (var O = R * a, W = R * t, h = 0; h < t; h++) {
        var C = W + h << 2, z = e[O + (h >> 1)] >> 4 - ((h & 1) << 2) & 15, q = 3 * z;
        s[C] = E[q], s[C + 1] = E[q + 1], s[C + 2] = E[q + 2], s[C + 3] = z < A ? D[z] : 255;
      }
    if (u == 8) for (var h = 0; h < o; h++) {
      var C = h << 2, z = e[h], q = 3 * z;
      s[C] = E[q], s[C + 1] = E[q + 1], s[C + 2] = E[q + 2], s[C + 3] = z < A ? D[z] : 255;
    }
  } else if (l == 4) {
    if (u == 8) for (var h = 0; h < o; h++) {
      var C = h << 2, V = h << 1, I = e[V];
      s[C] = I, s[C + 1] = I, s[C + 2] = I, s[C + 3] = e[V + 1];
    }
    if (u == 16) for (var h = 0; h < o; h++) {
      var C = h << 2, V = h << 2, I = e[V];
      s[C] = I, s[C + 1] = I, s[C + 2] = I, s[C + 3] = e[V + 2];
    }
  } else if (l == 0)
    for (var y = n.tabs.tRNS ? n.tabs.tRNS : -1, R = 0; R < r; R++) {
      var Z = R * a, Q = R * t;
      if (u == 1) for (var K = 0; K < t; K++) {
        var I = 255 * (e[Z + (K >>> 3)] >>> 7 - (K & 7) & 1), L = I == y * 255 ? 0 : 255;
        c[Q + K] = L << 24 | I << 16 | I << 8 | I;
      }
      else if (u == 2) for (var K = 0; K < t; K++) {
        var I = 85 * (e[Z + (K >>> 2)] >>> 6 - ((K & 3) << 1) & 3), L = I == y * 85 ? 0 : 255;
        c[Q + K] = L << 24 | I << 16 | I << 8 | I;
      }
      else if (u == 4) for (var K = 0; K < t; K++) {
        var I = 17 * (e[Z + (K >>> 1)] >>> 4 - ((K & 1) << 2) & 15), L = I == y * 17 ? 0 : 255;
        c[Q + K] = L << 24 | I << 16 | I << 8 | I;
      }
      else if (u == 8) for (var K = 0; K < t; K++) {
        var I = e[Z + K], L = I == y ? 0 : 255;
        c[Q + K] = L << 24 | I << 16 | I << 8 | I;
      }
      else if (u == 16) for (var K = 0; K < t; K++) {
        var I = e[Z + (K << 1)], L = d(e, Z + (K << h)) == y ? 0 : 255;
        c[Q + K] = L << 24 | I << 16 | I << 8 | I;
      }
    }
  return s;
};
_.decode = function(e) {
  for (var t = new Uint8Array(e), r = 8, n = _._bin, o = n.readUshort, i = n.readUint, a = { tabs: {}, frames: [] }, s = new Uint8Array(t.length), c = 0, l, u = 0, d = [137, 80, 78, 71, 13, 10, 26, 10], f = 0; f < 8; f++) if (t[f] != d[f]) throw "The input is not a PNG file!";
  for (; r < t.length; ) {
    var h = n.readUint(t, r);
    r += 4;
    var g = n.readASCII(t, r, 4);
    if (r += 4, g == "IHDR")
      _.decode._IHDR(t, r, a);
    else if (g == "IDAT") {
      for (var f = 0; f < h; f++) s[c + f] = t[r + f];
      c += h;
    } else if (g == "acTL")
      a.tabs[g] = { num_frames: i(t, r), num_plays: i(t, r + 4) }, l = new Uint8Array(t.length);
    else if (g == "fcTL") {
      if (u != 0) {
        var v = a.frames[a.frames.length - 1];
        v.data = _.decode._decompress(a, l.slice(0, u), v.rect.width, v.rect.height), u = 0;
      }
      var y = { x: i(t, r + 12), y: i(t, r + 16), width: i(t, r + 4), height: i(t, r + 8) }, b = o(t, r + 22);
      b = o(t, r + 20) / (b == 0 ? 100 : b);
      var x = { rect: y, delay: Math.round(b * 1e3), dispose: t[r + 24], blend: t[r + 25] };
      a.frames.push(x);
    } else if (g == "fdAT") {
      for (var f = 0; f < h - 4; f++) l[u + f] = t[r + f + 4];
      u += h - 4;
    } else if (g == "pHYs")
      a.tabs[g] = [n.readUint(t, r), n.readUint(t, r + 4), t[r + 8]];
    else if (g == "cHRM") {
      a.tabs[g] = [];
      for (var f = 0; f < 8; f++) a.tabs[g].push(n.readUint(t, r + f * 4));
    } else if (g == "tEXt") {
      a.tabs[g] == null && (a.tabs[g] = {});
      var C = n.nextZero(t, r), E = n.readASCII(t, r, C - r), D = n.readASCII(t, C + 1, r + h - C - 1);
      a.tabs[g][E] = D;
    } else if (g == "iTXt") {
      a.tabs[g] == null && (a.tabs[g] = {});
      var C = 0, A = r;
      C = n.nextZero(t, A);
      var E = n.readASCII(t, A, C - A);
      A = C + 1, t[A], t[A + 1], A += 2, C = n.nextZero(t, A), n.readASCII(t, A, C - A), A = C + 1, C = n.nextZero(t, A), n.readUTF8(t, A, C - A), A = C + 1;
      var D = n.readUTF8(t, A, h - (A - r));
      a.tabs[g][E] = D;
    } else if (g == "PLTE")
      a.tabs[g] = n.readBytes(t, r, h);
    else if (g == "hIST") {
      var R = a.tabs.PLTE.length / 3;
      a.tabs[g] = [];
      for (var f = 0; f < R; f++) a.tabs[g].push(o(t, r + f * 2));
    } else if (g == "tRNS")
      a.ctype == 3 ? a.tabs[g] = n.readBytes(t, r, h) : a.ctype == 0 ? a.tabs[g] = o(t, r) : a.ctype == 2 && (a.tabs[g] = [o(t, r), o(t, r + 2), o(t, r + 4)]);
    else if (g == "gAMA") a.tabs[g] = n.readUint(t, r) / 1e5;
    else if (g == "sRGB") a.tabs[g] = t[r];
    else if (g == "bKGD")
      a.ctype == 0 || a.ctype == 4 ? a.tabs[g] = [o(t, r)] : a.ctype == 2 || a.ctype == 6 ? a.tabs[g] = [o(t, r), o(t, r + 2), o(t, r + 4)] : a.ctype == 3 && (a.tabs[g] = t[r]);
    else if (g == "IEND")
      break;
    r += h, n.readUint(t, r), r += 4;
  }
  if (u != 0) {
    var v = a.frames[a.frames.length - 1];
    v.data = _.decode._decompress(a, l.slice(0, u), v.rect.width, v.rect.height), u = 0;
  }
  return a.data = _.decode._decompress(a, s, a.width, a.height), delete a.compress, delete a.interlace, delete a.filter, a;
};
_.decode._decompress = function(e, t, r, n) {
  var o = _.decode._getBPP(e), i = Math.ceil(r * o / 8), a = new Uint8Array((i + 1 + e.interlace) * n);
  return t = _.decode._inflate(t, a), e.interlace == 0 ? t = _.decode._filterZero(t, e, 0, r, n) : e.interlace == 1 && (t = _.decode._readInterlace(t, e)), t;
};
_.decode._inflate = function(e, t) {
  var r = _.inflateRaw(new Uint8Array(e.buffer, 2, e.length - 6), t);
  return r;
};
_.inflateRaw = (function() {
  var e = {};
  return e.H = {}, e.H.N = function(t, r) {
    var n = Uint8Array, o = 0, i = 0, a = 0, s = 0, c = 0, l = 0, u = 0, d = 0, f = 0, h, g;
    if (t[0] == 3 && t[1] == 0) return r || new n(0);
    var v = e.H, y = v.b, b = v.e, x = v.R, C = v.n, E = v.A, D = v.Z, A = v.m, R = r == null;
    for (R && (r = new n(t.length >>> 2 << 3)); o == 0; ) {
      if (o = y(t, f, 1), i = y(t, f + 1, 2), f += 3, i == 0) {
        (f & 7) != 0 && (f += 8 - (f & 7));
        var O = (f >>> 3) + 4, W = t[O - 4] | t[O - 3] << 8;
        R && (r = e.H.W(r, d + W)), r.set(new n(t.buffer, t.byteOffset + O, W), d), f = O + W << 3, d += W;
        continue;
      }
      if (R && (r = e.H.W(r, d + (1 << 17))), i == 1 && (h = A.J, g = A.h, l = 511, u = 31), i == 2) {
        a = b(t, f, 5) + 257, s = b(t, f + 5, 5) + 1, c = b(t, f + 10, 4) + 4, f += 14;
        for (var z = 1, q = 0; q < 38; q += 2)
          A.Q[q] = 0, A.Q[q + 1] = 0;
        for (var q = 0; q < c; q++) {
          var V = b(t, f + q * 3, 3);
          A.Q[(A.X[q] << 1) + 1] = V, V > z && (z = V);
        }
        f += 3 * c, C(A.Q, z), E(A.Q, z, A.u), h = A.w, g = A.d, f = x(A.u, (1 << z) - 1, a + s, t, f, A.v);
        var I = v.V(A.v, 0, a, A.C);
        l = (1 << I) - 1;
        var Z = v.V(A.v, a, s, A.D);
        u = (1 << Z) - 1, C(A.C, I), E(A.C, I, h), C(A.D, Z), E(A.D, Z, g);
      }
      for (; ; ) {
        var Q = h[D(t, f) & l];
        f += Q & 15;
        var K = Q >>> 4;
        if (!(K >>> 8))
          r[d++] = K;
        else {
          if (K == 256)
            break;
          var L = d + K - 254;
          if (K > 264) {
            var U = A.q[K - 257];
            L = d + (U >>> 3) + b(t, f, U & 7), f += U & 7;
          }
          var Y = g[D(t, f) & u];
          f += Y & 15;
          var he = Y >>> 4, ce = A.c[he], ke = (ce >>> 4) + y(t, f, ce & 15);
          for (f += ce & 15; d < L; )
            r[d] = r[d++ - ke], r[d] = r[d++ - ke], r[d] = r[d++ - ke], r[d] = r[d++ - ke];
          d = L;
        }
      }
    }
    return r.length == d ? r : r.slice(0, d);
  }, e.H.W = function(t, r) {
    var n = t.length;
    if (r <= n) return t;
    var o = new Uint8Array(n << 1);
    return o.set(t, 0), o;
  }, e.H.R = function(t, r, n, o, i, a) {
    for (var s = e.H.e, c = e.H.Z, l = 0; l < n; ) {
      var u = t[c(o, i) & r];
      i += u & 15;
      var d = u >>> 4;
      if (d <= 15)
        a[l] = d, l++;
      else {
        var f = 0, h = 0;
        d == 16 ? (h = 3 + s(o, i, 2), i += 2, f = a[l - 1]) : d == 17 ? (h = 3 + s(o, i, 3), i += 3) : d == 18 && (h = 11 + s(o, i, 7), i += 7);
        for (var g = l + h; l < g; )
          a[l] = f, l++;
      }
    }
    return i;
  }, e.H.V = function(t, r, n, o) {
    for (var i = 0, a = 0, s = o.length >>> 1; a < n; ) {
      var c = t[a + r];
      o[a << 1] = 0, o[(a << 1) + 1] = c, c > i && (i = c), a++;
    }
    for (; a < s; )
      o[a << 1] = 0, o[(a << 1) + 1] = 0, a++;
    return i;
  }, e.H.n = function(t, r) {
    for (var n = e.H.m, o = t.length, i, a, s, c, l, u = n.j, c = 0; c <= r; c++) u[c] = 0;
    for (c = 1; c < o; c += 2) u[t[c]]++;
    var d = n.K;
    for (i = 0, u[0] = 0, a = 1; a <= r; a++)
      i = i + u[a - 1] << 1, d[a] = i;
    for (s = 0; s < o; s += 2)
      l = t[s + 1], l != 0 && (t[s] = d[l], d[l]++);
  }, e.H.A = function(t, r, n) {
    for (var o = t.length, i = e.H.m, a = i.r, s = 0; s < o; s += 2) if (t[s + 1] != 0)
      for (var c = s >> 1, l = t[s + 1], u = c << 4 | l, d = r - l, f = t[s] << d, h = f + (1 << d); f != h; ) {
        var g = a[f] >>> 15 - r;
        n[g] = u, f++;
      }
  }, e.H.l = function(t, r) {
    for (var n = e.H.m.r, o = 15 - r, i = 0; i < t.length; i += 2) {
      var a = t[i] << r - t[i + 1];
      t[i] = n[a] >>> o;
    }
  }, e.H.M = function(t, r, n) {
    n = n << (r & 7);
    var o = r >>> 3;
    t[o] |= n, t[o + 1] |= n >>> 8;
  }, e.H.I = function(t, r, n) {
    n = n << (r & 7);
    var o = r >>> 3;
    t[o] |= n, t[o + 1] |= n >>> 8, t[o + 2] |= n >>> 16;
  }, e.H.e = function(t, r, n) {
    return (t[r >>> 3] | t[(r >>> 3) + 1] << 8) >>> (r & 7) & (1 << n) - 1;
  }, e.H.b = function(t, r, n) {
    return (t[r >>> 3] | t[(r >>> 3) + 1] << 8 | t[(r >>> 3) + 2] << 16) >>> (r & 7) & (1 << n) - 1;
  }, e.H.Z = function(t, r) {
    return (t[r >>> 3] | t[(r >>> 3) + 1] << 8 | t[(r >>> 3) + 2] << 16) >>> (r & 7);
  }, e.H.i = function(t, r) {
    return (t[r >>> 3] | t[(r >>> 3) + 1] << 8 | t[(r >>> 3) + 2] << 16 | t[(r >>> 3) + 3] << 24) >>> (r & 7);
  }, e.H.m = (function() {
    var t = Uint16Array, r = Uint32Array;
    return { K: new t(16), j: new t(16), X: [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15], S: [3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 999, 999, 999], T: [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0, 0, 0, 0], q: new t(32), p: [1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 65535, 65535], z: [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 0, 0], c: new r(32), J: new t(512), _: [], h: new t(32), $: [], w: new t(32768), C: [], v: [], d: new t(32768), D: [], u: new t(512), Q: [], r: new t(32768), s: new r(286), Y: new r(30), a: new r(19), t: new r(15e3), k: new t(65536), g: new t(32768) };
  })(), (function() {
    for (var t = e.H.m, r = 32768, n = 0; n < r; n++) {
      var o = n;
      o = (o & 2863311530) >>> 1 | (o & 1431655765) << 1, o = (o & 3435973836) >>> 2 | (o & 858993459) << 2, o = (o & 4042322160) >>> 4 | (o & 252645135) << 4, o = (o & 4278255360) >>> 8 | (o & 16711935) << 8, t.r[n] = (o >>> 16 | o << 16) >>> 17;
    }
    function i(a, s, c) {
      for (; s-- != 0; ) a.push(0, c);
    }
    for (var n = 0; n < 32; n++)
      t.q[n] = t.S[n] << 3 | t.T[n], t.c[n] = t.p[n] << 4 | t.z[n];
    i(t._, 144, 8), i(t._, 112, 9), i(t._, 24, 7), i(t._, 8, 8), e.H.n(t._, 9), e.H.A(t._, 9, t.J), e.H.l(t._, 9), i(t.$, 32, 5), e.H.n(t.$, 5), e.H.A(t.$, 5, t.h), e.H.l(t.$, 5), i(t.Q, 19, 0), i(t.C, 286, 0), i(t.D, 30, 0), i(t.v, 320, 0);
  })(), e.H.N;
})();
_.decode._readInterlace = function(e, t) {
  for (var r = t.width, n = t.height, o = _.decode._getBPP(t), i = o >> 3, a = Math.ceil(r * o / 8), s = new Uint8Array(n * a), c = 0, l = [0, 0, 4, 0, 2, 0, 1], u = [0, 4, 0, 2, 0, 1, 0], d = [8, 8, 8, 4, 4, 2, 2], f = [8, 8, 4, 4, 2, 2, 1], h = 0; h < 7; ) {
    for (var g = d[h], v = f[h], y = 0, b = 0, x = l[h]; x < n; )
      x += g, b++;
    for (var C = u[h]; C < r; )
      C += v, y++;
    var E = Math.ceil(y * o / 8);
    _.decode._filterZero(e, t, c, y, b);
    for (var D = 0, A = l[h]; A < n; ) {
      for (var R = u[h], O = c + D * E << 3; R < r; ) {
        if (o == 1) {
          var W = e[O >> 3];
          W = W >> 7 - (O & 7) & 1, s[A * a + (R >> 3)] |= W << 7 - ((R & 7) << 0);
        }
        if (o == 2) {
          var W = e[O >> 3];
          W = W >> 6 - (O & 7) & 3, s[A * a + (R >> 2)] |= W << 6 - ((R & 3) << 1);
        }
        if (o == 4) {
          var W = e[O >> 3];
          W = W >> 4 - (O & 7) & 15, s[A * a + (R >> 1)] |= W << 4 - ((R & 1) << 2);
        }
        if (o >= 8)
          for (var z = A * a + R * i, q = 0; q < i; q++) s[z + q] = e[(O >> 3) + q];
        O += o, R += v;
      }
      D++, A += g;
    }
    y * b != 0 && (c += b * (1 + E)), h = h + 1;
  }
  return s;
};
_.decode._getBPP = function(e) {
  var t = [1, null, 3, 1, 2, null, 4][e.ctype];
  return t * e.depth;
};
_.decode._filterZero = function(e, t, r, n, o) {
  var i = _.decode._getBPP(t), a = Math.ceil(n * i / 8), s = _.decode._paeth;
  i = Math.ceil(i / 8);
  var c = 0, l = 1, u = e[r], d = 0;
  if (u > 1 && (e[r] = [0, 0, 1][u - 2]), u == 3) for (d = i; d < a; d++) e[d + 1] = e[d + 1] + (e[d + 1 - i] >>> 1) & 255;
  for (var f = 0; f < o; f++)
    if (c = r + f * a, l = c + f + 1, u = e[l - 1], d = 0, u == 0) for (; d < a; d++) e[c + d] = e[l + d];
    else if (u == 1) {
      for (; d < i; d++) e[c + d] = e[l + d];
      for (; d < a; d++) e[c + d] = e[l + d] + e[c + d - i];
    } else if (u == 2)
      for (; d < a; d++) e[c + d] = e[l + d] + e[c + d - a];
    else if (u == 3) {
      for (; d < i; d++) e[c + d] = e[l + d] + (e[c + d - a] >>> 1);
      for (; d < a; d++) e[c + d] = e[l + d] + (e[c + d - a] + e[c + d - i] >>> 1);
    } else {
      for (; d < i; d++) e[c + d] = e[l + d] + s(0, e[c + d - a], 0);
      for (; d < a; d++) e[c + d] = e[l + d] + s(e[c + d - i], e[c + d - a], e[c + d - i - a]);
    }
  return e;
};
_.decode._paeth = function(e, t, r) {
  var n = e + t - r, o = n - e, i = n - t, a = n - r;
  return o * o <= i * i && o * o <= a * a ? e : i * i <= a * a ? t : r;
};
_.decode._IHDR = function(e, t, r) {
  var n = _._bin;
  r.width = n.readUint(e, t), t += 4, r.height = n.readUint(e, t), t += 4, r.depth = e[t], t++, r.ctype = e[t], t++, r.compress = e[t], t++, r.filter = e[t], t++, r.interlace = e[t], t++;
};
_._bin = {
  nextZero: function(e, t) {
    for (; e[t] != 0; ) t++;
    return t;
  },
  readUshort: function(e, t) {
    return e[t] << 8 | e[t + 1];
  },
  writeUshort: function(e, t, r) {
    e[t] = r >> 8 & 255, e[t + 1] = r & 255;
  },
  readUint: function(e, t) {
    return e[t] * (256 * 256 * 256) + (e[t + 1] << 16 | e[t + 2] << 8 | e[t + 3]);
  },
  writeUint: function(e, t, r) {
    e[t] = r >> 24 & 255, e[t + 1] = r >> 16 & 255, e[t + 2] = r >> 8 & 255, e[t + 3] = r & 255;
  },
  readASCII: function(e, t, r) {
    for (var n = "", o = 0; o < r; o++) n += String.fromCharCode(e[t + o]);
    return n;
  },
  writeASCII: function(e, t, r) {
    for (var n = 0; n < r.length; n++) e[t + n] = r.charCodeAt(n);
  },
  readBytes: function(e, t, r) {
    for (var n = [], o = 0; o < r; o++) n.push(e[t + o]);
    return n;
  },
  pad: function(e) {
    return e.length < 2 ? "0" + e : e;
  },
  readUTF8: function(e, t, r) {
    for (var n = "", o, i = 0; i < r; i++) n += "%" + _._bin.pad(e[t + i].toString(16));
    try {
      o = decodeURIComponent(n);
    } catch {
      return _._bin.readASCII(e, t, r);
    }
    return o;
  }
};
_._copyTile = function(e, t, r, n, o, i, a, s, c) {
  for (var l = Math.min(t, o), u = Math.min(r, i), d = 0, f = 0, h = 0; h < u; h++)
    for (var g = 0; g < l; g++)
      if (a >= 0 && s >= 0 ? (d = h * t + g << 2, f = (s + h) * o + a + g << 2) : (d = (-s + h) * t - a + g << 2, f = h * o + g << 2), c == 0)
        n[f] = e[d], n[f + 1] = e[d + 1], n[f + 2] = e[d + 2], n[f + 3] = e[d + 3];
      else if (c == 1) {
        var v = e[d + 3] * 0.00392156862745098, y = e[d] * v, b = e[d + 1] * v, x = e[d + 2] * v, C = n[f + 3] * (1 / 255), E = n[f] * C, D = n[f + 1] * C, A = n[f + 2] * C, R = 1 - v, O = v + C * R, W = O == 0 ? 0 : 1 / O;
        n[f + 3] = 255 * O, n[f + 0] = (y + E * R) * W, n[f + 1] = (b + D * R) * W, n[f + 2] = (x + A * R) * W;
      } else if (c == 2) {
        var v = e[d + 3], y = e[d], b = e[d + 1], x = e[d + 2], C = n[f + 3], E = n[f], D = n[f + 1], A = n[f + 2];
        v == C && y == E && b == D && x == A ? (n[f] = 0, n[f + 1] = 0, n[f + 2] = 0, n[f + 3] = 0) : (n[f] = y, n[f + 1] = b, n[f + 2] = x, n[f + 3] = v);
      } else if (c == 3) {
        var v = e[d + 3], y = e[d], b = e[d + 1], x = e[d + 2], C = n[f + 3], E = n[f], D = n[f + 1], A = n[f + 2];
        if (v == C && y == E && b == D && x == A) continue;
        if (v < 220 && C > 20) return !1;
      }
  return !0;
};
_.encode = function(e, t, r, n, o, i, a) {
  n == null && (n = 0), a == null && (a = !1);
  var s = _.encode.compress(e, t, r, n, [!1, !1, !1, 0, a]);
  return _.encode.compressPNG(s, -1), _.encode._main(s, t, r, o, i);
};
_.encodeLL = function(e, t, r, n, o, i, a, s) {
  for (var c = { ctype: 0 + (n == 1 ? 0 : 2) + (o == 0 ? 0 : 4), depth: i, frames: [] }, l = (n + o) * i, u = l * t, d = 0; d < e.length; d++)
    c.frames.push({ rect: { x: 0, y: 0, width: t, height: r }, img: new Uint8Array(e[d]), blend: 0, dispose: 1, bpp: Math.ceil(l / 8), bpl: Math.ceil(u / 8) });
  _.encode.compressPNG(c, 0, !0);
  var f = _.encode._main(c, t, r, a, s);
  return f;
};
_.encode._main = function(e, t, r, n, o) {
  o == null && (o = {});
  var i = _.crc.crc, a = _._bin.writeUint, s = _._bin.writeUshort, c = _._bin.writeASCII, l = 8, u = e.frames.length > 1, d = !1, f = 33 + (u ? 20 : 0);
  if (o.sRGB != null && (f += 13), o.pHYs != null && (f += 21), e.ctype == 3) {
    for (var h = e.plte.length, g = 0; g < h; g++) e.plte[g] >>> 24 != 255 && (d = !0);
    f += 8 + h * 3 + 4 + (d ? 8 + h * 1 + 4 : 0);
  }
  for (var v = 0; v < e.frames.length; v++) {
    var y = e.frames[v];
    u && (f += 38), f += y.cimg.length + 12, v != 0 && (f += 4);
  }
  f += 12;
  for (var b = new Uint8Array(f), x = [137, 80, 78, 71, 13, 10, 26, 10], g = 0; g < 8; g++) b[g] = x[g];
  if (a(b, l, 13), l += 4, c(b, l, "IHDR"), l += 4, a(b, l, t), l += 4, a(b, l, r), l += 4, b[l] = e.depth, l++, b[l] = e.ctype, l++, b[l] = 0, l++, b[l] = 0, l++, b[l] = 0, l++, a(b, l, i(b, l - 17, 17)), l += 4, o.sRGB != null && (a(b, l, 1), l += 4, c(b, l, "sRGB"), l += 4, b[l] = o.sRGB, l++, a(b, l, i(b, l - 5, 5)), l += 4), o.pHYs != null && (a(b, l, 9), l += 4, c(b, l, "pHYs"), l += 4, a(b, l, o.pHYs[0]), l += 4, a(b, l, o.pHYs[1]), l += 4, b[l] = o.pHYs[2], l++, a(b, l, i(b, l - 13, 13)), l += 4), u && (a(b, l, 8), l += 4, c(b, l, "acTL"), l += 4, a(b, l, e.frames.length), l += 4, a(b, l, o.loop != null ? o.loop : 0), l += 4, a(b, l, i(b, l - 12, 12)), l += 4), e.ctype == 3) {
    var h = e.plte.length;
    a(b, l, h * 3), l += 4, c(b, l, "PLTE"), l += 4;
    for (var g = 0; g < h; g++) {
      var C = g * 3, E = e.plte[g], D = E & 255, A = E >>> 8 & 255, R = E >>> 16 & 255;
      b[l + C + 0] = D, b[l + C + 1] = A, b[l + C + 2] = R;
    }
    if (l += h * 3, a(b, l, i(b, l - h * 3 - 4, h * 3 + 4)), l += 4, d) {
      a(b, l, h), l += 4, c(b, l, "tRNS"), l += 4;
      for (var g = 0; g < h; g++) b[l + g] = e.plte[g] >>> 24 & 255;
      l += h, a(b, l, i(b, l - h - 4, h + 4)), l += 4;
    }
  }
  for (var O = 0, v = 0; v < e.frames.length; v++) {
    var y = e.frames[v];
    u && (a(b, l, 26), l += 4, c(b, l, "fcTL"), l += 4, a(b, l, O++), l += 4, a(b, l, y.rect.width), l += 4, a(b, l, y.rect.height), l += 4, a(b, l, y.rect.x), l += 4, a(b, l, y.rect.y), l += 4, s(b, l, n[v]), l += 2, s(b, l, 1e3), l += 2, b[l] = y.dispose, l++, b[l] = y.blend, l++, a(b, l, i(b, l - 30, 30)), l += 4);
    var W = y.cimg, h = W.length;
    a(b, l, h + (v == 0 ? 0 : 4)), l += 4;
    var z = l;
    c(b, l, v == 0 ? "IDAT" : "fdAT"), l += 4, v != 0 && (a(b, l, O++), l += 4), b.set(W, l), l += h, a(b, l, i(b, z, l - z)), l += 4;
  }
  return a(b, l, 0), l += 4, c(b, l, "IEND"), l += 4, a(b, l, i(b, l - 4, 4)), l += 4, b.buffer;
};
_.encode.compressPNG = function(e, t, r) {
  for (var n = 0; n < e.frames.length; n++) {
    var o = e.frames[n];
    o.rect.width;
    var i = o.rect.height, a = new Uint8Array(i * o.bpl + i);
    o.cimg = _.encode._filterZero(o.img, i, o.bpp, o.bpl, a, t, r);
  }
};
_.encode.compress = function(e, t, r, n, o) {
  for (var i = o[0], a = o[1], s = o[2], c = o[3], l = o[4], u = 6, d = 8, f = 255, h = 0; h < e.length; h++)
    for (var g = new Uint8Array(e[h]), v = g.length, y = 0; y < v; y += 4) f &= g[y + 3];
  var b = f != 255, x = _.encode.framize(e, t, r, i, a, s), C = {}, E = [], D = [];
  if (n != 0) {
    for (var A = [], y = 0; y < x.length; y++) A.push(x[y].img.buffer);
    for (var R = _.encode.concatRGBA(A), O = _.quantize(R, n), W = 0, z = new Uint8Array(O.abuf), y = 0; y < x.length; y++) {
      var q = x[y].img, V = q.length;
      D.push(new Uint8Array(O.inds.buffer, W >> 2, V >> 2));
      for (var h = 0; h < V; h += 4)
        q[h] = z[W + h], q[h + 1] = z[W + h + 1], q[h + 2] = z[W + h + 2], q[h + 3] = z[W + h + 3];
      W += V;
    }
    for (var y = 0; y < O.plte.length; y++) E.push(O.plte[y].est.rgba);
  } else
    for (var h = 0; h < x.length; h++) {
      var I = x[h], Z = new Uint32Array(I.img.buffer), Q = I.rect.width, v = Z.length, K = new Uint8Array(v);
      D.push(K);
      for (var y = 0; y < v; y++) {
        var L = Z[y];
        if (y != 0 && L == Z[y - 1]) K[y] = K[y - 1];
        else if (y > Q && L == Z[y - Q]) K[y] = K[y - Q];
        else {
          var U = C[L];
          if (U == null && (C[L] = U = E.length, E.push(L), E.length >= 300))
            break;
          K[y] = U;
        }
      }
    }
  var Y = E.length;
  Y <= 256 && l == !1 && (Y <= 2 ? d = 1 : Y <= 4 ? d = 2 : Y <= 16 ? d = 4 : d = 8, d = Math.max(d, c));
  for (var h = 0; h < x.length; h++) {
    var I = x[h];
    I.rect.x, I.rect.y;
    var Q = I.rect.width, he = I.rect.height, ce = I.img;
    new Uint32Array(ce.buffer);
    var ke = 4 * Q, Ie = 4;
    if (Y <= 256 && l == !1) {
      ke = Math.ceil(d * Q / 8);
      for (var Ne = new Uint8Array(ke * he), qe = D[h], ge = 0; ge < he; ge++) {
        var y = ge * ke, ee = ge * Q;
        if (d == 8) for (var oe = 0; oe < Q; oe++) Ne[y + oe] = qe[ee + oe];
        else if (d == 4) for (var oe = 0; oe < Q; oe++) Ne[y + (oe >> 1)] |= qe[ee + oe] << 4 - (oe & 1) * 4;
        else if (d == 2) for (var oe = 0; oe < Q; oe++) Ne[y + (oe >> 2)] |= qe[ee + oe] << 6 - (oe & 3) * 2;
        else if (d == 1) for (var oe = 0; oe < Q; oe++) Ne[y + (oe >> 3)] |= qe[ee + oe] << 7 - (oe & 7) * 1;
      }
      ce = Ne, u = 3, Ie = 1;
    } else if (b == !1 && x.length == 1) {
      for (var Ne = new Uint8Array(Q * he * 3), We = Q * he, y = 0; y < We; y++) {
        var q = y * 3, Fe = y * 4;
        Ne[q] = ce[Fe], Ne[q + 1] = ce[Fe + 1], Ne[q + 2] = ce[Fe + 2];
      }
      ce = Ne, u = 2, Ie = 3, ke = 3 * Q;
    }
    I.img = ce, I.bpl = ke, I.bpp = Ie;
  }
  return { ctype: u, depth: d, plte: E, frames: x };
};
_.encode.framize = function(e, t, r, n, o, i) {
  for (var a = [], s = 0; s < e.length; s++) {
    var c = new Uint8Array(e[s]), l = new Uint32Array(c.buffer), u, d = 0, f = 0, h = t, g = r, v = n ? 1 : 0;
    if (s != 0) {
      for (var y = i || n || s == 1 || a[s - 2].dispose != 0 ? 1 : 2, b = 0, x = 1e9, C = 0; C < y; C++) {
        for (var I = new Uint8Array(e[s - 1 - C]), E = new Uint32Array(e[s - 1 - C]), D = t, A = r, R = -1, O = -1, W = 0; W < r; W++) for (var z = 0; z < t; z++) {
          var q = W * t + z;
          l[q] != E[q] && (z < D && (D = z), z > R && (R = z), W < A && (A = W), W > O && (O = W));
        }
        R == -1 && (D = A = R = O = 0), o && ((D & 1) == 1 && D--, (A & 1) == 1 && A--);
        var V = (R - D + 1) * (O - A + 1);
        V < x && (x = V, b = C, d = D, f = A, h = R - D + 1, g = O - A + 1);
      }
      var I = new Uint8Array(e[s - 1 - b]);
      b == 1 && (a[s - 1].dispose = 2), u = new Uint8Array(h * g * 4), _._copyTile(I, t, r, u, h, g, -d, -f, 0), v = _._copyTile(c, t, r, u, h, g, -d, -f, 3) ? 1 : 0, v == 1 ? _.encode._prepareDiff(c, t, r, u, { x: d, y: f, width: h, height: g }) : _._copyTile(c, t, r, u, h, g, -d, -f, 0);
    } else u = c.slice(0);
    a.push({ rect: { x: d, y: f, width: h, height: g }, img: u, blend: v, dispose: 0 });
  }
  if (n) for (var s = 0; s < a.length; s++) {
    var Z = a[s];
    if (Z.blend != 1) {
      var Q = Z.rect, K = a[s - 1].rect, L = Math.min(Q.x, K.x), U = Math.min(Q.y, K.y), Y = Math.max(Q.x + Q.width, K.x + K.width), he = Math.max(Q.y + Q.height, K.y + K.height), ce = { x: L, y: U, width: Y - L, height: he - U };
      a[s - 1].dispose = 1, s - 1 != 0 && _.encode._updateFrame(e, t, r, a, s - 1, ce, o), _.encode._updateFrame(e, t, r, a, s, ce, o);
    }
  }
  var ke = 0;
  if (e.length != 1) for (var q = 0; q < a.length; q++) {
    var Z = a[q];
    ke += Z.rect.width * Z.rect.height;
  }
  return a;
};
_.encode._updateFrame = function(e, t, r, n, o, i, a) {
  for (var s = Uint8Array, c = Uint32Array, l = new s(e[o - 1]), u = new c(e[o - 1]), d = o + 1 < e.length ? new s(e[o + 1]) : null, f = new s(e[o]), h = new c(f.buffer), g = t, v = r, y = -1, b = -1, x = 0; x < i.height; x++) for (var C = 0; C < i.width; C++) {
    var E = i.x + C, D = i.y + x, A = D * t + E, R = h[A];
    R == 0 || n[o - 1].dispose == 0 && u[A] == R && (d == null || d[A * 4 + 3] != 0) || (E < g && (g = E), E > y && (y = E), D < v && (v = D), D > b && (b = D));
  }
  y == -1 && (g = v = y = b = 0), a && ((g & 1) == 1 && g--, (v & 1) == 1 && v--), i = { x: g, y: v, width: y - g + 1, height: b - v + 1 };
  var O = n[o];
  O.rect = i, O.blend = 1, O.img = new Uint8Array(i.width * i.height * 4), n[o - 1].dispose == 0 ? (_._copyTile(l, t, r, O.img, i.width, i.height, -i.x, -i.y, 0), _.encode._prepareDiff(f, t, r, O.img, i)) : _._copyTile(f, t, r, O.img, i.width, i.height, -i.x, -i.y, 0);
};
_.encode._prepareDiff = function(e, t, r, n, o) {
  _._copyTile(e, t, r, n, o.width, o.height, -o.x, -o.y, 2);
};
_.encode._filterZero = function(e, t, r, n, o, i, a) {
  var s = [], c = [0, 1, 2, 3, 4];
  i != -1 ? c = [i] : (t * n > 5e5 || r == 1) && (c = [0]);
  var l;
  a && (l = { level: 0 });
  for (var u = a && UZIP != null ? UZIP : Es, d = 0; d < c.length; d++) {
    for (var f = 0; f < t; f++) _.encode._filterLine(o, e, f, n, r, c[d]);
    s.push(u.deflate(o, l));
  }
  for (var h, g = 1e9, d = 0; d < s.length; d++) s[d].length < g && (h = d, g = s[d].length);
  return s[h];
};
_.encode._filterLine = function(e, t, r, n, o, i) {
  var a = r * n, s = a + r, c = _.decode._paeth;
  if (e[s] = i, s++, i == 0)
    if (n < 500) for (var l = 0; l < n; l++) e[s + l] = t[a + l];
    else e.set(new Uint8Array(t.buffer, a, n), s);
  else if (i == 1) {
    for (var l = 0; l < o; l++) e[s + l] = t[a + l];
    for (var l = o; l < n; l++) e[s + l] = t[a + l] - t[a + l - o] + 256 & 255;
  } else if (r == 0) {
    for (var l = 0; l < o; l++) e[s + l] = t[a + l];
    if (i == 2) for (var l = o; l < n; l++) e[s + l] = t[a + l];
    if (i == 3) for (var l = o; l < n; l++) e[s + l] = t[a + l] - (t[a + l - o] >> 1) + 256 & 255;
    if (i == 4) for (var l = o; l < n; l++) e[s + l] = t[a + l] - c(t[a + l - o], 0, 0) + 256 & 255;
  } else {
    if (i == 2)
      for (var l = 0; l < n; l++) e[s + l] = t[a + l] + 256 - t[a + l - n] & 255;
    if (i == 3) {
      for (var l = 0; l < o; l++) e[s + l] = t[a + l] + 256 - (t[a + l - n] >> 1) & 255;
      for (var l = o; l < n; l++) e[s + l] = t[a + l] + 256 - (t[a + l - n] + t[a + l - o] >> 1) & 255;
    }
    if (i == 4) {
      for (var l = 0; l < o; l++) e[s + l] = t[a + l] + 256 - c(0, t[a + l - n], 0) & 255;
      for (var l = o; l < n; l++) e[s + l] = t[a + l] + 256 - c(t[a + l - o], t[a + l - n], t[a + l - o - n]) & 255;
    }
  }
};
_.crc = {
  table: (function() {
    for (var e = new Uint32Array(256), t = 0; t < 256; t++) {
      for (var r = t, n = 0; n < 8; n++)
        r & 1 ? r = 3988292384 ^ r >>> 1 : r = r >>> 1;
      e[t] = r;
    }
    return e;
  })(),
  update: function(e, t, r, n) {
    for (var o = 0; o < n; o++) e = _.crc.table[(e ^ t[r + o]) & 255] ^ e >>> 8;
    return e;
  },
  crc: function(e, t, r) {
    return _.crc.update(4294967295, e, t, r) ^ 4294967295;
  }
};
_.quantize = function(e, t) {
  var r = new Uint8Array(e), n = r.slice(0), o = new Uint32Array(n.buffer), i = _.quantize.getKDtree(n, t), a = i[0], s = i[1];
  _.quantize.planeDst;
  for (var c = r, l = o, u = c.length, d = new Uint8Array(r.length >> 2), f = 0; f < u; f += 4) {
    var h = c[f] * 0.00392156862745098, g = c[f + 1] * (1 / 255), v = c[f + 2] * (1 / 255), y = c[f + 3] * (1 / 255), b = _.quantize.getNearest(a, h, g, v, y);
    d[f >> 2] = b.ind, l[f >> 2] = b.est.rgba;
  }
  return { abuf: n.buffer, inds: d, plte: s };
};
_.quantize.getKDtree = function(e, t, r) {
  r == null && (r = 1e-4);
  var n = new Uint32Array(e.buffer), o = { i0: 0, i1: e.length, bst: null, est: null, tdst: 0, left: null, right: null };
  o.bst = _.quantize.stats(e, o.i0, o.i1), o.est = _.quantize.estats(o.bst);
  for (var i = [o]; i.length < t; ) {
    for (var a = 0, s = 0, c = 0; c < i.length; c++) i[c].est.L > a && (a = i[c].est.L, s = c);
    if (a < r) break;
    var l = i[s], u = _.quantize.splitPixels(e, n, l.i0, l.i1, l.est.e, l.est.eMq255), d = l.i0 >= u || l.i1 <= u;
    if (d) {
      l.est.L = 0;
      continue;
    }
    var f = { i0: l.i0, i1: u, bst: null, est: null, tdst: 0, left: null, right: null };
    f.bst = _.quantize.stats(e, f.i0, f.i1), f.est = _.quantize.estats(f.bst);
    var h = { i0: u, i1: l.i1, bst: null, est: null, tdst: 0, left: null, right: null };
    h.bst = { R: [], m: [], N: l.bst.N - f.bst.N };
    for (var c = 0; c < 16; c++) h.bst.R[c] = l.bst.R[c] - f.bst.R[c];
    for (var c = 0; c < 4; c++) h.bst.m[c] = l.bst.m[c] - f.bst.m[c];
    h.est = _.quantize.estats(h.bst), l.left = f, l.right = h, i[s] = f, i.push(h);
  }
  i.sort(function(g, v) {
    return v.bst.N - g.bst.N;
  });
  for (var c = 0; c < i.length; c++) i[c].ind = c;
  return [o, i];
};
_.quantize.getNearest = function(e, t, r, n, o) {
  if (e.left == null)
    return e.tdst = _.quantize.dist(e.est.q, t, r, n, o), e;
  var i = _.quantize.planeDst(e.est, t, r, n, o), a = e.left, s = e.right;
  i > 0 && (a = e.right, s = e.left);
  var c = _.quantize.getNearest(a, t, r, n, o);
  if (c.tdst <= i * i) return c;
  var l = _.quantize.getNearest(s, t, r, n, o);
  return l.tdst < c.tdst ? l : c;
};
_.quantize.planeDst = function(e, t, r, n, o) {
  var i = e.e;
  return i[0] * t + i[1] * r + i[2] * n + i[3] * o - e.eMq;
};
_.quantize.dist = function(e, t, r, n, o) {
  var i = t - e[0], a = r - e[1], s = n - e[2], c = o - e[3];
  return i * i + a * a + s * s + c * c;
};
_.quantize.splitPixels = function(e, t, r, n, o, i) {
  var a = _.quantize.vecDot;
  for (n -= 4; r < n; ) {
    for (; a(e, r, o) <= i; ) r += 4;
    for (; a(e, n, o) > i; ) n -= 4;
    if (r >= n) break;
    var s = t[r >> 2];
    t[r >> 2] = t[n >> 2], t[n >> 2] = s, r += 4, n -= 4;
  }
  for (; a(e, r, o) > i; ) r -= 4;
  return r + 4;
};
_.quantize.vecDot = function(e, t, r) {
  return e[t] * r[0] + e[t + 1] * r[1] + e[t + 2] * r[2] + e[t + 3] * r[3];
};
_.quantize.stats = function(e, t, r) {
  for (var n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], o = [0, 0, 0, 0], i = r - t >> 2, a = t; a < r; a += 4) {
    var s = e[a] * 0.00392156862745098, c = e[a + 1] * (1 / 255), l = e[a + 2] * (1 / 255), u = e[a + 3] * (1 / 255);
    o[0] += s, o[1] += c, o[2] += l, o[3] += u, n[0] += s * s, n[1] += s * c, n[2] += s * l, n[3] += s * u, n[5] += c * c, n[6] += c * l, n[7] += c * u, n[10] += l * l, n[11] += l * u, n[15] += u * u;
  }
  return n[4] = n[1], n[8] = n[2], n[9] = n[6], n[12] = n[3], n[13] = n[7], n[14] = n[11], { R: n, m: o, N: i };
};
_.quantize.estats = function(e) {
  var t = e.R, r = e.m, n = e.N, o = r[0], i = r[1], a = r[2], s = r[3], c = n == 0 ? 0 : 1 / n, l = [
    t[0] - o * o * c,
    t[1] - o * i * c,
    t[2] - o * a * c,
    t[3] - o * s * c,
    t[4] - i * o * c,
    t[5] - i * i * c,
    t[6] - i * a * c,
    t[7] - i * s * c,
    t[8] - a * o * c,
    t[9] - a * i * c,
    t[10] - a * a * c,
    t[11] - a * s * c,
    t[12] - s * o * c,
    t[13] - s * i * c,
    t[14] - s * a * c,
    t[15] - s * s * c
  ], u = l, d = _.M4, f = [0.5, 0.5, 0.5, 0.5], h = 0, g = 0;
  if (n != 0)
    for (var v = 0; v < 10 && (f = d.multVec(u, f), g = Math.sqrt(d.dot(f, f)), f = d.sml(1 / g, f), !(Math.abs(g - h) < 1e-9)); v++)
      h = g;
  var y = [o * c, i * c, a * c, s * c], b = d.dot(d.sml(255, y), f);
  return {
    Cov: l,
    q: y,
    e: f,
    L: h,
    eMq255: b,
    eMq: d.dot(f, y),
    rgba: (Math.round(255 * y[3]) << 24 | Math.round(255 * y[2]) << 16 | Math.round(255 * y[1]) << 8 | Math.round(255 * y[0]) << 0) >>> 0
  };
};
_.M4 = {
  multVec: function(e, t) {
    return [
      e[0] * t[0] + e[1] * t[1] + e[2] * t[2] + e[3] * t[3],
      e[4] * t[0] + e[5] * t[1] + e[6] * t[2] + e[7] * t[3],
      e[8] * t[0] + e[9] * t[1] + e[10] * t[2] + e[11] * t[3],
      e[12] * t[0] + e[13] * t[1] + e[14] * t[2] + e[15] * t[3]
    ];
  },
  dot: function(e, t) {
    return e[0] * t[0] + e[1] * t[1] + e[2] * t[2] + e[3] * t[3];
  },
  sml: function(e, t) {
    return [e * t[0], e * t[1], e * t[2], e * t[3]];
  }
};
_.encode.concatRGBA = function(e) {
  for (var t = 0, r = 0; r < e.length; r++) t += e[r].byteLength;
  for (var n = new Uint8Array(t), o = 0, r = 0; r < e.length; r++) {
    for (var i = new Uint8Array(e[r]), a = i.length, s = 0; s < a; s += 4) {
      var c = i[s], l = i[s + 1], u = i[s + 2], d = i[s + 3];
      d == 0 && (c = l = u = 0), n[o + s] = c, n[o + s + 1] = l, n[o + s + 2] = u, n[o + s + 3] = d;
    }
    o += a;
  }
  return n.buffer;
};
var MR = function(e) {
  if (e === 0)
    return zn.Greyscale;
  if (e === 2)
    return zn.Truecolour;
  if (e === 3)
    return zn.IndexedColour;
  if (e === 4)
    return zn.GreyscaleWithAlpha;
  if (e === 6)
    return zn.TruecolourWithAlpha;
  throw new Error("Unknown color type: " + e);
}, IR = function(e) {
  for (var t = Math.floor(e.length / 4), r = new Uint8Array(t * 3), n = new Uint8Array(t * 1), o = 0, i = 0, a = 0; o < e.length; )
    r[i++] = e[o++], r[i++] = e[o++], r[i++] = e[o++], n[a++] = e[o++];
  return { rgbChannel: r, alphaChannel: n };
}, zn;
(function(e) {
  e.Greyscale = "Greyscale", e.Truecolour = "Truecolour", e.IndexedColour = "IndexedColour", e.GreyscaleWithAlpha = "GreyscaleWithAlpha", e.TruecolourWithAlpha = "TruecolourWithAlpha";
})(zn || (zn = {}));
var BR = (
  /** @class */
  (function() {
    function e(t) {
      var r = _.decode(t), n = _.toRGBA8(r);
      if (n.length > 1)
        throw new Error("Animated PNGs are not supported");
      var o = new Uint8Array(n[0]), i = IR(o), a = i.rgbChannel, s = i.alphaChannel;
      this.rgbChannel = a;
      var c = s.some(function(l) {
        return l < 255;
      });
      c && (this.alphaChannel = s), this.type = MR(r.ctype), this.width = r.width, this.height = r.height, this.bitsPerComponent = 8;
    }
    return e.load = function(t) {
      return new e(t);
    }, e;
  })()
), rm = (
  /** @class */
  (function() {
    function e(t) {
      this.image = t, this.bitsPerComponent = t.bitsPerComponent, this.width = t.width, this.height = t.height, this.colorSpace = "DeviceRGB";
    }
    return e.for = function(t) {
      return Re(this, void 0, void 0, function() {
        var r;
        return Te(this, function(n) {
          return r = BR.load(t), [2, new e(r)];
        });
      });
    }, e.prototype.embedIntoContext = function(t, r) {
      return Re(this, void 0, void 0, function() {
        var n, o;
        return Te(this, function(i) {
          return n = this.embedAlphaChannel(t), o = t.flateStream(this.image.rgbChannel, {
            Type: "XObject",
            Subtype: "Image",
            BitsPerComponent: this.image.bitsPerComponent,
            Width: this.image.width,
            Height: this.image.height,
            ColorSpace: this.colorSpace,
            SMask: n
          }), r ? (t.assign(r, o), [2, r]) : [2, t.register(o)];
        });
      });
    }, e.prototype.embedAlphaChannel = function(t) {
      if (this.image.alphaChannel) {
        var r = t.flateStream(this.image.alphaChannel, {
          Type: "XObject",
          Subtype: "Image",
          Height: this.image.height,
          Width: this.image.width,
          BitsPerComponent: this.image.bitsPerComponent,
          ColorSpace: "DeviceGray",
          Decode: [0, 1]
        });
        return t.register(r);
      }
    }, e;
  })()
), nm = (
  /** @class */
  (function() {
    function e(t, r, n) {
      this.bytes = t, this.start = r || 0, this.pos = this.start, this.end = r && n ? r + n : this.bytes.length;
    }
    return Object.defineProperty(e.prototype, "length", {
      get: function() {
        return this.end - this.start;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "isEmpty", {
      get: function() {
        return this.length === 0;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getByte = function() {
      return this.pos >= this.end ? -1 : this.bytes[this.pos++];
    }, e.prototype.getUint16 = function() {
      var t = this.getByte(), r = this.getByte();
      return t === -1 || r === -1 ? -1 : (t << 8) + r;
    }, e.prototype.getInt32 = function() {
      var t = this.getByte(), r = this.getByte(), n = this.getByte(), o = this.getByte();
      return (t << 24) + (r << 16) + (n << 8) + o;
    }, e.prototype.getBytes = function(t, r) {
      r === void 0 && (r = !1);
      var n = this.bytes, o = this.pos, i = this.end;
      if (t) {
        var s = o + t;
        s > i && (s = i), this.pos = s;
        var a = n.subarray(o, s);
        return r ? new Uint8ClampedArray(a) : a;
      } else {
        var a = n.subarray(o, i);
        return r ? new Uint8ClampedArray(a) : a;
      }
    }, e.prototype.peekByte = function() {
      var t = this.getByte();
      return this.pos--, t;
    }, e.prototype.peekBytes = function(t, r) {
      r === void 0 && (r = !1);
      var n = this.getBytes(t, r);
      return this.pos -= n.length, n;
    }, e.prototype.skip = function(t) {
      t || (t = 1), this.pos += t;
    }, e.prototype.reset = function() {
      this.pos = this.start;
    }, e.prototype.moveStart = function() {
      this.start = this.pos;
    }, e.prototype.makeSubStream = function(t, r) {
      return new e(this.bytes, t, r);
    }, e.prototype.decode = function() {
      return this.bytes;
    }, e;
  })()
), LR = new Uint8Array(0), Vi = (
  /** @class */
  (function() {
    function e(t) {
      if (this.pos = 0, this.bufferLength = 0, this.eof = !1, this.buffer = LR, this.minBufferLength = 512, t)
        for (; this.minBufferLength < t; )
          this.minBufferLength *= 2;
    }
    return Object.defineProperty(e.prototype, "isEmpty", {
      get: function() {
        for (; !this.eof && this.bufferLength === 0; )
          this.readBlock();
        return this.bufferLength === 0;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.getByte = function() {
      for (var t = this.pos; this.bufferLength <= t; ) {
        if (this.eof)
          return -1;
        this.readBlock();
      }
      return this.buffer[this.pos++];
    }, e.prototype.getUint16 = function() {
      var t = this.getByte(), r = this.getByte();
      return t === -1 || r === -1 ? -1 : (t << 8) + r;
    }, e.prototype.getInt32 = function() {
      var t = this.getByte(), r = this.getByte(), n = this.getByte(), o = this.getByte();
      return (t << 24) + (r << 16) + (n << 8) + o;
    }, e.prototype.getBytes = function(t, r) {
      r === void 0 && (r = !1);
      var n, o = this.pos;
      if (t) {
        for (this.ensureBuffer(o + t), n = o + t; !this.eof && this.bufferLength < n; )
          this.readBlock();
        var i = this.bufferLength;
        n > i && (n = i);
      } else {
        for (; !this.eof; )
          this.readBlock();
        n = this.bufferLength;
      }
      this.pos = n;
      var a = this.buffer.subarray(o, n);
      return r && !(a instanceof Uint8ClampedArray) ? new Uint8ClampedArray(a) : a;
    }, e.prototype.peekByte = function() {
      var t = this.getByte();
      return this.pos--, t;
    }, e.prototype.peekBytes = function(t, r) {
      r === void 0 && (r = !1);
      var n = this.getBytes(t, r);
      return this.pos -= n.length, n;
    }, e.prototype.skip = function(t) {
      t || (t = 1), this.pos += t;
    }, e.prototype.reset = function() {
      this.pos = 0;
    }, e.prototype.makeSubStream = function(t, r) {
      for (var n = t + r; this.bufferLength <= n && !this.eof; )
        this.readBlock();
      return new nm(
        this.buffer,
        t,
        r
        /* dict */
      );
    }, e.prototype.decode = function() {
      for (; !this.eof; )
        this.readBlock();
      return this.buffer.subarray(0, this.bufferLength);
    }, e.prototype.readBlock = function() {
      throw new tr(this.constructor.name, "readBlock");
    }, e.prototype.ensureBuffer = function(t) {
      var r = this.buffer;
      if (t <= r.byteLength)
        return r;
      for (var n = this.minBufferLength; n < t; )
        n *= 2;
      var o = new Uint8Array(n);
      return o.set(r), this.buffer = o;
    }, e;
  })()
), Pf = function(e) {
  return e === 32 || e === 9 || e === 13 || e === 10;
}, WR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = e.call(this, n) || this;
      return o.stream = r, o.input = new Uint8Array(5), n && (n = 0.8 * n), o;
    }
    return t.prototype.readBlock = function() {
      for (var r = 126, n = 122, o = -1, i = this.stream, a = i.getByte(); Pf(a); )
        a = i.getByte();
      if (a === o || a === r) {
        this.eof = !0;
        return;
      }
      var s = this.bufferLength, c, l;
      if (a === n) {
        for (c = this.ensureBuffer(s + 4), l = 0; l < 4; ++l)
          c[s + l] = 0;
        this.bufferLength += 4;
      } else {
        var u = this.input;
        for (u[0] = a, l = 1; l < 5; ++l) {
          for (a = i.getByte(); Pf(a); )
            a = i.getByte();
          if (u[l] = a, a === o || a === r)
            break;
        }
        if (c = this.ensureBuffer(s + l - 1), this.bufferLength += l - 1, l < 5) {
          for (; l < 5; ++l)
            u[l] = 117;
          this.eof = !0;
        }
        var d = 0;
        for (l = 0; l < 5; ++l)
          d = d * 85 + (u[l] - 33);
        for (l = 3; l >= 0; --l)
          c[s + l] = d & 255, d >>= 8;
      }
    }, t;
  })(Vi)
), zR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = e.call(this, n) || this;
      return o.stream = r, o.firstDigit = -1, n && (n = 0.5 * n), o;
    }
    return t.prototype.readBlock = function() {
      var r = 8e3, n = this.stream.getBytes(r);
      if (!n.length) {
        this.eof = !0;
        return;
      }
      for (var o = n.length + 1 >> 1, i = this.ensureBuffer(this.bufferLength + o), a = this.bufferLength, s = this.firstDigit, c = 0, l = n.length; c < l; c++) {
        var u = n[c], d = void 0;
        if (u >= 48 && u <= 57)
          d = u & 15;
        else if (u >= 65 && u <= 70 || u >= 97 && u <= 102)
          d = (u & 15) + 9;
        else if (u === 62) {
          this.eof = !0;
          break;
        } else
          continue;
        s < 0 ? s = d : (i[a++] = s << 4 | d, s = -1);
      }
      s >= 0 && this.eof && (i[a++] = s << 4, s = -1), this.firstDigit = s, this.bufferLength = a;
    }, t;
  })(Vi)
), Ef = new Int32Array([
  16,
  17,
  18,
  0,
  8,
  7,
  9,
  6,
  10,
  5,
  11,
  4,
  12,
  3,
  13,
  2,
  14,
  1,
  15
]), jR = new Int32Array([
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  65547,
  65549,
  65551,
  65553,
  131091,
  131095,
  131099,
  131103,
  196643,
  196651,
  196659,
  196667,
  262211,
  262227,
  262243,
  262259,
  327811,
  327843,
  327875,
  327907,
  258,
  258,
  258
]), UR = new Int32Array([
  1,
  2,
  3,
  4,
  65541,
  65543,
  131081,
  131085,
  196625,
  196633,
  262177,
  262193,
  327745,
  327777,
  393345,
  393409,
  459009,
  459137,
  524801,
  525057,
  590849,
  591361,
  657409,
  658433,
  724993,
  727041,
  794625,
  798721,
  868353,
  876545
]), VR = [new Int32Array([
  459008,
  524368,
  524304,
  524568,
  459024,
  524400,
  524336,
  590016,
  459016,
  524384,
  524320,
  589984,
  524288,
  524416,
  524352,
  590048,
  459012,
  524376,
  524312,
  589968,
  459028,
  524408,
  524344,
  590032,
  459020,
  524392,
  524328,
  59e4,
  524296,
  524424,
  524360,
  590064,
  459010,
  524372,
  524308,
  524572,
  459026,
  524404,
  524340,
  590024,
  459018,
  524388,
  524324,
  589992,
  524292,
  524420,
  524356,
  590056,
  459014,
  524380,
  524316,
  589976,
  459030,
  524412,
  524348,
  590040,
  459022,
  524396,
  524332,
  590008,
  524300,
  524428,
  524364,
  590072,
  459009,
  524370,
  524306,
  524570,
  459025,
  524402,
  524338,
  590020,
  459017,
  524386,
  524322,
  589988,
  524290,
  524418,
  524354,
  590052,
  459013,
  524378,
  524314,
  589972,
  459029,
  524410,
  524346,
  590036,
  459021,
  524394,
  524330,
  590004,
  524298,
  524426,
  524362,
  590068,
  459011,
  524374,
  524310,
  524574,
  459027,
  524406,
  524342,
  590028,
  459019,
  524390,
  524326,
  589996,
  524294,
  524422,
  524358,
  590060,
  459015,
  524382,
  524318,
  589980,
  459031,
  524414,
  524350,
  590044,
  459023,
  524398,
  524334,
  590012,
  524302,
  524430,
  524366,
  590076,
  459008,
  524369,
  524305,
  524569,
  459024,
  524401,
  524337,
  590018,
  459016,
  524385,
  524321,
  589986,
  524289,
  524417,
  524353,
  590050,
  459012,
  524377,
  524313,
  589970,
  459028,
  524409,
  524345,
  590034,
  459020,
  524393,
  524329,
  590002,
  524297,
  524425,
  524361,
  590066,
  459010,
  524373,
  524309,
  524573,
  459026,
  524405,
  524341,
  590026,
  459018,
  524389,
  524325,
  589994,
  524293,
  524421,
  524357,
  590058,
  459014,
  524381,
  524317,
  589978,
  459030,
  524413,
  524349,
  590042,
  459022,
  524397,
  524333,
  590010,
  524301,
  524429,
  524365,
  590074,
  459009,
  524371,
  524307,
  524571,
  459025,
  524403,
  524339,
  590022,
  459017,
  524387,
  524323,
  589990,
  524291,
  524419,
  524355,
  590054,
  459013,
  524379,
  524315,
  589974,
  459029,
  524411,
  524347,
  590038,
  459021,
  524395,
  524331,
  590006,
  524299,
  524427,
  524363,
  590070,
  459011,
  524375,
  524311,
  524575,
  459027,
  524407,
  524343,
  590030,
  459019,
  524391,
  524327,
  589998,
  524295,
  524423,
  524359,
  590062,
  459015,
  524383,
  524319,
  589982,
  459031,
  524415,
  524351,
  590046,
  459023,
  524399,
  524335,
  590014,
  524303,
  524431,
  524367,
  590078,
  459008,
  524368,
  524304,
  524568,
  459024,
  524400,
  524336,
  590017,
  459016,
  524384,
  524320,
  589985,
  524288,
  524416,
  524352,
  590049,
  459012,
  524376,
  524312,
  589969,
  459028,
  524408,
  524344,
  590033,
  459020,
  524392,
  524328,
  590001,
  524296,
  524424,
  524360,
  590065,
  459010,
  524372,
  524308,
  524572,
  459026,
  524404,
  524340,
  590025,
  459018,
  524388,
  524324,
  589993,
  524292,
  524420,
  524356,
  590057,
  459014,
  524380,
  524316,
  589977,
  459030,
  524412,
  524348,
  590041,
  459022,
  524396,
  524332,
  590009,
  524300,
  524428,
  524364,
  590073,
  459009,
  524370,
  524306,
  524570,
  459025,
  524402,
  524338,
  590021,
  459017,
  524386,
  524322,
  589989,
  524290,
  524418,
  524354,
  590053,
  459013,
  524378,
  524314,
  589973,
  459029,
  524410,
  524346,
  590037,
  459021,
  524394,
  524330,
  590005,
  524298,
  524426,
  524362,
  590069,
  459011,
  524374,
  524310,
  524574,
  459027,
  524406,
  524342,
  590029,
  459019,
  524390,
  524326,
  589997,
  524294,
  524422,
  524358,
  590061,
  459015,
  524382,
  524318,
  589981,
  459031,
  524414,
  524350,
  590045,
  459023,
  524398,
  524334,
  590013,
  524302,
  524430,
  524366,
  590077,
  459008,
  524369,
  524305,
  524569,
  459024,
  524401,
  524337,
  590019,
  459016,
  524385,
  524321,
  589987,
  524289,
  524417,
  524353,
  590051,
  459012,
  524377,
  524313,
  589971,
  459028,
  524409,
  524345,
  590035,
  459020,
  524393,
  524329,
  590003,
  524297,
  524425,
  524361,
  590067,
  459010,
  524373,
  524309,
  524573,
  459026,
  524405,
  524341,
  590027,
  459018,
  524389,
  524325,
  589995,
  524293,
  524421,
  524357,
  590059,
  459014,
  524381,
  524317,
  589979,
  459030,
  524413,
  524349,
  590043,
  459022,
  524397,
  524333,
  590011,
  524301,
  524429,
  524365,
  590075,
  459009,
  524371,
  524307,
  524571,
  459025,
  524403,
  524339,
  590023,
  459017,
  524387,
  524323,
  589991,
  524291,
  524419,
  524355,
  590055,
  459013,
  524379,
  524315,
  589975,
  459029,
  524411,
  524347,
  590039,
  459021,
  524395,
  524331,
  590007,
  524299,
  524427,
  524363,
  590071,
  459011,
  524375,
  524311,
  524575,
  459027,
  524407,
  524343,
  590031,
  459019,
  524391,
  524327,
  589999,
  524295,
  524423,
  524359,
  590063,
  459015,
  524383,
  524319,
  589983,
  459031,
  524415,
  524351,
  590047,
  459023,
  524399,
  524335,
  590015,
  524303,
  524431,
  524367,
  590079
]), 9], HR = [new Int32Array([
  327680,
  327696,
  327688,
  327704,
  327684,
  327700,
  327692,
  327708,
  327682,
  327698,
  327690,
  327706,
  327686,
  327702,
  327694,
  0,
  327681,
  327697,
  327689,
  327705,
  327685,
  327701,
  327693,
  327709,
  327683,
  327699,
  327691,
  327707,
  327687,
  327703,
  327695,
  0
]), 5], qR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = e.call(this, n) || this;
      o.stream = r;
      var i = r.getByte(), a = r.getByte();
      if (i === -1 || a === -1)
        throw new Error("Invalid header in flate stream: " + i + ", " + a);
      if ((i & 15) !== 8)
        throw new Error("Unknown compression method in flate stream: " + i + ", " + a);
      if (((i << 8) + a) % 31 !== 0)
        throw new Error("Bad FCHECK in flate stream: " + i + ", " + a);
      if (a & 32)
        throw new Error("FDICT bit set in flate stream: " + i + ", " + a);
      return o.codeSize = 0, o.codeBuf = 0, o;
    }
    return t.prototype.readBlock = function() {
      var r, n, o = this.stream, i = this.getBits(3);
      if (i & 1 && (this.eof = !0), i >>= 1, i === 0) {
        var a = void 0;
        if ((a = o.getByte()) === -1)
          throw new Error("Bad block header in flate stream");
        var s = a;
        if ((a = o.getByte()) === -1)
          throw new Error("Bad block header in flate stream");
        if (s |= a << 8, (a = o.getByte()) === -1)
          throw new Error("Bad block header in flate stream");
        var c = a;
        if ((a = o.getByte()) === -1)
          throw new Error("Bad block header in flate stream");
        if (c |= a << 8, c !== (~s & 65535) && (s !== 0 || c !== 0))
          throw new Error("Bad uncompressed block length in flate stream");
        this.codeBuf = 0, this.codeSize = 0;
        var l = this.bufferLength;
        r = this.ensureBuffer(l + s);
        var u = l + s;
        if (this.bufferLength = u, s === 0)
          o.peekByte() === -1 && (this.eof = !0);
        else
          for (var d = l; d < u; ++d) {
            if ((a = o.getByte()) === -1) {
              this.eof = !0;
              break;
            }
            r[d] = a;
          }
        return;
      }
      var f, h;
      if (i === 1)
        f = VR, h = HR;
      else if (i === 2) {
        var g = this.getBits(5) + 257, v = this.getBits(5) + 1, y = this.getBits(4) + 4, b = new Uint8Array(Ef.length), x = void 0;
        for (x = 0; x < y; ++x)
          b[Ef[x]] = this.getBits(3);
        var C = this.generateHuffmanTable(b);
        n = 0, x = 0;
        for (var E = g + v, D = new Uint8Array(E), A = void 0, R = void 0, O = void 0; x < E; ) {
          var W = this.getCode(C);
          if (W === 16)
            A = 2, R = 3, O = n;
          else if (W === 17)
            A = 3, R = 3, O = n = 0;
          else if (W === 18)
            A = 7, R = 11, O = n = 0;
          else {
            D[x++] = n = W;
            continue;
          }
          for (var z = this.getBits(A) + R; z-- > 0; )
            D[x++] = O;
        }
        f = this.generateHuffmanTable(D.subarray(0, g)), h = this.generateHuffmanTable(D.subarray(g, E));
      } else
        throw new Error("Unknown block type in flate stream");
      r = this.buffer;
      for (var q = r ? r.length : 0, V = this.bufferLength; ; ) {
        var I = this.getCode(f);
        if (I < 256) {
          V + 1 >= q && (r = this.ensureBuffer(V + 1), q = r.length), r[V++] = I;
          continue;
        }
        if (I === 256) {
          this.bufferLength = V;
          return;
        }
        I -= 257, I = jR[I];
        var Z = I >> 16;
        Z > 0 && (Z = this.getBits(Z)), n = (I & 65535) + Z, I = this.getCode(h), I = UR[I], Z = I >> 16, Z > 0 && (Z = this.getBits(Z));
        var Q = (I & 65535) + Z;
        V + n >= q && (r = this.ensureBuffer(V + n), q = r.length);
        for (var K = 0; K < n; ++K, ++V)
          r[V] = r[V - Q];
      }
    }, t.prototype.getBits = function(r) {
      for (var n = this.stream, o = this.codeSize, i = this.codeBuf, a; o < r; ) {
        if ((a = n.getByte()) === -1)
          throw new Error("Bad encoding in flate stream");
        i |= a << o, o += 8;
      }
      return a = i & (1 << r) - 1, this.codeBuf = i >> r, this.codeSize = o -= r, a;
    }, t.prototype.getCode = function(r) {
      for (var n = this.stream, o = r[0], i = r[1], a = this.codeSize, s = this.codeBuf, c; a < i && (c = n.getByte()) !== -1; )
        s |= c << a, a += 8;
      var l = o[s & (1 << i) - 1];
      typeof o == "number" && console.log("FLATE:", l);
      var u = l >> 16, d = l & 65535;
      if (u < 1 || a < u)
        throw new Error("Bad encoding in flate stream");
      return this.codeBuf = s >> u, this.codeSize = a - u, d;
    }, t.prototype.generateHuffmanTable = function(r) {
      var n = r.length, o = 0, i;
      for (i = 0; i < n; ++i)
        r[i] > o && (o = r[i]);
      for (var a = 1 << o, s = new Int32Array(a), c = 1, l = 0, u = 2; c <= o; ++c, l <<= 1, u <<= 1)
        for (var d = 0; d < n; ++d)
          if (r[d] === c) {
            var f = 0, h = l;
            for (i = 0; i < c; ++i)
              f = f << 1 | h & 1, h >>= 1;
            for (i = f; i < a; i += u)
              s[i] = c << 16 | d;
            ++l;
          }
      return [s, o];
    }, t;
  })(Vi)
), GR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      var i = e.call(this, n) || this;
      i.stream = r, i.cachedData = 0, i.bitsCached = 0;
      for (var a = 4096, s = {
        earlyChange: o,
        codeLength: 9,
        nextCode: 258,
        dictionaryValues: new Uint8Array(a),
        dictionaryLengths: new Uint16Array(a),
        dictionaryPrevCodes: new Uint16Array(a),
        currentSequence: new Uint8Array(a),
        currentSequenceLength: 0
      }, c = 0; c < 256; ++c)
        s.dictionaryValues[c] = c, s.dictionaryLengths[c] = 1;
      return i.lzwState = s, i;
    }
    return t.prototype.readBlock = function() {
      var r = 512, n = r * 2, o = r, i, a, s, c = this.lzwState;
      if (c) {
        var l = c.earlyChange, u = c.nextCode, d = c.dictionaryValues, f = c.dictionaryLengths, h = c.dictionaryPrevCodes, g = c.codeLength, v = c.prevCode, y = c.currentSequence, b = c.currentSequenceLength, x = 0, C = this.bufferLength, E = this.ensureBuffer(this.bufferLength + n);
        for (i = 0; i < r; i++) {
          var D = this.readBits(g), A = b > 0;
          if (!D || D < 256)
            y[0] = D, b = 1;
          else if (D >= 258)
            if (D < u)
              for (b = f[D], a = b - 1, s = D; a >= 0; a--)
                y[a] = d[s], s = h[s];
            else
              y[b++] = y[0];
          else if (D === 256) {
            g = 9, u = 258, b = 0;
            continue;
          } else {
            this.eof = !0, delete this.lzwState;
            break;
          }
          if (A && (h[u] = v, f[u] = f[v] + 1, d[u] = y[0], u++, g = u + l & u + l - 1 ? g : Math.min(Math.log(u + l) / 0.6931471805599453 + 1, 12) | 0), v = D, x += b, n < x) {
            do
              n += o;
            while (n < x);
            E = this.ensureBuffer(this.bufferLength + n);
          }
          for (a = 0; a < b; a++)
            E[C++] = y[a];
        }
        c.nextCode = u, c.codeLength = g, c.prevCode = v, c.currentSequenceLength = b, this.bufferLength = C;
      }
    }, t.prototype.readBits = function(r) {
      for (var n = this.bitsCached, o = this.cachedData; n < r; ) {
        var i = this.stream.getByte();
        if (i === -1)
          return this.eof = !0, null;
        o = o << 8 | i, n += 8;
      }
      return this.bitsCached = n -= r, this.cachedData = o, o >>> n & (1 << r) - 1;
    }, t;
  })(Vi)
), KR = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = e.call(this, n) || this;
      return o.stream = r, o;
    }
    return t.prototype.readBlock = function() {
      var r = this.stream.getBytes(2);
      if (!r || r.length < 2 || r[0] === 128) {
        this.eof = !0;
        return;
      }
      var n, o = this.bufferLength, i = r[0];
      if (i < 128) {
        if (n = this.ensureBuffer(o + i + 1), n[o++] = r[1], i > 0) {
          var a = this.stream.getBytes(i);
          n.set(a, o), o += i;
        }
      } else {
        i = 257 - i;
        var s = r[1];
        n = this.ensureBuffer(o + i + 1);
        for (var c = 0; c < i; c++)
          n[o++] = s;
      }
      this.bufferLength = o;
    }, t;
  })(Vi)
), kf = function(e, t, r) {
  if (t === F.of("FlateDecode"))
    return new qR(e);
  if (t === F.of("LZWDecode")) {
    var n = 1;
    if (r instanceof De) {
      var o = r.lookup(F.of("EarlyChange"));
      o instanceof we && (n = o.asNumber());
    }
    return new GR(e, void 0, n);
  }
  if (t === F.of("ASCII85Decode"))
    return new WR(e);
  if (t === F.of("ASCIIHexDecode"))
    return new zR(e);
  if (t === F.of("RunLengthDecode"))
    return new KR(e);
  throw new tR(t.asString());
}, om = function(e) {
  var t = e.dict, r = e.contents, n = new nm(r), o = t.lookup(F.of("Filter")), i = t.lookup(F.of("DecodeParms"));
  if (o instanceof F)
    n = kf(n, o, i);
  else if (o instanceof _e)
    for (var a = 0, s = o.size(); a < s; a++)
      n = kf(n, o.lookup(a, F), i && i.lookupMaybe(a, De));
  else if (o)
    throw new za([F, _e], o);
  return n;
}, XR = function(e) {
  var t = e.MediaBox(), r = t.lookup(2, we).asNumber() - t.lookup(0, we).asNumber(), n = t.lookup(3, we).asNumber() - t.lookup(1, we).asNumber();
  return { left: 0, bottom: 0, right: r, top: n };
}, YR = function(e) {
  return [1, 0, 0, 1, -e.left, -e.bottom];
}, im = (
  /** @class */
  (function() {
    function e(t, r, n) {
      this.page = t;
      var o = r ?? XR(t);
      this.width = o.right - o.left, this.height = o.top - o.bottom, this.boundingBox = o, this.transformationMatrix = n ?? YR(o);
    }
    return e.for = function(t, r, n) {
      return Re(this, void 0, void 0, function() {
        return Te(this, function(o) {
          return [2, new e(t, r, n)];
        });
      });
    }, e.prototype.embedIntoContext = function(t, r) {
      return Re(this, void 0, void 0, function() {
        var n, o, i, a, s, c, l, u, d, f;
        return Te(this, function(h) {
          if (n = this.page.normalizedEntries(), o = n.Contents, i = n.Resources, !o)
            throw new rR();
          return a = this.decodeContents(o), s = this.boundingBox, c = s.left, l = s.bottom, u = s.right, d = s.top, f = t.flateStream(a, {
            Type: "XObject",
            Subtype: "Form",
            FormType: 1,
            BBox: [c, l, u, d],
            Matrix: this.transformationMatrix,
            Resources: i
          }), r ? (t.assign(r, f), [2, r]) : [2, t.register(f)];
        });
      });
    }, e.prototype.decodeContents = function(t) {
      for (var r = Uint8Array.of(T.Newline), n = [], o = 0, i = t.size(); o < i; o++) {
        var a = t.lookup(o, Gt), s = void 0;
        if (a instanceof wi)
          s = om(a).decode();
        else if (a instanceof si)
          s = a.getUnencodedContents();
        else
          throw new nR(a);
        n.push(s, r);
      }
      return rD.apply(void 0, n);
    }, e;
  })()
), la = function(e, t) {
  if (e !== void 0)
    return t[e];
}, ci;
(function(e) {
  e.UseNone = "UseNone", e.UseOutlines = "UseOutlines", e.UseThumbs = "UseThumbs", e.UseOC = "UseOC";
})(ci || (ci = {}));
var li;
(function(e) {
  e.L2R = "L2R", e.R2L = "R2L";
})(li || (li = {}));
var ui;
(function(e) {
  e.None = "None", e.AppDefault = "AppDefault";
})(ui || (ui = {}));
var Va;
(function(e) {
  e.Simplex = "Simplex", e.DuplexFlipShortEdge = "DuplexFlipShortEdge", e.DuplexFlipLongEdge = "DuplexFlipLongEdge";
})(Va || (Va = {}));
var Ff = (
  /** @class */
  (function() {
    function e(t) {
      this.dict = t;
    }
    return e.prototype.lookupBool = function(t) {
      var r = this.dict.lookup(F.of(t));
      if (r instanceof bi)
        return r;
    }, e.prototype.lookupName = function(t) {
      var r = this.dict.lookup(F.of(t));
      if (r instanceof F)
        return r;
    }, e.prototype.HideToolbar = function() {
      return this.lookupBool("HideToolbar");
    }, e.prototype.HideMenubar = function() {
      return this.lookupBool("HideMenubar");
    }, e.prototype.HideWindowUI = function() {
      return this.lookupBool("HideWindowUI");
    }, e.prototype.FitWindow = function() {
      return this.lookupBool("FitWindow");
    }, e.prototype.CenterWindow = function() {
      return this.lookupBool("CenterWindow");
    }, e.prototype.DisplayDocTitle = function() {
      return this.lookupBool("DisplayDocTitle");
    }, e.prototype.NonFullScreenPageMode = function() {
      return this.lookupName("NonFullScreenPageMode");
    }, e.prototype.Direction = function() {
      return this.lookupName("Direction");
    }, e.prototype.PrintScaling = function() {
      return this.lookupName("PrintScaling");
    }, e.prototype.Duplex = function() {
      return this.lookupName("Duplex");
    }, e.prototype.PickTrayByPDFSize = function() {
      return this.lookupBool("PickTrayByPDFSize");
    }, e.prototype.PrintPageRange = function() {
      var t = this.dict.lookup(F.of("PrintPageRange"));
      if (t instanceof _e)
        return t;
    }, e.prototype.NumCopies = function() {
      var t = this.dict.lookup(F.of("NumCopies"));
      if (t instanceof we)
        return t;
    }, e.prototype.getHideToolbar = function() {
      var t, r;
      return (r = (t = this.HideToolbar()) === null || t === void 0 ? void 0 : t.asBoolean()) !== null && r !== void 0 ? r : !1;
    }, e.prototype.getHideMenubar = function() {
      var t, r;
      return (r = (t = this.HideMenubar()) === null || t === void 0 ? void 0 : t.asBoolean()) !== null && r !== void 0 ? r : !1;
    }, e.prototype.getHideWindowUI = function() {
      var t, r;
      return (r = (t = this.HideWindowUI()) === null || t === void 0 ? void 0 : t.asBoolean()) !== null && r !== void 0 ? r : !1;
    }, e.prototype.getFitWindow = function() {
      var t, r;
      return (r = (t = this.FitWindow()) === null || t === void 0 ? void 0 : t.asBoolean()) !== null && r !== void 0 ? r : !1;
    }, e.prototype.getCenterWindow = function() {
      var t, r;
      return (r = (t = this.CenterWindow()) === null || t === void 0 ? void 0 : t.asBoolean()) !== null && r !== void 0 ? r : !1;
    }, e.prototype.getDisplayDocTitle = function() {
      var t, r;
      return (r = (t = this.DisplayDocTitle()) === null || t === void 0 ? void 0 : t.asBoolean()) !== null && r !== void 0 ? r : !1;
    }, e.prototype.getNonFullScreenPageMode = function() {
      var t, r, n = (t = this.NonFullScreenPageMode()) === null || t === void 0 ? void 0 : t.decodeText();
      return (r = la(n, ci)) !== null && r !== void 0 ? r : ci.UseNone;
    }, e.prototype.getReadingDirection = function() {
      var t, r, n = (t = this.Direction()) === null || t === void 0 ? void 0 : t.decodeText();
      return (r = la(n, li)) !== null && r !== void 0 ? r : li.L2R;
    }, e.prototype.getPrintScaling = function() {
      var t, r, n = (t = this.PrintScaling()) === null || t === void 0 ? void 0 : t.decodeText();
      return (r = la(n, ui)) !== null && r !== void 0 ? r : ui.AppDefault;
    }, e.prototype.getDuplex = function() {
      var t, r = (t = this.Duplex()) === null || t === void 0 ? void 0 : t.decodeText();
      return la(r, Va);
    }, e.prototype.getPickTrayByPDFSize = function() {
      var t;
      return (t = this.PickTrayByPDFSize()) === null || t === void 0 ? void 0 : t.asBoolean();
    }, e.prototype.getPrintPageRange = function() {
      var t = this.PrintPageRange();
      if (!t)
        return [];
      for (var r = [], n = 0; n < t.size(); n += 2) {
        var o = t.lookup(n, we).asNumber(), i = t.lookup(n + 1, we).asNumber();
        r.push({ start: o, end: i });
      }
      return r;
    }, e.prototype.getNumCopies = function() {
      var t, r;
      return (r = (t = this.NumCopies()) === null || t === void 0 ? void 0 : t.asNumber()) !== null && r !== void 0 ? r : 1;
    }, e.prototype.setHideToolbar = function(t) {
      var r = this.dict.context.obj(t);
      this.dict.set(F.of("HideToolbar"), r);
    }, e.prototype.setHideMenubar = function(t) {
      var r = this.dict.context.obj(t);
      this.dict.set(F.of("HideMenubar"), r);
    }, e.prototype.setHideWindowUI = function(t) {
      var r = this.dict.context.obj(t);
      this.dict.set(F.of("HideWindowUI"), r);
    }, e.prototype.setFitWindow = function(t) {
      var r = this.dict.context.obj(t);
      this.dict.set(F.of("FitWindow"), r);
    }, e.prototype.setCenterWindow = function(t) {
      var r = this.dict.context.obj(t);
      this.dict.set(F.of("CenterWindow"), r);
    }, e.prototype.setDisplayDocTitle = function(t) {
      var r = this.dict.context.obj(t);
      this.dict.set(F.of("DisplayDocTitle"), r);
    }, e.prototype.setNonFullScreenPageMode = function(t) {
      cn(t, "nonFullScreenPageMode", ci);
      var r = F.of(t);
      this.dict.set(F.of("NonFullScreenPageMode"), r);
    }, e.prototype.setReadingDirection = function(t) {
      cn(t, "readingDirection", li);
      var r = F.of(t);
      this.dict.set(F.of("Direction"), r);
    }, e.prototype.setPrintScaling = function(t) {
      cn(t, "printScaling", ui);
      var r = F.of(t);
      this.dict.set(F.of("PrintScaling"), r);
    }, e.prototype.setDuplex = function(t) {
      cn(t, "duplex", Va);
      var r = F.of(t);
      this.dict.set(F.of("Duplex"), r);
    }, e.prototype.setPickTrayByPDFSize = function(t) {
      var r = this.dict.context.obj(t);
      this.dict.set(F.of("PickTrayByPDFSize"), r);
    }, e.prototype.setPrintPageRange = function(t) {
      Array.isArray(t) || (t = [t]);
      for (var r = [], n = 0, o = t.length; n < o; n++)
        r.push(t[n].start), r.push(t[n].end);
      Xg(r, "printPageRange", ["number"]);
      var i = this.dict.context.obj(r);
      this.dict.set(F.of("PrintPageRange"), i);
    }, e.prototype.setNumCopies = function(t) {
      Vt(t, "numCopies", 1, Number.MAX_VALUE), eR(t, "numCopies");
      var r = this.dict.context.obj(t);
      this.dict.set(F.of("NumCopies"), r);
    }, e.fromDict = function(t) {
      return new e(t);
    }, e.create = function(t) {
      var r = t.obj({});
      return new e(r);
    }, e;
  })()
), ZR = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+Tf/, am = (
  /** @class */
  (function() {
    function e(t, r) {
      this.dict = t, this.ref = r;
    }
    return e.prototype.T = function() {
      return this.dict.lookupMaybe(F.of("T"), $e, pe);
    }, e.prototype.Ff = function() {
      var t = this.getInheritableAttribute(F.of("Ff"));
      return this.dict.context.lookupMaybe(t, we);
    }, e.prototype.V = function() {
      var t = this.getInheritableAttribute(F.of("V"));
      return this.dict.context.lookup(t);
    }, e.prototype.Kids = function() {
      return this.dict.lookupMaybe(F.of("Kids"), _e);
    }, e.prototype.DA = function() {
      var t = this.dict.lookup(F.of("DA"));
      if (t instanceof $e || t instanceof pe)
        return t;
    }, e.prototype.setKids = function(t) {
      this.dict.set(F.of("Kids"), this.dict.context.obj(t));
    }, e.prototype.getParent = function() {
      var t = this.dict.get(F.of("Parent"));
      if (t instanceof et) {
        var r = this.dict.lookup(F.of("Parent"), De);
        return new e(r, t);
      }
    }, e.prototype.setParent = function(t) {
      t ? this.dict.set(F.of("Parent"), t) : this.dict.delete(F.of("Parent"));
    }, e.prototype.getFullyQualifiedName = function() {
      var t = this.getParent();
      return t ? t.getFullyQualifiedName() + "." + this.getPartialName() : this.getPartialName();
    }, e.prototype.getPartialName = function() {
      var t;
      return (t = this.T()) === null || t === void 0 ? void 0 : t.decodeText();
    }, e.prototype.setPartialName = function(t) {
      t ? this.dict.set(F.of("T"), pe.fromText(t)) : this.dict.delete(F.of("T"));
    }, e.prototype.setDefaultAppearance = function(t) {
      this.dict.set(F.of("DA"), $e.of(t));
    }, e.prototype.getDefaultAppearance = function() {
      var t = this.DA();
      return t instanceof pe ? t.decodeText() : t?.asString();
    }, e.prototype.setFontSize = function(t) {
      var r, n = (r = this.getFullyQualifiedName()) !== null && r !== void 0 ? r : "", o = this.getDefaultAppearance();
      if (!o)
        throw new sR(n);
      var i = bu(o, ZR);
      if (!i.match)
        throw new cR(n);
      var a = o.slice(0, i.pos - i.match[0].length), s = i.pos <= o.length ? o.slice(i.pos) : "", c = i.match[1], l = a + " /" + c + " " + t + " Tf " + s;
      this.setDefaultAppearance(l);
    }, e.prototype.getFlags = function() {
      var t, r;
      return (r = (t = this.Ff()) === null || t === void 0 ? void 0 : t.asNumber()) !== null && r !== void 0 ? r : 0;
    }, e.prototype.setFlags = function(t) {
      this.dict.set(F.of("Ff"), we.of(t));
    }, e.prototype.hasFlag = function(t) {
      var r = this.getFlags();
      return (r & t) !== 0;
    }, e.prototype.setFlag = function(t) {
      var r = this.getFlags();
      this.setFlags(r | t);
    }, e.prototype.clearFlag = function(t) {
      var r = this.getFlags();
      this.setFlags(r & ~t);
    }, e.prototype.setFlagTo = function(t, r) {
      r ? this.setFlag(t) : this.clearFlag(t);
    }, e.prototype.getInheritableAttribute = function(t) {
      var r;
      return this.ascend(function(n) {
        r || (r = n.dict.get(t));
      }), r;
    }, e.prototype.ascend = function(t) {
      t(this);
      var r = this.getParent();
      r && r.ascend(t);
    }, e;
  })()
), Sc = (
  /** @class */
  (function() {
    function e(t) {
      this.dict = t;
    }
    return e.prototype.W = function() {
      var t = this.dict.lookup(F.of("W"));
      if (t instanceof we)
        return t;
    }, e.prototype.getWidth = function() {
      var t, r;
      return (r = (t = this.W()) === null || t === void 0 ? void 0 : t.asNumber()) !== null && r !== void 0 ? r : 1;
    }, e.prototype.setWidth = function(t) {
      var r = this.dict.context.obj(t);
      this.dict.set(F.of("W"), r);
    }, e.fromDict = function(t) {
      return new e(t);
    }, e;
  })()
), _R = (
  /** @class */
  (function() {
    function e(t) {
      this.dict = t;
    }
    return e.prototype.Rect = function() {
      return this.dict.lookup(F.of("Rect"), _e);
    }, e.prototype.AP = function() {
      return this.dict.lookupMaybe(F.of("AP"), De);
    }, e.prototype.F = function() {
      var t = this.dict.lookup(F.of("F"));
      return this.dict.context.lookupMaybe(t, we);
    }, e.prototype.getRectangle = function() {
      var t, r = this.Rect();
      return (t = r?.asRectangle()) !== null && t !== void 0 ? t : { x: 0, y: 0, width: 0, height: 0 };
    }, e.prototype.setRectangle = function(t) {
      var r = t.x, n = t.y, o = t.width, i = t.height, a = this.dict.context.obj([r, n, r + o, n + i]);
      this.dict.set(F.of("Rect"), a);
    }, e.prototype.getAppearanceState = function() {
      var t = this.dict.lookup(F.of("AS"));
      if (t instanceof F)
        return t;
    }, e.prototype.setAppearanceState = function(t) {
      this.dict.set(F.of("AS"), t);
    }, e.prototype.setAppearances = function(t) {
      this.dict.set(F.of("AP"), t);
    }, e.prototype.ensureAP = function() {
      var t = this.AP();
      return t || (t = this.dict.context.obj({}), this.dict.set(F.of("AP"), t)), t;
    }, e.prototype.getNormalAppearance = function() {
      var t = this.ensureAP(), r = t.get(F.of("N"));
      if (r instanceof et || r instanceof De)
        return r;
      throw new Error("Unexpected N type: " + r?.constructor.name);
    }, e.prototype.setNormalAppearance = function(t) {
      var r = this.ensureAP();
      r.set(F.of("N"), t);
    }, e.prototype.setRolloverAppearance = function(t) {
      var r = this.ensureAP();
      r.set(F.of("R"), t);
    }, e.prototype.setDownAppearance = function(t) {
      var r = this.ensureAP();
      r.set(F.of("D"), t);
    }, e.prototype.removeRolloverAppearance = function() {
      var t = this.AP();
      t?.delete(F.of("R"));
    }, e.prototype.removeDownAppearance = function() {
      var t = this.AP();
      t?.delete(F.of("D"));
    }, e.prototype.getAppearances = function() {
      var t = this.AP();
      if (t) {
        var r = t.lookup(F.of("N"), De, Gt), n = t.lookupMaybe(F.of("R"), De, Gt), o = t.lookupMaybe(F.of("D"), De, Gt);
        return { normal: r, rollover: n, down: o };
      }
    }, e.prototype.getFlags = function() {
      var t, r;
      return (r = (t = this.F()) === null || t === void 0 ? void 0 : t.asNumber()) !== null && r !== void 0 ? r : 0;
    }, e.prototype.setFlags = function(t) {
      this.dict.set(F.of("F"), we.of(t));
    }, e.prototype.hasFlag = function(t) {
      var r = this.getFlags();
      return (r & t) !== 0;
    }, e.prototype.setFlag = function(t) {
      var r = this.getFlags();
      this.setFlags(r | t);
    }, e.prototype.clearFlag = function(t) {
      var r = this.getFlags();
      this.setFlags(r & ~t);
    }, e.prototype.setFlagTo = function(t, r) {
      r ? this.setFlag(t) : this.clearFlag(t);
    }, e.fromDict = function(t) {
      return new e(t);
    }, e;
  })()
), Pc = (
  /** @class */
  (function() {
    function e(t) {
      this.dict = t;
    }
    return e.prototype.R = function() {
      var t = this.dict.lookup(F.of("R"));
      if (t instanceof we)
        return t;
    }, e.prototype.BC = function() {
      var t = this.dict.lookup(F.of("BC"));
      if (t instanceof _e)
        return t;
    }, e.prototype.BG = function() {
      var t = this.dict.lookup(F.of("BG"));
      if (t instanceof _e)
        return t;
    }, e.prototype.CA = function() {
      var t = this.dict.lookup(F.of("CA"));
      if (t instanceof pe || t instanceof $e)
        return t;
    }, e.prototype.RC = function() {
      var t = this.dict.lookup(F.of("RC"));
      if (t instanceof pe || t instanceof $e)
        return t;
    }, e.prototype.AC = function() {
      var t = this.dict.lookup(F.of("AC"));
      if (t instanceof pe || t instanceof $e)
        return t;
    }, e.prototype.getRotation = function() {
      var t;
      return (t = this.R()) === null || t === void 0 ? void 0 : t.asNumber();
    }, e.prototype.getBorderColor = function() {
      var t = this.BC();
      if (t) {
        for (var r = [], n = 0, o = t?.size(); n < o; n++) {
          var i = t.get(n);
          i instanceof we && r.push(i.asNumber());
        }
        return r;
      }
    }, e.prototype.getBackgroundColor = function() {
      var t = this.BG();
      if (t) {
        for (var r = [], n = 0, o = t?.size(); n < o; n++) {
          var i = t.get(n);
          i instanceof we && r.push(i.asNumber());
        }
        return r;
      }
    }, e.prototype.getCaptions = function() {
      var t = this.CA(), r = this.RC(), n = this.AC();
      return {
        normal: t?.decodeText(),
        rollover: r?.decodeText(),
        down: n?.decodeText()
      };
    }, e.prototype.setRotation = function(t) {
      var r = this.dict.context.obj(t);
      this.dict.set(F.of("R"), r);
    }, e.prototype.setBorderColor = function(t) {
      var r = this.dict.context.obj(t);
      this.dict.set(F.of("BC"), r);
    }, e.prototype.setBackgroundColor = function(t) {
      var r = this.dict.context.obj(t);
      this.dict.set(F.of("BG"), r);
    }, e.prototype.setCaptions = function(t) {
      var r = pe.fromText(t.normal);
      if (this.dict.set(F.of("CA"), r), t.rollover) {
        var n = pe.fromText(t.rollover);
        this.dict.set(F.of("RC"), n);
      } else
        this.dict.delete(F.of("RC"));
      if (t.down) {
        var o = pe.fromText(t.down);
        this.dict.set(F.of("AC"), o);
      } else
        this.dict.delete(F.of("AC"));
    }, e.fromDict = function(t) {
      return new e(t);
    }, e;
  })()
), al = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.MK = function() {
      var r = this.dict.lookup(F.of("MK"));
      if (r instanceof De)
        return r;
    }, t.prototype.BS = function() {
      var r = this.dict.lookup(F.of("BS"));
      if (r instanceof De)
        return r;
    }, t.prototype.DA = function() {
      var r = this.dict.lookup(F.of("DA"));
      if (r instanceof $e || r instanceof pe)
        return r;
    }, t.prototype.P = function() {
      var r = this.dict.get(F.of("P"));
      if (r instanceof et)
        return r;
    }, t.prototype.setP = function(r) {
      this.dict.set(F.of("P"), r);
    }, t.prototype.setDefaultAppearance = function(r) {
      this.dict.set(F.of("DA"), $e.of(r));
    }, t.prototype.getDefaultAppearance = function() {
      var r = this.DA();
      return r instanceof pe ? r.decodeText() : r?.asString();
    }, t.prototype.getAppearanceCharacteristics = function() {
      var r = this.MK();
      if (r)
        return Pc.fromDict(r);
    }, t.prototype.getOrCreateAppearanceCharacteristics = function() {
      var r = this.MK();
      if (r)
        return Pc.fromDict(r);
      var n = Pc.fromDict(this.dict.context.obj({}));
      return this.dict.set(F.of("MK"), n.dict), n;
    }, t.prototype.getBorderStyle = function() {
      var r = this.BS();
      if (r)
        return Sc.fromDict(r);
    }, t.prototype.getOrCreateBorderStyle = function() {
      var r = this.BS();
      if (r)
        return Sc.fromDict(r);
      var n = Sc.fromDict(this.dict.context.obj({}));
      return this.dict.set(F.of("BS"), n.dict), n;
    }, t.prototype.getOnValue = function() {
      var r, n = (r = this.getAppearances()) === null || r === void 0 ? void 0 : r.normal;
      if (n instanceof De)
        for (var o = n.keys(), i = 0, a = o.length; i < a; i++) {
          var s = o[i];
          if (s !== F.of("Off"))
            return s;
        }
    }, t.fromDict = function(r) {
      return new t(r);
    }, t.create = function(r, n) {
      var o = r.obj({
        Type: "Annot",
        Subtype: "Widget",
        Rect: [0, 0, 0, 0],
        Parent: n
      });
      return new t(o);
    }, t;
  })(_R)
), Bo = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.FT = function() {
      var r = this.getInheritableAttribute(F.of("FT"));
      return this.dict.context.lookup(r, F);
    }, t.prototype.getWidgets = function() {
      var r = this.Kids();
      if (!r)
        return [al.fromDict(this.dict)];
      for (var n = new Array(r.size()), o = 0, i = r.size(); o < i; o++) {
        var a = r.lookup(o, De);
        n[o] = al.fromDict(a);
      }
      return n;
    }, t.prototype.addWidget = function(r) {
      var n = this.normalizedEntries().Kids;
      n.push(r);
    }, t.prototype.removeWidget = function(r) {
      var n = this.Kids();
      if (n) {
        if (r < 0 || r > n.size())
          throw new ja(r, 0, n.size());
        n.remove(r);
      } else {
        if (r !== 0)
          throw new ja(r, 0, 0);
        this.setKids([]);
      }
    }, t.prototype.normalizedEntries = function() {
      var r = this.Kids();
      return r || (r = this.dict.context.obj([this.ref]), this.dict.set(F.of("Kids"), r)), { Kids: r };
    }, t.fromDict = function(r, n) {
      return new t(r, n);
    }, t;
  })(am)
), Du = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.Opt = function() {
      return this.dict.lookupMaybe(F.of("Opt"), $e, pe, _e);
    }, t.prototype.setOpt = function(r) {
      this.dict.set(F.of("Opt"), this.dict.context.obj(r));
    }, t.prototype.getExportValues = function() {
      var r = this.Opt();
      if (r) {
        if (r instanceof $e || r instanceof pe)
          return [r];
        for (var n = [], o = 0, i = r.size(); o < i; o++) {
          var a = r.lookup(o);
          (a instanceof $e || a instanceof pe) && n.push(a);
        }
        return n;
      }
    }, t.prototype.removeExportValue = function(r) {
      var n = this.Opt();
      if (n)
        if (n instanceof $e || n instanceof pe) {
          if (r !== 0)
            throw new ja(r, 0, 0);
          this.setOpt([]);
        } else {
          if (r < 0 || r > n.size())
            throw new ja(r, 0, n.size());
          n.remove(r);
        }
    }, t.prototype.normalizeExportValues = function() {
      for (var r, n, o, i, a = (r = this.getExportValues()) !== null && r !== void 0 ? r : [], s = [], c = this.getWidgets(), l = 0, u = c.length; l < u; l++) {
        var d = c[l], f = (n = a[l]) !== null && n !== void 0 ? n : pe.fromText((i = (o = d.getOnValue()) === null || o === void 0 ? void 0 : o.decodeText()) !== null && i !== void 0 ? i : "");
        s.push(f);
      }
      this.setOpt(s);
    }, t.prototype.addOpt = function(r, n) {
      var o;
      this.normalizeExportValues();
      var i = r.decodeText(), a;
      if (n)
        for (var s = (o = this.getExportValues()) !== null && o !== void 0 ? o : [], c = 0, l = s.length; c < l; c++) {
          var u = s[c];
          u.decodeText() === i && (a = c);
        }
      var d = this.Opt();
      return d.push(r), a ?? d.size() - 1;
    }, t.prototype.addWidgetWithOpt = function(r, n, o) {
      var i = this.addOpt(n, o), a = F.of(String(i));
      return this.addWidget(r), a;
    }, t;
  })(Bo)
), Rs = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.setValue = function(r) {
      var n, o = (n = this.getOnValue()) !== null && n !== void 0 ? n : F.of("Yes");
      if (r !== o && r !== F.of("Off"))
        throw new Su();
      this.dict.set(F.of("V"), r);
      for (var i = this.getWidgets(), a = 0, s = i.length; a < s; a++) {
        var c = i[a], l = c.getOnValue() === r ? r : F.of("Off");
        c.setAppearanceState(l);
      }
    }, t.prototype.getValue = function() {
      var r = this.V();
      return r instanceof F ? r : F.of("Off");
    }, t.prototype.getOnValue = function() {
      var r = this.getWidgets()[0];
      return r?.getOnValue();
    }, t.fromDict = function(r, n) {
      return new t(r, n);
    }, t.create = function(r) {
      var n = r.obj({
        FT: "Btn",
        Kids: []
      }), o = r.register(n);
      return new t(n, o);
    }, t;
  })(Du)
), ft = function(e) {
  return 1 << e;
}, hr;
(function(e) {
  e[e.ReadOnly = ft(0)] = "ReadOnly", e[e.Required = ft(1)] = "Required", e[e.NoExport = ft(2)] = "NoExport";
})(hr || (hr = {}));
var $t;
(function(e) {
  e[e.NoToggleToOff = ft(14)] = "NoToggleToOff", e[e.Radio = ft(15)] = "Radio", e[e.PushButton = ft(16)] = "PushButton", e[e.RadiosInUnison = ft(25)] = "RadiosInUnison";
})($t || ($t = {}));
var lt;
(function(e) {
  e[e.Multiline = ft(12)] = "Multiline", e[e.Password = ft(13)] = "Password", e[e.FileSelect = ft(20)] = "FileSelect", e[e.DoNotSpellCheck = ft(22)] = "DoNotSpellCheck", e[e.DoNotScroll = ft(23)] = "DoNotScroll", e[e.Comb = ft(24)] = "Comb", e[e.RichText = ft(25)] = "RichText";
})(lt || (lt = {}));
var Qe;
(function(e) {
  e[e.Combo = ft(17)] = "Combo", e[e.Edit = ft(18)] = "Edit", e[e.Sort = ft(19)] = "Sort", e[e.MultiSelect = ft(21)] = "MultiSelect", e[e.DoNotSpellCheck = ft(22)] = "DoNotSpellCheck", e[e.CommitOnSelChange = ft(26)] = "CommitOnSelChange";
})(Qe || (Qe = {}));
var sm = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.setValues = function(r) {
      if (this.hasFlag(Qe.Combo) && !this.hasFlag(Qe.Edit) && !this.valuesAreValid(r))
        throw new Su();
      if (r.length === 0 && this.dict.delete(F.of("V")), r.length === 1 && this.dict.set(F.of("V"), r[0]), r.length > 1) {
        if (!this.hasFlag(Qe.MultiSelect))
          throw new aR();
        this.dict.set(F.of("V"), this.dict.context.obj(r));
      }
      this.updateSelectedIndices(r);
    }, t.prototype.valuesAreValid = function(r) {
      for (var n = this.getOptions(), o = function(c, l) {
        var u = r[c].decodeText();
        if (!n.find(function(d) {
          return u === (d.display || d.value).decodeText();
        }))
          return { value: !1 };
      }, i = 0, a = r.length; i < a; i++) {
        var s = o(i);
        if (typeof s == "object")
          return s.value;
      }
      return !0;
    }, t.prototype.updateSelectedIndices = function(r) {
      if (r.length > 1) {
        for (var n = new Array(r.length), o = this.getOptions(), i = function(c, l) {
          var u = r[c].decodeText();
          n[c] = o.findIndex(function(d) {
            return u === (d.display || d.value).decodeText();
          });
        }, a = 0, s = r.length; a < s; a++)
          i(a, s);
        this.dict.set(F.of("I"), this.dict.context.obj(n.sort()));
      } else
        this.dict.delete(F.of("I"));
    }, t.prototype.getValues = function() {
      var r = this.V();
      if (r instanceof $e || r instanceof pe)
        return [r];
      if (r instanceof _e) {
        for (var n = [], o = 0, i = r.size(); o < i; o++) {
          var a = r.lookup(o);
          (a instanceof $e || a instanceof pe) && n.push(a);
        }
        return n;
      }
      return [];
    }, t.prototype.Opt = function() {
      return this.dict.lookupMaybe(F.of("Opt"), $e, pe, _e);
    }, t.prototype.setOptions = function(r) {
      for (var n = new Array(r.length), o = 0, i = r.length; o < i; o++) {
        var a = r[o], s = a.value, c = a.display;
        n[o] = this.dict.context.obj([s, c || s]);
      }
      this.dict.set(F.of("Opt"), this.dict.context.obj(n));
    }, t.prototype.getOptions = function() {
      var r = this.Opt();
      if (r instanceof $e || r instanceof pe)
        return [{ value: r, display: r }];
      if (r instanceof _e) {
        for (var n = [], o = 0, i = r.size(); o < i; o++) {
          var a = r.lookup(o);
          if ((a instanceof $e || a instanceof pe) && n.push({ value: a, display: a }), a instanceof _e && a.size() > 0) {
            var s = a.lookup(0, $e, pe), c = a.lookupMaybe(1, $e, pe);
            n.push({ value: s, display: c || s });
          }
        }
        return n;
      }
      return [];
    }, t;
  })(Bo)
), Ts = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.fromDict = function(r, n) {
      return new t(r, n);
    }, t.create = function(r) {
      var n = r.obj({
        FT: "Ch",
        Ff: Qe.Combo,
        Kids: []
      }), o = r.register(n);
      return new t(n, o);
    }, t;
  })(sm)
), Ha = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.addField = function(r) {
      var n = this.normalizedEntries().Kids;
      n?.push(r);
    }, t.prototype.normalizedEntries = function() {
      var r = this.Kids();
      return r || (r = this.dict.context.obj([]), this.dict.set(F.of("Kids"), r)), { Kids: r };
    }, t.fromDict = function(r, n) {
      return new t(r, n);
    }, t.create = function(r) {
      var n = r.obj({}), o = r.register(n);
      return new t(n, o);
    }, t;
  })(am)
), Ru = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.fromDict = function(r, n) {
      return new t(r, n);
    }, t;
  })(Bo)
), As = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.MaxLen = function() {
      var r = this.dict.lookup(F.of("MaxLen"));
      if (r instanceof we)
        return r;
    }, t.prototype.Q = function() {
      var r = this.dict.lookup(F.of("Q"));
      if (r instanceof we)
        return r;
    }, t.prototype.setMaxLength = function(r) {
      this.dict.set(F.of("MaxLen"), we.of(r));
    }, t.prototype.removeMaxLength = function() {
      this.dict.delete(F.of("MaxLen"));
    }, t.prototype.getMaxLength = function() {
      var r;
      return (r = this.MaxLen()) === null || r === void 0 ? void 0 : r.asNumber();
    }, t.prototype.setQuadding = function(r) {
      this.dict.set(F.of("Q"), we.of(r));
    }, t.prototype.getQuadding = function() {
      var r;
      return (r = this.Q()) === null || r === void 0 ? void 0 : r.asNumber();
    }, t.prototype.setValue = function(r) {
      this.dict.set(F.of("V"), r);
    }, t.prototype.removeValue = function() {
      this.dict.delete(F.of("V"));
    }, t.prototype.getValue = function() {
      var r = this.V();
      if (r instanceof $e || r instanceof pe)
        return r;
    }, t.fromDict = function(r, n) {
      return new t(r, n);
    }, t.create = function(r) {
      var n = r.obj({
        FT: "Tx",
        Kids: []
      }), o = r.register(n);
      return new t(n, o);
    }, t;
  })(Bo)
), Ns = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.fromDict = function(r, n) {
      return new t(r, n);
    }, t.create = function(r) {
      var n = r.obj({
        FT: "Btn",
        Ff: $t.PushButton,
        Kids: []
      }), o = r.register(n);
      return new t(n, o);
    }, t;
  })(Du)
), Os = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.setValue = function(r) {
      var n = this.getOnValues();
      if (!n.includes(r) && r !== F.of("Off"))
        throw new Su();
      this.dict.set(F.of("V"), r);
      for (var o = this.getWidgets(), i = 0, a = o.length; i < a; i++) {
        var s = o[i], c = s.getOnValue() === r ? r : F.of("Off");
        s.setAppearanceState(c);
      }
    }, t.prototype.getValue = function() {
      var r = this.V();
      return r instanceof F ? r : F.of("Off");
    }, t.prototype.getOnValues = function() {
      for (var r = this.getWidgets(), n = [], o = 0, i = r.length; o < i; o++) {
        var a = r[o].getOnValue();
        a && n.push(a);
      }
      return n;
    }, t.fromDict = function(r, n) {
      return new t(r, n);
    }, t.create = function(r) {
      var n = r.obj({
        FT: "Btn",
        Ff: $t.Radio,
        Kids: []
      }), o = r.register(n);
      return new t(n, o);
    }, t;
  })(Du)
), Ms = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.fromDict = function(r, n) {
      return new t(r, n);
    }, t.create = function(r) {
      var n = r.obj({
        FT: "Ch",
        Kids: []
      }), o = r.register(n);
      return new t(n, o);
    }, t;
  })(sm)
), Tu = function(e) {
  if (!e)
    return [];
  for (var t = [], r = 0, n = e.size(); r < n; r++) {
    var o = e.get(r), i = e.lookup(r);
    o instanceof et && i instanceof De && t.push([cm(i, o), o]);
  }
  return t;
}, cm = function(e, t) {
  var r = JR(e);
  return r ? Ha.fromDict(e, t) : QR(e, t);
}, JR = function(e) {
  var t = e.lookup(F.of("Kids"));
  if (t instanceof _e)
    for (var r = 0, n = t.size(); r < n; r++) {
      var o = t.lookup(r), i = o instanceof De && o.has(F.of("T"));
      if (i)
        return !0;
    }
  return !1;
}, QR = function(e, t) {
  var r = Au(e, F.of("FT")), n = e.context.lookup(r, F);
  return n === F.of("Btn") ? $R(e, t) : n === F.of("Ch") ? eT(e, t) : n === F.of("Tx") ? As.fromDict(e, t) : n === F.of("Sig") ? Ru.fromDict(e, t) : Bo.fromDict(e, t);
}, $R = function(e, t) {
  var r, n = Au(e, F.of("Ff")), o = e.context.lookupMaybe(n, we), i = (r = o?.asNumber()) !== null && r !== void 0 ? r : 0;
  return sl(i, $t.PushButton) ? Ns.fromDict(e, t) : sl(i, $t.Radio) ? Os.fromDict(e, t) : Rs.fromDict(e, t);
}, eT = function(e, t) {
  var r, n = Au(e, F.of("Ff")), o = e.context.lookupMaybe(n, we), i = (r = o?.asNumber()) !== null && r !== void 0 ? r : 0;
  return sl(i, Qe.Combo) ? Ts.fromDict(e, t) : Ms.fromDict(e, t);
}, sl = function(e, t) {
  return (e & t) !== 0;
}, Au = function(e, t) {
  var r;
  return lm(e, function(n) {
    r || (r = n.get(t));
  }), r;
}, lm = function(e, t) {
  t(e);
  var r = e.lookupMaybe(F.of("Parent"), De);
  r && lm(r, t);
}, qa = (
  /** @class */
  (function() {
    function e(t) {
      this.dict = t;
    }
    return e.prototype.Fields = function() {
      var t = this.dict.lookup(F.of("Fields"));
      if (t instanceof _e)
        return t;
    }, e.prototype.getFields = function() {
      for (var t = this.normalizedEntries().Fields, r = new Array(t.size()), n = 0, o = t.size(); n < o; n++) {
        var i = t.get(n), a = t.lookup(n, De);
        r[n] = [cm(a, i), i];
      }
      return r;
    }, e.prototype.getAllFields = function() {
      var t = [], r = function(n) {
        if (n)
          for (var o = 0, i = n.length; o < i; o++) {
            var a = n[o];
            t.push(a);
            var s = a[0];
            s instanceof Ha && r(Tu(s.Kids()));
          }
      };
      return r(this.getFields()), t;
    }, e.prototype.addField = function(t) {
      var r = this.normalizedEntries().Fields;
      r?.push(t);
    }, e.prototype.removeField = function(t) {
      var r = t.getParent(), n = r === void 0 ? this.normalizedEntries().Fields : r.Kids(), o = n?.indexOf(t.ref);
      if (n === void 0 || o === void 0)
        throw new Error("Tried to remove inexistent field " + t.getFullyQualifiedName());
      n.remove(o), r !== void 0 && n.size() === 0 && this.removeField(r);
    }, e.prototype.normalizedEntries = function() {
      var t = this.Fields();
      return t || (t = this.dict.context.obj([]), this.dict.set(F.of("Fields"), t)), { Fields: t };
    }, e.fromDict = function(t) {
      return new e(t);
    }, e.create = function(t) {
      var r = t.obj({ Fields: [] });
      return new e(r);
    }, e;
  })()
), um = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.Pages = function() {
      return this.lookup(F.of("Pages"), De);
    }, t.prototype.AcroForm = function() {
      return this.lookupMaybe(F.of("AcroForm"), De);
    }, t.prototype.getAcroForm = function() {
      var r = this.AcroForm();
      if (r)
        return qa.fromDict(r);
    }, t.prototype.getOrCreateAcroForm = function() {
      var r = this.getAcroForm();
      if (!r) {
        r = qa.create(this.context);
        var n = this.context.register(r.dict);
        this.set(F.of("AcroForm"), n);
      }
      return r;
    }, t.prototype.ViewerPreferences = function() {
      return this.lookupMaybe(F.of("ViewerPreferences"), De);
    }, t.prototype.getViewerPreferences = function() {
      var r = this.ViewerPreferences();
      if (r)
        return Ff.fromDict(r);
    }, t.prototype.getOrCreateViewerPreferences = function() {
      var r = this.getViewerPreferences();
      if (!r) {
        r = Ff.create(this.context);
        var n = this.context.register(r.dict);
        this.set(F.of("ViewerPreferences"), n);
      }
      return r;
    }, t.prototype.insertLeafNode = function(r, n) {
      var o = this.get(F.of("Pages")), i = this.Pages().insertLeafNode(r, n);
      return i || o;
    }, t.prototype.removeLeafNode = function(r) {
      this.Pages().removeLeafNode(r);
    }, t.withContextAndPages = function(r, n) {
      var o = /* @__PURE__ */ new Map();
      return o.set(F.of("Type"), F.of("Catalog")), o.set(F.of("Pages"), n), new t(o, r);
    }, t.fromMapWithContext = function(r, n) {
      return new t(r, n);
    }, t;
  })(De)
), dm = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.Parent = function() {
      return this.lookup(F.of("Parent"));
    }, t.prototype.Kids = function() {
      return this.lookup(F.of("Kids"), _e);
    }, t.prototype.Count = function() {
      return this.lookup(F.of("Count"), we);
    }, t.prototype.pushTreeNode = function(r) {
      var n = this.Kids();
      n.push(r);
    }, t.prototype.pushLeafNode = function(r) {
      var n = this.Kids();
      this.insertLeafKid(n.size(), r);
    }, t.prototype.insertLeafNode = function(r, n) {
      var o = this.Kids(), i = this.Count().asNumber();
      if (n > i)
        throw new vf(n, i);
      for (var a = n, s = 0, c = o.size(); s < c; s++) {
        if (a === 0) {
          this.insertLeafKid(s, r);
          return;
        }
        var l = o.get(s), u = this.context.lookup(l);
        if (u instanceof t) {
          if (u.Count().asNumber() > a)
            return u.insertLeafNode(r, a) || l;
          a -= u.Count().asNumber();
        }
        u instanceof Ur && (a -= 1);
      }
      if (a === 0) {
        this.insertLeafKid(o.size(), r);
        return;
      }
      throw new pf(n, "insertLeafNode");
    }, t.prototype.removeLeafNode = function(r, n) {
      n === void 0 && (n = !0);
      var o = this.Kids(), i = this.Count().asNumber();
      if (r >= i)
        throw new vf(r, i);
      for (var a = r, s = 0, c = o.size(); s < c; s++) {
        var l = o.get(s), u = this.context.lookup(l);
        if (u instanceof t)
          if (u.Count().asNumber() > a) {
            u.removeLeafNode(a, n), n && u.Kids().size() === 0 && o.remove(s);
            return;
          } else
            a -= u.Count().asNumber();
        if (u instanceof Ur)
          if (a === 0) {
            this.removeKid(s);
            return;
          } else
            a -= 1;
      }
      throw new pf(r, "removeLeafNode");
    }, t.prototype.ascend = function(r) {
      r(this);
      var n = this.Parent();
      n && n.ascend(r);
    }, t.prototype.traverse = function(r) {
      for (var n = this.Kids(), o = 0, i = n.size(); o < i; o++) {
        var a = n.get(o), s = this.context.lookup(a);
        s instanceof t && s.traverse(r), r(s, a);
      }
    }, t.prototype.insertLeafKid = function(r, n) {
      var o = this.Kids();
      this.ascend(function(i) {
        var a = i.Count().asNumber() + 1;
        i.set(F.of("Count"), we.of(a));
      }), o.insert(r, n);
    }, t.prototype.removeKid = function(r) {
      var n = this.Kids(), o = n.lookup(r);
      o instanceof Ur && this.ascend(function(i) {
        var a = i.Count().asNumber() - 1;
        i.set(F.of("Count"), we.of(a));
      }), n.remove(r);
    }, t.withContext = function(r, n) {
      var o = /* @__PURE__ */ new Map();
      return o.set(F.of("Type"), F.of("Pages")), o.set(F.of("Kids"), r.obj([])), o.set(F.of("Count"), r.obj(0)), n && o.set(F.of("Parent"), n), new t(o, r);
    }, t.fromMapWithContext = function(r, n) {
      return new t(r, n);
    }, t;
  })(De)
), At = new Uint8Array(256);
At[T.Zero] = 1;
At[T.One] = 1;
At[T.Two] = 1;
At[T.Three] = 1;
At[T.Four] = 1;
At[T.Five] = 1;
At[T.Six] = 1;
At[T.Seven] = 1;
At[T.Eight] = 1;
At[T.Nine] = 1;
var Is = new Uint8Array(256);
Is[T.Period] = 1;
Is[T.Plus] = 1;
Is[T.Minus] = 1;
var Nu = new Uint8Array(256);
for (var Xo = 0, tT = 256; Xo < tT; Xo++)
  Nu[Xo] = At[Xo] || Is[Xo] ? 1 : 0;
var Df = T.Newline, Rf = T.CarriageReturn, rT = (
  /** @class */
  (function() {
    function e(t, r) {
      r === void 0 && (r = !1), this.bytes = t, this.capNumbers = r;
    }
    return e.prototype.parseRawInt = function() {
      for (var t = ""; !this.bytes.done(); ) {
        var r = this.bytes.peek();
        if (!At[r])
          break;
        t += zr(this.bytes.next());
      }
      var n = Number(t);
      if (!t || !isFinite(n))
        throw new gf(this.bytes.position(), t);
      return n;
    }, e.prototype.parseRawNumber = function() {
      for (var t = ""; !this.bytes.done(); ) {
        var r = this.bytes.peek();
        if (!Nu[r] || (t += zr(this.bytes.next()), r === T.Period))
          break;
      }
      for (; !this.bytes.done(); ) {
        var r = this.bytes.peek();
        if (!At[r])
          break;
        t += zr(this.bytes.next());
      }
      var n = Number(t);
      if (!t || !isFinite(n))
        throw new gf(this.bytes.position(), t);
      if (n > Number.MAX_SAFE_INTEGER)
        if (this.capNumbers) {
          var o = "Parsed number that is too large for some PDF readers: " + t + ", using Number.MAX_SAFE_INTEGER instead.";
          return console.warn(o), Number.MAX_SAFE_INTEGER;
        } else {
          var o = "Parsed number that is too large for some PDF readers: " + t + ", not capping.";
          console.warn(o);
        }
      return n;
    }, e.prototype.skipWhitespace = function() {
      for (; !this.bytes.done() && Yr[this.bytes.peek()]; )
        this.bytes.next();
    }, e.prototype.skipLine = function() {
      for (; !this.bytes.done(); ) {
        var t = this.bytes.peek();
        if (t === Df || t === Rf)
          return;
        this.bytes.next();
      }
    }, e.prototype.skipComment = function() {
      if (this.bytes.peek() !== T.Percent)
        return !1;
      for (; !this.bytes.done(); ) {
        var t = this.bytes.peek();
        if (t === Df || t === Rf)
          return !0;
        this.bytes.next();
      }
      return !0;
    }, e.prototype.skipWhitespaceAndComments = function() {
      for (this.skipWhitespace(); this.skipComment(); )
        this.skipWhitespace();
    }, e.prototype.matchKeyword = function(t) {
      for (var r = this.bytes.offset(), n = 0, o = t.length; n < o; n++)
        if (this.bytes.done() || this.bytes.next() !== t[n])
          return this.bytes.moveTo(r), !1;
      return !0;
    }, e;
  })()
), Bs = (
  /** @class */
  (function() {
    function e(t) {
      this.idx = 0, this.line = 0, this.column = 0, this.bytes = t, this.length = this.bytes.length;
    }
    return e.prototype.moveTo = function(t) {
      this.idx = t;
    }, e.prototype.next = function() {
      var t = this.bytes[this.idx++];
      return t === T.Newline ? (this.line += 1, this.column = 0) : this.column += 1, t;
    }, e.prototype.assertNext = function(t) {
      if (this.peek() !== t)
        throw new lR(this.position(), t, this.peek());
      return this.next();
    }, e.prototype.peek = function() {
      return this.bytes[this.idx];
    }, e.prototype.peekAhead = function(t) {
      return this.bytes[this.idx + t];
    }, e.prototype.peekAt = function(t) {
      return this.bytes[t];
    }, e.prototype.done = function() {
      return this.idx >= this.length;
    }, e.prototype.offset = function() {
      return this.idx;
    }, e.prototype.slice = function(t, r) {
      return this.bytes.slice(t, r);
    }, e.prototype.position = function() {
      return { line: this.line, column: this.column, offset: this.idx };
    }, e.of = function(t) {
      return new e(t);
    }, e.fromPDFRawStream = function(t) {
      return e.of(om(t).decode());
    }, e;
  })()
), nT = T.Space, Yo = T.CarriageReturn, Zo = T.Newline, _o = [
  T.s,
  T.t,
  T.r,
  T.e,
  T.a,
  T.m
], ua = [
  T.e,
  T.n,
  T.d,
  T.s,
  T.t,
  T.r,
  T.e,
  T.a,
  T.m
], ot = {
  header: [
    T.Percent,
    T.P,
    T.D,
    T.F,
    T.Dash
  ],
  eof: [
    T.Percent,
    T.Percent,
    T.E,
    T.O,
    T.F
  ],
  obj: [T.o, T.b, T.j],
  endobj: [
    T.e,
    T.n,
    T.d,
    T.o,
    T.b,
    T.j
  ],
  xref: [T.x, T.r, T.e, T.f],
  trailer: [
    T.t,
    T.r,
    T.a,
    T.i,
    T.l,
    T.e,
    T.r
  ],
  startxref: [
    T.s,
    T.t,
    T.a,
    T.r,
    T.t,
    T.x,
    T.r,
    T.e,
    T.f
  ],
  true: [T.t, T.r, T.u, T.e],
  false: [T.f, T.a, T.l, T.s, T.e],
  null: [T.n, T.u, T.l, T.l],
  stream: _o,
  streamEOF1: Ge(_o, [nT, Yo, Zo]),
  streamEOF2: Ge(_o, [Yo, Zo]),
  streamEOF3: Ge(_o, [Yo]),
  streamEOF4: Ge(_o, [Zo]),
  endstream: ua,
  EOF1endstream: Ge([Yo, Zo], ua),
  EOF2endstream: Ge([Yo], ua),
  EOF3endstream: Ge([Zo], ua)
}, fm = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      o === void 0 && (o = !1);
      var i = e.call(this, r, o) || this;
      return i.context = n, i;
    }
    return t.prototype.parseObject = function() {
      if (this.skipWhitespaceAndComments(), this.matchKeyword(ot.true))
        return bi.True;
      if (this.matchKeyword(ot.false))
        return bi.False;
      if (this.matchKeyword(ot.null))
        return Wt;
      var r = this.bytes.peek();
      if (r === T.LessThan && this.bytes.peekAhead(1) === T.LessThan)
        return this.parseDictOrStream();
      if (r === T.LessThan)
        return this.parseHexString();
      if (r === T.LeftParen)
        return this.parseString();
      if (r === T.ForwardSlash)
        return this.parseName();
      if (r === T.LeftSquareBracket)
        return this.parseArray();
      if (Nu[r])
        return this.parseNumberOrRef();
      throw new uR(this.bytes.position(), r);
    }, t.prototype.parseNumberOrRef = function() {
      var r = this.parseRawNumber();
      this.skipWhitespaceAndComments();
      var n = this.bytes.offset();
      if (At[this.bytes.peek()]) {
        var o = this.parseRawNumber();
        if (this.skipWhitespaceAndComments(), this.bytes.peek() === T.R)
          return this.bytes.assertNext(T.R), et.of(r, o);
      }
      return this.bytes.moveTo(n), we.of(r);
    }, t.prototype.parseHexString = function() {
      var r = "";
      for (this.bytes.assertNext(T.LessThan); !this.bytes.done() && this.bytes.peek() !== T.GreaterThan; )
        r += zr(this.bytes.next());
      return this.bytes.assertNext(T.GreaterThan), pe.of(r);
    }, t.prototype.parseString = function() {
      for (var r = 0, n = !1, o = ""; !this.bytes.done(); ) {
        var i = this.bytes.next();
        if (o += zr(i), n || (i === T.LeftParen && (r += 1), i === T.RightParen && (r -= 1)), i === T.BackSlash ? n = !n : n && (n = !1), r === 0)
          return $e.of(o.substring(1, o.length - 1));
      }
      throw new hR(this.bytes.position());
    }, t.prototype.parseName = function() {
      this.bytes.assertNext(T.ForwardSlash);
      for (var r = ""; !this.bytes.done(); ) {
        var n = this.bytes.peek();
        if (Yr[n] || cr[n])
          break;
        r += zr(n), this.bytes.next();
      }
      return F.of(r);
    }, t.prototype.parseArray = function() {
      this.bytes.assertNext(T.LeftSquareBracket), this.skipWhitespaceAndComments();
      for (var r = _e.withContext(this.context); this.bytes.peek() !== T.RightSquareBracket; ) {
        var n = this.parseObject();
        r.push(n), this.skipWhitespaceAndComments();
      }
      return this.bytes.assertNext(T.RightSquareBracket), r;
    }, t.prototype.parseDict = function() {
      this.bytes.assertNext(T.LessThan), this.bytes.assertNext(T.LessThan), this.skipWhitespaceAndComments();
      for (var r = /* @__PURE__ */ new Map(); !this.bytes.done() && this.bytes.peek() !== T.GreaterThan && this.bytes.peekAhead(1) !== T.GreaterThan; ) {
        var n = this.parseName(), o = this.parseObject();
        r.set(n, o), this.skipWhitespaceAndComments();
      }
      this.skipWhitespaceAndComments(), this.bytes.assertNext(T.GreaterThan), this.bytes.assertNext(T.GreaterThan);
      var i = r.get(F.of("Type"));
      return i === F.of("Catalog") ? um.fromMapWithContext(r, this.context) : i === F.of("Pages") ? dm.fromMapWithContext(r, this.context) : i === F.of("Page") ? Ur.fromMapWithContext(r, this.context) : De.fromMapWithContext(r, this.context);
    }, t.prototype.parseDictOrStream = function() {
      var r = this.bytes.position(), n = this.parseDict();
      if (this.skipWhitespaceAndComments(), !this.matchKeyword(ot.streamEOF1) && !this.matchKeyword(ot.streamEOF2) && !this.matchKeyword(ot.streamEOF3) && !this.matchKeyword(ot.streamEOF4) && !this.matchKeyword(ot.stream))
        return n;
      var o = this.bytes.offset(), i, a = n.get(F.of("Length"));
      a instanceof we ? (i = o + a.asNumber(), this.bytes.moveTo(i), this.skipWhitespaceAndComments(), this.matchKeyword(ot.endstream) || (this.bytes.moveTo(o), i = this.findEndOfStreamFallback(r))) : i = this.findEndOfStreamFallback(r);
      var s = this.bytes.slice(o, i);
      return wi.of(n, s);
    }, t.prototype.findEndOfStreamFallback = function(r) {
      for (var n = 1, o = this.bytes.offset(); !this.bytes.done() && (o = this.bytes.offset(), this.matchKeyword(ot.stream) ? n += 1 : this.matchKeyword(ot.EOF1endstream) || this.matchKeyword(ot.EOF2endstream) || this.matchKeyword(ot.EOF3endstream) || this.matchKeyword(ot.endstream) ? n -= 1 : this.bytes.next(), n !== 0); )
        ;
      if (n !== 0)
        throw new fR(r);
      return o;
    }, t.forBytes = function(r, n, o) {
      return new t(Bs.of(r), n, o);
    }, t.forByteStream = function(r, n, o) {
      return o === void 0 && (o = !1), new t(r, n, o);
    }, t;
  })(rT)
), oT = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = e.call(this, Bs.fromPDFRawStream(r), r.dict.context) || this, i = r.dict;
      return o.alreadyParsed = !1, o.shouldWaitForTick = n || (function() {
        return !1;
      }), o.firstOffset = i.lookup(F.of("First"), we).asNumber(), o.objectCount = i.lookup(F.of("N"), we).asNumber(), o;
    }
    return t.prototype.parseIntoContext = function() {
      return Re(this, void 0, void 0, function() {
        var r, n, o, i, a, s, c, l;
        return Te(this, function(u) {
          switch (u.label) {
            case 0:
              if (this.alreadyParsed)
                throw new Cu("PDFObjectStreamParser", "parseIntoContext");
              this.alreadyParsed = !0, r = this.parseOffsetsAndObjectNumbers(), n = 0, o = r.length, u.label = 1;
            case 1:
              return n < o ? (i = r[n], a = i.objectNumber, s = i.offset, this.bytes.moveTo(this.firstOffset + s), c = this.parseObject(), l = et.of(a, 0), this.context.assign(l, c), this.shouldWaitForTick() ? [4, Fo()] : [3, 3]) : [3, 4];
            case 2:
              u.sent(), u.label = 3;
            case 3:
              return n++, [3, 1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.parseOffsetsAndObjectNumbers = function() {
      for (var r = [], n = 0, o = this.objectCount; n < o; n++) {
        this.skipWhitespaceAndComments();
        var i = this.parseRawInt();
        this.skipWhitespaceAndComments();
        var a = this.parseRawInt();
        r.push({ objectNumber: i, offset: a });
      }
      return r;
    }, t.forStream = function(r, n) {
      return new t(r, n);
    }, t;
  })(fm)
), iT = (
  /** @class */
  (function() {
    function e(t) {
      this.alreadyParsed = !1, this.dict = t.dict, this.bytes = Bs.fromPDFRawStream(t), this.context = this.dict.context;
      var r = this.dict.lookup(F.of("Size"), we), n = this.dict.lookup(F.of("Index"));
      if (n instanceof _e) {
        this.subsections = [];
        for (var o = 0, i = n.size(); o < i; o += 2) {
          var a = n.lookup(o + 0, we).asNumber(), s = n.lookup(o + 1, we).asNumber();
          this.subsections.push({ firstObjectNumber: a, length: s });
        }
      } else
        this.subsections = [{ firstObjectNumber: 0, length: r.asNumber() }];
      var c = this.dict.lookup(F.of("W"), _e);
      this.byteWidths = [-1, -1, -1];
      for (var o = 0, i = c.size(); o < i; o++)
        this.byteWidths[o] = c.lookup(o, we).asNumber();
    }
    return e.prototype.parseIntoContext = function() {
      if (this.alreadyParsed)
        throw new Cu("PDFXRefStreamParser", "parseIntoContext");
      this.alreadyParsed = !0, this.context.trailerInfo = {
        Root: this.dict.get(F.of("Root")),
        Encrypt: this.dict.get(F.of("Encrypt")),
        Info: this.dict.get(F.of("Info")),
        ID: this.dict.get(F.of("ID"))
      };
      var t = this.parseEntries();
      return t;
    }, e.prototype.parseEntries = function() {
      for (var t = [], r = this.byteWidths, n = r[0], o = r[1], i = r[2], a = 0, s = this.subsections.length; a < s; a++)
        for (var c = this.subsections[a], l = c.firstObjectNumber, u = c.length, d = 0; d < u; d++) {
          for (var f = 0, h = 0, g = n; h < g; h++)
            f = f << 8 | this.bytes.next();
          for (var v = 0, h = 0, g = o; h < g; h++)
            v = v << 8 | this.bytes.next();
          for (var y = 0, h = 0, g = i; h < g; h++)
            y = y << 8 | this.bytes.next();
          n === 0 && (f = 1);
          var b = l + d, x = {
            ref: et.of(b, y),
            offset: v,
            deleted: f === 0,
            inObjectStream: f === 2
          };
          t.push(x);
        }
      return t;
    }, e.forStream = function(t) {
      return new e(t);
    }, e;
  })()
), aT = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o, i) {
      n === void 0 && (n = 1 / 0), o === void 0 && (o = !1), i === void 0 && (i = !1);
      var a = e.call(this, Bs.of(r), ol.create(), i) || this;
      return a.alreadyParsed = !1, a.parsedObjects = 0, a.shouldWaitForTick = function() {
        return a.parsedObjects += 1, a.parsedObjects % a.objectsPerTick === 0;
      }, a.objectsPerTick = n, a.throwOnInvalidObject = o, a;
    }
    return t.prototype.parseDocument = function() {
      return Re(this, void 0, void 0, function() {
        var r, n;
        return Te(this, function(o) {
          switch (o.label) {
            case 0:
              if (this.alreadyParsed)
                throw new Cu("PDFParser", "parseDocument");
              this.alreadyParsed = !0, this.context.header = this.parseHeader(), o.label = 1;
            case 1:
              return this.bytes.done() ? [3, 3] : [4, this.parseDocumentSection()];
            case 2:
              if (o.sent(), n = this.bytes.offset(), n === r)
                throw new vR(this.bytes.position());
              return r = n, [3, 1];
            case 3:
              return this.maybeRecoverRoot(), this.context.lookup(et.of(0)) && (console.warn("Removing parsed object: 0 0 R"), this.context.delete(et.of(0))), [2, this.context];
          }
        });
      });
    }, t.prototype.maybeRecoverRoot = function() {
      var r = function(u) {
        return u instanceof De && u.lookup(F.of("Type")) === F.of("Catalog");
      }, n = this.context.lookup(this.context.trailerInfo.Root);
      if (!r(n))
        for (var o = this.context.enumerateIndirectObjects(), i = 0, a = o.length; i < a; i++) {
          var s = o[i], c = s[0], l = s[1];
          r(l) && (this.context.trailerInfo.Root = c);
        }
    }, t.prototype.parseHeader = function() {
      for (; !this.bytes.done(); ) {
        if (this.matchKeyword(ot.header)) {
          var r = this.parseRawInt();
          this.bytes.assertNext(T.Period);
          var n = this.parseRawInt(), o = Ds.forVersion(r, n);
          return this.skipBinaryHeaderComment(), o;
        }
        this.bytes.next();
      }
      throw new pR(this.bytes.position());
    }, t.prototype.parseIndirectObjectHeader = function() {
      this.skipWhitespaceAndComments();
      var r = this.parseRawInt();
      this.skipWhitespaceAndComments();
      var n = this.parseRawInt();
      if (this.skipWhitespaceAndComments(), !this.matchKeyword(ot.obj))
        throw new gR(this.bytes.position(), ot.obj);
      return et.of(r, n);
    }, t.prototype.matchIndirectObjectHeader = function() {
      var r = this.bytes.offset();
      try {
        return this.parseIndirectObjectHeader(), !0;
      } catch {
        return this.bytes.moveTo(r), !1;
      }
    }, t.prototype.parseIndirectObject = function() {
      return Re(this, void 0, void 0, function() {
        var r, n;
        return Te(this, function(o) {
          switch (o.label) {
            case 0:
              return r = this.parseIndirectObjectHeader(), this.skipWhitespaceAndComments(), n = this.parseObject(), this.skipWhitespaceAndComments(), this.matchKeyword(ot.endobj), n instanceof wi && n.dict.lookup(F.of("Type")) === F.of("ObjStm") ? [4, oT.forStream(n, this.shouldWaitForTick).parseIntoContext()] : [3, 2];
            case 1:
              return o.sent(), [3, 3];
            case 2:
              n instanceof wi && n.dict.lookup(F.of("Type")) === F.of("XRef") ? iT.forStream(n).parseIntoContext() : this.context.assign(r, n), o.label = 3;
            case 3:
              return [2, r];
          }
        });
      });
    }, t.prototype.tryToParseInvalidIndirectObject = function() {
      var r = this.bytes.position(), n = "Trying to parse invalid object: " + JSON.stringify(r) + ")";
      if (this.throwOnInvalidObject)
        throw new Error(n);
      console.warn(n);
      var o = this.parseIndirectObjectHeader();
      console.warn("Invalid object ref: " + o), this.skipWhitespaceAndComments();
      for (var i = this.bytes.offset(), a = !0; !this.bytes.done() && (this.matchKeyword(ot.endobj) && (a = !1), !!a); )
        this.bytes.next();
      if (a)
        throw new dR(r);
      var s = this.bytes.offset() - ot.endobj.length, c = em.of(this.bytes.slice(i, s));
      return this.context.assign(o, c), o;
    }, t.prototype.parseIndirectObjects = function() {
      return Re(this, void 0, void 0, function() {
        var r;
        return Te(this, function(n) {
          switch (n.label) {
            case 0:
              this.skipWhitespaceAndComments(), n.label = 1;
            case 1:
              if (!(!this.bytes.done() && At[this.bytes.peek()])) return [3, 8];
              r = this.bytes.offset(), n.label = 2;
            case 2:
              return n.trys.push([2, 4, , 5]), [4, this.parseIndirectObject()];
            case 3:
              return n.sent(), [3, 5];
            case 4:
              return n.sent(), this.bytes.moveTo(r), this.tryToParseInvalidIndirectObject(), [3, 5];
            case 5:
              return this.skipWhitespaceAndComments(), this.skipJibberish(), this.shouldWaitForTick() ? [4, Fo()] : [3, 7];
            case 6:
              n.sent(), n.label = 7;
            case 7:
              return [3, 1];
            case 8:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.maybeParseCrossRefSection = function() {
      if (this.skipWhitespaceAndComments(), !!this.matchKeyword(ot.xref)) {
        this.skipWhitespaceAndComments();
        for (var r = -1, n = Jg.createEmpty(); !this.bytes.done() && At[this.bytes.peek()]; ) {
          var o = this.parseRawInt();
          this.skipWhitespaceAndComments();
          var i = this.parseRawInt();
          this.skipWhitespaceAndComments();
          var a = this.bytes.peek();
          if (a === T.n || a === T.f) {
            var s = et.of(r, i);
            this.bytes.next() === T.n ? n.addEntry(s, o) : n.addDeletedEntry(s, o), r += 1;
          } else
            r = o;
          this.skipWhitespaceAndComments();
        }
        return n;
      }
    }, t.prototype.maybeParseTrailerDict = function() {
      if (this.skipWhitespaceAndComments(), !!this.matchKeyword(ot.trailer)) {
        this.skipWhitespaceAndComments();
        var r = this.parseDict(), n = this.context;
        n.trailerInfo = {
          Root: r.get(F.of("Root")) || n.trailerInfo.Root,
          Encrypt: r.get(F.of("Encrypt")) || n.trailerInfo.Encrypt,
          Info: r.get(F.of("Info")) || n.trailerInfo.Info,
          ID: r.get(F.of("ID")) || n.trailerInfo.ID
        };
      }
    }, t.prototype.maybeParseTrailer = function() {
      if (this.skipWhitespaceAndComments(), !!this.matchKeyword(ot.startxref)) {
        this.skipWhitespaceAndComments();
        var r = this.parseRawInt();
        return this.skipWhitespace(), this.matchKeyword(ot.eof), this.skipWhitespaceAndComments(), this.matchKeyword(ot.eof), this.skipWhitespaceAndComments(), ku.forLastCrossRefSectionOffset(r);
      }
    }, t.prototype.parseDocumentSection = function() {
      return Re(this, void 0, void 0, function() {
        return Te(this, function(r) {
          switch (r.label) {
            case 0:
              return [4, this.parseIndirectObjects()];
            case 1:
              return r.sent(), this.maybeParseCrossRefSection(), this.maybeParseTrailerDict(), this.maybeParseTrailer(), this.skipJibberish(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.skipJibberish = function() {
      for (this.skipWhitespaceAndComments(); !this.bytes.done(); ) {
        var r = this.bytes.offset(), n = this.bytes.peek(), o = n >= T.Space && n <= T.Tilde;
        if (o && (this.matchKeyword(ot.xref) || this.matchKeyword(ot.trailer) || this.matchKeyword(ot.startxref) || this.matchIndirectObjectHeader())) {
          this.bytes.moveTo(r);
          break;
        }
        this.bytes.next();
      }
    }, t.prototype.skipBinaryHeaderComment = function() {
      this.skipWhitespaceAndComments();
      try {
        var r = this.bytes.offset();
        this.parseIndirectObjectHeader(), this.bytes.moveTo(r);
      } catch {
        this.bytes.next(), this.skipWhitespaceAndComments();
      }
    }, t.forBytesWithOptions = function(r, n, o, i) {
      return new t(r, n, o, i);
    }, t;
  })(fm)
), Er = function(e) {
  return 1 << e;
}, di;
(function(e) {
  e[e.Invisible = Er(0)] = "Invisible", e[e.Hidden = Er(1)] = "Hidden", e[e.Print = Er(2)] = "Print", e[e.NoZoom = Er(3)] = "NoZoom", e[e.NoRotate = Er(4)] = "NoRotate", e[e.NoView = Er(5)] = "NoView", e[e.ReadOnly = Er(6)] = "ReadOnly", e[e.Locked = Er(7)] = "Locked", e[e.ToggleNoView = Er(8)] = "ToggleNoView", e[e.LockedContents = Er(9)] = "LockedContents";
})(di || (di = {}));
var Ls = function(e) {
  return e instanceof F ? e : F.of(e);
}, xe = function(e) {
  return e instanceof we ? e : we.of(e);
}, Ae = function(e) {
  return e instanceof we ? e.asNumber() : e;
}, xi;
(function(e) {
  e.Degrees = "degrees", e.Radians = "radians";
})(xi || (xi = {}));
var ye = function(e) {
  return B(e, "degreeAngle", ["number"]), { type: xi.Degrees, angle: e };
}, hm = xi.Radians, vm = xi.Degrees, pm = function(e) {
  return e * Math.PI / 180;
}, sT = function(e) {
  return e * 180 / Math.PI;
}, Et = function(e) {
  return e.type === hm ? e.angle : e.type === vm ? pm(e.angle) : Ui("Invalid rotation: " + JSON.stringify(e));
}, gm = function(e) {
  return e.type === hm ? sT(e.angle) : e.type === vm ? e.angle : Ui("Invalid rotation: " + JSON.stringify(e));
}, Zr = function(e) {
  e === void 0 && (e = 0);
  var t = e / 90 % 4;
  return t === 0 ? 0 : t === 1 ? 90 : t === 2 ? 180 : t === 3 ? 270 : 0;
}, Yn = function(e, t) {
  t === void 0 && (t = 0);
  var r = Zr(t);
  return r === 90 || r === 270 ? { width: e.height, height: e.width } : { width: e.width, height: e.height };
}, cT = function(e, t, r) {
  t === void 0 && (t = 0), r === void 0 && (r = 0);
  var n = e.x, o = e.y, i = e.width, a = e.height, s = Zr(r), c = t / 2;
  return s === 0 ? { x: n - c, y: o - c, width: i, height: a } : s === 90 ? { x: n - a + c, y: o - c, width: a, height: i } : s === 180 ? { x: n - i + c, y: o - a + c, width: i, height: a } : s === 270 ? { x: n - c, y: o - i + c, width: a, height: i } : { x: n - c, y: o - c, width: i, height: a };
}, mm = function() {
  return He.of(Ke.ClipNonZero);
}, Ga = Math.cos, Ka = Math.sin, Xa = Math.tan, Ws = function(e, t, r, n, o, i) {
  return He.of(Ke.ConcatTransformationMatrix, [
    xe(e),
    xe(t),
    xe(r),
    xe(n),
    xe(o),
    xe(i)
  ]);
}, rr = function(e, t) {
  return Ws(1, 0, 0, 1, e, t);
}, Ci = function(e, t) {
  return Ws(e, 0, 0, t, 0, 0);
}, Lo = function(e) {
  return Ws(Ga(Ae(e)), Ka(Ae(e)), -Ka(Ae(e)), Ga(Ae(e)), 0, 0);
}, da = function(e) {
  return Lo(pm(Ae(e)));
}, Ou = function(e, t) {
  return Ws(1, Xa(Ae(e)), Xa(Ae(t)), 1, 0, 0);
}, zs = function(e, t) {
  return He.of(Ke.SetLineDashPattern, [
    "[" + e.map(xe).join(" ") + "]",
    xe(t)
  ]);
}, mo;
(function(e) {
  e[e.Butt = 0] = "Butt", e[e.Round = 1] = "Round", e[e.Projecting = 2] = "Projecting";
})(mo || (mo = {}));
var js = function(e) {
  return He.of(Ke.SetLineCapStyle, [xe(e)]);
}, Tf;
(function(e) {
  e[e.Miter = 0] = "Miter", e[e.Round = 1] = "Round", e[e.Bevel = 2] = "Bevel";
})(Tf || (Tf = {}));
var Zn = function(e) {
  return He.of(Ke.SetGraphicsStateParams, [Ls(e)]);
}, gt = function() {
  return He.of(Ke.PushGraphicsState);
}, mt = function() {
  return He.of(Ke.PopGraphicsState);
}, Hi = function(e) {
  return He.of(Ke.SetLineWidth, [xe(e)]);
}, Ht = function(e, t, r, n, o, i) {
  return He.of(Ke.AppendBezierCurve, [
    xe(e),
    xe(t),
    xe(r),
    xe(n),
    xe(o),
    xe(i)
  ]);
}, fa = function(e, t, r, n) {
  return He.of(Ke.CurveToReplicateInitialPoint, [
    xe(e),
    xe(t),
    xe(r),
    xe(n)
  ]);
}, bn = function() {
  return He.of(Ke.ClosePath);
}, Tr = function(e, t) {
  return He.of(Ke.MoveTo, [xe(e), xe(t)]);
}, yt = function(e, t) {
  return He.of(Ke.LineTo, [xe(e), xe(t)]);
}, qi = function() {
  return He.of(Ke.StrokePath);
}, Mu = function() {
  return He.of(Ke.FillNonZero);
}, Iu = function() {
  return He.of(Ke.FillNonZeroAndStroke);
}, ym = function() {
  return He.of(Ke.EndPath);
}, lT = function() {
  return He.of(Ke.NextLine);
}, bm = function(e) {
  return He.of(Ke.ShowText, [e]);
}, wm = function() {
  return He.of(Ke.BeginText);
}, xm = function() {
  return He.of(Ke.EndText);
}, Bu = function(e, t) {
  return He.of(Ke.SetFontAndSize, [Ls(e), xe(t)]);
}, uT = function(e) {
  return He.of(Ke.SetTextLineHeight, [xe(e)]);
}, Af;
(function(e) {
  e[e.Fill = 0] = "Fill", e[e.Outline = 1] = "Outline", e[e.FillAndOutline = 2] = "FillAndOutline", e[e.Invisible = 3] = "Invisible", e[e.FillAndClip = 4] = "FillAndClip", e[e.OutlineAndClip = 5] = "OutlineAndClip", e[e.FillAndOutlineAndClip = 6] = "FillAndOutlineAndClip", e[e.Clip = 7] = "Clip";
})(Af || (Af = {}));
var dT = function(e, t, r, n, o, i) {
  return He.of(Ke.SetTextMatrix, [
    xe(e),
    xe(t),
    xe(r),
    xe(n),
    xe(o),
    xe(i)
  ]);
}, Cm = function(e, t, r, n, o) {
  return dT(Ga(Ae(e)), Ka(Ae(e)) + Xa(Ae(t)), -Ka(Ae(e)) + Xa(Ae(r)), Ga(Ae(e)), n, o);
}, Lu = function(e) {
  return He.of(Ke.DrawObject, [Ls(e)]);
}, fT = function(e) {
  return He.of(Ke.NonStrokingColorGray, [xe(e)]);
}, hT = function(e) {
  return He.of(Ke.StrokingColorGray, [xe(e)]);
}, vT = function(e, t, r) {
  return He.of(Ke.NonStrokingColorRgb, [
    xe(e),
    xe(t),
    xe(r)
  ]);
}, pT = function(e, t, r) {
  return He.of(Ke.StrokingColorRgb, [
    xe(e),
    xe(t),
    xe(r)
  ]);
}, gT = function(e, t, r, n) {
  return He.of(Ke.NonStrokingColorCmyk, [
    xe(e),
    xe(t),
    xe(r),
    xe(n)
  ]);
}, mT = function(e, t, r, n) {
  return He.of(Ke.StrokingColorCmyk, [
    xe(e),
    xe(t),
    xe(r),
    xe(n)
  ]);
}, Sm = function(e) {
  return He.of(Ke.BeginMarkedContent, [Ls(e)]);
}, Pm = function() {
  return He.of(Ke.EndMarkedContent);
}, wn;
(function(e) {
  e.Grayscale = "Grayscale", e.RGB = "RGB", e.CMYK = "CMYK";
})(wn || (wn = {}));
var Em = function(e) {
  return Vt(e, "gray", 0, 1), { type: wn.Grayscale, gray: e };
}, tt = function(e, t, r) {
  return Vt(e, "red", 0, 1), Vt(t, "green", 0, 1), Vt(r, "blue", 0, 1), { type: wn.RGB, red: e, green: t, blue: r };
}, km = function(e, t, r, n) {
  return Vt(e, "cyan", 0, 1), Vt(t, "magenta", 0, 1), Vt(r, "yellow", 0, 1), Vt(n, "key", 0, 1), { type: wn.CMYK, cyan: e, magenta: t, yellow: r, key: n };
}, Wu = wn.Grayscale, zu = wn.RGB, ju = wn.CMYK, _n = function(e) {
  return e.type === Wu ? fT(e.gray) : e.type === zu ? vT(e.red, e.green, e.blue) : e.type === ju ? gT(e.cyan, e.magenta, e.yellow, e.key) : Ui("Invalid color: " + JSON.stringify(e));
}, Gi = function(e) {
  return e.type === Wu ? hT(e.gray) : e.type === zu ? pT(e.red, e.green, e.blue) : e.type === ju ? mT(e.cyan, e.magenta, e.yellow, e.key) : Ui("Invalid color: " + JSON.stringify(e));
}, Bt = function(e, t) {
  return t === void 0 && (t = 1), e?.length === 1 ? Em(e[0] * t) : e?.length === 3 ? tt(e[0] * t, e[1] * t, e[2] * t) : e?.length === 4 ? km(e[0] * t, e[1] * t, e[2] * t, e[3] * t) : void 0;
}, Nf = function(e) {
  return e.type === Wu ? [e.gray] : e.type === zu ? [e.red, e.green, e.blue] : e.type === ju ? [e.cyan, e.magenta, e.yellow, e.key] : Ui("Invalid color: " + JSON.stringify(e));
}, de = 0, fe = 0, ze = 0, je = 0, ti = 0, ri = 0, Of = /* @__PURE__ */ new Map([
  ["A", 7],
  ["a", 7],
  ["C", 6],
  ["c", 6],
  ["H", 1],
  ["h", 1],
  ["L", 2],
  ["l", 2],
  ["M", 2],
  ["m", 2],
  ["Q", 4],
  ["q", 4],
  ["S", 4],
  ["s", 4],
  ["T", 2],
  ["t", 2],
  ["V", 1],
  ["v", 1],
  ["Z", 0],
  ["z", 0]
]), yT = function(e) {
  for (var t, r = [], n = [], o = "", i = !1, a = 0, s = 0, c = e; s < c.length; s++) {
    var l = c[s];
    if (Of.has(l))
      a = Of.get(l), t && (o.length > 0 && (n[n.length] = +o), r[r.length] = { cmd: t, args: n }, n = [], o = "", i = !1), t = l;
    else if ([" ", ","].includes(l) || l === "-" && o.length > 0 && o[o.length - 1] !== "e" || l === "." && i) {
      if (o.length === 0)
        continue;
      n.length === a ? (r[r.length] = { cmd: t, args: n }, n = [+o], t === "M" && (t = "L"), t === "m" && (t = "l")) : n[n.length] = +o, i = l === ".", o = ["-", "."].includes(l) ? l : "";
    } else
      o += l, l === "." && (i = !0);
  }
  return o.length > 0 && (n.length === a ? (r[r.length] = { cmd: t, args: n }, n = [+o], t === "M" && (t = "L"), t === "m" && (t = "l")) : n[n.length] = +o), r[r.length] = { cmd: t, args: n }, r;
}, bT = function(e) {
  de = fe = ze = je = ti = ri = 0;
  for (var t = [], r = 0; r < e.length; r++) {
    var n = e[r];
    if (n.cmd && typeof Mf[n.cmd] == "function") {
      var o = Mf[n.cmd](n.args);
      Array.isArray(o) ? t = t.concat(o) : t.push(o);
    }
  }
  return t;
}, Mf = {
  M: function(e) {
    return de = e[0], fe = e[1], ze = je = null, ti = de, ri = fe, Tr(de, fe);
  },
  m: function(e) {
    return de += e[0], fe += e[1], ze = je = null, ti = de, ri = fe, Tr(de, fe);
  },
  C: function(e) {
    return de = e[4], fe = e[5], ze = e[2], je = e[3], Ht(e[0], e[1], e[2], e[3], e[4], e[5]);
  },
  c: function(e) {
    var t = Ht(e[0] + de, e[1] + fe, e[2] + de, e[3] + fe, e[4] + de, e[5] + fe);
    return ze = de + e[2], je = fe + e[3], de += e[4], fe += e[5], t;
  },
  S: function(e) {
    (ze === null || je === null) && (ze = de, je = fe);
    var t = Ht(de - (ze - de), fe - (je - fe), e[0], e[1], e[2], e[3]);
    return ze = e[0], je = e[1], de = e[2], fe = e[3], t;
  },
  s: function(e) {
    (ze === null || je === null) && (ze = de, je = fe);
    var t = Ht(de - (ze - de), fe - (je - fe), de + e[0], fe + e[1], de + e[2], fe + e[3]);
    return ze = de + e[0], je = fe + e[1], de += e[2], fe += e[3], t;
  },
  Q: function(e) {
    return ze = e[0], je = e[1], de = e[2], fe = e[3], fa(e[0], e[1], de, fe);
  },
  q: function(e) {
    var t = fa(e[0] + de, e[1] + fe, e[2] + de, e[3] + fe);
    return ze = de + e[0], je = fe + e[1], de += e[2], fe += e[3], t;
  },
  T: function(e) {
    ze === null || je === null ? (ze = de, je = fe) : (ze = de - (ze - de), je = fe - (je - fe));
    var t = fa(ze, je, e[0], e[1]);
    return ze = de - (ze - de), je = fe - (je - fe), de = e[0], fe = e[1], t;
  },
  t: function(e) {
    ze === null || je === null ? (ze = de, je = fe) : (ze = de - (ze - de), je = fe - (je - fe));
    var t = fa(ze, je, de + e[0], fe + e[1]);
    return de += e[0], fe += e[1], t;
  },
  A: function(e) {
    var t = If(de, fe, e);
    return de = e[5], fe = e[6], t;
  },
  a: function(e) {
    e[5] += de, e[6] += fe;
    var t = If(de, fe, e);
    return de = e[5], fe = e[6], t;
  },
  L: function(e) {
    return de = e[0], fe = e[1], ze = je = null, yt(de, fe);
  },
  l: function(e) {
    return de += e[0], fe += e[1], ze = je = null, yt(de, fe);
  },
  H: function(e) {
    return de = e[0], ze = je = null, yt(de, fe);
  },
  h: function(e) {
    return de += e[0], ze = je = null, yt(de, fe);
  },
  V: function(e) {
    return fe = e[0], ze = je = null, yt(de, fe);
  },
  v: function(e) {
    return fe += e[0], ze = je = null, yt(de, fe);
  },
  Z: function() {
    var e = bn();
    return de = ti, fe = ri, e;
  },
  z: function() {
    var e = bn();
    return de = ti, fe = ri, e;
  }
}, If = function(e, t, r) {
  for (var n = r[0], o = r[1], i = r[2], a = r[3], s = r[4], c = r[5], l = r[6], u = wT(c, l, n, o, a, s, i, e, t), d = [], f = 0, h = u; f < h.length; f++) {
    var g = h[f], v = xT.apply(void 0, g);
    d.push(Ht.apply(void 0, v));
  }
  return d;
}, wT = function(e, t, r, n, o, i, a, s, c) {
  var l = a * (Math.PI / 180), u = Math.sin(l), d = Math.cos(l);
  r = Math.abs(r), n = Math.abs(n), ze = d * (s - e) * 0.5 + u * (c - t) * 0.5, je = d * (c - t) * 0.5 - u * (s - e) * 0.5;
  var f = ze * ze / (r * r) + je * je / (n * n);
  f > 1 && (f = Math.sqrt(f), r *= f, n *= f);
  var h = d / r, g = u / r, v = -u / n, y = d / n, b = h * s + g * c, x = v * s + y * c, C = h * e + g * t, E = v * e + y * t, D = (C - b) * (C - b) + (E - x) * (E - x), A = 1 / D - 0.25;
  A < 0 && (A = 0);
  var R = Math.sqrt(A);
  i === o && (R = -R);
  var O = 0.5 * (b + C) - R * (E - x), W = 0.5 * (x + E) + R * (C - b), z = Math.atan2(x - W, b - O), q = Math.atan2(E - W, C - O), V = q - z;
  V < 0 && i === 1 ? V += 2 * Math.PI : V > 0 && i === 0 && (V -= 2 * Math.PI);
  for (var I = Math.ceil(Math.abs(V / (Math.PI * 0.5 + 1e-3))), Z = [], Q = 0; Q < I; Q++) {
    var K = z + Q * V / I, L = z + (Q + 1) * V / I;
    Z[Q] = [O, W, K, L, r, n, u, d];
  }
  return Z;
}, xT = function(e, t, r, n, o, i, a, s) {
  var c = s * o, l = -a * i, u = a * o, d = s * i, f = 0.5 * (n - r), h = 8 / 3 * Math.sin(f * 0.5) * Math.sin(f * 0.5) / Math.sin(f), g = e + Math.cos(r) - h * Math.sin(r), v = t + Math.sin(r) + h * Math.cos(r), y = e + Math.cos(n), b = t + Math.sin(n), x = y + h * Math.sin(n), C = b - h * Math.cos(n), E = [
    c * g + l * v,
    u * g + d * v,
    c * x + l * C,
    u * x + d * C,
    c * y + l * b,
    u * y + d * b
  ];
  return E;
}, CT = function(e) {
  return bT(yT(e));
}, ST = function(e, t) {
  for (var r = [
    gt(),
    t.graphicsState && Zn(t.graphicsState),
    wm(),
    _n(t.color),
    Bu(t.font, t.size),
    uT(t.lineHeight),
    Cm(Et(t.rotate), Et(t.xSkew), Et(t.ySkew), t.x, t.y)
  ].filter(Boolean), n = 0, o = e.length; n < o; n++)
    r.push(bm(e[n]), lT());
  return r.push(xm(), mt()), r;
}, Fm = function(e, t) {
  return [
    gt(),
    t.graphicsState && Zn(t.graphicsState),
    rr(t.x, t.y),
    Lo(Et(t.rotate)),
    Ci(t.width, t.height),
    Ou(Et(t.xSkew), Et(t.ySkew)),
    Lu(e),
    mt()
  ].filter(Boolean);
}, PT = function(e, t) {
  return [
    gt(),
    t.graphicsState && Zn(t.graphicsState),
    rr(t.x, t.y),
    Lo(Et(t.rotate)),
    Ci(t.xScale, t.yScale),
    Ou(Et(t.xSkew), Et(t.ySkew)),
    Lu(e),
    mt()
  ].filter(Boolean);
}, ET = function(e) {
  var t, r;
  return [
    gt(),
    e.graphicsState && Zn(e.graphicsState),
    e.color && Gi(e.color),
    Hi(e.thickness),
    zs((t = e.dashArray) !== null && t !== void 0 ? t : [], (r = e.dashPhase) !== null && r !== void 0 ? r : 0),
    Tr(e.start.x, e.start.y),
    e.lineCap && js(e.lineCap),
    Tr(e.start.x, e.start.y),
    yt(e.end.x, e.end.y),
    qi(),
    mt()
  ].filter(Boolean);
}, Do = function(e) {
  var t, r;
  return [
    gt(),
    e.graphicsState && Zn(e.graphicsState),
    e.color && _n(e.color),
    e.borderColor && Gi(e.borderColor),
    Hi(e.borderWidth),
    e.borderLineCap && js(e.borderLineCap),
    zs((t = e.borderDashArray) !== null && t !== void 0 ? t : [], (r = e.borderDashPhase) !== null && r !== void 0 ? r : 0),
    rr(e.x, e.y),
    Lo(Et(e.rotate)),
    Ou(Et(e.xSkew), Et(e.ySkew)),
    Tr(0, 0),
    yt(0, e.height),
    yt(e.width, e.height),
    yt(e.width, 0),
    bn(),
    // prettier-ignore
    e.color && e.borderWidth ? Iu() : e.color ? Mu() : e.borderColor ? qi() : bn(),
    mt()
  ].filter(Boolean);
}, Ya = 4 * ((Math.sqrt(2) - 1) / 3), kT = function(e) {
  var t = Ae(e.x), r = Ae(e.y), n = Ae(e.xScale), o = Ae(e.yScale);
  t -= n, r -= o;
  var i = n * Ya, a = o * Ya, s = t + n * 2, c = r + o * 2, l = t + n, u = r + o;
  return [
    gt(),
    Tr(t, u),
    Ht(t, u - a, l - i, r, l, r),
    Ht(l + i, r, s, u - a, s, u),
    Ht(s, u + a, l + i, c, l, c),
    Ht(l - i, c, t, u + a, t, u),
    mt()
  ];
}, FT = function(e) {
  var t = Ae(e.x), r = Ae(e.y), n = Ae(e.xScale), o = Ae(e.yScale), i = -n, a = -o, s = n * Ya, c = o * Ya, l = i + n * 2, u = a + o * 2, d = i + n, f = a + o;
  return [
    rr(t, r),
    Lo(Et(e.rotate)),
    Tr(i, f),
    Ht(i, f - c, d - s, a, d, a),
    Ht(d + s, a, l, f - c, l, f),
    Ht(l, f + c, d + s, u, d, u),
    Ht(d - s, u, i, f + c, i, f)
  ];
}, cl = function(e) {
  var t, r, n;
  return Ge([
    gt(),
    e.graphicsState && Zn(e.graphicsState),
    e.color && _n(e.color),
    e.borderColor && Gi(e.borderColor),
    Hi(e.borderWidth),
    e.borderLineCap && js(e.borderLineCap),
    zs((t = e.borderDashArray) !== null && t !== void 0 ? t : [], (r = e.borderDashPhase) !== null && r !== void 0 ? r : 0)
  ], e.rotate === void 0 ? kT({
    x: e.x,
    y: e.y,
    xScale: e.xScale,
    yScale: e.yScale
  }) : FT({
    x: e.x,
    y: e.y,
    xScale: e.xScale,
    yScale: e.yScale,
    rotate: (n = e.rotate) !== null && n !== void 0 ? n : ye(0)
  }), [
    // prettier-ignore
    e.color && e.borderWidth ? Iu() : e.color ? Mu() : e.borderColor ? qi() : bn(),
    mt()
  ]).filter(Boolean);
}, DT = function(e, t) {
  var r, n, o;
  return Ge([
    gt(),
    t.graphicsState && Zn(t.graphicsState),
    rr(t.x, t.y),
    Lo(Et((r = t.rotate) !== null && r !== void 0 ? r : ye(0))),
    // SVG path Y axis is opposite pdf-lib's
    t.scale ? Ci(t.scale, -t.scale) : Ci(1, -1),
    t.color && _n(t.color),
    t.borderColor && Gi(t.borderColor),
    t.borderWidth && Hi(t.borderWidth),
    t.borderLineCap && js(t.borderLineCap),
    zs((n = t.borderDashArray) !== null && n !== void 0 ? n : [], (o = t.borderDashPhase) !== null && o !== void 0 ? o : 0)
  ], CT(e), [
    // prettier-ignore
    t.color && t.borderWidth ? Iu() : t.color ? Mu() : t.borderColor ? qi() : bn(),
    mt()
  ]).filter(Boolean);
}, RT = function(e) {
  var t = Ae(e.size), r = -1 + 0.75, n = -1 + 0.51, o = 1 - 0.525, i = 1 - 0.31, a = -1 + 0.325, s = 0.3995 / (o - n) + n;
  return [
    gt(),
    e.color && Gi(e.color),
    Hi(e.thickness),
    rr(e.x, e.y),
    Tr(a * t, s * t),
    yt(r * t, n * t),
    yt(i * t, o * t),
    qi(),
    mt()
  ].filter(Boolean);
}, Mn = function(e) {
  return e.rotation === 0 ? [
    rr(0, 0),
    da(0)
  ] : e.rotation === 90 ? [
    rr(e.width, 0),
    da(90)
  ] : e.rotation === 180 ? [
    rr(e.width, e.height),
    da(180)
  ] : e.rotation === 270 ? [
    rr(0, e.height),
    da(270)
  ] : [];
}, ha = function(e) {
  var t = Do({
    x: e.x,
    y: e.y,
    width: e.width,
    height: e.height,
    borderWidth: e.borderWidth,
    color: e.color,
    borderColor: e.borderColor,
    rotate: ye(0),
    xSkew: ye(0),
    ySkew: ye(0)
  });
  if (!e.filled)
    return t;
  var r = Ae(e.width), n = Ae(e.height), o = Math.min(r, n) / 2, i = RT({
    x: r / 2,
    y: n / 2,
    size: o,
    thickness: e.thickness,
    color: e.markColor
  });
  return Ge([gt()], t, i, [mt()]);
}, va = function(e) {
  var t = Ae(e.width), r = Ae(e.height), n = Math.min(t, r) / 2, o = cl({
    x: e.x,
    y: e.y,
    xScale: n,
    yScale: n,
    color: e.color,
    borderColor: e.borderColor,
    borderWidth: e.borderWidth
  });
  if (!e.filled)
    return o;
  var i = cl({
    x: e.x,
    y: e.y,
    xScale: n * 0.45,
    yScale: n * 0.45,
    color: e.dotColor,
    borderColor: void 0,
    borderWidth: 0
  });
  return Ge([gt()], o, i, [mt()]);
}, Bf = function(e) {
  var t = Ae(e.x), r = Ae(e.y), n = Ae(e.width), o = Ae(e.height), i = Do({
    x: t,
    y: r,
    width: n,
    height: o,
    borderWidth: e.borderWidth,
    color: e.color,
    borderColor: e.borderColor,
    rotate: ye(0),
    xSkew: ye(0),
    ySkew: ye(0)
  }), a = Uu(e.textLines, {
    color: e.textColor,
    font: e.font,
    size: e.fontSize,
    rotate: ye(0),
    xSkew: ye(0),
    ySkew: ye(0)
  });
  return Ge([gt()], i, a, [mt()]);
}, Uu = function(e, t) {
  for (var r = [
    wm(),
    _n(t.color),
    Bu(t.font, t.size)
  ], n = 0, o = e.length; n < o; n++) {
    var i = e[n], a = i.encoded, s = i.x, c = i.y;
    r.push(Cm(Et(t.rotate), Et(t.xSkew), Et(t.ySkew), s, c), bm(a));
  }
  return r.push(xm()), r;
}, Dm = function(e) {
  var t = Ae(e.x), r = Ae(e.y), n = Ae(e.width), o = Ae(e.height), i = Ae(e.borderWidth), a = Ae(e.padding), s = t + i / 2 + a, c = r + i / 2 + a, l = n - (i / 2 + a) * 2, u = o - (i / 2 + a) * 2, d = [
    Tr(s, c),
    yt(s, c + u),
    yt(s + l, c + u),
    yt(s + l, c),
    bn(),
    mm(),
    ym()
  ], f = Do({
    x: t,
    y: r,
    width: n,
    height: o,
    borderWidth: e.borderWidth,
    color: e.color,
    borderColor: e.borderColor,
    rotate: ye(0),
    xSkew: ye(0),
    ySkew: ye(0)
  }), h = Uu(e.textLines, {
    color: e.textColor,
    font: e.font,
    size: e.fontSize,
    rotate: ye(0),
    xSkew: ye(0),
    ySkew: ye(0)
  }), g = Ge([
    Sm("Tx"),
    gt()
  ], h, [
    mt(),
    Pm()
  ]);
  return Ge([
    gt()
  ], f, d, g, [
    mt()
  ]);
}, TT = function(e) {
  for (var t = Ae(e.x), r = Ae(e.y), n = Ae(e.width), o = Ae(e.height), i = Ae(e.lineHeight), a = Ae(e.borderWidth), s = Ae(e.padding), c = t + a / 2 + s, l = r + a / 2 + s, u = n - (a / 2 + s) * 2, d = o - (a / 2 + s) * 2, f = [
    Tr(c, l),
    yt(c, l + d),
    yt(c + u, l + d),
    yt(c + u, l),
    bn(),
    mm(),
    ym()
  ], h = Do({
    x: t,
    y: r,
    width: n,
    height: o,
    borderWidth: e.borderWidth,
    color: e.color,
    borderColor: e.borderColor,
    rotate: ye(0),
    xSkew: ye(0),
    ySkew: ye(0)
  }), g = [], v = 0, y = e.selectedLines.length; v < y; v++) {
    var b = e.textLines[e.selectedLines[v]];
    g.push.apply(g, Do({
      x: b.x - s,
      y: b.y - (i - b.height) / 2,
      width: n - a,
      height: b.height + (i - b.height) / 2,
      borderWidth: 0,
      color: e.selectedColor,
      borderColor: void 0,
      rotate: ye(0),
      xSkew: ye(0),
      ySkew: ye(0)
    }));
  }
  var x = Uu(e.textLines, {
    color: e.textColor,
    font: e.font,
    size: e.fontSize,
    rotate: ye(0),
    xSkew: ye(0),
    ySkew: ye(0)
  }), C = Ge([
    Sm("Tx"),
    gt()
  ], x, [
    mt(),
    Pm()
  ]);
  return Ge([
    gt()
  ], h, g, f, C, [
    mt()
  ]);
}, AT = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      var r = this, n = "Input document to `PDFDocument.load` is encrypted. You can use `PDFDocument.load(..., { ignoreEncryption: true })` if you wish to load the document anyways.";
      return r = e.call(this, n) || this, r;
    }
    return t;
  })(Error)
), NT = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      var r = this, n = "Input to `PDFDocument.embedFont` was a custom font, but no `fontkit` instance was found. You must register a `fontkit` instance with `PDFDocument.registerFontkit(...)` before embedding custom fonts.";
      return r = e.call(this, n) || this, r;
    }
    return t;
  })(Error)
), OT = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      var r = this, n = "A `page` passed to `PDFDocument.addPage` or `PDFDocument.insertPage` was from a different (foreign) PDF document. If you want to copy pages from one PDFDocument to another, you must use `PDFDocument.copyPages(...)` to copy the pages before adding or inserting them.";
      return r = e.call(this, n) || this, r;
    }
    return t;
  })(Error)
), MT = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t() {
      var r = this, n = "PDFDocument has no pages so `PDFDocument.removePage` cannot be called";
      return r = e.call(this, n) || this, r;
    }
    return t;
  })(Error)
), IT = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = this, o = 'PDFDocument has no form field with the name "' + r + '"';
      return n = e.call(this, o) || this, n;
    }
    return t;
  })(Error)
), Ln = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      var i, a, s = this, c = n?.name, l = (a = (i = o?.constructor) === null || i === void 0 ? void 0 : i.name) !== null && a !== void 0 ? a : o, u = 'Expected field "' + r + '" to be of type ' + c + ", " + ("but it is actually of type " + l);
      return s = e.call(this, u) || this, s;
    }
    return t;
  })(Error)
);
(function(e) {
  ne(t, e);
  function t(r) {
    var n = this, o = 'Failed to select check box due to missing onValue: "' + r + '"';
    return n = e.call(this, o) || this, n;
  }
  return t;
})(Error);
var Rm = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = this, o = 'A field already exists with the specified name: "' + r + '"';
      return n = e.call(this, o) || this, n;
    }
    return t;
  })(Error)
), BT = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = this, o = 'Field name contains invalid component: "' + r + '"';
      return n = e.call(this, o) || this, n;
    }
    return t;
  })(Error)
);
(function(e) {
  ne(t, e);
  function t(r) {
    var n = this, o = 'A non-terminal field already exists with the specified name: "' + r + '"';
    return n = e.call(this, o) || this, n;
  }
  return t;
})(Error);
var LT = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r) {
      var n = this, o = "Reading rich text fields is not supported: Attempted to read rich text field: " + r;
      return n = e.call(this, o) || this, n;
    }
    return t;
  })(Error)
), WT = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n) {
      var o = this, i = "Failed to layout combed text as lineLength=" + r + " is greater than cellCount=" + n;
      return o = e.call(this, i) || this, o;
    }
    return t;
  })(Error)
), zT = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      var i = this, a = "Attempted to set text with length=" + r + " for TextField with maxLength=" + n + " and name=" + o;
      return i = e.call(this, a) || this, i;
    }
    return t;
  })(Error)
), jT = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      var i = this, a = "Attempted to set maxLength=" + n + ", which is less than " + r + ", the length of this field's current value (name=" + o + ")";
      return i = e.call(this, a) || this, i;
    }
    return t;
  })(Error)
), pt;
(function(e) {
  e[e.Left = 0] = "Left", e[e.Center = 1] = "Center", e[e.Right = 2] = "Right";
})(pt || (pt = {}));
var Tm = 4, Am = 500, Nm = function(e, t, r, n) {
  n === void 0 && (n = !1);
  for (var o = Tm; o < Am; ) {
    for (var i = 0, a = 0, s = e.length; a < s; a++) {
      i += 1;
      for (var c = e[a], l = c.split(" "), u = r.width, d = 0, f = l.length; d < f; d++) {
        var h = d === f - 1, g = h ? l[d] : l[d] + " ", v = t.widthOfTextAtSize(g, o);
        u -= v, u <= 0 && (i += 1, u = r.width - v);
      }
    }
    if (!n && i > e.length)
      return o - 1;
    var y = t.heightAtSize(o), b = y + y * 0.2, x = b * i;
    if (x > Math.abs(r.height))
      return o - 1;
    o += 1;
  }
  return o;
}, UT = function(e, t, r, n) {
  for (var o = r.width / n, i = r.height, a = Tm, s = QF(e); a < Am; ) {
    for (var c = 0, l = s.length; c < l; c++) {
      var u = s[c], d = t.widthOfTextAtSize(u, a) > o * 0.75;
      if (d)
        return a - 1;
    }
    var f = t.heightAtSize(a, { descender: !1 });
    if (f > i)
      return a - 1;
    a += 1;
  }
  return a;
}, VT = function(e) {
  for (var t = e.length; t > 0; t--)
    if (/\s/.test(e[t]))
      return t;
}, HT = function(e, t, r, n) {
  for (var o, i = e.length; i > 0; ) {
    var a = e.substring(0, i), s = r.encodeText(a), c = r.widthOfTextAtSize(a, n);
    if (c < t) {
      var l = e.substring(i) || void 0;
      return { line: a, encoded: s, width: c, remainder: l };
    }
    i = (o = VT(a)) !== null && o !== void 0 ? o : 0;
  }
  return {
    line: e,
    encoded: r.encodeText(e),
    width: r.widthOfTextAtSize(e, n),
    remainder: void 0
  };
}, Om = function(e, t) {
  var r = t.alignment, n = t.fontSize, o = t.font, i = t.bounds, a = Tg(ji(e));
  (n === void 0 || n === 0) && (n = Nm(a, o, i, !0));
  for (var s = o.heightAtSize(n), c = s + s * 0.2, l = [], u = i.x, d = i.y, f = i.x + i.width, h = i.y + i.height, g = i.y + i.height, v = 0, y = a.length; v < y; v++)
    for (var b = a[v]; b !== void 0; ) {
      var x = HT(b, i.width, o, n), C = x.line, E = x.encoded, D = x.width, A = x.remainder, R = r === pt.Left ? i.x : r === pt.Center ? i.x + i.width / 2 - D / 2 : r === pt.Right ? i.x + i.width - D : i.x;
      g -= c, R < u && (u = R), g < d && (d = g), R + D > f && (f = R + D), g + s > h && (h = g + s), l.push({ text: C, encoded: E, width: D, height: s, x: R, y: g }), b = A?.trim();
    }
  return {
    fontSize: n,
    lineHeight: c,
    lines: l,
    bounds: {
      x: u,
      y: d,
      width: f - u,
      height: h - d
    }
  };
}, qT = function(e, t) {
  var r = t.fontSize, n = t.font, o = t.bounds, i = t.cellCount, a = Ag(ji(e));
  if (a.length > i)
    throw new WT(a.length, i);
  (r === void 0 || r === 0) && (r = UT(a, n, o, i));
  for (var s = o.width / i, c = n.heightAtSize(r, { descender: !1 }), l = o.y + (o.height / 2 - c / 2), u = [], d = o.x, f = o.y, h = o.x + o.width, g = o.y + o.height, v = 0, y = 0; v < i; ) {
    var b = Ng(a, y), x = b[0], C = b[1], E = n.encodeText(x), D = n.widthOfTextAtSize(x, r), A = o.x + (s * v + s / 2), R = A - D / 2;
    R < d && (d = R), l < f && (f = l), R + D > h && (h = R + D), l + c > g && (g = l + c), u.push({ text: a, encoded: E, width: D, height: c, x: R, y: l }), v += 1, y += C;
  }
  return {
    fontSize: r,
    cells: u,
    bounds: {
      x: d,
      y: f,
      width: h - d,
      height: g - f
    }
  };
}, Za = function(e, t) {
  var r = t.alignment, n = t.fontSize, o = t.font, i = t.bounds, a = Ag(ji(e));
  (n === void 0 || n === 0) && (n = Nm([a], o, i));
  var s = o.encodeText(a), c = o.widthOfTextAtSize(a, n), l = o.heightAtSize(n, { descender: !1 }), u = r === pt.Left ? i.x : r === pt.Center ? i.x + i.width / 2 - c / 2 : r === pt.Right ? i.x + i.width - c : i.x, d = i.y + (i.height / 2 - l / 2);
  return {
    fontSize: n,
    line: { text: a, encoded: s, width: c, height: l, x: u, y: d },
    bounds: { x: u, y: d, width: c, height: l }
  };
}, Wo = function(e) {
  return "normal" in e ? e : { normal: e };
}, GT = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]+(\d*\.\d+|\d+)[\0\t\n\f\r\ ]+Tf/, xn = function(e) {
  var t, r, n = (t = e.getDefaultAppearance()) !== null && t !== void 0 ? t : "", o = (r = bu(n, GT).match) !== null && r !== void 0 ? r : [], i = Number(o[2]);
  return isFinite(i) ? i : void 0;
}, KT = /(\d*\.\d+|\d+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+(g|rg|k)/, ar = function(e) {
  var t, r = (t = e.getDefaultAppearance()) !== null && t !== void 0 ? t : "", n = bu(r, KT).match, o = n ?? [], i = o[1], a = o[2], s = o[3], c = o[4], l = o[5];
  if (l === "g" && i)
    return Em(Number(i));
  if (l === "rg" && i && a && s)
    return tt(Number(i), Number(a), Number(s));
  if (l === "k" && i && a && s && c)
    return km(Number(i), Number(a), Number(s), Number(c));
}, sr = function(e, t, r, n) {
  var o;
  n === void 0 && (n = 0);
  var i = [
    _n(t).toString(),
    Bu((o = r?.name) !== null && o !== void 0 ? o : "dummy__noop", n).toString()
  ].join(`
`);
  e.setDefaultAppearance(i);
}, XT = function(e, t) {
  var r, n, o, i = ar(t), a = ar(e.acroField), s = t.getRectangle(), c = t.getAppearanceCharacteristics(), l = t.getBorderStyle(), u = (r = l?.getWidth()) !== null && r !== void 0 ? r : 0, d = Zr(c?.getRotation()), f = Yn(s, d), h = f.width, g = f.height, v = Mn(Se(Se({}, s), { rotation: d })), y = tt(0, 0, 0), b = (n = Bt(c?.getBorderColor())) !== null && n !== void 0 ? n : y, x = Bt(c?.getBackgroundColor()), C = Bt(c?.getBackgroundColor(), 0.8), E = (o = i ?? a) !== null && o !== void 0 ? o : y;
  sr(i ? t : e.acroField, E);
  var D = {
    x: 0 + u / 2,
    y: 0 + u / 2,
    width: h - u,
    height: g - u,
    thickness: 1.5,
    borderWidth: u,
    borderColor: b,
    markColor: E
  };
  return {
    normal: {
      on: Ge(v, ha(Se(Se({}, D), { color: x, filled: !0 }))),
      off: Ge(v, ha(Se(Se({}, D), { color: x, filled: !1 })))
    },
    down: {
      on: Ge(v, ha(Se(Se({}, D), { color: C, filled: !0 }))),
      off: Ge(v, ha(Se(Se({}, D), { color: C, filled: !1 })))
    }
  };
}, YT = function(e, t) {
  var r, n, o, i = ar(t), a = ar(e.acroField), s = t.getRectangle(), c = t.getAppearanceCharacteristics(), l = t.getBorderStyle(), u = (r = l?.getWidth()) !== null && r !== void 0 ? r : 0, d = Zr(c?.getRotation()), f = Yn(s, d), h = f.width, g = f.height, v = Mn(Se(Se({}, s), { rotation: d })), y = tt(0, 0, 0), b = (n = Bt(c?.getBorderColor())) !== null && n !== void 0 ? n : y, x = Bt(c?.getBackgroundColor()), C = Bt(c?.getBackgroundColor(), 0.8), E = (o = i ?? a) !== null && o !== void 0 ? o : y;
  sr(i ? t : e.acroField, E);
  var D = {
    x: h / 2,
    y: g / 2,
    width: h - u,
    height: g - u,
    borderWidth: u,
    borderColor: b,
    dotColor: E
  };
  return {
    normal: {
      on: Ge(v, va(Se(Se({}, D), { color: x, filled: !0 }))),
      off: Ge(v, va(Se(Se({}, D), { color: x, filled: !1 })))
    },
    down: {
      on: Ge(v, va(Se(Se({}, D), { color: C, filled: !0 }))),
      off: Ge(v, va(Se(Se({}, D), { color: C, filled: !1 })))
    }
  };
}, ZT = function(e, t, r) {
  var n, o, i, a, s, c = ar(t), l = ar(e.acroField), u = xn(t), d = xn(e.acroField), f = t.getRectangle(), h = t.getAppearanceCharacteristics(), g = t.getBorderStyle(), v = h?.getCaptions(), y = (n = v?.normal) !== null && n !== void 0 ? n : "", b = (i = (o = v?.down) !== null && o !== void 0 ? o : y) !== null && i !== void 0 ? i : "", x = (a = g?.getWidth()) !== null && a !== void 0 ? a : 0, C = Zr(h?.getRotation()), E = Yn(f, C), D = E.width, A = E.height, R = Mn(Se(Se({}, f), { rotation: C })), O = tt(0, 0, 0), W = Bt(h?.getBorderColor()), z = Bt(h?.getBackgroundColor()), q = Bt(h?.getBackgroundColor(), 0.8), V = {
    x,
    y: x,
    width: D - x * 2,
    height: A - x * 2
  }, I = Za(y, {
    alignment: pt.Center,
    fontSize: u ?? d,
    font: r,
    bounds: V
  }), Z = Za(b, {
    alignment: pt.Center,
    fontSize: u ?? d,
    font: r,
    bounds: V
  }), Q = Math.min(I.fontSize, Z.fontSize), K = (s = c ?? l) !== null && s !== void 0 ? s : O;
  sr(c || u !== void 0 ? t : e.acroField, K, r, Q);
  var L = {
    x: 0 + x / 2,
    y: 0 + x / 2,
    width: D - x,
    height: A - x,
    borderWidth: x,
    borderColor: W,
    textColor: K,
    font: r.name,
    fontSize: Q
  };
  return {
    normal: Ge(R, Bf(Se(Se({}, L), { color: z, textLines: [I.line] }))),
    down: Ge(R, Bf(Se(Se({}, L), { color: q, textLines: [Z.line] })))
  };
}, _T = function(e, t, r) {
  var n, o, i, a, s = ar(t), c = ar(e.acroField), l = xn(t), u = xn(e.acroField), d = t.getRectangle(), f = t.getAppearanceCharacteristics(), h = t.getBorderStyle(), g = (n = e.getText()) !== null && n !== void 0 ? n : "", v = (o = h?.getWidth()) !== null && o !== void 0 ? o : 0, y = Zr(f?.getRotation()), b = Yn(d, y), x = b.width, C = b.height, E = Mn(Se(Se({}, d), { rotation: y })), D = tt(0, 0, 0), A = Bt(f?.getBorderColor()), R = Bt(f?.getBackgroundColor()), O, W, z = e.isCombed() ? 0 : 1, q = {
    x: v + z,
    y: v + z,
    width: x - (v + z) * 2,
    height: C - (v + z) * 2
  };
  if (e.isMultiline()) {
    var V = Om(g, {
      alignment: e.getAlignment(),
      fontSize: l ?? u,
      font: r,
      bounds: q
    });
    O = V.lines, W = V.fontSize;
  } else if (e.isCombed()) {
    var V = qT(g, {
      fontSize: l ?? u,
      font: r,
      bounds: q,
      cellCount: (i = e.getMaxLength()) !== null && i !== void 0 ? i : 0
    });
    O = V.cells, W = V.fontSize;
  } else {
    var V = Za(g, {
      alignment: e.getAlignment(),
      fontSize: l ?? u,
      font: r,
      bounds: q
    });
    O = [V.line], W = V.fontSize;
  }
  var I = (a = s ?? c) !== null && a !== void 0 ? a : D;
  sr(s || l !== void 0 ? t : e.acroField, I, r, W);
  var Z = {
    x: 0 + v / 2,
    y: 0 + v / 2,
    width: x - v,
    height: C - v,
    borderWidth: v ?? 0,
    borderColor: A,
    textColor: I,
    font: r.name,
    fontSize: W,
    color: R,
    textLines: O,
    padding: z
  };
  return Ge(E, Dm(Z));
}, JT = function(e, t, r) {
  var n, o, i, a = ar(t), s = ar(e.acroField), c = xn(t), l = xn(e.acroField), u = t.getRectangle(), d = t.getAppearanceCharacteristics(), f = t.getBorderStyle(), h = (n = e.getSelected()[0]) !== null && n !== void 0 ? n : "", g = (o = f?.getWidth()) !== null && o !== void 0 ? o : 0, v = Zr(d?.getRotation()), y = Yn(u, v), b = y.width, x = y.height, C = Mn(Se(Se({}, u), { rotation: v })), E = tt(0, 0, 0), D = Bt(d?.getBorderColor()), A = Bt(d?.getBackgroundColor()), R = 1, O = {
    x: g + R,
    y: g + R,
    width: b - (g + R) * 2,
    height: x - (g + R) * 2
  }, W = Za(h, {
    alignment: pt.Left,
    fontSize: c ?? l,
    font: r,
    bounds: O
  }), z = W.line, q = W.fontSize, V = (i = a ?? s) !== null && i !== void 0 ? i : E;
  sr(a || c !== void 0 ? t : e.acroField, V, r, q);
  var I = {
    x: 0 + g / 2,
    y: 0 + g / 2,
    width: b - g,
    height: x - g,
    borderWidth: g ?? 0,
    borderColor: D,
    textColor: V,
    font: r.name,
    fontSize: q,
    color: A,
    textLines: [z],
    padding: R
  };
  return Ge(C, Dm(I));
}, QT = function(e, t, r) {
  var n, o, i = ar(t), a = ar(e.acroField), s = xn(t), c = xn(e.acroField), l = t.getRectangle(), u = t.getAppearanceCharacteristics(), d = t.getBorderStyle(), f = (n = d?.getWidth()) !== null && n !== void 0 ? n : 0, h = Zr(u?.getRotation()), g = Yn(l, h), v = g.width, y = g.height, b = Mn(Se(Se({}, l), { rotation: h })), x = tt(0, 0, 0), C = Bt(u?.getBorderColor()), E = Bt(u?.getBackgroundColor()), D = e.getOptions(), A = e.getSelected();
  e.isSorted() && D.sort();
  for (var R = "", O = 0, W = D.length; O < W; O++)
    R += D[O], O < W - 1 && (R += `
`);
  for (var z = 1, q = {
    x: f + z,
    y: f + z,
    width: v - (f + z) * 2,
    height: y - (f + z) * 2
  }, V = Om(R, {
    alignment: pt.Left,
    fontSize: s ?? c,
    font: r,
    bounds: q
  }), I = V.lines, Z = V.fontSize, Q = V.lineHeight, K = [], O = 0, W = I.length; O < W; O++) {
    var L = I[O];
    A.includes(L.text) && K.push(O);
  }
  var U = tt(153 / 255, 193 / 255, 218 / 255), Y = (o = i ?? a) !== null && o !== void 0 ? o : x;
  return sr(i || s !== void 0 ? t : e.acroField, Y, r, Z), Ge(b, TT({
    x: 0 + f / 2,
    y: 0 + f / 2,
    width: v - f,
    height: y - f,
    borderWidth: f ?? 0,
    borderColor: C,
    textColor: Y,
    font: r.name,
    fontSize: Z,
    color: E,
    textLines: I,
    lineHeight: Q,
    selectedColor: U,
    selectedLines: K,
    padding: z
  }));
}, Mm = (
  /** @class */
  (function() {
    function e(t, r, n) {
      this.alreadyEmbedded = !1, B(t, "ref", [[et, "PDFRef"]]), B(r, "doc", [[Cn, "PDFDocument"]]), B(n, "embedder", [[im, "PDFPageEmbedder"]]), this.ref = t, this.doc = r, this.width = n.width, this.height = n.height, this.embedder = n;
    }
    return e.prototype.scale = function(t) {
      return B(t, "factor", ["number"]), { width: this.width * t, height: this.height * t };
    }, e.prototype.size = function() {
      return this.scale(1);
    }, e.prototype.embed = function() {
      return Re(this, void 0, void 0, function() {
        return Te(this, function(t) {
          switch (t.label) {
            case 0:
              return this.alreadyEmbedded ? [3, 2] : [4, this.embedder.embedIntoContext(this.doc.context, this.ref)];
            case 1:
              t.sent(), this.alreadyEmbedded = !0, t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.of = function(t, r, n) {
      return new e(t, r, n);
    }, e;
  })()
), Xt = (
  /** @class */
  (function() {
    function e(t, r, n) {
      this.modified = !0, B(t, "ref", [[et, "PDFRef"]]), B(r, "doc", [[Cn, "PDFDocument"]]), B(n, "embedder", [
        [Fu, "CustomFontEmbedder"],
        [Ua, "StandardFontEmbedder"]
      ]), this.ref = t, this.doc = r, this.name = n.fontName, this.embedder = n;
    }
    return e.prototype.encodeText = function(t) {
      return B(t, "text", ["string"]), this.modified = !0, this.embedder.encodeText(t);
    }, e.prototype.widthOfTextAtSize = function(t, r) {
      return B(t, "text", ["string"]), B(r, "size", ["number"]), this.embedder.widthOfTextAtSize(t, r);
    }, e.prototype.heightAtSize = function(t, r) {
      var n;
      return B(t, "size", ["number"]), te(r?.descender, "options.descender", ["boolean"]), this.embedder.heightOfFontAtSize(t, {
        descender: (n = r?.descender) !== null && n !== void 0 ? n : !0
      });
    }, e.prototype.sizeAtHeight = function(t) {
      return B(t, "height", ["number"]), this.embedder.sizeOfFontAtHeight(t);
    }, e.prototype.getCharacterSet = function() {
      return this.embedder instanceof Ua ? this.embedder.encoding.supportedCodePoints : this.embedder.font.characterSet;
    }, e.prototype.embed = function() {
      return Re(this, void 0, void 0, function() {
        return Te(this, function(t) {
          switch (t.label) {
            case 0:
              return this.modified ? [4, this.embedder.embedIntoContext(this.doc.context, this.ref)] : [3, 2];
            case 1:
              t.sent(), this.modified = !1, t.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.of = function(t, r, n) {
      return new e(t, r, n);
    }, e;
  })()
), ll = (
  /** @class */
  (function() {
    function e(t, r, n) {
      B(t, "ref", [[et, "PDFRef"]]), B(r, "doc", [[Cn, "PDFDocument"]]), B(n, "embedder", [
        [tm, "JpegEmbedder"],
        [rm, "PngEmbedder"]
      ]), this.ref = t, this.doc = r, this.width = n.width, this.height = n.height, this.embedder = n;
    }
    return e.prototype.scale = function(t) {
      return B(t, "factor", ["number"]), { width: this.width * t, height: this.height * t };
    }, e.prototype.scaleToFit = function(t, r) {
      B(t, "width", ["number"]), B(r, "height", ["number"]);
      var n = t / this.width, o = r / this.height, i = Math.min(n, o);
      return this.scale(i);
    }, e.prototype.size = function() {
      return this.scale(1);
    }, e.prototype.embed = function() {
      return Re(this, void 0, void 0, function() {
        var t, r, n;
        return Te(this, function(o) {
          switch (o.label) {
            case 0:
              return this.embedder ? (this.embedTask || (t = this, r = t.doc, n = t.ref, this.embedTask = this.embedder.embedIntoContext(r.context, n)), [4, this.embedTask]) : [
                2
                /*return*/
              ];
            case 1:
              return o.sent(), this.embedder = void 0, [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.of = function(t, r, n) {
      return new e(t, r, n);
    }, e;
  })()
), dn;
(function(e) {
  e[e.Left = 0] = "Left", e[e.Center = 1] = "Center", e[e.Right = 2] = "Right";
})(dn || (dn = {}));
var zo = function(e) {
  te(e?.x, "options.x", ["number"]), te(e?.y, "options.y", ["number"]), te(e?.width, "options.width", ["number"]), te(e?.height, "options.height", ["number"]), te(e?.textColor, "options.textColor", [
    [Object, "Color"]
  ]), te(e?.backgroundColor, "options.backgroundColor", [
    [Object, "Color"]
  ]), te(e?.borderColor, "options.borderColor", [
    [Object, "Color"]
  ]), te(e?.borderWidth, "options.borderWidth", ["number"]), te(e?.rotate, "options.rotate", [[Object, "Rotation"]]);
}, Jn = (
  /** @class */
  (function() {
    function e(t, r, n) {
      B(t, "acroField", [[Bo, "PDFAcroTerminal"]]), B(r, "ref", [[et, "PDFRef"]]), B(n, "doc", [[Cn, "PDFDocument"]]), this.acroField = t, this.ref = r, this.doc = n;
    }
    return e.prototype.getName = function() {
      var t;
      return (t = this.acroField.getFullyQualifiedName()) !== null && t !== void 0 ? t : "";
    }, e.prototype.isReadOnly = function() {
      return this.acroField.hasFlag(hr.ReadOnly);
    }, e.prototype.enableReadOnly = function() {
      this.acroField.setFlagTo(hr.ReadOnly, !0);
    }, e.prototype.disableReadOnly = function() {
      this.acroField.setFlagTo(hr.ReadOnly, !1);
    }, e.prototype.isRequired = function() {
      return this.acroField.hasFlag(hr.Required);
    }, e.prototype.enableRequired = function() {
      this.acroField.setFlagTo(hr.Required, !0);
    }, e.prototype.disableRequired = function() {
      this.acroField.setFlagTo(hr.Required, !1);
    }, e.prototype.isExported = function() {
      return !this.acroField.hasFlag(hr.NoExport);
    }, e.prototype.enableExporting = function() {
      this.acroField.setFlagTo(hr.NoExport, !1);
    }, e.prototype.disableExporting = function() {
      this.acroField.setFlagTo(hr.NoExport, !0);
    }, e.prototype.needsAppearancesUpdate = function() {
      throw new tr(this.constructor.name, "needsAppearancesUpdate");
    }, e.prototype.defaultUpdateAppearances = function(t) {
      throw new tr(this.constructor.name, "defaultUpdateAppearances");
    }, e.prototype.markAsDirty = function() {
      this.doc.getForm().markFieldAsDirty(this.ref);
    }, e.prototype.markAsClean = function() {
      this.doc.getForm().markFieldAsClean(this.ref);
    }, e.prototype.isDirty = function() {
      return this.doc.getForm().fieldIsDirty(this.ref);
    }, e.prototype.createWidget = function(t) {
      var r, n = t.textColor, o = t.backgroundColor, i = t.borderColor, a = t.borderWidth, s = gm(t.rotate), c = t.caption, l = t.x, u = t.y, d = t.width + a, f = t.height + a, h = !!t.hidden, g = t.page;
      Yg(s, "degreesAngle", 90);
      var v = al.create(this.doc.context, this.ref), y = cT({ x: l, y: u, width: d, height: f }, a, s);
      v.setRectangle(y), g && v.setP(g);
      var b = v.getOrCreateAppearanceCharacteristics();
      o && b.setBackgroundColor(Nf(o)), b.setRotation(s), c && b.setCaptions({ normal: c }), i && b.setBorderColor(Nf(i));
      var x = v.getOrCreateBorderStyle();
      if (a !== void 0 && x.setWidth(a), v.setFlagTo(di.Print, !0), v.setFlagTo(di.Hidden, h), v.setFlagTo(di.Invisible, !1), n) {
        var C = (r = this.acroField.getDefaultAppearance()) !== null && r !== void 0 ? r : "", E = C + `
` + _n(n).toString();
        this.acroField.setDefaultAppearance(E);
      }
      return v;
    }, e.prototype.updateWidgetAppearanceWithFont = function(t, r, n) {
      var o = n.normal, i = n.rollover, a = n.down;
      this.updateWidgetAppearances(t, {
        normal: this.createAppearanceStream(t, o, r),
        rollover: i && this.createAppearanceStream(t, i, r),
        down: a && this.createAppearanceStream(t, a, r)
      });
    }, e.prototype.updateOnOffWidgetAppearance = function(t, r, n) {
      var o = n.normal, i = n.rollover, a = n.down;
      this.updateWidgetAppearances(t, {
        normal: this.createAppearanceDict(t, o, r),
        rollover: i && this.createAppearanceDict(t, i, r),
        down: a && this.createAppearanceDict(t, a, r)
      });
    }, e.prototype.updateWidgetAppearances = function(t, r) {
      var n = r.normal, o = r.rollover, i = r.down;
      t.setNormalAppearance(n), o ? t.setRolloverAppearance(o) : t.removeRolloverAppearance(), i ? t.setDownAppearance(i) : t.removeDownAppearance();
    }, e.prototype.createAppearanceStream = function(t, r, n) {
      var o, i = this.acroField.dict.context, a = t.getRectangle(), s = a.width, c = a.height, l = n && { Font: (o = {}, o[n.name] = n.ref, o) }, u = i.formXObject(r, {
        Resources: l,
        BBox: i.obj([0, 0, s, c]),
        Matrix: i.obj([1, 0, 0, 1, 0, 0])
      }), d = i.register(u);
      return d;
    }, e.prototype.createImageAppearanceStream = function(t, r, n) {
      var o, i, a = this.acroField.dict.context, s = t.getRectangle(), c = t.getAppearanceCharacteristics(), l = t.getBorderStyle(), u = (i = l?.getWidth()) !== null && i !== void 0 ? i : 0, d = Zr(c?.getRotation()), f = Mn(Se(Se({}, s), { rotation: d })), h = Yn(s, d), g = r.scaleToFit(h.width - u * 2, h.height - u * 2), v = {
        x: u,
        y: u,
        width: g.width,
        height: g.height,
        //
        rotate: ye(0),
        xSkew: ye(0),
        ySkew: ye(0)
      };
      n === dn.Center ? (v.x += (h.width - u * 2) / 2 - g.width / 2, v.y += (h.height - u * 2) / 2 - g.height / 2) : n === dn.Right && (v.x = h.width - u - g.width, v.y = h.height - u - g.height);
      var y = this.doc.context.addRandomSuffix("Image", 10), b = Ge(f, Fm(y, v)), x = { XObject: (o = {}, o[y] = r.ref, o) }, C = a.formXObject(b, {
        Resources: x,
        BBox: a.obj([0, 0, s.width, s.height]),
        Matrix: a.obj([1, 0, 0, 1, 0, 0])
      });
      return a.register(C);
    }, e.prototype.createAppearanceDict = function(t, r, n) {
      var o = this.acroField.dict.context, i = this.createAppearanceStream(t, r.on), a = this.createAppearanceStream(t, r.off), s = o.obj({});
      return s.set(n, i), s.set(F.of("Off"), a), s;
    }, e;
  })()
), ni = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      var i = e.call(this, r, n, o) || this;
      return B(r, "acroCheckBox", [
        [Rs, "PDFAcroCheckBox"]
      ]), i.acroField = r, i;
    }
    return t.prototype.check = function() {
      var r, n = (r = this.acroField.getOnValue()) !== null && r !== void 0 ? r : F.of("Yes");
      this.markAsDirty(), this.acroField.setValue(n);
    }, t.prototype.uncheck = function() {
      this.markAsDirty(), this.acroField.setValue(F.of("Off"));
    }, t.prototype.isChecked = function() {
      var r = this.acroField.getOnValue();
      return !!r && r === this.acroField.getValue();
    }, t.prototype.addToPage = function(r, n) {
      var o, i, a, s, c, l;
      B(r, "page", [[er, "PDFPage"]]), zo(n), n || (n = {}), "textColor" in n || (n.textColor = tt(0, 0, 0)), "backgroundColor" in n || (n.backgroundColor = tt(1, 1, 1)), "borderColor" in n || (n.borderColor = tt(0, 0, 0)), "borderWidth" in n || (n.borderWidth = 1);
      var u = this.createWidget({
        x: (o = n.x) !== null && o !== void 0 ? o : 0,
        y: (i = n.y) !== null && i !== void 0 ? i : 0,
        width: (a = n.width) !== null && a !== void 0 ? a : 50,
        height: (s = n.height) !== null && s !== void 0 ? s : 50,
        textColor: n.textColor,
        backgroundColor: n.backgroundColor,
        borderColor: n.borderColor,
        borderWidth: (c = n.borderWidth) !== null && c !== void 0 ? c : 0,
        rotate: (l = n.rotate) !== null && l !== void 0 ? l : ye(0),
        hidden: n.hidden,
        page: r.ref
      }), d = this.doc.context.register(u.dict);
      this.acroField.addWidget(d), u.setAppearanceState(F.of("Off")), this.updateWidgetAppearance(u, F.of("Yes")), r.node.addAnnot(d);
    }, t.prototype.needsAppearancesUpdate = function() {
      for (var r, n = this.acroField.getWidgets(), o = 0, i = n.length; o < i; o++) {
        var a = n[o], s = a.getAppearanceState(), c = (r = a.getAppearances()) === null || r === void 0 ? void 0 : r.normal;
        if (!(c instanceof De) || s && !c.has(s))
          return !0;
      }
      return !1;
    }, t.prototype.defaultUpdateAppearances = function() {
      this.updateAppearances();
    }, t.prototype.updateAppearances = function(r) {
      var n;
      te(r, "provider", [Function]);
      for (var o = this.acroField.getWidgets(), i = 0, a = o.length; i < a; i++) {
        var s = o[i], c = (n = s.getOnValue()) !== null && n !== void 0 ? n : F.of("Yes");
        c && this.updateWidgetAppearance(s, c, r);
      }
      this.markAsClean();
    }, t.prototype.updateWidgetAppearance = function(r, n, o) {
      var i = o ?? XT, a = Wo(i(this, r));
      this.updateOnOffWidgetAppearance(r, n, a);
    }, t.of = function(r, n, o) {
      return new t(r, n, o);
    }, t;
  })(Jn)
), wa = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      var i = e.call(this, r, n, o) || this;
      return B(r, "acroComboBox", [
        [Ts, "PDFAcroComboBox"]
      ]), i.acroField = r, i;
    }
    return t.prototype.getOptions = function() {
      for (var r = this.acroField.getOptions(), n = new Array(r.length), o = 0, i = n.length; o < i; o++) {
        var a = r[o], s = a.display, c = a.value;
        n[o] = (s ?? c).decodeText();
      }
      return n;
    }, t.prototype.getSelected = function() {
      for (var r = this.acroField.getValues(), n = new Array(r.length), o = 0, i = r.length; o < i; o++)
        n[o] = r[o].decodeText();
      return n;
    }, t.prototype.setOptions = function(r) {
      B(r, "options", [Array]);
      for (var n = new Array(r.length), o = 0, i = r.length; o < i; o++)
        n[o] = { value: pe.fromText(r[o]) };
      this.acroField.setOptions(n);
    }, t.prototype.addOptions = function(r) {
      B(r, "options", ["string", Array]);
      for (var n = Array.isArray(r) ? r : [r], o = this.acroField.getOptions(), i = new Array(n.length), a = 0, s = n.length; a < s; a++)
        i[a] = { value: pe.fromText(n[a]) };
      this.acroField.setOptions(o.concat(i));
    }, t.prototype.select = function(r, n) {
      n === void 0 && (n = !1), B(r, "options", ["string", Array]), B(n, "merge", ["boolean"]);
      var o = Array.isArray(r) ? r : [r], i = this.getOptions(), a = o.find(function(d) {
        return !i.includes(d);
      });
      a && this.enableEditing(), this.markAsDirty(), (o.length > 1 || o.length === 1 && n) && this.enableMultiselect();
      for (var s = new Array(o.length), c = 0, l = o.length; c < l; c++)
        s[c] = pe.fromText(o[c]);
      if (n) {
        var u = this.acroField.getValues();
        this.acroField.setValues(u.concat(s));
      } else
        this.acroField.setValues(s);
    }, t.prototype.clear = function() {
      this.markAsDirty(), this.acroField.setValues([]);
    }, t.prototype.setFontSize = function(r) {
      Fs(r, "fontSize"), this.acroField.setFontSize(r), this.markAsDirty();
    }, t.prototype.isEditable = function() {
      return this.acroField.hasFlag(Qe.Edit);
    }, t.prototype.enableEditing = function() {
      this.acroField.setFlagTo(Qe.Edit, !0);
    }, t.prototype.disableEditing = function() {
      this.acroField.setFlagTo(Qe.Edit, !1);
    }, t.prototype.isSorted = function() {
      return this.acroField.hasFlag(Qe.Sort);
    }, t.prototype.enableSorting = function() {
      this.acroField.setFlagTo(Qe.Sort, !0);
    }, t.prototype.disableSorting = function() {
      this.acroField.setFlagTo(Qe.Sort, !1);
    }, t.prototype.isMultiselect = function() {
      return this.acroField.hasFlag(Qe.MultiSelect);
    }, t.prototype.enableMultiselect = function() {
      this.acroField.setFlagTo(Qe.MultiSelect, !0);
    }, t.prototype.disableMultiselect = function() {
      this.acroField.setFlagTo(Qe.MultiSelect, !1);
    }, t.prototype.isSpellChecked = function() {
      return !this.acroField.hasFlag(Qe.DoNotSpellCheck);
    }, t.prototype.enableSpellChecking = function() {
      this.acroField.setFlagTo(Qe.DoNotSpellCheck, !1);
    }, t.prototype.disableSpellChecking = function() {
      this.acroField.setFlagTo(Qe.DoNotSpellCheck, !0);
    }, t.prototype.isSelectOnClick = function() {
      return this.acroField.hasFlag(Qe.CommitOnSelChange);
    }, t.prototype.enableSelectOnClick = function() {
      this.acroField.setFlagTo(Qe.CommitOnSelChange, !0);
    }, t.prototype.disableSelectOnClick = function() {
      this.acroField.setFlagTo(Qe.CommitOnSelChange, !1);
    }, t.prototype.addToPage = function(r, n) {
      var o, i, a, s, c, l, u;
      B(r, "page", [[er, "PDFPage"]]), zo(n), n || (n = {}), "textColor" in n || (n.textColor = tt(0, 0, 0)), "backgroundColor" in n || (n.backgroundColor = tt(1, 1, 1)), "borderColor" in n || (n.borderColor = tt(0, 0, 0)), "borderWidth" in n || (n.borderWidth = 1);
      var d = this.createWidget({
        x: (o = n.x) !== null && o !== void 0 ? o : 0,
        y: (i = n.y) !== null && i !== void 0 ? i : 0,
        width: (a = n.width) !== null && a !== void 0 ? a : 200,
        height: (s = n.height) !== null && s !== void 0 ? s : 50,
        textColor: n.textColor,
        backgroundColor: n.backgroundColor,
        borderColor: n.borderColor,
        borderWidth: (c = n.borderWidth) !== null && c !== void 0 ? c : 0,
        rotate: (l = n.rotate) !== null && l !== void 0 ? l : ye(0),
        hidden: n.hidden,
        page: r.ref
      }), f = this.doc.context.register(d.dict);
      this.acroField.addWidget(f);
      var h = (u = n.font) !== null && u !== void 0 ? u : this.doc.getForm().getDefaultFont();
      this.updateWidgetAppearance(d, h), r.node.addAnnot(f);
    }, t.prototype.needsAppearancesUpdate = function() {
      var r;
      if (this.isDirty())
        return !0;
      for (var n = this.acroField.getWidgets(), o = 0, i = n.length; o < i; o++) {
        var a = n[o], s = ((r = a.getAppearances()) === null || r === void 0 ? void 0 : r.normal) instanceof Gt;
        if (!s)
          return !0;
      }
      return !1;
    }, t.prototype.defaultUpdateAppearances = function(r) {
      B(r, "font", [[Xt, "PDFFont"]]), this.updateAppearances(r);
    }, t.prototype.updateAppearances = function(r, n) {
      B(r, "font", [[Xt, "PDFFont"]]), te(n, "provider", [Function]);
      for (var o = this.acroField.getWidgets(), i = 0, a = o.length; i < a; i++) {
        var s = o[i];
        this.updateWidgetAppearance(s, r, n);
      }
      this.markAsClean();
    }, t.prototype.updateWidgetAppearance = function(r, n, o) {
      var i = o ?? JT, a = Wo(i(this, r, n));
      this.updateWidgetAppearanceWithFont(r, n, a);
    }, t.of = function(r, n, o) {
      return new t(r, n, o);
    }, t;
  })(Jn)
), xa = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      var i = e.call(this, r, n, o) || this;
      return B(r, "acroListBox", [[Ms, "PDFAcroListBox"]]), i.acroField = r, i;
    }
    return t.prototype.getOptions = function() {
      for (var r = this.acroField.getOptions(), n = new Array(r.length), o = 0, i = n.length; o < i; o++) {
        var a = r[o], s = a.display, c = a.value;
        n[o] = (s ?? c).decodeText();
      }
      return n;
    }, t.prototype.getSelected = function() {
      for (var r = this.acroField.getValues(), n = new Array(r.length), o = 0, i = r.length; o < i; o++)
        n[o] = r[o].decodeText();
      return n;
    }, t.prototype.setOptions = function(r) {
      B(r, "options", [Array]), this.markAsDirty();
      for (var n = new Array(r.length), o = 0, i = r.length; o < i; o++)
        n[o] = { value: pe.fromText(r[o]) };
      this.acroField.setOptions(n);
    }, t.prototype.addOptions = function(r) {
      B(r, "options", ["string", Array]), this.markAsDirty();
      for (var n = Array.isArray(r) ? r : [r], o = this.acroField.getOptions(), i = new Array(n.length), a = 0, s = n.length; a < s; a++)
        i[a] = { value: pe.fromText(n[a]) };
      this.acroField.setOptions(o.concat(i));
    }, t.prototype.select = function(r, n) {
      n === void 0 && (n = !1), B(r, "options", ["string", Array]), B(n, "merge", ["boolean"]);
      var o = Array.isArray(r) ? r : [r], i = this.getOptions();
      _D(o, "option", i), this.markAsDirty(), (o.length > 1 || o.length === 1 && n) && this.enableMultiselect();
      for (var a = new Array(o.length), s = 0, c = o.length; s < c; s++)
        a[s] = pe.fromText(o[s]);
      if (n) {
        var l = this.acroField.getValues();
        this.acroField.setValues(l.concat(a));
      } else
        this.acroField.setValues(a);
    }, t.prototype.clear = function() {
      this.markAsDirty(), this.acroField.setValues([]);
    }, t.prototype.setFontSize = function(r) {
      Fs(r, "fontSize"), this.acroField.setFontSize(r), this.markAsDirty();
    }, t.prototype.isSorted = function() {
      return this.acroField.hasFlag(Qe.Sort);
    }, t.prototype.enableSorting = function() {
      this.acroField.setFlagTo(Qe.Sort, !0);
    }, t.prototype.disableSorting = function() {
      this.acroField.setFlagTo(Qe.Sort, !1);
    }, t.prototype.isMultiselect = function() {
      return this.acroField.hasFlag(Qe.MultiSelect);
    }, t.prototype.enableMultiselect = function() {
      this.acroField.setFlagTo(Qe.MultiSelect, !0);
    }, t.prototype.disableMultiselect = function() {
      this.acroField.setFlagTo(Qe.MultiSelect, !1);
    }, t.prototype.isSelectOnClick = function() {
      return this.acroField.hasFlag(Qe.CommitOnSelChange);
    }, t.prototype.enableSelectOnClick = function() {
      this.acroField.setFlagTo(Qe.CommitOnSelChange, !0);
    }, t.prototype.disableSelectOnClick = function() {
      this.acroField.setFlagTo(Qe.CommitOnSelChange, !1);
    }, t.prototype.addToPage = function(r, n) {
      var o, i, a, s, c, l, u;
      B(r, "page", [[er, "PDFPage"]]), zo(n), n || (n = {}), "textColor" in n || (n.textColor = tt(0, 0, 0)), "backgroundColor" in n || (n.backgroundColor = tt(1, 1, 1)), "borderColor" in n || (n.borderColor = tt(0, 0, 0)), "borderWidth" in n || (n.borderWidth = 1);
      var d = this.createWidget({
        x: (o = n.x) !== null && o !== void 0 ? o : 0,
        y: (i = n.y) !== null && i !== void 0 ? i : 0,
        width: (a = n.width) !== null && a !== void 0 ? a : 200,
        height: (s = n.height) !== null && s !== void 0 ? s : 100,
        textColor: n.textColor,
        backgroundColor: n.backgroundColor,
        borderColor: n.borderColor,
        borderWidth: (c = n.borderWidth) !== null && c !== void 0 ? c : 0,
        rotate: (l = n.rotate) !== null && l !== void 0 ? l : ye(0),
        hidden: n.hidden,
        page: r.ref
      }), f = this.doc.context.register(d.dict);
      this.acroField.addWidget(f);
      var h = (u = n.font) !== null && u !== void 0 ? u : this.doc.getForm().getDefaultFont();
      this.updateWidgetAppearance(d, h), r.node.addAnnot(f);
    }, t.prototype.needsAppearancesUpdate = function() {
      var r;
      if (this.isDirty())
        return !0;
      for (var n = this.acroField.getWidgets(), o = 0, i = n.length; o < i; o++) {
        var a = n[o], s = ((r = a.getAppearances()) === null || r === void 0 ? void 0 : r.normal) instanceof Gt;
        if (!s)
          return !0;
      }
      return !1;
    }, t.prototype.defaultUpdateAppearances = function(r) {
      B(r, "font", [[Xt, "PDFFont"]]), this.updateAppearances(r);
    }, t.prototype.updateAppearances = function(r, n) {
      B(r, "font", [[Xt, "PDFFont"]]), te(n, "provider", [Function]);
      for (var o = this.acroField.getWidgets(), i = 0, a = o.length; i < a; i++) {
        var s = o[i];
        this.updateWidgetAppearance(s, r, n);
      }
      this.markAsClean();
    }, t.prototype.updateWidgetAppearance = function(r, n, o) {
      var i = o ?? QT, a = Wo(i(this, r, n));
      this.updateWidgetAppearanceWithFont(r, n, a);
    }, t.of = function(r, n, o) {
      return new t(r, n, o);
    }, t;
  })(Jn)
), oi = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      var i = e.call(this, r, n, o) || this;
      return B(r, "acroRadioButton", [
        [Os, "PDFAcroRadioButton"]
      ]), i.acroField = r, i;
    }
    return t.prototype.getOptions = function() {
      var r = this.acroField.getExportValues();
      if (r) {
        for (var n = new Array(r.length), o = 0, i = r.length; o < i; o++)
          n[o] = r[o].decodeText();
        return n;
      }
      for (var a = this.acroField.getOnValues(), s = new Array(a.length), o = 0, i = s.length; o < i; o++)
        s[o] = a[o].decodeText();
      return s;
    }, t.prototype.getSelected = function() {
      var r = this.acroField.getValue();
      if (r !== F.of("Off")) {
        var n = this.acroField.getExportValues();
        if (n) {
          for (var o = this.acroField.getOnValues(), i = 0, a = o.length; i < a; i++)
            if (o[i] === r)
              return n[i].decodeText();
        }
        return r.decodeText();
      }
    }, t.prototype.select = function(r) {
      B(r, "option", ["string"]);
      var n = this.getOptions();
      cn(r, "option", n), this.markAsDirty();
      var o = this.acroField.getOnValues(), i = this.acroField.getExportValues();
      if (i)
        for (var a = 0, s = i.length; a < s; a++)
          i[a].decodeText() === r && this.acroField.setValue(o[a]);
      else
        for (var a = 0, s = o.length; a < s; a++) {
          var c = o[a];
          c.decodeText() === r && this.acroField.setValue(c);
        }
    }, t.prototype.clear = function() {
      this.markAsDirty(), this.acroField.setValue(F.of("Off"));
    }, t.prototype.isOffToggleable = function() {
      return !this.acroField.hasFlag($t.NoToggleToOff);
    }, t.prototype.enableOffToggling = function() {
      this.acroField.setFlagTo($t.NoToggleToOff, !1);
    }, t.prototype.disableOffToggling = function() {
      this.acroField.setFlagTo($t.NoToggleToOff, !0);
    }, t.prototype.isMutuallyExclusive = function() {
      return !this.acroField.hasFlag($t.RadiosInUnison);
    }, t.prototype.enableMutualExclusion = function() {
      this.acroField.setFlagTo($t.RadiosInUnison, !1);
    }, t.prototype.disableMutualExclusion = function() {
      this.acroField.setFlagTo($t.RadiosInUnison, !0);
    }, t.prototype.addOptionToPage = function(r, n, o) {
      var i, a, s, c, l, u, d, f, h;
      B(r, "option", ["string"]), B(n, "page", [[er, "PDFPage"]]), zo(o);
      var g = this.createWidget({
        x: (i = o?.x) !== null && i !== void 0 ? i : 0,
        y: (a = o?.y) !== null && a !== void 0 ? a : 0,
        width: (s = o?.width) !== null && s !== void 0 ? s : 50,
        height: (c = o?.height) !== null && c !== void 0 ? c : 50,
        textColor: (l = o?.textColor) !== null && l !== void 0 ? l : tt(0, 0, 0),
        backgroundColor: (u = o?.backgroundColor) !== null && u !== void 0 ? u : tt(1, 1, 1),
        borderColor: (d = o?.borderColor) !== null && d !== void 0 ? d : tt(0, 0, 0),
        borderWidth: (f = o?.borderWidth) !== null && f !== void 0 ? f : 1,
        rotate: (h = o?.rotate) !== null && h !== void 0 ? h : ye(0),
        hidden: o?.hidden,
        page: n.ref
      }), v = this.doc.context.register(g.dict), y = this.acroField.addWidgetWithOpt(v, pe.fromText(r), !this.isMutuallyExclusive());
      g.setAppearanceState(F.of("Off")), this.updateWidgetAppearance(g, y), n.node.addAnnot(v);
    }, t.prototype.needsAppearancesUpdate = function() {
      for (var r, n = this.acroField.getWidgets(), o = 0, i = n.length; o < i; o++) {
        var a = n[o], s = a.getAppearanceState(), c = (r = a.getAppearances()) === null || r === void 0 ? void 0 : r.normal;
        if (!(c instanceof De) || s && !c.has(s))
          return !0;
      }
      return !1;
    }, t.prototype.defaultUpdateAppearances = function() {
      this.updateAppearances();
    }, t.prototype.updateAppearances = function(r) {
      te(r, "provider", [Function]);
      for (var n = this.acroField.getWidgets(), o = 0, i = n.length; o < i; o++) {
        var a = n[o], s = a.getOnValue();
        s && this.updateWidgetAppearance(a, s, r);
      }
    }, t.prototype.updateWidgetAppearance = function(r, n, o) {
      var i = o ?? YT, a = Wo(i(this, r));
      this.updateOnOffWidgetAppearance(r, n, a);
    }, t.of = function(r, n, o) {
      return new t(r, n, o);
    }, t;
  })(Jn)
), ul = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      var i = e.call(this, r, n, o) || this;
      return B(r, "acroSignature", [
        [Ru, "PDFAcroSignature"]
      ]), i.acroField = r, i;
    }
    return t.prototype.needsAppearancesUpdate = function() {
      return !1;
    }, t.of = function(r, n, o) {
      return new t(r, n, o);
    }, t;
  })(Jn)
), Ca = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      var i = e.call(this, r, n, o) || this;
      return B(r, "acroText", [[As, "PDFAcroText"]]), i.acroField = r, i;
    }
    return t.prototype.getText = function() {
      var r = this.acroField.getValue();
      if (!r && this.isRichFormatted())
        throw new LT(this.getName());
      return r?.decodeText();
    }, t.prototype.setText = function(r) {
      te(r, "text", ["string"]);
      var n = this.getMaxLength();
      if (n !== void 0 && r && r.length > n)
        throw new zT(r.length, n, this.getName());
      this.markAsDirty(), this.disableRichFormatting(), r ? this.acroField.setValue(pe.fromText(r)) : this.acroField.removeValue();
    }, t.prototype.getAlignment = function() {
      var r = this.acroField.getQuadding();
      return r === 0 ? pt.Left : r === 1 ? pt.Center : r === 2 ? pt.Right : pt.Left;
    }, t.prototype.setAlignment = function(r) {
      cn(r, "alignment", pt), this.markAsDirty(), this.acroField.setQuadding(r);
    }, t.prototype.getMaxLength = function() {
      return this.acroField.getMaxLength();
    }, t.prototype.setMaxLength = function(r) {
      if (dr(r, "maxLength", 0, Number.MAX_SAFE_INTEGER), this.markAsDirty(), r === void 0)
        this.acroField.removeMaxLength();
      else {
        var n = this.getText();
        if (n && n.length > r)
          throw new jT(n.length, r, this.getName());
        this.acroField.setMaxLength(r);
      }
    }, t.prototype.removeMaxLength = function() {
      this.markAsDirty(), this.acroField.removeMaxLength();
    }, t.prototype.setImage = function(r) {
      for (var n = this.getAlignment(), o = n === pt.Center ? dn.Center : n === pt.Right ? dn.Right : dn.Left, i = this.acroField.getWidgets(), a = 0, s = i.length; a < s; a++) {
        var c = i[a], l = this.createImageAppearanceStream(c, r, o);
        this.updateWidgetAppearances(c, { normal: l });
      }
      this.markAsClean();
    }, t.prototype.setFontSize = function(r) {
      Fs(r, "fontSize"), this.acroField.setFontSize(r), this.markAsDirty();
    }, t.prototype.isMultiline = function() {
      return this.acroField.hasFlag(lt.Multiline);
    }, t.prototype.enableMultiline = function() {
      this.markAsDirty(), this.acroField.setFlagTo(lt.Multiline, !0);
    }, t.prototype.disableMultiline = function() {
      this.markAsDirty(), this.acroField.setFlagTo(lt.Multiline, !1);
    }, t.prototype.isPassword = function() {
      return this.acroField.hasFlag(lt.Password);
    }, t.prototype.enablePassword = function() {
      this.acroField.setFlagTo(lt.Password, !0);
    }, t.prototype.disablePassword = function() {
      this.acroField.setFlagTo(lt.Password, !1);
    }, t.prototype.isFileSelector = function() {
      return this.acroField.hasFlag(lt.FileSelect);
    }, t.prototype.enableFileSelection = function() {
      this.acroField.setFlagTo(lt.FileSelect, !0);
    }, t.prototype.disableFileSelection = function() {
      this.acroField.setFlagTo(lt.FileSelect, !1);
    }, t.prototype.isSpellChecked = function() {
      return !this.acroField.hasFlag(lt.DoNotSpellCheck);
    }, t.prototype.enableSpellChecking = function() {
      this.acroField.setFlagTo(lt.DoNotSpellCheck, !1);
    }, t.prototype.disableSpellChecking = function() {
      this.acroField.setFlagTo(lt.DoNotSpellCheck, !0);
    }, t.prototype.isScrollable = function() {
      return !this.acroField.hasFlag(lt.DoNotScroll);
    }, t.prototype.enableScrolling = function() {
      this.acroField.setFlagTo(lt.DoNotScroll, !1);
    }, t.prototype.disableScrolling = function() {
      this.acroField.setFlagTo(lt.DoNotScroll, !0);
    }, t.prototype.isCombed = function() {
      return this.acroField.hasFlag(lt.Comb) && !this.isMultiline() && !this.isPassword() && !this.isFileSelector() && this.getMaxLength() !== void 0;
    }, t.prototype.enableCombing = function() {
      if (this.getMaxLength() === void 0) {
        var r = "PDFTextFields must have a max length in order to be combed";
        console.warn(r);
      }
      this.markAsDirty(), this.disableMultiline(), this.disablePassword(), this.disableFileSelection(), this.acroField.setFlagTo(lt.Comb, !0);
    }, t.prototype.disableCombing = function() {
      this.markAsDirty(), this.acroField.setFlagTo(lt.Comb, !1);
    }, t.prototype.isRichFormatted = function() {
      return this.acroField.hasFlag(lt.RichText);
    }, t.prototype.enableRichFormatting = function() {
      this.acroField.setFlagTo(lt.RichText, !0);
    }, t.prototype.disableRichFormatting = function() {
      this.acroField.setFlagTo(lt.RichText, !1);
    }, t.prototype.addToPage = function(r, n) {
      var o, i, a, s, c, l, u;
      B(r, "page", [[er, "PDFPage"]]), zo(n), n || (n = {}), "textColor" in n || (n.textColor = tt(0, 0, 0)), "backgroundColor" in n || (n.backgroundColor = tt(1, 1, 1)), "borderColor" in n || (n.borderColor = tt(0, 0, 0)), "borderWidth" in n || (n.borderWidth = 1);
      var d = this.createWidget({
        x: (o = n.x) !== null && o !== void 0 ? o : 0,
        y: (i = n.y) !== null && i !== void 0 ? i : 0,
        width: (a = n.width) !== null && a !== void 0 ? a : 200,
        height: (s = n.height) !== null && s !== void 0 ? s : 50,
        textColor: n.textColor,
        backgroundColor: n.backgroundColor,
        borderColor: n.borderColor,
        borderWidth: (c = n.borderWidth) !== null && c !== void 0 ? c : 0,
        rotate: (l = n.rotate) !== null && l !== void 0 ? l : ye(0),
        hidden: n.hidden,
        page: r.ref
      }), f = this.doc.context.register(d.dict);
      this.acroField.addWidget(f);
      var h = (u = n.font) !== null && u !== void 0 ? u : this.doc.getForm().getDefaultFont();
      this.updateWidgetAppearance(d, h), r.node.addAnnot(f);
    }, t.prototype.needsAppearancesUpdate = function() {
      var r;
      if (this.isDirty())
        return !0;
      for (var n = this.acroField.getWidgets(), o = 0, i = n.length; o < i; o++) {
        var a = n[o], s = ((r = a.getAppearances()) === null || r === void 0 ? void 0 : r.normal) instanceof Gt;
        if (!s)
          return !0;
      }
      return !1;
    }, t.prototype.defaultUpdateAppearances = function(r) {
      B(r, "font", [[Xt, "PDFFont"]]), this.updateAppearances(r);
    }, t.prototype.updateAppearances = function(r, n) {
      B(r, "font", [[Xt, "PDFFont"]]), te(n, "provider", [Function]);
      for (var o = this.acroField.getWidgets(), i = 0, a = o.length; i < a; i++) {
        var s = o[i];
        this.updateWidgetAppearance(s, r, n);
      }
      this.markAsClean();
    }, t.prototype.updateWidgetAppearance = function(r, n, o) {
      var i = o ?? _T, a = Wo(i(this, r, n));
      this.updateWidgetAppearanceWithFont(r, n, a);
    }, t.of = function(r, n, o) {
      return new t(r, n, o);
    }, t;
  })(Jn)
), _a;
(function(e) {
  e.Courier = "Courier", e.CourierBold = "Courier-Bold", e.CourierOblique = "Courier-Oblique", e.CourierBoldOblique = "Courier-BoldOblique", e.Helvetica = "Helvetica", e.HelveticaBold = "Helvetica-Bold", e.HelveticaOblique = "Helvetica-Oblique", e.HelveticaBoldOblique = "Helvetica-BoldOblique", e.TimesRoman = "Times-Roman", e.TimesRomanBold = "Times-Bold", e.TimesRomanItalic = "Times-Italic", e.TimesRomanBoldItalic = "Times-BoldItalic", e.Symbol = "Symbol", e.ZapfDingbats = "ZapfDingbats";
})(_a || (_a = {}));
var $T = (
  /** @class */
  (function() {
    function e(t, r) {
      var n = this;
      this.embedDefaultFont = function() {
        return n.doc.embedStandardFont(_a.Helvetica);
      }, B(t, "acroForm", [[qa, "PDFAcroForm"]]), B(r, "doc", [[Cn, "PDFDocument"]]), this.acroForm = t, this.doc = r, this.dirtyFields = /* @__PURE__ */ new Set(), this.defaultFontCache = jr.populatedBy(this.embedDefaultFont);
    }
    return e.prototype.hasXFA = function() {
      return this.acroForm.dict.has(F.of("XFA"));
    }, e.prototype.deleteXFA = function() {
      this.acroForm.dict.delete(F.of("XFA"));
    }, e.prototype.getFields = function() {
      for (var t = this.acroForm.getAllFields(), r = [], n = 0, o = t.length; n < o; n++) {
        var i = t[n], a = i[0], s = i[1], c = eA(a, s, this.doc);
        c && r.push(c);
      }
      return r;
    }, e.prototype.getFieldMaybe = function(t) {
      B(t, "name", ["string"]);
      for (var r = this.getFields(), n = 0, o = r.length; n < o; n++) {
        var i = r[n];
        if (i.getName() === t)
          return i;
      }
    }, e.prototype.getField = function(t) {
      B(t, "name", ["string"]);
      var r = this.getFieldMaybe(t);
      if (r)
        return r;
      throw new IT(t);
    }, e.prototype.getButton = function(t) {
      B(t, "name", ["string"]);
      var r = this.getField(t);
      if (r instanceof Sa)
        return r;
      throw new Ln(t, Sa, r);
    }, e.prototype.getCheckBox = function(t) {
      B(t, "name", ["string"]);
      var r = this.getField(t);
      if (r instanceof ni)
        return r;
      throw new Ln(t, ni, r);
    }, e.prototype.getDropdown = function(t) {
      B(t, "name", ["string"]);
      var r = this.getField(t);
      if (r instanceof wa)
        return r;
      throw new Ln(t, wa, r);
    }, e.prototype.getOptionList = function(t) {
      B(t, "name", ["string"]);
      var r = this.getField(t);
      if (r instanceof xa)
        return r;
      throw new Ln(t, xa, r);
    }, e.prototype.getRadioGroup = function(t) {
      B(t, "name", ["string"]);
      var r = this.getField(t);
      if (r instanceof oi)
        return r;
      throw new Ln(t, oi, r);
    }, e.prototype.getSignature = function(t) {
      B(t, "name", ["string"]);
      var r = this.getField(t);
      if (r instanceof ul)
        return r;
      throw new Ln(t, ul, r);
    }, e.prototype.getTextField = function(t) {
      B(t, "name", ["string"]);
      var r = this.getField(t);
      if (r instanceof Ca)
        return r;
      throw new Ln(t, Ca, r);
    }, e.prototype.createButton = function(t) {
      B(t, "name", ["string"]);
      var r = vo(t), n = this.findOrCreateNonTerminals(r.nonTerminal), o = Ns.create(this.doc.context);
      return o.setPartialName(r.terminal), po(n, [o, o.ref], r.terminal), Sa.of(o, o.ref, this.doc);
    }, e.prototype.createCheckBox = function(t) {
      B(t, "name", ["string"]);
      var r = vo(t), n = this.findOrCreateNonTerminals(r.nonTerminal), o = Rs.create(this.doc.context);
      return o.setPartialName(r.terminal), po(n, [o, o.ref], r.terminal), ni.of(o, o.ref, this.doc);
    }, e.prototype.createDropdown = function(t) {
      B(t, "name", ["string"]);
      var r = vo(t), n = this.findOrCreateNonTerminals(r.nonTerminal), o = Ts.create(this.doc.context);
      return o.setPartialName(r.terminal), po(n, [o, o.ref], r.terminal), wa.of(o, o.ref, this.doc);
    }, e.prototype.createOptionList = function(t) {
      B(t, "name", ["string"]);
      var r = vo(t), n = this.findOrCreateNonTerminals(r.nonTerminal), o = Ms.create(this.doc.context);
      return o.setPartialName(r.terminal), po(n, [o, o.ref], r.terminal), xa.of(o, o.ref, this.doc);
    }, e.prototype.createRadioGroup = function(t) {
      B(t, "name", ["string"]);
      var r = vo(t), n = this.findOrCreateNonTerminals(r.nonTerminal), o = Os.create(this.doc.context);
      return o.setPartialName(r.terminal), po(n, [o, o.ref], r.terminal), oi.of(o, o.ref, this.doc);
    }, e.prototype.createTextField = function(t) {
      B(t, "name", ["string"]);
      var r = vo(t), n = this.findOrCreateNonTerminals(r.nonTerminal), o = As.create(this.doc.context);
      return o.setPartialName(r.terminal), po(n, [o, o.ref], r.terminal), Ca.of(o, o.ref, this.doc);
    }, e.prototype.flatten = function(t) {
      t === void 0 && (t = { updateFieldAppearances: !0 }), t.updateFieldAppearances && this.updateFieldAppearances();
      for (var r = this.getFields(), n = 0, o = r.length; n < o; n++) {
        for (var i = r[n], a = i.acroField.getWidgets(), s = 0, c = a.length; s < c; s++) {
          var l = a[s], u = this.findWidgetPage(l), d = this.findWidgetAppearanceRef(i, l), f = u.node.newXObject("FlatWidget", d), h = l.getRectangle(), g = Ge([
            gt(),
            rr(h.x, h.y)
          ], Mn(Se(Se({}, h), { rotation: 0 })), [
            Lu(f),
            mt()
          ]).filter(Boolean);
          u.pushOperators.apply(u, g);
        }
        this.removeField(i);
      }
    }, e.prototype.removeField = function(t) {
      for (var r = t.acroField.getWidgets(), n = /* @__PURE__ */ new Set(), o = 0, i = r.length; o < i; o++) {
        var a = r[o], s = this.findWidgetAppearanceRef(t, a), c = this.findWidgetPage(a);
        n.add(c), c.node.removeAnnot(s);
      }
      n.forEach(function(h) {
        return h.node.removeAnnot(t.ref);
      }), this.acroForm.removeField(t.acroField);
      for (var l = t.acroField.normalizedEntries().Kids, u = l.size(), d = 0; d < u; d++) {
        var f = l.get(d);
        f instanceof et && this.doc.context.delete(f);
      }
      this.doc.context.delete(t.ref);
    }, e.prototype.updateFieldAppearances = function(t) {
      te(t, "font", [[Xt, "PDFFont"]]), t = t ?? this.getDefaultFont();
      for (var r = this.getFields(), n = 0, o = r.length; n < o; n++) {
        var i = r[n];
        i.needsAppearancesUpdate() && i.defaultUpdateAppearances(t);
      }
    }, e.prototype.markFieldAsDirty = function(t) {
      te(t, "fieldRef", [[et, "PDFRef"]]), this.dirtyFields.add(t);
    }, e.prototype.markFieldAsClean = function(t) {
      te(t, "fieldRef", [[et, "PDFRef"]]), this.dirtyFields.delete(t);
    }, e.prototype.fieldIsDirty = function(t) {
      return te(t, "fieldRef", [[et, "PDFRef"]]), this.dirtyFields.has(t);
    }, e.prototype.getDefaultFont = function() {
      return this.defaultFontCache.access();
    }, e.prototype.findWidgetPage = function(t) {
      var r = t.P(), n = this.doc.getPages().find(function(i) {
        return i.ref === r;
      });
      if (n === void 0) {
        var o = this.doc.context.getObjectRef(t.dict);
        if (o === void 0)
          throw new Error("Could not find PDFRef for PDFObject");
        if (n = this.doc.findPageForAnnotationRef(o), n === void 0)
          throw new Error("Could not find page for PDFRef " + o);
      }
      return n;
    }, e.prototype.findWidgetAppearanceRef = function(t, r) {
      var n, o = r.getNormalAppearance();
      if (o instanceof De && (t instanceof ni || t instanceof oi)) {
        var i = t.acroField.getValue(), a = (n = o.get(i)) !== null && n !== void 0 ? n : o.get(F.of("Off"));
        a instanceof et && (o = a);
      }
      if (!(o instanceof et)) {
        var s = t.getName();
        throw new Error("Failed to extract appearance ref for: " + s);
      }
      return o;
    }, e.prototype.findOrCreateNonTerminals = function(t) {
      for (var r = [
        this.acroForm
      ], n = 0, o = t.length; n < o; n++) {
        var i = t[n];
        if (!i)
          throw new BT(i);
        var a = r[0], s = r[1], c = this.findNonTerminal(i, a);
        if (c)
          r = c;
        else {
          var l = Ha.create(this.doc.context);
          l.setPartialName(i), l.setParent(s);
          var u = this.doc.context.register(l.dict);
          a.addField(u), r = [l, u];
        }
      }
      return r;
    }, e.prototype.findNonTerminal = function(t, r) {
      for (var n = r instanceof qa ? this.acroForm.getFields() : Tu(r.Kids()), o = 0, i = n.length; o < i; o++) {
        var a = n[o], s = a[0], c = a[1];
        if (s.getPartialName() === t) {
          if (s instanceof Ha)
            return [s, c];
          throw new Rm(t);
        }
      }
    }, e.of = function(t, r) {
      return new e(t, r);
    }, e;
  })()
), eA = function(e, t, r) {
  if (e instanceof Ns)
    return Sa.of(e, t, r);
  if (e instanceof Rs)
    return ni.of(e, t, r);
  if (e instanceof Ts)
    return wa.of(e, t, r);
  if (e instanceof Ms)
    return xa.of(e, t, r);
  if (e instanceof As)
    return Ca.of(e, t, r);
  if (e instanceof Os)
    return oi.of(e, t, r);
  if (e instanceof Ru)
    return ul.of(e, t, r);
}, vo = function(e) {
  if (e.length === 0)
    throw new Error("PDF field names must not be empty strings");
  for (var t = e.split("."), r = 0, n = t.length; r < n; r++)
    if (t[r] === "")
      throw new Error('Periods in PDF field names must be separated by at least one character: "' + e + '"');
  return t.length === 1 ? { nonTerminal: [], terminal: t[0] } : {
    nonTerminal: t.slice(0, t.length - 1),
    terminal: t[t.length - 1]
  };
}, po = function(e, t, r) {
  for (var n = e[0], o = e[1], i = t[0], a = t[1], s = n.normalizedEntries(), c = Tu("Kids" in s ? s.Kids : s.Fields), l = 0, u = c.length; l < u; l++)
    if (c[l][0].getPartialName() === r)
      throw new Rm(r);
  n.addField(a), i.setParent(o);
}, tA = {
  A4: [595.28, 841.89]
}, dl;
(function(e) {
  e[e.Fastest = 1 / 0] = "Fastest", e[e.Fast = 1500] = "Fast", e[e.Medium = 500] = "Medium", e[e.Slow = 100] = "Slow";
})(dl || (dl = {}));
var rA = (
  /** @class */
  (function() {
    function e(t, r, n) {
      this.alreadyEmbedded = !1, this.ref = t, this.doc = r, this.embedder = n;
    }
    return e.prototype.embed = function() {
      return Re(this, void 0, void 0, function() {
        var t, r, n, o, i;
        return Te(this, function(a) {
          switch (a.label) {
            case 0:
              return this.alreadyEmbedded ? [3, 2] : [4, this.embedder.embedIntoContext(this.doc.context, this.ref)];
            case 1:
              t = a.sent(), this.doc.catalog.has(F.of("Names")) || this.doc.catalog.set(F.of("Names"), this.doc.context.obj({})), r = this.doc.catalog.lookup(F.of("Names"), De), r.has(F.of("EmbeddedFiles")) || r.set(F.of("EmbeddedFiles"), this.doc.context.obj({})), n = r.lookup(F.of("EmbeddedFiles"), De), n.has(F.of("Names")) || n.set(F.of("Names"), this.doc.context.obj([])), o = n.lookup(F.of("Names"), _e), o.push(pe.fromText(this.embedder.fileName)), o.push(t), this.doc.catalog.has(F.of("AF")) || this.doc.catalog.set(F.of("AF"), this.doc.context.obj([])), i = this.doc.catalog.lookup(F.of("AF"), _e), i.push(t), this.alreadyEmbedded = !0, a.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.of = function(t, r, n) {
      return new e(t, r, n);
    }, e;
  })()
), nA = (
  /** @class */
  (function() {
    function e(t, r, n) {
      this.alreadyEmbedded = !1, this.ref = t, this.doc = r, this.embedder = n;
    }
    return e.prototype.embed = function() {
      return Re(this, void 0, void 0, function() {
        var t, r, n, o, i, a, s;
        return Te(this, function(c) {
          switch (c.label) {
            case 0:
              return this.alreadyEmbedded ? [3, 2] : (t = this.doc, r = t.catalog, n = t.context, [4, this.embedder.embedIntoContext(this.doc.context, this.ref)]);
            case 1:
              o = c.sent(), r.has(F.of("Names")) || r.set(F.of("Names"), n.obj({})), i = r.lookup(F.of("Names"), De), i.has(F.of("JavaScript")) || i.set(F.of("JavaScript"), n.obj({})), a = i.lookup(F.of("JavaScript"), De), a.has(F.of("Names")) || a.set(F.of("Names"), n.obj([])), s = a.lookup(F.of("Names"), _e), s.push(pe.fromText(this.embedder.scriptName)), s.push(o), this.alreadyEmbedded = !0, c.label = 2;
            case 2:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.of = function(t, r, n) {
      return new e(t, r, n);
    }, e;
  })()
), oA = (
  /** @class */
  (function() {
    function e(t, r) {
      this.script = t, this.scriptName = r;
    }
    return e.for = function(t, r) {
      return new e(t, r);
    }, e.prototype.embedIntoContext = function(t, r) {
      return Re(this, void 0, void 0, function() {
        var n;
        return Te(this, function(o) {
          return n = t.obj({
            Type: "Action",
            S: "JavaScript",
            JS: pe.fromText(this.script)
          }), r ? (t.assign(r, n), [2, r]) : [2, t.register(n)];
        });
      });
    }, e;
  })()
), Cn = (
  /** @class */
  (function() {
    function e(t, r, n) {
      var o = this;
      if (this.defaultWordBreaks = [" "], this.computePages = function() {
        var i = [];
        return o.catalog.Pages().traverse(function(a, s) {
          if (a instanceof Ur) {
            var c = o.pageMap.get(a);
            c || (c = er.of(a, s, o), o.pageMap.set(a, c)), i.push(c);
          }
        }), i;
      }, this.getOrCreateForm = function() {
        var i = o.catalog.getOrCreateAcroForm();
        return $T.of(i, o);
      }, B(t, "context", [[ol, "PDFContext"]]), B(r, "ignoreEncryption", ["boolean"]), this.context = t, this.catalog = t.lookup(t.trailerInfo.Root), this.isEncrypted = !!t.lookup(t.trailerInfo.Encrypt), this.pageCache = jr.populatedBy(this.computePages), this.pageMap = /* @__PURE__ */ new Map(), this.formCache = jr.populatedBy(this.getOrCreateForm), this.fonts = [], this.images = [], this.embeddedPages = [], this.embeddedFiles = [], this.javaScripts = [], !r && this.isEncrypted)
        throw new AT();
      n && this.updateInfoDict();
    }
    return e.load = function(t, r) {
      return r === void 0 && (r = {}), Re(this, void 0, void 0, function() {
        var n, o, i, a, s, c, l, u, d, f, h, g;
        return Te(this, function(v) {
          switch (v.label) {
            case 0:
              return n = r.ignoreEncryption, o = n === void 0 ? !1 : n, i = r.parseSpeed, a = i === void 0 ? dl.Slow : i, s = r.throwOnInvalidObject, c = s === void 0 ? !1 : s, l = r.updateMetadata, u = l === void 0 ? !0 : l, d = r.capNumbers, f = d === void 0 ? !1 : d, B(t, "pdf", ["string", Uint8Array, ArrayBuffer]), B(o, "ignoreEncryption", ["boolean"]), B(a, "parseSpeed", ["number"]), B(c, "throwOnInvalidObject", ["boolean"]), h = qo(t), [4, aT.forBytesWithOptions(h, a, c, f).parseDocument()];
            case 1:
              return g = v.sent(), [2, new e(g, o, u)];
          }
        });
      });
    }, e.create = function(t) {
      return t === void 0 && (t = {}), Re(this, void 0, void 0, function() {
        var r, n, o, i, a, s;
        return Te(this, function(c) {
          return r = t.updateMetadata, n = r === void 0 ? !0 : r, o = ol.create(), i = dm.withContext(o), a = o.register(i), s = um.withContextAndPages(o, a), o.trailerInfo.Root = o.register(s), [2, new e(o, !1, n)];
        });
      });
    }, e.prototype.registerFontkit = function(t) {
      this.fontkit = t;
    }, e.prototype.getForm = function() {
      var t = this.formCache.access();
      return t.hasXFA() && (console.warn("Removing XFA form data as pdf-lib does not support reading or writing XFA"), t.deleteXFA()), t;
    }, e.prototype.getTitle = function() {
      var t = this.getInfoDict().lookup(F.Title);
      if (t)
        return rn(t), t.decodeText();
    }, e.prototype.getAuthor = function() {
      var t = this.getInfoDict().lookup(F.Author);
      if (t)
        return rn(t), t.decodeText();
    }, e.prototype.getSubject = function() {
      var t = this.getInfoDict().lookup(F.Subject);
      if (t)
        return rn(t), t.decodeText();
    }, e.prototype.getKeywords = function() {
      var t = this.getInfoDict().lookup(F.Keywords);
      if (t)
        return rn(t), t.decodeText();
    }, e.prototype.getCreator = function() {
      var t = this.getInfoDict().lookup(F.Creator);
      if (t)
        return rn(t), t.decodeText();
    }, e.prototype.getProducer = function() {
      var t = this.getInfoDict().lookup(F.Producer);
      if (t)
        return rn(t), t.decodeText();
    }, e.prototype.getCreationDate = function() {
      var t = this.getInfoDict().lookup(F.CreationDate);
      if (t)
        return rn(t), t.decodeDate();
    }, e.prototype.getModificationDate = function() {
      var t = this.getInfoDict().lookup(F.ModDate);
      if (t)
        return rn(t), t.decodeDate();
    }, e.prototype.setTitle = function(t, r) {
      B(t, "title", ["string"]);
      var n = F.of("Title");
      if (this.getInfoDict().set(n, pe.fromText(t)), r?.showInWindowTitleBar) {
        var o = this.catalog.getOrCreateViewerPreferences();
        o.setDisplayDocTitle(!0);
      }
    }, e.prototype.setAuthor = function(t) {
      B(t, "author", ["string"]);
      var r = F.of("Author");
      this.getInfoDict().set(r, pe.fromText(t));
    }, e.prototype.setSubject = function(t) {
      B(t, "author", ["string"]);
      var r = F.of("Subject");
      this.getInfoDict().set(r, pe.fromText(t));
    }, e.prototype.setKeywords = function(t) {
      B(t, "keywords", [Array]);
      var r = F.of("Keywords");
      this.getInfoDict().set(r, pe.fromText(t.join(" ")));
    }, e.prototype.setCreator = function(t) {
      B(t, "creator", ["string"]);
      var r = F.of("Creator");
      this.getInfoDict().set(r, pe.fromText(t));
    }, e.prototype.setProducer = function(t) {
      B(t, "creator", ["string"]);
      var r = F.of("Producer");
      this.getInfoDict().set(r, pe.fromText(t));
    }, e.prototype.setLanguage = function(t) {
      B(t, "language", ["string"]);
      var r = F.of("Lang");
      this.catalog.set(r, $e.of(t));
    }, e.prototype.setCreationDate = function(t) {
      B(t, "creationDate", [[Date, "Date"]]);
      var r = F.of("CreationDate");
      this.getInfoDict().set(r, $e.fromDate(t));
    }, e.prototype.setModificationDate = function(t) {
      B(t, "modificationDate", [[Date, "Date"]]);
      var r = F.of("ModDate");
      this.getInfoDict().set(r, $e.fromDate(t));
    }, e.prototype.getPageCount = function() {
      return this.pageCount === void 0 && (this.pageCount = this.getPages().length), this.pageCount;
    }, e.prototype.getPages = function() {
      return this.pageCache.access();
    }, e.prototype.getPage = function(t) {
      var r = this.getPages();
      return Vt(t, "index", 0, r.length - 1), r[t];
    }, e.prototype.getPageIndices = function() {
      return sD(0, this.getPageCount());
    }, e.prototype.removePage = function(t) {
      var r = this.getPageCount();
      if (this.pageCount === 0)
        throw new MT();
      Vt(t, "index", 0, r - 1), this.catalog.removeLeafNode(t), this.pageCount = r - 1;
    }, e.prototype.addPage = function(t) {
      return B(t, "page", ["undefined", [er, "PDFPage"], Array]), this.insertPage(this.getPageCount(), t);
    }, e.prototype.insertPage = function(t, r) {
      var n = this.getPageCount();
      if (Vt(t, "index", 0, n), B(r, "page", ["undefined", [er, "PDFPage"], Array]), !r || Array.isArray(r)) {
        var o = Array.isArray(r) ? r : tA.A4;
        r = er.create(this), r.setSize.apply(r, o);
      } else if (r.doc !== this)
        throw new OT();
      var i = this.catalog.insertLeafNode(r.ref, t);
      return r.node.setParent(i), this.pageMap.set(r.node, r), this.pageCache.invalidate(), this.pageCount = n + 1, r;
    }, e.prototype.copyPages = function(t, r) {
      return Re(this, void 0, void 0, function() {
        var n, o, i, a, s, c, l, u;
        return Te(this, function(d) {
          switch (d.label) {
            case 0:
              return B(t, "srcDoc", [[e, "PDFDocument"]]), B(r, "indices", [Array]), [4, t.flush()];
            case 1:
              for (d.sent(), n = xf.for(t.context, this.context), o = t.getPages(), i = new Array(r.length), a = 0, s = r.length; a < s; a++)
                c = o[r[a]], l = n.copy(c.node), u = this.context.register(l), i[a] = er.of(l, u, this);
              return [2, i];
          }
        });
      });
    }, e.prototype.copy = function() {
      return Re(this, void 0, void 0, function() {
        var t, r, n, o;
        return Te(this, function(i) {
          switch (i.label) {
            case 0:
              return [4, e.create()];
            case 1:
              return t = i.sent(), [4, t.copyPages(this, this.getPageIndices())];
            case 2:
              for (r = i.sent(), n = 0, o = r.length; n < o; n++)
                t.addPage(r[n]);
              return this.getAuthor() !== void 0 && t.setAuthor(this.getAuthor()), this.getCreationDate() !== void 0 && t.setCreationDate(this.getCreationDate()), this.getCreator() !== void 0 && t.setCreator(this.getCreator()), this.getModificationDate() !== void 0 && t.setModificationDate(this.getModificationDate()), this.getProducer() !== void 0 && t.setProducer(this.getProducer()), this.getSubject() !== void 0 && t.setSubject(this.getSubject()), this.getTitle() !== void 0 && t.setTitle(this.getTitle()), t.defaultWordBreaks = this.defaultWordBreaks, [2, t];
          }
        });
      });
    }, e.prototype.addJavaScript = function(t, r) {
      B(t, "name", ["string"]), B(r, "script", ["string"]);
      var n = oA.for(r, t), o = this.context.nextRef(), i = nA.of(o, this, n);
      this.javaScripts.push(i);
    }, e.prototype.attach = function(t, r, n) {
      return n === void 0 && (n = {}), Re(this, void 0, void 0, function() {
        var o, i, a, s;
        return Te(this, function(c) {
          return B(t, "attachment", ["string", Uint8Array, ArrayBuffer]), B(r, "name", ["string"]), te(n.mimeType, "mimeType", ["string"]), te(n.description, "description", ["string"]), te(n.creationDate, "options.creationDate", [Date]), te(n.modificationDate, "options.modificationDate", [
            Date
          ]), Qt(n.afRelationship, "options.afRelationship", il), o = qo(t), i = NR.for(o, r, n), a = this.context.nextRef(), s = rA.of(a, this, i), this.embeddedFiles.push(s), [
            2
            /*return*/
          ];
        });
      });
    }, e.prototype.embedFont = function(t, r) {
      return r === void 0 && (r = {}), Re(this, void 0, void 0, function() {
        var n, o, i, a, s, c, l, u, d, f;
        return Te(this, function(h) {
          switch (h.label) {
            case 0:
              return n = r.subset, o = n === void 0 ? !1 : n, i = r.customName, a = r.features, B(t, "font", ["string", Uint8Array, ArrayBuffer]), B(o, "subset", ["boolean"]), ff(t) ? (s = Ua.for(t, i), [3, 7]) : [3, 1];
            case 1:
              return lD(t) ? (c = qo(t), l = this.assertFontkit(), o ? [4, AR.for(l, c, i, a)] : [3, 3]) : [3, 6];
            case 2:
              return u = h.sent(), [3, 5];
            case 3:
              return [4, Fu.for(l, c, i, a)];
            case 4:
              u = h.sent(), h.label = 5;
            case 5:
              return s = u, [3, 7];
            case 6:
              throw new TypeError("`font` must be one of `StandardFonts | string | Uint8Array | ArrayBuffer`");
            case 7:
              return d = this.context.nextRef(), f = Xt.of(d, this, s), this.fonts.push(f), [2, f];
          }
        });
      });
    }, e.prototype.embedStandardFont = function(t, r) {
      if (B(t, "font", ["string"]), !ff(t))
        throw new TypeError("`font` must be one of type `StandardFonts`");
      var n = Ua.for(t, r), o = this.context.nextRef(), i = Xt.of(o, this, n);
      return this.fonts.push(i), i;
    }, e.prototype.embedJpg = function(t) {
      return Re(this, void 0, void 0, function() {
        var r, n, o, i;
        return Te(this, function(a) {
          switch (a.label) {
            case 0:
              return B(t, "jpg", ["string", Uint8Array, ArrayBuffer]), r = qo(t), [4, tm.for(r)];
            case 1:
              return n = a.sent(), o = this.context.nextRef(), i = ll.of(o, this, n), this.images.push(i), [2, i];
          }
        });
      });
    }, e.prototype.embedPng = function(t) {
      return Re(this, void 0, void 0, function() {
        var r, n, o, i;
        return Te(this, function(a) {
          switch (a.label) {
            case 0:
              return B(t, "png", ["string", Uint8Array, ArrayBuffer]), r = qo(t), [4, rm.for(r)];
            case 1:
              return n = a.sent(), o = this.context.nextRef(), i = ll.of(o, this, n), this.images.push(i), [2, i];
          }
        });
      });
    }, e.prototype.embedPdf = function(t, r) {
      return r === void 0 && (r = [0]), Re(this, void 0, void 0, function() {
        var n, o, i;
        return Te(this, function(a) {
          switch (a.label) {
            case 0:
              return B(t, "pdf", [
                "string",
                Uint8Array,
                ArrayBuffer,
                [e, "PDFDocument"]
              ]), B(r, "indices", [Array]), t instanceof e ? (o = t, [3, 3]) : [3, 1];
            case 1:
              return [4, e.load(t)];
            case 2:
              o = a.sent(), a.label = 3;
            case 3:
              return n = o, i = cD(n.getPages(), r), [2, this.embedPages(i)];
          }
        });
      });
    }, e.prototype.embedPage = function(t, r, n) {
      return Re(this, void 0, void 0, function() {
        var o;
        return Te(this, function(i) {
          switch (i.label) {
            case 0:
              return B(t, "page", [[er, "PDFPage"]]), [4, this.embedPages([t], [r], [n])];
            case 1:
              return o = i.sent()[0], [2, o];
          }
        });
      });
    }, e.prototype.embedPages = function(t, r, n) {
      return r === void 0 && (r = []), n === void 0 && (n = []), Re(this, void 0, void 0, function() {
        var l, u, o, i, a, s, c, l, u, d, f, h, g, v, y;
        return Te(this, function(b) {
          switch (b.label) {
            case 0:
              if (t.length === 0)
                return [2, []];
              for (l = 0, u = t.length - 1; l < u; l++)
                if (o = t[l], i = t[l + 1], o.node.context !== i.node.context)
                  throw new oR();
              a = t[0].node.context, s = a === this.context ? function(x) {
                return x;
              } : xf.for(a, this.context).copy, c = new Array(t.length), l = 0, u = t.length, b.label = 1;
            case 1:
              return l < u ? (d = s(t[l].node), f = r[l], h = n[l], [4, im.for(d, f, h)]) : [3, 4];
            case 2:
              g = b.sent(), v = this.context.nextRef(), c[l] = Mm.of(v, this, g), b.label = 3;
            case 3:
              return l++, [3, 1];
            case 4:
              return (y = this.embeddedPages).push.apply(y, c), [2, c];
          }
        });
      });
    }, e.prototype.flush = function() {
      return Re(this, void 0, void 0, function() {
        return Te(this, function(t) {
          switch (t.label) {
            case 0:
              return [4, this.embedAll(this.fonts)];
            case 1:
              return t.sent(), [4, this.embedAll(this.images)];
            case 2:
              return t.sent(), [4, this.embedAll(this.embeddedPages)];
            case 3:
              return t.sent(), [4, this.embedAll(this.embeddedFiles)];
            case 4:
              return t.sent(), [4, this.embedAll(this.javaScripts)];
            case 5:
              return t.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.save = function(t) {
      return t === void 0 && (t = {}), Re(this, void 0, void 0, function() {
        var r, n, o, i, a, s, c, l, u, d;
        return Te(this, function(f) {
          switch (f.label) {
            case 0:
              return r = t.useObjectStreams, n = r === void 0 ? !0 : r, o = t.addDefaultPage, i = o === void 0 ? !0 : o, a = t.objectsPerTick, s = a === void 0 ? 50 : a, c = t.updateFieldAppearances, l = c === void 0 ? !0 : c, B(n, "useObjectStreams", ["boolean"]), B(i, "addDefaultPage", ["boolean"]), B(s, "objectsPerTick", ["number"]), B(l, "updateFieldAppearances", ["boolean"]), i && this.getPageCount() === 0 && this.addPage(), l && (u = this.formCache.getValue(), u && u.updateFieldAppearances()), [4, this.flush()];
            case 1:
              return f.sent(), d = n ? ER : $g, [2, d.forContext(this.context, s).serializeToBuffer()];
          }
        });
      });
    }, e.prototype.saveAsBase64 = function(t) {
      return t === void 0 && (t = {}), Re(this, void 0, void 0, function() {
        var r, n, o, i, a;
        return Te(this, function(s) {
          switch (s.label) {
            case 0:
              return r = t.dataUri, n = r === void 0 ? !1 : r, o = qF(t, ["dataUri"]), B(n, "dataUri", ["boolean"]), [4, this.save(o)];
            case 1:
              return i = s.sent(), a = GF(i), [2, n ? "data:application/pdf;base64," + a : a];
          }
        });
      });
    }, e.prototype.findPageForAnnotationRef = function(t) {
      for (var r = this.getPages(), n = 0, o = r.length; n < o; n++) {
        var i = r[n], a = i.node.Annots();
        if (a?.indexOf(t) !== void 0)
          return i;
      }
    }, e.prototype.embedAll = function(t) {
      return Re(this, void 0, void 0, function() {
        var r, n;
        return Te(this, function(o) {
          switch (o.label) {
            case 0:
              r = 0, n = t.length, o.label = 1;
            case 1:
              return r < n ? [4, t[r].embed()] : [3, 4];
            case 2:
              o.sent(), o.label = 3;
            case 3:
              return r++, [3, 1];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.updateInfoDict = function() {
      var t = "pdf-lib (https://github.com/Hopding/pdf-lib)", r = /* @__PURE__ */ new Date(), n = this.getInfoDict();
      this.setProducer(t), this.setModificationDate(r), n.get(F.of("Creator")) || this.setCreator(t), n.get(F.of("CreationDate")) || this.setCreationDate(r);
    }, e.prototype.getInfoDict = function() {
      var t = this.context.lookup(this.context.trailerInfo.Info);
      if (t instanceof De)
        return t;
      var r = this.context.obj({});
      return this.context.trailerInfo.Info = this.context.register(r), r;
    }, e.prototype.assertFontkit = function() {
      if (!this.fontkit)
        throw new NT();
      return this.fontkit;
    }, e;
  })()
);
function rn(e) {
  if (!(e instanceof pe) && !(e instanceof $e))
    throw new za([pe, $e], e);
}
var Lr;
(function(e) {
  e.Normal = "Normal", e.Multiply = "Multiply", e.Screen = "Screen", e.Overlay = "Overlay", e.Darken = "Darken", e.Lighten = "Lighten", e.ColorDodge = "ColorDodge", e.ColorBurn = "ColorBurn", e.HardLight = "HardLight", e.SoftLight = "SoftLight", e.Difference = "Difference", e.Exclusion = "Exclusion";
})(Lr || (Lr = {}));
var er = (
  /** @class */
  (function() {
    function e(t, r, n) {
      this.fontSize = 24, this.fontColor = tt(0, 0, 0), this.lineHeight = 24, this.x = 0, this.y = 0, B(t, "leafNode", [[Ur, "PDFPageLeaf"]]), B(r, "ref", [[et, "PDFRef"]]), B(n, "doc", [[Cn, "PDFDocument"]]), this.node = t, this.ref = r, this.doc = n;
    }
    return e.prototype.setRotation = function(t) {
      var r = gm(t);
      Yg(r, "degreesAngle", 90), this.node.set(F.of("Rotate"), this.doc.context.obj(r));
    }, e.prototype.getRotation = function() {
      var t = this.node.Rotate();
      return ye(t ? t.asNumber() : 0);
    }, e.prototype.setSize = function(t, r) {
      B(t, "width", ["number"]), B(r, "height", ["number"]);
      var n = this.getMediaBox();
      this.setMediaBox(n.x, n.y, t, r);
      var o = this.getCropBox(), i = this.getBleedBox(), a = this.getTrimBox(), s = this.getArtBox(), c = this.node.CropBox(), l = this.node.BleedBox(), u = this.node.TrimBox(), d = this.node.ArtBox();
      c && sa(o, n) && this.setCropBox(n.x, n.y, t, r), l && sa(i, n) && this.setBleedBox(n.x, n.y, t, r), u && sa(a, n) && this.setTrimBox(n.x, n.y, t, r), d && sa(s, n) && this.setArtBox(n.x, n.y, t, r);
    }, e.prototype.setWidth = function(t) {
      B(t, "width", ["number"]), this.setSize(t, this.getSize().height);
    }, e.prototype.setHeight = function(t) {
      B(t, "height", ["number"]), this.setSize(this.getSize().width, t);
    }, e.prototype.setMediaBox = function(t, r, n, o) {
      B(t, "x", ["number"]), B(r, "y", ["number"]), B(n, "width", ["number"]), B(o, "height", ["number"]);
      var i = this.doc.context.obj([t, r, t + n, r + o]);
      this.node.set(F.MediaBox, i);
    }, e.prototype.setCropBox = function(t, r, n, o) {
      B(t, "x", ["number"]), B(r, "y", ["number"]), B(n, "width", ["number"]), B(o, "height", ["number"]);
      var i = this.doc.context.obj([t, r, t + n, r + o]);
      this.node.set(F.CropBox, i);
    }, e.prototype.setBleedBox = function(t, r, n, o) {
      B(t, "x", ["number"]), B(r, "y", ["number"]), B(n, "width", ["number"]), B(o, "height", ["number"]);
      var i = this.doc.context.obj([t, r, t + n, r + o]);
      this.node.set(F.BleedBox, i);
    }, e.prototype.setTrimBox = function(t, r, n, o) {
      B(t, "x", ["number"]), B(r, "y", ["number"]), B(n, "width", ["number"]), B(o, "height", ["number"]);
      var i = this.doc.context.obj([t, r, t + n, r + o]);
      this.node.set(F.TrimBox, i);
    }, e.prototype.setArtBox = function(t, r, n, o) {
      B(t, "x", ["number"]), B(r, "y", ["number"]), B(n, "width", ["number"]), B(o, "height", ["number"]);
      var i = this.doc.context.obj([t, r, t + n, r + o]);
      this.node.set(F.ArtBox, i);
    }, e.prototype.getSize = function() {
      var t = this.getMediaBox(), r = t.width, n = t.height;
      return { width: r, height: n };
    }, e.prototype.getWidth = function() {
      return this.getSize().width;
    }, e.prototype.getHeight = function() {
      return this.getSize().height;
    }, e.prototype.getMediaBox = function() {
      var t = this.node.MediaBox();
      return t.asRectangle();
    }, e.prototype.getCropBox = function() {
      var t, r = this.node.CropBox();
      return (t = r?.asRectangle()) !== null && t !== void 0 ? t : this.getMediaBox();
    }, e.prototype.getBleedBox = function() {
      var t, r = this.node.BleedBox();
      return (t = r?.asRectangle()) !== null && t !== void 0 ? t : this.getCropBox();
    }, e.prototype.getTrimBox = function() {
      var t, r = this.node.TrimBox();
      return (t = r?.asRectangle()) !== null && t !== void 0 ? t : this.getCropBox();
    }, e.prototype.getArtBox = function() {
      var t, r = this.node.ArtBox();
      return (t = r?.asRectangle()) !== null && t !== void 0 ? t : this.getCropBox();
    }, e.prototype.translateContent = function(t, r) {
      B(t, "x", ["number"]), B(r, "y", ["number"]), this.node.normalize(), this.getContentStream();
      var n = this.createContentStream(gt(), rr(t, r)), o = this.doc.context.register(n), i = this.createContentStream(mt()), a = this.doc.context.register(i);
      this.node.wrapContentStreams(o, a);
    }, e.prototype.scale = function(t, r) {
      B(t, "x", ["number"]), B(r, "y", ["number"]), this.setSize(this.getWidth() * t, this.getHeight() * r), this.scaleContent(t, r), this.scaleAnnotations(t, r);
    }, e.prototype.scaleContent = function(t, r) {
      B(t, "x", ["number"]), B(r, "y", ["number"]), this.node.normalize(), this.getContentStream();
      var n = this.createContentStream(gt(), Ci(t, r)), o = this.doc.context.register(n), i = this.createContentStream(mt()), a = this.doc.context.register(i);
      this.node.wrapContentStreams(o, a);
    }, e.prototype.scaleAnnotations = function(t, r) {
      B(t, "x", ["number"]), B(r, "y", ["number"]);
      var n = this.node.Annots();
      if (n)
        for (var o = 0; o < n.size(); o++) {
          var i = n.lookup(o);
          i instanceof De && this.scaleAnnot(i, t, r);
        }
    }, e.prototype.resetPosition = function() {
      this.getContentStream(!1), this.x = 0, this.y = 0;
    }, e.prototype.setFont = function(t) {
      B(t, "font", [[Xt, "PDFFont"]]), this.font = t, this.fontKey = this.node.newFontDictionary(this.font.name, this.font.ref);
    }, e.prototype.setFontSize = function(t) {
      B(t, "fontSize", ["number"]), this.fontSize = t;
    }, e.prototype.setFontColor = function(t) {
      B(t, "fontColor", [[Object, "Color"]]), this.fontColor = t;
    }, e.prototype.setLineHeight = function(t) {
      B(t, "lineHeight", ["number"]), this.lineHeight = t;
    }, e.prototype.getPosition = function() {
      return { x: this.x, y: this.y };
    }, e.prototype.getX = function() {
      return this.x;
    }, e.prototype.getY = function() {
      return this.y;
    }, e.prototype.moveTo = function(t, r) {
      B(t, "x", ["number"]), B(r, "y", ["number"]), this.x = t, this.y = r;
    }, e.prototype.moveDown = function(t) {
      B(t, "yDecrease", ["number"]), this.y -= t;
    }, e.prototype.moveUp = function(t) {
      B(t, "yIncrease", ["number"]), this.y += t;
    }, e.prototype.moveLeft = function(t) {
      B(t, "xDecrease", ["number"]), this.x -= t;
    }, e.prototype.moveRight = function(t) {
      B(t, "xIncrease", ["number"]), this.x += t;
    }, e.prototype.pushOperators = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      Xg(t, "operator", [[He, "PDFOperator"]]);
      var n = this.getContentStream();
      n.push.apply(n, t);
    }, e.prototype.drawText = function(t, r) {
      var n, o, i, a, s, c, l;
      r === void 0 && (r = {}), B(t, "text", ["string"]), te(r.color, "options.color", [[Object, "Color"]]), dr(r.opacity, "opacity.opacity", 0, 1), te(r.font, "options.font", [[Xt, "PDFFont"]]), te(r.size, "options.size", ["number"]), te(r.rotate, "options.rotate", [[Object, "Rotation"]]), te(r.xSkew, "options.xSkew", [[Object, "Rotation"]]), te(r.ySkew, "options.ySkew", [[Object, "Rotation"]]), te(r.x, "options.x", ["number"]), te(r.y, "options.y", ["number"]), te(r.lineHeight, "options.lineHeight", ["number"]), te(r.maxWidth, "options.maxWidth", ["number"]), te(r.wordBreaks, "options.wordBreaks", [Array]), Qt(r.blendMode, "options.blendMode", Lr);
      for (var u = this.setOrEmbedFont(r.font), d = u.oldFont, f = u.newFont, h = u.newFontKey, g = r.size || this.fontSize, v = r.wordBreaks || this.doc.defaultWordBreaks, y = function(R) {
        return f.widthOfTextAtSize(R, g);
      }, b = r.maxWidth === void 0 ? Tg(ji(t)) : eD(t, v, r.maxWidth, y), x = new Array(b.length), C = 0, E = b.length; C < E; C++)
        x[C] = f.encodeText(b[C]);
      var D = this.maybeEmbedGraphicsState({
        opacity: r.opacity,
        blendMode: r.blendMode
      }), A = this.getContentStream();
      A.push.apply(A, ST(x, {
        color: (n = r.color) !== null && n !== void 0 ? n : this.fontColor,
        font: h,
        size: g,
        rotate: (o = r.rotate) !== null && o !== void 0 ? o : ye(0),
        xSkew: (i = r.xSkew) !== null && i !== void 0 ? i : ye(0),
        ySkew: (a = r.ySkew) !== null && a !== void 0 ? a : ye(0),
        x: (s = r.x) !== null && s !== void 0 ? s : this.x,
        y: (c = r.y) !== null && c !== void 0 ? c : this.y,
        lineHeight: (l = r.lineHeight) !== null && l !== void 0 ? l : this.lineHeight,
        graphicsState: D
      })), r.font && (d ? this.setFont(d) : this.resetFont());
    }, e.prototype.drawImage = function(t, r) {
      var n, o, i, a, s, c, l;
      r === void 0 && (r = {}), B(t, "image", [[ll, "PDFImage"]]), te(r.x, "options.x", ["number"]), te(r.y, "options.y", ["number"]), te(r.width, "options.width", ["number"]), te(r.height, "options.height", ["number"]), te(r.rotate, "options.rotate", [[Object, "Rotation"]]), te(r.xSkew, "options.xSkew", [[Object, "Rotation"]]), te(r.ySkew, "options.ySkew", [[Object, "Rotation"]]), dr(r.opacity, "opacity.opacity", 0, 1), Qt(r.blendMode, "options.blendMode", Lr);
      var u = this.node.newXObject("Image", t.ref), d = this.maybeEmbedGraphicsState({
        opacity: r.opacity,
        blendMode: r.blendMode
      }), f = this.getContentStream();
      f.push.apply(f, Fm(u, {
        x: (n = r.x) !== null && n !== void 0 ? n : this.x,
        y: (o = r.y) !== null && o !== void 0 ? o : this.y,
        width: (i = r.width) !== null && i !== void 0 ? i : t.size().width,
        height: (a = r.height) !== null && a !== void 0 ? a : t.size().height,
        rotate: (s = r.rotate) !== null && s !== void 0 ? s : ye(0),
        xSkew: (c = r.xSkew) !== null && c !== void 0 ? c : ye(0),
        ySkew: (l = r.ySkew) !== null && l !== void 0 ? l : ye(0),
        graphicsState: d
      }));
    }, e.prototype.drawPage = function(t, r) {
      var n, o, i, a, s;
      r === void 0 && (r = {}), B(t, "embeddedPage", [
        [Mm, "PDFEmbeddedPage"]
      ]), te(r.x, "options.x", ["number"]), te(r.y, "options.y", ["number"]), te(r.xScale, "options.xScale", ["number"]), te(r.yScale, "options.yScale", ["number"]), te(r.width, "options.width", ["number"]), te(r.height, "options.height", ["number"]), te(r.rotate, "options.rotate", [[Object, "Rotation"]]), te(r.xSkew, "options.xSkew", [[Object, "Rotation"]]), te(r.ySkew, "options.ySkew", [[Object, "Rotation"]]), dr(r.opacity, "opacity.opacity", 0, 1), Qt(r.blendMode, "options.blendMode", Lr);
      var c = this.node.newXObject("EmbeddedPdfPage", t.ref), l = this.maybeEmbedGraphicsState({
        opacity: r.opacity,
        blendMode: r.blendMode
      }), u = r.width !== void 0 ? r.width / t.width : r.xScale !== void 0 ? r.xScale : 1, d = r.height !== void 0 ? r.height / t.height : r.yScale !== void 0 ? r.yScale : 1, f = this.getContentStream();
      f.push.apply(f, PT(c, {
        x: (n = r.x) !== null && n !== void 0 ? n : this.x,
        y: (o = r.y) !== null && o !== void 0 ? o : this.y,
        xScale: u,
        yScale: d,
        rotate: (i = r.rotate) !== null && i !== void 0 ? i : ye(0),
        xSkew: (a = r.xSkew) !== null && a !== void 0 ? a : ye(0),
        ySkew: (s = r.ySkew) !== null && s !== void 0 ? s : ye(0),
        graphicsState: l
      }));
    }, e.prototype.drawSvgPath = function(t, r) {
      var n, o, i, a, s, c, l, u, d;
      r === void 0 && (r = {}), B(t, "path", ["string"]), te(r.x, "options.x", ["number"]), te(r.y, "options.y", ["number"]), te(r.scale, "options.scale", ["number"]), te(r.rotate, "options.rotate", [[Object, "Rotation"]]), te(r.borderWidth, "options.borderWidth", ["number"]), te(r.color, "options.color", [[Object, "Color"]]), dr(r.opacity, "opacity.opacity", 0, 1), te(r.borderColor, "options.borderColor", [
        [Object, "Color"]
      ]), te(r.borderDashArray, "options.borderDashArray", [
        Array
      ]), te(r.borderDashPhase, "options.borderDashPhase", [
        "number"
      ]), Qt(r.borderLineCap, "options.borderLineCap", mo), dr(r.borderOpacity, "options.borderOpacity", 0, 1), Qt(r.blendMode, "options.blendMode", Lr);
      var f = this.maybeEmbedGraphicsState({
        opacity: r.opacity,
        borderOpacity: r.borderOpacity,
        blendMode: r.blendMode
      });
      !("color" in r) && !("borderColor" in r) && (r.borderColor = tt(0, 0, 0));
      var h = this.getContentStream();
      h.push.apply(h, DT(t, {
        x: (n = r.x) !== null && n !== void 0 ? n : this.x,
        y: (o = r.y) !== null && o !== void 0 ? o : this.y,
        scale: r.scale,
        rotate: (i = r.rotate) !== null && i !== void 0 ? i : ye(0),
        color: (a = r.color) !== null && a !== void 0 ? a : void 0,
        borderColor: (s = r.borderColor) !== null && s !== void 0 ? s : void 0,
        borderWidth: (c = r.borderWidth) !== null && c !== void 0 ? c : 0,
        borderDashArray: (l = r.borderDashArray) !== null && l !== void 0 ? l : void 0,
        borderDashPhase: (u = r.borderDashPhase) !== null && u !== void 0 ? u : void 0,
        borderLineCap: (d = r.borderLineCap) !== null && d !== void 0 ? d : void 0,
        graphicsState: f
      }));
    }, e.prototype.drawLine = function(t) {
      var r, n, o, i, a;
      B(t.start, "options.start", [
        [Object, "{ x: number, y: number }"]
      ]), B(t.end, "options.end", [
        [Object, "{ x: number, y: number }"]
      ]), B(t.start.x, "options.start.x", ["number"]), B(t.start.y, "options.start.y", ["number"]), B(t.end.x, "options.end.x", ["number"]), B(t.end.y, "options.end.y", ["number"]), te(t.thickness, "options.thickness", ["number"]), te(t.color, "options.color", [[Object, "Color"]]), te(t.dashArray, "options.dashArray", [Array]), te(t.dashPhase, "options.dashPhase", ["number"]), Qt(t.lineCap, "options.lineCap", mo), dr(t.opacity, "opacity.opacity", 0, 1), Qt(t.blendMode, "options.blendMode", Lr);
      var s = this.maybeEmbedGraphicsState({
        borderOpacity: t.opacity,
        blendMode: t.blendMode
      });
      "color" in t || (t.color = tt(0, 0, 0));
      var c = this.getContentStream();
      c.push.apply(c, ET({
        start: t.start,
        end: t.end,
        thickness: (r = t.thickness) !== null && r !== void 0 ? r : 1,
        color: (n = t.color) !== null && n !== void 0 ? n : void 0,
        dashArray: (o = t.dashArray) !== null && o !== void 0 ? o : void 0,
        dashPhase: (i = t.dashPhase) !== null && i !== void 0 ? i : void 0,
        lineCap: (a = t.lineCap) !== null && a !== void 0 ? a : void 0,
        graphicsState: s
      }));
    }, e.prototype.drawRectangle = function(t) {
      var r, n, o, i, a, s, c, l, u, d, f, h, g;
      t === void 0 && (t = {}), te(t.x, "options.x", ["number"]), te(t.y, "options.y", ["number"]), te(t.width, "options.width", ["number"]), te(t.height, "options.height", ["number"]), te(t.rotate, "options.rotate", [[Object, "Rotation"]]), te(t.xSkew, "options.xSkew", [[Object, "Rotation"]]), te(t.ySkew, "options.ySkew", [[Object, "Rotation"]]), te(t.borderWidth, "options.borderWidth", ["number"]), te(t.color, "options.color", [[Object, "Color"]]), dr(t.opacity, "opacity.opacity", 0, 1), te(t.borderColor, "options.borderColor", [
        [Object, "Color"]
      ]), te(t.borderDashArray, "options.borderDashArray", [
        Array
      ]), te(t.borderDashPhase, "options.borderDashPhase", [
        "number"
      ]), Qt(t.borderLineCap, "options.borderLineCap", mo), dr(t.borderOpacity, "options.borderOpacity", 0, 1), Qt(t.blendMode, "options.blendMode", Lr);
      var v = this.maybeEmbedGraphicsState({
        opacity: t.opacity,
        borderOpacity: t.borderOpacity,
        blendMode: t.blendMode
      });
      !("color" in t) && !("borderColor" in t) && (t.color = tt(0, 0, 0));
      var y = this.getContentStream();
      y.push.apply(y, Do({
        x: (r = t.x) !== null && r !== void 0 ? r : this.x,
        y: (n = t.y) !== null && n !== void 0 ? n : this.y,
        width: (o = t.width) !== null && o !== void 0 ? o : 150,
        height: (i = t.height) !== null && i !== void 0 ? i : 100,
        rotate: (a = t.rotate) !== null && a !== void 0 ? a : ye(0),
        xSkew: (s = t.xSkew) !== null && s !== void 0 ? s : ye(0),
        ySkew: (c = t.ySkew) !== null && c !== void 0 ? c : ye(0),
        borderWidth: (l = t.borderWidth) !== null && l !== void 0 ? l : 0,
        color: (u = t.color) !== null && u !== void 0 ? u : void 0,
        borderColor: (d = t.borderColor) !== null && d !== void 0 ? d : void 0,
        borderDashArray: (f = t.borderDashArray) !== null && f !== void 0 ? f : void 0,
        borderDashPhase: (h = t.borderDashPhase) !== null && h !== void 0 ? h : void 0,
        graphicsState: v,
        borderLineCap: (g = t.borderLineCap) !== null && g !== void 0 ? g : void 0
      }));
    }, e.prototype.drawSquare = function(t) {
      t === void 0 && (t = {});
      var r = t.size;
      te(r, "size", ["number"]), this.drawRectangle(Se(Se({}, t), { width: r, height: r }));
    }, e.prototype.drawEllipse = function(t) {
      var r, n, o, i, a, s, c, l, u, d, f;
      t === void 0 && (t = {}), te(t.x, "options.x", ["number"]), te(t.y, "options.y", ["number"]), te(t.xScale, "options.xScale", ["number"]), te(t.yScale, "options.yScale", ["number"]), te(t.rotate, "options.rotate", [[Object, "Rotation"]]), te(t.color, "options.color", [[Object, "Color"]]), dr(t.opacity, "opacity.opacity", 0, 1), te(t.borderColor, "options.borderColor", [
        [Object, "Color"]
      ]), dr(t.borderOpacity, "options.borderOpacity", 0, 1), te(t.borderWidth, "options.borderWidth", ["number"]), te(t.borderDashArray, "options.borderDashArray", [
        Array
      ]), te(t.borderDashPhase, "options.borderDashPhase", [
        "number"
      ]), Qt(t.borderLineCap, "options.borderLineCap", mo), Qt(t.blendMode, "options.blendMode", Lr);
      var h = this.maybeEmbedGraphicsState({
        opacity: t.opacity,
        borderOpacity: t.borderOpacity,
        blendMode: t.blendMode
      });
      !("color" in t) && !("borderColor" in t) && (t.color = tt(0, 0, 0));
      var g = this.getContentStream();
      g.push.apply(g, cl({
        x: (r = t.x) !== null && r !== void 0 ? r : this.x,
        y: (n = t.y) !== null && n !== void 0 ? n : this.y,
        xScale: (o = t.xScale) !== null && o !== void 0 ? o : 100,
        yScale: (i = t.yScale) !== null && i !== void 0 ? i : 100,
        rotate: (a = t.rotate) !== null && a !== void 0 ? a : void 0,
        color: (s = t.color) !== null && s !== void 0 ? s : void 0,
        borderColor: (c = t.borderColor) !== null && c !== void 0 ? c : void 0,
        borderWidth: (l = t.borderWidth) !== null && l !== void 0 ? l : 0,
        borderDashArray: (u = t.borderDashArray) !== null && u !== void 0 ? u : void 0,
        borderDashPhase: (d = t.borderDashPhase) !== null && d !== void 0 ? d : void 0,
        borderLineCap: (f = t.borderLineCap) !== null && f !== void 0 ? f : void 0,
        graphicsState: h
      }));
    }, e.prototype.drawCircle = function(t) {
      t === void 0 && (t = {});
      var r = t.size, n = r === void 0 ? 100 : r;
      te(n, "size", ["number"]), this.drawEllipse(Se(Se({}, t), { xScale: n, yScale: n }));
    }, e.prototype.setOrEmbedFont = function(t) {
      var r = this.font, n = this.fontKey;
      t ? this.setFont(t) : this.getFont();
      var o = this.font, i = this.fontKey;
      return { oldFont: r, oldFontKey: n, newFont: o, newFontKey: i };
    }, e.prototype.getFont = function() {
      if (!this.font || !this.fontKey) {
        var t = this.doc.embedStandardFont(_a.Helvetica);
        this.setFont(t);
      }
      return [this.font, this.fontKey];
    }, e.prototype.resetFont = function() {
      this.font = void 0, this.fontKey = void 0;
    }, e.prototype.getContentStream = function(t) {
      return t === void 0 && (t = !0), t && this.contentStream ? this.contentStream : (this.contentStream = this.createContentStream(), this.contentStreamRef = this.doc.context.register(this.contentStream), this.node.addContentStream(this.contentStreamRef), this.contentStream);
    }, e.prototype.createContentStream = function() {
      for (var t = [], r = 0; r < arguments.length; r++)
        t[r] = arguments[r];
      var n = this.doc.context.obj({}), o = si.of(n, t);
      return o;
    }, e.prototype.maybeEmbedGraphicsState = function(t) {
      var r = t.opacity, n = t.borderOpacity, o = t.blendMode;
      if (!(r === void 0 && n === void 0 && o === void 0)) {
        var i = this.doc.context.obj({
          Type: "ExtGState",
          ca: r,
          CA: n,
          BM: o
        }), a = this.node.newExtGState("GS", i);
        return a;
      }
    }, e.prototype.scaleAnnot = function(t, r, n) {
      for (var o = ["RD", "CL", "Vertices", "QuadPoints", "L", "Rect"], i = 0, a = o.length; i < a; i++) {
        var s = t.lookup(F.of(o[i]));
        s instanceof _e && s.scalePDFNumbers(r, n);
      }
      var c = t.lookup(F.of("InkList"));
      if (c instanceof _e)
        for (var i = 0, a = c.size(); i < a; i++) {
          var l = c.lookup(i);
          l instanceof _e && l.scalePDFNumbers(r, n);
        }
    }, e.of = function(t, r, n) {
      return new e(t, r, n);
    }, e.create = function(t) {
      B(t, "doc", [[Cn, "PDFDocument"]]);
      var r = et.of(-1), n = Ur.withContextAndParent(t.context, r), o = t.context.register(n);
      return new e(n, o, t);
    }, e;
  })()
), Sa = (
  /** @class */
  (function(e) {
    ne(t, e);
    function t(r, n, o) {
      var i = e.call(this, r, n, o) || this;
      return B(r, "acroButton", [
        [Ns, "PDFAcroPushButton"]
      ]), i.acroField = r, i;
    }
    return t.prototype.setImage = function(r, n) {
      n === void 0 && (n = dn.Center);
      for (var o = this.acroField.getWidgets(), i = 0, a = o.length; i < a; i++) {
        var s = o[i], c = this.createImageAppearanceStream(s, r, n);
        this.updateWidgetAppearances(s, { normal: c });
      }
      this.markAsClean();
    }, t.prototype.setFontSize = function(r) {
      Fs(r, "fontSize"), this.acroField.setFontSize(r), this.markAsDirty();
    }, t.prototype.addToPage = function(r, n, o) {
      var i, a, s, c, l, u, d, f, h, g, v;
      te(r, "text", ["string"]), te(n, "page", [[er, "PDFPage"]]), zo(o);
      var y = this.createWidget({
        x: ((i = o?.x) !== null && i !== void 0 ? i : 0) - ((a = o?.borderWidth) !== null && a !== void 0 ? a : 0) / 2,
        y: ((s = o?.y) !== null && s !== void 0 ? s : 0) - ((c = o?.borderWidth) !== null && c !== void 0 ? c : 0) / 2,
        width: (l = o?.width) !== null && l !== void 0 ? l : 100,
        height: (u = o?.height) !== null && u !== void 0 ? u : 50,
        textColor: (d = o?.textColor) !== null && d !== void 0 ? d : tt(0, 0, 0),
        backgroundColor: (f = o?.backgroundColor) !== null && f !== void 0 ? f : tt(0.75, 0.75, 0.75),
        borderColor: o?.borderColor,
        borderWidth: (h = o?.borderWidth) !== null && h !== void 0 ? h : 0,
        rotate: (g = o?.rotate) !== null && g !== void 0 ? g : ye(0),
        caption: r,
        hidden: o?.hidden,
        page: n.ref
      }), b = this.doc.context.register(y.dict);
      this.acroField.addWidget(b);
      var x = (v = o?.font) !== null && v !== void 0 ? v : this.doc.getForm().getDefaultFont();
      this.updateWidgetAppearance(y, x), n.node.addAnnot(b);
    }, t.prototype.needsAppearancesUpdate = function() {
      var r;
      if (this.isDirty())
        return !0;
      for (var n = this.acroField.getWidgets(), o = 0, i = n.length; o < i; o++) {
        var a = n[o], s = ((r = a.getAppearances()) === null || r === void 0 ? void 0 : r.normal) instanceof Gt;
        if (!s)
          return !0;
      }
      return !1;
    }, t.prototype.defaultUpdateAppearances = function(r) {
      B(r, "font", [[Xt, "PDFFont"]]), this.updateAppearances(r);
    }, t.prototype.updateAppearances = function(r, n) {
      B(r, "font", [[Xt, "PDFFont"]]), te(n, "provider", [Function]);
      for (var o = this.acroField.getWidgets(), i = 0, a = o.length; i < a; i++) {
        var s = o[i];
        this.updateWidgetAppearance(s, r, n);
      }
    }, t.prototype.updateWidgetAppearance = function(r, n, o) {
      var i = o ?? ZT, a = Wo(i(this, r, n));
      this.updateWidgetAppearanceWithFont(r, n, a);
    }, t.of = function(r, n, o) {
      return new t(r, n, o);
    }, t;
  })(Jn)
);
const ON = async (e) => {
  if (e.type === "application/pdf")
    try {
      const t = await e.arrayBuffer();
      return (await Cn.load(t)).getPageCount();
    } catch (t) {
      return console.error("PDF 파일을 읽는 중 오류 발생:", t), 0;
    }
}, iA = ({
  reverse: e,
  number: t
}) => /* @__PURE__ */ w(
  "div",
  {
    className: `flex h-6 w-6 items-center justify-center rounded-full text-xs font-medium ${e ? "bg-default text-background" : "border border-default bg-card text-default"}`,
    children: t
  }
), aA = ({
  title: e,
  titleId: t,
  ...r
}, n) => /* @__PURE__ */ p.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: n, "aria-labelledby": t, ...r }, e ? /* @__PURE__ */ p.createElement("title", { id: t }, e) : null, /* @__PURE__ */ p.createElement("path", { d: "M10.32 17.52L18.78 9.06L17.1 7.38L10.32 14.16L6.9 10.74L5.22 12.42L10.32 17.52ZM12 24C10.34 24 8.78 23.685 7.32 23.055C5.86 22.425 4.59 21.57 3.51 20.49C2.43 19.41 1.575 18.14 0.945 16.68C0.315 15.22 0 13.66 0 12C0 10.34 0.315 8.78 0.945 7.32C1.575 5.86 2.43 4.59 3.51 3.51C4.59 2.43 5.86 1.575 7.32 0.945C8.78 0.315 10.34 0 12 0C13.66 0 15.22 0.315 16.68 0.945C18.14 1.575 19.41 2.43 20.49 3.51C21.57 4.59 22.425 5.86 23.055 7.32C23.685 8.78 24 10.34 24 12C24 13.66 23.685 15.22 23.055 16.68C22.425 18.14 21.57 19.41 20.49 20.49C19.41 21.57 18.14 22.425 16.68 23.055C15.22 23.685 13.66 24 12 24Z", fill: "#222222" })), sA = xr(aA), cA = ({
  title: e,
  titleId: t,
  ...r
}, n) => /* @__PURE__ */ p.createElement("svg", { width: 40, height: 2, viewBox: "0 0 40 2", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: n, "aria-labelledby": t, ...r }, e ? /* @__PURE__ */ p.createElement("title", { id: t }, e) : null, /* @__PURE__ */ p.createElement("rect", { y: 0.5, width: 1, height: 1, rx: 0.5, fill: "#222222" }), /* @__PURE__ */ p.createElement("rect", { x: 3, y: 0.5, width: 1, height: 1, rx: 0.5, fill: "#222222" }), /* @__PURE__ */ p.createElement("rect", { x: 6, y: 0.5, width: 1, height: 1, rx: 0.5, fill: "#222222" }), /* @__PURE__ */ p.createElement("rect", { x: 9, y: 0.5, width: 1, height: 1, rx: 0.5, fill: "#222222" }), /* @__PURE__ */ p.createElement("rect", { x: 12, y: 0.5, width: 1, height: 1, rx: 0.5, fill: "#222222" }), /* @__PURE__ */ p.createElement("rect", { x: 15, y: 0.5, width: 1, height: 1, rx: 0.5, fill: "#222222" }), /* @__PURE__ */ p.createElement("rect", { x: 18, y: 0.5, width: 1, height: 1, rx: 0.5, fill: "#222222" }), /* @__PURE__ */ p.createElement("rect", { x: 21, y: 0.5, width: 1, height: 1, rx: 0.5, fill: "#222222" }), /* @__PURE__ */ p.createElement("rect", { x: 24, y: 0.5, width: 1, height: 1, rx: 0.5, fill: "#222222" }), /* @__PURE__ */ p.createElement("rect", { x: 27, y: 0.5, width: 1, height: 1, rx: 0.5, fill: "#222222" }), /* @__PURE__ */ p.createElement("rect", { x: 30, y: 0.5, width: 1, height: 1, rx: 0.5, fill: "#222222" }), /* @__PURE__ */ p.createElement("rect", { x: 33, y: 0.5, width: 1, height: 1, rx: 0.5, fill: "#222222" }), /* @__PURE__ */ p.createElement("rect", { x: 36, y: 0.5, width: 1, height: 1, rx: 0.5, fill: "#222222" }), /* @__PURE__ */ p.createElement("rect", { x: 39, y: 0.5, width: 1, height: 1, rx: 0.5, fill: "#222222" })), lA = xr(cA), MN = ({
  rounds: e,
  step: t,
  setStep: r,
  completedStep: n
}) => /* @__PURE__ */ w(Im, { children: e.map((o, i) => {
  const a = n >= i;
  return /* @__PURE__ */ Pe("div", { className: "flex items-center", children: [
    /* @__PURE__ */ w(
      "button",
      {
        onClick: () => {
          a && r(o.value);
        },
        children: /* @__PURE__ */ Pe(
          "div",
          {
            className: `flex items-center justify-center ${a ? "cursor-pointer" : "cursor-default"}`,
            children: [
              t === i ? /* @__PURE__ */ w(sA, {}) : /* @__PURE__ */ w(
                iA,
                {
                  reverse: n > i,
                  number: i + 1
                }
              ),
              /* @__PURE__ */ w("span", { className: "ml-2", children: o.label })
            ]
          }
        )
      }
    ),
    i !== e.length - 1 && /* @__PURE__ */ w("span", { className: "px-2", children: /* @__PURE__ */ w(lA, {}) })
  ] }, o.label);
}) }), uA = {
  A: "#A94AB7",
  B: "#E74029",
  C: "#FEB424",
  D: "#5381F8",
  E: "#7D58BD",
  F: "#CE3A13",
  G: "#E3AB1C",
  H: "#4575CD",
  I: "#A05BF8",
  J: "#F1562D",
  K: "#FEC83C",
  L: "#6B9BF2",
  M: "#A94AB7",
  N: "#E74029",
  O: "#FEB424",
  P: "#5381F8",
  Q: "#7D58BD",
  R: "#CE3A13",
  S: "#E3AB1C",
  T: "#A05BF8",
  U: "#F1562D",
  V: "#FEC83C",
  W: "#6B9BF2",
  X: "#A94AB7",
  Y: "#E74029",
  Z: "#FEB424",
  1: "#A94AB7",
  2: "#E74029",
  3: "#FEB424",
  4: "#5381F8",
  5: "#7D58BD",
  6: "#CE3A13",
  7: "#E3AB1C",
  8: "#4575CD",
  9: "#A05BF8",
  0: "#F1562D"
}, IN = ({
  character: e,
  large: t = !1,
  className: r
}) => {
  const n = uA[e];
  return /* @__PURE__ */ w(
    "section",
    {
      style: { backgroundColor: n },
      className: le(
        `${t ? "h-8 w-8 cursor-default" : "h-6 w-6 text-xs"} rounded-[50%] text-white outline-none ring-0 focus:outline-none focus:ring-0`,
        r
      ),
      children: /* @__PURE__ */ w("div", { className: "flex h-full items-center justify-center", children: e })
    }
  );
};
export {
  EA as Accordion,
  DA as AccordionContent,
  kA as AccordionItem,
  FA as AccordionTrigger,
  hn as Button,
  Xb as ButtonSpinner,
  zx as Calendar,
  RA as Checkbox,
  KA as Dialog,
  YA as DialogClose,
  ZA as DialogContent,
  $A as DialogDescription,
  JA as DialogFooter,
  _A as DialogHeader,
  JP as DialogOverlay,
  _P as DialogPortal,
  QA as DialogTitle,
  XA as DialogTrigger,
  TA as DragDropFileInput,
  AA as DropdownMenu,
  UA as DropdownMenuCheckboxItem,
  zA as DropdownMenuContent,
  OA as DropdownMenuGroup,
  jA as DropdownMenuItem,
  HA as DropdownMenuLabel,
  MA as DropdownMenuPortal,
  BA as DropdownMenuRadioGroup,
  VA as DropdownMenuRadioItem,
  qA as DropdownMenuSeparator,
  GA as DropdownMenuShortcut,
  IA as DropdownMenuSub,
  WA as DropdownMenuSubContent,
  LA as DropdownMenuSubTrigger,
  NA as DropdownMenuTrigger,
  eN as FullDialog,
  QP as Input,
  UC as Label,
  MF as Pagination,
  TN as PaginationContent,
  IF as PaginationFirst,
  AN as PaginationItem,
  WF as PaginationLast,
  LF as PaginationNext,
  BF as PaginationPrevious,
  tN as Popover,
  oN as PopoverAnchor,
  nN as PopoverContent,
  rN as PopoverTrigger,
  IN as ProfileBadge,
  vA as Progress,
  NN as SearchBar,
  ak as Select,
  lk as SelectContent,
  iN as SelectGroup,
  uk as SelectItem,
  aN as SelectLabel,
  fk as SelectScrollDownButton,
  dk as SelectScrollUpButton,
  sN as SelectSeparator,
  ck as SelectTrigger,
  sk as SelectValue,
  gA as Sheet,
  yA as SheetClose,
  bA as SheetContent,
  SA as SheetDescription,
  xA as SheetFooter,
  wA as SheetHeader,
  CA as SheetTitle,
  mA as SheetTrigger,
  hN as Skeleton,
  fN as Spinner,
  MN as Stepper,
  PA as Switch,
  cN as Textarea,
  lN as Tooltip,
  dN as TooltipContent,
  Ok as TooltipProvider,
  uN as TooltipTrigger,
  yN as areObjectsEqual,
  ka as buttonVariants,
  le as cn,
  SN as convertStringToDate,
  vN as debounce,
  DN as enableOnlyNumber,
  PN as getFirstDayOfTheMonth,
  bN as getFormattedDate,
  xN as getFullDate,
  CN as getFullTime,
  EN as getLastDayOfTheMonth,
  NF as getNextMonth,
  ON as getPageCount,
  wN as getTimeBasedOnDistanceFromNow,
  FN as handleNumericInput,
  RN as handlePressEnter,
  pN as useCopyText,
  mN as useDeviceType,
  gN as usePromiseToast,
  kN as validateDate
};
